export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  academic_calendar_item_semester_enum: any;
  academic_calendar_item_type_enum: any;
  bigint: any;
  course_semester_semester_enum: any;
  date: any;
  inquiry_gender_enum: any;
  inquiry_inquirytype_enum: any;
  student_gender_enum: any;
  student_nationality_enum: any;
  timestamp: any;
  timestamptz: any;
  user_gender_enum: any;
  uuid: any;
  weekdays: any;
};

export enum AllowedImageExtensionTypes {
  jpeg = 'jpeg',
  jpg = 'jpg',
  png = 'png',
}

export type ApproveDenyResultSheetInput = {
  academicHeadRemark?: Maybe<Scalars['String']>;
  isApproved: Scalars['Boolean'];
};

export type ApproveDenyResultSheetResult = {
  __typename?: 'ApproveDenyResultSheetResult';
  id: Scalars['String'];
};

export type ApproveDenyResultSheetWhereInput = {
  id: Scalars['String'];
};

export type AssessmentResourcesUploadURLsInput = {
  uploadRequestURLs: Array<UploadRequestURLInput>;
};

export enum Attendance {
  absent = 'absent',
  halfday = 'halfday',
  none = 'none',
  present = 'present',
}

export type AttendanceWhereInput = {
  batchClassId: Scalars['String'];
  batchSubjectConfigurationId?: Maybe<Scalars['String']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['String']>;
  studentIds: Array<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_comparison_exp = {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
};

export type CreateInquiryInput = {
  assignedUser?: Maybe<InquiryUserInput>;
  city?: Maybe<Scalars['String']>;
  course?: Maybe<InquiryCourseInput>;
  date?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  educationQualifications?: Maybe<Array<InquiryEducationQualificationInput>>;
  employmentExperiences?: Maybe<Array<InquiryEmploymentExperienceInput>>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  inquirerContactNo?: Maybe<Scalars['String']>;
  inquirerEmail?: Maybe<Scalars['String']>;
  inquirerName?: Maybe<Scalars['String']>;
  inquiryType?: Maybe<InquiryType>;
  intake?: Maybe<InquiryIntakeInput>;
  landlineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  preferredYear?: Maybe<Scalars['Float']>;
  referredVia?: Maybe<Array<Scalars['String']>>;
  studentEmail?: Maybe<Scalars['String']>;
  whatsapp_number?: Maybe<Scalars['String']>;
  willingToMigrate?: Maybe<Scalars['Boolean']>;
};

export type CreateInquiryResult = {
  __typename?: 'CreateInquiryResult';
  id: Scalars['Float'];
  inquiryNumber: Scalars['String'];
};

export type CreateRequestInput = {
  approvedOn?: Maybe<Scalars['DateTime']>;
  approvedUserId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  evidence?: Maybe<Scalars['String']>;
  student_external_engagement_requests?: Maybe<StudentExternalEngagementRequestInputData>;
  student_general_requests?: Maybe<StudentGeneralRequestInputData>;
  student_medical_requests?: Maybe<StudentMedicalRequestInputData>;
  student_request_requestees?: Maybe<StudentRequestRequesteesInputData>;
};

export type CreateRequestResult = {
  __typename?: 'CreateRequestResult';
  requestId: Scalars['Float'];
};

export type CreateStudentAssessmentSubmissionInput = {
  assessmentId: Scalars['String'];
  uploadURLs: Array<Scalars['String']>;
};

export type CreateStudentAssessmentSubmissionResult = {
  __typename?: 'CreateStudentAssessmentSubmissionResult';
  studentAssessmentSubmissionId: Scalars['String'];
};

export type CreateUserInput = {
  allergies?: Maybe<Scalars['String']>;
  currentMedications?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfJoining?: Maybe<Scalars['DateTime']>;
  departmentId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emergencyContact1City?: Maybe<Scalars['String']>;
  emergencyContact1Country?: Maybe<Scalars['String']>;
  emergencyContact1District?: Maybe<Scalars['String']>;
  emergencyContact1LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact1MobileNo?: Maybe<Scalars['String']>;
  emergencyContact1Name?: Maybe<Scalars['String']>;
  emergencyContact1Province?: Maybe<Scalars['String']>;
  emergencyContact1Relationship?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact1WorkPhoneNo?: Maybe<Scalars['String']>;
  emergencyContact2City?: Maybe<Scalars['String']>;
  emergencyContact2Country?: Maybe<Scalars['String']>;
  emergencyContact2District?: Maybe<Scalars['String']>;
  emergencyContact2LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact2MobileNo?: Maybe<Scalars['String']>;
  emergencyContact2Name?: Maybe<Scalars['String']>;
  emergencyContact2Province?: Maybe<Scalars['String']>;
  emergencyContact2Relationship?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact2WorkPhoneNo?: Maybe<Scalars['String']>;
  employeeID: Scalars['String'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  extensionNo?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: Maybe<GenderType>;
  healthConditions?: Maybe<Scalars['String']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  insuranceName?: Maybe<Scalars['String']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  married?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  policyNo?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  userRoleId?: Maybe<Scalars['String']>;
};

export type CreateUserResult = {
  __typename?: 'CreateUserResult';
  employeeID: Scalars['String'];
};

export type DepartmentForStudent = {
  __typename?: 'DepartmentForStudent';
  id: Scalars['String'];
  name: Scalars['String'];
  users: Array<DepartmentRestrictedUser>;
};

export type DepartmentRestrictedUser = {
  __typename?: 'DepartmentRestrictedUser';
  employeeID?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FinalStudentDetailsResult = {
  __typename?: 'FinalStudentDetailsResult';
  agreementURLs?: Maybe<Array<Scalars['String']>>;
  educationalCertificatesURLs?: Maybe<Array<Scalars['String']>>;
  initialRegistrationFeePaid?: Maybe<Scalars['Boolean']>;
  nicCopyURLs?: Maybe<Array<Scalars['String']>>;
  ordinaryLevelCertificateURLs?: Maybe<Array<Scalars['String']>>;
  passportOrBirthCertificateURLs?: Maybe<Array<Scalars['String']>>;
  passportSizePhotoURLs?: Maybe<Array<Scalars['String']>>;
  remarks?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  status?: Maybe<StudentStatus>;
  waiID?: Maybe<Scalars['String']>;
};

export type FinalStudentDetailsWhereInput = {
  regNumber: Scalars['String'];
};

export enum GenderType {
  female = 'female',
  male = 'male',
}

export type InquiryCourseInput = {
  id: Scalars['String'];
};

export type InquiryEducationQualificationInput = {
  gradings?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  schoolOrInstitute: Scalars['String'];
  yearOfCompletion?: Maybe<Scalars['Float']>;
};

export type InquiryEmploymentExperienceInput = {
  company: Scalars['String'];
  duties?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  position: Scalars['String'];
  references?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type InquiryIntakeInput = {
  id: Scalars['String'];
};

export enum InquiryType {
  phone = 'phone',
  walking = 'walking',
  web = 'web',
}

export type InquiryUserInput = {
  id: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_comparison_exp = {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
};

export type LectureMaterialAttachmentsUploadURLsInput = {
  uploadRequestURLs: Array<UploadRequestURLInput>;
};

export type LogBookStudent = {
  __typename?: 'LogBookStudent';
  assessment: Array<LogBookStudentAssessment>;
  attendance: Array<LogBookStudentAttendance>;
  class_name: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
  regNumber: Scalars['String'];
  sliitID: Scalars['String'];
  waiID: Scalars['String'];
};

export type LogBookStudentAssessment = {
  __typename?: 'LogBookStudentAssessment';
  allocatedMarks: Scalars['Float'];
  endDate: Scalars['String'];
  id: Scalars['String'];
  result: Scalars['String'];
  title: Scalars['String'];
};

export type LogBookStudentAttendance = {
  __typename?: 'LogBookStudentAttendance';
  attendance?: Maybe<Attendance>;
  date: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  isExtra: Scalars['Boolean'];
};

export enum NationalityType {
  other = 'other',
  sri_lankan = 'sri_lankan',
}

export type ProfilePictureUploadURL = {
  __typename?: 'ProfilePictureUploadURL';
  url: Scalars['String'];
};

export type ProfilePictureUploadURLInput = {
  contentType: Scalars['String'];
  fileExtension: AllowedImageExtensionTypes;
};

export type ReSendLoginEmailInput = {
  studentEmail?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
};

export type ReSendLoginEmailResult = {
  __typename?: 'ReSendLoginEmailResult';
  studentEmail?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
};

export type RegisterStudentInput = {
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  education_qualifications?: Maybe<StudentEducationQualificationInputData>;
  email: Scalars['String'];
  employment_experiences?: Maybe<StudentEmploymentExperienceInputData>;
  firstName: Scalars['String'];
  gender?: Maybe<GenderType>;
  inquiryNumber?: Maybe<Scalars['String']>;
  isContactParent?: Maybe<Scalars['Boolean']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nationality?: Maybe<NationalityType>;
  nicNo?: Maybe<Scalars['String']>;
  parentOrGuardianCity?: Maybe<Scalars['String']>;
  parentOrGuardianCountry?: Maybe<Scalars['String']>;
  parentOrGuardianDistrict?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianName?: Maybe<Scalars['String']>;
  parentOrGuardianProvince?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress1?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress2?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  postal_id?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  referredVia?: Maybe<Scalars['String']>;
  sameAsPermanentAddress?: Maybe<Scalars['Boolean']>;
  spokenLanguages?: Maybe<Scalars['String']>;
  studentEmail?: Maybe<Scalars['String']>;
  student_courses?: Maybe<StudentCoursesInputData>;
  whatsapp_number?: Maybe<Scalars['String']>;
};

export type RegisterStudentResult = {
  __typename?: 'RegisterStudentResult';
  regNumber: Scalars['String'];
};

export type ResultSheetReportResult = {
  __typename?: 'ResultSheetReportResult';
  batchSubjectConfigurationId: Scalars['String'];
  student: Array<ResultSheetReportStudent>;
  subjectCode?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
};

export type ResultSheetReportStudent = {
  __typename?: 'ResultSheetReportStudent';
  attendancePercentage: Scalars['Float'];
  grade: Scalars['String'];
  id: Scalars['Float'];
  name: Scalars['String'];
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  waiID?: Maybe<Scalars['String']>;
};

export type ResultSheetReportWhereInput = {
  batchClassId: Scalars['String'];
  batchId: Scalars['String'];
  courseSemesterId: Scalars['String'];
};

export type SampleInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type SampleOutput = {
  __typename?: 'SampleOutput';
  accessToken: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_comparison_exp = {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
};

export type StudentAssessmentSubmissionUploadURLsInput = {
  uploadRequestURLs: Array<UploadRequestURLInput>;
};

export type StudentAttendance = {
  __typename?: 'StudentAttendance';
  attendance: Scalars['Float'];
  studentId: Scalars['Float'];
};

export type StudentAttendanceResult = {
  __typename?: 'StudentAttendanceResult';
  studentsAttendance: Array<StudentAttendance>;
};

export type StudentCoursesInput = {
  active: Scalars['Boolean'];
  courseId: Scalars['String'];
  intakeId: Scalars['String'];
  registeredYear: Scalars['Float'];
};

export type StudentCoursesInputData = {
  data: Array<StudentCoursesInput>;
};

export enum StudentDocumentFileTypes {
  agreement = 'agreement',
  educationalCertificates = 'educationalCertificates',
  nicCopy = 'nicCopy',
  ordinaryLevelCertificate = 'ordinaryLevelCertificate',
  passportOrBirthCertificate = 'passportOrBirthCertificate',
  passportSizePhoto = 'passportSizePhoto',
  profileUploadedPhoto = 'profileUploadedPhoto',
}

export type StudentDocumentUploadURLsInput = {
  fileType: StudentDocumentFileTypes;
  studentDocumentUploadRequestURLs: Array<UploadRequestURLInput>;
};

export type StudentEducationQualificationInput = {
  gradings?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  schoolOrInstitute: Scalars['String'];
  yearOfCompletion?: Maybe<Scalars['Float']>;
};

export type StudentEducationQualificationInputData = {
  data?: Maybe<Array<StudentEducationQualificationInput>>;
};

export type StudentEmploymentExperienceInput = {
  company: Scalars['String'];
  duties?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  position: Scalars['String'];
  references?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type StudentEmploymentExperienceInputData = {
  data?: Maybe<Array<StudentEmploymentExperienceInput>>;
};

export type StudentExternalEngagementRequestInput = {
  timetableItemId: Scalars['String'];
};

export type StudentExternalEngagementRequestInputData = {
  data: Array<StudentExternalEngagementRequestInput>;
};

export type StudentGeneralRequestInput = {
  title: Scalars['String'];
};

export type StudentGeneralRequestInputData = {
  data: Array<StudentGeneralRequestInput>;
};

export type StudentLogBookResult = {
  __typename?: 'StudentLogBookResult';
  batchSubjectConfigurationId: Scalars['String'];
  lecturer: Scalars['String'];
  month: Scalars['Float'];
  student: Array<LogBookStudent>;
  subjectCode?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
  year: Scalars['Float'];
};

export type StudentLogBookWhereInput = {
  batchId: Scalars['String'];
  courseSemesterId: Scalars['String'];
};

export type StudentMedicalRequestInput = {
  leaveEndDate: Scalars['DateTime'];
  leaveStartDate: Scalars['DateTime'];
  medicalCertificateIssueDate?: Maybe<Scalars['DateTime']>;
  medicalOfficerName: Scalars['String'];
  signAndSymptoms?: Maybe<Scalars['String']>;
};

export type StudentMedicalRequestInputData = {
  data: Array<StudentMedicalRequestInput>;
};

export type StudentProfileAcademicInformationResult = {
  __typename?: 'StudentProfileAcademicInformationResult';
  studentsAttendance: Array<StudentProfileSubjectWiseAcademicInformation>;
};

export type StudentProfileAcademicInformationWhereInput = {
  batchClassId: Scalars['String'];
  studentId: Scalars['Float'];
};

export type StudentProfileSubjectWiseAcademicInformation = {
  __typename?: 'StudentProfileSubjectWiseAcademicInformation';
  attendance: Scalars['Float'];
  batchSubjectConfigurationId: Scalars['String'];
  externalEngagementRequestsCount?: Maybe<Scalars['Float']>;
  grade?: Maybe<Scalars['String']>;
  halfDaysCount?: Maybe<Scalars['Float']>;
  medicalRequestsCount?: Maybe<Scalars['Float']>;
};

export type StudentRequestRequesteesInput = {
  userId: Scalars['String'];
};

export type StudentRequestRequesteesInputData = {
  data: Array<StudentRequestRequesteesInput>;
};

export type StudentRequestUploadURLsInput = {
  uploadRequestURLs: Array<UploadRequestURLInput>;
};

export type StudentResultInput = {
  assessmentId?: Maybe<Scalars['String']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['String']>;
  firstAttemptMarks?: Maybe<Scalars['Float']>;
  isFirstAttemptNYC?: Maybe<Scalars['Boolean']>;
  isSecondAttemptNYC?: Maybe<Scalars['Boolean']>;
  isThirdAttemptNYC?: Maybe<Scalars['Boolean']>;
  secondAttemptMarks?: Maybe<Scalars['Float']>;
  thirdAttemptMarks?: Maybe<Scalars['Float']>;
};

export type StudentResultSheetInput = {
  customMarks?: Maybe<Scalars['Float']>;
  remark: Scalars['String'];
  studentId: Scalars['Float'];
  studentResults?: Maybe<Array<StudentResultInput>>;
};

export enum StudentStatus {
  active = 'active',
  pending = 'pending',
}

export type StudentsWithAttendanceResult = {
  __typename?: 'StudentsWithAttendanceResult';
  attendance: Scalars['Float'];
  firstName: Scalars['String'];
  id: Scalars['Float'];
  lastName: Scalars['String'];
  preferredName?: Maybe<Scalars['String']>;
  regNumber: Scalars['String'];
  sliitID?: Maybe<Scalars['String']>;
  waiID?: Maybe<Scalars['String']>;
};

export type StudentsWithAttendanceWhereInput = {
  batchClassId: Scalars['String'];
  batchSubjectConfigurationId: Scalars['String'];
};

export type URLArrayGetStorageReadSignedURLInput = {
  urls: Array<Scalars['String']>;
};

export type URLArrayGetStorageReadSignedURLResult = {
  __typename?: 'URLArrayGetStorageReadSignedURLResult';
  url: Scalars['String'];
};

export type UpdateFinalStudentDetailsInput = {
  agreementURLs?: Maybe<Array<Scalars['String']>>;
  educationalCertificatesURLs?: Maybe<Array<Scalars['String']>>;
  finalize?: Maybe<Scalars['Boolean']>;
  initialRegistrationFeePaid?: Maybe<Scalars['Boolean']>;
  nicCopyURLs?: Maybe<Array<Scalars['String']>>;
  ordinaryLevelCertificateURLs?: Maybe<Array<Scalars['String']>>;
  passportOrBirthCertificateURLs?: Maybe<Array<Scalars['String']>>;
  passportSizePhotoURLs?: Maybe<Array<Scalars['String']>>;
  remarks?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  status?: Maybe<StudentStatus>;
  waiID?: Maybe<Scalars['String']>;
};

export type UpdateFinalStudentDetailsResult = {
  __typename?: 'UpdateFinalStudentDetailsResult';
  regNumber: Scalars['String'];
};

export type UpdateFinalStudentDetailsWhereInput = {
  regNumber: Scalars['String'];
};

export type UpdateInquiryInput = {
  assignedUser?: Maybe<InquiryUserInput>;
  city?: Maybe<Scalars['String']>;
  course?: Maybe<InquiryCourseInput>;
  date?: Maybe<Scalars['DateTime']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  educationQualifications?: Maybe<Array<InquiryEducationQualificationInput>>;
  employmentExperiences?: Maybe<Array<InquiryEmploymentExperienceInput>>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<GenderType>;
  inquirerContactNo?: Maybe<Scalars['String']>;
  inquirerEmail?: Maybe<Scalars['String']>;
  inquirerName?: Maybe<Scalars['String']>;
  inquiryType?: Maybe<InquiryType>;
  intake?: Maybe<InquiryIntakeInput>;
  landlineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  preferredYear?: Maybe<Scalars['Float']>;
  referredVia?: Maybe<Array<Scalars['String']>>;
  studentEmail?: Maybe<Scalars['String']>;
  whatsapp_number?: Maybe<Scalars['String']>;
  willingToMigrate?: Maybe<Scalars['Boolean']>;
};

export type UpdateInquiryResult = {
  __typename?: 'UpdateInquiryResult';
  id: Scalars['Float'];
  inquiryNumber: Scalars['String'];
};

export type UpdateInquiryWhereInput = {
  inquiryNumber: Scalars['String'];
};

export type UpdateStudentInput = {
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  education_qualifications?: Maybe<StudentEducationQualificationInputData>;
  email: Scalars['String'];
  employment_experiences?: Maybe<StudentEmploymentExperienceInputData>;
  firstName: Scalars['String'];
  gender?: Maybe<GenderType>;
  inquiryNumber?: Maybe<Scalars['String']>;
  isContactParent?: Maybe<Scalars['Boolean']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nationality?: Maybe<NationalityType>;
  nicNo?: Maybe<Scalars['String']>;
  parentOrGuardianCity?: Maybe<Scalars['String']>;
  parentOrGuardianCountry?: Maybe<Scalars['String']>;
  parentOrGuardianDistrict?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianName?: Maybe<Scalars['String']>;
  parentOrGuardianProvince?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress1?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress2?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  postal_id?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  referredVia?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  sameAsPermanentAddress?: Maybe<Scalars['Boolean']>;
  spokenLanguages?: Maybe<Scalars['String']>;
  student_courses?: Maybe<StudentCoursesInputData>;
  whatsapp_number?: Maybe<Scalars['String']>;
};

export type UpdateStudentRequestStatusInput = {
  status: student_request_status_enum;
};

export type UpdateStudentRequestStatusResult = {
  __typename?: 'UpdateStudentRequestStatusResult';
  affectedRows: Scalars['Float'];
};

export type UpdateStudentRequestStatusWhereInput = {
  requestId: Scalars['Float'];
};

export type UpdateStudentResult = {
  __typename?: 'UpdateStudentResult';
  regNumber: Scalars['String'];
  status: Scalars['String'];
};

export type UpdateStudentWhereInput = {
  regNumber: Scalars['String'];
};

export type UpdateUserActiveStateInput = {
  active: Scalars['Boolean'];
  id: Scalars['String'];
};

export type UpdateUserActiveStateResult = {
  __typename?: 'UpdateUserActiveStateResult';
  employeeID?: Maybe<Scalars['String']>;
};

export type UpdateUserInput = {
  allergies?: Maybe<Scalars['String']>;
  currentMedications?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfJoining?: Maybe<Scalars['DateTime']>;
  departmentId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emergencyContact1City?: Maybe<Scalars['String']>;
  emergencyContact1Country?: Maybe<Scalars['String']>;
  emergencyContact1District?: Maybe<Scalars['String']>;
  emergencyContact1LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact1MobileNo?: Maybe<Scalars['String']>;
  emergencyContact1Name?: Maybe<Scalars['String']>;
  emergencyContact1Province?: Maybe<Scalars['String']>;
  emergencyContact1Relationship?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact1WorkPhoneNo?: Maybe<Scalars['String']>;
  emergencyContact2City?: Maybe<Scalars['String']>;
  emergencyContact2Country?: Maybe<Scalars['String']>;
  emergencyContact2District?: Maybe<Scalars['String']>;
  emergencyContact2LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact2MobileNo?: Maybe<Scalars['String']>;
  emergencyContact2Name?: Maybe<Scalars['String']>;
  emergencyContact2Province?: Maybe<Scalars['String']>;
  emergencyContact2Relationship?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact2WorkPhoneNo?: Maybe<Scalars['String']>;
  employeeID: Scalars['String'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  extensionNo?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: Maybe<GenderType>;
  healthConditions?: Maybe<Scalars['String']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  insuranceName?: Maybe<Scalars['String']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  married?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  policyNo?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  userRoleId?: Maybe<Scalars['String']>;
};

export type UpdateUserResult = {
  __typename?: 'UpdateUserResult';
  employeeID: Scalars['String'];
};

export type UpdateUserWhereInput = {
  id: Scalars['String'];
};

export type UploadRequestURLInput = {
  contentType: Scalars['String'];
  fileExtension: Scalars['String'];
  id: Scalars['String'];
};

export type UploadURLs = {
  __typename?: 'UploadURLs';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type UpsertResultSheetInput = {
  batchClassId: Scalars['String'];
  batchSubjectConfigurationId: Scalars['String'];
  studentResultSheets?: Maybe<Array<StudentResultSheetInput>>;
  submit?: Maybe<Scalars['Boolean']>;
};

export type UpsertResultSheetResult = {
  __typename?: 'UpsertResultSheetResult';
  id: Scalars['String'];
};

/** columns and relationships of "academic_calendar_item" */
export type academic_calendar_item = {
  __typename?: 'academic_calendar_item';
  /** An object relationship */
  batch?: Maybe<batch>;
  batchId?: Maybe<Scalars['uuid']>;
  endDate: Scalars['timestamp'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  semester: Scalars['academic_calendar_item_semester_enum'];
  startDate: Scalars['timestamp'];
  type: Scalars['academic_calendar_item_type_enum'];
};

/** aggregated selection of "academic_calendar_item" */
export type academic_calendar_item_aggregate = {
  __typename?: 'academic_calendar_item_aggregate';
  aggregate?: Maybe<academic_calendar_item_aggregate_fields>;
  nodes: Array<academic_calendar_item>;
};

/** aggregate fields of "academic_calendar_item" */
export type academic_calendar_item_aggregate_fields = {
  __typename?: 'academic_calendar_item_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<academic_calendar_item_max_fields>;
  min?: Maybe<academic_calendar_item_min_fields>;
};

/** aggregate fields of "academic_calendar_item" */
export type academic_calendar_item_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<academic_calendar_item_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "academic_calendar_item" */
export type academic_calendar_item_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<academic_calendar_item_max_order_by>;
  min?: Maybe<academic_calendar_item_min_order_by>;
};

/** input type for inserting array relation for remote table "academic_calendar_item" */
export type academic_calendar_item_arr_rel_insert_input = {
  data: Array<academic_calendar_item_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<academic_calendar_item_on_conflict>;
};

/** Boolean expression to filter rows from the table "academic_calendar_item". All fields are combined with a logical 'AND'. */
export type academic_calendar_item_bool_exp = {
  _and?: Maybe<Array<academic_calendar_item_bool_exp>>;
  _not?: Maybe<academic_calendar_item_bool_exp>;
  _or?: Maybe<Array<academic_calendar_item_bool_exp>>;
  batch?: Maybe<batch_bool_exp>;
  batchId?: Maybe<uuid_comparison_exp>;
  endDate?: Maybe<timestamp_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  semester?: Maybe<academic_calendar_item_semester_enum_comparison_exp>;
  startDate?: Maybe<timestamp_comparison_exp>;
  type?: Maybe<academic_calendar_item_type_enum_comparison_exp>;
};

/** unique or primary key constraints on table "academic_calendar_item" */
export enum academic_calendar_item_constraint {
  /** unique or primary key constraint */
  PK_03a34a7c2957c1787d32adfd5fa = 'PK_03a34a7c2957c1787d32adfd5fa',
}

/** input type for inserting data into table "academic_calendar_item" */
export type academic_calendar_item_insert_input = {
  batch?: Maybe<batch_obj_rel_insert_input>;
  batchId?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  semester?: Maybe<Scalars['academic_calendar_item_semester_enum']>;
  startDate?: Maybe<Scalars['timestamp']>;
  type?: Maybe<Scalars['academic_calendar_item_type_enum']>;
};

/** aggregate max on columns */
export type academic_calendar_item_max_fields = {
  __typename?: 'academic_calendar_item_max_fields';
  batchId?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "academic_calendar_item" */
export type academic_calendar_item_max_order_by = {
  batchId?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
};

/** aggregate min on columns */
export type academic_calendar_item_min_fields = {
  __typename?: 'academic_calendar_item_min_fields';
  batchId?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "academic_calendar_item" */
export type academic_calendar_item_min_order_by = {
  batchId?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
};

/** response of any mutation on the table "academic_calendar_item" */
export type academic_calendar_item_mutation_response = {
  __typename?: 'academic_calendar_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<academic_calendar_item>;
};

/** on conflict condition type for table "academic_calendar_item" */
export type academic_calendar_item_on_conflict = {
  constraint: academic_calendar_item_constraint;
  update_columns?: Array<academic_calendar_item_update_column>;
  where?: Maybe<academic_calendar_item_bool_exp>;
};

/** Ordering options when selecting data from "academic_calendar_item". */
export type academic_calendar_item_order_by = {
  batch?: Maybe<batch_order_by>;
  batchId?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  semester?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  type?: Maybe<order_by>;
};

/** primary key columns input for table: academic_calendar_item */
export type academic_calendar_item_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "academic_calendar_item" */
export enum academic_calendar_item_select_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  endDate = 'endDate',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  semester = 'semester',
  /** column name */
  startDate = 'startDate',
  /** column name */
  type = 'type',
}

/** Boolean expression to compare columns of type "academic_calendar_item_semester_enum". All fields are combined with logical 'AND'. */
export type academic_calendar_item_semester_enum_comparison_exp = {
  _eq?: Maybe<Scalars['academic_calendar_item_semester_enum']>;
  _gt?: Maybe<Scalars['academic_calendar_item_semester_enum']>;
  _gte?: Maybe<Scalars['academic_calendar_item_semester_enum']>;
  _in?: Maybe<Array<Scalars['academic_calendar_item_semester_enum']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['academic_calendar_item_semester_enum']>;
  _lte?: Maybe<Scalars['academic_calendar_item_semester_enum']>;
  _neq?: Maybe<Scalars['academic_calendar_item_semester_enum']>;
  _nin?: Maybe<Array<Scalars['academic_calendar_item_semester_enum']>>;
};

/** input type for updating data in table "academic_calendar_item" */
export type academic_calendar_item_set_input = {
  batchId?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  semester?: Maybe<Scalars['academic_calendar_item_semester_enum']>;
  startDate?: Maybe<Scalars['timestamp']>;
  type?: Maybe<Scalars['academic_calendar_item_type_enum']>;
};

/** Boolean expression to compare columns of type "academic_calendar_item_type_enum". All fields are combined with logical 'AND'. */
export type academic_calendar_item_type_enum_comparison_exp = {
  _eq?: Maybe<Scalars['academic_calendar_item_type_enum']>;
  _gt?: Maybe<Scalars['academic_calendar_item_type_enum']>;
  _gte?: Maybe<Scalars['academic_calendar_item_type_enum']>;
  _in?: Maybe<Array<Scalars['academic_calendar_item_type_enum']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['academic_calendar_item_type_enum']>;
  _lte?: Maybe<Scalars['academic_calendar_item_type_enum']>;
  _neq?: Maybe<Scalars['academic_calendar_item_type_enum']>;
  _nin?: Maybe<Array<Scalars['academic_calendar_item_type_enum']>>;
};

/** update columns of table "academic_calendar_item" */
export enum academic_calendar_item_update_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  endDate = 'endDate',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  semester = 'semester',
  /** column name */
  startDate = 'startDate',
  /** column name */
  type = 'type',
}

/** columns and relationships of "active_batch" */
export type active_batch = {
  __typename?: 'active_batch';
  active?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  active_batch_subject_configurations: Array<batch_subject_configuration>;
  /** An aggregate relationship */
  active_batch_subject_configurations_aggregate: batch_subject_configuration_aggregate;
  /** An array relationship */
  batch_classes: Array<batch_class>;
  /** An aggregate relationship */
  batch_classes_aggregate: batch_class_aggregate;
  /** An object relationship */
  course?: Maybe<course>;
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  intake?: Maybe<intake>;
  intakeId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "active_batch" */
export type active_batchactive_batch_subject_configurationsArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

/** columns and relationships of "active_batch" */
export type active_batchactive_batch_subject_configurations_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

/** columns and relationships of "active_batch" */
export type active_batchbatch_classesArgs = {
  distinct_on?: Maybe<Array<batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_order_by>>;
  where?: Maybe<batch_class_bool_exp>;
};

/** columns and relationships of "active_batch" */
export type active_batchbatch_classes_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_order_by>>;
  where?: Maybe<batch_class_bool_exp>;
};

/** aggregated selection of "active_batch" */
export type active_batch_aggregate = {
  __typename?: 'active_batch_aggregate';
  aggregate?: Maybe<active_batch_aggregate_fields>;
  nodes: Array<active_batch>;
};

/** aggregate fields of "active_batch" */
export type active_batch_aggregate_fields = {
  __typename?: 'active_batch_aggregate_fields';
  avg?: Maybe<active_batch_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<active_batch_max_fields>;
  min?: Maybe<active_batch_min_fields>;
  stddev?: Maybe<active_batch_stddev_fields>;
  stddev_pop?: Maybe<active_batch_stddev_pop_fields>;
  stddev_samp?: Maybe<active_batch_stddev_samp_fields>;
  sum?: Maybe<active_batch_sum_fields>;
  var_pop?: Maybe<active_batch_var_pop_fields>;
  var_samp?: Maybe<active_batch_var_samp_fields>;
  variance?: Maybe<active_batch_variance_fields>;
};

/** aggregate fields of "active_batch" */
export type active_batch_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<active_batch_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type active_batch_avg_fields = {
  __typename?: 'active_batch_avg_fields';
  year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "active_batch". All fields are combined with a logical 'AND'. */
export type active_batch_bool_exp = {
  _and?: Maybe<Array<active_batch_bool_exp>>;
  _not?: Maybe<active_batch_bool_exp>;
  _or?: Maybe<Array<active_batch_bool_exp>>;
  active?: Maybe<Boolean_comparison_exp>;
  active_batch_subject_configurations?: Maybe<batch_subject_configuration_bool_exp>;
  batch_classes?: Maybe<batch_class_bool_exp>;
  course?: Maybe<course_bool_exp>;
  courseId?: Maybe<uuid_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  intake?: Maybe<intake_bool_exp>;
  intakeId?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  year?: Maybe<Int_comparison_exp>;
};

/** input type for incrementing numeric columns in table "active_batch" */
export type active_batch_inc_input = {
  year?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "active_batch" */
export type active_batch_insert_input = {
  active?: Maybe<Scalars['Boolean']>;
  active_batch_subject_configurations?: Maybe<batch_subject_configuration_arr_rel_insert_input>;
  batch_classes?: Maybe<batch_class_arr_rel_insert_input>;
  course?: Maybe<course_obj_rel_insert_input>;
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intake?: Maybe<intake_obj_rel_insert_input>;
  intakeId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type active_batch_max_fields = {
  __typename?: 'active_batch_max_fields';
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type active_batch_min_fields = {
  __typename?: 'active_batch_min_fields';
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "active_batch" */
export type active_batch_mutation_response = {
  __typename?: 'active_batch_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<active_batch>;
};

/** Ordering options when selecting data from "active_batch". */
export type active_batch_order_by = {
  active?: Maybe<order_by>;
  active_batch_subject_configurations_aggregate?: Maybe<batch_subject_configuration_aggregate_order_by>;
  batch_classes_aggregate?: Maybe<batch_class_aggregate_order_by>;
  course?: Maybe<course_order_by>;
  courseId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  intake?: Maybe<intake_order_by>;
  intakeId?: Maybe<order_by>;
  name?: Maybe<order_by>;
  year?: Maybe<order_by>;
};

/** select columns of table "active_batch" */
export enum active_batch_select_column {
  /** column name */
  active = 'active',
  /** column name */
  courseId = 'courseId',
  /** column name */
  id = 'id',
  /** column name */
  intakeId = 'intakeId',
  /** column name */
  name = 'name',
  /** column name */
  year = 'year',
}

/** input type for updating data in table "active_batch" */
export type active_batch_set_input = {
  active?: Maybe<Scalars['Boolean']>;
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type active_batch_stddev_fields = {
  __typename?: 'active_batch_stddev_fields';
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type active_batch_stddev_pop_fields = {
  __typename?: 'active_batch_stddev_pop_fields';
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type active_batch_stddev_samp_fields = {
  __typename?: 'active_batch_stddev_samp_fields';
  year?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type active_batch_sum_fields = {
  __typename?: 'active_batch_sum_fields';
  year?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type active_batch_var_pop_fields = {
  __typename?: 'active_batch_var_pop_fields';
  year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type active_batch_var_samp_fields = {
  __typename?: 'active_batch_var_samp_fields';
  year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type active_batch_variance_fields = {
  __typename?: 'active_batch_variance_fields';
  year?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "assessment" */
export type assessment = {
  __typename?: 'assessment';
  batchSubjectConfigurationId: Scalars['uuid'];
  /** An object relationship */
  batch_subject_configuration: batch_subject_configuration;
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description: Scalars['String'];
  endDate: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isUploadable: Scalars['Boolean'];
  resources?: Maybe<Scalars['String']>;
  startDate: Scalars['timestamptz'];
  /** An array relationship */
  student_assessment_submissions: Array<student_assessment_submission>;
  /** An aggregate relationship */
  student_assessment_submissions_aggregate: student_assessment_submission_aggregate;
  /** An array relationship */
  student_results: Array<student_result>;
  /** An aggregate relationship */
  student_results_aggregate: student_result_aggregate;
  title: Scalars['String'];
  totalMarks?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "assessment" */
export type assessmentstudent_assessment_submissionsArgs = {
  distinct_on?: Maybe<Array<student_assessment_submission_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_assessment_submission_order_by>>;
  where?: Maybe<student_assessment_submission_bool_exp>;
};

/** columns and relationships of "assessment" */
export type assessmentstudent_assessment_submissions_aggregateArgs = {
  distinct_on?: Maybe<Array<student_assessment_submission_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_assessment_submission_order_by>>;
  where?: Maybe<student_assessment_submission_bool_exp>;
};

/** columns and relationships of "assessment" */
export type assessmentstudent_resultsArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

/** columns and relationships of "assessment" */
export type assessmentstudent_results_aggregateArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

/** aggregated selection of "assessment" */
export type assessment_aggregate = {
  __typename?: 'assessment_aggregate';
  aggregate?: Maybe<assessment_aggregate_fields>;
  nodes: Array<assessment>;
};

/** aggregate fields of "assessment" */
export type assessment_aggregate_fields = {
  __typename?: 'assessment_aggregate_fields';
  avg?: Maybe<assessment_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<assessment_max_fields>;
  min?: Maybe<assessment_min_fields>;
  stddev?: Maybe<assessment_stddev_fields>;
  stddev_pop?: Maybe<assessment_stddev_pop_fields>;
  stddev_samp?: Maybe<assessment_stddev_samp_fields>;
  sum?: Maybe<assessment_sum_fields>;
  var_pop?: Maybe<assessment_var_pop_fields>;
  var_samp?: Maybe<assessment_var_samp_fields>;
  variance?: Maybe<assessment_variance_fields>;
};

/** aggregate fields of "assessment" */
export type assessment_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<assessment_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assessment" */
export type assessment_aggregate_order_by = {
  avg?: Maybe<assessment_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<assessment_max_order_by>;
  min?: Maybe<assessment_min_order_by>;
  stddev?: Maybe<assessment_stddev_order_by>;
  stddev_pop?: Maybe<assessment_stddev_pop_order_by>;
  stddev_samp?: Maybe<assessment_stddev_samp_order_by>;
  sum?: Maybe<assessment_sum_order_by>;
  var_pop?: Maybe<assessment_var_pop_order_by>;
  var_samp?: Maybe<assessment_var_samp_order_by>;
  variance?: Maybe<assessment_variance_order_by>;
};

/** input type for inserting array relation for remote table "assessment" */
export type assessment_arr_rel_insert_input = {
  data: Array<assessment_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<assessment_on_conflict>;
};

/** aggregate avg on columns */
export type assessment_avg_fields = {
  __typename?: 'assessment_avg_fields';
  totalMarks?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "assessment" */
export type assessment_avg_order_by = {
  totalMarks?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "assessment". All fields are combined with a logical 'AND'. */
export type assessment_bool_exp = {
  _and?: Maybe<Array<assessment_bool_exp>>;
  _not?: Maybe<assessment_bool_exp>;
  _or?: Maybe<Array<assessment_bool_exp>>;
  batchSubjectConfigurationId?: Maybe<uuid_comparison_exp>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_bool_exp>;
  createdByUserFirebaseUID?: Maybe<String_comparison_exp>;
  created_at?: Maybe<timestamptz_comparison_exp>;
  description?: Maybe<String_comparison_exp>;
  endDate?: Maybe<timestamptz_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  isUploadable?: Maybe<Boolean_comparison_exp>;
  resources?: Maybe<String_comparison_exp>;
  startDate?: Maybe<timestamptz_comparison_exp>;
  student_assessment_submissions?: Maybe<student_assessment_submission_bool_exp>;
  student_results?: Maybe<student_result_bool_exp>;
  title?: Maybe<String_comparison_exp>;
  totalMarks?: Maybe<Int_comparison_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "assessment" */
export enum assessment_constraint {
  /** unique or primary key constraint */
  assessment_pkey = 'assessment_pkey',
}

/** input type for incrementing numeric columns in table "assessment" */
export type assessment_inc_input = {
  totalMarks?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "assessment" */
export type assessment_insert_input = {
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_obj_rel_insert_input>;
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  isUploadable?: Maybe<Scalars['Boolean']>;
  resources?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  student_assessment_submissions?: Maybe<student_assessment_submission_arr_rel_insert_input>;
  student_results?: Maybe<student_result_arr_rel_insert_input>;
  title?: Maybe<Scalars['String']>;
  totalMarks?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type assessment_max_fields = {
  __typename?: 'assessment_max_fields';
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  resources?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  totalMarks?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "assessment" */
export type assessment_max_order_by = {
  batchSubjectConfigurationId?: Maybe<order_by>;
  createdByUserFirebaseUID?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  description?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  resources?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  title?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** aggregate min on columns */
export type assessment_min_fields = {
  __typename?: 'assessment_min_fields';
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  resources?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  totalMarks?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "assessment" */
export type assessment_min_order_by = {
  batchSubjectConfigurationId?: Maybe<order_by>;
  createdByUserFirebaseUID?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  description?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  resources?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  title?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** response of any mutation on the table "assessment" */
export type assessment_mutation_response = {
  __typename?: 'assessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<assessment>;
};

/** input type for inserting object relation for remote table "assessment" */
export type assessment_obj_rel_insert_input = {
  data: assessment_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<assessment_on_conflict>;
};

/** on conflict condition type for table "assessment" */
export type assessment_on_conflict = {
  constraint: assessment_constraint;
  update_columns?: Array<assessment_update_column>;
  where?: Maybe<assessment_bool_exp>;
};

/** Ordering options when selecting data from "assessment". */
export type assessment_order_by = {
  batchSubjectConfigurationId?: Maybe<order_by>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_order_by>;
  createdByUserFirebaseUID?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  description?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  isUploadable?: Maybe<order_by>;
  resources?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  student_assessment_submissions_aggregate?: Maybe<student_assessment_submission_aggregate_order_by>;
  student_results_aggregate?: Maybe<student_result_aggregate_order_by>;
  title?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** primary key columns input for table: assessment */
export type assessment_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "assessment" */
export enum assessment_select_column {
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  createdByUserFirebaseUID = 'createdByUserFirebaseUID',
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  endDate = 'endDate',
  /** column name */
  id = 'id',
  /** column name */
  isUploadable = 'isUploadable',
  /** column name */
  resources = 'resources',
  /** column name */
  startDate = 'startDate',
  /** column name */
  title = 'title',
  /** column name */
  totalMarks = 'totalMarks',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "assessment" */
export type assessment_set_input = {
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  isUploadable?: Maybe<Scalars['Boolean']>;
  resources?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  title?: Maybe<Scalars['String']>;
  totalMarks?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type assessment_stddev_fields = {
  __typename?: 'assessment_stddev_fields';
  totalMarks?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "assessment" */
export type assessment_stddev_order_by = {
  totalMarks?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type assessment_stddev_pop_fields = {
  __typename?: 'assessment_stddev_pop_fields';
  totalMarks?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "assessment" */
export type assessment_stddev_pop_order_by = {
  totalMarks?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type assessment_stddev_samp_fields = {
  __typename?: 'assessment_stddev_samp_fields';
  totalMarks?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "assessment" */
export type assessment_stddev_samp_order_by = {
  totalMarks?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type assessment_sum_fields = {
  __typename?: 'assessment_sum_fields';
  totalMarks?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "assessment" */
export type assessment_sum_order_by = {
  totalMarks?: Maybe<order_by>;
};

/** update columns of table "assessment" */
export enum assessment_update_column {
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  createdByUserFirebaseUID = 'createdByUserFirebaseUID',
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  endDate = 'endDate',
  /** column name */
  id = 'id',
  /** column name */
  isUploadable = 'isUploadable',
  /** column name */
  resources = 'resources',
  /** column name */
  startDate = 'startDate',
  /** column name */
  title = 'title',
  /** column name */
  totalMarks = 'totalMarks',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate var_pop on columns */
export type assessment_var_pop_fields = {
  __typename?: 'assessment_var_pop_fields';
  totalMarks?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "assessment" */
export type assessment_var_pop_order_by = {
  totalMarks?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type assessment_var_samp_fields = {
  __typename?: 'assessment_var_samp_fields';
  totalMarks?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "assessment" */
export type assessment_var_samp_order_by = {
  totalMarks?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type assessment_variance_fields = {
  __typename?: 'assessment_variance_fields';
  totalMarks?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "assessment" */
export type assessment_variance_order_by = {
  totalMarks?: Maybe<order_by>;
};

/** columns and relationships of "attendance" */
export type attendance = {
  __typename?: 'attendance';
  /** An array relationship */
  attendance_students: Array<attendance_student>;
  /** An aggregate relationship */
  attendance_students_aggregate: attendance_student_aggregate;
  date?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  timetableItemId: Scalars['uuid'];
  /** An object relationship */
  timetable_item: timetable_item;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "attendance" */
export type attendanceattendance_studentsArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

/** columns and relationships of "attendance" */
export type attendanceattendance_students_aggregateArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

/** aggregated selection of "attendance" */
export type attendance_aggregate = {
  __typename?: 'attendance_aggregate';
  aggregate?: Maybe<attendance_aggregate_fields>;
  nodes: Array<attendance>;
};

/** aggregate fields of "attendance" */
export type attendance_aggregate_fields = {
  __typename?: 'attendance_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<attendance_max_fields>;
  min?: Maybe<attendance_min_fields>;
};

/** aggregate fields of "attendance" */
export type attendance_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<attendance_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "attendance" */
export type attendance_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<attendance_max_order_by>;
  min?: Maybe<attendance_min_order_by>;
};

/** input type for inserting array relation for remote table "attendance" */
export type attendance_arr_rel_insert_input = {
  data: Array<attendance_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<attendance_on_conflict>;
};

/** Boolean expression to filter rows from the table "attendance". All fields are combined with a logical 'AND'. */
export type attendance_bool_exp = {
  _and?: Maybe<Array<attendance_bool_exp>>;
  _not?: Maybe<attendance_bool_exp>;
  _or?: Maybe<Array<attendance_bool_exp>>;
  attendance_students?: Maybe<attendance_student_bool_exp>;
  date?: Maybe<timestamp_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  timetableItemId?: Maybe<uuid_comparison_exp>;
  timetable_item?: Maybe<timetable_item_bool_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "attendance" */
export enum attendance_constraint {
  /** unique or primary key constraint */
  attendance_pkey = 'attendance_pkey',
}

/** input type for inserting data into table "attendance" */
export type attendance_insert_input = {
  attendance_students?: Maybe<attendance_student_arr_rel_insert_input>;
  date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  timetableItemId?: Maybe<Scalars['uuid']>;
  timetable_item?: Maybe<timetable_item_obj_rel_insert_input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type attendance_max_fields = {
  __typename?: 'attendance_max_fields';
  date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  timetableItemId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "attendance" */
export type attendance_max_order_by = {
  date?: Maybe<order_by>;
  id?: Maybe<order_by>;
  timetableItemId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** aggregate min on columns */
export type attendance_min_fields = {
  __typename?: 'attendance_min_fields';
  date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  timetableItemId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "attendance" */
export type attendance_min_order_by = {
  date?: Maybe<order_by>;
  id?: Maybe<order_by>;
  timetableItemId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** response of any mutation on the table "attendance" */
export type attendance_mutation_response = {
  __typename?: 'attendance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<attendance>;
};

/** input type for inserting object relation for remote table "attendance" */
export type attendance_obj_rel_insert_input = {
  data: attendance_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<attendance_on_conflict>;
};

/** on conflict condition type for table "attendance" */
export type attendance_on_conflict = {
  constraint: attendance_constraint;
  update_columns?: Array<attendance_update_column>;
  where?: Maybe<attendance_bool_exp>;
};

/** Ordering options when selecting data from "attendance". */
export type attendance_order_by = {
  attendance_students_aggregate?: Maybe<attendance_student_aggregate_order_by>;
  date?: Maybe<order_by>;
  id?: Maybe<order_by>;
  timetableItemId?: Maybe<order_by>;
  timetable_item?: Maybe<timetable_item_order_by>;
  updated_at?: Maybe<order_by>;
};

/** primary key columns input for table: attendance */
export type attendance_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "attendance" */
export enum attendance_select_column {
  /** column name */
  date = 'date',
  /** column name */
  id = 'id',
  /** column name */
  timetableItemId = 'timetableItemId',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "attendance" */
export type attendance_set_input = {
  date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  timetableItemId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "attendance_student" */
export type attendance_student = {
  __typename?: 'attendance_student';
  /** An object relationship */
  attendance?: Maybe<attendance>;
  attendanceId?: Maybe<Scalars['uuid']>;
  discardWithdrawalNotice: Scalars['Boolean'];
  id: Scalars['uuid'];
  notifyWithdrawal: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['timestamp']>;
  remarks?: Maybe<Scalars['String']>;
  status: student_attendance_status_enum;
  /** An object relationship */
  student: student;
  studentId: Scalars['Int'];
  /** An object relationship */
  student_attendance_status: student_attendance_status;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "attendance_student" */
export type attendance_student_aggregate = {
  __typename?: 'attendance_student_aggregate';
  aggregate?: Maybe<attendance_student_aggregate_fields>;
  nodes: Array<attendance_student>;
};

/** aggregate fields of "attendance_student" */
export type attendance_student_aggregate_fields = {
  __typename?: 'attendance_student_aggregate_fields';
  avg?: Maybe<attendance_student_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<attendance_student_max_fields>;
  min?: Maybe<attendance_student_min_fields>;
  stddev?: Maybe<attendance_student_stddev_fields>;
  stddev_pop?: Maybe<attendance_student_stddev_pop_fields>;
  stddev_samp?: Maybe<attendance_student_stddev_samp_fields>;
  sum?: Maybe<attendance_student_sum_fields>;
  var_pop?: Maybe<attendance_student_var_pop_fields>;
  var_samp?: Maybe<attendance_student_var_samp_fields>;
  variance?: Maybe<attendance_student_variance_fields>;
};

/** aggregate fields of "attendance_student" */
export type attendance_student_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<attendance_student_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "attendance_student" */
export type attendance_student_aggregate_order_by = {
  avg?: Maybe<attendance_student_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<attendance_student_max_order_by>;
  min?: Maybe<attendance_student_min_order_by>;
  stddev?: Maybe<attendance_student_stddev_order_by>;
  stddev_pop?: Maybe<attendance_student_stddev_pop_order_by>;
  stddev_samp?: Maybe<attendance_student_stddev_samp_order_by>;
  sum?: Maybe<attendance_student_sum_order_by>;
  var_pop?: Maybe<attendance_student_var_pop_order_by>;
  var_samp?: Maybe<attendance_student_var_samp_order_by>;
  variance?: Maybe<attendance_student_variance_order_by>;
};

/** input type for inserting array relation for remote table "attendance_student" */
export type attendance_student_arr_rel_insert_input = {
  data: Array<attendance_student_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<attendance_student_on_conflict>;
};

/** aggregate avg on columns */
export type attendance_student_avg_fields = {
  __typename?: 'attendance_student_avg_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "attendance_student" */
export type attendance_student_avg_order_by = {
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "attendance_student". All fields are combined with a logical 'AND'. */
export type attendance_student_bool_exp = {
  _and?: Maybe<Array<attendance_student_bool_exp>>;
  _not?: Maybe<attendance_student_bool_exp>;
  _or?: Maybe<Array<attendance_student_bool_exp>>;
  attendance?: Maybe<attendance_bool_exp>;
  attendanceId?: Maybe<uuid_comparison_exp>;
  discardWithdrawalNotice?: Maybe<Boolean_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  notifyWithdrawal?: Maybe<Boolean_comparison_exp>;
  publishedAt?: Maybe<timestamp_comparison_exp>;
  remarks?: Maybe<String_comparison_exp>;
  status?: Maybe<student_attendance_status_enum_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  student_attendance_status?: Maybe<student_attendance_status_bool_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
  userId?: Maybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "attendance_student" */
export enum attendance_student_constraint {
  /** unique or primary key constraint */
  attendance_student_pkey = 'attendance_student_pkey',
}

/** input type for incrementing numeric columns in table "attendance_student" */
export type attendance_student_inc_input = {
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "attendance_student" */
export type attendance_student_insert_input = {
  attendance?: Maybe<attendance_obj_rel_insert_input>;
  attendanceId?: Maybe<Scalars['uuid']>;
  discardWithdrawalNotice?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  notifyWithdrawal?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<student_attendance_status_enum>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  student_attendance_status?: Maybe<student_attendance_status_obj_rel_insert_input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type attendance_student_max_fields = {
  __typename?: 'attendance_student_max_fields';
  attendanceId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  remarks?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "attendance_student" */
export type attendance_student_max_order_by = {
  attendanceId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  publishedAt?: Maybe<order_by>;
  remarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type attendance_student_min_fields = {
  __typename?: 'attendance_student_min_fields';
  attendanceId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  remarks?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "attendance_student" */
export type attendance_student_min_order_by = {
  attendanceId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  publishedAt?: Maybe<order_by>;
  remarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** response of any mutation on the table "attendance_student" */
export type attendance_student_mutation_response = {
  __typename?: 'attendance_student_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<attendance_student>;
};

/** on conflict condition type for table "attendance_student" */
export type attendance_student_on_conflict = {
  constraint: attendance_student_constraint;
  update_columns?: Array<attendance_student_update_column>;
  where?: Maybe<attendance_student_bool_exp>;
};

/** Ordering options when selecting data from "attendance_student". */
export type attendance_student_order_by = {
  attendance?: Maybe<attendance_order_by>;
  attendanceId?: Maybe<order_by>;
  discardWithdrawalNotice?: Maybe<order_by>;
  id?: Maybe<order_by>;
  notifyWithdrawal?: Maybe<order_by>;
  publishedAt?: Maybe<order_by>;
  remarks?: Maybe<order_by>;
  status?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  student_attendance_status?: Maybe<student_attendance_status_order_by>;
  updated_at?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** primary key columns input for table: attendance_student */
export type attendance_student_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "attendance_student" */
export enum attendance_student_select_column {
  /** column name */
  attendanceId = 'attendanceId',
  /** column name */
  discardWithdrawalNotice = 'discardWithdrawalNotice',
  /** column name */
  id = 'id',
  /** column name */
  notifyWithdrawal = 'notifyWithdrawal',
  /** column name */
  publishedAt = 'publishedAt',
  /** column name */
  remarks = 'remarks',
  /** column name */
  status = 'status',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  userId = 'userId',
}

/** input type for updating data in table "attendance_student" */
export type attendance_student_set_input = {
  attendanceId?: Maybe<Scalars['uuid']>;
  discardWithdrawalNotice?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  notifyWithdrawal?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  remarks?: Maybe<Scalars['String']>;
  status?: Maybe<student_attendance_status_enum>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type attendance_student_stddev_fields = {
  __typename?: 'attendance_student_stddev_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "attendance_student" */
export type attendance_student_stddev_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type attendance_student_stddev_pop_fields = {
  __typename?: 'attendance_student_stddev_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "attendance_student" */
export type attendance_student_stddev_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type attendance_student_stddev_samp_fields = {
  __typename?: 'attendance_student_stddev_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "attendance_student" */
export type attendance_student_stddev_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type attendance_student_sum_fields = {
  __typename?: 'attendance_student_sum_fields';
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "attendance_student" */
export type attendance_student_sum_order_by = {
  studentId?: Maybe<order_by>;
};

/** update columns of table "attendance_student" */
export enum attendance_student_update_column {
  /** column name */
  attendanceId = 'attendanceId',
  /** column name */
  discardWithdrawalNotice = 'discardWithdrawalNotice',
  /** column name */
  id = 'id',
  /** column name */
  notifyWithdrawal = 'notifyWithdrawal',
  /** column name */
  publishedAt = 'publishedAt',
  /** column name */
  remarks = 'remarks',
  /** column name */
  status = 'status',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  userId = 'userId',
}

/** aggregate var_pop on columns */
export type attendance_student_var_pop_fields = {
  __typename?: 'attendance_student_var_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "attendance_student" */
export type attendance_student_var_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type attendance_student_var_samp_fields = {
  __typename?: 'attendance_student_var_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "attendance_student" */
export type attendance_student_var_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type attendance_student_variance_fields = {
  __typename?: 'attendance_student_variance_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "attendance_student" */
export type attendance_student_variance_order_by = {
  studentId?: Maybe<order_by>;
};

/** update columns of table "attendance" */
export enum attendance_update_column {
  /** column name */
  date = 'date',
  /** column name */
  id = 'id',
  /** column name */
  timetableItemId = 'timetableItemId',
  /** column name */
  updated_at = 'updated_at',
}

/** columns and relationships of "batch" */
export type batch = {
  __typename?: 'batch';
  /** An array relationship */
  academic_calendar_items: Array<academic_calendar_item>;
  /** An aggregate relationship */
  academic_calendar_items_aggregate: academic_calendar_item_aggregate;
  active: Scalars['Boolean'];
  /** An array relationship */
  batch_classes: Array<batch_class>;
  /** An aggregate relationship */
  batch_classes_aggregate: batch_class_aggregate;
  /** An array relationship */
  batch_subject_configurations: Array<batch_subject_configuration>;
  /** An aggregate relationship */
  batch_subject_configurations_aggregate: batch_subject_configuration_aggregate;
  /** An object relationship */
  course?: Maybe<course>;
  courseId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  course_coordinators: Array<course_coordinator>;
  /** An aggregate relationship */
  course_coordinators_aggregate: course_coordinator_aggregate;
  id: Scalars['uuid'];
  /** An object relationship */
  intake?: Maybe<intake>;
  intakeId?: Maybe<Scalars['uuid']>;
  name: Scalars['String'];
  /** An array relationship */
  timetable_timeslot_configurations: Array<timetable_timeslot_configuration>;
  /** An aggregate relationship */
  timetable_timeslot_configurations_aggregate: timetable_timeslot_configuration_aggregate;
  year: Scalars['Int'];
};

/** columns and relationships of "batch" */
export type batchacademic_calendar_itemsArgs = {
  distinct_on?: Maybe<Array<academic_calendar_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<academic_calendar_item_order_by>>;
  where?: Maybe<academic_calendar_item_bool_exp>;
};

/** columns and relationships of "batch" */
export type batchacademic_calendar_items_aggregateArgs = {
  distinct_on?: Maybe<Array<academic_calendar_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<academic_calendar_item_order_by>>;
  where?: Maybe<academic_calendar_item_bool_exp>;
};

/** columns and relationships of "batch" */
export type batchbatch_classesArgs = {
  distinct_on?: Maybe<Array<batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_order_by>>;
  where?: Maybe<batch_class_bool_exp>;
};

/** columns and relationships of "batch" */
export type batchbatch_classes_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_order_by>>;
  where?: Maybe<batch_class_bool_exp>;
};

/** columns and relationships of "batch" */
export type batchbatch_subject_configurationsArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

/** columns and relationships of "batch" */
export type batchbatch_subject_configurations_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

/** columns and relationships of "batch" */
export type batchcourse_coordinatorsArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

/** columns and relationships of "batch" */
export type batchcourse_coordinators_aggregateArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

/** columns and relationships of "batch" */
export type batchtimetable_timeslot_configurationsArgs = {
  distinct_on?: Maybe<Array<timetable_timeslot_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_timeslot_configuration_order_by>>;
  where?: Maybe<timetable_timeslot_configuration_bool_exp>;
};

/** columns and relationships of "batch" */
export type batchtimetable_timeslot_configurations_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_timeslot_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_timeslot_configuration_order_by>>;
  where?: Maybe<timetable_timeslot_configuration_bool_exp>;
};

/** aggregated selection of "batch" */
export type batch_aggregate = {
  __typename?: 'batch_aggregate';
  aggregate?: Maybe<batch_aggregate_fields>;
  nodes: Array<batch>;
};

/** aggregate fields of "batch" */
export type batch_aggregate_fields = {
  __typename?: 'batch_aggregate_fields';
  avg?: Maybe<batch_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<batch_max_fields>;
  min?: Maybe<batch_min_fields>;
  stddev?: Maybe<batch_stddev_fields>;
  stddev_pop?: Maybe<batch_stddev_pop_fields>;
  stddev_samp?: Maybe<batch_stddev_samp_fields>;
  sum?: Maybe<batch_sum_fields>;
  var_pop?: Maybe<batch_var_pop_fields>;
  var_samp?: Maybe<batch_var_samp_fields>;
  variance?: Maybe<batch_variance_fields>;
};

/** aggregate fields of "batch" */
export type batch_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<batch_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "batch" */
export type batch_aggregate_order_by = {
  avg?: Maybe<batch_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<batch_max_order_by>;
  min?: Maybe<batch_min_order_by>;
  stddev?: Maybe<batch_stddev_order_by>;
  stddev_pop?: Maybe<batch_stddev_pop_order_by>;
  stddev_samp?: Maybe<batch_stddev_samp_order_by>;
  sum?: Maybe<batch_sum_order_by>;
  var_pop?: Maybe<batch_var_pop_order_by>;
  var_samp?: Maybe<batch_var_samp_order_by>;
  variance?: Maybe<batch_variance_order_by>;
};

/** input type for inserting array relation for remote table "batch" */
export type batch_arr_rel_insert_input = {
  data: Array<batch_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<batch_on_conflict>;
};

/** aggregate avg on columns */
export type batch_avg_fields = {
  __typename?: 'batch_avg_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "batch" */
export type batch_avg_order_by = {
  year?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "batch". All fields are combined with a logical 'AND'. */
export type batch_bool_exp = {
  _and?: Maybe<Array<batch_bool_exp>>;
  _not?: Maybe<batch_bool_exp>;
  _or?: Maybe<Array<batch_bool_exp>>;
  academic_calendar_items?: Maybe<academic_calendar_item_bool_exp>;
  active?: Maybe<Boolean_comparison_exp>;
  batch_classes?: Maybe<batch_class_bool_exp>;
  batch_subject_configurations?: Maybe<batch_subject_configuration_bool_exp>;
  course?: Maybe<course_bool_exp>;
  courseId?: Maybe<uuid_comparison_exp>;
  course_coordinators?: Maybe<course_coordinator_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  intake?: Maybe<intake_bool_exp>;
  intakeId?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  timetable_timeslot_configurations?: Maybe<timetable_timeslot_configuration_bool_exp>;
  year?: Maybe<Int_comparison_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_class = {
  __typename?: 'batch_class';
  /** An object relationship */
  batch?: Maybe<batch>;
  batchId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  batch_class_batch_subject_configurations: Array<batch_class_batch_subject_configurations>;
  /** An aggregate relationship */
  batch_class_batch_subject_configurations_aggregate: batch_class_batch_subject_configurations_aggregate;
  /** An array relationship */
  batch_class_batch_subject_extra_slot: Array<batch_class_batch_subject_extra_slot>;
  /** An aggregate relationship */
  batch_class_batch_subject_extra_slot_aggregate: batch_class_batch_subject_extra_slot_aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  result_sheets: Array<result_sheet>;
  /** An aggregate relationship */
  result_sheets_aggregate: result_sheet_aggregate;
  /** An array relationship */
  student_batch_classes_batch_classes: Array<student_batch_classes_batch_class>;
  /** An aggregate relationship */
  student_batch_classes_batch_classes_aggregate: student_batch_classes_batch_class_aggregate;
  /** An array relationship */
  student_batch_histories: Array<student_batch_history>;
  /** An aggregate relationship */
  student_batch_histories_aggregate: student_batch_history_aggregate;
  /** An array relationship */
  timetable_items: Array<timetable_item>;
  /** An aggregate relationship */
  timetable_items_aggregate: timetable_item_aggregate;
};

/** columns and relationships of "batch_class" */
export type batch_classbatch_class_batch_subject_configurationsArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_configurations_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_configurations_order_by>>;
  where?: Maybe<batch_class_batch_subject_configurations_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classbatch_class_batch_subject_configurations_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_configurations_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_configurations_order_by>>;
  where?: Maybe<batch_class_batch_subject_configurations_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classbatch_class_batch_subject_extra_slotArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_class_batch_subject_extra_slot_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classbatch_class_batch_subject_extra_slot_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_class_batch_subject_extra_slot_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classresult_sheetsArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classresult_sheets_aggregateArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classstudent_batch_classes_batch_classesArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classstudent_batch_classes_batch_classes_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classstudent_batch_historiesArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classstudent_batch_histories_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classtimetable_itemsArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** columns and relationships of "batch_class" */
export type batch_classtimetable_items_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** aggregated selection of "batch_class" */
export type batch_class_aggregate = {
  __typename?: 'batch_class_aggregate';
  aggregate?: Maybe<batch_class_aggregate_fields>;
  nodes: Array<batch_class>;
};

/** aggregate fields of "batch_class" */
export type batch_class_aggregate_fields = {
  __typename?: 'batch_class_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<batch_class_max_fields>;
  min?: Maybe<batch_class_min_fields>;
};

/** aggregate fields of "batch_class" */
export type batch_class_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<batch_class_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "batch_class" */
export type batch_class_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<batch_class_max_order_by>;
  min?: Maybe<batch_class_min_order_by>;
};

/** input type for inserting array relation for remote table "batch_class" */
export type batch_class_arr_rel_insert_input = {
  data: Array<batch_class_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<batch_class_on_conflict>;
};

/** columns and relationships of "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations = {
  __typename?: 'batch_class_batch_subject_configurations';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  batch_class?: Maybe<batch_class>;
  count?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_aggregate = {
  __typename?: 'batch_class_batch_subject_configurations_aggregate';
  aggregate?: Maybe<batch_class_batch_subject_configurations_aggregate_fields>;
  nodes: Array<batch_class_batch_subject_configurations>;
};

/** aggregate fields of "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_aggregate_fields = {
  __typename?: 'batch_class_batch_subject_configurations_aggregate_fields';
  avg?: Maybe<batch_class_batch_subject_configurations_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<batch_class_batch_subject_configurations_max_fields>;
  min?: Maybe<batch_class_batch_subject_configurations_min_fields>;
  stddev?: Maybe<batch_class_batch_subject_configurations_stddev_fields>;
  stddev_pop?: Maybe<batch_class_batch_subject_configurations_stddev_pop_fields>;
  stddev_samp?: Maybe<batch_class_batch_subject_configurations_stddev_samp_fields>;
  sum?: Maybe<batch_class_batch_subject_configurations_sum_fields>;
  var_pop?: Maybe<batch_class_batch_subject_configurations_var_pop_fields>;
  var_samp?: Maybe<batch_class_batch_subject_configurations_var_samp_fields>;
  variance?: Maybe<batch_class_batch_subject_configurations_variance_fields>;
};

/** aggregate fields of "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<batch_class_batch_subject_configurations_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_aggregate_order_by = {
  avg?: Maybe<batch_class_batch_subject_configurations_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<batch_class_batch_subject_configurations_max_order_by>;
  min?: Maybe<batch_class_batch_subject_configurations_min_order_by>;
  stddev?: Maybe<batch_class_batch_subject_configurations_stddev_order_by>;
  stddev_pop?: Maybe<batch_class_batch_subject_configurations_stddev_pop_order_by>;
  stddev_samp?: Maybe<batch_class_batch_subject_configurations_stddev_samp_order_by>;
  sum?: Maybe<batch_class_batch_subject_configurations_sum_order_by>;
  var_pop?: Maybe<batch_class_batch_subject_configurations_var_pop_order_by>;
  var_samp?: Maybe<batch_class_batch_subject_configurations_var_samp_order_by>;
  variance?: Maybe<batch_class_batch_subject_configurations_variance_order_by>;
};

/** input type for inserting array relation for remote table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_arr_rel_insert_input = {
  data: Array<batch_class_batch_subject_configurations_insert_input>;
};

/** aggregate avg on columns */
export type batch_class_batch_subject_configurations_avg_fields = {
  __typename?: 'batch_class_batch_subject_configurations_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_avg_order_by = {
  count?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "batch_class_batch_subject_configurations". All fields are combined with a logical 'AND'. */
export type batch_class_batch_subject_configurations_bool_exp = {
  _and?: Maybe<Array<batch_class_batch_subject_configurations_bool_exp>>;
  _not?: Maybe<batch_class_batch_subject_configurations_bool_exp>;
  _or?: Maybe<Array<batch_class_batch_subject_configurations_bool_exp>>;
  batchClassId?: Maybe<uuid_comparison_exp>;
  batchSubjectConfigurationId?: Maybe<uuid_comparison_exp>;
  batch_class?: Maybe<batch_class_bool_exp>;
  count?: Maybe<bigint_comparison_exp>;
};

/** input type for inserting data into table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_insert_input = {
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batch_class?: Maybe<batch_class_obj_rel_insert_input>;
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type batch_class_batch_subject_configurations_max_fields = {
  __typename?: 'batch_class_batch_subject_configurations_max_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_max_order_by = {
  batchClassId?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  count?: Maybe<order_by>;
};

/** aggregate min on columns */
export type batch_class_batch_subject_configurations_min_fields = {
  __typename?: 'batch_class_batch_subject_configurations_min_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_min_order_by = {
  batchClassId?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  count?: Maybe<order_by>;
};

/** Ordering options when selecting data from "batch_class_batch_subject_configurations". */
export type batch_class_batch_subject_configurations_order_by = {
  batchClassId?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  batch_class?: Maybe<batch_class_order_by>;
  count?: Maybe<order_by>;
};

/** select columns of table "batch_class_batch_subject_configurations" */
export enum batch_class_batch_subject_configurations_select_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  count = 'count',
}

/** aggregate stddev on columns */
export type batch_class_batch_subject_configurations_stddev_fields = {
  __typename?: 'batch_class_batch_subject_configurations_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_stddev_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type batch_class_batch_subject_configurations_stddev_pop_fields = {
  __typename?: 'batch_class_batch_subject_configurations_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_stddev_pop_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type batch_class_batch_subject_configurations_stddev_samp_fields = {
  __typename?: 'batch_class_batch_subject_configurations_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_stddev_samp_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type batch_class_batch_subject_configurations_sum_fields = {
  __typename?: 'batch_class_batch_subject_configurations_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_sum_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate var_pop on columns */
export type batch_class_batch_subject_configurations_var_pop_fields = {
  __typename?: 'batch_class_batch_subject_configurations_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_var_pop_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type batch_class_batch_subject_configurations_var_samp_fields = {
  __typename?: 'batch_class_batch_subject_configurations_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_var_samp_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type batch_class_batch_subject_configurations_variance_fields = {
  __typename?: 'batch_class_batch_subject_configurations_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "batch_class_batch_subject_configurations" */
export type batch_class_batch_subject_configurations_variance_order_by = {
  count?: Maybe<order_by>;
};

/** columns and relationships of "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot = {
  __typename?: 'batch_class_batch_subject_extra_slot';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  batch_class?: Maybe<batch_class>;
  count?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_aggregate = {
  __typename?: 'batch_class_batch_subject_extra_slot_aggregate';
  aggregate?: Maybe<batch_class_batch_subject_extra_slot_aggregate_fields>;
  nodes: Array<batch_class_batch_subject_extra_slot>;
};

/** aggregate fields of "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_aggregate_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_aggregate_fields';
  avg?: Maybe<batch_class_batch_subject_extra_slot_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<batch_class_batch_subject_extra_slot_max_fields>;
  min?: Maybe<batch_class_batch_subject_extra_slot_min_fields>;
  stddev?: Maybe<batch_class_batch_subject_extra_slot_stddev_fields>;
  stddev_pop?: Maybe<batch_class_batch_subject_extra_slot_stddev_pop_fields>;
  stddev_samp?: Maybe<batch_class_batch_subject_extra_slot_stddev_samp_fields>;
  sum?: Maybe<batch_class_batch_subject_extra_slot_sum_fields>;
  var_pop?: Maybe<batch_class_batch_subject_extra_slot_var_pop_fields>;
  var_samp?: Maybe<batch_class_batch_subject_extra_slot_var_samp_fields>;
  variance?: Maybe<batch_class_batch_subject_extra_slot_variance_fields>;
};

/** aggregate fields of "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<batch_class_batch_subject_extra_slot_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_aggregate_order_by = {
  avg?: Maybe<batch_class_batch_subject_extra_slot_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<batch_class_batch_subject_extra_slot_max_order_by>;
  min?: Maybe<batch_class_batch_subject_extra_slot_min_order_by>;
  stddev?: Maybe<batch_class_batch_subject_extra_slot_stddev_order_by>;
  stddev_pop?: Maybe<batch_class_batch_subject_extra_slot_stddev_pop_order_by>;
  stddev_samp?: Maybe<batch_class_batch_subject_extra_slot_stddev_samp_order_by>;
  sum?: Maybe<batch_class_batch_subject_extra_slot_sum_order_by>;
  var_pop?: Maybe<batch_class_batch_subject_extra_slot_var_pop_order_by>;
  var_samp?: Maybe<batch_class_batch_subject_extra_slot_var_samp_order_by>;
  variance?: Maybe<batch_class_batch_subject_extra_slot_variance_order_by>;
};

/** input type for inserting array relation for remote table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_arr_rel_insert_input = {
  data: Array<batch_class_batch_subject_extra_slot_insert_input>;
};

/** aggregate avg on columns */
export type batch_class_batch_subject_extra_slot_avg_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_avg_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_avg_order_by = {
  count?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "batch_class_batch_subject_extra_slot". All fields are combined with a logical 'AND'. */
export type batch_class_batch_subject_extra_slot_bool_exp = {
  _and?: Maybe<Array<batch_class_batch_subject_extra_slot_bool_exp>>;
  _not?: Maybe<batch_class_batch_subject_extra_slot_bool_exp>;
  _or?: Maybe<Array<batch_class_batch_subject_extra_slot_bool_exp>>;
  batchClassId?: Maybe<uuid_comparison_exp>;
  batchSubjectExtraSlotId?: Maybe<uuid_comparison_exp>;
  batch_class?: Maybe<batch_class_bool_exp>;
  count?: Maybe<bigint_comparison_exp>;
};

/** input type for inserting data into table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_insert_input = {
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  batch_class?: Maybe<batch_class_obj_rel_insert_input>;
  count?: Maybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type batch_class_batch_subject_extra_slot_max_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_max_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_max_order_by = {
  batchClassId?: Maybe<order_by>;
  batchSubjectExtraSlotId?: Maybe<order_by>;
  count?: Maybe<order_by>;
};

/** aggregate min on columns */
export type batch_class_batch_subject_extra_slot_min_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_min_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  count?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_min_order_by = {
  batchClassId?: Maybe<order_by>;
  batchSubjectExtraSlotId?: Maybe<order_by>;
  count?: Maybe<order_by>;
};

/** Ordering options when selecting data from "batch_class_batch_subject_extra_slot". */
export type batch_class_batch_subject_extra_slot_order_by = {
  batchClassId?: Maybe<order_by>;
  batchSubjectExtraSlotId?: Maybe<order_by>;
  batch_class?: Maybe<batch_class_order_by>;
  count?: Maybe<order_by>;
};

/** select columns of table "batch_class_batch_subject_extra_slot" */
export enum batch_class_batch_subject_extra_slot_select_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  batchSubjectExtraSlotId = 'batchSubjectExtraSlotId',
  /** column name */
  count = 'count',
}

/** aggregate stddev on columns */
export type batch_class_batch_subject_extra_slot_stddev_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_stddev_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_stddev_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type batch_class_batch_subject_extra_slot_stddev_pop_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_stddev_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_stddev_pop_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type batch_class_batch_subject_extra_slot_stddev_samp_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_stddev_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_stddev_samp_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type batch_class_batch_subject_extra_slot_sum_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_sum_fields';
  count?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_sum_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate var_pop on columns */
export type batch_class_batch_subject_extra_slot_var_pop_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_var_pop_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_var_pop_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type batch_class_batch_subject_extra_slot_var_samp_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_var_samp_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_var_samp_order_by = {
  count?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type batch_class_batch_subject_extra_slot_variance_fields = {
  __typename?: 'batch_class_batch_subject_extra_slot_variance_fields';
  count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "batch_class_batch_subject_extra_slot" */
export type batch_class_batch_subject_extra_slot_variance_order_by = {
  count?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "batch_class". All fields are combined with a logical 'AND'. */
export type batch_class_bool_exp = {
  _and?: Maybe<Array<batch_class_bool_exp>>;
  _not?: Maybe<batch_class_bool_exp>;
  _or?: Maybe<Array<batch_class_bool_exp>>;
  batch?: Maybe<batch_bool_exp>;
  batchId?: Maybe<uuid_comparison_exp>;
  batch_class_batch_subject_configurations?: Maybe<batch_class_batch_subject_configurations_bool_exp>;
  batch_class_batch_subject_extra_slot?: Maybe<batch_class_batch_subject_extra_slot_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  result_sheets?: Maybe<result_sheet_bool_exp>;
  student_batch_classes_batch_classes?: Maybe<student_batch_classes_batch_class_bool_exp>;
  student_batch_histories?: Maybe<student_batch_history_bool_exp>;
  timetable_items?: Maybe<timetable_item_bool_exp>;
};

/** unique or primary key constraints on table "batch_class" */
export enum batch_class_constraint {
  /** unique or primary key constraint */
  PK_1688886b8eb5485cb8a5a827121 = 'PK_1688886b8eb5485cb8a5a827121',
}

/** input type for inserting data into table "batch_class" */
export type batch_class_insert_input = {
  batch?: Maybe<batch_obj_rel_insert_input>;
  batchId?: Maybe<Scalars['uuid']>;
  batch_class_batch_subject_configurations?: Maybe<batch_class_batch_subject_configurations_arr_rel_insert_input>;
  batch_class_batch_subject_extra_slot?: Maybe<batch_class_batch_subject_extra_slot_arr_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  result_sheets?: Maybe<result_sheet_arr_rel_insert_input>;
  student_batch_classes_batch_classes?: Maybe<student_batch_classes_batch_class_arr_rel_insert_input>;
  student_batch_histories?: Maybe<student_batch_history_arr_rel_insert_input>;
  timetable_items?: Maybe<timetable_item_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type batch_class_max_fields = {
  __typename?: 'batch_class_max_fields';
  batchId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "batch_class" */
export type batch_class_max_order_by = {
  batchId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
};

/** aggregate min on columns */
export type batch_class_min_fields = {
  __typename?: 'batch_class_min_fields';
  batchId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "batch_class" */
export type batch_class_min_order_by = {
  batchId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
};

/** response of any mutation on the table "batch_class" */
export type batch_class_mutation_response = {
  __typename?: 'batch_class_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<batch_class>;
};

/** input type for inserting object relation for remote table "batch_class" */
export type batch_class_obj_rel_insert_input = {
  data: batch_class_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<batch_class_on_conflict>;
};

/** on conflict condition type for table "batch_class" */
export type batch_class_on_conflict = {
  constraint: batch_class_constraint;
  update_columns?: Array<batch_class_update_column>;
  where?: Maybe<batch_class_bool_exp>;
};

/** Ordering options when selecting data from "batch_class". */
export type batch_class_order_by = {
  batch?: Maybe<batch_order_by>;
  batchId?: Maybe<order_by>;
  batch_class_batch_subject_configurations_aggregate?: Maybe<batch_class_batch_subject_configurations_aggregate_order_by>;
  batch_class_batch_subject_extra_slot_aggregate?: Maybe<batch_class_batch_subject_extra_slot_aggregate_order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  result_sheets_aggregate?: Maybe<result_sheet_aggregate_order_by>;
  student_batch_classes_batch_classes_aggregate?: Maybe<student_batch_classes_batch_class_aggregate_order_by>;
  student_batch_histories_aggregate?: Maybe<student_batch_history_aggregate_order_by>;
  timetable_items_aggregate?: Maybe<timetable_item_aggregate_order_by>;
};

/** primary key columns input for table: batch_class */
export type batch_class_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "batch_class" */
export enum batch_class_select_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** input type for updating data in table "batch_class" */
export type batch_class_set_input = {
  batchId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "batch_class" */
export enum batch_class_update_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** unique or primary key constraints on table "batch" */
export enum batch_constraint {
  /** unique or primary key constraint */
  IDX_458996cec8e4e926513ece5e4e = 'IDX_458996cec8e4e926513ece5e4e',
  /** unique or primary key constraint */
  PK_57da3b830b57bec1fd329dcaf43 = 'PK_57da3b830b57bec1fd329dcaf43',
  /** unique or primary key constraint */
  UQ_85fde1bea0b040ee9d132677d50 = 'UQ_85fde1bea0b040ee9d132677d50',
}

/** input type for incrementing numeric columns in table "batch" */
export type batch_inc_input = {
  year?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "batch" */
export type batch_insert_input = {
  academic_calendar_items?: Maybe<academic_calendar_item_arr_rel_insert_input>;
  active?: Maybe<Scalars['Boolean']>;
  batch_classes?: Maybe<batch_class_arr_rel_insert_input>;
  batch_subject_configurations?: Maybe<batch_subject_configuration_arr_rel_insert_input>;
  course?: Maybe<course_obj_rel_insert_input>;
  courseId?: Maybe<Scalars['uuid']>;
  course_coordinators?: Maybe<course_coordinator_arr_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  intake?: Maybe<intake_obj_rel_insert_input>;
  intakeId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  timetable_timeslot_configurations?: Maybe<timetable_timeslot_configuration_arr_rel_insert_input>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type batch_max_fields = {
  __typename?: 'batch_max_fields';
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "batch" */
export type batch_max_order_by = {
  courseId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  intakeId?: Maybe<order_by>;
  name?: Maybe<order_by>;
  year?: Maybe<order_by>;
};

/** aggregate min on columns */
export type batch_min_fields = {
  __typename?: 'batch_min_fields';
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "batch" */
export type batch_min_order_by = {
  courseId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  intakeId?: Maybe<order_by>;
  name?: Maybe<order_by>;
  year?: Maybe<order_by>;
};

/** response of any mutation on the table "batch" */
export type batch_mutation_response = {
  __typename?: 'batch_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<batch>;
};

/** input type for inserting object relation for remote table "batch" */
export type batch_obj_rel_insert_input = {
  data: batch_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<batch_on_conflict>;
};

/** on conflict condition type for table "batch" */
export type batch_on_conflict = {
  constraint: batch_constraint;
  update_columns?: Array<batch_update_column>;
  where?: Maybe<batch_bool_exp>;
};

/** Ordering options when selecting data from "batch". */
export type batch_order_by = {
  academic_calendar_items_aggregate?: Maybe<academic_calendar_item_aggregate_order_by>;
  active?: Maybe<order_by>;
  batch_classes_aggregate?: Maybe<batch_class_aggregate_order_by>;
  batch_subject_configurations_aggregate?: Maybe<batch_subject_configuration_aggregate_order_by>;
  course?: Maybe<course_order_by>;
  courseId?: Maybe<order_by>;
  course_coordinators_aggregate?: Maybe<course_coordinator_aggregate_order_by>;
  id?: Maybe<order_by>;
  intake?: Maybe<intake_order_by>;
  intakeId?: Maybe<order_by>;
  name?: Maybe<order_by>;
  timetable_timeslot_configurations_aggregate?: Maybe<timetable_timeslot_configuration_aggregate_order_by>;
  year?: Maybe<order_by>;
};

/** primary key columns input for table: batch */
export type batch_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "batch" */
export enum batch_select_column {
  /** column name */
  active = 'active',
  /** column name */
  courseId = 'courseId',
  /** column name */
  id = 'id',
  /** column name */
  intakeId = 'intakeId',
  /** column name */
  name = 'name',
  /** column name */
  year = 'year',
}

/** input type for updating data in table "batch" */
export type batch_set_input = {
  active?: Maybe<Scalars['Boolean']>;
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type batch_stddev_fields = {
  __typename?: 'batch_stddev_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "batch" */
export type batch_stddev_order_by = {
  year?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type batch_stddev_pop_fields = {
  __typename?: 'batch_stddev_pop_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "batch" */
export type batch_stddev_pop_order_by = {
  year?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type batch_stddev_samp_fields = {
  __typename?: 'batch_stddev_samp_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "batch" */
export type batch_stddev_samp_order_by = {
  year?: Maybe<order_by>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configuration = {
  __typename?: 'batch_subject_configuration';
  /** An array relationship */
  assessments: Array<assessment>;
  /** An aggregate relationship */
  assessments_aggregate: assessment_aggregate;
  /** An object relationship */
  batch?: Maybe<batch>;
  batchId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  batch_subject_extra_slots: Array<batch_subject_extra_slot>;
  /** An aggregate relationship */
  batch_subject_extra_slots_aggregate: batch_subject_extra_slot_aggregate;
  courseSemesterId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  course_semester?: Maybe<course_semester>;
  hoursPerSlot: Scalars['Int'];
  id: Scalars['uuid'];
  /** An array relationship */
  lecture_materials: Array<lecture_material>;
  /** An aggregate relationship */
  lecture_materials_aggregate: lecture_material_aggregate;
  minutesPerSlot: Scalars['Int'];
  /** An array relationship */
  result_sheets: Array<result_sheet>;
  /** An aggregate relationship */
  result_sheets_aggregate: result_sheet_aggregate;
  /** An object relationship */
  subject?: Maybe<subject>;
  subjectId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  timetable_items: Array<timetable_item>;
  /** An aggregate relationship */
  timetable_items_aggregate: timetable_item_aggregate;
  totalSlots: Scalars['Int'];
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationassessmentsArgs = {
  distinct_on?: Maybe<Array<assessment_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<assessment_order_by>>;
  where?: Maybe<assessment_bool_exp>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationassessments_aggregateArgs = {
  distinct_on?: Maybe<Array<assessment_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<assessment_order_by>>;
  where?: Maybe<assessment_bool_exp>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationbatch_subject_extra_slotsArgs = {
  distinct_on?: Maybe<Array<batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_subject_extra_slot_bool_exp>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationbatch_subject_extra_slots_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_subject_extra_slot_bool_exp>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationlecture_materialsArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationlecture_materials_aggregateArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationresult_sheetsArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationresult_sheets_aggregateArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationtimetable_itemsArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** columns and relationships of "batch_subject_configuration" */
export type batch_subject_configurationtimetable_items_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** aggregated selection of "batch_subject_configuration" */
export type batch_subject_configuration_aggregate = {
  __typename?: 'batch_subject_configuration_aggregate';
  aggregate?: Maybe<batch_subject_configuration_aggregate_fields>;
  nodes: Array<batch_subject_configuration>;
};

/** aggregate fields of "batch_subject_configuration" */
export type batch_subject_configuration_aggregate_fields = {
  __typename?: 'batch_subject_configuration_aggregate_fields';
  avg?: Maybe<batch_subject_configuration_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<batch_subject_configuration_max_fields>;
  min?: Maybe<batch_subject_configuration_min_fields>;
  stddev?: Maybe<batch_subject_configuration_stddev_fields>;
  stddev_pop?: Maybe<batch_subject_configuration_stddev_pop_fields>;
  stddev_samp?: Maybe<batch_subject_configuration_stddev_samp_fields>;
  sum?: Maybe<batch_subject_configuration_sum_fields>;
  var_pop?: Maybe<batch_subject_configuration_var_pop_fields>;
  var_samp?: Maybe<batch_subject_configuration_var_samp_fields>;
  variance?: Maybe<batch_subject_configuration_variance_fields>;
};

/** aggregate fields of "batch_subject_configuration" */
export type batch_subject_configuration_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<batch_subject_configuration_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "batch_subject_configuration" */
export type batch_subject_configuration_aggregate_order_by = {
  avg?: Maybe<batch_subject_configuration_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<batch_subject_configuration_max_order_by>;
  min?: Maybe<batch_subject_configuration_min_order_by>;
  stddev?: Maybe<batch_subject_configuration_stddev_order_by>;
  stddev_pop?: Maybe<batch_subject_configuration_stddev_pop_order_by>;
  stddev_samp?: Maybe<batch_subject_configuration_stddev_samp_order_by>;
  sum?: Maybe<batch_subject_configuration_sum_order_by>;
  var_pop?: Maybe<batch_subject_configuration_var_pop_order_by>;
  var_samp?: Maybe<batch_subject_configuration_var_samp_order_by>;
  variance?: Maybe<batch_subject_configuration_variance_order_by>;
};

/** input type for inserting array relation for remote table "batch_subject_configuration" */
export type batch_subject_configuration_arr_rel_insert_input = {
  data: Array<batch_subject_configuration_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<batch_subject_configuration_on_conflict>;
};

/** aggregate avg on columns */
export type batch_subject_configuration_avg_fields = {
  __typename?: 'batch_subject_configuration_avg_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_avg_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "batch_subject_configuration". All fields are combined with a logical 'AND'. */
export type batch_subject_configuration_bool_exp = {
  _and?: Maybe<Array<batch_subject_configuration_bool_exp>>;
  _not?: Maybe<batch_subject_configuration_bool_exp>;
  _or?: Maybe<Array<batch_subject_configuration_bool_exp>>;
  assessments?: Maybe<assessment_bool_exp>;
  batch?: Maybe<batch_bool_exp>;
  batchId?: Maybe<uuid_comparison_exp>;
  batch_subject_extra_slots?: Maybe<batch_subject_extra_slot_bool_exp>;
  courseSemesterId?: Maybe<uuid_comparison_exp>;
  course_semester?: Maybe<course_semester_bool_exp>;
  hoursPerSlot?: Maybe<Int_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  lecture_materials?: Maybe<lecture_material_bool_exp>;
  minutesPerSlot?: Maybe<Int_comparison_exp>;
  result_sheets?: Maybe<result_sheet_bool_exp>;
  subject?: Maybe<subject_bool_exp>;
  subjectId?: Maybe<uuid_comparison_exp>;
  timetable_items?: Maybe<timetable_item_bool_exp>;
  totalSlots?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "batch_subject_configuration" */
export enum batch_subject_configuration_constraint {
  /** unique or primary key constraint */
  PK_3bec14ac9e7709f71200b7caf5f = 'PK_3bec14ac9e7709f71200b7caf5f',
}

/** input type for incrementing numeric columns in table "batch_subject_configuration" */
export type batch_subject_configuration_inc_input = {
  hoursPerSlot?: Maybe<Scalars['Int']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "batch_subject_configuration" */
export type batch_subject_configuration_insert_input = {
  assessments?: Maybe<assessment_arr_rel_insert_input>;
  batch?: Maybe<batch_obj_rel_insert_input>;
  batchId?: Maybe<Scalars['uuid']>;
  batch_subject_extra_slots?: Maybe<batch_subject_extra_slot_arr_rel_insert_input>;
  courseSemesterId?: Maybe<Scalars['uuid']>;
  course_semester?: Maybe<course_semester_obj_rel_insert_input>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  lecture_materials?: Maybe<lecture_material_arr_rel_insert_input>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  result_sheets?: Maybe<result_sheet_arr_rel_insert_input>;
  subject?: Maybe<subject_obj_rel_insert_input>;
  subjectId?: Maybe<Scalars['uuid']>;
  timetable_items?: Maybe<timetable_item_arr_rel_insert_input>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type batch_subject_configuration_max_fields = {
  __typename?: 'batch_subject_configuration_max_fields';
  batchId?: Maybe<Scalars['uuid']>;
  courseSemesterId?: Maybe<Scalars['uuid']>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  subjectId?: Maybe<Scalars['uuid']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_max_order_by = {
  batchId?: Maybe<order_by>;
  courseSemesterId?: Maybe<order_by>;
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate min on columns */
export type batch_subject_configuration_min_fields = {
  __typename?: 'batch_subject_configuration_min_fields';
  batchId?: Maybe<Scalars['uuid']>;
  courseSemesterId?: Maybe<Scalars['uuid']>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  subjectId?: Maybe<Scalars['uuid']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_min_order_by = {
  batchId?: Maybe<order_by>;
  courseSemesterId?: Maybe<order_by>;
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** response of any mutation on the table "batch_subject_configuration" */
export type batch_subject_configuration_mutation_response = {
  __typename?: 'batch_subject_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<batch_subject_configuration>;
};

/** input type for inserting object relation for remote table "batch_subject_configuration" */
export type batch_subject_configuration_obj_rel_insert_input = {
  data: batch_subject_configuration_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<batch_subject_configuration_on_conflict>;
};

/** on conflict condition type for table "batch_subject_configuration" */
export type batch_subject_configuration_on_conflict = {
  constraint: batch_subject_configuration_constraint;
  update_columns?: Array<batch_subject_configuration_update_column>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

/** Ordering options when selecting data from "batch_subject_configuration". */
export type batch_subject_configuration_order_by = {
  assessments_aggregate?: Maybe<assessment_aggregate_order_by>;
  batch?: Maybe<batch_order_by>;
  batchId?: Maybe<order_by>;
  batch_subject_extra_slots_aggregate?: Maybe<batch_subject_extra_slot_aggregate_order_by>;
  courseSemesterId?: Maybe<order_by>;
  course_semester?: Maybe<course_semester_order_by>;
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lecture_materials_aggregate?: Maybe<lecture_material_aggregate_order_by>;
  minutesPerSlot?: Maybe<order_by>;
  result_sheets_aggregate?: Maybe<result_sheet_aggregate_order_by>;
  subject?: Maybe<subject_order_by>;
  subjectId?: Maybe<order_by>;
  timetable_items_aggregate?: Maybe<timetable_item_aggregate_order_by>;
  totalSlots?: Maybe<order_by>;
};

/** primary key columns input for table: batch_subject_configuration */
export type batch_subject_configuration_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "batch_subject_configuration" */
export enum batch_subject_configuration_select_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  courseSemesterId = 'courseSemesterId',
  /** column name */
  hoursPerSlot = 'hoursPerSlot',
  /** column name */
  id = 'id',
  /** column name */
  minutesPerSlot = 'minutesPerSlot',
  /** column name */
  subjectId = 'subjectId',
  /** column name */
  totalSlots = 'totalSlots',
}

/** input type for updating data in table "batch_subject_configuration" */
export type batch_subject_configuration_set_input = {
  batchId?: Maybe<Scalars['uuid']>;
  courseSemesterId?: Maybe<Scalars['uuid']>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  subjectId?: Maybe<Scalars['uuid']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type batch_subject_configuration_stddev_fields = {
  __typename?: 'batch_subject_configuration_stddev_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_stddev_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type batch_subject_configuration_stddev_pop_fields = {
  __typename?: 'batch_subject_configuration_stddev_pop_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_stddev_pop_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type batch_subject_configuration_stddev_samp_fields = {
  __typename?: 'batch_subject_configuration_stddev_samp_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_stddev_samp_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type batch_subject_configuration_sum_fields = {
  __typename?: 'batch_subject_configuration_sum_fields';
  hoursPerSlot?: Maybe<Scalars['Int']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_sum_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** update columns of table "batch_subject_configuration" */
export enum batch_subject_configuration_update_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  courseSemesterId = 'courseSemesterId',
  /** column name */
  hoursPerSlot = 'hoursPerSlot',
  /** column name */
  id = 'id',
  /** column name */
  minutesPerSlot = 'minutesPerSlot',
  /** column name */
  subjectId = 'subjectId',
  /** column name */
  totalSlots = 'totalSlots',
}

/** aggregate var_pop on columns */
export type batch_subject_configuration_var_pop_fields = {
  __typename?: 'batch_subject_configuration_var_pop_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_var_pop_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type batch_subject_configuration_var_samp_fields = {
  __typename?: 'batch_subject_configuration_var_samp_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_var_samp_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type batch_subject_configuration_variance_fields = {
  __typename?: 'batch_subject_configuration_variance_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "batch_subject_configuration" */
export type batch_subject_configuration_variance_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** columns and relationships of "batch_subject_extra_slot" */
export type batch_subject_extra_slot = {
  __typename?: 'batch_subject_extra_slot';
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  batch_subject_configuration?: Maybe<batch_subject_configuration>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** An array relationship */
  student_results: Array<student_result>;
  /** An aggregate relationship */
  student_results_aggregate: student_result_aggregate;
  /** An array relationship */
  timetable_items: Array<timetable_item>;
  /** An aggregate relationship */
  timetable_items_aggregate: timetable_item_aggregate;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "batch_subject_extra_slot" */
export type batch_subject_extra_slotstudent_resultsArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

/** columns and relationships of "batch_subject_extra_slot" */
export type batch_subject_extra_slotstudent_results_aggregateArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

/** columns and relationships of "batch_subject_extra_slot" */
export type batch_subject_extra_slottimetable_itemsArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** columns and relationships of "batch_subject_extra_slot" */
export type batch_subject_extra_slottimetable_items_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** aggregated selection of "batch_subject_extra_slot" */
export type batch_subject_extra_slot_aggregate = {
  __typename?: 'batch_subject_extra_slot_aggregate';
  aggregate?: Maybe<batch_subject_extra_slot_aggregate_fields>;
  nodes: Array<batch_subject_extra_slot>;
};

/** aggregate fields of "batch_subject_extra_slot" */
export type batch_subject_extra_slot_aggregate_fields = {
  __typename?: 'batch_subject_extra_slot_aggregate_fields';
  avg?: Maybe<batch_subject_extra_slot_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<batch_subject_extra_slot_max_fields>;
  min?: Maybe<batch_subject_extra_slot_min_fields>;
  stddev?: Maybe<batch_subject_extra_slot_stddev_fields>;
  stddev_pop?: Maybe<batch_subject_extra_slot_stddev_pop_fields>;
  stddev_samp?: Maybe<batch_subject_extra_slot_stddev_samp_fields>;
  sum?: Maybe<batch_subject_extra_slot_sum_fields>;
  var_pop?: Maybe<batch_subject_extra_slot_var_pop_fields>;
  var_samp?: Maybe<batch_subject_extra_slot_var_samp_fields>;
  variance?: Maybe<batch_subject_extra_slot_variance_fields>;
};

/** aggregate fields of "batch_subject_extra_slot" */
export type batch_subject_extra_slot_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<batch_subject_extra_slot_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_aggregate_order_by = {
  avg?: Maybe<batch_subject_extra_slot_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<batch_subject_extra_slot_max_order_by>;
  min?: Maybe<batch_subject_extra_slot_min_order_by>;
  stddev?: Maybe<batch_subject_extra_slot_stddev_order_by>;
  stddev_pop?: Maybe<batch_subject_extra_slot_stddev_pop_order_by>;
  stddev_samp?: Maybe<batch_subject_extra_slot_stddev_samp_order_by>;
  sum?: Maybe<batch_subject_extra_slot_sum_order_by>;
  var_pop?: Maybe<batch_subject_extra_slot_var_pop_order_by>;
  var_samp?: Maybe<batch_subject_extra_slot_var_samp_order_by>;
  variance?: Maybe<batch_subject_extra_slot_variance_order_by>;
};

/** input type for inserting array relation for remote table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_arr_rel_insert_input = {
  data: Array<batch_subject_extra_slot_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<batch_subject_extra_slot_on_conflict>;
};

/** aggregate avg on columns */
export type batch_subject_extra_slot_avg_fields = {
  __typename?: 'batch_subject_extra_slot_avg_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_avg_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "batch_subject_extra_slot". All fields are combined with a logical 'AND'. */
export type batch_subject_extra_slot_bool_exp = {
  _and?: Maybe<Array<batch_subject_extra_slot_bool_exp>>;
  _not?: Maybe<batch_subject_extra_slot_bool_exp>;
  _or?: Maybe<Array<batch_subject_extra_slot_bool_exp>>;
  batchSubjectConfigurationId?: Maybe<uuid_comparison_exp>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_bool_exp>;
  hoursPerSlot?: Maybe<Int_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  minutesPerSlot?: Maybe<Int_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  student_results?: Maybe<student_result_bool_exp>;
  timetable_items?: Maybe<timetable_item_bool_exp>;
  totalMarks?: Maybe<Int_comparison_exp>;
  totalSlots?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "batch_subject_extra_slot" */
export enum batch_subject_extra_slot_constraint {
  /** unique or primary key constraint */
  PK_d6741e32e1040c5fc60f99294a3 = 'PK_d6741e32e1040c5fc60f99294a3',
}

/** input type for incrementing numeric columns in table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_inc_input = {
  hoursPerSlot?: Maybe<Scalars['Int']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_insert_input = {
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_obj_rel_insert_input>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  student_results?: Maybe<student_result_arr_rel_insert_input>;
  timetable_items?: Maybe<timetable_item_arr_rel_insert_input>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type batch_subject_extra_slot_max_fields = {
  __typename?: 'batch_subject_extra_slot_max_fields';
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_max_order_by = {
  batchSubjectConfigurationId?: Maybe<order_by>;
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  name?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate min on columns */
export type batch_subject_extra_slot_min_fields = {
  __typename?: 'batch_subject_extra_slot_min_fields';
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_min_order_by = {
  batchSubjectConfigurationId?: Maybe<order_by>;
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  name?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** response of any mutation on the table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_mutation_response = {
  __typename?: 'batch_subject_extra_slot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<batch_subject_extra_slot>;
};

/** input type for inserting object relation for remote table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_obj_rel_insert_input = {
  data: batch_subject_extra_slot_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<batch_subject_extra_slot_on_conflict>;
};

/** on conflict condition type for table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_on_conflict = {
  constraint: batch_subject_extra_slot_constraint;
  update_columns?: Array<batch_subject_extra_slot_update_column>;
  where?: Maybe<batch_subject_extra_slot_bool_exp>;
};

/** Ordering options when selecting data from "batch_subject_extra_slot". */
export type batch_subject_extra_slot_order_by = {
  batchSubjectConfigurationId?: Maybe<order_by>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_order_by>;
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  name?: Maybe<order_by>;
  student_results_aggregate?: Maybe<student_result_aggregate_order_by>;
  timetable_items_aggregate?: Maybe<timetable_item_aggregate_order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** primary key columns input for table: batch_subject_extra_slot */
export type batch_subject_extra_slot_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "batch_subject_extra_slot" */
export enum batch_subject_extra_slot_select_column {
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  hoursPerSlot = 'hoursPerSlot',
  /** column name */
  id = 'id',
  /** column name */
  minutesPerSlot = 'minutesPerSlot',
  /** column name */
  name = 'name',
  /** column name */
  totalMarks = 'totalMarks',
  /** column name */
  totalSlots = 'totalSlots',
}

/** input type for updating data in table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_set_input = {
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type batch_subject_extra_slot_stddev_fields = {
  __typename?: 'batch_subject_extra_slot_stddev_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_stddev_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type batch_subject_extra_slot_stddev_pop_fields = {
  __typename?: 'batch_subject_extra_slot_stddev_pop_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_stddev_pop_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type batch_subject_extra_slot_stddev_samp_fields = {
  __typename?: 'batch_subject_extra_slot_stddev_samp_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_stddev_samp_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type batch_subject_extra_slot_sum_fields = {
  __typename?: 'batch_subject_extra_slot_sum_fields';
  hoursPerSlot?: Maybe<Scalars['Int']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_sum_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** update columns of table "batch_subject_extra_slot" */
export enum batch_subject_extra_slot_update_column {
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  hoursPerSlot = 'hoursPerSlot',
  /** column name */
  id = 'id',
  /** column name */
  minutesPerSlot = 'minutesPerSlot',
  /** column name */
  name = 'name',
  /** column name */
  totalMarks = 'totalMarks',
  /** column name */
  totalSlots = 'totalSlots',
}

/** aggregate var_pop on columns */
export type batch_subject_extra_slot_var_pop_fields = {
  __typename?: 'batch_subject_extra_slot_var_pop_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_var_pop_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type batch_subject_extra_slot_var_samp_fields = {
  __typename?: 'batch_subject_extra_slot_var_samp_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_var_samp_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type batch_subject_extra_slot_variance_fields = {
  __typename?: 'batch_subject_extra_slot_variance_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "batch_subject_extra_slot" */
export type batch_subject_extra_slot_variance_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type batch_sum_fields = {
  __typename?: 'batch_sum_fields';
  year?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "batch" */
export type batch_sum_order_by = {
  year?: Maybe<order_by>;
};

/** update columns of table "batch" */
export enum batch_update_column {
  /** column name */
  active = 'active',
  /** column name */
  courseId = 'courseId',
  /** column name */
  id = 'id',
  /** column name */
  intakeId = 'intakeId',
  /** column name */
  name = 'name',
  /** column name */
  year = 'year',
}

/** aggregate var_pop on columns */
export type batch_var_pop_fields = {
  __typename?: 'batch_var_pop_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "batch" */
export type batch_var_pop_order_by = {
  year?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type batch_var_samp_fields = {
  __typename?: 'batch_var_samp_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "batch" */
export type batch_var_samp_order_by = {
  year?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type batch_variance_fields = {
  __typename?: 'batch_variance_fields';
  year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "batch" */
export type batch_variance_order_by = {
  year?: Maybe<order_by>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type bigint_comparison_exp = {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "blood_type" */
export type blood_type = {
  __typename?: 'blood_type';
  name: Scalars['String'];
  /** An array relationship */
  students: Array<student>;
  /** An aggregate relationship */
  students_aggregate: student_aggregate;
};

/** columns and relationships of "blood_type" */
export type blood_typestudentsArgs = {
  distinct_on?: Maybe<Array<student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_order_by>>;
  where?: Maybe<student_bool_exp>;
};

/** columns and relationships of "blood_type" */
export type blood_typestudents_aggregateArgs = {
  distinct_on?: Maybe<Array<student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_order_by>>;
  where?: Maybe<student_bool_exp>;
};

/** aggregated selection of "blood_type" */
export type blood_type_aggregate = {
  __typename?: 'blood_type_aggregate';
  aggregate?: Maybe<blood_type_aggregate_fields>;
  nodes: Array<blood_type>;
};

/** aggregate fields of "blood_type" */
export type blood_type_aggregate_fields = {
  __typename?: 'blood_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<blood_type_max_fields>;
  min?: Maybe<blood_type_min_fields>;
};

/** aggregate fields of "blood_type" */
export type blood_type_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<blood_type_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "blood_type". All fields are combined with a logical 'AND'. */
export type blood_type_bool_exp = {
  _and?: Maybe<Array<blood_type_bool_exp>>;
  _not?: Maybe<blood_type_bool_exp>;
  _or?: Maybe<Array<blood_type_bool_exp>>;
  name?: Maybe<String_comparison_exp>;
  students?: Maybe<student_bool_exp>;
};

/** unique or primary key constraints on table "blood_type" */
export enum blood_type_constraint {
  /** unique or primary key constraint */
  blood_type_pkey = 'blood_type_pkey',
}

export enum blood_type_enum {
  ABNegative = 'ABNegative',
  ABPositive = 'ABPositive',
  ANegative = 'ANegative',
  APositive = 'APositive',
  BNegative = 'BNegative',
  BPositive = 'BPositive',
  ONegative = 'ONegative',
  OPositive = 'OPositive',
}

/** Boolean expression to compare columns of type "blood_type_enum". All fields are combined with logical 'AND'. */
export type blood_type_enum_comparison_exp = {
  _eq?: Maybe<blood_type_enum>;
  _in?: Maybe<Array<blood_type_enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<blood_type_enum>;
  _nin?: Maybe<Array<blood_type_enum>>;
};

/** input type for inserting data into table "blood_type" */
export type blood_type_insert_input = {
  name?: Maybe<Scalars['String']>;
  students?: Maybe<student_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type blood_type_max_fields = {
  __typename?: 'blood_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type blood_type_min_fields = {
  __typename?: 'blood_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "blood_type" */
export type blood_type_mutation_response = {
  __typename?: 'blood_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<blood_type>;
};

/** input type for inserting object relation for remote table "blood_type" */
export type blood_type_obj_rel_insert_input = {
  data: blood_type_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<blood_type_on_conflict>;
};

/** on conflict condition type for table "blood_type" */
export type blood_type_on_conflict = {
  constraint: blood_type_constraint;
  update_columns?: Array<blood_type_update_column>;
  where?: Maybe<blood_type_bool_exp>;
};

/** Ordering options when selecting data from "blood_type". */
export type blood_type_order_by = {
  name?: Maybe<order_by>;
  students_aggregate?: Maybe<student_aggregate_order_by>;
};

/** primary key columns input for table: blood_type */
export type blood_type_pk_columns_input = {
  name: Scalars['String'];
};

/** select columns of table "blood_type" */
export enum blood_type_select_column {
  /** column name */
  name = 'name',
}

/** input type for updating data in table "blood_type" */
export type blood_type_set_input = {
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "blood_type" */
export enum blood_type_update_column {
  /** column name */
  name = 'name',
}

/** columns and relationships of "course" */
export type course = {
  __typename?: 'course';
  /** An array relationship */
  batches: Array<batch>;
  /** An aggregate relationship */
  batches_aggregate: batch_aggregate;
  code: Scalars['String'];
  /** An array relationship */
  course_semesters: Array<course_semester>;
  /** An aggregate relationship */
  course_semesters_aggregate: course_semester_aggregate;
  duration: Scalars['Int'];
  id: Scalars['uuid'];
  /** An array relationship */
  inquiries: Array<inquiry>;
  /** An aggregate relationship */
  inquiries_aggregate: inquiry_aggregate;
  name: Scalars['String'];
  partTime: Scalars['Boolean'];
  /** An array relationship */
  student_courses: Array<student_course>;
  /** An aggregate relationship */
  student_courses_aggregate: student_course_aggregate;
};

/** columns and relationships of "course" */
export type coursebatchesArgs = {
  distinct_on?: Maybe<Array<batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_order_by>>;
  where?: Maybe<batch_bool_exp>;
};

/** columns and relationships of "course" */
export type coursebatches_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_order_by>>;
  where?: Maybe<batch_bool_exp>;
};

/** columns and relationships of "course" */
export type coursecourse_semestersArgs = {
  distinct_on?: Maybe<Array<course_semester_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_order_by>>;
  where?: Maybe<course_semester_bool_exp>;
};

/** columns and relationships of "course" */
export type coursecourse_semesters_aggregateArgs = {
  distinct_on?: Maybe<Array<course_semester_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_order_by>>;
  where?: Maybe<course_semester_bool_exp>;
};

/** columns and relationships of "course" */
export type courseinquiriesArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

/** columns and relationships of "course" */
export type courseinquiries_aggregateArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

/** columns and relationships of "course" */
export type coursestudent_coursesArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** columns and relationships of "course" */
export type coursestudent_courses_aggregateArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** aggregated selection of "course" */
export type course_aggregate = {
  __typename?: 'course_aggregate';
  aggregate?: Maybe<course_aggregate_fields>;
  nodes: Array<course>;
};

/** aggregate fields of "course" */
export type course_aggregate_fields = {
  __typename?: 'course_aggregate_fields';
  avg?: Maybe<course_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<course_max_fields>;
  min?: Maybe<course_min_fields>;
  stddev?: Maybe<course_stddev_fields>;
  stddev_pop?: Maybe<course_stddev_pop_fields>;
  stddev_samp?: Maybe<course_stddev_samp_fields>;
  sum?: Maybe<course_sum_fields>;
  var_pop?: Maybe<course_var_pop_fields>;
  var_samp?: Maybe<course_var_samp_fields>;
  variance?: Maybe<course_variance_fields>;
};

/** aggregate fields of "course" */
export type course_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<course_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type course_avg_fields = {
  __typename?: 'course_avg_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "course". All fields are combined with a logical 'AND'. */
export type course_bool_exp = {
  _and?: Maybe<Array<course_bool_exp>>;
  _not?: Maybe<course_bool_exp>;
  _or?: Maybe<Array<course_bool_exp>>;
  batches?: Maybe<batch_bool_exp>;
  code?: Maybe<String_comparison_exp>;
  course_semesters?: Maybe<course_semester_bool_exp>;
  duration?: Maybe<Int_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  inquiries?: Maybe<inquiry_bool_exp>;
  name?: Maybe<String_comparison_exp>;
  partTime?: Maybe<Boolean_comparison_exp>;
  student_courses?: Maybe<student_course_bool_exp>;
};

/** unique or primary key constraints on table "course" */
export enum course_constraint {
  /** unique or primary key constraint */
  IDX_5cf4963ae12285cda6432d5a3a = 'IDX_5cf4963ae12285cda6432d5a3a',
  /** unique or primary key constraint */
  PK_bf95180dd756fd204fb01ce4916 = 'PK_bf95180dd756fd204fb01ce4916',
}

/** columns and relationships of "course_coordinator" */
export type course_coordinator = {
  __typename?: 'course_coordinator';
  /** An object relationship */
  batch: batch;
  batchId: Scalars['uuid'];
  /** An object relationship */
  course_semester: course_semester;
  id: Scalars['uuid'];
  semesterId: Scalars['uuid'];
  /** An object relationship */
  user: user;
  userId: Scalars['uuid'];
};

/** aggregated selection of "course_coordinator" */
export type course_coordinator_aggregate = {
  __typename?: 'course_coordinator_aggregate';
  aggregate?: Maybe<course_coordinator_aggregate_fields>;
  nodes: Array<course_coordinator>;
};

/** aggregate fields of "course_coordinator" */
export type course_coordinator_aggregate_fields = {
  __typename?: 'course_coordinator_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<course_coordinator_max_fields>;
  min?: Maybe<course_coordinator_min_fields>;
};

/** aggregate fields of "course_coordinator" */
export type course_coordinator_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<course_coordinator_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_coordinator" */
export type course_coordinator_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<course_coordinator_max_order_by>;
  min?: Maybe<course_coordinator_min_order_by>;
};

/** input type for inserting array relation for remote table "course_coordinator" */
export type course_coordinator_arr_rel_insert_input = {
  data: Array<course_coordinator_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<course_coordinator_on_conflict>;
};

/** Boolean expression to filter rows from the table "course_coordinator". All fields are combined with a logical 'AND'. */
export type course_coordinator_bool_exp = {
  _and?: Maybe<Array<course_coordinator_bool_exp>>;
  _not?: Maybe<course_coordinator_bool_exp>;
  _or?: Maybe<Array<course_coordinator_bool_exp>>;
  batch?: Maybe<batch_bool_exp>;
  batchId?: Maybe<uuid_comparison_exp>;
  course_semester?: Maybe<course_semester_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  semesterId?: Maybe<uuid_comparison_exp>;
  user?: Maybe<user_bool_exp>;
  userId?: Maybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "course_coordinator" */
export enum course_coordinator_constraint {
  /** unique or primary key constraint */
  course_coordinator_pkey = 'course_coordinator_pkey',
}

/** input type for inserting data into table "course_coordinator" */
export type course_coordinator_insert_input = {
  batch?: Maybe<batch_obj_rel_insert_input>;
  batchId?: Maybe<Scalars['uuid']>;
  course_semester?: Maybe<course_semester_obj_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  semesterId?: Maybe<Scalars['uuid']>;
  user?: Maybe<user_obj_rel_insert_input>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type course_coordinator_max_fields = {
  __typename?: 'course_coordinator_max_fields';
  batchId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  semesterId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "course_coordinator" */
export type course_coordinator_max_order_by = {
  batchId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  semesterId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type course_coordinator_min_fields = {
  __typename?: 'course_coordinator_min_fields';
  batchId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  semesterId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "course_coordinator" */
export type course_coordinator_min_order_by = {
  batchId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  semesterId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** response of any mutation on the table "course_coordinator" */
export type course_coordinator_mutation_response = {
  __typename?: 'course_coordinator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<course_coordinator>;
};

/** on conflict condition type for table "course_coordinator" */
export type course_coordinator_on_conflict = {
  constraint: course_coordinator_constraint;
  update_columns?: Array<course_coordinator_update_column>;
  where?: Maybe<course_coordinator_bool_exp>;
};

/** Ordering options when selecting data from "course_coordinator". */
export type course_coordinator_order_by = {
  batch?: Maybe<batch_order_by>;
  batchId?: Maybe<order_by>;
  course_semester?: Maybe<course_semester_order_by>;
  id?: Maybe<order_by>;
  semesterId?: Maybe<order_by>;
  user?: Maybe<user_order_by>;
  userId?: Maybe<order_by>;
};

/** primary key columns input for table: course_coordinator */
export type course_coordinator_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_coordinator" */
export enum course_coordinator_select_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  id = 'id',
  /** column name */
  semesterId = 'semesterId',
  /** column name */
  userId = 'userId',
}

/** input type for updating data in table "course_coordinator" */
export type course_coordinator_set_input = {
  batchId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  semesterId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "course_coordinator" */
export enum course_coordinator_update_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  id = 'id',
  /** column name */
  semesterId = 'semesterId',
  /** column name */
  userId = 'userId',
}

/** input type for incrementing numeric columns in table "course" */
export type course_inc_input = {
  duration?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "course" */
export type course_insert_input = {
  batches?: Maybe<batch_arr_rel_insert_input>;
  code?: Maybe<Scalars['String']>;
  course_semesters?: Maybe<course_semester_arr_rel_insert_input>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  inquiries?: Maybe<inquiry_arr_rel_insert_input>;
  name?: Maybe<Scalars['String']>;
  partTime?: Maybe<Scalars['Boolean']>;
  student_courses?: Maybe<student_course_arr_rel_insert_input>;
};

/** columns and relationships of "course_level" */
export type course_level = {
  __typename?: 'course_level';
  /** An array relationship */
  course_semesters: Array<course_semester>;
  /** An aggregate relationship */
  course_semesters_aggregate: course_semester_aggregate;
  id: Scalars['uuid'];
  name: Scalars['String'];
};

/** columns and relationships of "course_level" */
export type course_levelcourse_semestersArgs = {
  distinct_on?: Maybe<Array<course_semester_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_order_by>>;
  where?: Maybe<course_semester_bool_exp>;
};

/** columns and relationships of "course_level" */
export type course_levelcourse_semesters_aggregateArgs = {
  distinct_on?: Maybe<Array<course_semester_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_order_by>>;
  where?: Maybe<course_semester_bool_exp>;
};

/** aggregated selection of "course_level" */
export type course_level_aggregate = {
  __typename?: 'course_level_aggregate';
  aggregate?: Maybe<course_level_aggregate_fields>;
  nodes: Array<course_level>;
};

/** aggregate fields of "course_level" */
export type course_level_aggregate_fields = {
  __typename?: 'course_level_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<course_level_max_fields>;
  min?: Maybe<course_level_min_fields>;
};

/** aggregate fields of "course_level" */
export type course_level_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<course_level_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_level". All fields are combined with a logical 'AND'. */
export type course_level_bool_exp = {
  _and?: Maybe<Array<course_level_bool_exp>>;
  _not?: Maybe<course_level_bool_exp>;
  _or?: Maybe<Array<course_level_bool_exp>>;
  course_semesters?: Maybe<course_semester_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "course_level" */
export enum course_level_constraint {
  /** unique or primary key constraint */
  IDX_fd2d84a0423b4094d6f23dd897 = 'IDX_fd2d84a0423b4094d6f23dd897',
  /** unique or primary key constraint */
  PK_fab4dc4ff554cd78d16012c6d41 = 'PK_fab4dc4ff554cd78d16012c6d41',
  /** unique or primary key constraint */
  course_level_name_key = 'course_level_name_key',
}

/** input type for inserting data into table "course_level" */
export type course_level_insert_input = {
  course_semesters?: Maybe<course_semester_arr_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type course_level_max_fields = {
  __typename?: 'course_level_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type course_level_min_fields = {
  __typename?: 'course_level_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_level" */
export type course_level_mutation_response = {
  __typename?: 'course_level_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<course_level>;
};

/** input type for inserting object relation for remote table "course_level" */
export type course_level_obj_rel_insert_input = {
  data: course_level_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<course_level_on_conflict>;
};

/** on conflict condition type for table "course_level" */
export type course_level_on_conflict = {
  constraint: course_level_constraint;
  update_columns?: Array<course_level_update_column>;
  where?: Maybe<course_level_bool_exp>;
};

/** Ordering options when selecting data from "course_level". */
export type course_level_order_by = {
  course_semesters_aggregate?: Maybe<course_semester_aggregate_order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
};

/** primary key columns input for table: course_level */
export type course_level_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_level" */
export enum course_level_select_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** input type for updating data in table "course_level" */
export type course_level_set_input = {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "course_level" */
export enum course_level_update_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** aggregate max on columns */
export type course_max_fields = {
  __typename?: 'course_max_fields';
  code?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type course_min_fields = {
  __typename?: 'course_min_fields';
  code?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course" */
export type course_mutation_response = {
  __typename?: 'course_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<course>;
};

/** input type for inserting object relation for remote table "course" */
export type course_obj_rel_insert_input = {
  data: course_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<course_on_conflict>;
};

/** on conflict condition type for table "course" */
export type course_on_conflict = {
  constraint: course_constraint;
  update_columns?: Array<course_update_column>;
  where?: Maybe<course_bool_exp>;
};

/** Ordering options when selecting data from "course". */
export type course_order_by = {
  batches_aggregate?: Maybe<batch_aggregate_order_by>;
  code?: Maybe<order_by>;
  course_semesters_aggregate?: Maybe<course_semester_aggregate_order_by>;
  duration?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquiries_aggregate?: Maybe<inquiry_aggregate_order_by>;
  name?: Maybe<order_by>;
  partTime?: Maybe<order_by>;
  student_courses_aggregate?: Maybe<student_course_aggregate_order_by>;
};

/** primary key columns input for table: course */
export type course_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "course" */
export enum course_select_column {
  /** column name */
  code = 'code',
  /** column name */
  duration = 'duration',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  partTime = 'partTime',
}

/** columns and relationships of "course_semester" */
export type course_semester = {
  __typename?: 'course_semester';
  /** An array relationship */
  batch_subject_configurations: Array<batch_subject_configuration>;
  /** An aggregate relationship */
  batch_subject_configurations_aggregate: batch_subject_configuration_aggregate;
  /** An object relationship */
  course?: Maybe<course>;
  courseId?: Maybe<Scalars['uuid']>;
  courseLevelId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  course_coordinators: Array<course_coordinator>;
  /** An aggregate relationship */
  course_coordinators_aggregate: course_coordinator_aggregate;
  /** An object relationship */
  course_level?: Maybe<course_level>;
  /** An array relationship */
  course_semester_subjects_subjects: Array<course_semester_subjects_subject>;
  /** An aggregate relationship */
  course_semester_subjects_subjects_aggregate: course_semester_subjects_subject_aggregate;
  id: Scalars['uuid'];
  semester?: Maybe<Scalars['course_semester_semester_enum']>;
  weeksPerSemester?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "course_semester" */
export type course_semesterbatch_subject_configurationsArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

/** columns and relationships of "course_semester" */
export type course_semesterbatch_subject_configurations_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

/** columns and relationships of "course_semester" */
export type course_semestercourse_coordinatorsArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

/** columns and relationships of "course_semester" */
export type course_semestercourse_coordinators_aggregateArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

/** columns and relationships of "course_semester" */
export type course_semestercourse_semester_subjects_subjectsArgs = {
  distinct_on?: Maybe<Array<course_semester_subjects_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_subjects_subject_order_by>>;
  where?: Maybe<course_semester_subjects_subject_bool_exp>;
};

/** columns and relationships of "course_semester" */
export type course_semestercourse_semester_subjects_subjects_aggregateArgs = {
  distinct_on?: Maybe<Array<course_semester_subjects_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_subjects_subject_order_by>>;
  where?: Maybe<course_semester_subjects_subject_bool_exp>;
};

/** aggregated selection of "course_semester" */
export type course_semester_aggregate = {
  __typename?: 'course_semester_aggregate';
  aggregate?: Maybe<course_semester_aggregate_fields>;
  nodes: Array<course_semester>;
};

/** aggregate fields of "course_semester" */
export type course_semester_aggregate_fields = {
  __typename?: 'course_semester_aggregate_fields';
  avg?: Maybe<course_semester_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<course_semester_max_fields>;
  min?: Maybe<course_semester_min_fields>;
  stddev?: Maybe<course_semester_stddev_fields>;
  stddev_pop?: Maybe<course_semester_stddev_pop_fields>;
  stddev_samp?: Maybe<course_semester_stddev_samp_fields>;
  sum?: Maybe<course_semester_sum_fields>;
  var_pop?: Maybe<course_semester_var_pop_fields>;
  var_samp?: Maybe<course_semester_var_samp_fields>;
  variance?: Maybe<course_semester_variance_fields>;
};

/** aggregate fields of "course_semester" */
export type course_semester_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<course_semester_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_semester" */
export type course_semester_aggregate_order_by = {
  avg?: Maybe<course_semester_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<course_semester_max_order_by>;
  min?: Maybe<course_semester_min_order_by>;
  stddev?: Maybe<course_semester_stddev_order_by>;
  stddev_pop?: Maybe<course_semester_stddev_pop_order_by>;
  stddev_samp?: Maybe<course_semester_stddev_samp_order_by>;
  sum?: Maybe<course_semester_sum_order_by>;
  var_pop?: Maybe<course_semester_var_pop_order_by>;
  var_samp?: Maybe<course_semester_var_samp_order_by>;
  variance?: Maybe<course_semester_variance_order_by>;
};

/** input type for inserting array relation for remote table "course_semester" */
export type course_semester_arr_rel_insert_input = {
  data: Array<course_semester_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<course_semester_on_conflict>;
};

/** aggregate avg on columns */
export type course_semester_avg_fields = {
  __typename?: 'course_semester_avg_fields';
  weeksPerSemester?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_semester" */
export type course_semester_avg_order_by = {
  weeksPerSemester?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "course_semester". All fields are combined with a logical 'AND'. */
export type course_semester_bool_exp = {
  _and?: Maybe<Array<course_semester_bool_exp>>;
  _not?: Maybe<course_semester_bool_exp>;
  _or?: Maybe<Array<course_semester_bool_exp>>;
  batch_subject_configurations?: Maybe<batch_subject_configuration_bool_exp>;
  course?: Maybe<course_bool_exp>;
  courseId?: Maybe<uuid_comparison_exp>;
  courseLevelId?: Maybe<uuid_comparison_exp>;
  course_coordinators?: Maybe<course_coordinator_bool_exp>;
  course_level?: Maybe<course_level_bool_exp>;
  course_semester_subjects_subjects?: Maybe<course_semester_subjects_subject_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  semester?: Maybe<course_semester_semester_enum_comparison_exp>;
  weeksPerSemester?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "course_semester" */
export enum course_semester_constraint {
  /** unique or primary key constraint */
  PK_3daacf1aa8e795638c83bd2ab27 = 'PK_3daacf1aa8e795638c83bd2ab27',
}

/** input type for incrementing numeric columns in table "course_semester" */
export type course_semester_inc_input = {
  weeksPerSemester?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_semester" */
export type course_semester_insert_input = {
  batch_subject_configurations?: Maybe<batch_subject_configuration_arr_rel_insert_input>;
  course?: Maybe<course_obj_rel_insert_input>;
  courseId?: Maybe<Scalars['uuid']>;
  courseLevelId?: Maybe<Scalars['uuid']>;
  course_coordinators?: Maybe<course_coordinator_arr_rel_insert_input>;
  course_level?: Maybe<course_level_obj_rel_insert_input>;
  course_semester_subjects_subjects?: Maybe<course_semester_subjects_subject_arr_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  semester?: Maybe<Scalars['course_semester_semester_enum']>;
  weeksPerSemester?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type course_semester_max_fields = {
  __typename?: 'course_semester_max_fields';
  courseId?: Maybe<Scalars['uuid']>;
  courseLevelId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  weeksPerSemester?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "course_semester" */
export type course_semester_max_order_by = {
  courseId?: Maybe<order_by>;
  courseLevelId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  weeksPerSemester?: Maybe<order_by>;
};

/** aggregate min on columns */
export type course_semester_min_fields = {
  __typename?: 'course_semester_min_fields';
  courseId?: Maybe<Scalars['uuid']>;
  courseLevelId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  weeksPerSemester?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "course_semester" */
export type course_semester_min_order_by = {
  courseId?: Maybe<order_by>;
  courseLevelId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  weeksPerSemester?: Maybe<order_by>;
};

/** response of any mutation on the table "course_semester" */
export type course_semester_mutation_response = {
  __typename?: 'course_semester_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<course_semester>;
};

/** input type for inserting object relation for remote table "course_semester" */
export type course_semester_obj_rel_insert_input = {
  data: course_semester_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<course_semester_on_conflict>;
};

/** on conflict condition type for table "course_semester" */
export type course_semester_on_conflict = {
  constraint: course_semester_constraint;
  update_columns?: Array<course_semester_update_column>;
  where?: Maybe<course_semester_bool_exp>;
};

/** Ordering options when selecting data from "course_semester". */
export type course_semester_order_by = {
  batch_subject_configurations_aggregate?: Maybe<batch_subject_configuration_aggregate_order_by>;
  course?: Maybe<course_order_by>;
  courseId?: Maybe<order_by>;
  courseLevelId?: Maybe<order_by>;
  course_coordinators_aggregate?: Maybe<course_coordinator_aggregate_order_by>;
  course_level?: Maybe<course_level_order_by>;
  course_semester_subjects_subjects_aggregate?: Maybe<course_semester_subjects_subject_aggregate_order_by>;
  id?: Maybe<order_by>;
  semester?: Maybe<order_by>;
  weeksPerSemester?: Maybe<order_by>;
};

/** primary key columns input for table: course_semester */
export type course_semester_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_semester" */
export enum course_semester_select_column {
  /** column name */
  courseId = 'courseId',
  /** column name */
  courseLevelId = 'courseLevelId',
  /** column name */
  id = 'id',
  /** column name */
  semester = 'semester',
  /** column name */
  weeksPerSemester = 'weeksPerSemester',
}

/** Boolean expression to compare columns of type "course_semester_semester_enum". All fields are combined with logical 'AND'. */
export type course_semester_semester_enum_comparison_exp = {
  _eq?: Maybe<Scalars['course_semester_semester_enum']>;
  _gt?: Maybe<Scalars['course_semester_semester_enum']>;
  _gte?: Maybe<Scalars['course_semester_semester_enum']>;
  _in?: Maybe<Array<Scalars['course_semester_semester_enum']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['course_semester_semester_enum']>;
  _lte?: Maybe<Scalars['course_semester_semester_enum']>;
  _neq?: Maybe<Scalars['course_semester_semester_enum']>;
  _nin?: Maybe<Array<Scalars['course_semester_semester_enum']>>;
};

/** input type for updating data in table "course_semester" */
export type course_semester_set_input = {
  courseId?: Maybe<Scalars['uuid']>;
  courseLevelId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  semester?: Maybe<Scalars['course_semester_semester_enum']>;
  weeksPerSemester?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type course_semester_stddev_fields = {
  __typename?: 'course_semester_stddev_fields';
  weeksPerSemester?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_semester" */
export type course_semester_stddev_order_by = {
  weeksPerSemester?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type course_semester_stddev_pop_fields = {
  __typename?: 'course_semester_stddev_pop_fields';
  weeksPerSemester?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_semester" */
export type course_semester_stddev_pop_order_by = {
  weeksPerSemester?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type course_semester_stddev_samp_fields = {
  __typename?: 'course_semester_stddev_samp_fields';
  weeksPerSemester?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_semester" */
export type course_semester_stddev_samp_order_by = {
  weeksPerSemester?: Maybe<order_by>;
};

/** columns and relationships of "course_semester_subjects_subject" */
export type course_semester_subjects_subject = {
  __typename?: 'course_semester_subjects_subject';
  courseSemesterId: Scalars['uuid'];
  /** An object relationship */
  course_semester: course_semester;
  /** An object relationship */
  subject: subject;
  subjectId: Scalars['uuid'];
};

/** aggregated selection of "course_semester_subjects_subject" */
export type course_semester_subjects_subject_aggregate = {
  __typename?: 'course_semester_subjects_subject_aggregate';
  aggregate?: Maybe<course_semester_subjects_subject_aggregate_fields>;
  nodes: Array<course_semester_subjects_subject>;
};

/** aggregate fields of "course_semester_subjects_subject" */
export type course_semester_subjects_subject_aggregate_fields = {
  __typename?: 'course_semester_subjects_subject_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<course_semester_subjects_subject_max_fields>;
  min?: Maybe<course_semester_subjects_subject_min_fields>;
};

/** aggregate fields of "course_semester_subjects_subject" */
export type course_semester_subjects_subject_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<course_semester_subjects_subject_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_semester_subjects_subject" */
export type course_semester_subjects_subject_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<course_semester_subjects_subject_max_order_by>;
  min?: Maybe<course_semester_subjects_subject_min_order_by>;
};

/** input type for inserting array relation for remote table "course_semester_subjects_subject" */
export type course_semester_subjects_subject_arr_rel_insert_input = {
  data: Array<course_semester_subjects_subject_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<course_semester_subjects_subject_on_conflict>;
};

/** Boolean expression to filter rows from the table "course_semester_subjects_subject". All fields are combined with a logical 'AND'. */
export type course_semester_subjects_subject_bool_exp = {
  _and?: Maybe<Array<course_semester_subjects_subject_bool_exp>>;
  _not?: Maybe<course_semester_subjects_subject_bool_exp>;
  _or?: Maybe<Array<course_semester_subjects_subject_bool_exp>>;
  courseSemesterId?: Maybe<uuid_comparison_exp>;
  course_semester?: Maybe<course_semester_bool_exp>;
  subject?: Maybe<subject_bool_exp>;
  subjectId?: Maybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "course_semester_subjects_subject" */
export enum course_semester_subjects_subject_constraint {
  /** unique or primary key constraint */
  PK_a7e20539631d42627fc118ff171 = 'PK_a7e20539631d42627fc118ff171',
}

/** input type for inserting data into table "course_semester_subjects_subject" */
export type course_semester_subjects_subject_insert_input = {
  courseSemesterId?: Maybe<Scalars['uuid']>;
  course_semester?: Maybe<course_semester_obj_rel_insert_input>;
  subject?: Maybe<subject_obj_rel_insert_input>;
  subjectId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type course_semester_subjects_subject_max_fields = {
  __typename?: 'course_semester_subjects_subject_max_fields';
  courseSemesterId?: Maybe<Scalars['uuid']>;
  subjectId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "course_semester_subjects_subject" */
export type course_semester_subjects_subject_max_order_by = {
  courseSemesterId?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type course_semester_subjects_subject_min_fields = {
  __typename?: 'course_semester_subjects_subject_min_fields';
  courseSemesterId?: Maybe<Scalars['uuid']>;
  subjectId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "course_semester_subjects_subject" */
export type course_semester_subjects_subject_min_order_by = {
  courseSemesterId?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
};

/** response of any mutation on the table "course_semester_subjects_subject" */
export type course_semester_subjects_subject_mutation_response = {
  __typename?: 'course_semester_subjects_subject_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<course_semester_subjects_subject>;
};

/** on conflict condition type for table "course_semester_subjects_subject" */
export type course_semester_subjects_subject_on_conflict = {
  constraint: course_semester_subjects_subject_constraint;
  update_columns?: Array<course_semester_subjects_subject_update_column>;
  where?: Maybe<course_semester_subjects_subject_bool_exp>;
};

/** Ordering options when selecting data from "course_semester_subjects_subject". */
export type course_semester_subjects_subject_order_by = {
  courseSemesterId?: Maybe<order_by>;
  course_semester?: Maybe<course_semester_order_by>;
  subject?: Maybe<subject_order_by>;
  subjectId?: Maybe<order_by>;
};

/** primary key columns input for table: course_semester_subjects_subject */
export type course_semester_subjects_subject_pk_columns_input = {
  courseSemesterId: Scalars['uuid'];
  subjectId: Scalars['uuid'];
};

/** select columns of table "course_semester_subjects_subject" */
export enum course_semester_subjects_subject_select_column {
  /** column name */
  courseSemesterId = 'courseSemesterId',
  /** column name */
  subjectId = 'subjectId',
}

/** input type for updating data in table "course_semester_subjects_subject" */
export type course_semester_subjects_subject_set_input = {
  courseSemesterId?: Maybe<Scalars['uuid']>;
  subjectId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "course_semester_subjects_subject" */
export enum course_semester_subjects_subject_update_column {
  /** column name */
  courseSemesterId = 'courseSemesterId',
  /** column name */
  subjectId = 'subjectId',
}

/** aggregate sum on columns */
export type course_semester_sum_fields = {
  __typename?: 'course_semester_sum_fields';
  weeksPerSemester?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_semester" */
export type course_semester_sum_order_by = {
  weeksPerSemester?: Maybe<order_by>;
};

/** update columns of table "course_semester" */
export enum course_semester_update_column {
  /** column name */
  courseId = 'courseId',
  /** column name */
  courseLevelId = 'courseLevelId',
  /** column name */
  id = 'id',
  /** column name */
  semester = 'semester',
  /** column name */
  weeksPerSemester = 'weeksPerSemester',
}

/** aggregate var_pop on columns */
export type course_semester_var_pop_fields = {
  __typename?: 'course_semester_var_pop_fields';
  weeksPerSemester?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_semester" */
export type course_semester_var_pop_order_by = {
  weeksPerSemester?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type course_semester_var_samp_fields = {
  __typename?: 'course_semester_var_samp_fields';
  weeksPerSemester?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_semester" */
export type course_semester_var_samp_order_by = {
  weeksPerSemester?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type course_semester_variance_fields = {
  __typename?: 'course_semester_variance_fields';
  weeksPerSemester?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_semester" */
export type course_semester_variance_order_by = {
  weeksPerSemester?: Maybe<order_by>;
};

/** input type for updating data in table "course" */
export type course_set_input = {
  code?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  partTime?: Maybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type course_stddev_fields = {
  __typename?: 'course_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type course_stddev_pop_fields = {
  __typename?: 'course_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type course_stddev_samp_fields = {
  __typename?: 'course_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type course_sum_fields = {
  __typename?: 'course_sum_fields';
  duration?: Maybe<Scalars['Int']>;
};

/** update columns of table "course" */
export enum course_update_column {
  /** column name */
  code = 'code',
  /** column name */
  duration = 'duration',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  partTime = 'partTime',
}

/** aggregate var_pop on columns */
export type course_var_pop_fields = {
  __typename?: 'course_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type course_var_samp_fields = {
  __typename?: 'course_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type course_variance_fields = {
  __typename?: 'course_variance_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "current_student" */
export type current_student = {
  __typename?: 'current_student';
  /** An array relationship */
  current_student_courses: Array<current_student_course>;
  /** An aggregate relationship */
  current_student_courses_aggregate: current_student_course_aggregate;
  email?: Maybe<Scalars['String']>;
  /** An array relationship */
  exit_interview_answer: Array<exit_interview_answer>;
  /** An aggregate relationship */
  exit_interview_answer_aggregate: exit_interview_answer_aggregate;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['student_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** An object relationship */
  student_familiarization_form?: Maybe<student_familiarization_form>;
};

/** columns and relationships of "current_student" */
export type current_studentcurrent_student_coursesArgs = {
  distinct_on?: Maybe<Array<current_student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_course_order_by>>;
  where?: Maybe<current_student_course_bool_exp>;
};

/** columns and relationships of "current_student" */
export type current_studentcurrent_student_courses_aggregateArgs = {
  distinct_on?: Maybe<Array<current_student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_course_order_by>>;
  where?: Maybe<current_student_course_bool_exp>;
};

/** columns and relationships of "current_student" */
export type current_studentexit_interview_answerArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

/** columns and relationships of "current_student" */
export type current_studentexit_interview_answer_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

/** aggregated selection of "current_student" */
export type current_student_aggregate = {
  __typename?: 'current_student_aggregate';
  aggregate?: Maybe<current_student_aggregate_fields>;
  nodes: Array<current_student>;
};

/** aggregate fields of "current_student" */
export type current_student_aggregate_fields = {
  __typename?: 'current_student_aggregate_fields';
  avg?: Maybe<current_student_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<current_student_max_fields>;
  min?: Maybe<current_student_min_fields>;
  stddev?: Maybe<current_student_stddev_fields>;
  stddev_pop?: Maybe<current_student_stddev_pop_fields>;
  stddev_samp?: Maybe<current_student_stddev_samp_fields>;
  sum?: Maybe<current_student_sum_fields>;
  var_pop?: Maybe<current_student_var_pop_fields>;
  var_samp?: Maybe<current_student_var_samp_fields>;
  variance?: Maybe<current_student_variance_fields>;
};

/** aggregate fields of "current_student" */
export type current_student_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<current_student_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type current_student_avg_fields = {
  __typename?: 'current_student_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "current_student". All fields are combined with a logical 'AND'. */
export type current_student_bool_exp = {
  _and?: Maybe<Array<current_student_bool_exp>>;
  _not?: Maybe<current_student_bool_exp>;
  _or?: Maybe<Array<current_student_bool_exp>>;
  current_student_courses?: Maybe<current_student_course_bool_exp>;
  email?: Maybe<String_comparison_exp>;
  exit_interview_answer?: Maybe<exit_interview_answer_bool_exp>;
  firebaseUID?: Maybe<String_comparison_exp>;
  firstName?: Maybe<String_comparison_exp>;
  gender?: Maybe<student_gender_enum_comparison_exp>;
  id?: Maybe<Int_comparison_exp>;
  initialTourFollowed?: Maybe<Boolean_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  middleName?: Maybe<String_comparison_exp>;
  preferredName?: Maybe<String_comparison_exp>;
  regNumber?: Maybe<String_comparison_exp>;
  status?: Maybe<String_comparison_exp>;
  student_familiarization_form?: Maybe<student_familiarization_form_bool_exp>;
};

/** columns and relationships of "current_student_course" */
export type current_student_course = {
  __typename?: 'current_student_course';
  active?: Maybe<Scalars['Boolean']>;
  courseId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  current_student?: Maybe<current_student>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "current_student_course" */
export type current_student_course_aggregate = {
  __typename?: 'current_student_course_aggregate';
  aggregate?: Maybe<current_student_course_aggregate_fields>;
  nodes: Array<current_student_course>;
};

/** aggregate fields of "current_student_course" */
export type current_student_course_aggregate_fields = {
  __typename?: 'current_student_course_aggregate_fields';
  avg?: Maybe<current_student_course_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<current_student_course_max_fields>;
  min?: Maybe<current_student_course_min_fields>;
  stddev?: Maybe<current_student_course_stddev_fields>;
  stddev_pop?: Maybe<current_student_course_stddev_pop_fields>;
  stddev_samp?: Maybe<current_student_course_stddev_samp_fields>;
  sum?: Maybe<current_student_course_sum_fields>;
  var_pop?: Maybe<current_student_course_var_pop_fields>;
  var_samp?: Maybe<current_student_course_var_samp_fields>;
  variance?: Maybe<current_student_course_variance_fields>;
};

/** aggregate fields of "current_student_course" */
export type current_student_course_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<current_student_course_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "current_student_course" */
export type current_student_course_aggregate_order_by = {
  avg?: Maybe<current_student_course_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<current_student_course_max_order_by>;
  min?: Maybe<current_student_course_min_order_by>;
  stddev?: Maybe<current_student_course_stddev_order_by>;
  stddev_pop?: Maybe<current_student_course_stddev_pop_order_by>;
  stddev_samp?: Maybe<current_student_course_stddev_samp_order_by>;
  sum?: Maybe<current_student_course_sum_order_by>;
  var_pop?: Maybe<current_student_course_var_pop_order_by>;
  var_samp?: Maybe<current_student_course_var_samp_order_by>;
  variance?: Maybe<current_student_course_variance_order_by>;
};

/** input type for inserting array relation for remote table "current_student_course" */
export type current_student_course_arr_rel_insert_input = {
  data: Array<current_student_course_insert_input>;
};

/** aggregate avg on columns */
export type current_student_course_avg_fields = {
  __typename?: 'current_student_course_avg_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "current_student_course" */
export type current_student_course_avg_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "current_student_course". All fields are combined with a logical 'AND'. */
export type current_student_course_bool_exp = {
  _and?: Maybe<Array<current_student_course_bool_exp>>;
  _not?: Maybe<current_student_course_bool_exp>;
  _or?: Maybe<Array<current_student_course_bool_exp>>;
  active?: Maybe<Boolean_comparison_exp>;
  courseId?: Maybe<uuid_comparison_exp>;
  current_student?: Maybe<current_student_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  intakeId?: Maybe<uuid_comparison_exp>;
  registeredYear?: Maybe<Int_comparison_exp>;
  studentId?: Maybe<Int_comparison_exp>;
};

/** input type for incrementing numeric columns in table "current_student_course" */
export type current_student_course_inc_input = {
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "current_student_course" */
export type current_student_course_insert_input = {
  active?: Maybe<Scalars['Boolean']>;
  courseId?: Maybe<Scalars['uuid']>;
  current_student?: Maybe<current_student_obj_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type current_student_course_max_fields = {
  __typename?: 'current_student_course_max_fields';
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "current_student_course" */
export type current_student_course_max_order_by = {
  courseId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  intakeId?: Maybe<order_by>;
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type current_student_course_min_fields = {
  __typename?: 'current_student_course_min_fields';
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "current_student_course" */
export type current_student_course_min_order_by = {
  courseId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  intakeId?: Maybe<order_by>;
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** response of any mutation on the table "current_student_course" */
export type current_student_course_mutation_response = {
  __typename?: 'current_student_course_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<current_student_course>;
};

/** Ordering options when selecting data from "current_student_course". */
export type current_student_course_order_by = {
  active?: Maybe<order_by>;
  courseId?: Maybe<order_by>;
  current_student?: Maybe<current_student_order_by>;
  id?: Maybe<order_by>;
  intakeId?: Maybe<order_by>;
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** select columns of table "current_student_course" */
export enum current_student_course_select_column {
  /** column name */
  active = 'active',
  /** column name */
  courseId = 'courseId',
  /** column name */
  id = 'id',
  /** column name */
  intakeId = 'intakeId',
  /** column name */
  registeredYear = 'registeredYear',
  /** column name */
  studentId = 'studentId',
}

/** input type for updating data in table "current_student_course" */
export type current_student_course_set_input = {
  active?: Maybe<Scalars['Boolean']>;
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type current_student_course_stddev_fields = {
  __typename?: 'current_student_course_stddev_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "current_student_course" */
export type current_student_course_stddev_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type current_student_course_stddev_pop_fields = {
  __typename?: 'current_student_course_stddev_pop_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "current_student_course" */
export type current_student_course_stddev_pop_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type current_student_course_stddev_samp_fields = {
  __typename?: 'current_student_course_stddev_samp_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "current_student_course" */
export type current_student_course_stddev_samp_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type current_student_course_sum_fields = {
  __typename?: 'current_student_course_sum_fields';
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "current_student_course" */
export type current_student_course_sum_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate var_pop on columns */
export type current_student_course_var_pop_fields = {
  __typename?: 'current_student_course_var_pop_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "current_student_course" */
export type current_student_course_var_pop_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type current_student_course_var_samp_fields = {
  __typename?: 'current_student_course_var_samp_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "current_student_course" */
export type current_student_course_var_samp_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type current_student_course_variance_fields = {
  __typename?: 'current_student_course_variance_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "current_student_course" */
export type current_student_course_variance_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** input type for incrementing numeric columns in table "current_student" */
export type current_student_inc_input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "current_student" */
export type current_student_insert_input = {
  current_student_courses?: Maybe<current_student_course_arr_rel_insert_input>;
  email?: Maybe<Scalars['String']>;
  exit_interview_answer?: Maybe<exit_interview_answer_arr_rel_insert_input>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['student_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student_familiarization_form?: Maybe<student_familiarization_form_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type current_student_max_fields = {
  __typename?: 'current_student_max_fields';
  email?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type current_student_min_fields = {
  __typename?: 'current_student_min_fields';
  email?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "current_student" */
export type current_student_mutation_response = {
  __typename?: 'current_student_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<current_student>;
};

/** input type for inserting object relation for remote table "current_student" */
export type current_student_obj_rel_insert_input = {
  data: current_student_insert_input;
};

/** Ordering options when selecting data from "current_student". */
export type current_student_order_by = {
  current_student_courses_aggregate?: Maybe<current_student_course_aggregate_order_by>;
  email?: Maybe<order_by>;
  exit_interview_answer_aggregate?: Maybe<exit_interview_answer_aggregate_order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  gender?: Maybe<order_by>;
  id?: Maybe<order_by>;
  initialTourFollowed?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
  status?: Maybe<order_by>;
  student_familiarization_form?: Maybe<student_familiarization_form_order_by>;
};

/** columns and relationships of "current_student_routes_route" */
export type current_student_routes_route = {
  __typename?: 'current_student_routes_route';
  /** An object relationship */
  current_user_route?: Maybe<current_user_route>;
  routeId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "current_student_routes_route" */
export type current_student_routes_route_aggregate = {
  __typename?: 'current_student_routes_route_aggregate';
  aggregate?: Maybe<current_student_routes_route_aggregate_fields>;
  nodes: Array<current_student_routes_route>;
};

/** aggregate fields of "current_student_routes_route" */
export type current_student_routes_route_aggregate_fields = {
  __typename?: 'current_student_routes_route_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<current_student_routes_route_max_fields>;
  min?: Maybe<current_student_routes_route_min_fields>;
};

/** aggregate fields of "current_student_routes_route" */
export type current_student_routes_route_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<current_student_routes_route_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "current_student_routes_route". All fields are combined with a logical 'AND'. */
export type current_student_routes_route_bool_exp = {
  _and?: Maybe<Array<current_student_routes_route_bool_exp>>;
  _not?: Maybe<current_student_routes_route_bool_exp>;
  _or?: Maybe<Array<current_student_routes_route_bool_exp>>;
  current_user_route?: Maybe<current_user_route_bool_exp>;
  routeId?: Maybe<uuid_comparison_exp>;
};

/** aggregate max on columns */
export type current_student_routes_route_max_fields = {
  __typename?: 'current_student_routes_route_max_fields';
  routeId?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type current_student_routes_route_min_fields = {
  __typename?: 'current_student_routes_route_min_fields';
  routeId?: Maybe<Scalars['uuid']>;
};

/** Ordering options when selecting data from "current_student_routes_route". */
export type current_student_routes_route_order_by = {
  current_user_route?: Maybe<current_user_route_order_by>;
  routeId?: Maybe<order_by>;
};

/** select columns of table "current_student_routes_route" */
export enum current_student_routes_route_select_column {
  /** column name */
  routeId = 'routeId',
}

/** select columns of table "current_student" */
export enum current_student_select_column {
  /** column name */
  email = 'email',
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  gender = 'gender',
  /** column name */
  id = 'id',
  /** column name */
  initialTourFollowed = 'initialTourFollowed',
  /** column name */
  lastName = 'lastName',
  /** column name */
  middleName = 'middleName',
  /** column name */
  preferredName = 'preferredName',
  /** column name */
  regNumber = 'regNumber',
  /** column name */
  status = 'status',
}

/** input type for updating data in table "current_student" */
export type current_student_set_input = {
  email?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['student_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type current_student_stddev_fields = {
  __typename?: 'current_student_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type current_student_stddev_pop_fields = {
  __typename?: 'current_student_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type current_student_stddev_samp_fields = {
  __typename?: 'current_student_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type current_student_sum_fields = {
  __typename?: 'current_student_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type current_student_var_pop_fields = {
  __typename?: 'current_student_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type current_student_var_samp_fields = {
  __typename?: 'current_student_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type current_student_variance_fields = {
  __typename?: 'current_student_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "current_user" */
export type current_user = {
  __typename?: 'current_user';
  active?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  course_coordinators: Array<course_coordinator>;
  /** An aggregate relationship */
  course_coordinators_aggregate: course_coordinator_aggregate;
  /** fetch data from the table: "current_user_routes_route" */
  current_user_routes_route: Array<current_user_routes_route>;
  /** An aggregate relationship */
  current_user_routes_route_aggregate: current_user_routes_route_aggregate;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  department?: Maybe<department>;
  departmentId?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  employeeID?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['user_gender_enum']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  married?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  /** An array relationship */
  user_user_roles_user_roles: Array<user_user_roles_user_role>;
  /** An aggregate relationship */
  user_user_roles_user_roles_aggregate: user_user_roles_user_role_aggregate;
};

/** columns and relationships of "current_user" */
export type current_usercourse_coordinatorsArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

/** columns and relationships of "current_user" */
export type current_usercourse_coordinators_aggregateArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

/** columns and relationships of "current_user" */
export type current_usercurrent_user_routes_routeArgs = {
  distinct_on?: Maybe<Array<current_user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_routes_route_order_by>>;
  where?: Maybe<current_user_routes_route_bool_exp>;
};

/** columns and relationships of "current_user" */
export type current_usercurrent_user_routes_route_aggregateArgs = {
  distinct_on?: Maybe<Array<current_user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_routes_route_order_by>>;
  where?: Maybe<current_user_routes_route_bool_exp>;
};

/** columns and relationships of "current_user" */
export type current_useruser_user_roles_user_rolesArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** columns and relationships of "current_user" */
export type current_useruser_user_roles_user_roles_aggregateArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** aggregated selection of "current_user" */
export type current_user_aggregate = {
  __typename?: 'current_user_aggregate';
  aggregate?: Maybe<current_user_aggregate_fields>;
  nodes: Array<current_user>;
};

/** aggregate fields of "current_user" */
export type current_user_aggregate_fields = {
  __typename?: 'current_user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<current_user_max_fields>;
  min?: Maybe<current_user_min_fields>;
};

/** aggregate fields of "current_user" */
export type current_user_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<current_user_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "current_user". All fields are combined with a logical 'AND'. */
export type current_user_bool_exp = {
  _and?: Maybe<Array<current_user_bool_exp>>;
  _not?: Maybe<current_user_bool_exp>;
  _or?: Maybe<Array<current_user_bool_exp>>;
  active?: Maybe<Boolean_comparison_exp>;
  course_coordinators?: Maybe<course_coordinator_bool_exp>;
  current_user_routes_route?: Maybe<current_user_routes_route_bool_exp>;
  dateOfBirth?: Maybe<timestamp_comparison_exp>;
  dateOfJoining?: Maybe<timestamp_comparison_exp>;
  department?: Maybe<department_bool_exp>;
  departmentId?: Maybe<uuid_comparison_exp>;
  email?: Maybe<String_comparison_exp>;
  employeeID?: Maybe<String_comparison_exp>;
  expirationDate?: Maybe<timestamp_comparison_exp>;
  extensionNo?: Maybe<String_comparison_exp>;
  firebaseUID?: Maybe<String_comparison_exp>;
  firstName?: Maybe<String_comparison_exp>;
  gender?: Maybe<user_gender_enum_comparison_exp>;
  homeCity?: Maybe<String_comparison_exp>;
  homeCountry?: Maybe<String_comparison_exp>;
  homeDistrict?: Maybe<String_comparison_exp>;
  homeProvince?: Maybe<String_comparison_exp>;
  homeStreetAddress1?: Maybe<String_comparison_exp>;
  homeStreetAddress2?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  initialTourFollowed?: Maybe<Boolean_comparison_exp>;
  landLineNo?: Maybe<String_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  married?: Maybe<Boolean_comparison_exp>;
  middleName?: Maybe<String_comparison_exp>;
  mobileNo?: Maybe<String_comparison_exp>;
  nicNo?: Maybe<String_comparison_exp>;
  passportNo?: Maybe<String_comparison_exp>;
  permanentCity?: Maybe<String_comparison_exp>;
  permanentCountry?: Maybe<String_comparison_exp>;
  permanentDistrict?: Maybe<String_comparison_exp>;
  permanentProvince?: Maybe<String_comparison_exp>;
  permanentStreetAddress1?: Maybe<String_comparison_exp>;
  permanentStreetAddress2?: Maybe<String_comparison_exp>;
  preferredName?: Maybe<String_comparison_exp>;
  profilePicture?: Maybe<String_comparison_exp>;
  user_user_roles_user_roles?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** input type for inserting data into table "current_user" */
export type current_user_insert_input = {
  active?: Maybe<Scalars['Boolean']>;
  course_coordinators?: Maybe<course_coordinator_arr_rel_insert_input>;
  current_user_routes_route?: Maybe<current_user_routes_route_arr_rel_insert_input>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  department?: Maybe<department_obj_rel_insert_input>;
  departmentId?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  employeeID?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['user_gender_enum']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  married?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  user_user_roles_user_roles?: Maybe<user_user_roles_user_role_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type current_user_max_fields = {
  __typename?: 'current_user_max_fields';
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  departmentId?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  employeeID?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type current_user_min_fields = {
  __typename?: 'current_user_min_fields';
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  departmentId?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  employeeID?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "current_user" */
export type current_user_mutation_response = {
  __typename?: 'current_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<current_user>;
};

/** input type for inserting object relation for remote table "current_user" */
export type current_user_obj_rel_insert_input = {
  data: current_user_insert_input;
};

/** Ordering options when selecting data from "current_user". */
export type current_user_order_by = {
  active?: Maybe<order_by>;
  course_coordinators_aggregate?: Maybe<course_coordinator_aggregate_order_by>;
  current_user_routes_route_aggregate?: Maybe<current_user_routes_route_aggregate_order_by>;
  dateOfBirth?: Maybe<order_by>;
  dateOfJoining?: Maybe<order_by>;
  department?: Maybe<department_order_by>;
  departmentId?: Maybe<order_by>;
  email?: Maybe<order_by>;
  employeeID?: Maybe<order_by>;
  expirationDate?: Maybe<order_by>;
  extensionNo?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  gender?: Maybe<order_by>;
  homeCity?: Maybe<order_by>;
  homeCountry?: Maybe<order_by>;
  homeDistrict?: Maybe<order_by>;
  homeProvince?: Maybe<order_by>;
  homeStreetAddress1?: Maybe<order_by>;
  homeStreetAddress2?: Maybe<order_by>;
  id?: Maybe<order_by>;
  initialTourFollowed?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  married?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  nicNo?: Maybe<order_by>;
  passportNo?: Maybe<order_by>;
  permanentCity?: Maybe<order_by>;
  permanentCountry?: Maybe<order_by>;
  permanentDistrict?: Maybe<order_by>;
  permanentProvince?: Maybe<order_by>;
  permanentStreetAddress1?: Maybe<order_by>;
  permanentStreetAddress2?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  profilePicture?: Maybe<order_by>;
  user_user_roles_user_roles_aggregate?: Maybe<user_user_roles_user_role_aggregate_order_by>;
};

/** columns and relationships of "current_user_route" */
export type current_user_route = {
  __typename?: 'current_user_route';
  componentName?: Maybe<Scalars['String']>;
  /** An object relationship */
  current_user_route_parent?: Maybe<current_user_route>;
  dummy?: Maybe<Scalars['Boolean']>;
  global?: Maybe<Scalars['Boolean']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  showInMenu?: Maybe<Scalars['Boolean']>;
  studentStatus?: Maybe<Scalars['String']>;
  /** An array relationship */
  user_role_routes_routes: Array<user_role_routes_route>;
  /** An aggregate relationship */
  user_role_routes_routes_aggregate: user_role_routes_route_aggregate;
};

/** columns and relationships of "current_user_route" */
export type current_user_routeuser_role_routes_routesArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

/** columns and relationships of "current_user_route" */
export type current_user_routeuser_role_routes_routes_aggregateArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

/** aggregated selection of "current_user_route" */
export type current_user_route_aggregate = {
  __typename?: 'current_user_route_aggregate';
  aggregate?: Maybe<current_user_route_aggregate_fields>;
  nodes: Array<current_user_route>;
};

/** aggregate fields of "current_user_route" */
export type current_user_route_aggregate_fields = {
  __typename?: 'current_user_route_aggregate_fields';
  avg?: Maybe<current_user_route_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<current_user_route_max_fields>;
  min?: Maybe<current_user_route_min_fields>;
  stddev?: Maybe<current_user_route_stddev_fields>;
  stddev_pop?: Maybe<current_user_route_stddev_pop_fields>;
  stddev_samp?: Maybe<current_user_route_stddev_samp_fields>;
  sum?: Maybe<current_user_route_sum_fields>;
  var_pop?: Maybe<current_user_route_var_pop_fields>;
  var_samp?: Maybe<current_user_route_var_samp_fields>;
  variance?: Maybe<current_user_route_variance_fields>;
};

/** aggregate fields of "current_user_route" */
export type current_user_route_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<current_user_route_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type current_user_route_avg_fields = {
  __typename?: 'current_user_route_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "current_user_route". All fields are combined with a logical 'AND'. */
export type current_user_route_bool_exp = {
  _and?: Maybe<Array<current_user_route_bool_exp>>;
  _not?: Maybe<current_user_route_bool_exp>;
  _or?: Maybe<Array<current_user_route_bool_exp>>;
  componentName?: Maybe<String_comparison_exp>;
  current_user_route_parent?: Maybe<current_user_route_bool_exp>;
  dummy?: Maybe<Boolean_comparison_exp>;
  global?: Maybe<Boolean_comparison_exp>;
  iconName?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  order?: Maybe<Int_comparison_exp>;
  parentId?: Maybe<uuid_comparison_exp>;
  path?: Maybe<String_comparison_exp>;
  showInMenu?: Maybe<Boolean_comparison_exp>;
  studentStatus?: Maybe<String_comparison_exp>;
  user_role_routes_routes?: Maybe<user_role_routes_route_bool_exp>;
};

/** input type for incrementing numeric columns in table "current_user_route" */
export type current_user_route_inc_input = {
  order?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "current_user_route" */
export type current_user_route_insert_input = {
  componentName?: Maybe<Scalars['String']>;
  current_user_route_parent?: Maybe<current_user_route_obj_rel_insert_input>;
  dummy?: Maybe<Scalars['Boolean']>;
  global?: Maybe<Scalars['Boolean']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  showInMenu?: Maybe<Scalars['Boolean']>;
  studentStatus?: Maybe<Scalars['String']>;
  user_role_routes_routes?: Maybe<user_role_routes_route_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type current_user_route_max_fields = {
  __typename?: 'current_user_route_max_fields';
  componentName?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  studentStatus?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type current_user_route_min_fields = {
  __typename?: 'current_user_route_min_fields';
  componentName?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  studentStatus?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "current_user_route" */
export type current_user_route_mutation_response = {
  __typename?: 'current_user_route_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<current_user_route>;
};

/** input type for inserting object relation for remote table "current_user_route" */
export type current_user_route_obj_rel_insert_input = {
  data: current_user_route_insert_input;
};

/** Ordering options when selecting data from "current_user_route". */
export type current_user_route_order_by = {
  componentName?: Maybe<order_by>;
  current_user_route_parent?: Maybe<current_user_route_order_by>;
  dummy?: Maybe<order_by>;
  global?: Maybe<order_by>;
  iconName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  order?: Maybe<order_by>;
  parentId?: Maybe<order_by>;
  path?: Maybe<order_by>;
  showInMenu?: Maybe<order_by>;
  studentStatus?: Maybe<order_by>;
  user_role_routes_routes_aggregate?: Maybe<user_role_routes_route_aggregate_order_by>;
};

/** select columns of table "current_user_route" */
export enum current_user_route_select_column {
  /** column name */
  componentName = 'componentName',
  /** column name */
  dummy = 'dummy',
  /** column name */
  global = 'global',
  /** column name */
  iconName = 'iconName',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  order = 'order',
  /** column name */
  parentId = 'parentId',
  /** column name */
  path = 'path',
  /** column name */
  showInMenu = 'showInMenu',
  /** column name */
  studentStatus = 'studentStatus',
}

/** input type for updating data in table "current_user_route" */
export type current_user_route_set_input = {
  componentName?: Maybe<Scalars['String']>;
  dummy?: Maybe<Scalars['Boolean']>;
  global?: Maybe<Scalars['Boolean']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  showInMenu?: Maybe<Scalars['Boolean']>;
  studentStatus?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type current_user_route_stddev_fields = {
  __typename?: 'current_user_route_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type current_user_route_stddev_pop_fields = {
  __typename?: 'current_user_route_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type current_user_route_stddev_samp_fields = {
  __typename?: 'current_user_route_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type current_user_route_sum_fields = {
  __typename?: 'current_user_route_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type current_user_route_var_pop_fields = {
  __typename?: 'current_user_route_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type current_user_route_var_samp_fields = {
  __typename?: 'current_user_route_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type current_user_route_variance_fields = {
  __typename?: 'current_user_route_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "current_user_routes_route" */
export type current_user_routes_route = {
  __typename?: 'current_user_routes_route';
  /** An object relationship */
  current_user?: Maybe<current_user>;
  /** An object relationship */
  current_user_route?: Maybe<current_user_route>;
  firebaseUID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  routeId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "current_user_routes_route" */
export type current_user_routes_route_aggregate = {
  __typename?: 'current_user_routes_route_aggregate';
  aggregate?: Maybe<current_user_routes_route_aggregate_fields>;
  nodes: Array<current_user_routes_route>;
};

/** aggregate fields of "current_user_routes_route" */
export type current_user_routes_route_aggregate_fields = {
  __typename?: 'current_user_routes_route_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<current_user_routes_route_max_fields>;
  min?: Maybe<current_user_routes_route_min_fields>;
};

/** aggregate fields of "current_user_routes_route" */
export type current_user_routes_route_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<current_user_routes_route_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "current_user_routes_route" */
export type current_user_routes_route_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<current_user_routes_route_max_order_by>;
  min?: Maybe<current_user_routes_route_min_order_by>;
};

/** input type for inserting array relation for remote table "current_user_routes_route" */
export type current_user_routes_route_arr_rel_insert_input = {
  data: Array<current_user_routes_route_insert_input>;
};

/** Boolean expression to filter rows from the table "current_user_routes_route". All fields are combined with a logical 'AND'. */
export type current_user_routes_route_bool_exp = {
  _and?: Maybe<Array<current_user_routes_route_bool_exp>>;
  _not?: Maybe<current_user_routes_route_bool_exp>;
  _or?: Maybe<Array<current_user_routes_route_bool_exp>>;
  current_user?: Maybe<current_user_bool_exp>;
  current_user_route?: Maybe<current_user_route_bool_exp>;
  firebaseUID?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  routeId?: Maybe<uuid_comparison_exp>;
};

/** input type for inserting data into table "current_user_routes_route" */
export type current_user_routes_route_insert_input = {
  current_user?: Maybe<current_user_obj_rel_insert_input>;
  current_user_route?: Maybe<current_user_route_obj_rel_insert_input>;
  firebaseUID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  routeId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type current_user_routes_route_max_fields = {
  __typename?: 'current_user_routes_route_max_fields';
  firebaseUID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  routeId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "current_user_routes_route" */
export type current_user_routes_route_max_order_by = {
  firebaseUID?: Maybe<order_by>;
  id?: Maybe<order_by>;
  routeId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type current_user_routes_route_min_fields = {
  __typename?: 'current_user_routes_route_min_fields';
  firebaseUID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  routeId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "current_user_routes_route" */
export type current_user_routes_route_min_order_by = {
  firebaseUID?: Maybe<order_by>;
  id?: Maybe<order_by>;
  routeId?: Maybe<order_by>;
};

/** Ordering options when selecting data from "current_user_routes_route". */
export type current_user_routes_route_order_by = {
  current_user?: Maybe<current_user_order_by>;
  current_user_route?: Maybe<current_user_route_order_by>;
  firebaseUID?: Maybe<order_by>;
  id?: Maybe<order_by>;
  routeId?: Maybe<order_by>;
};

/** select columns of table "current_user_routes_route" */
export enum current_user_routes_route_select_column {
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  id = 'id',
  /** column name */
  routeId = 'routeId',
}

/** select columns of table "current_user" */
export enum current_user_select_column {
  /** column name */
  active = 'active',
  /** column name */
  dateOfBirth = 'dateOfBirth',
  /** column name */
  dateOfJoining = 'dateOfJoining',
  /** column name */
  departmentId = 'departmentId',
  /** column name */
  email = 'email',
  /** column name */
  employeeID = 'employeeID',
  /** column name */
  expirationDate = 'expirationDate',
  /** column name */
  extensionNo = 'extensionNo',
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  gender = 'gender',
  /** column name */
  homeCity = 'homeCity',
  /** column name */
  homeCountry = 'homeCountry',
  /** column name */
  homeDistrict = 'homeDistrict',
  /** column name */
  homeProvince = 'homeProvince',
  /** column name */
  homeStreetAddress1 = 'homeStreetAddress1',
  /** column name */
  homeStreetAddress2 = 'homeStreetAddress2',
  /** column name */
  id = 'id',
  /** column name */
  initialTourFollowed = 'initialTourFollowed',
  /** column name */
  landLineNo = 'landLineNo',
  /** column name */
  lastName = 'lastName',
  /** column name */
  married = 'married',
  /** column name */
  middleName = 'middleName',
  /** column name */
  mobileNo = 'mobileNo',
  /** column name */
  nicNo = 'nicNo',
  /** column name */
  passportNo = 'passportNo',
  /** column name */
  permanentCity = 'permanentCity',
  /** column name */
  permanentCountry = 'permanentCountry',
  /** column name */
  permanentDistrict = 'permanentDistrict',
  /** column name */
  permanentProvince = 'permanentProvince',
  /** column name */
  permanentStreetAddress1 = 'permanentStreetAddress1',
  /** column name */
  permanentStreetAddress2 = 'permanentStreetAddress2',
  /** column name */
  preferredName = 'preferredName',
  /** column name */
  profilePicture = 'profilePicture',
}

/** input type for updating data in table "current_user" */
export type current_user_set_input = {
  active?: Maybe<Scalars['Boolean']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  departmentId?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  employeeID?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['user_gender_enum']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  married?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type date_comparison_exp = {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
};

/** columns and relationships of "department" */
export type department = {
  __typename?: 'department';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  user_roles: Array<user_role>;
  /** An aggregate relationship */
  user_roles_aggregate: user_role_aggregate;
  /** An array relationship */
  users: Array<user>;
  /** An aggregate relationship */
  users_aggregate: user_aggregate;
  /** An array relationship */
  users_public: Array<user_public>;
  /** An aggregate relationship */
  users_public_aggregate: user_public_aggregate;
};

/** columns and relationships of "department" */
export type departmentuser_rolesArgs = {
  distinct_on?: Maybe<Array<user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_order_by>>;
  where?: Maybe<user_role_bool_exp>;
};

/** columns and relationships of "department" */
export type departmentuser_roles_aggregateArgs = {
  distinct_on?: Maybe<Array<user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_order_by>>;
  where?: Maybe<user_role_bool_exp>;
};

/** columns and relationships of "department" */
export type departmentusersArgs = {
  distinct_on?: Maybe<Array<user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_order_by>>;
  where?: Maybe<user_bool_exp>;
};

/** columns and relationships of "department" */
export type departmentusers_aggregateArgs = {
  distinct_on?: Maybe<Array<user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_order_by>>;
  where?: Maybe<user_bool_exp>;
};

/** columns and relationships of "department" */
export type departmentusers_publicArgs = {
  distinct_on?: Maybe<Array<user_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_public_order_by>>;
  where?: Maybe<user_public_bool_exp>;
};

/** columns and relationships of "department" */
export type departmentusers_public_aggregateArgs = {
  distinct_on?: Maybe<Array<user_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_public_order_by>>;
  where?: Maybe<user_public_bool_exp>;
};

/** aggregated selection of "department" */
export type department_aggregate = {
  __typename?: 'department_aggregate';
  aggregate?: Maybe<department_aggregate_fields>;
  nodes: Array<department>;
};

/** aggregate fields of "department" */
export type department_aggregate_fields = {
  __typename?: 'department_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<department_max_fields>;
  min?: Maybe<department_min_fields>;
};

/** aggregate fields of "department" */
export type department_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<department_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "department". All fields are combined with a logical 'AND'. */
export type department_bool_exp = {
  _and?: Maybe<Array<department_bool_exp>>;
  _not?: Maybe<department_bool_exp>;
  _or?: Maybe<Array<department_bool_exp>>;
  id?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  user_roles?: Maybe<user_role_bool_exp>;
  users?: Maybe<user_bool_exp>;
  users_public?: Maybe<user_public_bool_exp>;
};

/** unique or primary key constraints on table "department" */
export enum department_constraint {
  /** unique or primary key constraint */
  PK_9a2213262c1593bffb581e382f5 = 'PK_9a2213262c1593bffb581e382f5',
  /** unique or primary key constraint */
  department_name_key = 'department_name_key',
}

/** input type for inserting data into table "department" */
export type department_insert_input = {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  user_roles?: Maybe<user_role_arr_rel_insert_input>;
  users?: Maybe<user_arr_rel_insert_input>;
  users_public?: Maybe<user_public_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type department_max_fields = {
  __typename?: 'department_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type department_min_fields = {
  __typename?: 'department_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "department" */
export type department_mutation_response = {
  __typename?: 'department_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<department>;
};

/** input type for inserting object relation for remote table "department" */
export type department_obj_rel_insert_input = {
  data: department_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<department_on_conflict>;
};

/** on conflict condition type for table "department" */
export type department_on_conflict = {
  constraint: department_constraint;
  update_columns?: Array<department_update_column>;
  where?: Maybe<department_bool_exp>;
};

/** Ordering options when selecting data from "department". */
export type department_order_by = {
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  user_roles_aggregate?: Maybe<user_role_aggregate_order_by>;
  users_aggregate?: Maybe<user_aggregate_order_by>;
  users_public_aggregate?: Maybe<user_public_aggregate_order_by>;
};

/** primary key columns input for table: department */
export type department_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "department" */
export enum department_select_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** input type for updating data in table "department" */
export type department_set_input = {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "department" */
export enum department_update_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** columns and relationships of "education_qualification" */
export type education_qualification = {
  __typename?: 'education_qualification';
  gradings?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  inquiry?: Maybe<inquiry>;
  inquiryId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  schoolOrInstitute?: Maybe<Scalars['String']>;
  /** An object relationship */
  student?: Maybe<student>;
  studentId?: Maybe<Scalars['Int']>;
  yearOfCompletion?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "education_qualification" */
export type education_qualification_aggregate = {
  __typename?: 'education_qualification_aggregate';
  aggregate?: Maybe<education_qualification_aggregate_fields>;
  nodes: Array<education_qualification>;
};

/** aggregate fields of "education_qualification" */
export type education_qualification_aggregate_fields = {
  __typename?: 'education_qualification_aggregate_fields';
  avg?: Maybe<education_qualification_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<education_qualification_max_fields>;
  min?: Maybe<education_qualification_min_fields>;
  stddev?: Maybe<education_qualification_stddev_fields>;
  stddev_pop?: Maybe<education_qualification_stddev_pop_fields>;
  stddev_samp?: Maybe<education_qualification_stddev_samp_fields>;
  sum?: Maybe<education_qualification_sum_fields>;
  var_pop?: Maybe<education_qualification_var_pop_fields>;
  var_samp?: Maybe<education_qualification_var_samp_fields>;
  variance?: Maybe<education_qualification_variance_fields>;
};

/** aggregate fields of "education_qualification" */
export type education_qualification_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<education_qualification_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "education_qualification" */
export type education_qualification_aggregate_order_by = {
  avg?: Maybe<education_qualification_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<education_qualification_max_order_by>;
  min?: Maybe<education_qualification_min_order_by>;
  stddev?: Maybe<education_qualification_stddev_order_by>;
  stddev_pop?: Maybe<education_qualification_stddev_pop_order_by>;
  stddev_samp?: Maybe<education_qualification_stddev_samp_order_by>;
  sum?: Maybe<education_qualification_sum_order_by>;
  var_pop?: Maybe<education_qualification_var_pop_order_by>;
  var_samp?: Maybe<education_qualification_var_samp_order_by>;
  variance?: Maybe<education_qualification_variance_order_by>;
};

/** input type for inserting array relation for remote table "education_qualification" */
export type education_qualification_arr_rel_insert_input = {
  data: Array<education_qualification_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<education_qualification_on_conflict>;
};

/** aggregate avg on columns */
export type education_qualification_avg_fields = {
  __typename?: 'education_qualification_avg_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  yearOfCompletion?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "education_qualification" */
export type education_qualification_avg_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "education_qualification". All fields are combined with a logical 'AND'. */
export type education_qualification_bool_exp = {
  _and?: Maybe<Array<education_qualification_bool_exp>>;
  _not?: Maybe<education_qualification_bool_exp>;
  _or?: Maybe<Array<education_qualification_bool_exp>>;
  gradings?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  inquiry?: Maybe<inquiry_bool_exp>;
  inquiryId?: Maybe<Int_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  schoolOrInstitute?: Maybe<String_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  yearOfCompletion?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "education_qualification" */
export enum education_qualification_constraint {
  /** unique or primary key constraint */
  PK_e13e52d5aa14e27d7eb34edf4c2 = 'PK_e13e52d5aa14e27d7eb34edf4c2',
}

/** input type for incrementing numeric columns in table "education_qualification" */
export type education_qualification_inc_input = {
  inquiryId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  yearOfCompletion?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "education_qualification" */
export type education_qualification_insert_input = {
  gradings?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  inquiry?: Maybe<inquiry_obj_rel_insert_input>;
  inquiryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  schoolOrInstitute?: Maybe<Scalars['String']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  yearOfCompletion?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type education_qualification_max_fields = {
  __typename?: 'education_qualification_max_fields';
  gradings?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  inquiryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  schoolOrInstitute?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  yearOfCompletion?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "education_qualification" */
export type education_qualification_max_order_by = {
  gradings?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquiryId?: Maybe<order_by>;
  name?: Maybe<order_by>;
  schoolOrInstitute?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** aggregate min on columns */
export type education_qualification_min_fields = {
  __typename?: 'education_qualification_min_fields';
  gradings?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  inquiryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  schoolOrInstitute?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  yearOfCompletion?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "education_qualification" */
export type education_qualification_min_order_by = {
  gradings?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquiryId?: Maybe<order_by>;
  name?: Maybe<order_by>;
  schoolOrInstitute?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** response of any mutation on the table "education_qualification" */
export type education_qualification_mutation_response = {
  __typename?: 'education_qualification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<education_qualification>;
};

/** on conflict condition type for table "education_qualification" */
export type education_qualification_on_conflict = {
  constraint: education_qualification_constraint;
  update_columns?: Array<education_qualification_update_column>;
  where?: Maybe<education_qualification_bool_exp>;
};

/** Ordering options when selecting data from "education_qualification". */
export type education_qualification_order_by = {
  gradings?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquiry?: Maybe<inquiry_order_by>;
  inquiryId?: Maybe<order_by>;
  name?: Maybe<order_by>;
  schoolOrInstitute?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** primary key columns input for table: education_qualification */
export type education_qualification_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "education_qualification" */
export enum education_qualification_select_column {
  /** column name */
  gradings = 'gradings',
  /** column name */
  id = 'id',
  /** column name */
  inquiryId = 'inquiryId',
  /** column name */
  name = 'name',
  /** column name */
  schoolOrInstitute = 'schoolOrInstitute',
  /** column name */
  studentId = 'studentId',
  /** column name */
  yearOfCompletion = 'yearOfCompletion',
}

/** input type for updating data in table "education_qualification" */
export type education_qualification_set_input = {
  gradings?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  inquiryId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  schoolOrInstitute?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  yearOfCompletion?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type education_qualification_stddev_fields = {
  __typename?: 'education_qualification_stddev_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  yearOfCompletion?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "education_qualification" */
export type education_qualification_stddev_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type education_qualification_stddev_pop_fields = {
  __typename?: 'education_qualification_stddev_pop_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  yearOfCompletion?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "education_qualification" */
export type education_qualification_stddev_pop_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type education_qualification_stddev_samp_fields = {
  __typename?: 'education_qualification_stddev_samp_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  yearOfCompletion?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "education_qualification" */
export type education_qualification_stddev_samp_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type education_qualification_sum_fields = {
  __typename?: 'education_qualification_sum_fields';
  inquiryId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  yearOfCompletion?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "education_qualification" */
export type education_qualification_sum_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** update columns of table "education_qualification" */
export enum education_qualification_update_column {
  /** column name */
  gradings = 'gradings',
  /** column name */
  id = 'id',
  /** column name */
  inquiryId = 'inquiryId',
  /** column name */
  name = 'name',
  /** column name */
  schoolOrInstitute = 'schoolOrInstitute',
  /** column name */
  studentId = 'studentId',
  /** column name */
  yearOfCompletion = 'yearOfCompletion',
}

/** aggregate var_pop on columns */
export type education_qualification_var_pop_fields = {
  __typename?: 'education_qualification_var_pop_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  yearOfCompletion?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "education_qualification" */
export type education_qualification_var_pop_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type education_qualification_var_samp_fields = {
  __typename?: 'education_qualification_var_samp_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  yearOfCompletion?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "education_qualification" */
export type education_qualification_var_samp_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type education_qualification_variance_fields = {
  __typename?: 'education_qualification_variance_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  yearOfCompletion?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "education_qualification" */
export type education_qualification_variance_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  yearOfCompletion?: Maybe<order_by>;
};

/** columns and relationships of "employment_experience" */
export type employment_experience = {
  __typename?: 'employment_experience';
  company: Scalars['String'];
  duties?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  /** An object relationship */
  inquiry?: Maybe<inquiry>;
  inquiryId?: Maybe<Scalars['Int']>;
  position: Scalars['String'];
  references?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  student?: Maybe<student>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "employment_experience" */
export type employment_experience_aggregate = {
  __typename?: 'employment_experience_aggregate';
  aggregate?: Maybe<employment_experience_aggregate_fields>;
  nodes: Array<employment_experience>;
};

/** aggregate fields of "employment_experience" */
export type employment_experience_aggregate_fields = {
  __typename?: 'employment_experience_aggregate_fields';
  avg?: Maybe<employment_experience_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<employment_experience_max_fields>;
  min?: Maybe<employment_experience_min_fields>;
  stddev?: Maybe<employment_experience_stddev_fields>;
  stddev_pop?: Maybe<employment_experience_stddev_pop_fields>;
  stddev_samp?: Maybe<employment_experience_stddev_samp_fields>;
  sum?: Maybe<employment_experience_sum_fields>;
  var_pop?: Maybe<employment_experience_var_pop_fields>;
  var_samp?: Maybe<employment_experience_var_samp_fields>;
  variance?: Maybe<employment_experience_variance_fields>;
};

/** aggregate fields of "employment_experience" */
export type employment_experience_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<employment_experience_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "employment_experience" */
export type employment_experience_aggregate_order_by = {
  avg?: Maybe<employment_experience_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<employment_experience_max_order_by>;
  min?: Maybe<employment_experience_min_order_by>;
  stddev?: Maybe<employment_experience_stddev_order_by>;
  stddev_pop?: Maybe<employment_experience_stddev_pop_order_by>;
  stddev_samp?: Maybe<employment_experience_stddev_samp_order_by>;
  sum?: Maybe<employment_experience_sum_order_by>;
  var_pop?: Maybe<employment_experience_var_pop_order_by>;
  var_samp?: Maybe<employment_experience_var_samp_order_by>;
  variance?: Maybe<employment_experience_variance_order_by>;
};

/** input type for inserting array relation for remote table "employment_experience" */
export type employment_experience_arr_rel_insert_input = {
  data: Array<employment_experience_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<employment_experience_on_conflict>;
};

/** aggregate avg on columns */
export type employment_experience_avg_fields = {
  __typename?: 'employment_experience_avg_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "employment_experience" */
export type employment_experience_avg_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "employment_experience". All fields are combined with a logical 'AND'. */
export type employment_experience_bool_exp = {
  _and?: Maybe<Array<employment_experience_bool_exp>>;
  _not?: Maybe<employment_experience_bool_exp>;
  _or?: Maybe<Array<employment_experience_bool_exp>>;
  company?: Maybe<String_comparison_exp>;
  duties?: Maybe<String_comparison_exp>;
  endDate?: Maybe<timestamp_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  inquiry?: Maybe<inquiry_bool_exp>;
  inquiryId?: Maybe<Int_comparison_exp>;
  position?: Maybe<String_comparison_exp>;
  references?: Maybe<String_comparison_exp>;
  startDate?: Maybe<timestamp_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "employment_experience" */
export enum employment_experience_constraint {
  /** unique or primary key constraint */
  PK_8200484985b3289a675b72443cf = 'PK_8200484985b3289a675b72443cf',
}

/** input type for incrementing numeric columns in table "employment_experience" */
export type employment_experience_inc_input = {
  inquiryId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "employment_experience" */
export type employment_experience_insert_input = {
  company?: Maybe<Scalars['String']>;
  duties?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  inquiry?: Maybe<inquiry_obj_rel_insert_input>;
  inquiryId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  references?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamp']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type employment_experience_max_fields = {
  __typename?: 'employment_experience_max_fields';
  company?: Maybe<Scalars['String']>;
  duties?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  inquiryId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  references?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamp']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "employment_experience" */
export type employment_experience_max_order_by = {
  company?: Maybe<order_by>;
  duties?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquiryId?: Maybe<order_by>;
  position?: Maybe<order_by>;
  references?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type employment_experience_min_fields = {
  __typename?: 'employment_experience_min_fields';
  company?: Maybe<Scalars['String']>;
  duties?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  inquiryId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  references?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamp']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "employment_experience" */
export type employment_experience_min_order_by = {
  company?: Maybe<order_by>;
  duties?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquiryId?: Maybe<order_by>;
  position?: Maybe<order_by>;
  references?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** response of any mutation on the table "employment_experience" */
export type employment_experience_mutation_response = {
  __typename?: 'employment_experience_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<employment_experience>;
};

/** on conflict condition type for table "employment_experience" */
export type employment_experience_on_conflict = {
  constraint: employment_experience_constraint;
  update_columns?: Array<employment_experience_update_column>;
  where?: Maybe<employment_experience_bool_exp>;
};

/** Ordering options when selecting data from "employment_experience". */
export type employment_experience_order_by = {
  company?: Maybe<order_by>;
  duties?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquiry?: Maybe<inquiry_order_by>;
  inquiryId?: Maybe<order_by>;
  position?: Maybe<order_by>;
  references?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
};

/** primary key columns input for table: employment_experience */
export type employment_experience_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "employment_experience" */
export enum employment_experience_select_column {
  /** column name */
  company = 'company',
  /** column name */
  duties = 'duties',
  /** column name */
  endDate = 'endDate',
  /** column name */
  id = 'id',
  /** column name */
  inquiryId = 'inquiryId',
  /** column name */
  position = 'position',
  /** column name */
  references = 'references',
  /** column name */
  startDate = 'startDate',
  /** column name */
  studentId = 'studentId',
}

/** input type for updating data in table "employment_experience" */
export type employment_experience_set_input = {
  company?: Maybe<Scalars['String']>;
  duties?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  inquiryId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  references?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['timestamp']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type employment_experience_stddev_fields = {
  __typename?: 'employment_experience_stddev_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "employment_experience" */
export type employment_experience_stddev_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type employment_experience_stddev_pop_fields = {
  __typename?: 'employment_experience_stddev_pop_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "employment_experience" */
export type employment_experience_stddev_pop_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type employment_experience_stddev_samp_fields = {
  __typename?: 'employment_experience_stddev_samp_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "employment_experience" */
export type employment_experience_stddev_samp_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type employment_experience_sum_fields = {
  __typename?: 'employment_experience_sum_fields';
  inquiryId?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "employment_experience" */
export type employment_experience_sum_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** update columns of table "employment_experience" */
export enum employment_experience_update_column {
  /** column name */
  company = 'company',
  /** column name */
  duties = 'duties',
  /** column name */
  endDate = 'endDate',
  /** column name */
  id = 'id',
  /** column name */
  inquiryId = 'inquiryId',
  /** column name */
  position = 'position',
  /** column name */
  references = 'references',
  /** column name */
  startDate = 'startDate',
  /** column name */
  studentId = 'studentId',
}

/** aggregate var_pop on columns */
export type employment_experience_var_pop_fields = {
  __typename?: 'employment_experience_var_pop_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "employment_experience" */
export type employment_experience_var_pop_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type employment_experience_var_samp_fields = {
  __typename?: 'employment_experience_var_samp_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "employment_experience" */
export type employment_experience_var_samp_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type employment_experience_variance_fields = {
  __typename?: 'employment_experience_variance_fields';
  inquiryId?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "employment_experience" */
export type employment_experience_variance_order_by = {
  inquiryId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** columns and relationships of "endpoint" */
export type endpoint = {
  __typename?: 'endpoint';
  global: Scalars['Boolean'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  route_endpoints_endpoints: Array<route_endpoints_endpoint>;
  /** An aggregate relationship */
  route_endpoints_endpoints_aggregate: route_endpoints_endpoint_aggregate;
};

/** columns and relationships of "endpoint" */
export type endpointroute_endpoints_endpointsArgs = {
  distinct_on?: Maybe<Array<route_endpoints_endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_endpoints_endpoint_order_by>>;
  where?: Maybe<route_endpoints_endpoint_bool_exp>;
};

/** columns and relationships of "endpoint" */
export type endpointroute_endpoints_endpoints_aggregateArgs = {
  distinct_on?: Maybe<Array<route_endpoints_endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_endpoints_endpoint_order_by>>;
  where?: Maybe<route_endpoints_endpoint_bool_exp>;
};

/** aggregated selection of "endpoint" */
export type endpoint_aggregate = {
  __typename?: 'endpoint_aggregate';
  aggregate?: Maybe<endpoint_aggregate_fields>;
  nodes: Array<endpoint>;
};

/** aggregate fields of "endpoint" */
export type endpoint_aggregate_fields = {
  __typename?: 'endpoint_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<endpoint_max_fields>;
  min?: Maybe<endpoint_min_fields>;
};

/** aggregate fields of "endpoint" */
export type endpoint_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<endpoint_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "endpoint". All fields are combined with a logical 'AND'. */
export type endpoint_bool_exp = {
  _and?: Maybe<Array<endpoint_bool_exp>>;
  _not?: Maybe<endpoint_bool_exp>;
  _or?: Maybe<Array<endpoint_bool_exp>>;
  global?: Maybe<Boolean_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  route_endpoints_endpoints?: Maybe<route_endpoints_endpoint_bool_exp>;
};

/** unique or primary key constraints on table "endpoint" */
export enum endpoint_constraint {
  /** unique or primary key constraint */
  IDX_2af256baa0c9d12b07f32cd495 = 'IDX_2af256baa0c9d12b07f32cd495',
  /** unique or primary key constraint */
  PK_7785c5c2cf24e6ab3abb7a2e89f = 'PK_7785c5c2cf24e6ab3abb7a2e89f',
  /** unique or primary key constraint */
  endpoint_name_key = 'endpoint_name_key',
}

/** input type for inserting data into table "endpoint" */
export type endpoint_insert_input = {
  global?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  route_endpoints_endpoints?: Maybe<route_endpoints_endpoint_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type endpoint_max_fields = {
  __typename?: 'endpoint_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type endpoint_min_fields = {
  __typename?: 'endpoint_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "endpoint" */
export type endpoint_mutation_response = {
  __typename?: 'endpoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<endpoint>;
};

/** input type for inserting object relation for remote table "endpoint" */
export type endpoint_obj_rel_insert_input = {
  data: endpoint_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<endpoint_on_conflict>;
};

/** on conflict condition type for table "endpoint" */
export type endpoint_on_conflict = {
  constraint: endpoint_constraint;
  update_columns?: Array<endpoint_update_column>;
  where?: Maybe<endpoint_bool_exp>;
};

/** Ordering options when selecting data from "endpoint". */
export type endpoint_order_by = {
  global?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  route_endpoints_endpoints_aggregate?: Maybe<route_endpoints_endpoint_aggregate_order_by>;
};

/** primary key columns input for table: endpoint */
export type endpoint_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "endpoint" */
export enum endpoint_select_column {
  /** column name */
  global = 'global',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** input type for updating data in table "endpoint" */
export type endpoint_set_input = {
  global?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "endpoint" */
export enum endpoint_update_column {
  /** column name */
  global = 'global',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** columns and relationships of "exit_interview_answer" */
export type exit_interview_answer = {
  __typename?: 'exit_interview_answer';
  created_at: Scalars['timestamptz'];
  /** An array relationship */
  exit_interview_answer_multi_choice_questions: Array<exit_interview_answer_multi_choice_questions>;
  /** An aggregate relationship */
  exit_interview_answer_multi_choice_questions_aggregate: exit_interview_answer_multi_choice_questions_aggregate;
  /** An object relationship */
  exit_interview_question: exit_interview_question;
  /** An array relationship */
  exit_interview_question_answers: Array<exit_interview_question_answers>;
  /** An aggregate relationship */
  exit_interview_question_answers_aggregate: exit_interview_question_answers_aggregate;
  id: Scalars['uuid'];
  questionId: Scalars['uuid'];
  rateAnswer?: Maybe<Scalars['Int']>;
  /** An object relationship */
  student: student;
  studentId: Scalars['Int'];
  textAnswer?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** columns and relationships of "exit_interview_answer" */
export type exit_interview_answerexit_interview_answer_multi_choice_questionsArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_multi_choice_questions_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_multi_choice_questions_order_by>>;
  where?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
};

/** columns and relationships of "exit_interview_answer" */
export type exit_interview_answerexit_interview_answer_multi_choice_questions_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_multi_choice_questions_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_multi_choice_questions_order_by>>;
  where?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
};

/** columns and relationships of "exit_interview_answer" */
export type exit_interview_answerexit_interview_question_answersArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_answers_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_answers_order_by>>;
  where?: Maybe<exit_interview_question_answers_bool_exp>;
};

/** columns and relationships of "exit_interview_answer" */
export type exit_interview_answerexit_interview_question_answers_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_answers_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_answers_order_by>>;
  where?: Maybe<exit_interview_question_answers_bool_exp>;
};

/** aggregated selection of "exit_interview_answer" */
export type exit_interview_answer_aggregate = {
  __typename?: 'exit_interview_answer_aggregate';
  aggregate?: Maybe<exit_interview_answer_aggregate_fields>;
  nodes: Array<exit_interview_answer>;
};

/** aggregate fields of "exit_interview_answer" */
export type exit_interview_answer_aggregate_fields = {
  __typename?: 'exit_interview_answer_aggregate_fields';
  avg?: Maybe<exit_interview_answer_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<exit_interview_answer_max_fields>;
  min?: Maybe<exit_interview_answer_min_fields>;
  stddev?: Maybe<exit_interview_answer_stddev_fields>;
  stddev_pop?: Maybe<exit_interview_answer_stddev_pop_fields>;
  stddev_samp?: Maybe<exit_interview_answer_stddev_samp_fields>;
  sum?: Maybe<exit_interview_answer_sum_fields>;
  var_pop?: Maybe<exit_interview_answer_var_pop_fields>;
  var_samp?: Maybe<exit_interview_answer_var_samp_fields>;
  variance?: Maybe<exit_interview_answer_variance_fields>;
};

/** aggregate fields of "exit_interview_answer" */
export type exit_interview_answer_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<exit_interview_answer_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exit_interview_answer" */
export type exit_interview_answer_aggregate_order_by = {
  avg?: Maybe<exit_interview_answer_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<exit_interview_answer_max_order_by>;
  min?: Maybe<exit_interview_answer_min_order_by>;
  stddev?: Maybe<exit_interview_answer_stddev_order_by>;
  stddev_pop?: Maybe<exit_interview_answer_stddev_pop_order_by>;
  stddev_samp?: Maybe<exit_interview_answer_stddev_samp_order_by>;
  sum?: Maybe<exit_interview_answer_sum_order_by>;
  var_pop?: Maybe<exit_interview_answer_var_pop_order_by>;
  var_samp?: Maybe<exit_interview_answer_var_samp_order_by>;
  variance?: Maybe<exit_interview_answer_variance_order_by>;
};

/** input type for inserting array relation for remote table "exit_interview_answer" */
export type exit_interview_answer_arr_rel_insert_input = {
  data: Array<exit_interview_answer_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<exit_interview_answer_on_conflict>;
};

/** aggregate avg on columns */
export type exit_interview_answer_avg_fields = {
  __typename?: 'exit_interview_answer_avg_fields';
  rateAnswer?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "exit_interview_answer" */
export type exit_interview_answer_avg_order_by = {
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "exit_interview_answer". All fields are combined with a logical 'AND'. */
export type exit_interview_answer_bool_exp = {
  _and?: Maybe<Array<exit_interview_answer_bool_exp>>;
  _not?: Maybe<exit_interview_answer_bool_exp>;
  _or?: Maybe<Array<exit_interview_answer_bool_exp>>;
  created_at?: Maybe<timestamptz_comparison_exp>;
  exit_interview_answer_multi_choice_questions?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
  exit_interview_question?: Maybe<exit_interview_question_bool_exp>;
  exit_interview_question_answers?: Maybe<exit_interview_question_answers_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  questionId?: Maybe<uuid_comparison_exp>;
  rateAnswer?: Maybe<Int_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  textAnswer?: Maybe<String_comparison_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "exit_interview_answer" */
export enum exit_interview_answer_constraint {
  /** unique or primary key constraint */
  exit_interview_answer_id_key = 'exit_interview_answer_id_key',
  /** unique or primary key constraint */
  exit_interview_answer_pkey = 'exit_interview_answer_pkey',
}

/** input type for incrementing numeric columns in table "exit_interview_answer" */
export type exit_interview_answer_inc_input = {
  rateAnswer?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "exit_interview_answer" */
export type exit_interview_answer_insert_input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  exit_interview_answer_multi_choice_questions?: Maybe<exit_interview_answer_multi_choice_questions_arr_rel_insert_input>;
  exit_interview_question?: Maybe<exit_interview_question_obj_rel_insert_input>;
  exit_interview_question_answers?: Maybe<exit_interview_question_answers_arr_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
  rateAnswer?: Maybe<Scalars['Int']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  textAnswer?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type exit_interview_answer_max_fields = {
  __typename?: 'exit_interview_answer_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
  rateAnswer?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  textAnswer?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "exit_interview_answer" */
export type exit_interview_answer_max_order_by = {
  created_at?: Maybe<order_by>;
  id?: Maybe<order_by>;
  questionId?: Maybe<order_by>;
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  textAnswer?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** aggregate min on columns */
export type exit_interview_answer_min_fields = {
  __typename?: 'exit_interview_answer_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
  rateAnswer?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  textAnswer?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "exit_interview_answer" */
export type exit_interview_answer_min_order_by = {
  created_at?: Maybe<order_by>;
  id?: Maybe<order_by>;
  questionId?: Maybe<order_by>;
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  textAnswer?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** columns and relationships of "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions = {
  __typename?: 'exit_interview_answer_multi_choice_questions';
  exitInterviewAnswerId: Scalars['uuid'];
  /** An object relationship */
  exit_interview_answer: exit_interview_answer;
  id: Scalars['uuid'];
  multiChoiceQuestionId: Scalars['uuid'];
  /** An object relationship */
  multi_choice_question: multi_choice_question;
};

/** aggregated selection of "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_aggregate = {
  __typename?: 'exit_interview_answer_multi_choice_questions_aggregate';
  aggregate?: Maybe<exit_interview_answer_multi_choice_questions_aggregate_fields>;
  nodes: Array<exit_interview_answer_multi_choice_questions>;
};

/** aggregate fields of "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_aggregate_fields = {
  __typename?: 'exit_interview_answer_multi_choice_questions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<exit_interview_answer_multi_choice_questions_max_fields>;
  min?: Maybe<exit_interview_answer_multi_choice_questions_min_fields>;
};

/** aggregate fields of "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<exit_interview_answer_multi_choice_questions_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<exit_interview_answer_multi_choice_questions_max_order_by>;
  min?: Maybe<exit_interview_answer_multi_choice_questions_min_order_by>;
};

/** input type for inserting array relation for remote table "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_arr_rel_insert_input = {
  data: Array<exit_interview_answer_multi_choice_questions_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<exit_interview_answer_multi_choice_questions_on_conflict>;
};

/** Boolean expression to filter rows from the table "exit_interview_answer_multi_choice_questions". All fields are combined with a logical 'AND'. */
export type exit_interview_answer_multi_choice_questions_bool_exp = {
  _and?: Maybe<Array<exit_interview_answer_multi_choice_questions_bool_exp>>;
  _not?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
  _or?: Maybe<Array<exit_interview_answer_multi_choice_questions_bool_exp>>;
  exitInterviewAnswerId?: Maybe<uuid_comparison_exp>;
  exit_interview_answer?: Maybe<exit_interview_answer_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  multiChoiceQuestionId?: Maybe<uuid_comparison_exp>;
  multi_choice_question?: Maybe<multi_choice_question_bool_exp>;
};

/** unique or primary key constraints on table "exit_interview_answer_multi_choice_questions" */
export enum exit_interview_answer_multi_choice_questions_constraint {
  /** unique or primary key constraint */
  exit_interview_answer_multi_choice_questions_pkey = 'exit_interview_answer_multi_choice_questions_pkey',
}

/** input type for inserting data into table "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_insert_input = {
  exitInterviewAnswerId?: Maybe<Scalars['uuid']>;
  exit_interview_answer?: Maybe<exit_interview_answer_obj_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  multiChoiceQuestionId?: Maybe<Scalars['uuid']>;
  multi_choice_question?: Maybe<multi_choice_question_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type exit_interview_answer_multi_choice_questions_max_fields = {
  __typename?: 'exit_interview_answer_multi_choice_questions_max_fields';
  exitInterviewAnswerId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  multiChoiceQuestionId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_max_order_by = {
  exitInterviewAnswerId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  multiChoiceQuestionId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type exit_interview_answer_multi_choice_questions_min_fields = {
  __typename?: 'exit_interview_answer_multi_choice_questions_min_fields';
  exitInterviewAnswerId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  multiChoiceQuestionId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_min_order_by = {
  exitInterviewAnswerId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  multiChoiceQuestionId?: Maybe<order_by>;
};

/** response of any mutation on the table "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_mutation_response = {
  __typename?: 'exit_interview_answer_multi_choice_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<exit_interview_answer_multi_choice_questions>;
};

/** on conflict condition type for table "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_on_conflict = {
  constraint: exit_interview_answer_multi_choice_questions_constraint;
  update_columns?: Array<exit_interview_answer_multi_choice_questions_update_column>;
  where?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
};

/** Ordering options when selecting data from "exit_interview_answer_multi_choice_questions". */
export type exit_interview_answer_multi_choice_questions_order_by = {
  exitInterviewAnswerId?: Maybe<order_by>;
  exit_interview_answer?: Maybe<exit_interview_answer_order_by>;
  id?: Maybe<order_by>;
  multiChoiceQuestionId?: Maybe<order_by>;
  multi_choice_question?: Maybe<multi_choice_question_order_by>;
};

/** primary key columns input for table: exit_interview_answer_multi_choice_questions */
export type exit_interview_answer_multi_choice_questions_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "exit_interview_answer_multi_choice_questions" */
export enum exit_interview_answer_multi_choice_questions_select_column {
  /** column name */
  exitInterviewAnswerId = 'exitInterviewAnswerId',
  /** column name */
  id = 'id',
  /** column name */
  multiChoiceQuestionId = 'multiChoiceQuestionId',
}

/** input type for updating data in table "exit_interview_answer_multi_choice_questions" */
export type exit_interview_answer_multi_choice_questions_set_input = {
  exitInterviewAnswerId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  multiChoiceQuestionId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "exit_interview_answer_multi_choice_questions" */
export enum exit_interview_answer_multi_choice_questions_update_column {
  /** column name */
  exitInterviewAnswerId = 'exitInterviewAnswerId',
  /** column name */
  id = 'id',
  /** column name */
  multiChoiceQuestionId = 'multiChoiceQuestionId',
}

/** response of any mutation on the table "exit_interview_answer" */
export type exit_interview_answer_mutation_response = {
  __typename?: 'exit_interview_answer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<exit_interview_answer>;
};

/** input type for inserting object relation for remote table "exit_interview_answer" */
export type exit_interview_answer_obj_rel_insert_input = {
  data: exit_interview_answer_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<exit_interview_answer_on_conflict>;
};

/** on conflict condition type for table "exit_interview_answer" */
export type exit_interview_answer_on_conflict = {
  constraint: exit_interview_answer_constraint;
  update_columns?: Array<exit_interview_answer_update_column>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

/** Ordering options when selecting data from "exit_interview_answer". */
export type exit_interview_answer_order_by = {
  created_at?: Maybe<order_by>;
  exit_interview_answer_multi_choice_questions_aggregate?: Maybe<exit_interview_answer_multi_choice_questions_aggregate_order_by>;
  exit_interview_question?: Maybe<exit_interview_question_order_by>;
  exit_interview_question_answers_aggregate?: Maybe<exit_interview_question_answers_aggregate_order_by>;
  id?: Maybe<order_by>;
  questionId?: Maybe<order_by>;
  rateAnswer?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  textAnswer?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** primary key columns input for table: exit_interview_answer */
export type exit_interview_answer_pk_columns_input = {
  questionId: Scalars['uuid'];
  studentId: Scalars['Int'];
};

/** select columns of table "exit_interview_answer" */
export enum exit_interview_answer_select_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  questionId = 'questionId',
  /** column name */
  rateAnswer = 'rateAnswer',
  /** column name */
  studentId = 'studentId',
  /** column name */
  textAnswer = 'textAnswer',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "exit_interview_answer" */
export type exit_interview_answer_set_input = {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
  rateAnswer?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  textAnswer?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type exit_interview_answer_stddev_fields = {
  __typename?: 'exit_interview_answer_stddev_fields';
  rateAnswer?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "exit_interview_answer" */
export type exit_interview_answer_stddev_order_by = {
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type exit_interview_answer_stddev_pop_fields = {
  __typename?: 'exit_interview_answer_stddev_pop_fields';
  rateAnswer?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "exit_interview_answer" */
export type exit_interview_answer_stddev_pop_order_by = {
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type exit_interview_answer_stddev_samp_fields = {
  __typename?: 'exit_interview_answer_stddev_samp_fields';
  rateAnswer?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "exit_interview_answer" */
export type exit_interview_answer_stddev_samp_order_by = {
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type exit_interview_answer_sum_fields = {
  __typename?: 'exit_interview_answer_sum_fields';
  rateAnswer?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "exit_interview_answer" */
export type exit_interview_answer_sum_order_by = {
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** update columns of table "exit_interview_answer" */
export enum exit_interview_answer_update_column {
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  questionId = 'questionId',
  /** column name */
  rateAnswer = 'rateAnswer',
  /** column name */
  studentId = 'studentId',
  /** column name */
  textAnswer = 'textAnswer',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate var_pop on columns */
export type exit_interview_answer_var_pop_fields = {
  __typename?: 'exit_interview_answer_var_pop_fields';
  rateAnswer?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "exit_interview_answer" */
export type exit_interview_answer_var_pop_order_by = {
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type exit_interview_answer_var_samp_fields = {
  __typename?: 'exit_interview_answer_var_samp_fields';
  rateAnswer?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "exit_interview_answer" */
export type exit_interview_answer_var_samp_order_by = {
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type exit_interview_answer_variance_fields = {
  __typename?: 'exit_interview_answer_variance_fields';
  rateAnswer?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "exit_interview_answer" */
export type exit_interview_answer_variance_order_by = {
  rateAnswer?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** columns and relationships of "exit_interview_question" */
export type exit_interview_question = {
  __typename?: 'exit_interview_question';
  exitInterviewQuestionGroupId?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  exit_interview_answers: Array<exit_interview_answer>;
  /** An aggregate relationship */
  exit_interview_answers_aggregate: exit_interview_answer_aggregate;
  /** An array relationship */
  exit_interview_question_answers: Array<exit_interview_question_answers>;
  /** An aggregate relationship */
  exit_interview_question_answers_aggregate: exit_interview_question_answers_aggregate;
  /** An object relationship */
  exit_interview_question_group?: Maybe<exit_interview_question_group>;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  /** An array relationship */
  multi_choice_questions: Array<multi_choice_question>;
  /** An aggregate relationship */
  multi_choice_questions_aggregate: multi_choice_question_aggregate;
  question: Scalars['String'];
  questionType: Scalars['String'];
  /** An object relationship */
  question_type: question_type;
};

/** columns and relationships of "exit_interview_question" */
export type exit_interview_questionexit_interview_answersArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

/** columns and relationships of "exit_interview_question" */
export type exit_interview_questionexit_interview_answers_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

/** columns and relationships of "exit_interview_question" */
export type exit_interview_questionexit_interview_question_answersArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_answers_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_answers_order_by>>;
  where?: Maybe<exit_interview_question_answers_bool_exp>;
};

/** columns and relationships of "exit_interview_question" */
export type exit_interview_questionexit_interview_question_answers_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_answers_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_answers_order_by>>;
  where?: Maybe<exit_interview_question_answers_bool_exp>;
};

/** columns and relationships of "exit_interview_question" */
export type exit_interview_questionmulti_choice_questionsArgs = {
  distinct_on?: Maybe<Array<multi_choice_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<multi_choice_question_order_by>>;
  where?: Maybe<multi_choice_question_bool_exp>;
};

/** columns and relationships of "exit_interview_question" */
export type exit_interview_questionmulti_choice_questions_aggregateArgs = {
  distinct_on?: Maybe<Array<multi_choice_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<multi_choice_question_order_by>>;
  where?: Maybe<multi_choice_question_bool_exp>;
};

/** aggregated selection of "exit_interview_question" */
export type exit_interview_question_aggregate = {
  __typename?: 'exit_interview_question_aggregate';
  aggregate?: Maybe<exit_interview_question_aggregate_fields>;
  nodes: Array<exit_interview_question>;
};

/** aggregate fields of "exit_interview_question" */
export type exit_interview_question_aggregate_fields = {
  __typename?: 'exit_interview_question_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<exit_interview_question_max_fields>;
  min?: Maybe<exit_interview_question_min_fields>;
};

/** aggregate fields of "exit_interview_question" */
export type exit_interview_question_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<exit_interview_question_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exit_interview_question" */
export type exit_interview_question_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<exit_interview_question_max_order_by>;
  min?: Maybe<exit_interview_question_min_order_by>;
};

/** columns and relationships of "exit_interview_question_answers" */
export type exit_interview_question_answers = {
  __typename?: 'exit_interview_question_answers';
  exitInterviewAnswerId: Scalars['uuid'];
  exitInterviewQuestionId: Scalars['uuid'];
  /** An object relationship */
  exit_interview_answer: exit_interview_answer;
  /** An object relationship */
  exit_interview_question: exit_interview_question;
  id: Scalars['uuid'];
};

/** aggregated selection of "exit_interview_question_answers" */
export type exit_interview_question_answers_aggregate = {
  __typename?: 'exit_interview_question_answers_aggregate';
  aggregate?: Maybe<exit_interview_question_answers_aggregate_fields>;
  nodes: Array<exit_interview_question_answers>;
};

/** aggregate fields of "exit_interview_question_answers" */
export type exit_interview_question_answers_aggregate_fields = {
  __typename?: 'exit_interview_question_answers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<exit_interview_question_answers_max_fields>;
  min?: Maybe<exit_interview_question_answers_min_fields>;
};

/** aggregate fields of "exit_interview_question_answers" */
export type exit_interview_question_answers_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<exit_interview_question_answers_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "exit_interview_question_answers" */
export type exit_interview_question_answers_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<exit_interview_question_answers_max_order_by>;
  min?: Maybe<exit_interview_question_answers_min_order_by>;
};

/** input type for inserting array relation for remote table "exit_interview_question_answers" */
export type exit_interview_question_answers_arr_rel_insert_input = {
  data: Array<exit_interview_question_answers_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<exit_interview_question_answers_on_conflict>;
};

/** Boolean expression to filter rows from the table "exit_interview_question_answers". All fields are combined with a logical 'AND'. */
export type exit_interview_question_answers_bool_exp = {
  _and?: Maybe<Array<exit_interview_question_answers_bool_exp>>;
  _not?: Maybe<exit_interview_question_answers_bool_exp>;
  _or?: Maybe<Array<exit_interview_question_answers_bool_exp>>;
  exitInterviewAnswerId?: Maybe<uuid_comparison_exp>;
  exitInterviewQuestionId?: Maybe<uuid_comparison_exp>;
  exit_interview_answer?: Maybe<exit_interview_answer_bool_exp>;
  exit_interview_question?: Maybe<exit_interview_question_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "exit_interview_question_answers" */
export enum exit_interview_question_answers_constraint {
  /** unique or primary key constraint */
  exit_interview_question_answers_pkey = 'exit_interview_question_answers_pkey',
}

/** input type for inserting data into table "exit_interview_question_answers" */
export type exit_interview_question_answers_insert_input = {
  exitInterviewAnswerId?: Maybe<Scalars['uuid']>;
  exitInterviewQuestionId?: Maybe<Scalars['uuid']>;
  exit_interview_answer?: Maybe<exit_interview_answer_obj_rel_insert_input>;
  exit_interview_question?: Maybe<exit_interview_question_obj_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type exit_interview_question_answers_max_fields = {
  __typename?: 'exit_interview_question_answers_max_fields';
  exitInterviewAnswerId?: Maybe<Scalars['uuid']>;
  exitInterviewQuestionId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "exit_interview_question_answers" */
export type exit_interview_question_answers_max_order_by = {
  exitInterviewAnswerId?: Maybe<order_by>;
  exitInterviewQuestionId?: Maybe<order_by>;
  id?: Maybe<order_by>;
};

/** aggregate min on columns */
export type exit_interview_question_answers_min_fields = {
  __typename?: 'exit_interview_question_answers_min_fields';
  exitInterviewAnswerId?: Maybe<Scalars['uuid']>;
  exitInterviewQuestionId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "exit_interview_question_answers" */
export type exit_interview_question_answers_min_order_by = {
  exitInterviewAnswerId?: Maybe<order_by>;
  exitInterviewQuestionId?: Maybe<order_by>;
  id?: Maybe<order_by>;
};

/** response of any mutation on the table "exit_interview_question_answers" */
export type exit_interview_question_answers_mutation_response = {
  __typename?: 'exit_interview_question_answers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<exit_interview_question_answers>;
};

/** on conflict condition type for table "exit_interview_question_answers" */
export type exit_interview_question_answers_on_conflict = {
  constraint: exit_interview_question_answers_constraint;
  update_columns?: Array<exit_interview_question_answers_update_column>;
  where?: Maybe<exit_interview_question_answers_bool_exp>;
};

/** Ordering options when selecting data from "exit_interview_question_answers". */
export type exit_interview_question_answers_order_by = {
  exitInterviewAnswerId?: Maybe<order_by>;
  exitInterviewQuestionId?: Maybe<order_by>;
  exit_interview_answer?: Maybe<exit_interview_answer_order_by>;
  exit_interview_question?: Maybe<exit_interview_question_order_by>;
  id?: Maybe<order_by>;
};

/** primary key columns input for table: exit_interview_question_answers */
export type exit_interview_question_answers_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "exit_interview_question_answers" */
export enum exit_interview_question_answers_select_column {
  /** column name */
  exitInterviewAnswerId = 'exitInterviewAnswerId',
  /** column name */
  exitInterviewQuestionId = 'exitInterviewQuestionId',
  /** column name */
  id = 'id',
}

/** input type for updating data in table "exit_interview_question_answers" */
export type exit_interview_question_answers_set_input = {
  exitInterviewAnswerId?: Maybe<Scalars['uuid']>;
  exitInterviewQuestionId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** update columns of table "exit_interview_question_answers" */
export enum exit_interview_question_answers_update_column {
  /** column name */
  exitInterviewAnswerId = 'exitInterviewAnswerId',
  /** column name */
  exitInterviewQuestionId = 'exitInterviewQuestionId',
  /** column name */
  id = 'id',
}

/** input type for inserting array relation for remote table "exit_interview_question" */
export type exit_interview_question_arr_rel_insert_input = {
  data: Array<exit_interview_question_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<exit_interview_question_on_conflict>;
};

/** Boolean expression to filter rows from the table "exit_interview_question". All fields are combined with a logical 'AND'. */
export type exit_interview_question_bool_exp = {
  _and?: Maybe<Array<exit_interview_question_bool_exp>>;
  _not?: Maybe<exit_interview_question_bool_exp>;
  _or?: Maybe<Array<exit_interview_question_bool_exp>>;
  exitInterviewQuestionGroupId?: Maybe<uuid_comparison_exp>;
  exit_interview_answers?: Maybe<exit_interview_answer_bool_exp>;
  exit_interview_question_answers?: Maybe<exit_interview_question_answers_bool_exp>;
  exit_interview_question_group?: Maybe<exit_interview_question_group_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  isActive?: Maybe<Boolean_comparison_exp>;
  multi_choice_questions?: Maybe<multi_choice_question_bool_exp>;
  question?: Maybe<String_comparison_exp>;
  questionType?: Maybe<String_comparison_exp>;
  question_type?: Maybe<question_type_bool_exp>;
};

/** unique or primary key constraints on table "exit_interview_question" */
export enum exit_interview_question_constraint {
  /** unique or primary key constraint */
  exit_interview_question_pkey = 'exit_interview_question_pkey',
}

/** columns and relationships of "exit_interview_question_group" */
export type exit_interview_question_group = {
  __typename?: 'exit_interview_question_group';
  /** An array relationship */
  exit_interview_questions: Array<exit_interview_question>;
  /** An aggregate relationship */
  exit_interview_questions_aggregate: exit_interview_question_aggregate;
  id: Scalars['uuid'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

/** columns and relationships of "exit_interview_question_group" */
export type exit_interview_question_groupexit_interview_questionsArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_order_by>>;
  where?: Maybe<exit_interview_question_bool_exp>;
};

/** columns and relationships of "exit_interview_question_group" */
export type exit_interview_question_groupexit_interview_questions_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_order_by>>;
  where?: Maybe<exit_interview_question_bool_exp>;
};

/** aggregated selection of "exit_interview_question_group" */
export type exit_interview_question_group_aggregate = {
  __typename?: 'exit_interview_question_group_aggregate';
  aggregate?: Maybe<exit_interview_question_group_aggregate_fields>;
  nodes: Array<exit_interview_question_group>;
};

/** aggregate fields of "exit_interview_question_group" */
export type exit_interview_question_group_aggregate_fields = {
  __typename?: 'exit_interview_question_group_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<exit_interview_question_group_max_fields>;
  min?: Maybe<exit_interview_question_group_min_fields>;
};

/** aggregate fields of "exit_interview_question_group" */
export type exit_interview_question_group_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<exit_interview_question_group_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "exit_interview_question_group". All fields are combined with a logical 'AND'. */
export type exit_interview_question_group_bool_exp = {
  _and?: Maybe<Array<exit_interview_question_group_bool_exp>>;
  _not?: Maybe<exit_interview_question_group_bool_exp>;
  _or?: Maybe<Array<exit_interview_question_group_bool_exp>>;
  exit_interview_questions?: Maybe<exit_interview_question_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  isActive?: Maybe<Boolean_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "exit_interview_question_group" */
export enum exit_interview_question_group_constraint {
  /** unique or primary key constraint */
  exit_interview_question_group_name_key = 'exit_interview_question_group_name_key',
  /** unique or primary key constraint */
  exit_interview_question_group_pkey = 'exit_interview_question_group_pkey',
}

/** input type for inserting data into table "exit_interview_question_group" */
export type exit_interview_question_group_insert_input = {
  exit_interview_questions?: Maybe<exit_interview_question_arr_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type exit_interview_question_group_max_fields = {
  __typename?: 'exit_interview_question_group_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type exit_interview_question_group_min_fields = {
  __typename?: 'exit_interview_question_group_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "exit_interview_question_group" */
export type exit_interview_question_group_mutation_response = {
  __typename?: 'exit_interview_question_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<exit_interview_question_group>;
};

/** input type for inserting object relation for remote table "exit_interview_question_group" */
export type exit_interview_question_group_obj_rel_insert_input = {
  data: exit_interview_question_group_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<exit_interview_question_group_on_conflict>;
};

/** on conflict condition type for table "exit_interview_question_group" */
export type exit_interview_question_group_on_conflict = {
  constraint: exit_interview_question_group_constraint;
  update_columns?: Array<exit_interview_question_group_update_column>;
  where?: Maybe<exit_interview_question_group_bool_exp>;
};

/** Ordering options when selecting data from "exit_interview_question_group". */
export type exit_interview_question_group_order_by = {
  exit_interview_questions_aggregate?: Maybe<exit_interview_question_aggregate_order_by>;
  id?: Maybe<order_by>;
  isActive?: Maybe<order_by>;
  name?: Maybe<order_by>;
};

/** primary key columns input for table: exit_interview_question_group */
export type exit_interview_question_group_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "exit_interview_question_group" */
export enum exit_interview_question_group_select_column {
  /** column name */
  id = 'id',
  /** column name */
  isActive = 'isActive',
  /** column name */
  name = 'name',
}

/** input type for updating data in table "exit_interview_question_group" */
export type exit_interview_question_group_set_input = {
  id?: Maybe<Scalars['uuid']>;
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "exit_interview_question_group" */
export enum exit_interview_question_group_update_column {
  /** column name */
  id = 'id',
  /** column name */
  isActive = 'isActive',
  /** column name */
  name = 'name',
}

/** input type for inserting data into table "exit_interview_question" */
export type exit_interview_question_insert_input = {
  exitInterviewQuestionGroupId?: Maybe<Scalars['uuid']>;
  exit_interview_answers?: Maybe<exit_interview_answer_arr_rel_insert_input>;
  exit_interview_question_answers?: Maybe<exit_interview_question_answers_arr_rel_insert_input>;
  exit_interview_question_group?: Maybe<exit_interview_question_group_obj_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  isActive?: Maybe<Scalars['Boolean']>;
  multi_choice_questions?: Maybe<multi_choice_question_arr_rel_insert_input>;
  question?: Maybe<Scalars['String']>;
  questionType?: Maybe<Scalars['String']>;
  question_type?: Maybe<question_type_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type exit_interview_question_max_fields = {
  __typename?: 'exit_interview_question_max_fields';
  exitInterviewQuestionGroupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  questionType?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "exit_interview_question" */
export type exit_interview_question_max_order_by = {
  exitInterviewQuestionGroupId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  question?: Maybe<order_by>;
  questionType?: Maybe<order_by>;
};

/** aggregate min on columns */
export type exit_interview_question_min_fields = {
  __typename?: 'exit_interview_question_min_fields';
  exitInterviewQuestionGroupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  questionType?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "exit_interview_question" */
export type exit_interview_question_min_order_by = {
  exitInterviewQuestionGroupId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  question?: Maybe<order_by>;
  questionType?: Maybe<order_by>;
};

/** response of any mutation on the table "exit_interview_question" */
export type exit_interview_question_mutation_response = {
  __typename?: 'exit_interview_question_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<exit_interview_question>;
};

/** input type for inserting object relation for remote table "exit_interview_question" */
export type exit_interview_question_obj_rel_insert_input = {
  data: exit_interview_question_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<exit_interview_question_on_conflict>;
};

/** on conflict condition type for table "exit_interview_question" */
export type exit_interview_question_on_conflict = {
  constraint: exit_interview_question_constraint;
  update_columns?: Array<exit_interview_question_update_column>;
  where?: Maybe<exit_interview_question_bool_exp>;
};

/** Ordering options when selecting data from "exit_interview_question". */
export type exit_interview_question_order_by = {
  exitInterviewQuestionGroupId?: Maybe<order_by>;
  exit_interview_answers_aggregate?: Maybe<exit_interview_answer_aggregate_order_by>;
  exit_interview_question_answers_aggregate?: Maybe<exit_interview_question_answers_aggregate_order_by>;
  exit_interview_question_group?: Maybe<exit_interview_question_group_order_by>;
  id?: Maybe<order_by>;
  isActive?: Maybe<order_by>;
  multi_choice_questions_aggregate?: Maybe<multi_choice_question_aggregate_order_by>;
  question?: Maybe<order_by>;
  questionType?: Maybe<order_by>;
  question_type?: Maybe<question_type_order_by>;
};

/** primary key columns input for table: exit_interview_question */
export type exit_interview_question_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "exit_interview_question" */
export enum exit_interview_question_select_column {
  /** column name */
  exitInterviewQuestionGroupId = 'exitInterviewQuestionGroupId',
  /** column name */
  id = 'id',
  /** column name */
  isActive = 'isActive',
  /** column name */
  question = 'question',
  /** column name */
  questionType = 'questionType',
}

/** input type for updating data in table "exit_interview_question" */
export type exit_interview_question_set_input = {
  exitInterviewQuestionGroupId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  isActive?: Maybe<Scalars['Boolean']>;
  question?: Maybe<Scalars['String']>;
  questionType?: Maybe<Scalars['String']>;
};

/** update columns of table "exit_interview_question" */
export enum exit_interview_question_update_column {
  /** column name */
  exitInterviewQuestionGroupId = 'exitInterviewQuestionGroupId',
  /** column name */
  id = 'id',
  /** column name */
  isActive = 'isActive',
  /** column name */
  question = 'question',
  /** column name */
  questionType = 'questionType',
}

/** columns and relationships of "inquiry" */
export type inquiry = {
  __typename?: 'inquiry';
  assignedUserId?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  /** An object relationship */
  course?: Maybe<course>;
  courseId?: Maybe<Scalars['uuid']>;
  createdAt: Scalars['timestamp'];
  date?: Maybe<Scalars['timestamp']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  education_qualifications: Array<education_qualification>;
  /** An aggregate relationship */
  education_qualifications_aggregate: education_qualification_aggregate;
  /** An array relationship */
  employment_experiences: Array<employment_experience>;
  /** An aggregate relationship */
  employment_experiences_aggregate: employment_experience_aggregate;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['inquiry_gender_enum']>;
  id: Scalars['Int'];
  inquirerContactNo?: Maybe<Scalars['String']>;
  inquirerEmail?: Maybe<Scalars['String']>;
  inquirerName?: Maybe<Scalars['String']>;
  inquiryNumber?: Maybe<Scalars['String']>;
  inquiryType?: Maybe<Scalars['inquiry_inquirytype_enum']>;
  /** An object relationship */
  inquiry_status?: Maybe<inquiry_status_enum>;
  /** An object relationship */
  intake?: Maybe<intake>;
  intakeId?: Maybe<Scalars['uuid']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  preferredYear?: Maybe<Scalars['Int']>;
  referredVia?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  /** An object relationship */
  student?: Maybe<student>;
  studentEmail?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  student_registered?: Maybe<student>;
  updatedAt: Scalars['timestamp'];
  /** An object relationship */
  user?: Maybe<user>;
  whatsapp_number?: Maybe<Scalars['String']>;
  willingToMigrate?: Maybe<Scalars['Boolean']>;
};

/** columns and relationships of "inquiry" */
export type inquiryeducation_qualificationsArgs = {
  distinct_on?: Maybe<Array<education_qualification_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<education_qualification_order_by>>;
  where?: Maybe<education_qualification_bool_exp>;
};

/** columns and relationships of "inquiry" */
export type inquiryeducation_qualifications_aggregateArgs = {
  distinct_on?: Maybe<Array<education_qualification_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<education_qualification_order_by>>;
  where?: Maybe<education_qualification_bool_exp>;
};

/** columns and relationships of "inquiry" */
export type inquiryemployment_experiencesArgs = {
  distinct_on?: Maybe<Array<employment_experience_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<employment_experience_order_by>>;
  where?: Maybe<employment_experience_bool_exp>;
};

/** columns and relationships of "inquiry" */
export type inquiryemployment_experiences_aggregateArgs = {
  distinct_on?: Maybe<Array<employment_experience_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<employment_experience_order_by>>;
  where?: Maybe<employment_experience_bool_exp>;
};

/** aggregated selection of "inquiry" */
export type inquiry_aggregate = {
  __typename?: 'inquiry_aggregate';
  aggregate?: Maybe<inquiry_aggregate_fields>;
  nodes: Array<inquiry>;
};

/** aggregate fields of "inquiry" */
export type inquiry_aggregate_fields = {
  __typename?: 'inquiry_aggregate_fields';
  avg?: Maybe<inquiry_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<inquiry_max_fields>;
  min?: Maybe<inquiry_min_fields>;
  stddev?: Maybe<inquiry_stddev_fields>;
  stddev_pop?: Maybe<inquiry_stddev_pop_fields>;
  stddev_samp?: Maybe<inquiry_stddev_samp_fields>;
  sum?: Maybe<inquiry_sum_fields>;
  var_pop?: Maybe<inquiry_var_pop_fields>;
  var_samp?: Maybe<inquiry_var_samp_fields>;
  variance?: Maybe<inquiry_variance_fields>;
};

/** aggregate fields of "inquiry" */
export type inquiry_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<inquiry_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "inquiry" */
export type inquiry_aggregate_order_by = {
  avg?: Maybe<inquiry_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<inquiry_max_order_by>;
  min?: Maybe<inquiry_min_order_by>;
  stddev?: Maybe<inquiry_stddev_order_by>;
  stddev_pop?: Maybe<inquiry_stddev_pop_order_by>;
  stddev_samp?: Maybe<inquiry_stddev_samp_order_by>;
  sum?: Maybe<inquiry_sum_order_by>;
  var_pop?: Maybe<inquiry_var_pop_order_by>;
  var_samp?: Maybe<inquiry_var_samp_order_by>;
  variance?: Maybe<inquiry_variance_order_by>;
};

/** input type for inserting array relation for remote table "inquiry" */
export type inquiry_arr_rel_insert_input = {
  data: Array<inquiry_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<inquiry_on_conflict>;
};

/** aggregate avg on columns */
export type inquiry_avg_fields = {
  __typename?: 'inquiry_avg_fields';
  id?: Maybe<Scalars['Float']>;
  preferredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "inquiry" */
export type inquiry_avg_order_by = {
  id?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "inquiry". All fields are combined with a logical 'AND'. */
export type inquiry_bool_exp = {
  _and?: Maybe<Array<inquiry_bool_exp>>;
  _not?: Maybe<inquiry_bool_exp>;
  _or?: Maybe<Array<inquiry_bool_exp>>;
  assignedUserId?: Maybe<uuid_comparison_exp>;
  city?: Maybe<String_comparison_exp>;
  course?: Maybe<course_bool_exp>;
  courseId?: Maybe<uuid_comparison_exp>;
  createdAt?: Maybe<timestamp_comparison_exp>;
  date?: Maybe<timestamp_comparison_exp>;
  dateOfBirth?: Maybe<timestamp_comparison_exp>;
  education_qualifications?: Maybe<education_qualification_bool_exp>;
  employment_experiences?: Maybe<employment_experience_bool_exp>;
  firstName?: Maybe<String_comparison_exp>;
  gender?: Maybe<inquiry_gender_enum_comparison_exp>;
  id?: Maybe<Int_comparison_exp>;
  inquirerContactNo?: Maybe<String_comparison_exp>;
  inquirerEmail?: Maybe<String_comparison_exp>;
  inquirerName?: Maybe<String_comparison_exp>;
  inquiryNumber?: Maybe<String_comparison_exp>;
  inquiryType?: Maybe<inquiry_inquirytype_enum_comparison_exp>;
  inquiry_status?: Maybe<inquiry_status_enum_bool_exp>;
  intake?: Maybe<intake_bool_exp>;
  intakeId?: Maybe<uuid_comparison_exp>;
  landLineNo?: Maybe<String_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  middleName?: Maybe<String_comparison_exp>;
  mobileNo?: Maybe<String_comparison_exp>;
  parentOrGuardianLandLineNo?: Maybe<String_comparison_exp>;
  parentOrGuardianMobileNo?: Maybe<String_comparison_exp>;
  preferredYear?: Maybe<Int_comparison_exp>;
  referredVia?: Maybe<String_comparison_exp>;
  status?: Maybe<String_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentEmail?: Maybe<String_comparison_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  student_registered?: Maybe<student_bool_exp>;
  updatedAt?: Maybe<timestamp_comparison_exp>;
  user?: Maybe<user_bool_exp>;
  whatsapp_number?: Maybe<String_comparison_exp>;
  willingToMigrate?: Maybe<Boolean_comparison_exp>;
};

/** unique or primary key constraints on table "inquiry" */
export enum inquiry_constraint {
  /** unique or primary key constraint */
  IDX_98b74a3125a1ec7dbdb931ff3a = 'IDX_98b74a3125a1ec7dbdb931ff3a',
  /** unique or primary key constraint */
  PK_3e226d0994e8bd24252dd65e1b6 = 'PK_3e226d0994e8bd24252dd65e1b6',
  /** unique or primary key constraint */
  REL_92f4596307588b12f4a24c4e42 = 'REL_92f4596307588b12f4a24c4e42',
}

/** Boolean expression to compare columns of type "inquiry_gender_enum". All fields are combined with logical 'AND'. */
export type inquiry_gender_enum_comparison_exp = {
  _eq?: Maybe<Scalars['inquiry_gender_enum']>;
  _gt?: Maybe<Scalars['inquiry_gender_enum']>;
  _gte?: Maybe<Scalars['inquiry_gender_enum']>;
  _in?: Maybe<Array<Scalars['inquiry_gender_enum']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['inquiry_gender_enum']>;
  _lte?: Maybe<Scalars['inquiry_gender_enum']>;
  _neq?: Maybe<Scalars['inquiry_gender_enum']>;
  _nin?: Maybe<Array<Scalars['inquiry_gender_enum']>>;
};

/** input type for incrementing numeric columns in table "inquiry" */
export type inquiry_inc_input = {
  id?: Maybe<Scalars['Int']>;
  preferredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** Boolean expression to compare columns of type "inquiry_inquirytype_enum". All fields are combined with logical 'AND'. */
export type inquiry_inquirytype_enum_comparison_exp = {
  _eq?: Maybe<Scalars['inquiry_inquirytype_enum']>;
  _gt?: Maybe<Scalars['inquiry_inquirytype_enum']>;
  _gte?: Maybe<Scalars['inquiry_inquirytype_enum']>;
  _in?: Maybe<Array<Scalars['inquiry_inquirytype_enum']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['inquiry_inquirytype_enum']>;
  _lte?: Maybe<Scalars['inquiry_inquirytype_enum']>;
  _neq?: Maybe<Scalars['inquiry_inquirytype_enum']>;
  _nin?: Maybe<Array<Scalars['inquiry_inquirytype_enum']>>;
};

/** input type for inserting data into table "inquiry" */
export type inquiry_insert_input = {
  assignedUserId?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  course?: Maybe<course_obj_rel_insert_input>;
  courseId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  date?: Maybe<Scalars['timestamp']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  education_qualifications?: Maybe<education_qualification_arr_rel_insert_input>;
  employment_experiences?: Maybe<employment_experience_arr_rel_insert_input>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['inquiry_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  inquirerContactNo?: Maybe<Scalars['String']>;
  inquirerEmail?: Maybe<Scalars['String']>;
  inquirerName?: Maybe<Scalars['String']>;
  inquiryNumber?: Maybe<Scalars['String']>;
  inquiryType?: Maybe<Scalars['inquiry_inquirytype_enum']>;
  inquiry_status?: Maybe<inquiry_status_enum_obj_rel_insert_input>;
  intake?: Maybe<intake_obj_rel_insert_input>;
  intakeId?: Maybe<Scalars['uuid']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  preferredYear?: Maybe<Scalars['Int']>;
  referredVia?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentEmail?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  student_registered?: Maybe<student_obj_rel_insert_input>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  user?: Maybe<user_obj_rel_insert_input>;
  whatsapp_number?: Maybe<Scalars['String']>;
  willingToMigrate?: Maybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type inquiry_max_fields = {
  __typename?: 'inquiry_max_fields';
  assignedUserId?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  date?: Maybe<Scalars['timestamp']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inquirerContactNo?: Maybe<Scalars['String']>;
  inquirerEmail?: Maybe<Scalars['String']>;
  inquirerName?: Maybe<Scalars['String']>;
  inquiryNumber?: Maybe<Scalars['String']>;
  intakeId?: Maybe<Scalars['uuid']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  preferredYear?: Maybe<Scalars['Int']>;
  referredVia?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentEmail?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  whatsapp_number?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "inquiry" */
export type inquiry_max_order_by = {
  assignedUserId?: Maybe<order_by>;
  city?: Maybe<order_by>;
  courseId?: Maybe<order_by>;
  createdAt?: Maybe<order_by>;
  date?: Maybe<order_by>;
  dateOfBirth?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquirerContactNo?: Maybe<order_by>;
  inquirerEmail?: Maybe<order_by>;
  inquirerName?: Maybe<order_by>;
  inquiryNumber?: Maybe<order_by>;
  intakeId?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  parentOrGuardianLandLineNo?: Maybe<order_by>;
  parentOrGuardianMobileNo?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  referredVia?: Maybe<order_by>;
  status?: Maybe<order_by>;
  studentEmail?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updatedAt?: Maybe<order_by>;
  whatsapp_number?: Maybe<order_by>;
};

/** aggregate min on columns */
export type inquiry_min_fields = {
  __typename?: 'inquiry_min_fields';
  assignedUserId?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  date?: Maybe<Scalars['timestamp']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  inquirerContactNo?: Maybe<Scalars['String']>;
  inquirerEmail?: Maybe<Scalars['String']>;
  inquirerName?: Maybe<Scalars['String']>;
  inquiryNumber?: Maybe<Scalars['String']>;
  intakeId?: Maybe<Scalars['uuid']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  preferredYear?: Maybe<Scalars['Int']>;
  referredVia?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentEmail?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  whatsapp_number?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "inquiry" */
export type inquiry_min_order_by = {
  assignedUserId?: Maybe<order_by>;
  city?: Maybe<order_by>;
  courseId?: Maybe<order_by>;
  createdAt?: Maybe<order_by>;
  date?: Maybe<order_by>;
  dateOfBirth?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquirerContactNo?: Maybe<order_by>;
  inquirerEmail?: Maybe<order_by>;
  inquirerName?: Maybe<order_by>;
  inquiryNumber?: Maybe<order_by>;
  intakeId?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  parentOrGuardianLandLineNo?: Maybe<order_by>;
  parentOrGuardianMobileNo?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  referredVia?: Maybe<order_by>;
  status?: Maybe<order_by>;
  studentEmail?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updatedAt?: Maybe<order_by>;
  whatsapp_number?: Maybe<order_by>;
};

/** response of any mutation on the table "inquiry" */
export type inquiry_mutation_response = {
  __typename?: 'inquiry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<inquiry>;
};

/** input type for inserting object relation for remote table "inquiry" */
export type inquiry_obj_rel_insert_input = {
  data: inquiry_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<inquiry_on_conflict>;
};

/** on conflict condition type for table "inquiry" */
export type inquiry_on_conflict = {
  constraint: inquiry_constraint;
  update_columns?: Array<inquiry_update_column>;
  where?: Maybe<inquiry_bool_exp>;
};

/** Ordering options when selecting data from "inquiry". */
export type inquiry_order_by = {
  assignedUserId?: Maybe<order_by>;
  city?: Maybe<order_by>;
  course?: Maybe<course_order_by>;
  courseId?: Maybe<order_by>;
  createdAt?: Maybe<order_by>;
  date?: Maybe<order_by>;
  dateOfBirth?: Maybe<order_by>;
  education_qualifications_aggregate?: Maybe<education_qualification_aggregate_order_by>;
  employment_experiences_aggregate?: Maybe<employment_experience_aggregate_order_by>;
  firstName?: Maybe<order_by>;
  gender?: Maybe<order_by>;
  id?: Maybe<order_by>;
  inquirerContactNo?: Maybe<order_by>;
  inquirerEmail?: Maybe<order_by>;
  inquirerName?: Maybe<order_by>;
  inquiryNumber?: Maybe<order_by>;
  inquiryType?: Maybe<order_by>;
  inquiry_status?: Maybe<inquiry_status_enum_order_by>;
  intake?: Maybe<intake_order_by>;
  intakeId?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  parentOrGuardianLandLineNo?: Maybe<order_by>;
  parentOrGuardianMobileNo?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  referredVia?: Maybe<order_by>;
  status?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentEmail?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  student_registered?: Maybe<student_order_by>;
  updatedAt?: Maybe<order_by>;
  user?: Maybe<user_order_by>;
  whatsapp_number?: Maybe<order_by>;
  willingToMigrate?: Maybe<order_by>;
};

/** primary key columns input for table: inquiry */
export type inquiry_pk_columns_input = {
  id: Scalars['Int'];
};

/** select columns of table "inquiry" */
export enum inquiry_select_column {
  /** column name */
  assignedUserId = 'assignedUserId',
  /** column name */
  city = 'city',
  /** column name */
  courseId = 'courseId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  date = 'date',
  /** column name */
  dateOfBirth = 'dateOfBirth',
  /** column name */
  firstName = 'firstName',
  /** column name */
  gender = 'gender',
  /** column name */
  id = 'id',
  /** column name */
  inquirerContactNo = 'inquirerContactNo',
  /** column name */
  inquirerEmail = 'inquirerEmail',
  /** column name */
  inquirerName = 'inquirerName',
  /** column name */
  inquiryNumber = 'inquiryNumber',
  /** column name */
  inquiryType = 'inquiryType',
  /** column name */
  intakeId = 'intakeId',
  /** column name */
  landLineNo = 'landLineNo',
  /** column name */
  lastName = 'lastName',
  /** column name */
  middleName = 'middleName',
  /** column name */
  mobileNo = 'mobileNo',
  /** column name */
  parentOrGuardianLandLineNo = 'parentOrGuardianLandLineNo',
  /** column name */
  parentOrGuardianMobileNo = 'parentOrGuardianMobileNo',
  /** column name */
  preferredYear = 'preferredYear',
  /** column name */
  referredVia = 'referredVia',
  /** column name */
  status = 'status',
  /** column name */
  studentEmail = 'studentEmail',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  whatsapp_number = 'whatsapp_number',
  /** column name */
  willingToMigrate = 'willingToMigrate',
}

/** input type for updating data in table "inquiry" */
export type inquiry_set_input = {
  assignedUserId?: Maybe<Scalars['uuid']>;
  city?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  date?: Maybe<Scalars['timestamp']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['inquiry_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  inquirerContactNo?: Maybe<Scalars['String']>;
  inquirerEmail?: Maybe<Scalars['String']>;
  inquirerName?: Maybe<Scalars['String']>;
  inquiryNumber?: Maybe<Scalars['String']>;
  inquiryType?: Maybe<Scalars['inquiry_inquirytype_enum']>;
  intakeId?: Maybe<Scalars['uuid']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  preferredYear?: Maybe<Scalars['Int']>;
  referredVia?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentEmail?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  whatsapp_number?: Maybe<Scalars['String']>;
  willingToMigrate?: Maybe<Scalars['Boolean']>;
};

/** columns and relationships of "inquiry_status_enum" */
export type inquiry_status_enum = {
  __typename?: 'inquiry_status_enum';
  /** An array relationship */
  inquiry: Array<inquiry>;
  /** An aggregate relationship */
  inquiry_aggregate: inquiry_aggregate;
  name: Scalars['String'];
};

/** columns and relationships of "inquiry_status_enum" */
export type inquiry_status_enuminquiryArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

/** columns and relationships of "inquiry_status_enum" */
export type inquiry_status_enuminquiry_aggregateArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

/** aggregated selection of "inquiry_status_enum" */
export type inquiry_status_enum_aggregate = {
  __typename?: 'inquiry_status_enum_aggregate';
  aggregate?: Maybe<inquiry_status_enum_aggregate_fields>;
  nodes: Array<inquiry_status_enum>;
};

/** aggregate fields of "inquiry_status_enum" */
export type inquiry_status_enum_aggregate_fields = {
  __typename?: 'inquiry_status_enum_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<inquiry_status_enum_max_fields>;
  min?: Maybe<inquiry_status_enum_min_fields>;
};

/** aggregate fields of "inquiry_status_enum" */
export type inquiry_status_enum_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<inquiry_status_enum_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "inquiry_status_enum". All fields are combined with a logical 'AND'. */
export type inquiry_status_enum_bool_exp = {
  _and?: Maybe<Array<inquiry_status_enum_bool_exp>>;
  _not?: Maybe<inquiry_status_enum_bool_exp>;
  _or?: Maybe<Array<inquiry_status_enum_bool_exp>>;
  inquiry?: Maybe<inquiry_bool_exp>;
  name?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "inquiry_status_enum" */
export enum inquiry_status_enum_constraint {
  /** unique or primary key constraint */
  inquiry_status_enum_pkey = 'inquiry_status_enum_pkey',
}

/** input type for inserting data into table "inquiry_status_enum" */
export type inquiry_status_enum_insert_input = {
  inquiry?: Maybe<inquiry_arr_rel_insert_input>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type inquiry_status_enum_max_fields = {
  __typename?: 'inquiry_status_enum_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type inquiry_status_enum_min_fields = {
  __typename?: 'inquiry_status_enum_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "inquiry_status_enum" */
export type inquiry_status_enum_mutation_response = {
  __typename?: 'inquiry_status_enum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<inquiry_status_enum>;
};

/** input type for inserting object relation for remote table "inquiry_status_enum" */
export type inquiry_status_enum_obj_rel_insert_input = {
  data: inquiry_status_enum_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<inquiry_status_enum_on_conflict>;
};

/** on conflict condition type for table "inquiry_status_enum" */
export type inquiry_status_enum_on_conflict = {
  constraint: inquiry_status_enum_constraint;
  update_columns?: Array<inquiry_status_enum_update_column>;
  where?: Maybe<inquiry_status_enum_bool_exp>;
};

/** Ordering options when selecting data from "inquiry_status_enum". */
export type inquiry_status_enum_order_by = {
  inquiry_aggregate?: Maybe<inquiry_aggregate_order_by>;
  name?: Maybe<order_by>;
};

/** primary key columns input for table: inquiry_status_enum */
export type inquiry_status_enum_pk_columns_input = {
  name: Scalars['String'];
};

/** select columns of table "inquiry_status_enum" */
export enum inquiry_status_enum_select_column {
  /** column name */
  name = 'name',
}

/** input type for updating data in table "inquiry_status_enum" */
export type inquiry_status_enum_set_input = {
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "inquiry_status_enum" */
export enum inquiry_status_enum_update_column {
  /** column name */
  name = 'name',
}

/** aggregate stddev on columns */
export type inquiry_stddev_fields = {
  __typename?: 'inquiry_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  preferredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "inquiry" */
export type inquiry_stddev_order_by = {
  id?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type inquiry_stddev_pop_fields = {
  __typename?: 'inquiry_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  preferredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "inquiry" */
export type inquiry_stddev_pop_order_by = {
  id?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type inquiry_stddev_samp_fields = {
  __typename?: 'inquiry_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  preferredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "inquiry" */
export type inquiry_stddev_samp_order_by = {
  id?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type inquiry_sum_fields = {
  __typename?: 'inquiry_sum_fields';
  id?: Maybe<Scalars['Int']>;
  preferredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "inquiry" */
export type inquiry_sum_order_by = {
  id?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** update columns of table "inquiry" */
export enum inquiry_update_column {
  /** column name */
  assignedUserId = 'assignedUserId',
  /** column name */
  city = 'city',
  /** column name */
  courseId = 'courseId',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  date = 'date',
  /** column name */
  dateOfBirth = 'dateOfBirth',
  /** column name */
  firstName = 'firstName',
  /** column name */
  gender = 'gender',
  /** column name */
  id = 'id',
  /** column name */
  inquirerContactNo = 'inquirerContactNo',
  /** column name */
  inquirerEmail = 'inquirerEmail',
  /** column name */
  inquirerName = 'inquirerName',
  /** column name */
  inquiryNumber = 'inquiryNumber',
  /** column name */
  inquiryType = 'inquiryType',
  /** column name */
  intakeId = 'intakeId',
  /** column name */
  landLineNo = 'landLineNo',
  /** column name */
  lastName = 'lastName',
  /** column name */
  middleName = 'middleName',
  /** column name */
  mobileNo = 'mobileNo',
  /** column name */
  parentOrGuardianLandLineNo = 'parentOrGuardianLandLineNo',
  /** column name */
  parentOrGuardianMobileNo = 'parentOrGuardianMobileNo',
  /** column name */
  preferredYear = 'preferredYear',
  /** column name */
  referredVia = 'referredVia',
  /** column name */
  status = 'status',
  /** column name */
  studentEmail = 'studentEmail',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  whatsapp_number = 'whatsapp_number',
  /** column name */
  willingToMigrate = 'willingToMigrate',
}

/** aggregate var_pop on columns */
export type inquiry_var_pop_fields = {
  __typename?: 'inquiry_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  preferredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "inquiry" */
export type inquiry_var_pop_order_by = {
  id?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type inquiry_var_samp_fields = {
  __typename?: 'inquiry_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  preferredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "inquiry" */
export type inquiry_var_samp_order_by = {
  id?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type inquiry_variance_fields = {
  __typename?: 'inquiry_variance_fields';
  id?: Maybe<Scalars['Float']>;
  preferredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "inquiry" */
export type inquiry_variance_order_by = {
  id?: Maybe<order_by>;
  preferredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** columns and relationships of "intake" */
export type intake = {
  __typename?: 'intake';
  /** An array relationship */
  batches: Array<batch>;
  /** An aggregate relationship */
  batches_aggregate: batch_aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  inquiries: Array<inquiry>;
  /** An aggregate relationship */
  inquiries_aggregate: inquiry_aggregate;
  month: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  student_courses: Array<student_course>;
  /** An aggregate relationship */
  student_courses_aggregate: student_course_aggregate;
};

/** columns and relationships of "intake" */
export type intakebatchesArgs = {
  distinct_on?: Maybe<Array<batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_order_by>>;
  where?: Maybe<batch_bool_exp>;
};

/** columns and relationships of "intake" */
export type intakebatches_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_order_by>>;
  where?: Maybe<batch_bool_exp>;
};

/** columns and relationships of "intake" */
export type intakeinquiriesArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

/** columns and relationships of "intake" */
export type intakeinquiries_aggregateArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

/** columns and relationships of "intake" */
export type intakestudent_coursesArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** columns and relationships of "intake" */
export type intakestudent_courses_aggregateArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** aggregated selection of "intake" */
export type intake_aggregate = {
  __typename?: 'intake_aggregate';
  aggregate?: Maybe<intake_aggregate_fields>;
  nodes: Array<intake>;
};

/** aggregate fields of "intake" */
export type intake_aggregate_fields = {
  __typename?: 'intake_aggregate_fields';
  avg?: Maybe<intake_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<intake_max_fields>;
  min?: Maybe<intake_min_fields>;
  stddev?: Maybe<intake_stddev_fields>;
  stddev_pop?: Maybe<intake_stddev_pop_fields>;
  stddev_samp?: Maybe<intake_stddev_samp_fields>;
  sum?: Maybe<intake_sum_fields>;
  var_pop?: Maybe<intake_var_pop_fields>;
  var_samp?: Maybe<intake_var_samp_fields>;
  variance?: Maybe<intake_variance_fields>;
};

/** aggregate fields of "intake" */
export type intake_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<intake_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type intake_avg_fields = {
  __typename?: 'intake_avg_fields';
  month?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "intake". All fields are combined with a logical 'AND'. */
export type intake_bool_exp = {
  _and?: Maybe<Array<intake_bool_exp>>;
  _not?: Maybe<intake_bool_exp>;
  _or?: Maybe<Array<intake_bool_exp>>;
  batches?: Maybe<batch_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  inquiries?: Maybe<inquiry_bool_exp>;
  month?: Maybe<Int_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  student_courses?: Maybe<student_course_bool_exp>;
};

/** unique or primary key constraints on table "intake" */
export enum intake_constraint {
  /** unique or primary key constraint */
  PK_ca09c74600819624d88bf60b6fe = 'PK_ca09c74600819624d88bf60b6fe',
  /** unique or primary key constraint */
  intake_name_key = 'intake_name_key',
}

/** input type for incrementing numeric columns in table "intake" */
export type intake_inc_input = {
  month?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "intake" */
export type intake_insert_input = {
  batches?: Maybe<batch_arr_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  inquiries?: Maybe<inquiry_arr_rel_insert_input>;
  month?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  student_courses?: Maybe<student_course_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type intake_max_fields = {
  __typename?: 'intake_max_fields';
  id?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type intake_min_fields = {
  __typename?: 'intake_min_fields';
  id?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "intake" */
export type intake_mutation_response = {
  __typename?: 'intake_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<intake>;
};

/** input type for inserting object relation for remote table "intake" */
export type intake_obj_rel_insert_input = {
  data: intake_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<intake_on_conflict>;
};

/** on conflict condition type for table "intake" */
export type intake_on_conflict = {
  constraint: intake_constraint;
  update_columns?: Array<intake_update_column>;
  where?: Maybe<intake_bool_exp>;
};

/** Ordering options when selecting data from "intake". */
export type intake_order_by = {
  batches_aggregate?: Maybe<batch_aggregate_order_by>;
  id?: Maybe<order_by>;
  inquiries_aggregate?: Maybe<inquiry_aggregate_order_by>;
  month?: Maybe<order_by>;
  name?: Maybe<order_by>;
  student_courses_aggregate?: Maybe<student_course_aggregate_order_by>;
};

/** primary key columns input for table: intake */
export type intake_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "intake" */
export enum intake_select_column {
  /** column name */
  id = 'id',
  /** column name */
  month = 'month',
  /** column name */
  name = 'name',
}

/** input type for updating data in table "intake" */
export type intake_set_input = {
  id?: Maybe<Scalars['uuid']>;
  month?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type intake_stddev_fields = {
  __typename?: 'intake_stddev_fields';
  month?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type intake_stddev_pop_fields = {
  __typename?: 'intake_stddev_pop_fields';
  month?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type intake_stddev_samp_fields = {
  __typename?: 'intake_stddev_samp_fields';
  month?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type intake_sum_fields = {
  __typename?: 'intake_sum_fields';
  month?: Maybe<Scalars['Int']>;
};

/** update columns of table "intake" */
export enum intake_update_column {
  /** column name */
  id = 'id',
  /** column name */
  month = 'month',
  /** column name */
  name = 'name',
}

/** aggregate var_pop on columns */
export type intake_var_pop_fields = {
  __typename?: 'intake_var_pop_fields';
  month?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type intake_var_samp_fields = {
  __typename?: 'intake_var_samp_fields';
  month?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type intake_variance_fields = {
  __typename?: 'intake_variance_fields';
  month?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "lecture_material" */
export type lecture_material = {
  __typename?: 'lecture_material';
  attachments?: Maybe<Scalars['String']>;
  batchSubjectConfigurationId: Scalars['uuid'];
  /** An object relationship */
  batch_subject_configuration: batch_subject_configuration;
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  lectureMaterialCategoryId: Scalars['uuid'];
  /** An object relationship */
  lecture_material_category: lecture_material_category;
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: user;
  userFirebaseUID: Scalars['String'];
};

/** aggregated selection of "lecture_material" */
export type lecture_material_aggregate = {
  __typename?: 'lecture_material_aggregate';
  aggregate?: Maybe<lecture_material_aggregate_fields>;
  nodes: Array<lecture_material>;
};

/** aggregate fields of "lecture_material" */
export type lecture_material_aggregate_fields = {
  __typename?: 'lecture_material_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<lecture_material_max_fields>;
  min?: Maybe<lecture_material_min_fields>;
};

/** aggregate fields of "lecture_material" */
export type lecture_material_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<lecture_material_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "lecture_material" */
export type lecture_material_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<lecture_material_max_order_by>;
  min?: Maybe<lecture_material_min_order_by>;
};

/** input type for inserting array relation for remote table "lecture_material" */
export type lecture_material_arr_rel_insert_input = {
  data: Array<lecture_material_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<lecture_material_on_conflict>;
};

/** Boolean expression to filter rows from the table "lecture_material". All fields are combined with a logical 'AND'. */
export type lecture_material_bool_exp = {
  _and?: Maybe<Array<lecture_material_bool_exp>>;
  _not?: Maybe<lecture_material_bool_exp>;
  _or?: Maybe<Array<lecture_material_bool_exp>>;
  attachments?: Maybe<String_comparison_exp>;
  batchSubjectConfigurationId?: Maybe<uuid_comparison_exp>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_bool_exp>;
  content?: Maybe<String_comparison_exp>;
  created_at?: Maybe<timestamptz_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  lectureMaterialCategoryId?: Maybe<uuid_comparison_exp>;
  lecture_material_category?: Maybe<lecture_material_category_bool_exp>;
  title?: Maybe<String_comparison_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
  user?: Maybe<user_bool_exp>;
  userFirebaseUID?: Maybe<String_comparison_exp>;
};

/** columns and relationships of "lecture_material_category" */
export type lecture_material_category = {
  __typename?: 'lecture_material_category';
  id: Scalars['uuid'];
  /** An array relationship */
  lecture_materials: Array<lecture_material>;
  /** An aggregate relationship */
  lecture_materials_aggregate: lecture_material_aggregate;
  name: Scalars['String'];
};

/** columns and relationships of "lecture_material_category" */
export type lecture_material_categorylecture_materialsArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

/** columns and relationships of "lecture_material_category" */
export type lecture_material_categorylecture_materials_aggregateArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

/** aggregated selection of "lecture_material_category" */
export type lecture_material_category_aggregate = {
  __typename?: 'lecture_material_category_aggregate';
  aggregate?: Maybe<lecture_material_category_aggregate_fields>;
  nodes: Array<lecture_material_category>;
};

/** aggregate fields of "lecture_material_category" */
export type lecture_material_category_aggregate_fields = {
  __typename?: 'lecture_material_category_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<lecture_material_category_max_fields>;
  min?: Maybe<lecture_material_category_min_fields>;
};

/** aggregate fields of "lecture_material_category" */
export type lecture_material_category_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<lecture_material_category_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lecture_material_category". All fields are combined with a logical 'AND'. */
export type lecture_material_category_bool_exp = {
  _and?: Maybe<Array<lecture_material_category_bool_exp>>;
  _not?: Maybe<lecture_material_category_bool_exp>;
  _or?: Maybe<Array<lecture_material_category_bool_exp>>;
  id?: Maybe<uuid_comparison_exp>;
  lecture_materials?: Maybe<lecture_material_bool_exp>;
  name?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "lecture_material_category" */
export enum lecture_material_category_constraint {
  /** unique or primary key constraint */
  lecture_material_category_pkey = 'lecture_material_category_pkey',
}

/** input type for inserting data into table "lecture_material_category" */
export type lecture_material_category_insert_input = {
  id?: Maybe<Scalars['uuid']>;
  lecture_materials?: Maybe<lecture_material_arr_rel_insert_input>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type lecture_material_category_max_fields = {
  __typename?: 'lecture_material_category_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type lecture_material_category_min_fields = {
  __typename?: 'lecture_material_category_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "lecture_material_category" */
export type lecture_material_category_mutation_response = {
  __typename?: 'lecture_material_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<lecture_material_category>;
};

/** input type for inserting object relation for remote table "lecture_material_category" */
export type lecture_material_category_obj_rel_insert_input = {
  data: lecture_material_category_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<lecture_material_category_on_conflict>;
};

/** on conflict condition type for table "lecture_material_category" */
export type lecture_material_category_on_conflict = {
  constraint: lecture_material_category_constraint;
  update_columns?: Array<lecture_material_category_update_column>;
  where?: Maybe<lecture_material_category_bool_exp>;
};

/** Ordering options when selecting data from "lecture_material_category". */
export type lecture_material_category_order_by = {
  id?: Maybe<order_by>;
  lecture_materials_aggregate?: Maybe<lecture_material_aggregate_order_by>;
  name?: Maybe<order_by>;
};

/** primary key columns input for table: lecture_material_category */
export type lecture_material_category_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "lecture_material_category" */
export enum lecture_material_category_select_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** input type for updating data in table "lecture_material_category" */
export type lecture_material_category_set_input = {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "lecture_material_category" */
export enum lecture_material_category_update_column {
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** unique or primary key constraints on table "lecture_material" */
export enum lecture_material_constraint {
  /** unique or primary key constraint */
  lecture_material_pkey = 'lecture_material_pkey',
}

/** input type for inserting data into table "lecture_material" */
export type lecture_material_insert_input = {
  attachments?: Maybe<Scalars['String']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_obj_rel_insert_input>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lectureMaterialCategoryId?: Maybe<Scalars['uuid']>;
  lecture_material_category?: Maybe<lecture_material_category_obj_rel_insert_input>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<user_obj_rel_insert_input>;
  userFirebaseUID?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type lecture_material_max_fields = {
  __typename?: 'lecture_material_max_fields';
  attachments?: Maybe<Scalars['String']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lectureMaterialCategoryId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userFirebaseUID?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "lecture_material" */
export type lecture_material_max_order_by = {
  attachments?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  content?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lectureMaterialCategoryId?: Maybe<order_by>;
  title?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  userFirebaseUID?: Maybe<order_by>;
};

/** aggregate min on columns */
export type lecture_material_min_fields = {
  __typename?: 'lecture_material_min_fields';
  attachments?: Maybe<Scalars['String']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lectureMaterialCategoryId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userFirebaseUID?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "lecture_material" */
export type lecture_material_min_order_by = {
  attachments?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  content?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lectureMaterialCategoryId?: Maybe<order_by>;
  title?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  userFirebaseUID?: Maybe<order_by>;
};

/** response of any mutation on the table "lecture_material" */
export type lecture_material_mutation_response = {
  __typename?: 'lecture_material_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<lecture_material>;
};

/** on conflict condition type for table "lecture_material" */
export type lecture_material_on_conflict = {
  constraint: lecture_material_constraint;
  update_columns?: Array<lecture_material_update_column>;
  where?: Maybe<lecture_material_bool_exp>;
};

/** Ordering options when selecting data from "lecture_material". */
export type lecture_material_order_by = {
  attachments?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_order_by>;
  content?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lectureMaterialCategoryId?: Maybe<order_by>;
  lecture_material_category?: Maybe<lecture_material_category_order_by>;
  title?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  user?: Maybe<user_order_by>;
  userFirebaseUID?: Maybe<order_by>;
};

/** primary key columns input for table: lecture_material */
export type lecture_material_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "lecture_material" */
export enum lecture_material_select_column {
  /** column name */
  attachments = 'attachments',
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  content = 'content',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  lectureMaterialCategoryId = 'lectureMaterialCategoryId',
  /** column name */
  title = 'title',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  userFirebaseUID = 'userFirebaseUID',
}

/** input type for updating data in table "lecture_material" */
export type lecture_material_set_input = {
  attachments?: Maybe<Scalars['String']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lectureMaterialCategoryId?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userFirebaseUID?: Maybe<Scalars['String']>;
};

/** update columns of table "lecture_material" */
export enum lecture_material_update_column {
  /** column name */
  attachments = 'attachments',
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  content = 'content',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  lectureMaterialCategoryId = 'lectureMaterialCategoryId',
  /** column name */
  title = 'title',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  userFirebaseUID = 'userFirebaseUID',
}

/** columns and relationships of "lecturer" */
export type lecturer = {
  __typename?: 'lecturer';
  active?: Maybe<Scalars['Boolean']>;
  employeeID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  /** An array relationship */
  subject_to_users: Array<subject_to_user>;
  /** An aggregate relationship */
  subject_to_users_aggregate: subject_to_user_aggregate;
  /** An array relationship */
  timetable_items: Array<timetable_item>;
  /** An aggregate relationship */
  timetable_items_aggregate: timetable_item_aggregate;
};

/** columns and relationships of "lecturer" */
export type lecturersubject_to_usersArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

/** columns and relationships of "lecturer" */
export type lecturersubject_to_users_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

/** columns and relationships of "lecturer" */
export type lecturertimetable_itemsArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** columns and relationships of "lecturer" */
export type lecturertimetable_items_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** aggregated selection of "lecturer" */
export type lecturer_aggregate = {
  __typename?: 'lecturer_aggregate';
  aggregate?: Maybe<lecturer_aggregate_fields>;
  nodes: Array<lecturer>;
};

/** aggregate fields of "lecturer" */
export type lecturer_aggregate_fields = {
  __typename?: 'lecturer_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<lecturer_max_fields>;
  min?: Maybe<lecturer_min_fields>;
};

/** aggregate fields of "lecturer" */
export type lecturer_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<lecturer_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "lecturer". All fields are combined with a logical 'AND'. */
export type lecturer_bool_exp = {
  _and?: Maybe<Array<lecturer_bool_exp>>;
  _not?: Maybe<lecturer_bool_exp>;
  _or?: Maybe<Array<lecturer_bool_exp>>;
  active?: Maybe<Boolean_comparison_exp>;
  employeeID?: Maybe<String_comparison_exp>;
  firstName?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  subject_to_users?: Maybe<subject_to_user_bool_exp>;
  timetable_items?: Maybe<timetable_item_bool_exp>;
};

/** aggregate max on columns */
export type lecturer_max_fields = {
  __typename?: 'lecturer_max_fields';
  employeeID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type lecturer_min_fields = {
  __typename?: 'lecturer_min_fields';
  employeeID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "lecturer". */
export type lecturer_order_by = {
  active?: Maybe<order_by>;
  employeeID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  subject_to_users_aggregate?: Maybe<subject_to_user_aggregate_order_by>;
  timetable_items_aggregate?: Maybe<timetable_item_aggregate_order_by>;
};

/** select columns of table "lecturer" */
export enum lecturer_select_column {
  /** column name */
  active = 'active',
  /** column name */
  employeeID = 'employeeID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastName = 'lastName',
}

/** columns and relationships of "location" */
export type location = {
  __typename?: 'location';
  color: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  timetable_items: Array<timetable_item>;
  /** An aggregate relationship */
  timetable_items_aggregate: timetable_item_aggregate;
};

/** columns and relationships of "location" */
export type locationtimetable_itemsArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** columns and relationships of "location" */
export type locationtimetable_items_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** aggregated selection of "location" */
export type location_aggregate = {
  __typename?: 'location_aggregate';
  aggregate?: Maybe<location_aggregate_fields>;
  nodes: Array<location>;
};

/** aggregate fields of "location" */
export type location_aggregate_fields = {
  __typename?: 'location_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<location_max_fields>;
  min?: Maybe<location_min_fields>;
};

/** aggregate fields of "location" */
export type location_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<location_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "location". All fields are combined with a logical 'AND'. */
export type location_bool_exp = {
  _and?: Maybe<Array<location_bool_exp>>;
  _not?: Maybe<location_bool_exp>;
  _or?: Maybe<Array<location_bool_exp>>;
  color?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  timetable_items?: Maybe<timetable_item_bool_exp>;
};

/** unique or primary key constraints on table "location" */
export enum location_constraint {
  /** unique or primary key constraint */
  PK_876d7bdba03c72251ec4c2dc827 = 'PK_876d7bdba03c72251ec4c2dc827',
  /** unique or primary key constraint */
  location_name_key = 'location_name_key',
}

/** input type for inserting data into table "location" */
export type location_insert_input = {
  color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  timetable_items?: Maybe<timetable_item_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type location_max_fields = {
  __typename?: 'location_max_fields';
  color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type location_min_fields = {
  __typename?: 'location_min_fields';
  color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "location" */
export type location_mutation_response = {
  __typename?: 'location_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<location>;
};

/** input type for inserting object relation for remote table "location" */
export type location_obj_rel_insert_input = {
  data: location_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<location_on_conflict>;
};

/** on conflict condition type for table "location" */
export type location_on_conflict = {
  constraint: location_constraint;
  update_columns?: Array<location_update_column>;
  where?: Maybe<location_bool_exp>;
};

/** Ordering options when selecting data from "location". */
export type location_order_by = {
  color?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  timetable_items_aggregate?: Maybe<timetable_item_aggregate_order_by>;
};

/** primary key columns input for table: location */
export type location_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "location" */
export enum location_select_column {
  /** column name */
  color = 'color',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** input type for updating data in table "location" */
export type location_set_input = {
  color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "location" */
export enum location_update_column {
  /** column name */
  color = 'color',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
}

/** columns and relationships of "multi_choice_question" */
export type multi_choice_question = {
  __typename?: 'multi_choice_question';
  exitInterviewQuestionId: Scalars['uuid'];
  /** An array relationship */
  exit_interview_answer_multi_choice_questions: Array<exit_interview_answer_multi_choice_questions>;
  /** An aggregate relationship */
  exit_interview_answer_multi_choice_questions_aggregate: exit_interview_answer_multi_choice_questions_aggregate;
  /** An object relationship */
  exit_interview_question: exit_interview_question;
  id: Scalars['uuid'];
  question: Scalars['String'];
};

/** columns and relationships of "multi_choice_question" */
export type multi_choice_questionexit_interview_answer_multi_choice_questionsArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_multi_choice_questions_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_multi_choice_questions_order_by>>;
  where?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
};

/** columns and relationships of "multi_choice_question" */
export type multi_choice_questionexit_interview_answer_multi_choice_questions_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_multi_choice_questions_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_multi_choice_questions_order_by>>;
  where?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
};

/** aggregated selection of "multi_choice_question" */
export type multi_choice_question_aggregate = {
  __typename?: 'multi_choice_question_aggregate';
  aggregate?: Maybe<multi_choice_question_aggregate_fields>;
  nodes: Array<multi_choice_question>;
};

/** aggregate fields of "multi_choice_question" */
export type multi_choice_question_aggregate_fields = {
  __typename?: 'multi_choice_question_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<multi_choice_question_max_fields>;
  min?: Maybe<multi_choice_question_min_fields>;
};

/** aggregate fields of "multi_choice_question" */
export type multi_choice_question_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<multi_choice_question_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "multi_choice_question" */
export type multi_choice_question_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<multi_choice_question_max_order_by>;
  min?: Maybe<multi_choice_question_min_order_by>;
};

/** input type for inserting array relation for remote table "multi_choice_question" */
export type multi_choice_question_arr_rel_insert_input = {
  data: Array<multi_choice_question_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<multi_choice_question_on_conflict>;
};

/** Boolean expression to filter rows from the table "multi_choice_question". All fields are combined with a logical 'AND'. */
export type multi_choice_question_bool_exp = {
  _and?: Maybe<Array<multi_choice_question_bool_exp>>;
  _not?: Maybe<multi_choice_question_bool_exp>;
  _or?: Maybe<Array<multi_choice_question_bool_exp>>;
  exitInterviewQuestionId?: Maybe<uuid_comparison_exp>;
  exit_interview_answer_multi_choice_questions?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
  exit_interview_question?: Maybe<exit_interview_question_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  question?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "multi_choice_question" */
export enum multi_choice_question_constraint {
  /** unique or primary key constraint */
  multi_choice_question_pkey = 'multi_choice_question_pkey',
  /** unique or primary key constraint */
  multi_choice_question_question_exitInterviewQuestionId_key = 'multi_choice_question_question_exitInterviewQuestionId_key',
}

/** input type for inserting data into table "multi_choice_question" */
export type multi_choice_question_insert_input = {
  exitInterviewQuestionId?: Maybe<Scalars['uuid']>;
  exit_interview_answer_multi_choice_questions?: Maybe<exit_interview_answer_multi_choice_questions_arr_rel_insert_input>;
  exit_interview_question?: Maybe<exit_interview_question_obj_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type multi_choice_question_max_fields = {
  __typename?: 'multi_choice_question_max_fields';
  exitInterviewQuestionId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "multi_choice_question" */
export type multi_choice_question_max_order_by = {
  exitInterviewQuestionId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  question?: Maybe<order_by>;
};

/** aggregate min on columns */
export type multi_choice_question_min_fields = {
  __typename?: 'multi_choice_question_min_fields';
  exitInterviewQuestionId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "multi_choice_question" */
export type multi_choice_question_min_order_by = {
  exitInterviewQuestionId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  question?: Maybe<order_by>;
};

/** response of any mutation on the table "multi_choice_question" */
export type multi_choice_question_mutation_response = {
  __typename?: 'multi_choice_question_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<multi_choice_question>;
};

/** input type for inserting object relation for remote table "multi_choice_question" */
export type multi_choice_question_obj_rel_insert_input = {
  data: multi_choice_question_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<multi_choice_question_on_conflict>;
};

/** on conflict condition type for table "multi_choice_question" */
export type multi_choice_question_on_conflict = {
  constraint: multi_choice_question_constraint;
  update_columns?: Array<multi_choice_question_update_column>;
  where?: Maybe<multi_choice_question_bool_exp>;
};

/** Ordering options when selecting data from "multi_choice_question". */
export type multi_choice_question_order_by = {
  exitInterviewQuestionId?: Maybe<order_by>;
  exit_interview_answer_multi_choice_questions_aggregate?: Maybe<exit_interview_answer_multi_choice_questions_aggregate_order_by>;
  exit_interview_question?: Maybe<exit_interview_question_order_by>;
  id?: Maybe<order_by>;
  question?: Maybe<order_by>;
};

/** primary key columns input for table: multi_choice_question */
export type multi_choice_question_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "multi_choice_question" */
export enum multi_choice_question_select_column {
  /** column name */
  exitInterviewQuestionId = 'exitInterviewQuestionId',
  /** column name */
  id = 'id',
  /** column name */
  question = 'question',
}

/** input type for updating data in table "multi_choice_question" */
export type multi_choice_question_set_input = {
  exitInterviewQuestionId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
};

/** update columns of table "multi_choice_question" */
export enum multi_choice_question_update_column {
  /** column name */
  exitInterviewQuestionId = 'exitInterviewQuestionId',
  /** column name */
  id = 'id',
  /** column name */
  question = 'question',
}

/** mutation root */
export type mutation_root = {
  __typename?: 'mutation_root';
  actionName?: Maybe<SampleOutput>;
  approveDenyResultSheet: ApproveDenyResultSheetResult;
  createInquiry: CreateInquiryResult;
  createStudentAssessmentSubmission: CreateStudentAssessmentSubmissionResult;
  createStudentRequest: CreateRequestResult;
  createUser: CreateUserResult;
  /** delete data from the table: "academic_calendar_item" */
  delete_academic_calendar_item?: Maybe<academic_calendar_item_mutation_response>;
  /** delete single row from the table: "academic_calendar_item" */
  delete_academic_calendar_item_by_pk?: Maybe<academic_calendar_item>;
  /** delete data from the table: "active_batch" */
  delete_active_batch?: Maybe<active_batch_mutation_response>;
  /** delete data from the table: "assessment" */
  delete_assessment?: Maybe<assessment_mutation_response>;
  /** delete single row from the table: "assessment" */
  delete_assessment_by_pk?: Maybe<assessment>;
  /** delete data from the table: "attendance" */
  delete_attendance?: Maybe<attendance_mutation_response>;
  /** delete single row from the table: "attendance" */
  delete_attendance_by_pk?: Maybe<attendance>;
  /** delete data from the table: "attendance_student" */
  delete_attendance_student?: Maybe<attendance_student_mutation_response>;
  /** delete single row from the table: "attendance_student" */
  delete_attendance_student_by_pk?: Maybe<attendance_student>;
  /** delete data from the table: "batch" */
  delete_batch?: Maybe<batch_mutation_response>;
  /** delete single row from the table: "batch" */
  delete_batch_by_pk?: Maybe<batch>;
  /** delete data from the table: "batch_class" */
  delete_batch_class?: Maybe<batch_class_mutation_response>;
  /** delete single row from the table: "batch_class" */
  delete_batch_class_by_pk?: Maybe<batch_class>;
  /** delete data from the table: "batch_subject_configuration" */
  delete_batch_subject_configuration?: Maybe<batch_subject_configuration_mutation_response>;
  /** delete single row from the table: "batch_subject_configuration" */
  delete_batch_subject_configuration_by_pk?: Maybe<batch_subject_configuration>;
  /** delete data from the table: "batch_subject_extra_slot" */
  delete_batch_subject_extra_slot?: Maybe<batch_subject_extra_slot_mutation_response>;
  /** delete single row from the table: "batch_subject_extra_slot" */
  delete_batch_subject_extra_slot_by_pk?: Maybe<batch_subject_extra_slot>;
  /** delete data from the table: "blood_type" */
  delete_blood_type?: Maybe<blood_type_mutation_response>;
  /** delete single row from the table: "blood_type" */
  delete_blood_type_by_pk?: Maybe<blood_type>;
  /** delete data from the table: "course" */
  delete_course?: Maybe<course_mutation_response>;
  /** delete single row from the table: "course" */
  delete_course_by_pk?: Maybe<course>;
  /** delete data from the table: "course_coordinator" */
  delete_course_coordinator?: Maybe<course_coordinator_mutation_response>;
  /** delete single row from the table: "course_coordinator" */
  delete_course_coordinator_by_pk?: Maybe<course_coordinator>;
  /** delete data from the table: "course_level" */
  delete_course_level?: Maybe<course_level_mutation_response>;
  /** delete single row from the table: "course_level" */
  delete_course_level_by_pk?: Maybe<course_level>;
  /** delete data from the table: "course_semester" */
  delete_course_semester?: Maybe<course_semester_mutation_response>;
  /** delete single row from the table: "course_semester" */
  delete_course_semester_by_pk?: Maybe<course_semester>;
  /** delete data from the table: "course_semester_subjects_subject" */
  delete_course_semester_subjects_subject?: Maybe<course_semester_subjects_subject_mutation_response>;
  /** delete single row from the table: "course_semester_subjects_subject" */
  delete_course_semester_subjects_subject_by_pk?: Maybe<course_semester_subjects_subject>;
  /** delete data from the table: "current_student" */
  delete_current_student?: Maybe<current_student_mutation_response>;
  /** delete data from the table: "current_student_course" */
  delete_current_student_course?: Maybe<current_student_course_mutation_response>;
  /** delete data from the table: "current_user" */
  delete_current_user?: Maybe<current_user_mutation_response>;
  /** delete data from the table: "current_user_route" */
  delete_current_user_route?: Maybe<current_user_route_mutation_response>;
  /** delete data from the table: "department" */
  delete_department?: Maybe<department_mutation_response>;
  /** delete single row from the table: "department" */
  delete_department_by_pk?: Maybe<department>;
  /** delete data from the table: "education_qualification" */
  delete_education_qualification?: Maybe<education_qualification_mutation_response>;
  /** delete single row from the table: "education_qualification" */
  delete_education_qualification_by_pk?: Maybe<education_qualification>;
  /** delete data from the table: "employment_experience" */
  delete_employment_experience?: Maybe<employment_experience_mutation_response>;
  /** delete single row from the table: "employment_experience" */
  delete_employment_experience_by_pk?: Maybe<employment_experience>;
  /** delete data from the table: "endpoint" */
  delete_endpoint?: Maybe<endpoint_mutation_response>;
  /** delete single row from the table: "endpoint" */
  delete_endpoint_by_pk?: Maybe<endpoint>;
  /** delete data from the table: "exit_interview_answer" */
  delete_exit_interview_answer?: Maybe<exit_interview_answer_mutation_response>;
  /** delete single row from the table: "exit_interview_answer" */
  delete_exit_interview_answer_by_pk?: Maybe<exit_interview_answer>;
  /** delete data from the table: "exit_interview_answer_multi_choice_questions" */
  delete_exit_interview_answer_multi_choice_questions?: Maybe<exit_interview_answer_multi_choice_questions_mutation_response>;
  /** delete single row from the table: "exit_interview_answer_multi_choice_questions" */
  delete_exit_interview_answer_multi_choice_questions_by_pk?: Maybe<exit_interview_answer_multi_choice_questions>;
  /** delete data from the table: "exit_interview_question" */
  delete_exit_interview_question?: Maybe<exit_interview_question_mutation_response>;
  /** delete data from the table: "exit_interview_question_answers" */
  delete_exit_interview_question_answers?: Maybe<exit_interview_question_answers_mutation_response>;
  /** delete single row from the table: "exit_interview_question_answers" */
  delete_exit_interview_question_answers_by_pk?: Maybe<exit_interview_question_answers>;
  /** delete single row from the table: "exit_interview_question" */
  delete_exit_interview_question_by_pk?: Maybe<exit_interview_question>;
  /** delete data from the table: "exit_interview_question_group" */
  delete_exit_interview_question_group?: Maybe<exit_interview_question_group_mutation_response>;
  /** delete single row from the table: "exit_interview_question_group" */
  delete_exit_interview_question_group_by_pk?: Maybe<exit_interview_question_group>;
  /** delete data from the table: "inquiry" */
  delete_inquiry?: Maybe<inquiry_mutation_response>;
  /** delete single row from the table: "inquiry" */
  delete_inquiry_by_pk?: Maybe<inquiry>;
  /** delete data from the table: "inquiry_status_enum" */
  delete_inquiry_status_enum?: Maybe<inquiry_status_enum_mutation_response>;
  /** delete single row from the table: "inquiry_status_enum" */
  delete_inquiry_status_enum_by_pk?: Maybe<inquiry_status_enum>;
  /** delete data from the table: "intake" */
  delete_intake?: Maybe<intake_mutation_response>;
  /** delete single row from the table: "intake" */
  delete_intake_by_pk?: Maybe<intake>;
  /** delete data from the table: "lecture_material" */
  delete_lecture_material?: Maybe<lecture_material_mutation_response>;
  /** delete single row from the table: "lecture_material" */
  delete_lecture_material_by_pk?: Maybe<lecture_material>;
  /** delete data from the table: "lecture_material_category" */
  delete_lecture_material_category?: Maybe<lecture_material_category_mutation_response>;
  /** delete single row from the table: "lecture_material_category" */
  delete_lecture_material_category_by_pk?: Maybe<lecture_material_category>;
  /** delete data from the table: "location" */
  delete_location?: Maybe<location_mutation_response>;
  /** delete single row from the table: "location" */
  delete_location_by_pk?: Maybe<location>;
  /** delete data from the table: "multi_choice_question" */
  delete_multi_choice_question?: Maybe<multi_choice_question_mutation_response>;
  /** delete single row from the table: "multi_choice_question" */
  delete_multi_choice_question_by_pk?: Maybe<multi_choice_question>;
  /** delete data from the table: "perfomance_status" */
  delete_perfomance_status?: Maybe<perfomance_status_mutation_response>;
  /** delete single row from the table: "perfomance_status" */
  delete_perfomance_status_by_pk?: Maybe<perfomance_status>;
  /** delete data from the table: "question_type" */
  delete_question_type?: Maybe<question_type_mutation_response>;
  /** delete single row from the table: "question_type" */
  delete_question_type_by_pk?: Maybe<question_type>;
  /** delete data from the table: "result_sheet" */
  delete_result_sheet?: Maybe<result_sheet_mutation_response>;
  /** delete single row from the table: "result_sheet" */
  delete_result_sheet_by_pk?: Maybe<result_sheet>;
  /** delete data from the table: "result_sheet_status" */
  delete_result_sheet_status?: Maybe<result_sheet_status_mutation_response>;
  /** delete single row from the table: "result_sheet_status" */
  delete_result_sheet_status_by_pk?: Maybe<result_sheet_status>;
  /** delete data from the table: "route" */
  delete_route?: Maybe<route_mutation_response>;
  /** delete single row from the table: "route" */
  delete_route_by_pk?: Maybe<route>;
  /** delete data from the table: "route_endpoints_endpoint" */
  delete_route_endpoints_endpoint?: Maybe<route_endpoints_endpoint_mutation_response>;
  /** delete single row from the table: "route_endpoints_endpoint" */
  delete_route_endpoints_endpoint_by_pk?: Maybe<route_endpoints_endpoint>;
  /** delete data from the table: "student" */
  delete_student?: Maybe<student_mutation_response>;
  /** delete data from the table: "student_admin_editable_information" */
  delete_student_admin_editable_information?: Maybe<student_admin_editable_information_mutation_response>;
  /** delete data from the table: "student_assessment_submission" */
  delete_student_assessment_submission?: Maybe<student_assessment_submission_mutation_response>;
  /** delete single row from the table: "student_assessment_submission" */
  delete_student_assessment_submission_by_pk?: Maybe<student_assessment_submission>;
  /** delete data from the table: "student_attendance_status" */
  delete_student_attendance_status?: Maybe<student_attendance_status_mutation_response>;
  /** delete single row from the table: "student_attendance_status" */
  delete_student_attendance_status_by_pk?: Maybe<student_attendance_status>;
  /** delete data from the table: "student_batch_classes_batch_class" */
  delete_student_batch_classes_batch_class?: Maybe<student_batch_classes_batch_class_mutation_response>;
  /** delete single row from the table: "student_batch_classes_batch_class" */
  delete_student_batch_classes_batch_class_by_pk?: Maybe<student_batch_classes_batch_class>;
  /** delete data from the table: "student_batch_history" */
  delete_student_batch_history?: Maybe<student_batch_history_mutation_response>;
  /** delete single row from the table: "student_batch_history" */
  delete_student_batch_history_by_pk?: Maybe<student_batch_history>;
  /** delete data from the table: "student_batch_history_subject" */
  delete_student_batch_history_subject?: Maybe<student_batch_history_subject_mutation_response>;
  /** delete single row from the table: "student_batch_history_subject" */
  delete_student_batch_history_subject_by_pk?: Maybe<student_batch_history_subject>;
  /** delete single row from the table: "student" */
  delete_student_by_pk?: Maybe<student>;
  /** delete data from the table: "student_course" */
  delete_student_course?: Maybe<student_course_mutation_response>;
  /** delete single row from the table: "student_course" */
  delete_student_course_by_pk?: Maybe<student_course>;
  /** delete data from the table: "student_external_engagement_request" */
  delete_student_external_engagement_request?: Maybe<student_external_engagement_request_mutation_response>;
  /** delete single row from the table: "student_external_engagement_request" */
  delete_student_external_engagement_request_by_pk?: Maybe<student_external_engagement_request>;
  /** delete data from the table: "student_familiarization_form" */
  delete_student_familiarization_form?: Maybe<student_familiarization_form_mutation_response>;
  /** delete single row from the table: "student_familiarization_form" */
  delete_student_familiarization_form_by_pk?: Maybe<student_familiarization_form>;
  /** delete data from the table: "student_familiarization_interview" */
  delete_student_familiarization_interview?: Maybe<student_familiarization_interview_mutation_response>;
  /** delete single row from the table: "student_familiarization_interview" */
  delete_student_familiarization_interview_by_pk?: Maybe<student_familiarization_interview>;
  /** delete data from the table: "student_for_batch" */
  delete_student_for_batch?: Maybe<student_for_batch_mutation_response>;
  /** delete data from the table: "student_general_request" */
  delete_student_general_request?: Maybe<student_general_request_mutation_response>;
  /** delete single row from the table: "student_general_request" */
  delete_student_general_request_by_pk?: Maybe<student_general_request>;
  /** delete data from the table: "student_medical_request" */
  delete_student_medical_request?: Maybe<student_medical_request_mutation_response>;
  /** delete single row from the table: "student_medical_request" */
  delete_student_medical_request_by_pk?: Maybe<student_medical_request>;
  /** delete data from the table: "student_performance" */
  delete_student_performance?: Maybe<student_performance_mutation_response>;
  /** delete single row from the table: "student_performance" */
  delete_student_performance_by_pk?: Maybe<student_performance>;
  /** delete data from the table: "student_request" */
  delete_student_request?: Maybe<student_request_mutation_response>;
  /** delete single row from the table: "student_request" */
  delete_student_request_by_pk?: Maybe<student_request>;
  /** delete data from the table: "student_request_message" */
  delete_student_request_message?: Maybe<student_request_message_mutation_response>;
  /** delete single row from the table: "student_request_message" */
  delete_student_request_message_by_pk?: Maybe<student_request_message>;
  /** delete data from the table: "student_request_requestee" */
  delete_student_request_requestee?: Maybe<student_request_requestee_mutation_response>;
  /** delete single row from the table: "student_request_requestee" */
  delete_student_request_requestee_by_pk?: Maybe<student_request_requestee>;
  /** delete data from the table: "student_request_status" */
  delete_student_request_status?: Maybe<student_request_status_mutation_response>;
  /** delete single row from the table: "student_request_status" */
  delete_student_request_status_by_pk?: Maybe<student_request_status>;
  /** delete data from the table: "student_result" */
  delete_student_result?: Maybe<student_result_mutation_response>;
  /** delete single row from the table: "student_result" */
  delete_student_result_by_pk?: Maybe<student_result>;
  /** delete data from the table: "student_result_sheet" */
  delete_student_result_sheet?: Maybe<student_result_sheet_mutation_response>;
  /** delete single row from the table: "student_result_sheet" */
  delete_student_result_sheet_by_pk?: Maybe<student_result_sheet>;
  /** delete data from the table: "student_self_editable_information" */
  delete_student_self_editable_information?: Maybe<student_self_editable_information_mutation_response>;
  /** delete data from the table: "student_status" */
  delete_student_status?: Maybe<student_status_mutation_response>;
  /** delete single row from the table: "student_status" */
  delete_student_status_by_pk?: Maybe<student_status>;
  /** delete data from the table: "subject" */
  delete_subject?: Maybe<subject_mutation_response>;
  /** delete single row from the table: "subject" */
  delete_subject_by_pk?: Maybe<subject>;
  /** delete data from the table: "subject_extra_slot" */
  delete_subject_extra_slot?: Maybe<subject_extra_slot_mutation_response>;
  /** delete single row from the table: "subject_extra_slot" */
  delete_subject_extra_slot_by_pk?: Maybe<subject_extra_slot>;
  /** delete data from the table: "subject_to_user" */
  delete_subject_to_user?: Maybe<subject_to_user_mutation_response>;
  /** delete single row from the table: "subject_to_user" */
  delete_subject_to_user_by_pk?: Maybe<subject_to_user>;
  /** delete data from the table: "timetable_item" */
  delete_timetable_item?: Maybe<timetable_item_mutation_response>;
  /** delete single row from the table: "timetable_item" */
  delete_timetable_item_by_pk?: Maybe<timetable_item>;
  /** delete data from the table: "timetable_timeslot_configuration" */
  delete_timetable_timeslot_configuration?: Maybe<timetable_timeslot_configuration_mutation_response>;
  /** delete single row from the table: "timetable_timeslot_configuration" */
  delete_timetable_timeslot_configuration_by_pk?: Maybe<timetable_timeslot_configuration>;
  /** delete data from the table: "user" */
  delete_user?: Maybe<user_mutation_response>;
  /** delete single row from the table: "user" */
  delete_user_by_pk?: Maybe<user>;
  /** delete data from the table: "user_performance_public" */
  delete_user_performance_public?: Maybe<user_performance_public_mutation_response>;
  /** delete data from the table: "user_public" */
  delete_user_public?: Maybe<user_public_mutation_response>;
  /** delete data from the table: "user_role" */
  delete_user_role?: Maybe<user_role_mutation_response>;
  /** delete single row from the table: "user_role" */
  delete_user_role_by_pk?: Maybe<user_role>;
  /** delete data from the table: "user_role_routes_route" */
  delete_user_role_routes_route?: Maybe<user_role_routes_route_mutation_response>;
  /** delete single row from the table: "user_role_routes_route" */
  delete_user_role_routes_route_by_pk?: Maybe<user_role_routes_route>;
  /** delete data from the table: "user_routes_route" */
  delete_user_routes_route?: Maybe<user_routes_route_mutation_response>;
  /** delete single row from the table: "user_routes_route" */
  delete_user_routes_route_by_pk?: Maybe<user_routes_route>;
  /** delete data from the table: "user_user_roles_user_role" */
  delete_user_user_roles_user_role?: Maybe<user_user_roles_user_role_mutation_response>;
  /** delete single row from the table: "user_user_roles_user_role" */
  delete_user_user_roles_user_role_by_pk?: Maybe<user_user_roles_user_role>;
  /** insert data into the table: "academic_calendar_item" */
  insert_academic_calendar_item?: Maybe<academic_calendar_item_mutation_response>;
  /** insert a single row into the table: "academic_calendar_item" */
  insert_academic_calendar_item_one?: Maybe<academic_calendar_item>;
  /** insert data into the table: "active_batch" */
  insert_active_batch?: Maybe<active_batch_mutation_response>;
  /** insert a single row into the table: "active_batch" */
  insert_active_batch_one?: Maybe<active_batch>;
  /** insert data into the table: "assessment" */
  insert_assessment?: Maybe<assessment_mutation_response>;
  /** insert a single row into the table: "assessment" */
  insert_assessment_one?: Maybe<assessment>;
  /** insert data into the table: "attendance" */
  insert_attendance?: Maybe<attendance_mutation_response>;
  /** insert a single row into the table: "attendance" */
  insert_attendance_one?: Maybe<attendance>;
  /** insert data into the table: "attendance_student" */
  insert_attendance_student?: Maybe<attendance_student_mutation_response>;
  /** insert a single row into the table: "attendance_student" */
  insert_attendance_student_one?: Maybe<attendance_student>;
  /** insert data into the table: "batch" */
  insert_batch?: Maybe<batch_mutation_response>;
  /** insert data into the table: "batch_class" */
  insert_batch_class?: Maybe<batch_class_mutation_response>;
  /** insert a single row into the table: "batch_class" */
  insert_batch_class_one?: Maybe<batch_class>;
  /** insert a single row into the table: "batch" */
  insert_batch_one?: Maybe<batch>;
  /** insert data into the table: "batch_subject_configuration" */
  insert_batch_subject_configuration?: Maybe<batch_subject_configuration_mutation_response>;
  /** insert a single row into the table: "batch_subject_configuration" */
  insert_batch_subject_configuration_one?: Maybe<batch_subject_configuration>;
  /** insert data into the table: "batch_subject_extra_slot" */
  insert_batch_subject_extra_slot?: Maybe<batch_subject_extra_slot_mutation_response>;
  /** insert a single row into the table: "batch_subject_extra_slot" */
  insert_batch_subject_extra_slot_one?: Maybe<batch_subject_extra_slot>;
  /** insert data into the table: "blood_type" */
  insert_blood_type?: Maybe<blood_type_mutation_response>;
  /** insert a single row into the table: "blood_type" */
  insert_blood_type_one?: Maybe<blood_type>;
  /** insert data into the table: "course" */
  insert_course?: Maybe<course_mutation_response>;
  /** insert data into the table: "course_coordinator" */
  insert_course_coordinator?: Maybe<course_coordinator_mutation_response>;
  /** insert a single row into the table: "course_coordinator" */
  insert_course_coordinator_one?: Maybe<course_coordinator>;
  /** insert data into the table: "course_level" */
  insert_course_level?: Maybe<course_level_mutation_response>;
  /** insert a single row into the table: "course_level" */
  insert_course_level_one?: Maybe<course_level>;
  /** insert a single row into the table: "course" */
  insert_course_one?: Maybe<course>;
  /** insert data into the table: "course_semester" */
  insert_course_semester?: Maybe<course_semester_mutation_response>;
  /** insert a single row into the table: "course_semester" */
  insert_course_semester_one?: Maybe<course_semester>;
  /** insert data into the table: "course_semester_subjects_subject" */
  insert_course_semester_subjects_subject?: Maybe<course_semester_subjects_subject_mutation_response>;
  /** insert a single row into the table: "course_semester_subjects_subject" */
  insert_course_semester_subjects_subject_one?: Maybe<course_semester_subjects_subject>;
  /** insert data into the table: "current_student" */
  insert_current_student?: Maybe<current_student_mutation_response>;
  /** insert data into the table: "current_student_course" */
  insert_current_student_course?: Maybe<current_student_course_mutation_response>;
  /** insert a single row into the table: "current_student_course" */
  insert_current_student_course_one?: Maybe<current_student_course>;
  /** insert a single row into the table: "current_student" */
  insert_current_student_one?: Maybe<current_student>;
  /** insert data into the table: "current_user" */
  insert_current_user?: Maybe<current_user_mutation_response>;
  /** insert a single row into the table: "current_user" */
  insert_current_user_one?: Maybe<current_user>;
  /** insert data into the table: "current_user_route" */
  insert_current_user_route?: Maybe<current_user_route_mutation_response>;
  /** insert a single row into the table: "current_user_route" */
  insert_current_user_route_one?: Maybe<current_user_route>;
  /** insert data into the table: "department" */
  insert_department?: Maybe<department_mutation_response>;
  /** insert a single row into the table: "department" */
  insert_department_one?: Maybe<department>;
  /** insert data into the table: "education_qualification" */
  insert_education_qualification?: Maybe<education_qualification_mutation_response>;
  /** insert a single row into the table: "education_qualification" */
  insert_education_qualification_one?: Maybe<education_qualification>;
  /** insert data into the table: "employment_experience" */
  insert_employment_experience?: Maybe<employment_experience_mutation_response>;
  /** insert a single row into the table: "employment_experience" */
  insert_employment_experience_one?: Maybe<employment_experience>;
  /** insert data into the table: "endpoint" */
  insert_endpoint?: Maybe<endpoint_mutation_response>;
  /** insert a single row into the table: "endpoint" */
  insert_endpoint_one?: Maybe<endpoint>;
  /** insert data into the table: "exit_interview_answer" */
  insert_exit_interview_answer?: Maybe<exit_interview_answer_mutation_response>;
  /** insert data into the table: "exit_interview_answer_multi_choice_questions" */
  insert_exit_interview_answer_multi_choice_questions?: Maybe<exit_interview_answer_multi_choice_questions_mutation_response>;
  /** insert a single row into the table: "exit_interview_answer_multi_choice_questions" */
  insert_exit_interview_answer_multi_choice_questions_one?: Maybe<exit_interview_answer_multi_choice_questions>;
  /** insert a single row into the table: "exit_interview_answer" */
  insert_exit_interview_answer_one?: Maybe<exit_interview_answer>;
  /** insert data into the table: "exit_interview_question" */
  insert_exit_interview_question?: Maybe<exit_interview_question_mutation_response>;
  /** insert data into the table: "exit_interview_question_answers" */
  insert_exit_interview_question_answers?: Maybe<exit_interview_question_answers_mutation_response>;
  /** insert a single row into the table: "exit_interview_question_answers" */
  insert_exit_interview_question_answers_one?: Maybe<exit_interview_question_answers>;
  /** insert data into the table: "exit_interview_question_group" */
  insert_exit_interview_question_group?: Maybe<exit_interview_question_group_mutation_response>;
  /** insert a single row into the table: "exit_interview_question_group" */
  insert_exit_interview_question_group_one?: Maybe<exit_interview_question_group>;
  /** insert a single row into the table: "exit_interview_question" */
  insert_exit_interview_question_one?: Maybe<exit_interview_question>;
  /** insert data into the table: "inquiry" */
  insert_inquiry?: Maybe<inquiry_mutation_response>;
  /** insert a single row into the table: "inquiry" */
  insert_inquiry_one?: Maybe<inquiry>;
  /** insert data into the table: "inquiry_status_enum" */
  insert_inquiry_status_enum?: Maybe<inquiry_status_enum_mutation_response>;
  /** insert a single row into the table: "inquiry_status_enum" */
  insert_inquiry_status_enum_one?: Maybe<inquiry_status_enum>;
  /** insert data into the table: "intake" */
  insert_intake?: Maybe<intake_mutation_response>;
  /** insert a single row into the table: "intake" */
  insert_intake_one?: Maybe<intake>;
  /** insert data into the table: "lecture_material" */
  insert_lecture_material?: Maybe<lecture_material_mutation_response>;
  /** insert data into the table: "lecture_material_category" */
  insert_lecture_material_category?: Maybe<lecture_material_category_mutation_response>;
  /** insert a single row into the table: "lecture_material_category" */
  insert_lecture_material_category_one?: Maybe<lecture_material_category>;
  /** insert a single row into the table: "lecture_material" */
  insert_lecture_material_one?: Maybe<lecture_material>;
  /** insert data into the table: "location" */
  insert_location?: Maybe<location_mutation_response>;
  /** insert a single row into the table: "location" */
  insert_location_one?: Maybe<location>;
  /** insert data into the table: "multi_choice_question" */
  insert_multi_choice_question?: Maybe<multi_choice_question_mutation_response>;
  /** insert a single row into the table: "multi_choice_question" */
  insert_multi_choice_question_one?: Maybe<multi_choice_question>;
  /** insert data into the table: "perfomance_status" */
  insert_perfomance_status?: Maybe<perfomance_status_mutation_response>;
  /** insert a single row into the table: "perfomance_status" */
  insert_perfomance_status_one?: Maybe<perfomance_status>;
  /** insert data into the table: "question_type" */
  insert_question_type?: Maybe<question_type_mutation_response>;
  /** insert a single row into the table: "question_type" */
  insert_question_type_one?: Maybe<question_type>;
  /** insert data into the table: "result_sheet" */
  insert_result_sheet?: Maybe<result_sheet_mutation_response>;
  /** insert a single row into the table: "result_sheet" */
  insert_result_sheet_one?: Maybe<result_sheet>;
  /** insert data into the table: "result_sheet_status" */
  insert_result_sheet_status?: Maybe<result_sheet_status_mutation_response>;
  /** insert a single row into the table: "result_sheet_status" */
  insert_result_sheet_status_one?: Maybe<result_sheet_status>;
  /** insert data into the table: "route" */
  insert_route?: Maybe<route_mutation_response>;
  /** insert data into the table: "route_endpoints_endpoint" */
  insert_route_endpoints_endpoint?: Maybe<route_endpoints_endpoint_mutation_response>;
  /** insert a single row into the table: "route_endpoints_endpoint" */
  insert_route_endpoints_endpoint_one?: Maybe<route_endpoints_endpoint>;
  /** insert a single row into the table: "route" */
  insert_route_one?: Maybe<route>;
  /** insert data into the table: "student" */
  insert_student?: Maybe<student_mutation_response>;
  /** insert data into the table: "student_admin_editable_information" */
  insert_student_admin_editable_information?: Maybe<student_admin_editable_information_mutation_response>;
  /** insert a single row into the table: "student_admin_editable_information" */
  insert_student_admin_editable_information_one?: Maybe<student_admin_editable_information>;
  /** insert data into the table: "student_assessment_submission" */
  insert_student_assessment_submission?: Maybe<student_assessment_submission_mutation_response>;
  /** insert a single row into the table: "student_assessment_submission" */
  insert_student_assessment_submission_one?: Maybe<student_assessment_submission>;
  /** insert data into the table: "student_attendance_status" */
  insert_student_attendance_status?: Maybe<student_attendance_status_mutation_response>;
  /** insert a single row into the table: "student_attendance_status" */
  insert_student_attendance_status_one?: Maybe<student_attendance_status>;
  /** insert data into the table: "student_batch_classes_batch_class" */
  insert_student_batch_classes_batch_class?: Maybe<student_batch_classes_batch_class_mutation_response>;
  /** insert a single row into the table: "student_batch_classes_batch_class" */
  insert_student_batch_classes_batch_class_one?: Maybe<student_batch_classes_batch_class>;
  /** insert data into the table: "student_batch_history" */
  insert_student_batch_history?: Maybe<student_batch_history_mutation_response>;
  /** insert a single row into the table: "student_batch_history" */
  insert_student_batch_history_one?: Maybe<student_batch_history>;
  /** insert data into the table: "student_batch_history_subject" */
  insert_student_batch_history_subject?: Maybe<student_batch_history_subject_mutation_response>;
  /** insert a single row into the table: "student_batch_history_subject" */
  insert_student_batch_history_subject_one?: Maybe<student_batch_history_subject>;
  /** insert data into the table: "student_course" */
  insert_student_course?: Maybe<student_course_mutation_response>;
  /** insert a single row into the table: "student_course" */
  insert_student_course_one?: Maybe<student_course>;
  /** insert data into the table: "student_external_engagement_request" */
  insert_student_external_engagement_request?: Maybe<student_external_engagement_request_mutation_response>;
  /** insert a single row into the table: "student_external_engagement_request" */
  insert_student_external_engagement_request_one?: Maybe<student_external_engagement_request>;
  /** insert data into the table: "student_familiarization_form" */
  insert_student_familiarization_form?: Maybe<student_familiarization_form_mutation_response>;
  /** insert a single row into the table: "student_familiarization_form" */
  insert_student_familiarization_form_one?: Maybe<student_familiarization_form>;
  /** insert data into the table: "student_familiarization_interview" */
  insert_student_familiarization_interview?: Maybe<student_familiarization_interview_mutation_response>;
  /** insert a single row into the table: "student_familiarization_interview" */
  insert_student_familiarization_interview_one?: Maybe<student_familiarization_interview>;
  /** insert data into the table: "student_for_batch" */
  insert_student_for_batch?: Maybe<student_for_batch_mutation_response>;
  /** insert a single row into the table: "student_for_batch" */
  insert_student_for_batch_one?: Maybe<student_for_batch>;
  /** insert data into the table: "student_general_request" */
  insert_student_general_request?: Maybe<student_general_request_mutation_response>;
  /** insert a single row into the table: "student_general_request" */
  insert_student_general_request_one?: Maybe<student_general_request>;
  /** insert data into the table: "student_medical_request" */
  insert_student_medical_request?: Maybe<student_medical_request_mutation_response>;
  /** insert a single row into the table: "student_medical_request" */
  insert_student_medical_request_one?: Maybe<student_medical_request>;
  /** insert a single row into the table: "student" */
  insert_student_one?: Maybe<student>;
  /** insert data into the table: "student_performance" */
  insert_student_performance?: Maybe<student_performance_mutation_response>;
  /** insert a single row into the table: "student_performance" */
  insert_student_performance_one?: Maybe<student_performance>;
  /** insert data into the table: "student_request" */
  insert_student_request?: Maybe<student_request_mutation_response>;
  /** insert data into the table: "student_request_message" */
  insert_student_request_message?: Maybe<student_request_message_mutation_response>;
  /** insert a single row into the table: "student_request_message" */
  insert_student_request_message_one?: Maybe<student_request_message>;
  /** insert a single row into the table: "student_request" */
  insert_student_request_one?: Maybe<student_request>;
  /** insert data into the table: "student_request_requestee" */
  insert_student_request_requestee?: Maybe<student_request_requestee_mutation_response>;
  /** insert a single row into the table: "student_request_requestee" */
  insert_student_request_requestee_one?: Maybe<student_request_requestee>;
  /** insert data into the table: "student_request_status" */
  insert_student_request_status?: Maybe<student_request_status_mutation_response>;
  /** insert a single row into the table: "student_request_status" */
  insert_student_request_status_one?: Maybe<student_request_status>;
  /** insert data into the table: "student_result" */
  insert_student_result?: Maybe<student_result_mutation_response>;
  /** insert a single row into the table: "student_result" */
  insert_student_result_one?: Maybe<student_result>;
  /** insert data into the table: "student_result_sheet" */
  insert_student_result_sheet?: Maybe<student_result_sheet_mutation_response>;
  /** insert a single row into the table: "student_result_sheet" */
  insert_student_result_sheet_one?: Maybe<student_result_sheet>;
  /** insert data into the table: "student_self_editable_information" */
  insert_student_self_editable_information?: Maybe<student_self_editable_information_mutation_response>;
  /** insert a single row into the table: "student_self_editable_information" */
  insert_student_self_editable_information_one?: Maybe<student_self_editable_information>;
  /** insert data into the table: "student_status" */
  insert_student_status?: Maybe<student_status_mutation_response>;
  /** insert a single row into the table: "student_status" */
  insert_student_status_one?: Maybe<student_status>;
  /** insert data into the table: "subject" */
  insert_subject?: Maybe<subject_mutation_response>;
  /** insert data into the table: "subject_extra_slot" */
  insert_subject_extra_slot?: Maybe<subject_extra_slot_mutation_response>;
  /** insert a single row into the table: "subject_extra_slot" */
  insert_subject_extra_slot_one?: Maybe<subject_extra_slot>;
  /** insert a single row into the table: "subject" */
  insert_subject_one?: Maybe<subject>;
  /** insert data into the table: "subject_to_user" */
  insert_subject_to_user?: Maybe<subject_to_user_mutation_response>;
  /** insert a single row into the table: "subject_to_user" */
  insert_subject_to_user_one?: Maybe<subject_to_user>;
  /** insert data into the table: "timetable_item" */
  insert_timetable_item?: Maybe<timetable_item_mutation_response>;
  /** insert a single row into the table: "timetable_item" */
  insert_timetable_item_one?: Maybe<timetable_item>;
  /** insert data into the table: "timetable_timeslot_configuration" */
  insert_timetable_timeslot_configuration?: Maybe<timetable_timeslot_configuration_mutation_response>;
  /** insert a single row into the table: "timetable_timeslot_configuration" */
  insert_timetable_timeslot_configuration_one?: Maybe<timetable_timeslot_configuration>;
  /** insert data into the table: "user" */
  insert_user?: Maybe<user_mutation_response>;
  /** insert a single row into the table: "user" */
  insert_user_one?: Maybe<user>;
  /** insert data into the table: "user_performance_public" */
  insert_user_performance_public?: Maybe<user_performance_public_mutation_response>;
  /** insert a single row into the table: "user_performance_public" */
  insert_user_performance_public_one?: Maybe<user_performance_public>;
  /** insert data into the table: "user_public" */
  insert_user_public?: Maybe<user_public_mutation_response>;
  /** insert a single row into the table: "user_public" */
  insert_user_public_one?: Maybe<user_public>;
  /** insert data into the table: "user_role" */
  insert_user_role?: Maybe<user_role_mutation_response>;
  /** insert a single row into the table: "user_role" */
  insert_user_role_one?: Maybe<user_role>;
  /** insert data into the table: "user_role_routes_route" */
  insert_user_role_routes_route?: Maybe<user_role_routes_route_mutation_response>;
  /** insert a single row into the table: "user_role_routes_route" */
  insert_user_role_routes_route_one?: Maybe<user_role_routes_route>;
  /** insert data into the table: "user_routes_route" */
  insert_user_routes_route?: Maybe<user_routes_route_mutation_response>;
  /** insert a single row into the table: "user_routes_route" */
  insert_user_routes_route_one?: Maybe<user_routes_route>;
  /** insert data into the table: "user_user_roles_user_role" */
  insert_user_user_roles_user_role?: Maybe<user_user_roles_user_role_mutation_response>;
  /** insert a single row into the table: "user_user_roles_user_role" */
  insert_user_user_roles_user_role_one?: Maybe<user_user_roles_user_role>;
  reSendLoginEmail: ReSendLoginEmailResult;
  registerStudent: RegisterStudentResult;
  updateFinalStudentDetails: UpdateFinalStudentDetailsResult;
  updateInquiry: UpdateInquiryResult;
  updateStudent: UpdateStudentResult;
  updateStudentRequestStatus: UpdateStudentRequestStatusResult;
  updateUser: UpdateUserResult;
  updateUserActiveState: UpdateUserActiveStateResult;
  /** update data of the table: "academic_calendar_item" */
  update_academic_calendar_item?: Maybe<academic_calendar_item_mutation_response>;
  /** update single row of the table: "academic_calendar_item" */
  update_academic_calendar_item_by_pk?: Maybe<academic_calendar_item>;
  /** update data of the table: "active_batch" */
  update_active_batch?: Maybe<active_batch_mutation_response>;
  /** update data of the table: "assessment" */
  update_assessment?: Maybe<assessment_mutation_response>;
  /** update single row of the table: "assessment" */
  update_assessment_by_pk?: Maybe<assessment>;
  /** update data of the table: "attendance" */
  update_attendance?: Maybe<attendance_mutation_response>;
  /** update single row of the table: "attendance" */
  update_attendance_by_pk?: Maybe<attendance>;
  /** update data of the table: "attendance_student" */
  update_attendance_student?: Maybe<attendance_student_mutation_response>;
  /** update single row of the table: "attendance_student" */
  update_attendance_student_by_pk?: Maybe<attendance_student>;
  /** update data of the table: "batch" */
  update_batch?: Maybe<batch_mutation_response>;
  /** update single row of the table: "batch" */
  update_batch_by_pk?: Maybe<batch>;
  /** update data of the table: "batch_class" */
  update_batch_class?: Maybe<batch_class_mutation_response>;
  /** update single row of the table: "batch_class" */
  update_batch_class_by_pk?: Maybe<batch_class>;
  /** update data of the table: "batch_subject_configuration" */
  update_batch_subject_configuration?: Maybe<batch_subject_configuration_mutation_response>;
  /** update single row of the table: "batch_subject_configuration" */
  update_batch_subject_configuration_by_pk?: Maybe<batch_subject_configuration>;
  /** update data of the table: "batch_subject_extra_slot" */
  update_batch_subject_extra_slot?: Maybe<batch_subject_extra_slot_mutation_response>;
  /** update single row of the table: "batch_subject_extra_slot" */
  update_batch_subject_extra_slot_by_pk?: Maybe<batch_subject_extra_slot>;
  /** update data of the table: "blood_type" */
  update_blood_type?: Maybe<blood_type_mutation_response>;
  /** update single row of the table: "blood_type" */
  update_blood_type_by_pk?: Maybe<blood_type>;
  /** update data of the table: "course" */
  update_course?: Maybe<course_mutation_response>;
  /** update single row of the table: "course" */
  update_course_by_pk?: Maybe<course>;
  /** update data of the table: "course_coordinator" */
  update_course_coordinator?: Maybe<course_coordinator_mutation_response>;
  /** update single row of the table: "course_coordinator" */
  update_course_coordinator_by_pk?: Maybe<course_coordinator>;
  /** update data of the table: "course_level" */
  update_course_level?: Maybe<course_level_mutation_response>;
  /** update single row of the table: "course_level" */
  update_course_level_by_pk?: Maybe<course_level>;
  /** update data of the table: "course_semester" */
  update_course_semester?: Maybe<course_semester_mutation_response>;
  /** update single row of the table: "course_semester" */
  update_course_semester_by_pk?: Maybe<course_semester>;
  /** update data of the table: "course_semester_subjects_subject" */
  update_course_semester_subjects_subject?: Maybe<course_semester_subjects_subject_mutation_response>;
  /** update single row of the table: "course_semester_subjects_subject" */
  update_course_semester_subjects_subject_by_pk?: Maybe<course_semester_subjects_subject>;
  /** update data of the table: "current_student" */
  update_current_student?: Maybe<current_student_mutation_response>;
  /** update data of the table: "current_student_course" */
  update_current_student_course?: Maybe<current_student_course_mutation_response>;
  /** update data of the table: "current_user" */
  update_current_user?: Maybe<current_user_mutation_response>;
  /** update data of the table: "current_user_route" */
  update_current_user_route?: Maybe<current_user_route_mutation_response>;
  /** update data of the table: "department" */
  update_department?: Maybe<department_mutation_response>;
  /** update single row of the table: "department" */
  update_department_by_pk?: Maybe<department>;
  /** update data of the table: "education_qualification" */
  update_education_qualification?: Maybe<education_qualification_mutation_response>;
  /** update single row of the table: "education_qualification" */
  update_education_qualification_by_pk?: Maybe<education_qualification>;
  /** update data of the table: "employment_experience" */
  update_employment_experience?: Maybe<employment_experience_mutation_response>;
  /** update single row of the table: "employment_experience" */
  update_employment_experience_by_pk?: Maybe<employment_experience>;
  /** update data of the table: "endpoint" */
  update_endpoint?: Maybe<endpoint_mutation_response>;
  /** update single row of the table: "endpoint" */
  update_endpoint_by_pk?: Maybe<endpoint>;
  /** update data of the table: "exit_interview_answer" */
  update_exit_interview_answer?: Maybe<exit_interview_answer_mutation_response>;
  /** update single row of the table: "exit_interview_answer" */
  update_exit_interview_answer_by_pk?: Maybe<exit_interview_answer>;
  /** update data of the table: "exit_interview_answer_multi_choice_questions" */
  update_exit_interview_answer_multi_choice_questions?: Maybe<exit_interview_answer_multi_choice_questions_mutation_response>;
  /** update single row of the table: "exit_interview_answer_multi_choice_questions" */
  update_exit_interview_answer_multi_choice_questions_by_pk?: Maybe<exit_interview_answer_multi_choice_questions>;
  /** update data of the table: "exit_interview_question" */
  update_exit_interview_question?: Maybe<exit_interview_question_mutation_response>;
  /** update data of the table: "exit_interview_question_answers" */
  update_exit_interview_question_answers?: Maybe<exit_interview_question_answers_mutation_response>;
  /** update single row of the table: "exit_interview_question_answers" */
  update_exit_interview_question_answers_by_pk?: Maybe<exit_interview_question_answers>;
  /** update single row of the table: "exit_interview_question" */
  update_exit_interview_question_by_pk?: Maybe<exit_interview_question>;
  /** update data of the table: "exit_interview_question_group" */
  update_exit_interview_question_group?: Maybe<exit_interview_question_group_mutation_response>;
  /** update single row of the table: "exit_interview_question_group" */
  update_exit_interview_question_group_by_pk?: Maybe<exit_interview_question_group>;
  /** update data of the table: "inquiry" */
  update_inquiry?: Maybe<inquiry_mutation_response>;
  /** update single row of the table: "inquiry" */
  update_inquiry_by_pk?: Maybe<inquiry>;
  /** update data of the table: "inquiry_status_enum" */
  update_inquiry_status_enum?: Maybe<inquiry_status_enum_mutation_response>;
  /** update single row of the table: "inquiry_status_enum" */
  update_inquiry_status_enum_by_pk?: Maybe<inquiry_status_enum>;
  /** update data of the table: "intake" */
  update_intake?: Maybe<intake_mutation_response>;
  /** update single row of the table: "intake" */
  update_intake_by_pk?: Maybe<intake>;
  /** update data of the table: "lecture_material" */
  update_lecture_material?: Maybe<lecture_material_mutation_response>;
  /** update single row of the table: "lecture_material" */
  update_lecture_material_by_pk?: Maybe<lecture_material>;
  /** update data of the table: "lecture_material_category" */
  update_lecture_material_category?: Maybe<lecture_material_category_mutation_response>;
  /** update single row of the table: "lecture_material_category" */
  update_lecture_material_category_by_pk?: Maybe<lecture_material_category>;
  /** update data of the table: "location" */
  update_location?: Maybe<location_mutation_response>;
  /** update single row of the table: "location" */
  update_location_by_pk?: Maybe<location>;
  /** update data of the table: "multi_choice_question" */
  update_multi_choice_question?: Maybe<multi_choice_question_mutation_response>;
  /** update single row of the table: "multi_choice_question" */
  update_multi_choice_question_by_pk?: Maybe<multi_choice_question>;
  /** update data of the table: "perfomance_status" */
  update_perfomance_status?: Maybe<perfomance_status_mutation_response>;
  /** update single row of the table: "perfomance_status" */
  update_perfomance_status_by_pk?: Maybe<perfomance_status>;
  /** update data of the table: "question_type" */
  update_question_type?: Maybe<question_type_mutation_response>;
  /** update single row of the table: "question_type" */
  update_question_type_by_pk?: Maybe<question_type>;
  /** update data of the table: "result_sheet" */
  update_result_sheet?: Maybe<result_sheet_mutation_response>;
  /** update single row of the table: "result_sheet" */
  update_result_sheet_by_pk?: Maybe<result_sheet>;
  /** update data of the table: "result_sheet_status" */
  update_result_sheet_status?: Maybe<result_sheet_status_mutation_response>;
  /** update single row of the table: "result_sheet_status" */
  update_result_sheet_status_by_pk?: Maybe<result_sheet_status>;
  /** update data of the table: "route" */
  update_route?: Maybe<route_mutation_response>;
  /** update single row of the table: "route" */
  update_route_by_pk?: Maybe<route>;
  /** update data of the table: "route_endpoints_endpoint" */
  update_route_endpoints_endpoint?: Maybe<route_endpoints_endpoint_mutation_response>;
  /** update single row of the table: "route_endpoints_endpoint" */
  update_route_endpoints_endpoint_by_pk?: Maybe<route_endpoints_endpoint>;
  /** update data of the table: "student" */
  update_student?: Maybe<student_mutation_response>;
  /** update data of the table: "student_admin_editable_information" */
  update_student_admin_editable_information?: Maybe<student_admin_editable_information_mutation_response>;
  /** update data of the table: "student_assessment_submission" */
  update_student_assessment_submission?: Maybe<student_assessment_submission_mutation_response>;
  /** update single row of the table: "student_assessment_submission" */
  update_student_assessment_submission_by_pk?: Maybe<student_assessment_submission>;
  /** update data of the table: "student_attendance_status" */
  update_student_attendance_status?: Maybe<student_attendance_status_mutation_response>;
  /** update single row of the table: "student_attendance_status" */
  update_student_attendance_status_by_pk?: Maybe<student_attendance_status>;
  /** update data of the table: "student_batch_classes_batch_class" */
  update_student_batch_classes_batch_class?: Maybe<student_batch_classes_batch_class_mutation_response>;
  /** update single row of the table: "student_batch_classes_batch_class" */
  update_student_batch_classes_batch_class_by_pk?: Maybe<student_batch_classes_batch_class>;
  /** update data of the table: "student_batch_history" */
  update_student_batch_history?: Maybe<student_batch_history_mutation_response>;
  /** update single row of the table: "student_batch_history" */
  update_student_batch_history_by_pk?: Maybe<student_batch_history>;
  /** update data of the table: "student_batch_history_subject" */
  update_student_batch_history_subject?: Maybe<student_batch_history_subject_mutation_response>;
  /** update single row of the table: "student_batch_history_subject" */
  update_student_batch_history_subject_by_pk?: Maybe<student_batch_history_subject>;
  /** update single row of the table: "student" */
  update_student_by_pk?: Maybe<student>;
  /** update data of the table: "student_course" */
  update_student_course?: Maybe<student_course_mutation_response>;
  /** update single row of the table: "student_course" */
  update_student_course_by_pk?: Maybe<student_course>;
  /** update data of the table: "student_external_engagement_request" */
  update_student_external_engagement_request?: Maybe<student_external_engagement_request_mutation_response>;
  /** update single row of the table: "student_external_engagement_request" */
  update_student_external_engagement_request_by_pk?: Maybe<student_external_engagement_request>;
  /** update data of the table: "student_familiarization_form" */
  update_student_familiarization_form?: Maybe<student_familiarization_form_mutation_response>;
  /** update single row of the table: "student_familiarization_form" */
  update_student_familiarization_form_by_pk?: Maybe<student_familiarization_form>;
  /** update data of the table: "student_familiarization_interview" */
  update_student_familiarization_interview?: Maybe<student_familiarization_interview_mutation_response>;
  /** update single row of the table: "student_familiarization_interview" */
  update_student_familiarization_interview_by_pk?: Maybe<student_familiarization_interview>;
  /** update data of the table: "student_for_batch" */
  update_student_for_batch?: Maybe<student_for_batch_mutation_response>;
  /** update data of the table: "student_general_request" */
  update_student_general_request?: Maybe<student_general_request_mutation_response>;
  /** update single row of the table: "student_general_request" */
  update_student_general_request_by_pk?: Maybe<student_general_request>;
  /** update data of the table: "student_medical_request" */
  update_student_medical_request?: Maybe<student_medical_request_mutation_response>;
  /** update single row of the table: "student_medical_request" */
  update_student_medical_request_by_pk?: Maybe<student_medical_request>;
  /** update data of the table: "student_performance" */
  update_student_performance?: Maybe<student_performance_mutation_response>;
  /** update single row of the table: "student_performance" */
  update_student_performance_by_pk?: Maybe<student_performance>;
  /** update data of the table: "student_request" */
  update_student_request?: Maybe<student_request_mutation_response>;
  /** update single row of the table: "student_request" */
  update_student_request_by_pk?: Maybe<student_request>;
  /** update data of the table: "student_request_message" */
  update_student_request_message?: Maybe<student_request_message_mutation_response>;
  /** update single row of the table: "student_request_message" */
  update_student_request_message_by_pk?: Maybe<student_request_message>;
  /** update data of the table: "student_request_requestee" */
  update_student_request_requestee?: Maybe<student_request_requestee_mutation_response>;
  /** update single row of the table: "student_request_requestee" */
  update_student_request_requestee_by_pk?: Maybe<student_request_requestee>;
  /** update data of the table: "student_request_status" */
  update_student_request_status?: Maybe<student_request_status_mutation_response>;
  /** update single row of the table: "student_request_status" */
  update_student_request_status_by_pk?: Maybe<student_request_status>;
  /** update data of the table: "student_result" */
  update_student_result?: Maybe<student_result_mutation_response>;
  /** update single row of the table: "student_result" */
  update_student_result_by_pk?: Maybe<student_result>;
  /** update data of the table: "student_result_sheet" */
  update_student_result_sheet?: Maybe<student_result_sheet_mutation_response>;
  /** update single row of the table: "student_result_sheet" */
  update_student_result_sheet_by_pk?: Maybe<student_result_sheet>;
  /** update data of the table: "student_self_editable_information" */
  update_student_self_editable_information?: Maybe<student_self_editable_information_mutation_response>;
  /** update data of the table: "student_status" */
  update_student_status?: Maybe<student_status_mutation_response>;
  /** update single row of the table: "student_status" */
  update_student_status_by_pk?: Maybe<student_status>;
  /** update data of the table: "subject" */
  update_subject?: Maybe<subject_mutation_response>;
  /** update single row of the table: "subject" */
  update_subject_by_pk?: Maybe<subject>;
  /** update data of the table: "subject_extra_slot" */
  update_subject_extra_slot?: Maybe<subject_extra_slot_mutation_response>;
  /** update single row of the table: "subject_extra_slot" */
  update_subject_extra_slot_by_pk?: Maybe<subject_extra_slot>;
  /** update data of the table: "subject_to_user" */
  update_subject_to_user?: Maybe<subject_to_user_mutation_response>;
  /** update single row of the table: "subject_to_user" */
  update_subject_to_user_by_pk?: Maybe<subject_to_user>;
  /** update data of the table: "timetable_item" */
  update_timetable_item?: Maybe<timetable_item_mutation_response>;
  /** update single row of the table: "timetable_item" */
  update_timetable_item_by_pk?: Maybe<timetable_item>;
  /** update data of the table: "timetable_timeslot_configuration" */
  update_timetable_timeslot_configuration?: Maybe<timetable_timeslot_configuration_mutation_response>;
  /** update single row of the table: "timetable_timeslot_configuration" */
  update_timetable_timeslot_configuration_by_pk?: Maybe<timetable_timeslot_configuration>;
  /** update data of the table: "user" */
  update_user?: Maybe<user_mutation_response>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<user>;
  /** update data of the table: "user_performance_public" */
  update_user_performance_public?: Maybe<user_performance_public_mutation_response>;
  /** update data of the table: "user_public" */
  update_user_public?: Maybe<user_public_mutation_response>;
  /** update data of the table: "user_role" */
  update_user_role?: Maybe<user_role_mutation_response>;
  /** update single row of the table: "user_role" */
  update_user_role_by_pk?: Maybe<user_role>;
  /** update data of the table: "user_role_routes_route" */
  update_user_role_routes_route?: Maybe<user_role_routes_route_mutation_response>;
  /** update single row of the table: "user_role_routes_route" */
  update_user_role_routes_route_by_pk?: Maybe<user_role_routes_route>;
  /** update data of the table: "user_routes_route" */
  update_user_routes_route?: Maybe<user_routes_route_mutation_response>;
  /** update single row of the table: "user_routes_route" */
  update_user_routes_route_by_pk?: Maybe<user_routes_route>;
  /** update data of the table: "user_user_roles_user_role" */
  update_user_user_roles_user_role?: Maybe<user_user_roles_user_role_mutation_response>;
  /** update single row of the table: "user_user_roles_user_role" */
  update_user_user_roles_user_role_by_pk?: Maybe<user_user_roles_user_role>;
  upsertResultSheet: UpsertResultSheetResult;
};

/** mutation root */
export type mutation_rootactionNameArgs = {
  arg1: SampleInput;
};

/** mutation root */
export type mutation_rootapproveDenyResultSheetArgs = {
  data: ApproveDenyResultSheetInput;
  where: ApproveDenyResultSheetWhereInput;
};

/** mutation root */
export type mutation_rootcreateInquiryArgs = {
  data: CreateInquiryInput;
};

/** mutation root */
export type mutation_rootcreateStudentAssessmentSubmissionArgs = {
  data: CreateStudentAssessmentSubmissionInput;
};

/** mutation root */
export type mutation_rootcreateStudentRequestArgs = {
  data: CreateRequestInput;
};

/** mutation root */
export type mutation_rootcreateUserArgs = {
  data: CreateUserInput;
};

/** mutation root */
export type mutation_rootdelete_academic_calendar_itemArgs = {
  where: academic_calendar_item_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_academic_calendar_item_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_active_batchArgs = {
  where: active_batch_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_assessmentArgs = {
  where: assessment_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_assessment_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_attendanceArgs = {
  where: attendance_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_attendance_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_attendance_studentArgs = {
  where: attendance_student_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_attendance_student_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_batchArgs = {
  where: batch_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_batch_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_batch_classArgs = {
  where: batch_class_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_batch_class_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_batch_subject_configurationArgs = {
  where: batch_subject_configuration_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_batch_subject_configuration_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_batch_subject_extra_slotArgs = {
  where: batch_subject_extra_slot_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_batch_subject_extra_slot_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_blood_typeArgs = {
  where: blood_type_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_blood_type_by_pkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type mutation_rootdelete_courseArgs = {
  where: course_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_course_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_course_coordinatorArgs = {
  where: course_coordinator_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_course_coordinator_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_course_levelArgs = {
  where: course_level_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_course_level_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_course_semesterArgs = {
  where: course_semester_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_course_semester_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_course_semester_subjects_subjectArgs = {
  where: course_semester_subjects_subject_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_course_semester_subjects_subject_by_pkArgs = {
  courseSemesterId: Scalars['uuid'];
  subjectId: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_current_studentArgs = {
  where: current_student_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_current_student_courseArgs = {
  where: current_student_course_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_current_userArgs = {
  where: current_user_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_current_user_routeArgs = {
  where: current_user_route_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_departmentArgs = {
  where: department_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_department_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_education_qualificationArgs = {
  where: education_qualification_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_education_qualification_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_employment_experienceArgs = {
  where: employment_experience_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_employment_experience_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_endpointArgs = {
  where: endpoint_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_endpoint_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_exit_interview_answerArgs = {
  where: exit_interview_answer_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_exit_interview_answer_by_pkArgs = {
  questionId: Scalars['uuid'];
  studentId: Scalars['Int'];
};

/** mutation root */
export type mutation_rootdelete_exit_interview_answer_multi_choice_questionsArgs = {
  where: exit_interview_answer_multi_choice_questions_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_exit_interview_answer_multi_choice_questions_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_exit_interview_questionArgs = {
  where: exit_interview_question_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_exit_interview_question_answersArgs = {
  where: exit_interview_question_answers_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_exit_interview_question_answers_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_exit_interview_question_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_exit_interview_question_groupArgs = {
  where: exit_interview_question_group_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_exit_interview_question_group_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_inquiryArgs = {
  where: inquiry_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_inquiry_by_pkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type mutation_rootdelete_inquiry_status_enumArgs = {
  where: inquiry_status_enum_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_inquiry_status_enum_by_pkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type mutation_rootdelete_intakeArgs = {
  where: intake_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_intake_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_lecture_materialArgs = {
  where: lecture_material_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_lecture_material_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_lecture_material_categoryArgs = {
  where: lecture_material_category_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_lecture_material_category_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_locationArgs = {
  where: location_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_location_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_multi_choice_questionArgs = {
  where: multi_choice_question_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_multi_choice_question_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_perfomance_statusArgs = {
  where: perfomance_status_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_perfomance_status_by_pkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type mutation_rootdelete_question_typeArgs = {
  where: question_type_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_question_type_by_pkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type mutation_rootdelete_result_sheetArgs = {
  where: result_sheet_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_result_sheet_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_result_sheet_statusArgs = {
  where: result_sheet_status_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_result_sheet_status_by_pkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type mutation_rootdelete_routeArgs = {
  where: route_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_route_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_route_endpoints_endpointArgs = {
  where: route_endpoints_endpoint_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_route_endpoints_endpoint_by_pkArgs = {
  endpointId: Scalars['uuid'];
  routeId: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_studentArgs = {
  where: student_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_admin_editable_informationArgs = {
  where: student_admin_editable_information_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_assessment_submissionArgs = {
  where: student_assessment_submission_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_assessment_submission_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_attendance_statusArgs = {
  where: student_attendance_status_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_attendance_status_by_pkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type mutation_rootdelete_student_batch_classes_batch_classArgs = {
  where: student_batch_classes_batch_class_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_batch_classes_batch_class_by_pkArgs = {
  batchClassId: Scalars['uuid'];
  studentId: Scalars['Int'];
};

/** mutation root */
export type mutation_rootdelete_student_batch_historyArgs = {
  where: student_batch_history_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_batch_history_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_batch_history_subjectArgs = {
  where: student_batch_history_subject_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_batch_history_subject_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_by_pkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type mutation_rootdelete_student_courseArgs = {
  where: student_course_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_course_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_external_engagement_requestArgs = {
  where: student_external_engagement_request_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_external_engagement_request_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_familiarization_formArgs = {
  where: student_familiarization_form_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_familiarization_form_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_familiarization_interviewArgs = {
  where: student_familiarization_interview_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_familiarization_interview_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_for_batchArgs = {
  where: student_for_batch_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_general_requestArgs = {
  where: student_general_request_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_general_request_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_medical_requestArgs = {
  where: student_medical_request_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_medical_request_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_performanceArgs = {
  where: student_performance_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_performance_by_pkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type mutation_rootdelete_student_requestArgs = {
  where: student_request_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_request_by_pkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type mutation_rootdelete_student_request_messageArgs = {
  where: student_request_message_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_request_message_by_pkArgs = {
  id: Scalars['Int'];
};

/** mutation root */
export type mutation_rootdelete_student_request_requesteeArgs = {
  where: student_request_requestee_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_request_requestee_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_request_statusArgs = {
  where: student_request_status_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_request_status_by_pkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type mutation_rootdelete_student_resultArgs = {
  where: student_result_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_result_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_result_sheetArgs = {
  where: student_result_sheet_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_result_sheet_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_student_self_editable_informationArgs = {
  where: student_self_editable_information_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_statusArgs = {
  where: student_status_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_student_status_by_pkArgs = {
  name: Scalars['String'];
};

/** mutation root */
export type mutation_rootdelete_subjectArgs = {
  where: subject_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_subject_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_subject_extra_slotArgs = {
  where: subject_extra_slot_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_subject_extra_slot_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_subject_to_userArgs = {
  where: subject_to_user_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_subject_to_user_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_timetable_itemArgs = {
  where: timetable_item_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_timetable_item_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_timetable_timeslot_configurationArgs = {
  where: timetable_timeslot_configuration_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_timetable_timeslot_configuration_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_userArgs = {
  where: user_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_user_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_user_performance_publicArgs = {
  where: user_performance_public_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_user_publicArgs = {
  where: user_public_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_user_roleArgs = {
  where: user_role_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_user_role_by_pkArgs = {
  id: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_user_role_routes_routeArgs = {
  where: user_role_routes_route_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_user_role_routes_route_by_pkArgs = {
  routeId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_user_routes_routeArgs = {
  where: user_routes_route_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_user_routes_route_by_pkArgs = {
  routeId: Scalars['uuid'];
  userId: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootdelete_user_user_roles_user_roleArgs = {
  where: user_user_roles_user_role_bool_exp;
};

/** mutation root */
export type mutation_rootdelete_user_user_roles_user_role_by_pkArgs = {
  userId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
};

/** mutation root */
export type mutation_rootinsert_academic_calendar_itemArgs = {
  objects: Array<academic_calendar_item_insert_input>;
  on_conflict?: Maybe<academic_calendar_item_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_academic_calendar_item_oneArgs = {
  object: academic_calendar_item_insert_input;
  on_conflict?: Maybe<academic_calendar_item_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_active_batchArgs = {
  objects: Array<active_batch_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_active_batch_oneArgs = {
  object: active_batch_insert_input;
};

/** mutation root */
export type mutation_rootinsert_assessmentArgs = {
  objects: Array<assessment_insert_input>;
  on_conflict?: Maybe<assessment_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_assessment_oneArgs = {
  object: assessment_insert_input;
  on_conflict?: Maybe<assessment_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_attendanceArgs = {
  objects: Array<attendance_insert_input>;
  on_conflict?: Maybe<attendance_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_attendance_oneArgs = {
  object: attendance_insert_input;
  on_conflict?: Maybe<attendance_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_attendance_studentArgs = {
  objects: Array<attendance_student_insert_input>;
  on_conflict?: Maybe<attendance_student_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_attendance_student_oneArgs = {
  object: attendance_student_insert_input;
  on_conflict?: Maybe<attendance_student_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_batchArgs = {
  objects: Array<batch_insert_input>;
  on_conflict?: Maybe<batch_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_batch_classArgs = {
  objects: Array<batch_class_insert_input>;
  on_conflict?: Maybe<batch_class_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_batch_class_oneArgs = {
  object: batch_class_insert_input;
  on_conflict?: Maybe<batch_class_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_batch_oneArgs = {
  object: batch_insert_input;
  on_conflict?: Maybe<batch_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_batch_subject_configurationArgs = {
  objects: Array<batch_subject_configuration_insert_input>;
  on_conflict?: Maybe<batch_subject_configuration_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_batch_subject_configuration_oneArgs = {
  object: batch_subject_configuration_insert_input;
  on_conflict?: Maybe<batch_subject_configuration_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_batch_subject_extra_slotArgs = {
  objects: Array<batch_subject_extra_slot_insert_input>;
  on_conflict?: Maybe<batch_subject_extra_slot_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_batch_subject_extra_slot_oneArgs = {
  object: batch_subject_extra_slot_insert_input;
  on_conflict?: Maybe<batch_subject_extra_slot_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_blood_typeArgs = {
  objects: Array<blood_type_insert_input>;
  on_conflict?: Maybe<blood_type_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_blood_type_oneArgs = {
  object: blood_type_insert_input;
  on_conflict?: Maybe<blood_type_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_courseArgs = {
  objects: Array<course_insert_input>;
  on_conflict?: Maybe<course_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_course_coordinatorArgs = {
  objects: Array<course_coordinator_insert_input>;
  on_conflict?: Maybe<course_coordinator_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_course_coordinator_oneArgs = {
  object: course_coordinator_insert_input;
  on_conflict?: Maybe<course_coordinator_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_course_levelArgs = {
  objects: Array<course_level_insert_input>;
  on_conflict?: Maybe<course_level_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_course_level_oneArgs = {
  object: course_level_insert_input;
  on_conflict?: Maybe<course_level_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_course_oneArgs = {
  object: course_insert_input;
  on_conflict?: Maybe<course_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_course_semesterArgs = {
  objects: Array<course_semester_insert_input>;
  on_conflict?: Maybe<course_semester_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_course_semester_oneArgs = {
  object: course_semester_insert_input;
  on_conflict?: Maybe<course_semester_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_course_semester_subjects_subjectArgs = {
  objects: Array<course_semester_subjects_subject_insert_input>;
  on_conflict?: Maybe<course_semester_subjects_subject_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_course_semester_subjects_subject_oneArgs = {
  object: course_semester_subjects_subject_insert_input;
  on_conflict?: Maybe<course_semester_subjects_subject_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_current_studentArgs = {
  objects: Array<current_student_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_current_student_courseArgs = {
  objects: Array<current_student_course_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_current_student_course_oneArgs = {
  object: current_student_course_insert_input;
};

/** mutation root */
export type mutation_rootinsert_current_student_oneArgs = {
  object: current_student_insert_input;
};

/** mutation root */
export type mutation_rootinsert_current_userArgs = {
  objects: Array<current_user_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_current_user_oneArgs = {
  object: current_user_insert_input;
};

/** mutation root */
export type mutation_rootinsert_current_user_routeArgs = {
  objects: Array<current_user_route_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_current_user_route_oneArgs = {
  object: current_user_route_insert_input;
};

/** mutation root */
export type mutation_rootinsert_departmentArgs = {
  objects: Array<department_insert_input>;
  on_conflict?: Maybe<department_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_department_oneArgs = {
  object: department_insert_input;
  on_conflict?: Maybe<department_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_education_qualificationArgs = {
  objects: Array<education_qualification_insert_input>;
  on_conflict?: Maybe<education_qualification_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_education_qualification_oneArgs = {
  object: education_qualification_insert_input;
  on_conflict?: Maybe<education_qualification_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_employment_experienceArgs = {
  objects: Array<employment_experience_insert_input>;
  on_conflict?: Maybe<employment_experience_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_employment_experience_oneArgs = {
  object: employment_experience_insert_input;
  on_conflict?: Maybe<employment_experience_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_endpointArgs = {
  objects: Array<endpoint_insert_input>;
  on_conflict?: Maybe<endpoint_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_endpoint_oneArgs = {
  object: endpoint_insert_input;
  on_conflict?: Maybe<endpoint_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_answerArgs = {
  objects: Array<exit_interview_answer_insert_input>;
  on_conflict?: Maybe<exit_interview_answer_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_answer_multi_choice_questionsArgs = {
  objects: Array<exit_interview_answer_multi_choice_questions_insert_input>;
  on_conflict?: Maybe<exit_interview_answer_multi_choice_questions_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_answer_multi_choice_questions_oneArgs = {
  object: exit_interview_answer_multi_choice_questions_insert_input;
  on_conflict?: Maybe<exit_interview_answer_multi_choice_questions_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_answer_oneArgs = {
  object: exit_interview_answer_insert_input;
  on_conflict?: Maybe<exit_interview_answer_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_questionArgs = {
  objects: Array<exit_interview_question_insert_input>;
  on_conflict?: Maybe<exit_interview_question_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_question_answersArgs = {
  objects: Array<exit_interview_question_answers_insert_input>;
  on_conflict?: Maybe<exit_interview_question_answers_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_question_answers_oneArgs = {
  object: exit_interview_question_answers_insert_input;
  on_conflict?: Maybe<exit_interview_question_answers_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_question_groupArgs = {
  objects: Array<exit_interview_question_group_insert_input>;
  on_conflict?: Maybe<exit_interview_question_group_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_question_group_oneArgs = {
  object: exit_interview_question_group_insert_input;
  on_conflict?: Maybe<exit_interview_question_group_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_exit_interview_question_oneArgs = {
  object: exit_interview_question_insert_input;
  on_conflict?: Maybe<exit_interview_question_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_inquiryArgs = {
  objects: Array<inquiry_insert_input>;
  on_conflict?: Maybe<inquiry_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_inquiry_oneArgs = {
  object: inquiry_insert_input;
  on_conflict?: Maybe<inquiry_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_inquiry_status_enumArgs = {
  objects: Array<inquiry_status_enum_insert_input>;
  on_conflict?: Maybe<inquiry_status_enum_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_inquiry_status_enum_oneArgs = {
  object: inquiry_status_enum_insert_input;
  on_conflict?: Maybe<inquiry_status_enum_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_intakeArgs = {
  objects: Array<intake_insert_input>;
  on_conflict?: Maybe<intake_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_intake_oneArgs = {
  object: intake_insert_input;
  on_conflict?: Maybe<intake_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_lecture_materialArgs = {
  objects: Array<lecture_material_insert_input>;
  on_conflict?: Maybe<lecture_material_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_lecture_material_categoryArgs = {
  objects: Array<lecture_material_category_insert_input>;
  on_conflict?: Maybe<lecture_material_category_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_lecture_material_category_oneArgs = {
  object: lecture_material_category_insert_input;
  on_conflict?: Maybe<lecture_material_category_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_lecture_material_oneArgs = {
  object: lecture_material_insert_input;
  on_conflict?: Maybe<lecture_material_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_locationArgs = {
  objects: Array<location_insert_input>;
  on_conflict?: Maybe<location_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_location_oneArgs = {
  object: location_insert_input;
  on_conflict?: Maybe<location_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_multi_choice_questionArgs = {
  objects: Array<multi_choice_question_insert_input>;
  on_conflict?: Maybe<multi_choice_question_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_multi_choice_question_oneArgs = {
  object: multi_choice_question_insert_input;
  on_conflict?: Maybe<multi_choice_question_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_perfomance_statusArgs = {
  objects: Array<perfomance_status_insert_input>;
  on_conflict?: Maybe<perfomance_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_perfomance_status_oneArgs = {
  object: perfomance_status_insert_input;
  on_conflict?: Maybe<perfomance_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_question_typeArgs = {
  objects: Array<question_type_insert_input>;
  on_conflict?: Maybe<question_type_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_question_type_oneArgs = {
  object: question_type_insert_input;
  on_conflict?: Maybe<question_type_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_result_sheetArgs = {
  objects: Array<result_sheet_insert_input>;
  on_conflict?: Maybe<result_sheet_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_result_sheet_oneArgs = {
  object: result_sheet_insert_input;
  on_conflict?: Maybe<result_sheet_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_result_sheet_statusArgs = {
  objects: Array<result_sheet_status_insert_input>;
  on_conflict?: Maybe<result_sheet_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_result_sheet_status_oneArgs = {
  object: result_sheet_status_insert_input;
  on_conflict?: Maybe<result_sheet_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_routeArgs = {
  objects: Array<route_insert_input>;
  on_conflict?: Maybe<route_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_route_endpoints_endpointArgs = {
  objects: Array<route_endpoints_endpoint_insert_input>;
  on_conflict?: Maybe<route_endpoints_endpoint_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_route_endpoints_endpoint_oneArgs = {
  object: route_endpoints_endpoint_insert_input;
  on_conflict?: Maybe<route_endpoints_endpoint_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_route_oneArgs = {
  object: route_insert_input;
  on_conflict?: Maybe<route_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_studentArgs = {
  objects: Array<student_insert_input>;
  on_conflict?: Maybe<student_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_admin_editable_informationArgs = {
  objects: Array<student_admin_editable_information_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_student_admin_editable_information_oneArgs = {
  object: student_admin_editable_information_insert_input;
};

/** mutation root */
export type mutation_rootinsert_student_assessment_submissionArgs = {
  objects: Array<student_assessment_submission_insert_input>;
  on_conflict?: Maybe<student_assessment_submission_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_assessment_submission_oneArgs = {
  object: student_assessment_submission_insert_input;
  on_conflict?: Maybe<student_assessment_submission_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_attendance_statusArgs = {
  objects: Array<student_attendance_status_insert_input>;
  on_conflict?: Maybe<student_attendance_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_attendance_status_oneArgs = {
  object: student_attendance_status_insert_input;
  on_conflict?: Maybe<student_attendance_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_batch_classes_batch_classArgs = {
  objects: Array<student_batch_classes_batch_class_insert_input>;
  on_conflict?: Maybe<student_batch_classes_batch_class_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_batch_classes_batch_class_oneArgs = {
  object: student_batch_classes_batch_class_insert_input;
  on_conflict?: Maybe<student_batch_classes_batch_class_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_batch_historyArgs = {
  objects: Array<student_batch_history_insert_input>;
  on_conflict?: Maybe<student_batch_history_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_batch_history_oneArgs = {
  object: student_batch_history_insert_input;
  on_conflict?: Maybe<student_batch_history_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_batch_history_subjectArgs = {
  objects: Array<student_batch_history_subject_insert_input>;
  on_conflict?: Maybe<student_batch_history_subject_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_batch_history_subject_oneArgs = {
  object: student_batch_history_subject_insert_input;
  on_conflict?: Maybe<student_batch_history_subject_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_courseArgs = {
  objects: Array<student_course_insert_input>;
  on_conflict?: Maybe<student_course_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_course_oneArgs = {
  object: student_course_insert_input;
  on_conflict?: Maybe<student_course_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_external_engagement_requestArgs = {
  objects: Array<student_external_engagement_request_insert_input>;
  on_conflict?: Maybe<student_external_engagement_request_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_external_engagement_request_oneArgs = {
  object: student_external_engagement_request_insert_input;
  on_conflict?: Maybe<student_external_engagement_request_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_familiarization_formArgs = {
  objects: Array<student_familiarization_form_insert_input>;
  on_conflict?: Maybe<student_familiarization_form_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_familiarization_form_oneArgs = {
  object: student_familiarization_form_insert_input;
  on_conflict?: Maybe<student_familiarization_form_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_familiarization_interviewArgs = {
  objects: Array<student_familiarization_interview_insert_input>;
  on_conflict?: Maybe<student_familiarization_interview_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_familiarization_interview_oneArgs = {
  object: student_familiarization_interview_insert_input;
  on_conflict?: Maybe<student_familiarization_interview_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_for_batchArgs = {
  objects: Array<student_for_batch_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_student_for_batch_oneArgs = {
  object: student_for_batch_insert_input;
};

/** mutation root */
export type mutation_rootinsert_student_general_requestArgs = {
  objects: Array<student_general_request_insert_input>;
  on_conflict?: Maybe<student_general_request_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_general_request_oneArgs = {
  object: student_general_request_insert_input;
  on_conflict?: Maybe<student_general_request_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_medical_requestArgs = {
  objects: Array<student_medical_request_insert_input>;
  on_conflict?: Maybe<student_medical_request_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_medical_request_oneArgs = {
  object: student_medical_request_insert_input;
  on_conflict?: Maybe<student_medical_request_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_oneArgs = {
  object: student_insert_input;
  on_conflict?: Maybe<student_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_performanceArgs = {
  objects: Array<student_performance_insert_input>;
  on_conflict?: Maybe<student_performance_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_performance_oneArgs = {
  object: student_performance_insert_input;
  on_conflict?: Maybe<student_performance_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_requestArgs = {
  objects: Array<student_request_insert_input>;
  on_conflict?: Maybe<student_request_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_request_messageArgs = {
  objects: Array<student_request_message_insert_input>;
  on_conflict?: Maybe<student_request_message_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_request_message_oneArgs = {
  object: student_request_message_insert_input;
  on_conflict?: Maybe<student_request_message_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_request_oneArgs = {
  object: student_request_insert_input;
  on_conflict?: Maybe<student_request_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_request_requesteeArgs = {
  objects: Array<student_request_requestee_insert_input>;
  on_conflict?: Maybe<student_request_requestee_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_request_requestee_oneArgs = {
  object: student_request_requestee_insert_input;
  on_conflict?: Maybe<student_request_requestee_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_request_statusArgs = {
  objects: Array<student_request_status_insert_input>;
  on_conflict?: Maybe<student_request_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_request_status_oneArgs = {
  object: student_request_status_insert_input;
  on_conflict?: Maybe<student_request_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_resultArgs = {
  objects: Array<student_result_insert_input>;
  on_conflict?: Maybe<student_result_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_result_oneArgs = {
  object: student_result_insert_input;
  on_conflict?: Maybe<student_result_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_result_sheetArgs = {
  objects: Array<student_result_sheet_insert_input>;
  on_conflict?: Maybe<student_result_sheet_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_result_sheet_oneArgs = {
  object: student_result_sheet_insert_input;
  on_conflict?: Maybe<student_result_sheet_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_self_editable_informationArgs = {
  objects: Array<student_self_editable_information_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_student_self_editable_information_oneArgs = {
  object: student_self_editable_information_insert_input;
};

/** mutation root */
export type mutation_rootinsert_student_statusArgs = {
  objects: Array<student_status_insert_input>;
  on_conflict?: Maybe<student_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_student_status_oneArgs = {
  object: student_status_insert_input;
  on_conflict?: Maybe<student_status_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_subjectArgs = {
  objects: Array<subject_insert_input>;
  on_conflict?: Maybe<subject_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_subject_extra_slotArgs = {
  objects: Array<subject_extra_slot_insert_input>;
  on_conflict?: Maybe<subject_extra_slot_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_subject_extra_slot_oneArgs = {
  object: subject_extra_slot_insert_input;
  on_conflict?: Maybe<subject_extra_slot_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_subject_oneArgs = {
  object: subject_insert_input;
  on_conflict?: Maybe<subject_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_subject_to_userArgs = {
  objects: Array<subject_to_user_insert_input>;
  on_conflict?: Maybe<subject_to_user_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_subject_to_user_oneArgs = {
  object: subject_to_user_insert_input;
  on_conflict?: Maybe<subject_to_user_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_timetable_itemArgs = {
  objects: Array<timetable_item_insert_input>;
  on_conflict?: Maybe<timetable_item_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_timetable_item_oneArgs = {
  object: timetable_item_insert_input;
  on_conflict?: Maybe<timetable_item_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_timetable_timeslot_configurationArgs = {
  objects: Array<timetable_timeslot_configuration_insert_input>;
  on_conflict?: Maybe<timetable_timeslot_configuration_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_timetable_timeslot_configuration_oneArgs = {
  object: timetable_timeslot_configuration_insert_input;
  on_conflict?: Maybe<timetable_timeslot_configuration_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_userArgs = {
  objects: Array<user_insert_input>;
  on_conflict?: Maybe<user_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_oneArgs = {
  object: user_insert_input;
  on_conflict?: Maybe<user_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_performance_publicArgs = {
  objects: Array<user_performance_public_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_user_performance_public_oneArgs = {
  object: user_performance_public_insert_input;
};

/** mutation root */
export type mutation_rootinsert_user_publicArgs = {
  objects: Array<user_public_insert_input>;
};

/** mutation root */
export type mutation_rootinsert_user_public_oneArgs = {
  object: user_public_insert_input;
};

/** mutation root */
export type mutation_rootinsert_user_roleArgs = {
  objects: Array<user_role_insert_input>;
  on_conflict?: Maybe<user_role_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_role_oneArgs = {
  object: user_role_insert_input;
  on_conflict?: Maybe<user_role_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_role_routes_routeArgs = {
  objects: Array<user_role_routes_route_insert_input>;
  on_conflict?: Maybe<user_role_routes_route_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_role_routes_route_oneArgs = {
  object: user_role_routes_route_insert_input;
  on_conflict?: Maybe<user_role_routes_route_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_routes_routeArgs = {
  objects: Array<user_routes_route_insert_input>;
  on_conflict?: Maybe<user_routes_route_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_routes_route_oneArgs = {
  object: user_routes_route_insert_input;
  on_conflict?: Maybe<user_routes_route_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_user_roles_user_roleArgs = {
  objects: Array<user_user_roles_user_role_insert_input>;
  on_conflict?: Maybe<user_user_roles_user_role_on_conflict>;
};

/** mutation root */
export type mutation_rootinsert_user_user_roles_user_role_oneArgs = {
  object: user_user_roles_user_role_insert_input;
  on_conflict?: Maybe<user_user_roles_user_role_on_conflict>;
};

/** mutation root */
export type mutation_rootreSendLoginEmailArgs = {
  data: ReSendLoginEmailInput;
};

/** mutation root */
export type mutation_rootregisterStudentArgs = {
  data: RegisterStudentInput;
};

/** mutation root */
export type mutation_rootupdateFinalStudentDetailsArgs = {
  data: UpdateFinalStudentDetailsInput;
  where: UpdateFinalStudentDetailsWhereInput;
};

/** mutation root */
export type mutation_rootupdateInquiryArgs = {
  data: UpdateInquiryInput;
  where: UpdateInquiryWhereInput;
};

/** mutation root */
export type mutation_rootupdateStudentArgs = {
  data: UpdateStudentInput;
  where: UpdateStudentWhereInput;
};

/** mutation root */
export type mutation_rootupdateStudentRequestStatusArgs = {
  data: UpdateStudentRequestStatusInput;
  where: UpdateStudentRequestStatusWhereInput;
};

/** mutation root */
export type mutation_rootupdateUserArgs = {
  data: UpdateUserInput;
  where: UpdateUserWhereInput;
};

/** mutation root */
export type mutation_rootupdateUserActiveStateArgs = {
  data: UpdateUserActiveStateInput;
};

/** mutation root */
export type mutation_rootupdate_academic_calendar_itemArgs = {
  _set?: Maybe<academic_calendar_item_set_input>;
  where: academic_calendar_item_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_academic_calendar_item_by_pkArgs = {
  _set?: Maybe<academic_calendar_item_set_input>;
  pk_columns: academic_calendar_item_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_active_batchArgs = {
  _inc?: Maybe<active_batch_inc_input>;
  _set?: Maybe<active_batch_set_input>;
  where: active_batch_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_assessmentArgs = {
  _inc?: Maybe<assessment_inc_input>;
  _set?: Maybe<assessment_set_input>;
  where: assessment_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_assessment_by_pkArgs = {
  _inc?: Maybe<assessment_inc_input>;
  _set?: Maybe<assessment_set_input>;
  pk_columns: assessment_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_attendanceArgs = {
  _set?: Maybe<attendance_set_input>;
  where: attendance_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_attendance_by_pkArgs = {
  _set?: Maybe<attendance_set_input>;
  pk_columns: attendance_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_attendance_studentArgs = {
  _inc?: Maybe<attendance_student_inc_input>;
  _set?: Maybe<attendance_student_set_input>;
  where: attendance_student_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_attendance_student_by_pkArgs = {
  _inc?: Maybe<attendance_student_inc_input>;
  _set?: Maybe<attendance_student_set_input>;
  pk_columns: attendance_student_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_batchArgs = {
  _inc?: Maybe<batch_inc_input>;
  _set?: Maybe<batch_set_input>;
  where: batch_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_batch_by_pkArgs = {
  _inc?: Maybe<batch_inc_input>;
  _set?: Maybe<batch_set_input>;
  pk_columns: batch_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_batch_classArgs = {
  _set?: Maybe<batch_class_set_input>;
  where: batch_class_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_batch_class_by_pkArgs = {
  _set?: Maybe<batch_class_set_input>;
  pk_columns: batch_class_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_batch_subject_configurationArgs = {
  _inc?: Maybe<batch_subject_configuration_inc_input>;
  _set?: Maybe<batch_subject_configuration_set_input>;
  where: batch_subject_configuration_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_batch_subject_configuration_by_pkArgs = {
  _inc?: Maybe<batch_subject_configuration_inc_input>;
  _set?: Maybe<batch_subject_configuration_set_input>;
  pk_columns: batch_subject_configuration_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_batch_subject_extra_slotArgs = {
  _inc?: Maybe<batch_subject_extra_slot_inc_input>;
  _set?: Maybe<batch_subject_extra_slot_set_input>;
  where: batch_subject_extra_slot_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_batch_subject_extra_slot_by_pkArgs = {
  _inc?: Maybe<batch_subject_extra_slot_inc_input>;
  _set?: Maybe<batch_subject_extra_slot_set_input>;
  pk_columns: batch_subject_extra_slot_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_blood_typeArgs = {
  _set?: Maybe<blood_type_set_input>;
  where: blood_type_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_blood_type_by_pkArgs = {
  _set?: Maybe<blood_type_set_input>;
  pk_columns: blood_type_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_courseArgs = {
  _inc?: Maybe<course_inc_input>;
  _set?: Maybe<course_set_input>;
  where: course_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_course_by_pkArgs = {
  _inc?: Maybe<course_inc_input>;
  _set?: Maybe<course_set_input>;
  pk_columns: course_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_course_coordinatorArgs = {
  _set?: Maybe<course_coordinator_set_input>;
  where: course_coordinator_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_course_coordinator_by_pkArgs = {
  _set?: Maybe<course_coordinator_set_input>;
  pk_columns: course_coordinator_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_course_levelArgs = {
  _set?: Maybe<course_level_set_input>;
  where: course_level_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_course_level_by_pkArgs = {
  _set?: Maybe<course_level_set_input>;
  pk_columns: course_level_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_course_semesterArgs = {
  _inc?: Maybe<course_semester_inc_input>;
  _set?: Maybe<course_semester_set_input>;
  where: course_semester_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_course_semester_by_pkArgs = {
  _inc?: Maybe<course_semester_inc_input>;
  _set?: Maybe<course_semester_set_input>;
  pk_columns: course_semester_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_course_semester_subjects_subjectArgs = {
  _set?: Maybe<course_semester_subjects_subject_set_input>;
  where: course_semester_subjects_subject_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_course_semester_subjects_subject_by_pkArgs = {
  _set?: Maybe<course_semester_subjects_subject_set_input>;
  pk_columns: course_semester_subjects_subject_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_current_studentArgs = {
  _inc?: Maybe<current_student_inc_input>;
  _set?: Maybe<current_student_set_input>;
  where: current_student_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_current_student_courseArgs = {
  _inc?: Maybe<current_student_course_inc_input>;
  _set?: Maybe<current_student_course_set_input>;
  where: current_student_course_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_current_userArgs = {
  _set?: Maybe<current_user_set_input>;
  where: current_user_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_current_user_routeArgs = {
  _inc?: Maybe<current_user_route_inc_input>;
  _set?: Maybe<current_user_route_set_input>;
  where: current_user_route_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_departmentArgs = {
  _set?: Maybe<department_set_input>;
  where: department_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_department_by_pkArgs = {
  _set?: Maybe<department_set_input>;
  pk_columns: department_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_education_qualificationArgs = {
  _inc?: Maybe<education_qualification_inc_input>;
  _set?: Maybe<education_qualification_set_input>;
  where: education_qualification_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_education_qualification_by_pkArgs = {
  _inc?: Maybe<education_qualification_inc_input>;
  _set?: Maybe<education_qualification_set_input>;
  pk_columns: education_qualification_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_employment_experienceArgs = {
  _inc?: Maybe<employment_experience_inc_input>;
  _set?: Maybe<employment_experience_set_input>;
  where: employment_experience_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_employment_experience_by_pkArgs = {
  _inc?: Maybe<employment_experience_inc_input>;
  _set?: Maybe<employment_experience_set_input>;
  pk_columns: employment_experience_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_endpointArgs = {
  _set?: Maybe<endpoint_set_input>;
  where: endpoint_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_endpoint_by_pkArgs = {
  _set?: Maybe<endpoint_set_input>;
  pk_columns: endpoint_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_answerArgs = {
  _inc?: Maybe<exit_interview_answer_inc_input>;
  _set?: Maybe<exit_interview_answer_set_input>;
  where: exit_interview_answer_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_answer_by_pkArgs = {
  _inc?: Maybe<exit_interview_answer_inc_input>;
  _set?: Maybe<exit_interview_answer_set_input>;
  pk_columns: exit_interview_answer_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_answer_multi_choice_questionsArgs = {
  _set?: Maybe<exit_interview_answer_multi_choice_questions_set_input>;
  where: exit_interview_answer_multi_choice_questions_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_answer_multi_choice_questions_by_pkArgs = {
  _set?: Maybe<exit_interview_answer_multi_choice_questions_set_input>;
  pk_columns: exit_interview_answer_multi_choice_questions_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_questionArgs = {
  _set?: Maybe<exit_interview_question_set_input>;
  where: exit_interview_question_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_question_answersArgs = {
  _set?: Maybe<exit_interview_question_answers_set_input>;
  where: exit_interview_question_answers_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_question_answers_by_pkArgs = {
  _set?: Maybe<exit_interview_question_answers_set_input>;
  pk_columns: exit_interview_question_answers_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_question_by_pkArgs = {
  _set?: Maybe<exit_interview_question_set_input>;
  pk_columns: exit_interview_question_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_question_groupArgs = {
  _set?: Maybe<exit_interview_question_group_set_input>;
  where: exit_interview_question_group_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_exit_interview_question_group_by_pkArgs = {
  _set?: Maybe<exit_interview_question_group_set_input>;
  pk_columns: exit_interview_question_group_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_inquiryArgs = {
  _inc?: Maybe<inquiry_inc_input>;
  _set?: Maybe<inquiry_set_input>;
  where: inquiry_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_inquiry_by_pkArgs = {
  _inc?: Maybe<inquiry_inc_input>;
  _set?: Maybe<inquiry_set_input>;
  pk_columns: inquiry_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_inquiry_status_enumArgs = {
  _set?: Maybe<inquiry_status_enum_set_input>;
  where: inquiry_status_enum_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_inquiry_status_enum_by_pkArgs = {
  _set?: Maybe<inquiry_status_enum_set_input>;
  pk_columns: inquiry_status_enum_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_intakeArgs = {
  _inc?: Maybe<intake_inc_input>;
  _set?: Maybe<intake_set_input>;
  where: intake_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_intake_by_pkArgs = {
  _inc?: Maybe<intake_inc_input>;
  _set?: Maybe<intake_set_input>;
  pk_columns: intake_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_lecture_materialArgs = {
  _set?: Maybe<lecture_material_set_input>;
  where: lecture_material_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_lecture_material_by_pkArgs = {
  _set?: Maybe<lecture_material_set_input>;
  pk_columns: lecture_material_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_lecture_material_categoryArgs = {
  _set?: Maybe<lecture_material_category_set_input>;
  where: lecture_material_category_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_lecture_material_category_by_pkArgs = {
  _set?: Maybe<lecture_material_category_set_input>;
  pk_columns: lecture_material_category_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_locationArgs = {
  _set?: Maybe<location_set_input>;
  where: location_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_location_by_pkArgs = {
  _set?: Maybe<location_set_input>;
  pk_columns: location_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_multi_choice_questionArgs = {
  _set?: Maybe<multi_choice_question_set_input>;
  where: multi_choice_question_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_multi_choice_question_by_pkArgs = {
  _set?: Maybe<multi_choice_question_set_input>;
  pk_columns: multi_choice_question_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_perfomance_statusArgs = {
  _set?: Maybe<perfomance_status_set_input>;
  where: perfomance_status_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_perfomance_status_by_pkArgs = {
  _set?: Maybe<perfomance_status_set_input>;
  pk_columns: perfomance_status_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_question_typeArgs = {
  _set?: Maybe<question_type_set_input>;
  where: question_type_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_question_type_by_pkArgs = {
  _set?: Maybe<question_type_set_input>;
  pk_columns: question_type_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_result_sheetArgs = {
  _set?: Maybe<result_sheet_set_input>;
  where: result_sheet_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_result_sheet_by_pkArgs = {
  _set?: Maybe<result_sheet_set_input>;
  pk_columns: result_sheet_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_result_sheet_statusArgs = {
  _set?: Maybe<result_sheet_status_set_input>;
  where: result_sheet_status_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_result_sheet_status_by_pkArgs = {
  _set?: Maybe<result_sheet_status_set_input>;
  pk_columns: result_sheet_status_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_routeArgs = {
  _inc?: Maybe<route_inc_input>;
  _set?: Maybe<route_set_input>;
  where: route_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_route_by_pkArgs = {
  _inc?: Maybe<route_inc_input>;
  _set?: Maybe<route_set_input>;
  pk_columns: route_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_route_endpoints_endpointArgs = {
  _set?: Maybe<route_endpoints_endpoint_set_input>;
  where: route_endpoints_endpoint_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_route_endpoints_endpoint_by_pkArgs = {
  _set?: Maybe<route_endpoints_endpoint_set_input>;
  pk_columns: route_endpoints_endpoint_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_studentArgs = {
  _inc?: Maybe<student_inc_input>;
  _set?: Maybe<student_set_input>;
  where: student_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_admin_editable_informationArgs = {
  _inc?: Maybe<student_admin_editable_information_inc_input>;
  _set?: Maybe<student_admin_editable_information_set_input>;
  where: student_admin_editable_information_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_assessment_submissionArgs = {
  _inc?: Maybe<student_assessment_submission_inc_input>;
  _set?: Maybe<student_assessment_submission_set_input>;
  where: student_assessment_submission_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_assessment_submission_by_pkArgs = {
  _inc?: Maybe<student_assessment_submission_inc_input>;
  _set?: Maybe<student_assessment_submission_set_input>;
  pk_columns: student_assessment_submission_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_attendance_statusArgs = {
  _set?: Maybe<student_attendance_status_set_input>;
  where: student_attendance_status_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_attendance_status_by_pkArgs = {
  _set?: Maybe<student_attendance_status_set_input>;
  pk_columns: student_attendance_status_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_batch_classes_batch_classArgs = {
  _inc?: Maybe<student_batch_classes_batch_class_inc_input>;
  _set?: Maybe<student_batch_classes_batch_class_set_input>;
  where: student_batch_classes_batch_class_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_batch_classes_batch_class_by_pkArgs = {
  _inc?: Maybe<student_batch_classes_batch_class_inc_input>;
  _set?: Maybe<student_batch_classes_batch_class_set_input>;
  pk_columns: student_batch_classes_batch_class_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_batch_historyArgs = {
  _inc?: Maybe<student_batch_history_inc_input>;
  _set?: Maybe<student_batch_history_set_input>;
  where: student_batch_history_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_batch_history_by_pkArgs = {
  _inc?: Maybe<student_batch_history_inc_input>;
  _set?: Maybe<student_batch_history_set_input>;
  pk_columns: student_batch_history_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_batch_history_subjectArgs = {
  _set?: Maybe<student_batch_history_subject_set_input>;
  where: student_batch_history_subject_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_batch_history_subject_by_pkArgs = {
  _set?: Maybe<student_batch_history_subject_set_input>;
  pk_columns: student_batch_history_subject_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_by_pkArgs = {
  _inc?: Maybe<student_inc_input>;
  _set?: Maybe<student_set_input>;
  pk_columns: student_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_courseArgs = {
  _inc?: Maybe<student_course_inc_input>;
  _set?: Maybe<student_course_set_input>;
  where: student_course_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_course_by_pkArgs = {
  _inc?: Maybe<student_course_inc_input>;
  _set?: Maybe<student_course_set_input>;
  pk_columns: student_course_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_external_engagement_requestArgs = {
  _inc?: Maybe<student_external_engagement_request_inc_input>;
  _set?: Maybe<student_external_engagement_request_set_input>;
  where: student_external_engagement_request_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_external_engagement_request_by_pkArgs = {
  _inc?: Maybe<student_external_engagement_request_inc_input>;
  _set?: Maybe<student_external_engagement_request_set_input>;
  pk_columns: student_external_engagement_request_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_familiarization_formArgs = {
  _inc?: Maybe<student_familiarization_form_inc_input>;
  _set?: Maybe<student_familiarization_form_set_input>;
  where: student_familiarization_form_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_familiarization_form_by_pkArgs = {
  _inc?: Maybe<student_familiarization_form_inc_input>;
  _set?: Maybe<student_familiarization_form_set_input>;
  pk_columns: student_familiarization_form_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_familiarization_interviewArgs = {
  _inc?: Maybe<student_familiarization_interview_inc_input>;
  _set?: Maybe<student_familiarization_interview_set_input>;
  where: student_familiarization_interview_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_familiarization_interview_by_pkArgs = {
  _inc?: Maybe<student_familiarization_interview_inc_input>;
  _set?: Maybe<student_familiarization_interview_set_input>;
  pk_columns: student_familiarization_interview_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_for_batchArgs = {
  _inc?: Maybe<student_for_batch_inc_input>;
  _set?: Maybe<student_for_batch_set_input>;
  where: student_for_batch_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_general_requestArgs = {
  _inc?: Maybe<student_general_request_inc_input>;
  _set?: Maybe<student_general_request_set_input>;
  where: student_general_request_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_general_request_by_pkArgs = {
  _inc?: Maybe<student_general_request_inc_input>;
  _set?: Maybe<student_general_request_set_input>;
  pk_columns: student_general_request_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_medical_requestArgs = {
  _inc?: Maybe<student_medical_request_inc_input>;
  _set?: Maybe<student_medical_request_set_input>;
  where: student_medical_request_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_medical_request_by_pkArgs = {
  _inc?: Maybe<student_medical_request_inc_input>;
  _set?: Maybe<student_medical_request_set_input>;
  pk_columns: student_medical_request_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_performanceArgs = {
  _inc?: Maybe<student_performance_inc_input>;
  _set?: Maybe<student_performance_set_input>;
  where: student_performance_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_performance_by_pkArgs = {
  _inc?: Maybe<student_performance_inc_input>;
  _set?: Maybe<student_performance_set_input>;
  pk_columns: student_performance_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_requestArgs = {
  _inc?: Maybe<student_request_inc_input>;
  _set?: Maybe<student_request_set_input>;
  where: student_request_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_request_by_pkArgs = {
  _inc?: Maybe<student_request_inc_input>;
  _set?: Maybe<student_request_set_input>;
  pk_columns: student_request_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_request_messageArgs = {
  _inc?: Maybe<student_request_message_inc_input>;
  _set?: Maybe<student_request_message_set_input>;
  where: student_request_message_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_request_message_by_pkArgs = {
  _inc?: Maybe<student_request_message_inc_input>;
  _set?: Maybe<student_request_message_set_input>;
  pk_columns: student_request_message_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_request_requesteeArgs = {
  _inc?: Maybe<student_request_requestee_inc_input>;
  _set?: Maybe<student_request_requestee_set_input>;
  where: student_request_requestee_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_request_requestee_by_pkArgs = {
  _inc?: Maybe<student_request_requestee_inc_input>;
  _set?: Maybe<student_request_requestee_set_input>;
  pk_columns: student_request_requestee_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_request_statusArgs = {
  _set?: Maybe<student_request_status_set_input>;
  where: student_request_status_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_request_status_by_pkArgs = {
  _set?: Maybe<student_request_status_set_input>;
  pk_columns: student_request_status_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_resultArgs = {
  _inc?: Maybe<student_result_inc_input>;
  _set?: Maybe<student_result_set_input>;
  where: student_result_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_result_by_pkArgs = {
  _inc?: Maybe<student_result_inc_input>;
  _set?: Maybe<student_result_set_input>;
  pk_columns: student_result_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_result_sheetArgs = {
  _inc?: Maybe<student_result_sheet_inc_input>;
  _set?: Maybe<student_result_sheet_set_input>;
  where: student_result_sheet_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_result_sheet_by_pkArgs = {
  _inc?: Maybe<student_result_sheet_inc_input>;
  _set?: Maybe<student_result_sheet_set_input>;
  pk_columns: student_result_sheet_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_student_self_editable_informationArgs = {
  _inc?: Maybe<student_self_editable_information_inc_input>;
  _set?: Maybe<student_self_editable_information_set_input>;
  where: student_self_editable_information_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_statusArgs = {
  _set?: Maybe<student_status_set_input>;
  where: student_status_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_student_status_by_pkArgs = {
  _set?: Maybe<student_status_set_input>;
  pk_columns: student_status_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_subjectArgs = {
  _inc?: Maybe<subject_inc_input>;
  _set?: Maybe<subject_set_input>;
  where: subject_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_subject_by_pkArgs = {
  _inc?: Maybe<subject_inc_input>;
  _set?: Maybe<subject_set_input>;
  pk_columns: subject_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_subject_extra_slotArgs = {
  _inc?: Maybe<subject_extra_slot_inc_input>;
  _set?: Maybe<subject_extra_slot_set_input>;
  where: subject_extra_slot_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_subject_extra_slot_by_pkArgs = {
  _inc?: Maybe<subject_extra_slot_inc_input>;
  _set?: Maybe<subject_extra_slot_set_input>;
  pk_columns: subject_extra_slot_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_subject_to_userArgs = {
  _inc?: Maybe<subject_to_user_inc_input>;
  _set?: Maybe<subject_to_user_set_input>;
  where: subject_to_user_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_subject_to_user_by_pkArgs = {
  _inc?: Maybe<subject_to_user_inc_input>;
  _set?: Maybe<subject_to_user_set_input>;
  pk_columns: subject_to_user_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_timetable_itemArgs = {
  _set?: Maybe<timetable_item_set_input>;
  where: timetable_item_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_timetable_item_by_pkArgs = {
  _set?: Maybe<timetable_item_set_input>;
  pk_columns: timetable_item_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_timetable_timeslot_configurationArgs = {
  _set?: Maybe<timetable_timeslot_configuration_set_input>;
  where: timetable_timeslot_configuration_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_timetable_timeslot_configuration_by_pkArgs = {
  _set?: Maybe<timetable_timeslot_configuration_set_input>;
  pk_columns: timetable_timeslot_configuration_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_userArgs = {
  _set?: Maybe<user_set_input>;
  where: user_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_by_pkArgs = {
  _set?: Maybe<user_set_input>;
  pk_columns: user_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_user_performance_publicArgs = {
  _set?: Maybe<user_performance_public_set_input>;
  where: user_performance_public_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_publicArgs = {
  _set?: Maybe<user_public_set_input>;
  where: user_public_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_roleArgs = {
  _set?: Maybe<user_role_set_input>;
  where: user_role_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_role_by_pkArgs = {
  _set?: Maybe<user_role_set_input>;
  pk_columns: user_role_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_user_role_routes_routeArgs = {
  _set?: Maybe<user_role_routes_route_set_input>;
  where: user_role_routes_route_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_role_routes_route_by_pkArgs = {
  _set?: Maybe<user_role_routes_route_set_input>;
  pk_columns: user_role_routes_route_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_user_routes_routeArgs = {
  _set?: Maybe<user_routes_route_set_input>;
  where: user_routes_route_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_routes_route_by_pkArgs = {
  _set?: Maybe<user_routes_route_set_input>;
  pk_columns: user_routes_route_pk_columns_input;
};

/** mutation root */
export type mutation_rootupdate_user_user_roles_user_roleArgs = {
  _set?: Maybe<user_user_roles_user_role_set_input>;
  where: user_user_roles_user_role_bool_exp;
};

/** mutation root */
export type mutation_rootupdate_user_user_roles_user_role_by_pkArgs = {
  _set?: Maybe<user_user_roles_user_role_set_input>;
  pk_columns: user_user_roles_user_role_pk_columns_input;
};

/** mutation root */
export type mutation_rootupsertResultSheetArgs = {
  data: UpsertResultSheetInput;
};

/** column ordering options */
export enum order_by {
  /** in ascending order, nulls last */
  asc = 'asc',
  /** in ascending order, nulls first */
  asc_nulls_first = 'asc_nulls_first',
  /** in ascending order, nulls last */
  asc_nulls_last = 'asc_nulls_last',
  /** in descending order, nulls first */
  desc = 'desc',
  /** in descending order, nulls first */
  desc_nulls_first = 'desc_nulls_first',
  /** in descending order, nulls last */
  desc_nulls_last = 'desc_nulls_last',
}

/** columns and relationships of "perfomance_status" */
export type perfomance_status = {
  __typename?: 'perfomance_status';
  name: Scalars['String'];
  /** An array relationship */
  student_performances: Array<student_performance>;
  /** An aggregate relationship */
  student_performances_aggregate: student_performance_aggregate;
};

/** columns and relationships of "perfomance_status" */
export type perfomance_statusstudent_performancesArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

/** columns and relationships of "perfomance_status" */
export type perfomance_statusstudent_performances_aggregateArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

/** aggregated selection of "perfomance_status" */
export type perfomance_status_aggregate = {
  __typename?: 'perfomance_status_aggregate';
  aggregate?: Maybe<perfomance_status_aggregate_fields>;
  nodes: Array<perfomance_status>;
};

/** aggregate fields of "perfomance_status" */
export type perfomance_status_aggregate_fields = {
  __typename?: 'perfomance_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<perfomance_status_max_fields>;
  min?: Maybe<perfomance_status_min_fields>;
};

/** aggregate fields of "perfomance_status" */
export type perfomance_status_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<perfomance_status_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "perfomance_status". All fields are combined with a logical 'AND'. */
export type perfomance_status_bool_exp = {
  _and?: Maybe<Array<perfomance_status_bool_exp>>;
  _not?: Maybe<perfomance_status_bool_exp>;
  _or?: Maybe<Array<perfomance_status_bool_exp>>;
  name?: Maybe<String_comparison_exp>;
  student_performances?: Maybe<student_performance_bool_exp>;
};

/** unique or primary key constraints on table "perfomance_status" */
export enum perfomance_status_constraint {
  /** unique or primary key constraint */
  perfomance_status_pkey = 'perfomance_status_pkey',
}

export enum perfomance_status_enum {
  negative = 'negative',
  neutral = 'neutral',
  positive = 'positive',
}

/** Boolean expression to compare columns of type "perfomance_status_enum". All fields are combined with logical 'AND'. */
export type perfomance_status_enum_comparison_exp = {
  _eq?: Maybe<perfomance_status_enum>;
  _in?: Maybe<Array<perfomance_status_enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<perfomance_status_enum>;
  _nin?: Maybe<Array<perfomance_status_enum>>;
};

/** input type for inserting data into table "perfomance_status" */
export type perfomance_status_insert_input = {
  name?: Maybe<Scalars['String']>;
  student_performances?: Maybe<student_performance_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type perfomance_status_max_fields = {
  __typename?: 'perfomance_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type perfomance_status_min_fields = {
  __typename?: 'perfomance_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "perfomance_status" */
export type perfomance_status_mutation_response = {
  __typename?: 'perfomance_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<perfomance_status>;
};

/** on conflict condition type for table "perfomance_status" */
export type perfomance_status_on_conflict = {
  constraint: perfomance_status_constraint;
  update_columns?: Array<perfomance_status_update_column>;
  where?: Maybe<perfomance_status_bool_exp>;
};

/** Ordering options when selecting data from "perfomance_status". */
export type perfomance_status_order_by = {
  name?: Maybe<order_by>;
  student_performances_aggregate?: Maybe<student_performance_aggregate_order_by>;
};

/** primary key columns input for table: perfomance_status */
export type perfomance_status_pk_columns_input = {
  name: Scalars['String'];
};

/** select columns of table "perfomance_status" */
export enum perfomance_status_select_column {
  /** column name */
  name = 'name',
}

/** input type for updating data in table "perfomance_status" */
export type perfomance_status_set_input = {
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "perfomance_status" */
export enum perfomance_status_update_column {
  /** column name */
  name = 'name',
}

export type query_root = {
  __typename?: 'query_root';
  /** fetch data from the table: "academic_calendar_item" */
  academic_calendar_item: Array<academic_calendar_item>;
  /** fetch aggregated fields from the table: "academic_calendar_item" */
  academic_calendar_item_aggregate: academic_calendar_item_aggregate;
  /** fetch data from the table: "academic_calendar_item" using primary key columns */
  academic_calendar_item_by_pk?: Maybe<academic_calendar_item>;
  /** fetch data from the table: "active_batch" */
  active_batch: Array<active_batch>;
  /** fetch aggregated fields from the table: "active_batch" */
  active_batch_aggregate: active_batch_aggregate;
  /** fetch data from the table: "assessment" */
  assessment: Array<assessment>;
  assessmentResourcesUploadURLs: Array<UploadURLs>;
  /** fetch aggregated fields from the table: "assessment" */
  assessment_aggregate: assessment_aggregate;
  /** fetch data from the table: "assessment" using primary key columns */
  assessment_by_pk?: Maybe<assessment>;
  /** fetch data from the table: "attendance" */
  attendance: Array<attendance>;
  /** fetch aggregated fields from the table: "attendance" */
  attendance_aggregate: attendance_aggregate;
  /** fetch data from the table: "attendance" using primary key columns */
  attendance_by_pk?: Maybe<attendance>;
  /** fetch data from the table: "attendance_student" */
  attendance_student: Array<attendance_student>;
  /** fetch aggregated fields from the table: "attendance_student" */
  attendance_student_aggregate: attendance_student_aggregate;
  /** fetch data from the table: "attendance_student" using primary key columns */
  attendance_student_by_pk?: Maybe<attendance_student>;
  /** fetch data from the table: "batch" */
  batch: Array<batch>;
  /** fetch aggregated fields from the table: "batch" */
  batch_aggregate: batch_aggregate;
  /** fetch data from the table: "batch" using primary key columns */
  batch_by_pk?: Maybe<batch>;
  /** fetch data from the table: "batch_class" */
  batch_class: Array<batch_class>;
  /** fetch aggregated fields from the table: "batch_class" */
  batch_class_aggregate: batch_class_aggregate;
  /** An array relationship */
  batch_class_batch_subject_configurations: Array<batch_class_batch_subject_configurations>;
  /** An aggregate relationship */
  batch_class_batch_subject_configurations_aggregate: batch_class_batch_subject_configurations_aggregate;
  /** An array relationship */
  batch_class_batch_subject_extra_slot: Array<batch_class_batch_subject_extra_slot>;
  /** An aggregate relationship */
  batch_class_batch_subject_extra_slot_aggregate: batch_class_batch_subject_extra_slot_aggregate;
  /** fetch data from the table: "batch_class" using primary key columns */
  batch_class_by_pk?: Maybe<batch_class>;
  /** fetch data from the table: "batch_subject_configuration" */
  batch_subject_configuration: Array<batch_subject_configuration>;
  /** fetch aggregated fields from the table: "batch_subject_configuration" */
  batch_subject_configuration_aggregate: batch_subject_configuration_aggregate;
  /** fetch data from the table: "batch_subject_configuration" using primary key columns */
  batch_subject_configuration_by_pk?: Maybe<batch_subject_configuration>;
  /** fetch data from the table: "batch_subject_extra_slot" */
  batch_subject_extra_slot: Array<batch_subject_extra_slot>;
  /** fetch aggregated fields from the table: "batch_subject_extra_slot" */
  batch_subject_extra_slot_aggregate: batch_subject_extra_slot_aggregate;
  /** fetch data from the table: "batch_subject_extra_slot" using primary key columns */
  batch_subject_extra_slot_by_pk?: Maybe<batch_subject_extra_slot>;
  /** fetch data from the table: "blood_type" */
  blood_type: Array<blood_type>;
  /** fetch aggregated fields from the table: "blood_type" */
  blood_type_aggregate: blood_type_aggregate;
  /** fetch data from the table: "blood_type" using primary key columns */
  blood_type_by_pk?: Maybe<blood_type>;
  /** fetch data from the table: "course" */
  course: Array<course>;
  /** fetch aggregated fields from the table: "course" */
  course_aggregate: course_aggregate;
  /** fetch data from the table: "course" using primary key columns */
  course_by_pk?: Maybe<course>;
  /** fetch data from the table: "course_coordinator" */
  course_coordinator: Array<course_coordinator>;
  /** fetch aggregated fields from the table: "course_coordinator" */
  course_coordinator_aggregate: course_coordinator_aggregate;
  /** fetch data from the table: "course_coordinator" using primary key columns */
  course_coordinator_by_pk?: Maybe<course_coordinator>;
  /** fetch data from the table: "course_level" */
  course_level: Array<course_level>;
  /** fetch aggregated fields from the table: "course_level" */
  course_level_aggregate: course_level_aggregate;
  /** fetch data from the table: "course_level" using primary key columns */
  course_level_by_pk?: Maybe<course_level>;
  /** fetch data from the table: "course_semester" */
  course_semester: Array<course_semester>;
  /** fetch aggregated fields from the table: "course_semester" */
  course_semester_aggregate: course_semester_aggregate;
  /** fetch data from the table: "course_semester" using primary key columns */
  course_semester_by_pk?: Maybe<course_semester>;
  /** fetch data from the table: "course_semester_subjects_subject" */
  course_semester_subjects_subject: Array<course_semester_subjects_subject>;
  /** fetch aggregated fields from the table: "course_semester_subjects_subject" */
  course_semester_subjects_subject_aggregate: course_semester_subjects_subject_aggregate;
  /** fetch data from the table: "course_semester_subjects_subject" using primary key columns */
  course_semester_subjects_subject_by_pk?: Maybe<course_semester_subjects_subject>;
  /** fetch data from the table: "current_student" */
  current_student: Array<current_student>;
  /** fetch aggregated fields from the table: "current_student" */
  current_student_aggregate: current_student_aggregate;
  /** fetch data from the table: "current_student_course" */
  current_student_course: Array<current_student_course>;
  /** fetch aggregated fields from the table: "current_student_course" */
  current_student_course_aggregate: current_student_course_aggregate;
  /** fetch data from the table: "current_student_routes_route" */
  current_student_routes_route: Array<current_student_routes_route>;
  /** fetch aggregated fields from the table: "current_student_routes_route" */
  current_student_routes_route_aggregate: current_student_routes_route_aggregate;
  /** fetch data from the table: "current_user" */
  current_user: Array<current_user>;
  /** fetch aggregated fields from the table: "current_user" */
  current_user_aggregate: current_user_aggregate;
  /** fetch data from the table: "current_user_route" */
  current_user_route: Array<current_user_route>;
  /** fetch aggregated fields from the table: "current_user_route" */
  current_user_route_aggregate: current_user_route_aggregate;
  /** fetch data from the table: "current_user_routes_route" */
  current_user_routes_route: Array<current_user_routes_route>;
  /** An aggregate relationship */
  current_user_routes_route_aggregate: current_user_routes_route_aggregate;
  /** fetch data from the table: "department" */
  department: Array<department>;
  /** fetch aggregated fields from the table: "department" */
  department_aggregate: department_aggregate;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<department>;
  departmentsForStudent: Array<DepartmentForStudent>;
  /** fetch data from the table: "education_qualification" */
  education_qualification: Array<education_qualification>;
  /** fetch aggregated fields from the table: "education_qualification" */
  education_qualification_aggregate: education_qualification_aggregate;
  /** fetch data from the table: "education_qualification" using primary key columns */
  education_qualification_by_pk?: Maybe<education_qualification>;
  /** fetch data from the table: "employment_experience" */
  employment_experience: Array<employment_experience>;
  /** fetch aggregated fields from the table: "employment_experience" */
  employment_experience_aggregate: employment_experience_aggregate;
  /** fetch data from the table: "employment_experience" using primary key columns */
  employment_experience_by_pk?: Maybe<employment_experience>;
  /** fetch data from the table: "endpoint" */
  endpoint: Array<endpoint>;
  /** fetch aggregated fields from the table: "endpoint" */
  endpoint_aggregate: endpoint_aggregate;
  /** fetch data from the table: "endpoint" using primary key columns */
  endpoint_by_pk?: Maybe<endpoint>;
  /** An array relationship */
  exit_interview_answer: Array<exit_interview_answer>;
  /** An aggregate relationship */
  exit_interview_answer_aggregate: exit_interview_answer_aggregate;
  /** fetch data from the table: "exit_interview_answer" using primary key columns */
  exit_interview_answer_by_pk?: Maybe<exit_interview_answer>;
  /** An array relationship */
  exit_interview_answer_multi_choice_questions: Array<exit_interview_answer_multi_choice_questions>;
  /** An aggregate relationship */
  exit_interview_answer_multi_choice_questions_aggregate: exit_interview_answer_multi_choice_questions_aggregate;
  /** fetch data from the table: "exit_interview_answer_multi_choice_questions" using primary key columns */
  exit_interview_answer_multi_choice_questions_by_pk?: Maybe<exit_interview_answer_multi_choice_questions>;
  /** fetch data from the table: "exit_interview_question" */
  exit_interview_question: Array<exit_interview_question>;
  /** fetch aggregated fields from the table: "exit_interview_question" */
  exit_interview_question_aggregate: exit_interview_question_aggregate;
  /** An array relationship */
  exit_interview_question_answers: Array<exit_interview_question_answers>;
  /** An aggregate relationship */
  exit_interview_question_answers_aggregate: exit_interview_question_answers_aggregate;
  /** fetch data from the table: "exit_interview_question_answers" using primary key columns */
  exit_interview_question_answers_by_pk?: Maybe<exit_interview_question_answers>;
  /** fetch data from the table: "exit_interview_question" using primary key columns */
  exit_interview_question_by_pk?: Maybe<exit_interview_question>;
  /** fetch data from the table: "exit_interview_question_group" */
  exit_interview_question_group: Array<exit_interview_question_group>;
  /** fetch aggregated fields from the table: "exit_interview_question_group" */
  exit_interview_question_group_aggregate: exit_interview_question_group_aggregate;
  /** fetch data from the table: "exit_interview_question_group" using primary key columns */
  exit_interview_question_group_by_pk?: Maybe<exit_interview_question_group>;
  finalStudentDetails: FinalStudentDetailsResult;
  /** An array relationship */
  inquiry: Array<inquiry>;
  /** An aggregate relationship */
  inquiry_aggregate: inquiry_aggregate;
  /** fetch data from the table: "inquiry" using primary key columns */
  inquiry_by_pk?: Maybe<inquiry>;
  /** fetch data from the table: "inquiry_status_enum" */
  inquiry_status_enum: Array<inquiry_status_enum>;
  /** fetch aggregated fields from the table: "inquiry_status_enum" */
  inquiry_status_enum_aggregate: inquiry_status_enum_aggregate;
  /** fetch data from the table: "inquiry_status_enum" using primary key columns */
  inquiry_status_enum_by_pk?: Maybe<inquiry_status_enum>;
  /** fetch data from the table: "intake" */
  intake: Array<intake>;
  /** fetch aggregated fields from the table: "intake" */
  intake_aggregate: intake_aggregate;
  /** fetch data from the table: "intake" using primary key columns */
  intake_by_pk?: Maybe<intake>;
  lectureMaterialAttachmentsUploadURLs: Array<UploadURLs>;
  /** fetch data from the table: "lecture_material" */
  lecture_material: Array<lecture_material>;
  /** fetch aggregated fields from the table: "lecture_material" */
  lecture_material_aggregate: lecture_material_aggregate;
  /** fetch data from the table: "lecture_material" using primary key columns */
  lecture_material_by_pk?: Maybe<lecture_material>;
  /** fetch data from the table: "lecture_material_category" */
  lecture_material_category: Array<lecture_material_category>;
  /** fetch aggregated fields from the table: "lecture_material_category" */
  lecture_material_category_aggregate: lecture_material_category_aggregate;
  /** fetch data from the table: "lecture_material_category" using primary key columns */
  lecture_material_category_by_pk?: Maybe<lecture_material_category>;
  /** fetch data from the table: "lecturer" */
  lecturer: Array<lecturer>;
  /** fetch aggregated fields from the table: "lecturer" */
  lecturer_aggregate: lecturer_aggregate;
  /** fetch data from the table: "location" */
  location: Array<location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: location_aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<location>;
  /** fetch data from the table: "multi_choice_question" */
  multi_choice_question: Array<multi_choice_question>;
  /** fetch aggregated fields from the table: "multi_choice_question" */
  multi_choice_question_aggregate: multi_choice_question_aggregate;
  /** fetch data from the table: "multi_choice_question" using primary key columns */
  multi_choice_question_by_pk?: Maybe<multi_choice_question>;
  /** fetch data from the table: "perfomance_status" */
  perfomance_status: Array<perfomance_status>;
  /** fetch aggregated fields from the table: "perfomance_status" */
  perfomance_status_aggregate: perfomance_status_aggregate;
  /** fetch data from the table: "perfomance_status" using primary key columns */
  perfomance_status_by_pk?: Maybe<perfomance_status>;
  profilePictureUploadURL: ProfilePictureUploadURL;
  /** fetch data from the table: "question_type" */
  question_type: Array<question_type>;
  /** fetch aggregated fields from the table: "question_type" */
  question_type_aggregate: question_type_aggregate;
  /** fetch data from the table: "question_type" using primary key columns */
  question_type_by_pk?: Maybe<question_type>;
  resultSheetReport: Array<ResultSheetReportResult>;
  /** fetch data from the table: "result_sheet" */
  result_sheet: Array<result_sheet>;
  /** fetch aggregated fields from the table: "result_sheet" */
  result_sheet_aggregate: result_sheet_aggregate;
  /** fetch data from the table: "result_sheet" using primary key columns */
  result_sheet_by_pk?: Maybe<result_sheet>;
  /** fetch data from the table: "result_sheet_status" */
  result_sheet_status: Array<result_sheet_status>;
  /** fetch aggregated fields from the table: "result_sheet_status" */
  result_sheet_status_aggregate: result_sheet_status_aggregate;
  /** fetch data from the table: "result_sheet_status" using primary key columns */
  result_sheet_status_by_pk?: Maybe<result_sheet_status>;
  /** fetch data from the table: "route" */
  route: Array<route>;
  /** fetch aggregated fields from the table: "route" */
  route_aggregate: route_aggregate;
  /** fetch data from the table: "route" using primary key columns */
  route_by_pk?: Maybe<route>;
  /** fetch data from the table: "route_endpoints_endpoint" */
  route_endpoints_endpoint: Array<route_endpoints_endpoint>;
  /** fetch aggregated fields from the table: "route_endpoints_endpoint" */
  route_endpoints_endpoint_aggregate: route_endpoints_endpoint_aggregate;
  /** fetch data from the table: "route_endpoints_endpoint" using primary key columns */
  route_endpoints_endpoint_by_pk?: Maybe<route_endpoints_endpoint>;
  /** fetch data from the table: "student" */
  student: Array<student>;
  studentAssessmentSubmissionUploadsURLs: Array<UploadURLs>;
  studentAttendance: StudentAttendanceResult;
  studentDocumentUploadURLs: Array<UploadURLs>;
  studentLogBook: Array<StudentLogBookResult>;
  studentProfileAcademicInformation: StudentProfileAcademicInformationResult;
  studentRequestUploadURLs: Array<UploadURLs>;
  /** fetch data from the table: "student_admin_editable_information" */
  student_admin_editable_information: Array<student_admin_editable_information>;
  /** fetch aggregated fields from the table: "student_admin_editable_information" */
  student_admin_editable_information_aggregate: student_admin_editable_information_aggregate;
  /** fetch aggregated fields from the table: "student" */
  student_aggregate: student_aggregate;
  /** fetch data from the table: "student_assessment_submission" */
  student_assessment_submission: Array<student_assessment_submission>;
  /** fetch aggregated fields from the table: "student_assessment_submission" */
  student_assessment_submission_aggregate: student_assessment_submission_aggregate;
  /** fetch data from the table: "student_assessment_submission" using primary key columns */
  student_assessment_submission_by_pk?: Maybe<student_assessment_submission>;
  /** fetch data from the table: "student_attendance_status" */
  student_attendance_status: Array<student_attendance_status>;
  /** fetch aggregated fields from the table: "student_attendance_status" */
  student_attendance_status_aggregate: student_attendance_status_aggregate;
  /** fetch data from the table: "student_attendance_status" using primary key columns */
  student_attendance_status_by_pk?: Maybe<student_attendance_status>;
  /** fetch data from the table: "student_batch_classes_batch_class" */
  student_batch_classes_batch_class: Array<student_batch_classes_batch_class>;
  /** fetch aggregated fields from the table: "student_batch_classes_batch_class" */
  student_batch_classes_batch_class_aggregate: student_batch_classes_batch_class_aggregate;
  /** fetch data from the table: "student_batch_classes_batch_class" using primary key columns */
  student_batch_classes_batch_class_by_pk?: Maybe<student_batch_classes_batch_class>;
  /** fetch data from the table: "student_batch_history" */
  student_batch_history: Array<student_batch_history>;
  /** fetch aggregated fields from the table: "student_batch_history" */
  student_batch_history_aggregate: student_batch_history_aggregate;
  /** fetch data from the table: "student_batch_history" using primary key columns */
  student_batch_history_by_pk?: Maybe<student_batch_history>;
  /** fetch data from the table: "student_batch_history_subject" */
  student_batch_history_subject: Array<student_batch_history_subject>;
  /** fetch aggregated fields from the table: "student_batch_history_subject" */
  student_batch_history_subject_aggregate: student_batch_history_subject_aggregate;
  /** fetch data from the table: "student_batch_history_subject" using primary key columns */
  student_batch_history_subject_by_pk?: Maybe<student_batch_history_subject>;
  /** fetch data from the table: "student" using primary key columns */
  student_by_pk?: Maybe<student>;
  /** fetch data from the table: "student_course" */
  student_course: Array<student_course>;
  /** fetch aggregated fields from the table: "student_course" */
  student_course_aggregate: student_course_aggregate;
  /** fetch data from the table: "student_course" using primary key columns */
  student_course_by_pk?: Maybe<student_course>;
  /** fetch data from the table: "student_external_engagement_info" */
  student_external_engagement_info: Array<student_external_engagement_info>;
  /** fetch aggregated fields from the table: "student_external_engagement_info" */
  student_external_engagement_info_aggregate: student_external_engagement_info_aggregate;
  /** fetch data from the table: "student_external_engagement_request" */
  student_external_engagement_request: Array<student_external_engagement_request>;
  /** fetch aggregated fields from the table: "student_external_engagement_request" */
  student_external_engagement_request_aggregate: student_external_engagement_request_aggregate;
  /** fetch data from the table: "student_external_engagement_request" using primary key columns */
  student_external_engagement_request_by_pk?: Maybe<student_external_engagement_request>;
  /** fetch data from the table: "student_familiarization_form" */
  student_familiarization_form: Array<student_familiarization_form>;
  /** fetch aggregated fields from the table: "student_familiarization_form" */
  student_familiarization_form_aggregate: student_familiarization_form_aggregate;
  /** fetch data from the table: "student_familiarization_form" using primary key columns */
  student_familiarization_form_by_pk?: Maybe<student_familiarization_form>;
  /** fetch data from the table: "student_familiarization_interview" */
  student_familiarization_interview: Array<student_familiarization_interview>;
  /** fetch aggregated fields from the table: "student_familiarization_interview" */
  student_familiarization_interview_aggregate: student_familiarization_interview_aggregate;
  /** fetch data from the table: "student_familiarization_interview" using primary key columns */
  student_familiarization_interview_by_pk?: Maybe<student_familiarization_interview>;
  /** fetch data from the table: "student_for_batch" */
  student_for_batch: Array<student_for_batch>;
  /** fetch aggregated fields from the table: "student_for_batch" */
  student_for_batch_aggregate: student_for_batch_aggregate;
  /** fetch data from the table: "student_general_request" */
  student_general_request: Array<student_general_request>;
  /** fetch aggregated fields from the table: "student_general_request" */
  student_general_request_aggregate: student_general_request_aggregate;
  /** fetch data from the table: "student_general_request" using primary key columns */
  student_general_request_by_pk?: Maybe<student_general_request>;
  /** fetch data from the table: "student_medical_request" */
  student_medical_request: Array<student_medical_request>;
  /** fetch aggregated fields from the table: "student_medical_request" */
  student_medical_request_aggregate: student_medical_request_aggregate;
  /** fetch data from the table: "student_medical_request" using primary key columns */
  student_medical_request_by_pk?: Maybe<student_medical_request>;
  /** fetch data from the table: "student_performance" */
  student_performance: Array<student_performance>;
  /** fetch aggregated fields from the table: "student_performance" */
  student_performance_aggregate: student_performance_aggregate;
  /** fetch data from the table: "student_performance" using primary key columns */
  student_performance_by_pk?: Maybe<student_performance>;
  /** fetch data from the table: "student_request" */
  student_request: Array<student_request>;
  /** fetch aggregated fields from the table: "student_request" */
  student_request_aggregate: student_request_aggregate;
  /** fetch data from the table: "student_request" using primary key columns */
  student_request_by_pk?: Maybe<student_request>;
  /** fetch data from the table: "student_request_message" */
  student_request_message: Array<student_request_message>;
  /** fetch aggregated fields from the table: "student_request_message" */
  student_request_message_aggregate: student_request_message_aggregate;
  /** fetch data from the table: "student_request_message" using primary key columns */
  student_request_message_by_pk?: Maybe<student_request_message>;
  /** fetch data from the table: "student_request_requestee" */
  student_request_requestee: Array<student_request_requestee>;
  /** fetch aggregated fields from the table: "student_request_requestee" */
  student_request_requestee_aggregate: student_request_requestee_aggregate;
  /** fetch data from the table: "student_request_requestee" using primary key columns */
  student_request_requestee_by_pk?: Maybe<student_request_requestee>;
  /** fetch data from the table: "student_request_status" */
  student_request_status: Array<student_request_status>;
  /** fetch aggregated fields from the table: "student_request_status" */
  student_request_status_aggregate: student_request_status_aggregate;
  /** fetch data from the table: "student_request_status" using primary key columns */
  student_request_status_by_pk?: Maybe<student_request_status>;
  /** fetch data from the table: "student_result" */
  student_result: Array<student_result>;
  /** fetch aggregated fields from the table: "student_result" */
  student_result_aggregate: student_result_aggregate;
  /** fetch data from the table: "student_result" using primary key columns */
  student_result_by_pk?: Maybe<student_result>;
  /** fetch data from the table: "student_result_sheet" */
  student_result_sheet: Array<student_result_sheet>;
  /** fetch aggregated fields from the table: "student_result_sheet" */
  student_result_sheet_aggregate: student_result_sheet_aggregate;
  /** fetch data from the table: "student_result_sheet" using primary key columns */
  student_result_sheet_by_pk?: Maybe<student_result_sheet>;
  /** fetch data from the table: "student_self_editable_information" */
  student_self_editable_information: Array<student_self_editable_information>;
  /** fetch aggregated fields from the table: "student_self_editable_information" */
  student_self_editable_information_aggregate: student_self_editable_information_aggregate;
  /** fetch data from the table: "student_status" */
  student_status: Array<student_status>;
  /** fetch aggregated fields from the table: "student_status" */
  student_status_aggregate: student_status_aggregate;
  /** fetch data from the table: "student_status" using primary key columns */
  student_status_by_pk?: Maybe<student_status>;
  /** fetch data from the table: "student_timetable_item" */
  student_timetable_item: Array<student_timetable_item>;
  /** fetch aggregated fields from the table: "student_timetable_item" */
  student_timetable_item_aggregate: student_timetable_item_aggregate;
  studentsWithAttendance: Array<StudentsWithAttendanceResult>;
  /** fetch data from the table: "subject" */
  subject: Array<subject>;
  /** fetch aggregated fields from the table: "subject" */
  subject_aggregate: subject_aggregate;
  /** fetch data from the table: "subject" using primary key columns */
  subject_by_pk?: Maybe<subject>;
  /** fetch data from the table: "subject_extra_slot" */
  subject_extra_slot: Array<subject_extra_slot>;
  /** fetch aggregated fields from the table: "subject_extra_slot" */
  subject_extra_slot_aggregate: subject_extra_slot_aggregate;
  /** fetch data from the table: "subject_extra_slot" using primary key columns */
  subject_extra_slot_by_pk?: Maybe<subject_extra_slot>;
  /** fetch data from the table: "subject_to_user" */
  subject_to_user: Array<subject_to_user>;
  /** fetch aggregated fields from the table: "subject_to_user" */
  subject_to_user_aggregate: subject_to_user_aggregate;
  /** fetch data from the table: "subject_to_user" using primary key columns */
  subject_to_user_by_pk?: Maybe<subject_to_user>;
  /** fetch data from the table: "timetable_item" */
  timetable_item: Array<timetable_item>;
  /** fetch aggregated fields from the table: "timetable_item" */
  timetable_item_aggregate: timetable_item_aggregate;
  /** fetch data from the table: "timetable_item" using primary key columns */
  timetable_item_by_pk?: Maybe<timetable_item>;
  /** fetch data from the table: "timetable_timeslot_configuration" */
  timetable_timeslot_configuration: Array<timetable_timeslot_configuration>;
  /** fetch aggregated fields from the table: "timetable_timeslot_configuration" */
  timetable_timeslot_configuration_aggregate: timetable_timeslot_configuration_aggregate;
  /** fetch data from the table: "timetable_timeslot_configuration" using primary key columns */
  timetable_timeslot_configuration_by_pk?: Maybe<timetable_timeslot_configuration>;
  urlArrayGetStorageReadSignedURL: Array<URLArrayGetStorageReadSignedURLResult>;
  /** fetch data from the table: "user" */
  user: Array<user>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: user_aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<user>;
  /** fetch data from the table: "user_performance_public" */
  user_performance_public: Array<user_performance_public>;
  /** fetch aggregated fields from the table: "user_performance_public" */
  user_performance_public_aggregate: user_performance_public_aggregate;
  /** fetch data from the table: "user_public" */
  user_public: Array<user_public>;
  /** fetch aggregated fields from the table: "user_public" */
  user_public_aggregate: user_public_aggregate;
  /** fetch data from the table: "user_role" */
  user_role: Array<user_role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: user_role_aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<user_role>;
  /** fetch data from the table: "user_role_routes_route" */
  user_role_routes_route: Array<user_role_routes_route>;
  /** fetch aggregated fields from the table: "user_role_routes_route" */
  user_role_routes_route_aggregate: user_role_routes_route_aggregate;
  /** fetch data from the table: "user_role_routes_route" using primary key columns */
  user_role_routes_route_by_pk?: Maybe<user_role_routes_route>;
  /** fetch data from the table: "user_routes_route" */
  user_routes_route: Array<user_routes_route>;
  /** fetch aggregated fields from the table: "user_routes_route" */
  user_routes_route_aggregate: user_routes_route_aggregate;
  /** fetch data from the table: "user_routes_route" using primary key columns */
  user_routes_route_by_pk?: Maybe<user_routes_route>;
  /** fetch data from the table: "user_user_roles_user_role" */
  user_user_roles_user_role: Array<user_user_roles_user_role>;
  /** fetch aggregated fields from the table: "user_user_roles_user_role" */
  user_user_roles_user_role_aggregate: user_user_roles_user_role_aggregate;
  /** fetch data from the table: "user_user_roles_user_role" using primary key columns */
  user_user_roles_user_role_by_pk?: Maybe<user_user_roles_user_role>;
  /** fetch data from the table: "withdrawn_request" */
  withdrawn_request: Array<withdrawn_request>;
  /** fetch aggregated fields from the table: "withdrawn_request" */
  withdrawn_request_aggregate: withdrawn_request_aggregate;
};

export type query_rootacademic_calendar_itemArgs = {
  distinct_on?: Maybe<Array<academic_calendar_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<academic_calendar_item_order_by>>;
  where?: Maybe<academic_calendar_item_bool_exp>;
};

export type query_rootacademic_calendar_item_aggregateArgs = {
  distinct_on?: Maybe<Array<academic_calendar_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<academic_calendar_item_order_by>>;
  where?: Maybe<academic_calendar_item_bool_exp>;
};

export type query_rootacademic_calendar_item_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootactive_batchArgs = {
  distinct_on?: Maybe<Array<active_batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<active_batch_order_by>>;
  where?: Maybe<active_batch_bool_exp>;
};

export type query_rootactive_batch_aggregateArgs = {
  distinct_on?: Maybe<Array<active_batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<active_batch_order_by>>;
  where?: Maybe<active_batch_bool_exp>;
};

export type query_rootassessmentArgs = {
  distinct_on?: Maybe<Array<assessment_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<assessment_order_by>>;
  where?: Maybe<assessment_bool_exp>;
};

export type query_rootassessmentResourcesUploadURLsArgs = {
  data: AssessmentResourcesUploadURLsInput;
};

export type query_rootassessment_aggregateArgs = {
  distinct_on?: Maybe<Array<assessment_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<assessment_order_by>>;
  where?: Maybe<assessment_bool_exp>;
};

export type query_rootassessment_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootattendanceArgs = {
  distinct_on?: Maybe<Array<attendance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_order_by>>;
  where?: Maybe<attendance_bool_exp>;
};

export type query_rootattendance_aggregateArgs = {
  distinct_on?: Maybe<Array<attendance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_order_by>>;
  where?: Maybe<attendance_bool_exp>;
};

export type query_rootattendance_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootattendance_studentArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

export type query_rootattendance_student_aggregateArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

export type query_rootattendance_student_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootbatchArgs = {
  distinct_on?: Maybe<Array<batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_order_by>>;
  where?: Maybe<batch_bool_exp>;
};

export type query_rootbatch_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_order_by>>;
  where?: Maybe<batch_bool_exp>;
};

export type query_rootbatch_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootbatch_classArgs = {
  distinct_on?: Maybe<Array<batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_order_by>>;
  where?: Maybe<batch_class_bool_exp>;
};

export type query_rootbatch_class_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_order_by>>;
  where?: Maybe<batch_class_bool_exp>;
};

export type query_rootbatch_class_batch_subject_configurationsArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_configurations_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_configurations_order_by>>;
  where?: Maybe<batch_class_batch_subject_configurations_bool_exp>;
};

export type query_rootbatch_class_batch_subject_configurations_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_configurations_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_configurations_order_by>>;
  where?: Maybe<batch_class_batch_subject_configurations_bool_exp>;
};

export type query_rootbatch_class_batch_subject_extra_slotArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_class_batch_subject_extra_slot_bool_exp>;
};

export type query_rootbatch_class_batch_subject_extra_slot_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_class_batch_subject_extra_slot_bool_exp>;
};

export type query_rootbatch_class_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootbatch_subject_configurationArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

export type query_rootbatch_subject_configuration_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

export type query_rootbatch_subject_configuration_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootbatch_subject_extra_slotArgs = {
  distinct_on?: Maybe<Array<batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_subject_extra_slot_bool_exp>;
};

export type query_rootbatch_subject_extra_slot_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_subject_extra_slot_bool_exp>;
};

export type query_rootbatch_subject_extra_slot_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootblood_typeArgs = {
  distinct_on?: Maybe<Array<blood_type_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<blood_type_order_by>>;
  where?: Maybe<blood_type_bool_exp>;
};

export type query_rootblood_type_aggregateArgs = {
  distinct_on?: Maybe<Array<blood_type_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<blood_type_order_by>>;
  where?: Maybe<blood_type_bool_exp>;
};

export type query_rootblood_type_by_pkArgs = {
  name: Scalars['String'];
};

export type query_rootcourseArgs = {
  distinct_on?: Maybe<Array<course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_order_by>>;
  where?: Maybe<course_bool_exp>;
};

export type query_rootcourse_aggregateArgs = {
  distinct_on?: Maybe<Array<course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_order_by>>;
  where?: Maybe<course_bool_exp>;
};

export type query_rootcourse_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootcourse_coordinatorArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

export type query_rootcourse_coordinator_aggregateArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

export type query_rootcourse_coordinator_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootcourse_levelArgs = {
  distinct_on?: Maybe<Array<course_level_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_level_order_by>>;
  where?: Maybe<course_level_bool_exp>;
};

export type query_rootcourse_level_aggregateArgs = {
  distinct_on?: Maybe<Array<course_level_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_level_order_by>>;
  where?: Maybe<course_level_bool_exp>;
};

export type query_rootcourse_level_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootcourse_semesterArgs = {
  distinct_on?: Maybe<Array<course_semester_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_order_by>>;
  where?: Maybe<course_semester_bool_exp>;
};

export type query_rootcourse_semester_aggregateArgs = {
  distinct_on?: Maybe<Array<course_semester_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_order_by>>;
  where?: Maybe<course_semester_bool_exp>;
};

export type query_rootcourse_semester_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootcourse_semester_subjects_subjectArgs = {
  distinct_on?: Maybe<Array<course_semester_subjects_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_subjects_subject_order_by>>;
  where?: Maybe<course_semester_subjects_subject_bool_exp>;
};

export type query_rootcourse_semester_subjects_subject_aggregateArgs = {
  distinct_on?: Maybe<Array<course_semester_subjects_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_subjects_subject_order_by>>;
  where?: Maybe<course_semester_subjects_subject_bool_exp>;
};

export type query_rootcourse_semester_subjects_subject_by_pkArgs = {
  courseSemesterId: Scalars['uuid'];
  subjectId: Scalars['uuid'];
};

export type query_rootcurrent_studentArgs = {
  distinct_on?: Maybe<Array<current_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_order_by>>;
  where?: Maybe<current_student_bool_exp>;
};

export type query_rootcurrent_student_aggregateArgs = {
  distinct_on?: Maybe<Array<current_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_order_by>>;
  where?: Maybe<current_student_bool_exp>;
};

export type query_rootcurrent_student_courseArgs = {
  distinct_on?: Maybe<Array<current_student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_course_order_by>>;
  where?: Maybe<current_student_course_bool_exp>;
};

export type query_rootcurrent_student_course_aggregateArgs = {
  distinct_on?: Maybe<Array<current_student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_course_order_by>>;
  where?: Maybe<current_student_course_bool_exp>;
};

export type query_rootcurrent_student_routes_routeArgs = {
  distinct_on?: Maybe<Array<current_student_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_routes_route_order_by>>;
  where?: Maybe<current_student_routes_route_bool_exp>;
};

export type query_rootcurrent_student_routes_route_aggregateArgs = {
  distinct_on?: Maybe<Array<current_student_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_routes_route_order_by>>;
  where?: Maybe<current_student_routes_route_bool_exp>;
};

export type query_rootcurrent_userArgs = {
  distinct_on?: Maybe<Array<current_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_order_by>>;
  where?: Maybe<current_user_bool_exp>;
};

export type query_rootcurrent_user_aggregateArgs = {
  distinct_on?: Maybe<Array<current_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_order_by>>;
  where?: Maybe<current_user_bool_exp>;
};

export type query_rootcurrent_user_routeArgs = {
  distinct_on?: Maybe<Array<current_user_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_route_order_by>>;
  where?: Maybe<current_user_route_bool_exp>;
};

export type query_rootcurrent_user_route_aggregateArgs = {
  distinct_on?: Maybe<Array<current_user_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_route_order_by>>;
  where?: Maybe<current_user_route_bool_exp>;
};

export type query_rootcurrent_user_routes_routeArgs = {
  distinct_on?: Maybe<Array<current_user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_routes_route_order_by>>;
  where?: Maybe<current_user_routes_route_bool_exp>;
};

export type query_rootcurrent_user_routes_route_aggregateArgs = {
  distinct_on?: Maybe<Array<current_user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_routes_route_order_by>>;
  where?: Maybe<current_user_routes_route_bool_exp>;
};

export type query_rootdepartmentArgs = {
  distinct_on?: Maybe<Array<department_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<department_order_by>>;
  where?: Maybe<department_bool_exp>;
};

export type query_rootdepartment_aggregateArgs = {
  distinct_on?: Maybe<Array<department_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<department_order_by>>;
  where?: Maybe<department_bool_exp>;
};

export type query_rootdepartment_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rooteducation_qualificationArgs = {
  distinct_on?: Maybe<Array<education_qualification_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<education_qualification_order_by>>;
  where?: Maybe<education_qualification_bool_exp>;
};

export type query_rooteducation_qualification_aggregateArgs = {
  distinct_on?: Maybe<Array<education_qualification_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<education_qualification_order_by>>;
  where?: Maybe<education_qualification_bool_exp>;
};

export type query_rooteducation_qualification_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootemployment_experienceArgs = {
  distinct_on?: Maybe<Array<employment_experience_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<employment_experience_order_by>>;
  where?: Maybe<employment_experience_bool_exp>;
};

export type query_rootemployment_experience_aggregateArgs = {
  distinct_on?: Maybe<Array<employment_experience_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<employment_experience_order_by>>;
  where?: Maybe<employment_experience_bool_exp>;
};

export type query_rootemployment_experience_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootendpointArgs = {
  distinct_on?: Maybe<Array<endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<endpoint_order_by>>;
  where?: Maybe<endpoint_bool_exp>;
};

export type query_rootendpoint_aggregateArgs = {
  distinct_on?: Maybe<Array<endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<endpoint_order_by>>;
  where?: Maybe<endpoint_bool_exp>;
};

export type query_rootendpoint_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootexit_interview_answerArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

export type query_rootexit_interview_answer_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

export type query_rootexit_interview_answer_by_pkArgs = {
  questionId: Scalars['uuid'];
  studentId: Scalars['Int'];
};

export type query_rootexit_interview_answer_multi_choice_questionsArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_multi_choice_questions_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_multi_choice_questions_order_by>>;
  where?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
};

export type query_rootexit_interview_answer_multi_choice_questions_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_multi_choice_questions_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_multi_choice_questions_order_by>>;
  where?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
};

export type query_rootexit_interview_answer_multi_choice_questions_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootexit_interview_questionArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_order_by>>;
  where?: Maybe<exit_interview_question_bool_exp>;
};

export type query_rootexit_interview_question_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_order_by>>;
  where?: Maybe<exit_interview_question_bool_exp>;
};

export type query_rootexit_interview_question_answersArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_answers_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_answers_order_by>>;
  where?: Maybe<exit_interview_question_answers_bool_exp>;
};

export type query_rootexit_interview_question_answers_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_answers_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_answers_order_by>>;
  where?: Maybe<exit_interview_question_answers_bool_exp>;
};

export type query_rootexit_interview_question_answers_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootexit_interview_question_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootexit_interview_question_groupArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_group_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_group_order_by>>;
  where?: Maybe<exit_interview_question_group_bool_exp>;
};

export type query_rootexit_interview_question_group_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_group_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_group_order_by>>;
  where?: Maybe<exit_interview_question_group_bool_exp>;
};

export type query_rootexit_interview_question_group_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootfinalStudentDetailsArgs = {
  where: FinalStudentDetailsWhereInput;
};

export type query_rootinquiryArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

export type query_rootinquiry_aggregateArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

export type query_rootinquiry_by_pkArgs = {
  id: Scalars['Int'];
};

export type query_rootinquiry_status_enumArgs = {
  distinct_on?: Maybe<Array<inquiry_status_enum_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_status_enum_order_by>>;
  where?: Maybe<inquiry_status_enum_bool_exp>;
};

export type query_rootinquiry_status_enum_aggregateArgs = {
  distinct_on?: Maybe<Array<inquiry_status_enum_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_status_enum_order_by>>;
  where?: Maybe<inquiry_status_enum_bool_exp>;
};

export type query_rootinquiry_status_enum_by_pkArgs = {
  name: Scalars['String'];
};

export type query_rootintakeArgs = {
  distinct_on?: Maybe<Array<intake_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<intake_order_by>>;
  where?: Maybe<intake_bool_exp>;
};

export type query_rootintake_aggregateArgs = {
  distinct_on?: Maybe<Array<intake_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<intake_order_by>>;
  where?: Maybe<intake_bool_exp>;
};

export type query_rootintake_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootlectureMaterialAttachmentsUploadURLsArgs = {
  data: LectureMaterialAttachmentsUploadURLsInput;
};

export type query_rootlecture_materialArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

export type query_rootlecture_material_aggregateArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

export type query_rootlecture_material_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootlecture_material_categoryArgs = {
  distinct_on?: Maybe<Array<lecture_material_category_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_category_order_by>>;
  where?: Maybe<lecture_material_category_bool_exp>;
};

export type query_rootlecture_material_category_aggregateArgs = {
  distinct_on?: Maybe<Array<lecture_material_category_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_category_order_by>>;
  where?: Maybe<lecture_material_category_bool_exp>;
};

export type query_rootlecture_material_category_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootlecturerArgs = {
  distinct_on?: Maybe<Array<lecturer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecturer_order_by>>;
  where?: Maybe<lecturer_bool_exp>;
};

export type query_rootlecturer_aggregateArgs = {
  distinct_on?: Maybe<Array<lecturer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecturer_order_by>>;
  where?: Maybe<lecturer_bool_exp>;
};

export type query_rootlocationArgs = {
  distinct_on?: Maybe<Array<location_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<location_order_by>>;
  where?: Maybe<location_bool_exp>;
};

export type query_rootlocation_aggregateArgs = {
  distinct_on?: Maybe<Array<location_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<location_order_by>>;
  where?: Maybe<location_bool_exp>;
};

export type query_rootlocation_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootmulti_choice_questionArgs = {
  distinct_on?: Maybe<Array<multi_choice_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<multi_choice_question_order_by>>;
  where?: Maybe<multi_choice_question_bool_exp>;
};

export type query_rootmulti_choice_question_aggregateArgs = {
  distinct_on?: Maybe<Array<multi_choice_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<multi_choice_question_order_by>>;
  where?: Maybe<multi_choice_question_bool_exp>;
};

export type query_rootmulti_choice_question_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootperfomance_statusArgs = {
  distinct_on?: Maybe<Array<perfomance_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<perfomance_status_order_by>>;
  where?: Maybe<perfomance_status_bool_exp>;
};

export type query_rootperfomance_status_aggregateArgs = {
  distinct_on?: Maybe<Array<perfomance_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<perfomance_status_order_by>>;
  where?: Maybe<perfomance_status_bool_exp>;
};

export type query_rootperfomance_status_by_pkArgs = {
  name: Scalars['String'];
};

export type query_rootprofilePictureUploadURLArgs = {
  data: ProfilePictureUploadURLInput;
};

export type query_rootquestion_typeArgs = {
  distinct_on?: Maybe<Array<question_type_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<question_type_order_by>>;
  where?: Maybe<question_type_bool_exp>;
};

export type query_rootquestion_type_aggregateArgs = {
  distinct_on?: Maybe<Array<question_type_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<question_type_order_by>>;
  where?: Maybe<question_type_bool_exp>;
};

export type query_rootquestion_type_by_pkArgs = {
  name: Scalars['String'];
};

export type query_rootresultSheetReportArgs = {
  where: ResultSheetReportWhereInput;
};

export type query_rootresult_sheetArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

export type query_rootresult_sheet_aggregateArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

export type query_rootresult_sheet_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootresult_sheet_statusArgs = {
  distinct_on?: Maybe<Array<result_sheet_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_status_order_by>>;
  where?: Maybe<result_sheet_status_bool_exp>;
};

export type query_rootresult_sheet_status_aggregateArgs = {
  distinct_on?: Maybe<Array<result_sheet_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_status_order_by>>;
  where?: Maybe<result_sheet_status_bool_exp>;
};

export type query_rootresult_sheet_status_by_pkArgs = {
  name: Scalars['String'];
};

export type query_rootrouteArgs = {
  distinct_on?: Maybe<Array<route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_order_by>>;
  where?: Maybe<route_bool_exp>;
};

export type query_rootroute_aggregateArgs = {
  distinct_on?: Maybe<Array<route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_order_by>>;
  where?: Maybe<route_bool_exp>;
};

export type query_rootroute_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootroute_endpoints_endpointArgs = {
  distinct_on?: Maybe<Array<route_endpoints_endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_endpoints_endpoint_order_by>>;
  where?: Maybe<route_endpoints_endpoint_bool_exp>;
};

export type query_rootroute_endpoints_endpoint_aggregateArgs = {
  distinct_on?: Maybe<Array<route_endpoints_endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_endpoints_endpoint_order_by>>;
  where?: Maybe<route_endpoints_endpoint_bool_exp>;
};

export type query_rootroute_endpoints_endpoint_by_pkArgs = {
  endpointId: Scalars['uuid'];
  routeId: Scalars['uuid'];
};

export type query_rootstudentArgs = {
  distinct_on?: Maybe<Array<student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_order_by>>;
  where?: Maybe<student_bool_exp>;
};

export type query_rootstudentAssessmentSubmissionUploadsURLsArgs = {
  data: StudentAssessmentSubmissionUploadURLsInput;
};

export type query_rootstudentAttendanceArgs = {
  where: AttendanceWhereInput;
};

export type query_rootstudentDocumentUploadURLsArgs = {
  data: StudentDocumentUploadURLsInput;
};

export type query_rootstudentLogBookArgs = {
  where: StudentLogBookWhereInput;
};

export type query_rootstudentProfileAcademicInformationArgs = {
  where: StudentProfileAcademicInformationWhereInput;
};

export type query_rootstudentRequestUploadURLsArgs = {
  data: StudentRequestUploadURLsInput;
};

export type query_rootstudent_admin_editable_informationArgs = {
  distinct_on?: Maybe<Array<student_admin_editable_information_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_admin_editable_information_order_by>>;
  where?: Maybe<student_admin_editable_information_bool_exp>;
};

export type query_rootstudent_admin_editable_information_aggregateArgs = {
  distinct_on?: Maybe<Array<student_admin_editable_information_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_admin_editable_information_order_by>>;
  where?: Maybe<student_admin_editable_information_bool_exp>;
};

export type query_rootstudent_aggregateArgs = {
  distinct_on?: Maybe<Array<student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_order_by>>;
  where?: Maybe<student_bool_exp>;
};

export type query_rootstudent_assessment_submissionArgs = {
  distinct_on?: Maybe<Array<student_assessment_submission_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_assessment_submission_order_by>>;
  where?: Maybe<student_assessment_submission_bool_exp>;
};

export type query_rootstudent_assessment_submission_aggregateArgs = {
  distinct_on?: Maybe<Array<student_assessment_submission_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_assessment_submission_order_by>>;
  where?: Maybe<student_assessment_submission_bool_exp>;
};

export type query_rootstudent_assessment_submission_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_attendance_statusArgs = {
  distinct_on?: Maybe<Array<student_attendance_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_attendance_status_order_by>>;
  where?: Maybe<student_attendance_status_bool_exp>;
};

export type query_rootstudent_attendance_status_aggregateArgs = {
  distinct_on?: Maybe<Array<student_attendance_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_attendance_status_order_by>>;
  where?: Maybe<student_attendance_status_bool_exp>;
};

export type query_rootstudent_attendance_status_by_pkArgs = {
  name: Scalars['String'];
};

export type query_rootstudent_batch_classes_batch_classArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

export type query_rootstudent_batch_classes_batch_class_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

export type query_rootstudent_batch_classes_batch_class_by_pkArgs = {
  batchClassId: Scalars['uuid'];
  studentId: Scalars['Int'];
};

export type query_rootstudent_batch_historyArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

export type query_rootstudent_batch_history_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

export type query_rootstudent_batch_history_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_batch_history_subjectArgs = {
  distinct_on?: Maybe<Array<student_batch_history_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_subject_order_by>>;
  where?: Maybe<student_batch_history_subject_bool_exp>;
};

export type query_rootstudent_batch_history_subject_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_subject_order_by>>;
  where?: Maybe<student_batch_history_subject_bool_exp>;
};

export type query_rootstudent_batch_history_subject_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_by_pkArgs = {
  id: Scalars['Int'];
};

export type query_rootstudent_courseArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

export type query_rootstudent_course_aggregateArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

export type query_rootstudent_course_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_external_engagement_infoArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_info_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_info_order_by>>;
  where?: Maybe<student_external_engagement_info_bool_exp>;
};

export type query_rootstudent_external_engagement_info_aggregateArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_info_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_info_order_by>>;
  where?: Maybe<student_external_engagement_info_bool_exp>;
};

export type query_rootstudent_external_engagement_requestArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_request_order_by>>;
  where?: Maybe<student_external_engagement_request_bool_exp>;
};

export type query_rootstudent_external_engagement_request_aggregateArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_request_order_by>>;
  where?: Maybe<student_external_engagement_request_bool_exp>;
};

export type query_rootstudent_external_engagement_request_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_familiarization_formArgs = {
  distinct_on?: Maybe<Array<student_familiarization_form_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_form_order_by>>;
  where?: Maybe<student_familiarization_form_bool_exp>;
};

export type query_rootstudent_familiarization_form_aggregateArgs = {
  distinct_on?: Maybe<Array<student_familiarization_form_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_form_order_by>>;
  where?: Maybe<student_familiarization_form_bool_exp>;
};

export type query_rootstudent_familiarization_form_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_familiarization_interviewArgs = {
  distinct_on?: Maybe<Array<student_familiarization_interview_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_interview_order_by>>;
  where?: Maybe<student_familiarization_interview_bool_exp>;
};

export type query_rootstudent_familiarization_interview_aggregateArgs = {
  distinct_on?: Maybe<Array<student_familiarization_interview_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_interview_order_by>>;
  where?: Maybe<student_familiarization_interview_bool_exp>;
};

export type query_rootstudent_familiarization_interview_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_for_batchArgs = {
  distinct_on?: Maybe<Array<student_for_batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_for_batch_order_by>>;
  where?: Maybe<student_for_batch_bool_exp>;
};

export type query_rootstudent_for_batch_aggregateArgs = {
  distinct_on?: Maybe<Array<student_for_batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_for_batch_order_by>>;
  where?: Maybe<student_for_batch_bool_exp>;
};

export type query_rootstudent_general_requestArgs = {
  distinct_on?: Maybe<Array<student_general_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_general_request_order_by>>;
  where?: Maybe<student_general_request_bool_exp>;
};

export type query_rootstudent_general_request_aggregateArgs = {
  distinct_on?: Maybe<Array<student_general_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_general_request_order_by>>;
  where?: Maybe<student_general_request_bool_exp>;
};

export type query_rootstudent_general_request_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_medical_requestArgs = {
  distinct_on?: Maybe<Array<student_medical_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_medical_request_order_by>>;
  where?: Maybe<student_medical_request_bool_exp>;
};

export type query_rootstudent_medical_request_aggregateArgs = {
  distinct_on?: Maybe<Array<student_medical_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_medical_request_order_by>>;
  where?: Maybe<student_medical_request_bool_exp>;
};

export type query_rootstudent_medical_request_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_performanceArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

export type query_rootstudent_performance_aggregateArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

export type query_rootstudent_performance_by_pkArgs = {
  id: Scalars['Int'];
};

export type query_rootstudent_requestArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

export type query_rootstudent_request_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

export type query_rootstudent_request_by_pkArgs = {
  id: Scalars['Int'];
};

export type query_rootstudent_request_messageArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

export type query_rootstudent_request_message_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

export type query_rootstudent_request_message_by_pkArgs = {
  id: Scalars['Int'];
};

export type query_rootstudent_request_requesteeArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

export type query_rootstudent_request_requestee_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

export type query_rootstudent_request_requestee_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_request_statusArgs = {
  distinct_on?: Maybe<Array<student_request_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_status_order_by>>;
  where?: Maybe<student_request_status_bool_exp>;
};

export type query_rootstudent_request_status_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_status_order_by>>;
  where?: Maybe<student_request_status_bool_exp>;
};

export type query_rootstudent_request_status_by_pkArgs = {
  name: Scalars['String'];
};

export type query_rootstudent_resultArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

export type query_rootstudent_result_aggregateArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

export type query_rootstudent_result_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_result_sheetArgs = {
  distinct_on?: Maybe<Array<student_result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_sheet_order_by>>;
  where?: Maybe<student_result_sheet_bool_exp>;
};

export type query_rootstudent_result_sheet_aggregateArgs = {
  distinct_on?: Maybe<Array<student_result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_sheet_order_by>>;
  where?: Maybe<student_result_sheet_bool_exp>;
};

export type query_rootstudent_result_sheet_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootstudent_self_editable_informationArgs = {
  distinct_on?: Maybe<Array<student_self_editable_information_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_self_editable_information_order_by>>;
  where?: Maybe<student_self_editable_information_bool_exp>;
};

export type query_rootstudent_self_editable_information_aggregateArgs = {
  distinct_on?: Maybe<Array<student_self_editable_information_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_self_editable_information_order_by>>;
  where?: Maybe<student_self_editable_information_bool_exp>;
};

export type query_rootstudent_statusArgs = {
  distinct_on?: Maybe<Array<student_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_status_order_by>>;
  where?: Maybe<student_status_bool_exp>;
};

export type query_rootstudent_status_aggregateArgs = {
  distinct_on?: Maybe<Array<student_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_status_order_by>>;
  where?: Maybe<student_status_bool_exp>;
};

export type query_rootstudent_status_by_pkArgs = {
  name: Scalars['String'];
};

export type query_rootstudent_timetable_itemArgs = {
  distinct_on?: Maybe<Array<student_timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_timetable_item_order_by>>;
  where?: Maybe<student_timetable_item_bool_exp>;
};

export type query_rootstudent_timetable_item_aggregateArgs = {
  distinct_on?: Maybe<Array<student_timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_timetable_item_order_by>>;
  where?: Maybe<student_timetable_item_bool_exp>;
};

export type query_rootstudentsWithAttendanceArgs = {
  where: StudentsWithAttendanceWhereInput;
};

export type query_rootsubjectArgs = {
  distinct_on?: Maybe<Array<subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_order_by>>;
  where?: Maybe<subject_bool_exp>;
};

export type query_rootsubject_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_order_by>>;
  where?: Maybe<subject_bool_exp>;
};

export type query_rootsubject_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootsubject_extra_slotArgs = {
  distinct_on?: Maybe<Array<subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_extra_slot_order_by>>;
  where?: Maybe<subject_extra_slot_bool_exp>;
};

export type query_rootsubject_extra_slot_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_extra_slot_order_by>>;
  where?: Maybe<subject_extra_slot_bool_exp>;
};

export type query_rootsubject_extra_slot_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootsubject_to_userArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

export type query_rootsubject_to_user_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

export type query_rootsubject_to_user_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_roottimetable_itemArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

export type query_roottimetable_item_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

export type query_roottimetable_item_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_roottimetable_timeslot_configurationArgs = {
  distinct_on?: Maybe<Array<timetable_timeslot_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_timeslot_configuration_order_by>>;
  where?: Maybe<timetable_timeslot_configuration_bool_exp>;
};

export type query_roottimetable_timeslot_configuration_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_timeslot_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_timeslot_configuration_order_by>>;
  where?: Maybe<timetable_timeslot_configuration_bool_exp>;
};

export type query_roottimetable_timeslot_configuration_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rooturlArrayGetStorageReadSignedURLArgs = {
  data?: Maybe<URLArrayGetStorageReadSignedURLInput>;
};

export type query_rootuserArgs = {
  distinct_on?: Maybe<Array<user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_order_by>>;
  where?: Maybe<user_bool_exp>;
};

export type query_rootuser_aggregateArgs = {
  distinct_on?: Maybe<Array<user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_order_by>>;
  where?: Maybe<user_bool_exp>;
};

export type query_rootuser_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootuser_performance_publicArgs = {
  distinct_on?: Maybe<Array<user_performance_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_performance_public_order_by>>;
  where?: Maybe<user_performance_public_bool_exp>;
};

export type query_rootuser_performance_public_aggregateArgs = {
  distinct_on?: Maybe<Array<user_performance_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_performance_public_order_by>>;
  where?: Maybe<user_performance_public_bool_exp>;
};

export type query_rootuser_publicArgs = {
  distinct_on?: Maybe<Array<user_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_public_order_by>>;
  where?: Maybe<user_public_bool_exp>;
};

export type query_rootuser_public_aggregateArgs = {
  distinct_on?: Maybe<Array<user_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_public_order_by>>;
  where?: Maybe<user_public_bool_exp>;
};

export type query_rootuser_roleArgs = {
  distinct_on?: Maybe<Array<user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_order_by>>;
  where?: Maybe<user_role_bool_exp>;
};

export type query_rootuser_role_aggregateArgs = {
  distinct_on?: Maybe<Array<user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_order_by>>;
  where?: Maybe<user_role_bool_exp>;
};

export type query_rootuser_role_by_pkArgs = {
  id: Scalars['uuid'];
};

export type query_rootuser_role_routes_routeArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

export type query_rootuser_role_routes_route_aggregateArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

export type query_rootuser_role_routes_route_by_pkArgs = {
  routeId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
};

export type query_rootuser_routes_routeArgs = {
  distinct_on?: Maybe<Array<user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_routes_route_order_by>>;
  where?: Maybe<user_routes_route_bool_exp>;
};

export type query_rootuser_routes_route_aggregateArgs = {
  distinct_on?: Maybe<Array<user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_routes_route_order_by>>;
  where?: Maybe<user_routes_route_bool_exp>;
};

export type query_rootuser_routes_route_by_pkArgs = {
  routeId: Scalars['uuid'];
  userId: Scalars['uuid'];
};

export type query_rootuser_user_roles_user_roleArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

export type query_rootuser_user_roles_user_role_aggregateArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

export type query_rootuser_user_roles_user_role_by_pkArgs = {
  userId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
};

export type query_rootwithdrawn_requestArgs = {
  distinct_on?: Maybe<Array<withdrawn_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<withdrawn_request_order_by>>;
  where?: Maybe<withdrawn_request_bool_exp>;
};

export type query_rootwithdrawn_request_aggregateArgs = {
  distinct_on?: Maybe<Array<withdrawn_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<withdrawn_request_order_by>>;
  where?: Maybe<withdrawn_request_bool_exp>;
};

/** columns and relationships of "question_type" */
export type question_type = {
  __typename?: 'question_type';
  /** An array relationship */
  exit_interview_questions: Array<exit_interview_question>;
  /** An aggregate relationship */
  exit_interview_questions_aggregate: exit_interview_question_aggregate;
  name: Scalars['String'];
};

/** columns and relationships of "question_type" */
export type question_typeexit_interview_questionsArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_order_by>>;
  where?: Maybe<exit_interview_question_bool_exp>;
};

/** columns and relationships of "question_type" */
export type question_typeexit_interview_questions_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_order_by>>;
  where?: Maybe<exit_interview_question_bool_exp>;
};

/** aggregated selection of "question_type" */
export type question_type_aggregate = {
  __typename?: 'question_type_aggregate';
  aggregate?: Maybe<question_type_aggregate_fields>;
  nodes: Array<question_type>;
};

/** aggregate fields of "question_type" */
export type question_type_aggregate_fields = {
  __typename?: 'question_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<question_type_max_fields>;
  min?: Maybe<question_type_min_fields>;
};

/** aggregate fields of "question_type" */
export type question_type_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<question_type_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "question_type". All fields are combined with a logical 'AND'. */
export type question_type_bool_exp = {
  _and?: Maybe<Array<question_type_bool_exp>>;
  _not?: Maybe<question_type_bool_exp>;
  _or?: Maybe<Array<question_type_bool_exp>>;
  exit_interview_questions?: Maybe<exit_interview_question_bool_exp>;
  name?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "question_type" */
export enum question_type_constraint {
  /** unique or primary key constraint */
  question_type_pkey = 'question_type_pkey',
}

/** input type for inserting data into table "question_type" */
export type question_type_insert_input = {
  exit_interview_questions?: Maybe<exit_interview_question_arr_rel_insert_input>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type question_type_max_fields = {
  __typename?: 'question_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type question_type_min_fields = {
  __typename?: 'question_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "question_type" */
export type question_type_mutation_response = {
  __typename?: 'question_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<question_type>;
};

/** input type for inserting object relation for remote table "question_type" */
export type question_type_obj_rel_insert_input = {
  data: question_type_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<question_type_on_conflict>;
};

/** on conflict condition type for table "question_type" */
export type question_type_on_conflict = {
  constraint: question_type_constraint;
  update_columns?: Array<question_type_update_column>;
  where?: Maybe<question_type_bool_exp>;
};

/** Ordering options when selecting data from "question_type". */
export type question_type_order_by = {
  exit_interview_questions_aggregate?: Maybe<exit_interview_question_aggregate_order_by>;
  name?: Maybe<order_by>;
};

/** primary key columns input for table: question_type */
export type question_type_pk_columns_input = {
  name: Scalars['String'];
};

/** select columns of table "question_type" */
export enum question_type_select_column {
  /** column name */
  name = 'name',
}

/** input type for updating data in table "question_type" */
export type question_type_set_input = {
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "question_type" */
export enum question_type_update_column {
  /** column name */
  name = 'name',
}

/** columns and relationships of "result_sheet" */
export type result_sheet = {
  __typename?: 'result_sheet';
  academicHeadRemark?: Maybe<Scalars['String']>;
  batchClassId: Scalars['uuid'];
  batchSubjectConfigurationId: Scalars['uuid'];
  /** An object relationship */
  batch_class: batch_class;
  /** An object relationship */
  batch_subject_configuration: batch_subject_configuration;
  id: Scalars['uuid'];
  /** An object relationship */
  result_sheet_status: result_sheet_status;
  status: result_sheet_status_enum;
  /** An array relationship */
  student_result_sheets: Array<student_result_sheet>;
  /** An aggregate relationship */
  student_result_sheets_aggregate: student_result_sheet_aggregate;
  /** An object relationship */
  user?: Maybe<user>;
  userId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user_public?: Maybe<user_public>;
};

/** columns and relationships of "result_sheet" */
export type result_sheetstudent_result_sheetsArgs = {
  distinct_on?: Maybe<Array<student_result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_sheet_order_by>>;
  where?: Maybe<student_result_sheet_bool_exp>;
};

/** columns and relationships of "result_sheet" */
export type result_sheetstudent_result_sheets_aggregateArgs = {
  distinct_on?: Maybe<Array<student_result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_sheet_order_by>>;
  where?: Maybe<student_result_sheet_bool_exp>;
};

/** aggregated selection of "result_sheet" */
export type result_sheet_aggregate = {
  __typename?: 'result_sheet_aggregate';
  aggregate?: Maybe<result_sheet_aggregate_fields>;
  nodes: Array<result_sheet>;
};

/** aggregate fields of "result_sheet" */
export type result_sheet_aggregate_fields = {
  __typename?: 'result_sheet_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<result_sheet_max_fields>;
  min?: Maybe<result_sheet_min_fields>;
};

/** aggregate fields of "result_sheet" */
export type result_sheet_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<result_sheet_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "result_sheet" */
export type result_sheet_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<result_sheet_max_order_by>;
  min?: Maybe<result_sheet_min_order_by>;
};

/** input type for inserting array relation for remote table "result_sheet" */
export type result_sheet_arr_rel_insert_input = {
  data: Array<result_sheet_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<result_sheet_on_conflict>;
};

/** Boolean expression to filter rows from the table "result_sheet". All fields are combined with a logical 'AND'. */
export type result_sheet_bool_exp = {
  _and?: Maybe<Array<result_sheet_bool_exp>>;
  _not?: Maybe<result_sheet_bool_exp>;
  _or?: Maybe<Array<result_sheet_bool_exp>>;
  academicHeadRemark?: Maybe<String_comparison_exp>;
  batchClassId?: Maybe<uuid_comparison_exp>;
  batchSubjectConfigurationId?: Maybe<uuid_comparison_exp>;
  batch_class?: Maybe<batch_class_bool_exp>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_bool_exp>;
  id?: Maybe<uuid_comparison_exp>;
  result_sheet_status?: Maybe<result_sheet_status_bool_exp>;
  status?: Maybe<result_sheet_status_enum_comparison_exp>;
  student_result_sheets?: Maybe<student_result_sheet_bool_exp>;
  user?: Maybe<user_bool_exp>;
  userId?: Maybe<uuid_comparison_exp>;
  user_public?: Maybe<user_public_bool_exp>;
};

/** unique or primary key constraints on table "result_sheet" */
export enum result_sheet_constraint {
  /** unique or primary key constraint */
  result_sheet_batchSubjectConfigurationId_batchClassId_key = 'result_sheet_batchSubjectConfigurationId_batchClassId_key',
  /** unique or primary key constraint */
  result_sheet_pkey = 'result_sheet_pkey',
}

/** input type for inserting data into table "result_sheet" */
export type result_sheet_insert_input = {
  academicHeadRemark?: Maybe<Scalars['String']>;
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batch_class?: Maybe<batch_class_obj_rel_insert_input>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_obj_rel_insert_input>;
  id?: Maybe<Scalars['uuid']>;
  result_sheet_status?: Maybe<result_sheet_status_obj_rel_insert_input>;
  status?: Maybe<result_sheet_status_enum>;
  student_result_sheets?: Maybe<student_result_sheet_arr_rel_insert_input>;
  user?: Maybe<user_obj_rel_insert_input>;
  userId?: Maybe<Scalars['uuid']>;
  user_public?: Maybe<user_public_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type result_sheet_max_fields = {
  __typename?: 'result_sheet_max_fields';
  academicHeadRemark?: Maybe<Scalars['String']>;
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "result_sheet" */
export type result_sheet_max_order_by = {
  academicHeadRemark?: Maybe<order_by>;
  batchClassId?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type result_sheet_min_fields = {
  __typename?: 'result_sheet_min_fields';
  academicHeadRemark?: Maybe<Scalars['String']>;
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "result_sheet" */
export type result_sheet_min_order_by = {
  academicHeadRemark?: Maybe<order_by>;
  batchClassId?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** response of any mutation on the table "result_sheet" */
export type result_sheet_mutation_response = {
  __typename?: 'result_sheet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<result_sheet>;
};

/** input type for inserting object relation for remote table "result_sheet" */
export type result_sheet_obj_rel_insert_input = {
  data: result_sheet_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<result_sheet_on_conflict>;
};

/** on conflict condition type for table "result_sheet" */
export type result_sheet_on_conflict = {
  constraint: result_sheet_constraint;
  update_columns?: Array<result_sheet_update_column>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** Ordering options when selecting data from "result_sheet". */
export type result_sheet_order_by = {
  academicHeadRemark?: Maybe<order_by>;
  batchClassId?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  batch_class?: Maybe<batch_class_order_by>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_order_by>;
  id?: Maybe<order_by>;
  result_sheet_status?: Maybe<result_sheet_status_order_by>;
  status?: Maybe<order_by>;
  student_result_sheets_aggregate?: Maybe<student_result_sheet_aggregate_order_by>;
  user?: Maybe<user_order_by>;
  userId?: Maybe<order_by>;
  user_public?: Maybe<user_public_order_by>;
};

/** primary key columns input for table: result_sheet */
export type result_sheet_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "result_sheet" */
export enum result_sheet_select_column {
  /** column name */
  academicHeadRemark = 'academicHeadRemark',
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  id = 'id',
  /** column name */
  status = 'status',
  /** column name */
  userId = 'userId',
}

/** input type for updating data in table "result_sheet" */
export type result_sheet_set_input = {
  academicHeadRemark?: Maybe<Scalars['String']>;
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<result_sheet_status_enum>;
  userId?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "result_sheet_status" */
export type result_sheet_status = {
  __typename?: 'result_sheet_status';
  name: Scalars['String'];
  /** An array relationship */
  result_sheets: Array<result_sheet>;
  /** An aggregate relationship */
  result_sheets_aggregate: result_sheet_aggregate;
};

/** columns and relationships of "result_sheet_status" */
export type result_sheet_statusresult_sheetsArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** columns and relationships of "result_sheet_status" */
export type result_sheet_statusresult_sheets_aggregateArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** aggregated selection of "result_sheet_status" */
export type result_sheet_status_aggregate = {
  __typename?: 'result_sheet_status_aggregate';
  aggregate?: Maybe<result_sheet_status_aggregate_fields>;
  nodes: Array<result_sheet_status>;
};

/** aggregate fields of "result_sheet_status" */
export type result_sheet_status_aggregate_fields = {
  __typename?: 'result_sheet_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<result_sheet_status_max_fields>;
  min?: Maybe<result_sheet_status_min_fields>;
};

/** aggregate fields of "result_sheet_status" */
export type result_sheet_status_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<result_sheet_status_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "result_sheet_status". All fields are combined with a logical 'AND'. */
export type result_sheet_status_bool_exp = {
  _and?: Maybe<Array<result_sheet_status_bool_exp>>;
  _not?: Maybe<result_sheet_status_bool_exp>;
  _or?: Maybe<Array<result_sheet_status_bool_exp>>;
  name?: Maybe<String_comparison_exp>;
  result_sheets?: Maybe<result_sheet_bool_exp>;
};

/** unique or primary key constraints on table "result_sheet_status" */
export enum result_sheet_status_constraint {
  /** unique or primary key constraint */
  result_sheet_status_pkey = 'result_sheet_status_pkey',
}

export enum result_sheet_status_enum {
  approved = 'approved',
  draft = 'draft',
  notApproved = 'notApproved',
  pending = 'pending',
}

/** Boolean expression to compare columns of type "result_sheet_status_enum". All fields are combined with logical 'AND'. */
export type result_sheet_status_enum_comparison_exp = {
  _eq?: Maybe<result_sheet_status_enum>;
  _in?: Maybe<Array<result_sheet_status_enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<result_sheet_status_enum>;
  _nin?: Maybe<Array<result_sheet_status_enum>>;
};

/** input type for inserting data into table "result_sheet_status" */
export type result_sheet_status_insert_input = {
  name?: Maybe<Scalars['String']>;
  result_sheets?: Maybe<result_sheet_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type result_sheet_status_max_fields = {
  __typename?: 'result_sheet_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type result_sheet_status_min_fields = {
  __typename?: 'result_sheet_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "result_sheet_status" */
export type result_sheet_status_mutation_response = {
  __typename?: 'result_sheet_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<result_sheet_status>;
};

/** input type for inserting object relation for remote table "result_sheet_status" */
export type result_sheet_status_obj_rel_insert_input = {
  data: result_sheet_status_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<result_sheet_status_on_conflict>;
};

/** on conflict condition type for table "result_sheet_status" */
export type result_sheet_status_on_conflict = {
  constraint: result_sheet_status_constraint;
  update_columns?: Array<result_sheet_status_update_column>;
  where?: Maybe<result_sheet_status_bool_exp>;
};

/** Ordering options when selecting data from "result_sheet_status". */
export type result_sheet_status_order_by = {
  name?: Maybe<order_by>;
  result_sheets_aggregate?: Maybe<result_sheet_aggregate_order_by>;
};

/** primary key columns input for table: result_sheet_status */
export type result_sheet_status_pk_columns_input = {
  name: Scalars['String'];
};

/** select columns of table "result_sheet_status" */
export enum result_sheet_status_select_column {
  /** column name */
  name = 'name',
}

/** input type for updating data in table "result_sheet_status" */
export type result_sheet_status_set_input = {
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "result_sheet_status" */
export enum result_sheet_status_update_column {
  /** column name */
  name = 'name',
}

/** update columns of table "result_sheet" */
export enum result_sheet_update_column {
  /** column name */
  academicHeadRemark = 'academicHeadRemark',
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  id = 'id',
  /** column name */
  status = 'status',
  /** column name */
  userId = 'userId',
}

/** columns and relationships of "route" */
export type route = {
  __typename?: 'route';
  componentName?: Maybe<Scalars['String']>;
  dummy: Scalars['Boolean'];
  global: Scalars['Boolean'];
  iconName: Scalars['String'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  /** An object relationship */
  route?: Maybe<route>;
  /** An array relationship */
  route_endpoints_endpoints: Array<route_endpoints_endpoint>;
  /** An aggregate relationship */
  route_endpoints_endpoints_aggregate: route_endpoints_endpoint_aggregate;
  /** An array relationship */
  routes: Array<route>;
  /** An aggregate relationship */
  routes_aggregate: route_aggregate;
  showInMenu: Scalars['Boolean'];
  studentStatus?: Maybe<student_status_enum>;
  /** An object relationship */
  student_status?: Maybe<student_status>;
  /** An array relationship */
  user_role_routes_routes: Array<user_role_routes_route>;
  /** An aggregate relationship */
  user_role_routes_routes_aggregate: user_role_routes_route_aggregate;
  /** An array relationship */
  user_routes_routes: Array<user_routes_route>;
  /** An aggregate relationship */
  user_routes_routes_aggregate: user_routes_route_aggregate;
};

/** columns and relationships of "route" */
export type routeroute_endpoints_endpointsArgs = {
  distinct_on?: Maybe<Array<route_endpoints_endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_endpoints_endpoint_order_by>>;
  where?: Maybe<route_endpoints_endpoint_bool_exp>;
};

/** columns and relationships of "route" */
export type routeroute_endpoints_endpoints_aggregateArgs = {
  distinct_on?: Maybe<Array<route_endpoints_endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_endpoints_endpoint_order_by>>;
  where?: Maybe<route_endpoints_endpoint_bool_exp>;
};

/** columns and relationships of "route" */
export type routeroutesArgs = {
  distinct_on?: Maybe<Array<route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_order_by>>;
  where?: Maybe<route_bool_exp>;
};

/** columns and relationships of "route" */
export type routeroutes_aggregateArgs = {
  distinct_on?: Maybe<Array<route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_order_by>>;
  where?: Maybe<route_bool_exp>;
};

/** columns and relationships of "route" */
export type routeuser_role_routes_routesArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

/** columns and relationships of "route" */
export type routeuser_role_routes_routes_aggregateArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

/** columns and relationships of "route" */
export type routeuser_routes_routesArgs = {
  distinct_on?: Maybe<Array<user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_routes_route_order_by>>;
  where?: Maybe<user_routes_route_bool_exp>;
};

/** columns and relationships of "route" */
export type routeuser_routes_routes_aggregateArgs = {
  distinct_on?: Maybe<Array<user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_routes_route_order_by>>;
  where?: Maybe<user_routes_route_bool_exp>;
};

/** aggregated selection of "route" */
export type route_aggregate = {
  __typename?: 'route_aggregate';
  aggregate?: Maybe<route_aggregate_fields>;
  nodes: Array<route>;
};

/** aggregate fields of "route" */
export type route_aggregate_fields = {
  __typename?: 'route_aggregate_fields';
  avg?: Maybe<route_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<route_max_fields>;
  min?: Maybe<route_min_fields>;
  stddev?: Maybe<route_stddev_fields>;
  stddev_pop?: Maybe<route_stddev_pop_fields>;
  stddev_samp?: Maybe<route_stddev_samp_fields>;
  sum?: Maybe<route_sum_fields>;
  var_pop?: Maybe<route_var_pop_fields>;
  var_samp?: Maybe<route_var_samp_fields>;
  variance?: Maybe<route_variance_fields>;
};

/** aggregate fields of "route" */
export type route_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<route_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "route" */
export type route_aggregate_order_by = {
  avg?: Maybe<route_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<route_max_order_by>;
  min?: Maybe<route_min_order_by>;
  stddev?: Maybe<route_stddev_order_by>;
  stddev_pop?: Maybe<route_stddev_pop_order_by>;
  stddev_samp?: Maybe<route_stddev_samp_order_by>;
  sum?: Maybe<route_sum_order_by>;
  var_pop?: Maybe<route_var_pop_order_by>;
  var_samp?: Maybe<route_var_samp_order_by>;
  variance?: Maybe<route_variance_order_by>;
};

/** input type for inserting array relation for remote table "route" */
export type route_arr_rel_insert_input = {
  data: Array<route_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<route_on_conflict>;
};

/** aggregate avg on columns */
export type route_avg_fields = {
  __typename?: 'route_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "route" */
export type route_avg_order_by = {
  order?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "route". All fields are combined with a logical 'AND'. */
export type route_bool_exp = {
  _and?: Maybe<Array<route_bool_exp>>;
  _not?: Maybe<route_bool_exp>;
  _or?: Maybe<Array<route_bool_exp>>;
  componentName?: Maybe<String_comparison_exp>;
  dummy?: Maybe<Boolean_comparison_exp>;
  global?: Maybe<Boolean_comparison_exp>;
  iconName?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  order?: Maybe<Int_comparison_exp>;
  parentId?: Maybe<uuid_comparison_exp>;
  path?: Maybe<String_comparison_exp>;
  route?: Maybe<route_bool_exp>;
  route_endpoints_endpoints?: Maybe<route_endpoints_endpoint_bool_exp>;
  routes?: Maybe<route_bool_exp>;
  showInMenu?: Maybe<Boolean_comparison_exp>;
  studentStatus?: Maybe<student_status_enum_comparison_exp>;
  student_status?: Maybe<student_status_bool_exp>;
  user_role_routes_routes?: Maybe<user_role_routes_route_bool_exp>;
  user_routes_routes?: Maybe<user_routes_route_bool_exp>;
};

/** unique or primary key constraints on table "route" */
export enum route_constraint {
  /** unique or primary key constraint */
  PK_08affcd076e46415e5821acf52d = 'PK_08affcd076e46415e5821acf52d',
  /** unique or primary key constraint */
  route_name_key = 'route_name_key',
}

/** columns and relationships of "route_endpoints_endpoint" */
export type route_endpoints_endpoint = {
  __typename?: 'route_endpoints_endpoint';
  /** An object relationship */
  endpoint: endpoint;
  endpointId: Scalars['uuid'];
  /** An object relationship */
  route: route;
  routeId: Scalars['uuid'];
};

/** aggregated selection of "route_endpoints_endpoint" */
export type route_endpoints_endpoint_aggregate = {
  __typename?: 'route_endpoints_endpoint_aggregate';
  aggregate?: Maybe<route_endpoints_endpoint_aggregate_fields>;
  nodes: Array<route_endpoints_endpoint>;
};

/** aggregate fields of "route_endpoints_endpoint" */
export type route_endpoints_endpoint_aggregate_fields = {
  __typename?: 'route_endpoints_endpoint_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<route_endpoints_endpoint_max_fields>;
  min?: Maybe<route_endpoints_endpoint_min_fields>;
};

/** aggregate fields of "route_endpoints_endpoint" */
export type route_endpoints_endpoint_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<route_endpoints_endpoint_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "route_endpoints_endpoint" */
export type route_endpoints_endpoint_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<route_endpoints_endpoint_max_order_by>;
  min?: Maybe<route_endpoints_endpoint_min_order_by>;
};

/** input type for inserting array relation for remote table "route_endpoints_endpoint" */
export type route_endpoints_endpoint_arr_rel_insert_input = {
  data: Array<route_endpoints_endpoint_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<route_endpoints_endpoint_on_conflict>;
};

/** Boolean expression to filter rows from the table "route_endpoints_endpoint". All fields are combined with a logical 'AND'. */
export type route_endpoints_endpoint_bool_exp = {
  _and?: Maybe<Array<route_endpoints_endpoint_bool_exp>>;
  _not?: Maybe<route_endpoints_endpoint_bool_exp>;
  _or?: Maybe<Array<route_endpoints_endpoint_bool_exp>>;
  endpoint?: Maybe<endpoint_bool_exp>;
  endpointId?: Maybe<uuid_comparison_exp>;
  route?: Maybe<route_bool_exp>;
  routeId?: Maybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "route_endpoints_endpoint" */
export enum route_endpoints_endpoint_constraint {
  /** unique or primary key constraint */
  route_endpoints_endpoint_pkey = 'route_endpoints_endpoint_pkey',
}

/** input type for inserting data into table "route_endpoints_endpoint" */
export type route_endpoints_endpoint_insert_input = {
  endpoint?: Maybe<endpoint_obj_rel_insert_input>;
  endpointId?: Maybe<Scalars['uuid']>;
  route?: Maybe<route_obj_rel_insert_input>;
  routeId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type route_endpoints_endpoint_max_fields = {
  __typename?: 'route_endpoints_endpoint_max_fields';
  endpointId?: Maybe<Scalars['uuid']>;
  routeId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "route_endpoints_endpoint" */
export type route_endpoints_endpoint_max_order_by = {
  endpointId?: Maybe<order_by>;
  routeId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type route_endpoints_endpoint_min_fields = {
  __typename?: 'route_endpoints_endpoint_min_fields';
  endpointId?: Maybe<Scalars['uuid']>;
  routeId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "route_endpoints_endpoint" */
export type route_endpoints_endpoint_min_order_by = {
  endpointId?: Maybe<order_by>;
  routeId?: Maybe<order_by>;
};

/** response of any mutation on the table "route_endpoints_endpoint" */
export type route_endpoints_endpoint_mutation_response = {
  __typename?: 'route_endpoints_endpoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<route_endpoints_endpoint>;
};

/** on conflict condition type for table "route_endpoints_endpoint" */
export type route_endpoints_endpoint_on_conflict = {
  constraint: route_endpoints_endpoint_constraint;
  update_columns?: Array<route_endpoints_endpoint_update_column>;
  where?: Maybe<route_endpoints_endpoint_bool_exp>;
};

/** Ordering options when selecting data from "route_endpoints_endpoint". */
export type route_endpoints_endpoint_order_by = {
  endpoint?: Maybe<endpoint_order_by>;
  endpointId?: Maybe<order_by>;
  route?: Maybe<route_order_by>;
  routeId?: Maybe<order_by>;
};

/** primary key columns input for table: route_endpoints_endpoint */
export type route_endpoints_endpoint_pk_columns_input = {
  endpointId: Scalars['uuid'];
  routeId: Scalars['uuid'];
};

/** select columns of table "route_endpoints_endpoint" */
export enum route_endpoints_endpoint_select_column {
  /** column name */
  endpointId = 'endpointId',
  /** column name */
  routeId = 'routeId',
}

/** input type for updating data in table "route_endpoints_endpoint" */
export type route_endpoints_endpoint_set_input = {
  endpointId?: Maybe<Scalars['uuid']>;
  routeId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "route_endpoints_endpoint" */
export enum route_endpoints_endpoint_update_column {
  /** column name */
  endpointId = 'endpointId',
  /** column name */
  routeId = 'routeId',
}

/** input type for incrementing numeric columns in table "route" */
export type route_inc_input = {
  order?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "route" */
export type route_insert_input = {
  componentName?: Maybe<Scalars['String']>;
  dummy?: Maybe<Scalars['Boolean']>;
  global?: Maybe<Scalars['Boolean']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  route?: Maybe<route_obj_rel_insert_input>;
  route_endpoints_endpoints?: Maybe<route_endpoints_endpoint_arr_rel_insert_input>;
  routes?: Maybe<route_arr_rel_insert_input>;
  showInMenu?: Maybe<Scalars['Boolean']>;
  studentStatus?: Maybe<student_status_enum>;
  student_status?: Maybe<student_status_obj_rel_insert_input>;
  user_role_routes_routes?: Maybe<user_role_routes_route_arr_rel_insert_input>;
  user_routes_routes?: Maybe<user_routes_route_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type route_max_fields = {
  __typename?: 'route_max_fields';
  componentName?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "route" */
export type route_max_order_by = {
  componentName?: Maybe<order_by>;
  iconName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  order?: Maybe<order_by>;
  parentId?: Maybe<order_by>;
  path?: Maybe<order_by>;
};

/** aggregate min on columns */
export type route_min_fields = {
  __typename?: 'route_min_fields';
  componentName?: Maybe<Scalars['String']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "route" */
export type route_min_order_by = {
  componentName?: Maybe<order_by>;
  iconName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  order?: Maybe<order_by>;
  parentId?: Maybe<order_by>;
  path?: Maybe<order_by>;
};

/** response of any mutation on the table "route" */
export type route_mutation_response = {
  __typename?: 'route_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<route>;
};

/** input type for inserting object relation for remote table "route" */
export type route_obj_rel_insert_input = {
  data: route_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<route_on_conflict>;
};

/** on conflict condition type for table "route" */
export type route_on_conflict = {
  constraint: route_constraint;
  update_columns?: Array<route_update_column>;
  where?: Maybe<route_bool_exp>;
};

/** Ordering options when selecting data from "route". */
export type route_order_by = {
  componentName?: Maybe<order_by>;
  dummy?: Maybe<order_by>;
  global?: Maybe<order_by>;
  iconName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  order?: Maybe<order_by>;
  parentId?: Maybe<order_by>;
  path?: Maybe<order_by>;
  route?: Maybe<route_order_by>;
  route_endpoints_endpoints_aggregate?: Maybe<route_endpoints_endpoint_aggregate_order_by>;
  routes_aggregate?: Maybe<route_aggregate_order_by>;
  showInMenu?: Maybe<order_by>;
  studentStatus?: Maybe<order_by>;
  student_status?: Maybe<student_status_order_by>;
  user_role_routes_routes_aggregate?: Maybe<user_role_routes_route_aggregate_order_by>;
  user_routes_routes_aggregate?: Maybe<user_routes_route_aggregate_order_by>;
};

/** primary key columns input for table: route */
export type route_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "route" */
export enum route_select_column {
  /** column name */
  componentName = 'componentName',
  /** column name */
  dummy = 'dummy',
  /** column name */
  global = 'global',
  /** column name */
  iconName = 'iconName',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  order = 'order',
  /** column name */
  parentId = 'parentId',
  /** column name */
  path = 'path',
  /** column name */
  showInMenu = 'showInMenu',
  /** column name */
  studentStatus = 'studentStatus',
}

/** input type for updating data in table "route" */
export type route_set_input = {
  componentName?: Maybe<Scalars['String']>;
  dummy?: Maybe<Scalars['Boolean']>;
  global?: Maybe<Scalars['Boolean']>;
  iconName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentId?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  showInMenu?: Maybe<Scalars['Boolean']>;
  studentStatus?: Maybe<student_status_enum>;
};

/** aggregate stddev on columns */
export type route_stddev_fields = {
  __typename?: 'route_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "route" */
export type route_stddev_order_by = {
  order?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type route_stddev_pop_fields = {
  __typename?: 'route_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "route" */
export type route_stddev_pop_order_by = {
  order?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type route_stddev_samp_fields = {
  __typename?: 'route_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "route" */
export type route_stddev_samp_order_by = {
  order?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type route_sum_fields = {
  __typename?: 'route_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "route" */
export type route_sum_order_by = {
  order?: Maybe<order_by>;
};

/** update columns of table "route" */
export enum route_update_column {
  /** column name */
  componentName = 'componentName',
  /** column name */
  dummy = 'dummy',
  /** column name */
  global = 'global',
  /** column name */
  iconName = 'iconName',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  order = 'order',
  /** column name */
  parentId = 'parentId',
  /** column name */
  path = 'path',
  /** column name */
  showInMenu = 'showInMenu',
  /** column name */
  studentStatus = 'studentStatus',
}

/** aggregate var_pop on columns */
export type route_var_pop_fields = {
  __typename?: 'route_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "route" */
export type route_var_pop_order_by = {
  order?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type route_var_samp_fields = {
  __typename?: 'route_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "route" */
export type route_var_samp_order_by = {
  order?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type route_variance_fields = {
  __typename?: 'route_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "route" */
export type route_variance_order_by = {
  order?: Maybe<order_by>;
};

/** columns and relationships of "student" */
export type student = {
  __typename?: 'student';
  agreementURLs?: Maybe<Scalars['String']>;
  /** An array relationship */
  attendance_students: Array<attendance_student>;
  /** An aggregate relationship */
  attendance_students_aggregate: attendance_student_aggregate;
  bloodType?: Maybe<blood_type_enum>;
  /** An object relationship */
  blood_type?: Maybe<blood_type>;
  createdAt: Scalars['timestamp'];
  dateOfBirth?: Maybe<Scalars['date']>;
  /** An array relationship */
  education_qualifications: Array<education_qualification>;
  /** An aggregate relationship */
  education_qualifications_aggregate: education_qualification_aggregate;
  educationalCertificatesURLs?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  /** An array relationship */
  employment_experiences: Array<employment_experience>;
  /** An aggregate relationship */
  employment_experiences_aggregate: employment_experience_aggregate;
  /** An array relationship */
  exit_interview_answers: Array<exit_interview_answer>;
  /** An aggregate relationship */
  exit_interview_answers_aggregate: exit_interview_answer_aggregate;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['student_gender_enum']>;
  id: Scalars['Int'];
  illnessesDisabilities?: Maybe<Scalars['String']>;
  initialRegistrationFeePaid: Scalars['Boolean'];
  initialTourFollowed: Scalars['Boolean'];
  /** An object relationship */
  inquiry?: Maybe<inquiry>;
  isContactParent?: Maybe<Scalars['Boolean']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['student_nationality_enum']>;
  nicCopyURLs?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  ordinaryLevelCertificateURLs?: Maybe<Scalars['String']>;
  parentOrGuardianCity?: Maybe<Scalars['String']>;
  parentOrGuardianCountry?: Maybe<Scalars['String']>;
  parentOrGuardianDistrict?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianName?: Maybe<Scalars['String']>;
  parentOrGuardianProvince?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress1?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress2?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  passportOrBirthCertificateURLs?: Maybe<Scalars['String']>;
  passportSizePhotoURLs?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  postal_id?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  referredVia?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  /** An array relationship */
  request_messages: Array<student_request_message>;
  /** An aggregate relationship */
  request_messages_aggregate: student_request_message_aggregate;
  sameAsPermanentAddress?: Maybe<Scalars['Boolean']>;
  scannedDocumentURL?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  spokenLanguages?: Maybe<Scalars['String']>;
  status: student_status_enum;
  /** An array relationship */
  student_assessment_submissions: Array<student_assessment_submission>;
  /** An aggregate relationship */
  student_assessment_submissions_aggregate: student_assessment_submission_aggregate;
  /** An array relationship */
  student_batch_classes_batch_classes: Array<student_batch_classes_batch_class>;
  /** An aggregate relationship */
  student_batch_classes_batch_classes_aggregate: student_batch_classes_batch_class_aggregate;
  /** An array relationship */
  student_batch_histories: Array<student_batch_history>;
  /** An aggregate relationship */
  student_batch_histories_aggregate: student_batch_history_aggregate;
  /** An array relationship */
  student_courses: Array<student_course>;
  /** An aggregate relationship */
  student_courses_aggregate: student_course_aggregate;
  /** An array relationship */
  student_familiarization_interviews: Array<student_familiarization_interview>;
  /** An aggregate relationship */
  student_familiarization_interviews_aggregate: student_familiarization_interview_aggregate;
  /** An array relationship */
  student_performances: Array<student_performance>;
  /** An aggregate relationship */
  student_performances_aggregate: student_performance_aggregate;
  /** An array relationship */
  student_requests: Array<student_request>;
  /** An aggregate relationship */
  student_requests_aggregate: student_request_aggregate;
  /** An array relationship */
  student_result_sheets: Array<student_result_sheet>;
  /** An aggregate relationship */
  student_result_sheets_aggregate: student_result_sheet_aggregate;
  /** An object relationship */
  student_status: student_status;
  updatedAt: Scalars['timestamp'];
  updated_at?: Maybe<Scalars['timestamptz']>;
  waiID?: Maybe<Scalars['String']>;
  whatsapp_number?: Maybe<Scalars['String']>;
};

/** columns and relationships of "student" */
export type studentattendance_studentsArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

/** columns and relationships of "student" */
export type studentattendance_students_aggregateArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

/** columns and relationships of "student" */
export type studenteducation_qualificationsArgs = {
  distinct_on?: Maybe<Array<education_qualification_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<education_qualification_order_by>>;
  where?: Maybe<education_qualification_bool_exp>;
};

/** columns and relationships of "student" */
export type studenteducation_qualifications_aggregateArgs = {
  distinct_on?: Maybe<Array<education_qualification_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<education_qualification_order_by>>;
  where?: Maybe<education_qualification_bool_exp>;
};

/** columns and relationships of "student" */
export type studentemployment_experiencesArgs = {
  distinct_on?: Maybe<Array<employment_experience_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<employment_experience_order_by>>;
  where?: Maybe<employment_experience_bool_exp>;
};

/** columns and relationships of "student" */
export type studentemployment_experiences_aggregateArgs = {
  distinct_on?: Maybe<Array<employment_experience_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<employment_experience_order_by>>;
  where?: Maybe<employment_experience_bool_exp>;
};

/** columns and relationships of "student" */
export type studentexit_interview_answersArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

/** columns and relationships of "student" */
export type studentexit_interview_answers_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

/** columns and relationships of "student" */
export type studentrequest_messagesArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

/** columns and relationships of "student" */
export type studentrequest_messages_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_assessment_submissionsArgs = {
  distinct_on?: Maybe<Array<student_assessment_submission_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_assessment_submission_order_by>>;
  where?: Maybe<student_assessment_submission_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_assessment_submissions_aggregateArgs = {
  distinct_on?: Maybe<Array<student_assessment_submission_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_assessment_submission_order_by>>;
  where?: Maybe<student_assessment_submission_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_batch_classes_batch_classesArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_batch_classes_batch_classes_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_batch_historiesArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_batch_histories_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_coursesArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_courses_aggregateArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_familiarization_interviewsArgs = {
  distinct_on?: Maybe<Array<student_familiarization_interview_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_interview_order_by>>;
  where?: Maybe<student_familiarization_interview_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_familiarization_interviews_aggregateArgs = {
  distinct_on?: Maybe<Array<student_familiarization_interview_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_interview_order_by>>;
  where?: Maybe<student_familiarization_interview_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_performancesArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_performances_aggregateArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_requestsArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_requests_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_result_sheetsArgs = {
  distinct_on?: Maybe<Array<student_result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_sheet_order_by>>;
  where?: Maybe<student_result_sheet_bool_exp>;
};

/** columns and relationships of "student" */
export type studentstudent_result_sheets_aggregateArgs = {
  distinct_on?: Maybe<Array<student_result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_sheet_order_by>>;
  where?: Maybe<student_result_sheet_bool_exp>;
};

/** columns and relationships of "student_admin_editable_information" */
export type student_admin_editable_information = {
  __typename?: 'student_admin_editable_information';
  id?: Maybe<Scalars['Int']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** An object relationship */
  student_status?: Maybe<student_status>;
};

/** aggregated selection of "student_admin_editable_information" */
export type student_admin_editable_information_aggregate = {
  __typename?: 'student_admin_editable_information_aggregate';
  aggregate?: Maybe<student_admin_editable_information_aggregate_fields>;
  nodes: Array<student_admin_editable_information>;
};

/** aggregate fields of "student_admin_editable_information" */
export type student_admin_editable_information_aggregate_fields = {
  __typename?: 'student_admin_editable_information_aggregate_fields';
  avg?: Maybe<student_admin_editable_information_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_admin_editable_information_max_fields>;
  min?: Maybe<student_admin_editable_information_min_fields>;
  stddev?: Maybe<student_admin_editable_information_stddev_fields>;
  stddev_pop?: Maybe<student_admin_editable_information_stddev_pop_fields>;
  stddev_samp?: Maybe<student_admin_editable_information_stddev_samp_fields>;
  sum?: Maybe<student_admin_editable_information_sum_fields>;
  var_pop?: Maybe<student_admin_editable_information_var_pop_fields>;
  var_samp?: Maybe<student_admin_editable_information_var_samp_fields>;
  variance?: Maybe<student_admin_editable_information_variance_fields>;
};

/** aggregate fields of "student_admin_editable_information" */
export type student_admin_editable_information_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_admin_editable_information_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type student_admin_editable_information_avg_fields = {
  __typename?: 'student_admin_editable_information_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "student_admin_editable_information". All fields are combined with a logical 'AND'. */
export type student_admin_editable_information_bool_exp = {
  _and?: Maybe<Array<student_admin_editable_information_bool_exp>>;
  _not?: Maybe<student_admin_editable_information_bool_exp>;
  _or?: Maybe<Array<student_admin_editable_information_bool_exp>>;
  id?: Maybe<Int_comparison_exp>;
  regNumber?: Maybe<String_comparison_exp>;
  status?: Maybe<String_comparison_exp>;
  student_status?: Maybe<student_status_bool_exp>;
};

/** input type for incrementing numeric columns in table "student_admin_editable_information" */
export type student_admin_editable_information_inc_input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_admin_editable_information" */
export type student_admin_editable_information_insert_input = {
  id?: Maybe<Scalars['Int']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student_status?: Maybe<student_status_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type student_admin_editable_information_max_fields = {
  __typename?: 'student_admin_editable_information_max_fields';
  id?: Maybe<Scalars['Int']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type student_admin_editable_information_min_fields = {
  __typename?: 'student_admin_editable_information_min_fields';
  id?: Maybe<Scalars['Int']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "student_admin_editable_information" */
export type student_admin_editable_information_mutation_response = {
  __typename?: 'student_admin_editable_information_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_admin_editable_information>;
};

/** Ordering options when selecting data from "student_admin_editable_information". */
export type student_admin_editable_information_order_by = {
  id?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
  status?: Maybe<order_by>;
  student_status?: Maybe<student_status_order_by>;
};

/** select columns of table "student_admin_editable_information" */
export enum student_admin_editable_information_select_column {
  /** column name */
  id = 'id',
  /** column name */
  regNumber = 'regNumber',
  /** column name */
  status = 'status',
}

/** input type for updating data in table "student_admin_editable_information" */
export type student_admin_editable_information_set_input = {
  id?: Maybe<Scalars['Int']>;
  regNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type student_admin_editable_information_stddev_fields = {
  __typename?: 'student_admin_editable_information_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type student_admin_editable_information_stddev_pop_fields = {
  __typename?: 'student_admin_editable_information_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type student_admin_editable_information_stddev_samp_fields = {
  __typename?: 'student_admin_editable_information_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type student_admin_editable_information_sum_fields = {
  __typename?: 'student_admin_editable_information_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type student_admin_editable_information_var_pop_fields = {
  __typename?: 'student_admin_editable_information_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type student_admin_editable_information_var_samp_fields = {
  __typename?: 'student_admin_editable_information_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type student_admin_editable_information_variance_fields = {
  __typename?: 'student_admin_editable_information_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "student" */
export type student_aggregate = {
  __typename?: 'student_aggregate';
  aggregate?: Maybe<student_aggregate_fields>;
  nodes: Array<student>;
};

/** aggregate fields of "student" */
export type student_aggregate_fields = {
  __typename?: 'student_aggregate_fields';
  avg?: Maybe<student_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_max_fields>;
  min?: Maybe<student_min_fields>;
  stddev?: Maybe<student_stddev_fields>;
  stddev_pop?: Maybe<student_stddev_pop_fields>;
  stddev_samp?: Maybe<student_stddev_samp_fields>;
  sum?: Maybe<student_sum_fields>;
  var_pop?: Maybe<student_var_pop_fields>;
  var_samp?: Maybe<student_var_samp_fields>;
  variance?: Maybe<student_variance_fields>;
};

/** aggregate fields of "student" */
export type student_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student" */
export type student_aggregate_order_by = {
  avg?: Maybe<student_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_max_order_by>;
  min?: Maybe<student_min_order_by>;
  stddev?: Maybe<student_stddev_order_by>;
  stddev_pop?: Maybe<student_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_stddev_samp_order_by>;
  sum?: Maybe<student_sum_order_by>;
  var_pop?: Maybe<student_var_pop_order_by>;
  var_samp?: Maybe<student_var_samp_order_by>;
  variance?: Maybe<student_variance_order_by>;
};

/** input type for inserting array relation for remote table "student" */
export type student_arr_rel_insert_input = {
  data: Array<student_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_on_conflict>;
};

/** columns and relationships of "student_assessment_submission" */
export type student_assessment_submission = {
  __typename?: 'student_assessment_submission';
  /** An object relationship */
  assessment: assessment;
  assessmentId: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  student: student;
  studentId: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
  uploadURLs: Scalars['String'];
};

/** aggregated selection of "student_assessment_submission" */
export type student_assessment_submission_aggregate = {
  __typename?: 'student_assessment_submission_aggregate';
  aggregate?: Maybe<student_assessment_submission_aggregate_fields>;
  nodes: Array<student_assessment_submission>;
};

/** aggregate fields of "student_assessment_submission" */
export type student_assessment_submission_aggregate_fields = {
  __typename?: 'student_assessment_submission_aggregate_fields';
  avg?: Maybe<student_assessment_submission_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_assessment_submission_max_fields>;
  min?: Maybe<student_assessment_submission_min_fields>;
  stddev?: Maybe<student_assessment_submission_stddev_fields>;
  stddev_pop?: Maybe<student_assessment_submission_stddev_pop_fields>;
  stddev_samp?: Maybe<student_assessment_submission_stddev_samp_fields>;
  sum?: Maybe<student_assessment_submission_sum_fields>;
  var_pop?: Maybe<student_assessment_submission_var_pop_fields>;
  var_samp?: Maybe<student_assessment_submission_var_samp_fields>;
  variance?: Maybe<student_assessment_submission_variance_fields>;
};

/** aggregate fields of "student_assessment_submission" */
export type student_assessment_submission_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_assessment_submission_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_assessment_submission" */
export type student_assessment_submission_aggregate_order_by = {
  avg?: Maybe<student_assessment_submission_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_assessment_submission_max_order_by>;
  min?: Maybe<student_assessment_submission_min_order_by>;
  stddev?: Maybe<student_assessment_submission_stddev_order_by>;
  stddev_pop?: Maybe<student_assessment_submission_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_assessment_submission_stddev_samp_order_by>;
  sum?: Maybe<student_assessment_submission_sum_order_by>;
  var_pop?: Maybe<student_assessment_submission_var_pop_order_by>;
  var_samp?: Maybe<student_assessment_submission_var_samp_order_by>;
  variance?: Maybe<student_assessment_submission_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_assessment_submission" */
export type student_assessment_submission_arr_rel_insert_input = {
  data: Array<student_assessment_submission_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_assessment_submission_on_conflict>;
};

/** aggregate avg on columns */
export type student_assessment_submission_avg_fields = {
  __typename?: 'student_assessment_submission_avg_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_assessment_submission" */
export type student_assessment_submission_avg_order_by = {
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_assessment_submission". All fields are combined with a logical 'AND'. */
export type student_assessment_submission_bool_exp = {
  _and?: Maybe<Array<student_assessment_submission_bool_exp>>;
  _not?: Maybe<student_assessment_submission_bool_exp>;
  _or?: Maybe<Array<student_assessment_submission_bool_exp>>;
  assessment?: Maybe<assessment_bool_exp>;
  assessmentId?: Maybe<uuid_comparison_exp>;
  created_at?: Maybe<timestamptz_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
  uploadURLs?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "student_assessment_submission" */
export enum student_assessment_submission_constraint {
  /** unique or primary key constraint */
  student_assessment_submission_pkey = 'student_assessment_submission_pkey',
}

/** input type for incrementing numeric columns in table "student_assessment_submission" */
export type student_assessment_submission_inc_input = {
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_assessment_submission" */
export type student_assessment_submission_insert_input = {
  assessment?: Maybe<assessment_obj_rel_insert_input>;
  assessmentId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploadURLs?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type student_assessment_submission_max_fields = {
  __typename?: 'student_assessment_submission_max_fields';
  assessmentId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploadURLs?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "student_assessment_submission" */
export type student_assessment_submission_max_order_by = {
  assessmentId?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  uploadURLs?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_assessment_submission_min_fields = {
  __typename?: 'student_assessment_submission_min_fields';
  assessmentId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploadURLs?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "student_assessment_submission" */
export type student_assessment_submission_min_order_by = {
  assessmentId?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  uploadURLs?: Maybe<order_by>;
};

/** response of any mutation on the table "student_assessment_submission" */
export type student_assessment_submission_mutation_response = {
  __typename?: 'student_assessment_submission_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_assessment_submission>;
};

/** on conflict condition type for table "student_assessment_submission" */
export type student_assessment_submission_on_conflict = {
  constraint: student_assessment_submission_constraint;
  update_columns?: Array<student_assessment_submission_update_column>;
  where?: Maybe<student_assessment_submission_bool_exp>;
};

/** Ordering options when selecting data from "student_assessment_submission". */
export type student_assessment_submission_order_by = {
  assessment?: Maybe<assessment_order_by>;
  assessmentId?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  id?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  uploadURLs?: Maybe<order_by>;
};

/** primary key columns input for table: student_assessment_submission */
export type student_assessment_submission_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_assessment_submission" */
export enum student_assessment_submission_select_column {
  /** column name */
  assessmentId = 'assessmentId',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  uploadURLs = 'uploadURLs',
}

/** input type for updating data in table "student_assessment_submission" */
export type student_assessment_submission_set_input = {
  assessmentId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  uploadURLs?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type student_assessment_submission_stddev_fields = {
  __typename?: 'student_assessment_submission_stddev_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_assessment_submission" */
export type student_assessment_submission_stddev_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_assessment_submission_stddev_pop_fields = {
  __typename?: 'student_assessment_submission_stddev_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_assessment_submission" */
export type student_assessment_submission_stddev_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_assessment_submission_stddev_samp_fields = {
  __typename?: 'student_assessment_submission_stddev_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_assessment_submission" */
export type student_assessment_submission_stddev_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_assessment_submission_sum_fields = {
  __typename?: 'student_assessment_submission_sum_fields';
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_assessment_submission" */
export type student_assessment_submission_sum_order_by = {
  studentId?: Maybe<order_by>;
};

/** update columns of table "student_assessment_submission" */
export enum student_assessment_submission_update_column {
  /** column name */
  assessmentId = 'assessmentId',
  /** column name */
  created_at = 'created_at',
  /** column name */
  id = 'id',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  uploadURLs = 'uploadURLs',
}

/** aggregate var_pop on columns */
export type student_assessment_submission_var_pop_fields = {
  __typename?: 'student_assessment_submission_var_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_assessment_submission" */
export type student_assessment_submission_var_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_assessment_submission_var_samp_fields = {
  __typename?: 'student_assessment_submission_var_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_assessment_submission" */
export type student_assessment_submission_var_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_assessment_submission_variance_fields = {
  __typename?: 'student_assessment_submission_variance_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_assessment_submission" */
export type student_assessment_submission_variance_order_by = {
  studentId?: Maybe<order_by>;
};

/** columns and relationships of "student_attendance_status" */
export type student_attendance_status = {
  __typename?: 'student_attendance_status';
  /** An array relationship */
  attendance_students: Array<attendance_student>;
  /** An aggregate relationship */
  attendance_students_aggregate: attendance_student_aggregate;
  name: Scalars['String'];
};

/** columns and relationships of "student_attendance_status" */
export type student_attendance_statusattendance_studentsArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

/** columns and relationships of "student_attendance_status" */
export type student_attendance_statusattendance_students_aggregateArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

/** aggregated selection of "student_attendance_status" */
export type student_attendance_status_aggregate = {
  __typename?: 'student_attendance_status_aggregate';
  aggregate?: Maybe<student_attendance_status_aggregate_fields>;
  nodes: Array<student_attendance_status>;
};

/** aggregate fields of "student_attendance_status" */
export type student_attendance_status_aggregate_fields = {
  __typename?: 'student_attendance_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<student_attendance_status_max_fields>;
  min?: Maybe<student_attendance_status_min_fields>;
};

/** aggregate fields of "student_attendance_status" */
export type student_attendance_status_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_attendance_status_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "student_attendance_status". All fields are combined with a logical 'AND'. */
export type student_attendance_status_bool_exp = {
  _and?: Maybe<Array<student_attendance_status_bool_exp>>;
  _not?: Maybe<student_attendance_status_bool_exp>;
  _or?: Maybe<Array<student_attendance_status_bool_exp>>;
  attendance_students?: Maybe<attendance_student_bool_exp>;
  name?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "student_attendance_status" */
export enum student_attendance_status_constraint {
  /** unique or primary key constraint */
  student_attendance_status_pkey = 'student_attendance_status_pkey',
}

export enum student_attendance_status_enum {
  absent = 'absent',
  halfDay = 'halfDay',
  present = 'present',
}

/** Boolean expression to compare columns of type "student_attendance_status_enum". All fields are combined with logical 'AND'. */
export type student_attendance_status_enum_comparison_exp = {
  _eq?: Maybe<student_attendance_status_enum>;
  _in?: Maybe<Array<student_attendance_status_enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<student_attendance_status_enum>;
  _nin?: Maybe<Array<student_attendance_status_enum>>;
};

/** input type for inserting data into table "student_attendance_status" */
export type student_attendance_status_insert_input = {
  attendance_students?: Maybe<attendance_student_arr_rel_insert_input>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type student_attendance_status_max_fields = {
  __typename?: 'student_attendance_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type student_attendance_status_min_fields = {
  __typename?: 'student_attendance_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "student_attendance_status" */
export type student_attendance_status_mutation_response = {
  __typename?: 'student_attendance_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_attendance_status>;
};

/** input type for inserting object relation for remote table "student_attendance_status" */
export type student_attendance_status_obj_rel_insert_input = {
  data: student_attendance_status_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<student_attendance_status_on_conflict>;
};

/** on conflict condition type for table "student_attendance_status" */
export type student_attendance_status_on_conflict = {
  constraint: student_attendance_status_constraint;
  update_columns?: Array<student_attendance_status_update_column>;
  where?: Maybe<student_attendance_status_bool_exp>;
};

/** Ordering options when selecting data from "student_attendance_status". */
export type student_attendance_status_order_by = {
  attendance_students_aggregate?: Maybe<attendance_student_aggregate_order_by>;
  name?: Maybe<order_by>;
};

/** primary key columns input for table: student_attendance_status */
export type student_attendance_status_pk_columns_input = {
  name: Scalars['String'];
};

/** select columns of table "student_attendance_status" */
export enum student_attendance_status_select_column {
  /** column name */
  name = 'name',
}

/** input type for updating data in table "student_attendance_status" */
export type student_attendance_status_set_input = {
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "student_attendance_status" */
export enum student_attendance_status_update_column {
  /** column name */
  name = 'name',
}

/** aggregate avg on columns */
export type student_avg_fields = {
  __typename?: 'student_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student" */
export type student_avg_order_by = {
  id?: Maybe<order_by>;
};

/** columns and relationships of "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class = {
  __typename?: 'student_batch_classes_batch_class';
  batchClassId: Scalars['uuid'];
  /** An object relationship */
  batch_class: batch_class;
  /** An object relationship */
  student: student;
  studentId: Scalars['Int'];
};

/** aggregated selection of "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_aggregate = {
  __typename?: 'student_batch_classes_batch_class_aggregate';
  aggregate?: Maybe<student_batch_classes_batch_class_aggregate_fields>;
  nodes: Array<student_batch_classes_batch_class>;
};

/** aggregate fields of "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_aggregate_fields = {
  __typename?: 'student_batch_classes_batch_class_aggregate_fields';
  avg?: Maybe<student_batch_classes_batch_class_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_batch_classes_batch_class_max_fields>;
  min?: Maybe<student_batch_classes_batch_class_min_fields>;
  stddev?: Maybe<student_batch_classes_batch_class_stddev_fields>;
  stddev_pop?: Maybe<student_batch_classes_batch_class_stddev_pop_fields>;
  stddev_samp?: Maybe<student_batch_classes_batch_class_stddev_samp_fields>;
  sum?: Maybe<student_batch_classes_batch_class_sum_fields>;
  var_pop?: Maybe<student_batch_classes_batch_class_var_pop_fields>;
  var_samp?: Maybe<student_batch_classes_batch_class_var_samp_fields>;
  variance?: Maybe<student_batch_classes_batch_class_variance_fields>;
};

/** aggregate fields of "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_aggregate_order_by = {
  avg?: Maybe<student_batch_classes_batch_class_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_batch_classes_batch_class_max_order_by>;
  min?: Maybe<student_batch_classes_batch_class_min_order_by>;
  stddev?: Maybe<student_batch_classes_batch_class_stddev_order_by>;
  stddev_pop?: Maybe<student_batch_classes_batch_class_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_batch_classes_batch_class_stddev_samp_order_by>;
  sum?: Maybe<student_batch_classes_batch_class_sum_order_by>;
  var_pop?: Maybe<student_batch_classes_batch_class_var_pop_order_by>;
  var_samp?: Maybe<student_batch_classes_batch_class_var_samp_order_by>;
  variance?: Maybe<student_batch_classes_batch_class_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_arr_rel_insert_input = {
  data: Array<student_batch_classes_batch_class_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_batch_classes_batch_class_on_conflict>;
};

/** aggregate avg on columns */
export type student_batch_classes_batch_class_avg_fields = {
  __typename?: 'student_batch_classes_batch_class_avg_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_avg_order_by = {
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_batch_classes_batch_class". All fields are combined with a logical 'AND'. */
export type student_batch_classes_batch_class_bool_exp = {
  _and?: Maybe<Array<student_batch_classes_batch_class_bool_exp>>;
  _not?: Maybe<student_batch_classes_batch_class_bool_exp>;
  _or?: Maybe<Array<student_batch_classes_batch_class_bool_exp>>;
  batchClassId?: Maybe<uuid_comparison_exp>;
  batch_class?: Maybe<batch_class_bool_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "student_batch_classes_batch_class" */
export enum student_batch_classes_batch_class_constraint {
  /** unique or primary key constraint */
  PK_2fc751399a9d523639cc429eecc = 'PK_2fc751399a9d523639cc429eecc',
  /** unique or primary key constraint */
  student_batch_classes_batch_class_studentId_batchClassId_key = 'student_batch_classes_batch_class_studentId_batchClassId_key',
}

/** input type for incrementing numeric columns in table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_inc_input = {
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_insert_input = {
  batchClassId?: Maybe<Scalars['uuid']>;
  batch_class?: Maybe<batch_class_obj_rel_insert_input>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type student_batch_classes_batch_class_max_fields = {
  __typename?: 'student_batch_classes_batch_class_max_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_max_order_by = {
  batchClassId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_batch_classes_batch_class_min_fields = {
  __typename?: 'student_batch_classes_batch_class_min_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_min_order_by = {
  batchClassId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** response of any mutation on the table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_mutation_response = {
  __typename?: 'student_batch_classes_batch_class_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_batch_classes_batch_class>;
};

/** on conflict condition type for table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_on_conflict = {
  constraint: student_batch_classes_batch_class_constraint;
  update_columns?: Array<student_batch_classes_batch_class_update_column>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

/** Ordering options when selecting data from "student_batch_classes_batch_class". */
export type student_batch_classes_batch_class_order_by = {
  batchClassId?: Maybe<order_by>;
  batch_class?: Maybe<batch_class_order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
};

/** primary key columns input for table: student_batch_classes_batch_class */
export type student_batch_classes_batch_class_pk_columns_input = {
  batchClassId: Scalars['uuid'];
  studentId: Scalars['Int'];
};

/** select columns of table "student_batch_classes_batch_class" */
export enum student_batch_classes_batch_class_select_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  studentId = 'studentId',
}

/** input type for updating data in table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_set_input = {
  batchClassId?: Maybe<Scalars['uuid']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type student_batch_classes_batch_class_stddev_fields = {
  __typename?: 'student_batch_classes_batch_class_stddev_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_stddev_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_batch_classes_batch_class_stddev_pop_fields = {
  __typename?: 'student_batch_classes_batch_class_stddev_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_stddev_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_batch_classes_batch_class_stddev_samp_fields = {
  __typename?: 'student_batch_classes_batch_class_stddev_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_stddev_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_batch_classes_batch_class_sum_fields = {
  __typename?: 'student_batch_classes_batch_class_sum_fields';
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_sum_order_by = {
  studentId?: Maybe<order_by>;
};

/** update columns of table "student_batch_classes_batch_class" */
export enum student_batch_classes_batch_class_update_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  studentId = 'studentId',
}

/** aggregate var_pop on columns */
export type student_batch_classes_batch_class_var_pop_fields = {
  __typename?: 'student_batch_classes_batch_class_var_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_var_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_batch_classes_batch_class_var_samp_fields = {
  __typename?: 'student_batch_classes_batch_class_var_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_var_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_batch_classes_batch_class_variance_fields = {
  __typename?: 'student_batch_classes_batch_class_variance_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_batch_classes_batch_class" */
export type student_batch_classes_batch_class_variance_order_by = {
  studentId?: Maybe<order_by>;
};

/** columns and relationships of "student_batch_history" */
export type student_batch_history = {
  __typename?: 'student_batch_history';
  batchClassId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  batch_class?: Maybe<batch_class>;
  endDate?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  startDate: Scalars['timestamp'];
  /** An object relationship */
  student?: Maybe<student>;
  studentId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  student_batch_history_subjects: Array<student_batch_history_subject>;
  /** An aggregate relationship */
  student_batch_history_subjects_aggregate: student_batch_history_subject_aggregate;
};

/** columns and relationships of "student_batch_history" */
export type student_batch_historystudent_batch_history_subjectsArgs = {
  distinct_on?: Maybe<Array<student_batch_history_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_subject_order_by>>;
  where?: Maybe<student_batch_history_subject_bool_exp>;
};

/** columns and relationships of "student_batch_history" */
export type student_batch_historystudent_batch_history_subjects_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_subject_order_by>>;
  where?: Maybe<student_batch_history_subject_bool_exp>;
};

/** aggregated selection of "student_batch_history" */
export type student_batch_history_aggregate = {
  __typename?: 'student_batch_history_aggregate';
  aggregate?: Maybe<student_batch_history_aggregate_fields>;
  nodes: Array<student_batch_history>;
};

/** aggregate fields of "student_batch_history" */
export type student_batch_history_aggregate_fields = {
  __typename?: 'student_batch_history_aggregate_fields';
  avg?: Maybe<student_batch_history_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_batch_history_max_fields>;
  min?: Maybe<student_batch_history_min_fields>;
  stddev?: Maybe<student_batch_history_stddev_fields>;
  stddev_pop?: Maybe<student_batch_history_stddev_pop_fields>;
  stddev_samp?: Maybe<student_batch_history_stddev_samp_fields>;
  sum?: Maybe<student_batch_history_sum_fields>;
  var_pop?: Maybe<student_batch_history_var_pop_fields>;
  var_samp?: Maybe<student_batch_history_var_samp_fields>;
  variance?: Maybe<student_batch_history_variance_fields>;
};

/** aggregate fields of "student_batch_history" */
export type student_batch_history_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_batch_history_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_batch_history" */
export type student_batch_history_aggregate_order_by = {
  avg?: Maybe<student_batch_history_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_batch_history_max_order_by>;
  min?: Maybe<student_batch_history_min_order_by>;
  stddev?: Maybe<student_batch_history_stddev_order_by>;
  stddev_pop?: Maybe<student_batch_history_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_batch_history_stddev_samp_order_by>;
  sum?: Maybe<student_batch_history_sum_order_by>;
  var_pop?: Maybe<student_batch_history_var_pop_order_by>;
  var_samp?: Maybe<student_batch_history_var_samp_order_by>;
  variance?: Maybe<student_batch_history_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_batch_history" */
export type student_batch_history_arr_rel_insert_input = {
  data: Array<student_batch_history_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_batch_history_on_conflict>;
};

/** aggregate avg on columns */
export type student_batch_history_avg_fields = {
  __typename?: 'student_batch_history_avg_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_batch_history" */
export type student_batch_history_avg_order_by = {
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_batch_history". All fields are combined with a logical 'AND'. */
export type student_batch_history_bool_exp = {
  _and?: Maybe<Array<student_batch_history_bool_exp>>;
  _not?: Maybe<student_batch_history_bool_exp>;
  _or?: Maybe<Array<student_batch_history_bool_exp>>;
  batchClassId?: Maybe<uuid_comparison_exp>;
  batch_class?: Maybe<batch_class_bool_exp>;
  endDate?: Maybe<timestamp_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  startDate?: Maybe<timestamp_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  student_batch_history_subjects?: Maybe<student_batch_history_subject_bool_exp>;
};

/** unique or primary key constraints on table "student_batch_history" */
export enum student_batch_history_constraint {
  /** unique or primary key constraint */
  PK_b8a0eabad45e541d46bd11461a5 = 'PK_b8a0eabad45e541d46bd11461a5',
}

/** input type for incrementing numeric columns in table "student_batch_history" */
export type student_batch_history_inc_input = {
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_batch_history" */
export type student_batch_history_insert_input = {
  batchClassId?: Maybe<Scalars['uuid']>;
  batch_class?: Maybe<batch_class_obj_rel_insert_input>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamp']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  student_batch_history_subjects?: Maybe<student_batch_history_subject_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type student_batch_history_max_fields = {
  __typename?: 'student_batch_history_max_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamp']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "student_batch_history" */
export type student_batch_history_max_order_by = {
  batchClassId?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_batch_history_min_fields = {
  __typename?: 'student_batch_history_min_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamp']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "student_batch_history" */
export type student_batch_history_min_order_by = {
  batchClassId?: Maybe<order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** response of any mutation on the table "student_batch_history" */
export type student_batch_history_mutation_response = {
  __typename?: 'student_batch_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_batch_history>;
};

/** input type for inserting object relation for remote table "student_batch_history" */
export type student_batch_history_obj_rel_insert_input = {
  data: student_batch_history_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<student_batch_history_on_conflict>;
};

/** on conflict condition type for table "student_batch_history" */
export type student_batch_history_on_conflict = {
  constraint: student_batch_history_constraint;
  update_columns?: Array<student_batch_history_update_column>;
  where?: Maybe<student_batch_history_bool_exp>;
};

/** Ordering options when selecting data from "student_batch_history". */
export type student_batch_history_order_by = {
  batchClassId?: Maybe<order_by>;
  batch_class?: Maybe<batch_class_order_by>;
  endDate?: Maybe<order_by>;
  id?: Maybe<order_by>;
  startDate?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  student_batch_history_subjects_aggregate?: Maybe<student_batch_history_subject_aggregate_order_by>;
};

/** primary key columns input for table: student_batch_history */
export type student_batch_history_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_batch_history" */
export enum student_batch_history_select_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  endDate = 'endDate',
  /** column name */
  id = 'id',
  /** column name */
  startDate = 'startDate',
  /** column name */
  studentId = 'studentId',
}

/** input type for updating data in table "student_batch_history" */
export type student_batch_history_set_input = {
  batchClassId?: Maybe<Scalars['uuid']>;
  endDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  startDate?: Maybe<Scalars['timestamp']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type student_batch_history_stddev_fields = {
  __typename?: 'student_batch_history_stddev_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_batch_history" */
export type student_batch_history_stddev_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_batch_history_stddev_pop_fields = {
  __typename?: 'student_batch_history_stddev_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_batch_history" */
export type student_batch_history_stddev_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_batch_history_stddev_samp_fields = {
  __typename?: 'student_batch_history_stddev_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_batch_history" */
export type student_batch_history_stddev_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** columns and relationships of "student_batch_history_subject" */
export type student_batch_history_subject = {
  __typename?: 'student_batch_history_subject';
  completed: Scalars['Boolean'];
  id: Scalars['uuid'];
  studentBatchHistoryId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  student_batch_history?: Maybe<student_batch_history>;
  /** An object relationship */
  subject?: Maybe<subject>;
  subjectId?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "student_batch_history_subject" */
export type student_batch_history_subject_aggregate = {
  __typename?: 'student_batch_history_subject_aggregate';
  aggregate?: Maybe<student_batch_history_subject_aggregate_fields>;
  nodes: Array<student_batch_history_subject>;
};

/** aggregate fields of "student_batch_history_subject" */
export type student_batch_history_subject_aggregate_fields = {
  __typename?: 'student_batch_history_subject_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<student_batch_history_subject_max_fields>;
  min?: Maybe<student_batch_history_subject_min_fields>;
};

/** aggregate fields of "student_batch_history_subject" */
export type student_batch_history_subject_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_batch_history_subject_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_batch_history_subject" */
export type student_batch_history_subject_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<student_batch_history_subject_max_order_by>;
  min?: Maybe<student_batch_history_subject_min_order_by>;
};

/** input type for inserting array relation for remote table "student_batch_history_subject" */
export type student_batch_history_subject_arr_rel_insert_input = {
  data: Array<student_batch_history_subject_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_batch_history_subject_on_conflict>;
};

/** Boolean expression to filter rows from the table "student_batch_history_subject". All fields are combined with a logical 'AND'. */
export type student_batch_history_subject_bool_exp = {
  _and?: Maybe<Array<student_batch_history_subject_bool_exp>>;
  _not?: Maybe<student_batch_history_subject_bool_exp>;
  _or?: Maybe<Array<student_batch_history_subject_bool_exp>>;
  completed?: Maybe<Boolean_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  studentBatchHistoryId?: Maybe<uuid_comparison_exp>;
  student_batch_history?: Maybe<student_batch_history_bool_exp>;
  subject?: Maybe<subject_bool_exp>;
  subjectId?: Maybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "student_batch_history_subject" */
export enum student_batch_history_subject_constraint {
  /** unique or primary key constraint */
  PK_43554d183b1c39400e229d7cf6c = 'PK_43554d183b1c39400e229d7cf6c',
  /** unique or primary key constraint */
  student_batch_history_subject_studentBatchHistoryId_subjectId_k = 'student_batch_history_subject_studentBatchHistoryId_subjectId_k',
}

/** input type for inserting data into table "student_batch_history_subject" */
export type student_batch_history_subject_insert_input = {
  completed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  studentBatchHistoryId?: Maybe<Scalars['uuid']>;
  student_batch_history?: Maybe<student_batch_history_obj_rel_insert_input>;
  subject?: Maybe<subject_obj_rel_insert_input>;
  subjectId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type student_batch_history_subject_max_fields = {
  __typename?: 'student_batch_history_subject_max_fields';
  id?: Maybe<Scalars['uuid']>;
  studentBatchHistoryId?: Maybe<Scalars['uuid']>;
  subjectId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "student_batch_history_subject" */
export type student_batch_history_subject_max_order_by = {
  id?: Maybe<order_by>;
  studentBatchHistoryId?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_batch_history_subject_min_fields = {
  __typename?: 'student_batch_history_subject_min_fields';
  id?: Maybe<Scalars['uuid']>;
  studentBatchHistoryId?: Maybe<Scalars['uuid']>;
  subjectId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "student_batch_history_subject" */
export type student_batch_history_subject_min_order_by = {
  id?: Maybe<order_by>;
  studentBatchHistoryId?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
};

/** response of any mutation on the table "student_batch_history_subject" */
export type student_batch_history_subject_mutation_response = {
  __typename?: 'student_batch_history_subject_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_batch_history_subject>;
};

/** on conflict condition type for table "student_batch_history_subject" */
export type student_batch_history_subject_on_conflict = {
  constraint: student_batch_history_subject_constraint;
  update_columns?: Array<student_batch_history_subject_update_column>;
  where?: Maybe<student_batch_history_subject_bool_exp>;
};

/** Ordering options when selecting data from "student_batch_history_subject". */
export type student_batch_history_subject_order_by = {
  completed?: Maybe<order_by>;
  id?: Maybe<order_by>;
  studentBatchHistoryId?: Maybe<order_by>;
  student_batch_history?: Maybe<student_batch_history_order_by>;
  subject?: Maybe<subject_order_by>;
  subjectId?: Maybe<order_by>;
};

/** primary key columns input for table: student_batch_history_subject */
export type student_batch_history_subject_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_batch_history_subject" */
export enum student_batch_history_subject_select_column {
  /** column name */
  completed = 'completed',
  /** column name */
  id = 'id',
  /** column name */
  studentBatchHistoryId = 'studentBatchHistoryId',
  /** column name */
  subjectId = 'subjectId',
}

/** input type for updating data in table "student_batch_history_subject" */
export type student_batch_history_subject_set_input = {
  completed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  studentBatchHistoryId?: Maybe<Scalars['uuid']>;
  subjectId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "student_batch_history_subject" */
export enum student_batch_history_subject_update_column {
  /** column name */
  completed = 'completed',
  /** column name */
  id = 'id',
  /** column name */
  studentBatchHistoryId = 'studentBatchHistoryId',
  /** column name */
  subjectId = 'subjectId',
}

/** aggregate sum on columns */
export type student_batch_history_sum_fields = {
  __typename?: 'student_batch_history_sum_fields';
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_batch_history" */
export type student_batch_history_sum_order_by = {
  studentId?: Maybe<order_by>;
};

/** update columns of table "student_batch_history" */
export enum student_batch_history_update_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  endDate = 'endDate',
  /** column name */
  id = 'id',
  /** column name */
  startDate = 'startDate',
  /** column name */
  studentId = 'studentId',
}

/** aggregate var_pop on columns */
export type student_batch_history_var_pop_fields = {
  __typename?: 'student_batch_history_var_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_batch_history" */
export type student_batch_history_var_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_batch_history_var_samp_fields = {
  __typename?: 'student_batch_history_var_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_batch_history" */
export type student_batch_history_var_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_batch_history_variance_fields = {
  __typename?: 'student_batch_history_variance_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_batch_history" */
export type student_batch_history_variance_order_by = {
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student". All fields are combined with a logical 'AND'. */
export type student_bool_exp = {
  _and?: Maybe<Array<student_bool_exp>>;
  _not?: Maybe<student_bool_exp>;
  _or?: Maybe<Array<student_bool_exp>>;
  agreementURLs?: Maybe<String_comparison_exp>;
  attendance_students?: Maybe<attendance_student_bool_exp>;
  bloodType?: Maybe<blood_type_enum_comparison_exp>;
  blood_type?: Maybe<blood_type_bool_exp>;
  createdAt?: Maybe<timestamp_comparison_exp>;
  dateOfBirth?: Maybe<date_comparison_exp>;
  education_qualifications?: Maybe<education_qualification_bool_exp>;
  educationalCertificatesURLs?: Maybe<String_comparison_exp>;
  email?: Maybe<String_comparison_exp>;
  employment_experiences?: Maybe<employment_experience_bool_exp>;
  exit_interview_answers?: Maybe<exit_interview_answer_bool_exp>;
  firebaseUID?: Maybe<String_comparison_exp>;
  firstName?: Maybe<String_comparison_exp>;
  gender?: Maybe<student_gender_enum_comparison_exp>;
  id?: Maybe<Int_comparison_exp>;
  illnessesDisabilities?: Maybe<String_comparison_exp>;
  initialRegistrationFeePaid?: Maybe<Boolean_comparison_exp>;
  initialTourFollowed?: Maybe<Boolean_comparison_exp>;
  inquiry?: Maybe<inquiry_bool_exp>;
  isContactParent?: Maybe<Boolean_comparison_exp>;
  landLineNo?: Maybe<String_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  middleName?: Maybe<String_comparison_exp>;
  mobileNo?: Maybe<String_comparison_exp>;
  nationality?: Maybe<student_nationality_enum_comparison_exp>;
  nicCopyURLs?: Maybe<String_comparison_exp>;
  nicNo?: Maybe<String_comparison_exp>;
  ordinaryLevelCertificateURLs?: Maybe<String_comparison_exp>;
  parentOrGuardianCity?: Maybe<String_comparison_exp>;
  parentOrGuardianCountry?: Maybe<String_comparison_exp>;
  parentOrGuardianDistrict?: Maybe<String_comparison_exp>;
  parentOrGuardianLandLineNo?: Maybe<String_comparison_exp>;
  parentOrGuardianMobileNo?: Maybe<String_comparison_exp>;
  parentOrGuardianName?: Maybe<String_comparison_exp>;
  parentOrGuardianProvince?: Maybe<String_comparison_exp>;
  parentOrGuardianStreetAddress1?: Maybe<String_comparison_exp>;
  parentOrGuardianStreetAddress2?: Maybe<String_comparison_exp>;
  passportNo?: Maybe<String_comparison_exp>;
  passportOrBirthCertificateURLs?: Maybe<String_comparison_exp>;
  passportSizePhotoURLs?: Maybe<String_comparison_exp>;
  permanentCity?: Maybe<String_comparison_exp>;
  permanentCountry?: Maybe<String_comparison_exp>;
  permanentDistrict?: Maybe<String_comparison_exp>;
  permanentProvince?: Maybe<String_comparison_exp>;
  permanentStreetAddress1?: Maybe<String_comparison_exp>;
  permanentStreetAddress2?: Maybe<String_comparison_exp>;
  postal_id?: Maybe<String_comparison_exp>;
  preferredName?: Maybe<String_comparison_exp>;
  profileUploadedPhotoURLs?: Maybe<String_comparison_exp>;
  publishedAt?: Maybe<timestamp_comparison_exp>;
  referredVia?: Maybe<String_comparison_exp>;
  regNumber?: Maybe<String_comparison_exp>;
  remarks?: Maybe<String_comparison_exp>;
  request_messages?: Maybe<student_request_message_bool_exp>;
  sameAsPermanentAddress?: Maybe<Boolean_comparison_exp>;
  scannedDocumentURL?: Maybe<String_comparison_exp>;
  sliitID?: Maybe<String_comparison_exp>;
  spokenLanguages?: Maybe<String_comparison_exp>;
  status?: Maybe<student_status_enum_comparison_exp>;
  student_assessment_submissions?: Maybe<student_assessment_submission_bool_exp>;
  student_batch_classes_batch_classes?: Maybe<student_batch_classes_batch_class_bool_exp>;
  student_batch_histories?: Maybe<student_batch_history_bool_exp>;
  student_courses?: Maybe<student_course_bool_exp>;
  student_familiarization_interviews?: Maybe<student_familiarization_interview_bool_exp>;
  student_performances?: Maybe<student_performance_bool_exp>;
  student_requests?: Maybe<student_request_bool_exp>;
  student_result_sheets?: Maybe<student_result_sheet_bool_exp>;
  student_status?: Maybe<student_status_bool_exp>;
  updatedAt?: Maybe<timestamp_comparison_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
  waiID?: Maybe<String_comparison_exp>;
  whatsapp_number?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "student" */
export enum student_constraint {
  /** unique or primary key constraint */
  IDX_570af501cce684f8043439dfb4 = 'IDX_570af501cce684f8043439dfb4',
  /** unique or primary key constraint */
  IDX_6d10b0e20237dc0adb90e92758 = 'IDX_6d10b0e20237dc0adb90e92758',
  /** unique or primary key constraint */
  IDX_a56c051c91dbe1068ad683f536 = 'IDX_a56c051c91dbe1068ad683f536',
  /** unique or primary key constraint */
  PK_3d8016e1cb58429474a3c041904 = 'PK_3d8016e1cb58429474a3c041904',
  /** unique or primary key constraint */
  UQ_8e6232108b84b75e57538f2e586 = 'UQ_8e6232108b84b75e57538f2e586',
  /** unique or primary key constraint */
  UQ_91e21c551d11f3a4118c8a42686 = 'UQ_91e21c551d11f3a4118c8a42686',
  /** unique or primary key constraint */
  student_sliitID_key = 'student_sliitID_key',
  /** unique or primary key constraint */
  student_waiID_key = 'student_waiID_key',
}

/** columns and relationships of "student_course" */
export type student_course = {
  __typename?: 'student_course';
  active: Scalars['Boolean'];
  /** An object relationship */
  course?: Maybe<course>;
  courseId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  /** An object relationship */
  intake?: Maybe<intake>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear: Scalars['Int'];
  /** An object relationship */
  student?: Maybe<student>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "student_course" */
export type student_course_aggregate = {
  __typename?: 'student_course_aggregate';
  aggregate?: Maybe<student_course_aggregate_fields>;
  nodes: Array<student_course>;
};

/** aggregate fields of "student_course" */
export type student_course_aggregate_fields = {
  __typename?: 'student_course_aggregate_fields';
  avg?: Maybe<student_course_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_course_max_fields>;
  min?: Maybe<student_course_min_fields>;
  stddev?: Maybe<student_course_stddev_fields>;
  stddev_pop?: Maybe<student_course_stddev_pop_fields>;
  stddev_samp?: Maybe<student_course_stddev_samp_fields>;
  sum?: Maybe<student_course_sum_fields>;
  var_pop?: Maybe<student_course_var_pop_fields>;
  var_samp?: Maybe<student_course_var_samp_fields>;
  variance?: Maybe<student_course_variance_fields>;
};

/** aggregate fields of "student_course" */
export type student_course_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_course_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_course" */
export type student_course_aggregate_order_by = {
  avg?: Maybe<student_course_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_course_max_order_by>;
  min?: Maybe<student_course_min_order_by>;
  stddev?: Maybe<student_course_stddev_order_by>;
  stddev_pop?: Maybe<student_course_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_course_stddev_samp_order_by>;
  sum?: Maybe<student_course_sum_order_by>;
  var_pop?: Maybe<student_course_var_pop_order_by>;
  var_samp?: Maybe<student_course_var_samp_order_by>;
  variance?: Maybe<student_course_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_course" */
export type student_course_arr_rel_insert_input = {
  data: Array<student_course_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_course_on_conflict>;
};

/** aggregate avg on columns */
export type student_course_avg_fields = {
  __typename?: 'student_course_avg_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_course" */
export type student_course_avg_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_course". All fields are combined with a logical 'AND'. */
export type student_course_bool_exp = {
  _and?: Maybe<Array<student_course_bool_exp>>;
  _not?: Maybe<student_course_bool_exp>;
  _or?: Maybe<Array<student_course_bool_exp>>;
  active?: Maybe<Boolean_comparison_exp>;
  course?: Maybe<course_bool_exp>;
  courseId?: Maybe<uuid_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  intake?: Maybe<intake_bool_exp>;
  intakeId?: Maybe<uuid_comparison_exp>;
  registeredYear?: Maybe<Int_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "student_course" */
export enum student_course_constraint {
  /** unique or primary key constraint */
  PK_140d2607308f60eda2ae0d72a4f = 'PK_140d2607308f60eda2ae0d72a4f',
}

/** input type for incrementing numeric columns in table "student_course" */
export type student_course_inc_input = {
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_course" */
export type student_course_insert_input = {
  active?: Maybe<Scalars['Boolean']>;
  course?: Maybe<course_obj_rel_insert_input>;
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intake?: Maybe<intake_obj_rel_insert_input>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear?: Maybe<Scalars['Int']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type student_course_max_fields = {
  __typename?: 'student_course_max_fields';
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "student_course" */
export type student_course_max_order_by = {
  courseId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  intakeId?: Maybe<order_by>;
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_course_min_fields = {
  __typename?: 'student_course_min_fields';
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "student_course" */
export type student_course_min_order_by = {
  courseId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  intakeId?: Maybe<order_by>;
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** response of any mutation on the table "student_course" */
export type student_course_mutation_response = {
  __typename?: 'student_course_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_course>;
};

/** on conflict condition type for table "student_course" */
export type student_course_on_conflict = {
  constraint: student_course_constraint;
  update_columns?: Array<student_course_update_column>;
  where?: Maybe<student_course_bool_exp>;
};

/** Ordering options when selecting data from "student_course". */
export type student_course_order_by = {
  active?: Maybe<order_by>;
  course?: Maybe<course_order_by>;
  courseId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  intake?: Maybe<intake_order_by>;
  intakeId?: Maybe<order_by>;
  registeredYear?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
};

/** primary key columns input for table: student_course */
export type student_course_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_course" */
export enum student_course_select_column {
  /** column name */
  active = 'active',
  /** column name */
  courseId = 'courseId',
  /** column name */
  id = 'id',
  /** column name */
  intakeId = 'intakeId',
  /** column name */
  registeredYear = 'registeredYear',
  /** column name */
  studentId = 'studentId',
}

/** input type for updating data in table "student_course" */
export type student_course_set_input = {
  active?: Maybe<Scalars['Boolean']>;
  courseId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  intakeId?: Maybe<Scalars['uuid']>;
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type student_course_stddev_fields = {
  __typename?: 'student_course_stddev_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_course" */
export type student_course_stddev_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_course_stddev_pop_fields = {
  __typename?: 'student_course_stddev_pop_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_course" */
export type student_course_stddev_pop_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_course_stddev_samp_fields = {
  __typename?: 'student_course_stddev_samp_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_course" */
export type student_course_stddev_samp_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_course_sum_fields = {
  __typename?: 'student_course_sum_fields';
  registeredYear?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_course" */
export type student_course_sum_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** update columns of table "student_course" */
export enum student_course_update_column {
  /** column name */
  active = 'active',
  /** column name */
  courseId = 'courseId',
  /** column name */
  id = 'id',
  /** column name */
  intakeId = 'intakeId',
  /** column name */
  registeredYear = 'registeredYear',
  /** column name */
  studentId = 'studentId',
}

/** aggregate var_pop on columns */
export type student_course_var_pop_fields = {
  __typename?: 'student_course_var_pop_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_course" */
export type student_course_var_pop_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_course_var_samp_fields = {
  __typename?: 'student_course_var_samp_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_course" */
export type student_course_var_samp_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_course_variance_fields = {
  __typename?: 'student_course_variance_fields';
  registeredYear?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_course" */
export type student_course_variance_order_by = {
  registeredYear?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** columns and relationships of "student_external_engagement_info" */
export type student_external_engagement_info = {
  __typename?: 'student_external_engagement_info';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchName?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lecturerFirstName?: Maybe<Scalars['String']>;
  lecturerId?: Maybe<Scalars['uuid']>;
  lecturerLastName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  studentFirebaseUID?: Maybe<Scalars['String']>;
  studentFirstName?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  studentLastName?: Maybe<Scalars['String']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  subjectCode?: Maybe<Scalars['String']>;
  subjectColor?: Maybe<Scalars['String']>;
  subjectExtraSlotName?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<user>;
};

/** aggregated selection of "student_external_engagement_info" */
export type student_external_engagement_info_aggregate = {
  __typename?: 'student_external_engagement_info_aggregate';
  aggregate?: Maybe<student_external_engagement_info_aggregate_fields>;
  nodes: Array<student_external_engagement_info>;
};

/** aggregate fields of "student_external_engagement_info" */
export type student_external_engagement_info_aggregate_fields = {
  __typename?: 'student_external_engagement_info_aggregate_fields';
  avg?: Maybe<student_external_engagement_info_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_external_engagement_info_max_fields>;
  min?: Maybe<student_external_engagement_info_min_fields>;
  stddev?: Maybe<student_external_engagement_info_stddev_fields>;
  stddev_pop?: Maybe<student_external_engagement_info_stddev_pop_fields>;
  stddev_samp?: Maybe<student_external_engagement_info_stddev_samp_fields>;
  sum?: Maybe<student_external_engagement_info_sum_fields>;
  var_pop?: Maybe<student_external_engagement_info_var_pop_fields>;
  var_samp?: Maybe<student_external_engagement_info_var_samp_fields>;
  variance?: Maybe<student_external_engagement_info_variance_fields>;
};

/** aggregate fields of "student_external_engagement_info" */
export type student_external_engagement_info_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_external_engagement_info_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type student_external_engagement_info_avg_fields = {
  __typename?: 'student_external_engagement_info_avg_fields';
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "student_external_engagement_info". All fields are combined with a logical 'AND'. */
export type student_external_engagement_info_bool_exp = {
  _and?: Maybe<Array<student_external_engagement_info_bool_exp>>;
  _not?: Maybe<student_external_engagement_info_bool_exp>;
  _or?: Maybe<Array<student_external_engagement_info_bool_exp>>;
  batchClassId?: Maybe<uuid_comparison_exp>;
  batchName?: Maybe<String_comparison_exp>;
  endTime?: Maybe<timestamptz_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  lecturerFirstName?: Maybe<String_comparison_exp>;
  lecturerId?: Maybe<uuid_comparison_exp>;
  lecturerLastName?: Maybe<String_comparison_exp>;
  preferredName?: Maybe<String_comparison_exp>;
  regNumber?: Maybe<String_comparison_exp>;
  sliitID?: Maybe<String_comparison_exp>;
  startTime?: Maybe<timestamptz_comparison_exp>;
  status?: Maybe<String_comparison_exp>;
  studentFirebaseUID?: Maybe<String_comparison_exp>;
  studentFirstName?: Maybe<String_comparison_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  studentLastName?: Maybe<String_comparison_exp>;
  studentRequestId?: Maybe<Int_comparison_exp>;
  subjectCode?: Maybe<String_comparison_exp>;
  subjectColor?: Maybe<String_comparison_exp>;
  subjectExtraSlotName?: Maybe<String_comparison_exp>;
  subjectName?: Maybe<String_comparison_exp>;
  user?: Maybe<user_bool_exp>;
};

/** input type for inserting data into table "student_external_engagement_info" */
export type student_external_engagement_info_insert_input = {
  batchClassId?: Maybe<Scalars['uuid']>;
  batchName?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lecturerFirstName?: Maybe<Scalars['String']>;
  lecturerId?: Maybe<Scalars['uuid']>;
  lecturerLastName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  studentFirebaseUID?: Maybe<Scalars['String']>;
  studentFirstName?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  studentLastName?: Maybe<Scalars['String']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  subjectCode?: Maybe<Scalars['String']>;
  subjectColor?: Maybe<Scalars['String']>;
  subjectExtraSlotName?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
  user?: Maybe<user_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type student_external_engagement_info_max_fields = {
  __typename?: 'student_external_engagement_info_max_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchName?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lecturerFirstName?: Maybe<Scalars['String']>;
  lecturerId?: Maybe<Scalars['uuid']>;
  lecturerLastName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  studentFirebaseUID?: Maybe<Scalars['String']>;
  studentFirstName?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  studentLastName?: Maybe<Scalars['String']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  subjectCode?: Maybe<Scalars['String']>;
  subjectColor?: Maybe<Scalars['String']>;
  subjectExtraSlotName?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type student_external_engagement_info_min_fields = {
  __typename?: 'student_external_engagement_info_min_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchName?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lecturerFirstName?: Maybe<Scalars['String']>;
  lecturerId?: Maybe<Scalars['uuid']>;
  lecturerLastName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  studentFirebaseUID?: Maybe<Scalars['String']>;
  studentFirstName?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  studentLastName?: Maybe<Scalars['String']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  subjectCode?: Maybe<Scalars['String']>;
  subjectColor?: Maybe<Scalars['String']>;
  subjectExtraSlotName?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
};

/** input type for inserting object relation for remote table "student_external_engagement_info" */
export type student_external_engagement_info_obj_rel_insert_input = {
  data: student_external_engagement_info_insert_input;
};

/** Ordering options when selecting data from "student_external_engagement_info". */
export type student_external_engagement_info_order_by = {
  batchClassId?: Maybe<order_by>;
  batchName?: Maybe<order_by>;
  endTime?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lecturerFirstName?: Maybe<order_by>;
  lecturerId?: Maybe<order_by>;
  lecturerLastName?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
  sliitID?: Maybe<order_by>;
  startTime?: Maybe<order_by>;
  status?: Maybe<order_by>;
  studentFirebaseUID?: Maybe<order_by>;
  studentFirstName?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentLastName?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  subjectCode?: Maybe<order_by>;
  subjectColor?: Maybe<order_by>;
  subjectExtraSlotName?: Maybe<order_by>;
  subjectName?: Maybe<order_by>;
  user?: Maybe<user_order_by>;
};

/** select columns of table "student_external_engagement_info" */
export enum student_external_engagement_info_select_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  batchName = 'batchName',
  /** column name */
  endTime = 'endTime',
  /** column name */
  id = 'id',
  /** column name */
  lecturerFirstName = 'lecturerFirstName',
  /** column name */
  lecturerId = 'lecturerId',
  /** column name */
  lecturerLastName = 'lecturerLastName',
  /** column name */
  preferredName = 'preferredName',
  /** column name */
  regNumber = 'regNumber',
  /** column name */
  sliitID = 'sliitID',
  /** column name */
  startTime = 'startTime',
  /** column name */
  status = 'status',
  /** column name */
  studentFirebaseUID = 'studentFirebaseUID',
  /** column name */
  studentFirstName = 'studentFirstName',
  /** column name */
  studentId = 'studentId',
  /** column name */
  studentLastName = 'studentLastName',
  /** column name */
  studentRequestId = 'studentRequestId',
  /** column name */
  subjectCode = 'subjectCode',
  /** column name */
  subjectColor = 'subjectColor',
  /** column name */
  subjectExtraSlotName = 'subjectExtraSlotName',
  /** column name */
  subjectName = 'subjectName',
}

/** aggregate stddev on columns */
export type student_external_engagement_info_stddev_fields = {
  __typename?: 'student_external_engagement_info_stddev_fields';
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type student_external_engagement_info_stddev_pop_fields = {
  __typename?: 'student_external_engagement_info_stddev_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type student_external_engagement_info_stddev_samp_fields = {
  __typename?: 'student_external_engagement_info_stddev_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type student_external_engagement_info_sum_fields = {
  __typename?: 'student_external_engagement_info_sum_fields';
  studentId?: Maybe<Scalars['Int']>;
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type student_external_engagement_info_var_pop_fields = {
  __typename?: 'student_external_engagement_info_var_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type student_external_engagement_info_var_samp_fields = {
  __typename?: 'student_external_engagement_info_var_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type student_external_engagement_info_variance_fields = {
  __typename?: 'student_external_engagement_info_variance_fields';
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "student_external_engagement_request" */
export type student_external_engagement_request = {
  __typename?: 'student_external_engagement_request';
  id: Scalars['uuid'];
  studentRequestId: Scalars['Int'];
  /** An object relationship */
  student_request?: Maybe<student_request>;
  /** An object relationship */
  student_timetable_item?: Maybe<student_external_engagement_info>;
  timetableItemId: Scalars['uuid'];
  /** An object relationship */
  timetable_item: timetable_item;
};

/** aggregated selection of "student_external_engagement_request" */
export type student_external_engagement_request_aggregate = {
  __typename?: 'student_external_engagement_request_aggregate';
  aggregate?: Maybe<student_external_engagement_request_aggregate_fields>;
  nodes: Array<student_external_engagement_request>;
};

/** aggregate fields of "student_external_engagement_request" */
export type student_external_engagement_request_aggregate_fields = {
  __typename?: 'student_external_engagement_request_aggregate_fields';
  avg?: Maybe<student_external_engagement_request_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_external_engagement_request_max_fields>;
  min?: Maybe<student_external_engagement_request_min_fields>;
  stddev?: Maybe<student_external_engagement_request_stddev_fields>;
  stddev_pop?: Maybe<student_external_engagement_request_stddev_pop_fields>;
  stddev_samp?: Maybe<student_external_engagement_request_stddev_samp_fields>;
  sum?: Maybe<student_external_engagement_request_sum_fields>;
  var_pop?: Maybe<student_external_engagement_request_var_pop_fields>;
  var_samp?: Maybe<student_external_engagement_request_var_samp_fields>;
  variance?: Maybe<student_external_engagement_request_variance_fields>;
};

/** aggregate fields of "student_external_engagement_request" */
export type student_external_engagement_request_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_external_engagement_request_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_external_engagement_request" */
export type student_external_engagement_request_aggregate_order_by = {
  avg?: Maybe<student_external_engagement_request_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_external_engagement_request_max_order_by>;
  min?: Maybe<student_external_engagement_request_min_order_by>;
  stddev?: Maybe<student_external_engagement_request_stddev_order_by>;
  stddev_pop?: Maybe<student_external_engagement_request_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_external_engagement_request_stddev_samp_order_by>;
  sum?: Maybe<student_external_engagement_request_sum_order_by>;
  var_pop?: Maybe<student_external_engagement_request_var_pop_order_by>;
  var_samp?: Maybe<student_external_engagement_request_var_samp_order_by>;
  variance?: Maybe<student_external_engagement_request_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_external_engagement_request" */
export type student_external_engagement_request_arr_rel_insert_input = {
  data: Array<student_external_engagement_request_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_external_engagement_request_on_conflict>;
};

/** aggregate avg on columns */
export type student_external_engagement_request_avg_fields = {
  __typename?: 'student_external_engagement_request_avg_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_avg_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_external_engagement_request". All fields are combined with a logical 'AND'. */
export type student_external_engagement_request_bool_exp = {
  _and?: Maybe<Array<student_external_engagement_request_bool_exp>>;
  _not?: Maybe<student_external_engagement_request_bool_exp>;
  _or?: Maybe<Array<student_external_engagement_request_bool_exp>>;
  id?: Maybe<uuid_comparison_exp>;
  studentRequestId?: Maybe<Int_comparison_exp>;
  student_request?: Maybe<student_request_bool_exp>;
  student_timetable_item?: Maybe<student_external_engagement_info_bool_exp>;
  timetableItemId?: Maybe<uuid_comparison_exp>;
  timetable_item?: Maybe<timetable_item_bool_exp>;
};

/** unique or primary key constraints on table "student_external_engagement_request" */
export enum student_external_engagement_request_constraint {
  /** unique or primary key constraint */
  student_external_engagement_request_pkey = 'student_external_engagement_request_pkey',
}

/** input type for incrementing numeric columns in table "student_external_engagement_request" */
export type student_external_engagement_request_inc_input = {
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_external_engagement_request" */
export type student_external_engagement_request_insert_input = {
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  student_request?: Maybe<student_request_obj_rel_insert_input>;
  student_timetable_item?: Maybe<student_external_engagement_info_obj_rel_insert_input>;
  timetableItemId?: Maybe<Scalars['uuid']>;
  timetable_item?: Maybe<timetable_item_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type student_external_engagement_request_max_fields = {
  __typename?: 'student_external_engagement_request_max_fields';
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  timetableItemId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_max_order_by = {
  id?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  timetableItemId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_external_engagement_request_min_fields = {
  __typename?: 'student_external_engagement_request_min_fields';
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  timetableItemId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_min_order_by = {
  id?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  timetableItemId?: Maybe<order_by>;
};

/** response of any mutation on the table "student_external_engagement_request" */
export type student_external_engagement_request_mutation_response = {
  __typename?: 'student_external_engagement_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_external_engagement_request>;
};

/** on conflict condition type for table "student_external_engagement_request" */
export type student_external_engagement_request_on_conflict = {
  constraint: student_external_engagement_request_constraint;
  update_columns?: Array<student_external_engagement_request_update_column>;
  where?: Maybe<student_external_engagement_request_bool_exp>;
};

/** Ordering options when selecting data from "student_external_engagement_request". */
export type student_external_engagement_request_order_by = {
  id?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  student_request?: Maybe<student_request_order_by>;
  student_timetable_item?: Maybe<student_external_engagement_info_order_by>;
  timetableItemId?: Maybe<order_by>;
  timetable_item?: Maybe<timetable_item_order_by>;
};

/** primary key columns input for table: student_external_engagement_request */
export type student_external_engagement_request_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_external_engagement_request" */
export enum student_external_engagement_request_select_column {
  /** column name */
  id = 'id',
  /** column name */
  studentRequestId = 'studentRequestId',
  /** column name */
  timetableItemId = 'timetableItemId',
}

/** input type for updating data in table "student_external_engagement_request" */
export type student_external_engagement_request_set_input = {
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  timetableItemId?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type student_external_engagement_request_stddev_fields = {
  __typename?: 'student_external_engagement_request_stddev_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_stddev_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_external_engagement_request_stddev_pop_fields = {
  __typename?: 'student_external_engagement_request_stddev_pop_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_stddev_pop_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_external_engagement_request_stddev_samp_fields = {
  __typename?: 'student_external_engagement_request_stddev_samp_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_stddev_samp_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_external_engagement_request_sum_fields = {
  __typename?: 'student_external_engagement_request_sum_fields';
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_sum_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** update columns of table "student_external_engagement_request" */
export enum student_external_engagement_request_update_column {
  /** column name */
  id = 'id',
  /** column name */
  studentRequestId = 'studentRequestId',
  /** column name */
  timetableItemId = 'timetableItemId',
}

/** aggregate var_pop on columns */
export type student_external_engagement_request_var_pop_fields = {
  __typename?: 'student_external_engagement_request_var_pop_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_var_pop_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_external_engagement_request_var_samp_fields = {
  __typename?: 'student_external_engagement_request_var_samp_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_var_samp_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_external_engagement_request_variance_fields = {
  __typename?: 'student_external_engagement_request_variance_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_external_engagement_request" */
export type student_external_engagement_request_variance_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** columns and relationships of "student_familiarization_form" */
export type student_familiarization_form = {
  __typename?: 'student_familiarization_form';
  careerAmbition: Scalars['String'];
  created_at: Scalars['timestamptz'];
  currentResidentLocation: Scalars['String'];
  englishReading: Scalars['Int'];
  englishSpeaking: Scalars['Int'];
  englishUnderstanding: Scalars['Int'];
  englishWriting: Scalars['Int'];
  groupOrIndividual: Scalars['String'];
  hometown: Scalars['String'];
  id: Scalars['uuid'];
  leadOrFollow: Scalars['String'];
  mostComfortableLanguage: Scalars['String'];
  personality: Scalars['String'];
  priorWorkExperience: Scalars['String'];
  schoolsAttended: Scalars['String'];
  skillsToGainFromTheCourse: Scalars['String'];
  /** An object relationship */
  student: student;
  studentId: Scalars['Int'];
  timeAtCahmSoFar: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  whyChooseHospitality: Scalars['String'];
};

/** aggregated selection of "student_familiarization_form" */
export type student_familiarization_form_aggregate = {
  __typename?: 'student_familiarization_form_aggregate';
  aggregate?: Maybe<student_familiarization_form_aggregate_fields>;
  nodes: Array<student_familiarization_form>;
};

/** aggregate fields of "student_familiarization_form" */
export type student_familiarization_form_aggregate_fields = {
  __typename?: 'student_familiarization_form_aggregate_fields';
  avg?: Maybe<student_familiarization_form_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_familiarization_form_max_fields>;
  min?: Maybe<student_familiarization_form_min_fields>;
  stddev?: Maybe<student_familiarization_form_stddev_fields>;
  stddev_pop?: Maybe<student_familiarization_form_stddev_pop_fields>;
  stddev_samp?: Maybe<student_familiarization_form_stddev_samp_fields>;
  sum?: Maybe<student_familiarization_form_sum_fields>;
  var_pop?: Maybe<student_familiarization_form_var_pop_fields>;
  var_samp?: Maybe<student_familiarization_form_var_samp_fields>;
  variance?: Maybe<student_familiarization_form_variance_fields>;
};

/** aggregate fields of "student_familiarization_form" */
export type student_familiarization_form_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_familiarization_form_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type student_familiarization_form_avg_fields = {
  __typename?: 'student_familiarization_form_avg_fields';
  englishReading?: Maybe<Scalars['Float']>;
  englishSpeaking?: Maybe<Scalars['Float']>;
  englishUnderstanding?: Maybe<Scalars['Float']>;
  englishWriting?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "student_familiarization_form". All fields are combined with a logical 'AND'. */
export type student_familiarization_form_bool_exp = {
  _and?: Maybe<Array<student_familiarization_form_bool_exp>>;
  _not?: Maybe<student_familiarization_form_bool_exp>;
  _or?: Maybe<Array<student_familiarization_form_bool_exp>>;
  careerAmbition?: Maybe<String_comparison_exp>;
  created_at?: Maybe<timestamptz_comparison_exp>;
  currentResidentLocation?: Maybe<String_comparison_exp>;
  englishReading?: Maybe<Int_comparison_exp>;
  englishSpeaking?: Maybe<Int_comparison_exp>;
  englishUnderstanding?: Maybe<Int_comparison_exp>;
  englishWriting?: Maybe<Int_comparison_exp>;
  groupOrIndividual?: Maybe<String_comparison_exp>;
  hometown?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  leadOrFollow?: Maybe<String_comparison_exp>;
  mostComfortableLanguage?: Maybe<String_comparison_exp>;
  personality?: Maybe<String_comparison_exp>;
  priorWorkExperience?: Maybe<String_comparison_exp>;
  schoolsAttended?: Maybe<String_comparison_exp>;
  skillsToGainFromTheCourse?: Maybe<String_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  timeAtCahmSoFar?: Maybe<String_comparison_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
  whyChooseHospitality?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "student_familiarization_form" */
export enum student_familiarization_form_constraint {
  /** unique or primary key constraint */
  student_familiarization_form_pkey = 'student_familiarization_form_pkey',
  /** unique or primary key constraint */
  student_familiarization_form_studentId_key = 'student_familiarization_form_studentId_key',
}

/** input type for incrementing numeric columns in table "student_familiarization_form" */
export type student_familiarization_form_inc_input = {
  englishReading?: Maybe<Scalars['Int']>;
  englishSpeaking?: Maybe<Scalars['Int']>;
  englishUnderstanding?: Maybe<Scalars['Int']>;
  englishWriting?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_familiarization_form" */
export type student_familiarization_form_insert_input = {
  careerAmbition?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currentResidentLocation?: Maybe<Scalars['String']>;
  englishReading?: Maybe<Scalars['Int']>;
  englishSpeaking?: Maybe<Scalars['Int']>;
  englishUnderstanding?: Maybe<Scalars['Int']>;
  englishWriting?: Maybe<Scalars['Int']>;
  groupOrIndividual?: Maybe<Scalars['String']>;
  hometown?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  leadOrFollow?: Maybe<Scalars['String']>;
  mostComfortableLanguage?: Maybe<Scalars['String']>;
  personality?: Maybe<Scalars['String']>;
  priorWorkExperience?: Maybe<Scalars['String']>;
  schoolsAttended?: Maybe<Scalars['String']>;
  skillsToGainFromTheCourse?: Maybe<Scalars['String']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  timeAtCahmSoFar?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whyChooseHospitality?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type student_familiarization_form_max_fields = {
  __typename?: 'student_familiarization_form_max_fields';
  careerAmbition?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currentResidentLocation?: Maybe<Scalars['String']>;
  englishReading?: Maybe<Scalars['Int']>;
  englishSpeaking?: Maybe<Scalars['Int']>;
  englishUnderstanding?: Maybe<Scalars['Int']>;
  englishWriting?: Maybe<Scalars['Int']>;
  groupOrIndividual?: Maybe<Scalars['String']>;
  hometown?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  leadOrFollow?: Maybe<Scalars['String']>;
  mostComfortableLanguage?: Maybe<Scalars['String']>;
  personality?: Maybe<Scalars['String']>;
  priorWorkExperience?: Maybe<Scalars['String']>;
  schoolsAttended?: Maybe<Scalars['String']>;
  skillsToGainFromTheCourse?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  timeAtCahmSoFar?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whyChooseHospitality?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type student_familiarization_form_min_fields = {
  __typename?: 'student_familiarization_form_min_fields';
  careerAmbition?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currentResidentLocation?: Maybe<Scalars['String']>;
  englishReading?: Maybe<Scalars['Int']>;
  englishSpeaking?: Maybe<Scalars['Int']>;
  englishUnderstanding?: Maybe<Scalars['Int']>;
  englishWriting?: Maybe<Scalars['Int']>;
  groupOrIndividual?: Maybe<Scalars['String']>;
  hometown?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  leadOrFollow?: Maybe<Scalars['String']>;
  mostComfortableLanguage?: Maybe<Scalars['String']>;
  personality?: Maybe<Scalars['String']>;
  priorWorkExperience?: Maybe<Scalars['String']>;
  schoolsAttended?: Maybe<Scalars['String']>;
  skillsToGainFromTheCourse?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  timeAtCahmSoFar?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whyChooseHospitality?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "student_familiarization_form" */
export type student_familiarization_form_mutation_response = {
  __typename?: 'student_familiarization_form_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_familiarization_form>;
};

/** input type for inserting object relation for remote table "student_familiarization_form" */
export type student_familiarization_form_obj_rel_insert_input = {
  data: student_familiarization_form_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<student_familiarization_form_on_conflict>;
};

/** on conflict condition type for table "student_familiarization_form" */
export type student_familiarization_form_on_conflict = {
  constraint: student_familiarization_form_constraint;
  update_columns?: Array<student_familiarization_form_update_column>;
  where?: Maybe<student_familiarization_form_bool_exp>;
};

/** Ordering options when selecting data from "student_familiarization_form". */
export type student_familiarization_form_order_by = {
  careerAmbition?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  currentResidentLocation?: Maybe<order_by>;
  englishReading?: Maybe<order_by>;
  englishSpeaking?: Maybe<order_by>;
  englishUnderstanding?: Maybe<order_by>;
  englishWriting?: Maybe<order_by>;
  groupOrIndividual?: Maybe<order_by>;
  hometown?: Maybe<order_by>;
  id?: Maybe<order_by>;
  leadOrFollow?: Maybe<order_by>;
  mostComfortableLanguage?: Maybe<order_by>;
  personality?: Maybe<order_by>;
  priorWorkExperience?: Maybe<order_by>;
  schoolsAttended?: Maybe<order_by>;
  skillsToGainFromTheCourse?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  timeAtCahmSoFar?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  whyChooseHospitality?: Maybe<order_by>;
};

/** primary key columns input for table: student_familiarization_form */
export type student_familiarization_form_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_familiarization_form" */
export enum student_familiarization_form_select_column {
  /** column name */
  careerAmbition = 'careerAmbition',
  /** column name */
  created_at = 'created_at',
  /** column name */
  currentResidentLocation = 'currentResidentLocation',
  /** column name */
  englishReading = 'englishReading',
  /** column name */
  englishSpeaking = 'englishSpeaking',
  /** column name */
  englishUnderstanding = 'englishUnderstanding',
  /** column name */
  englishWriting = 'englishWriting',
  /** column name */
  groupOrIndividual = 'groupOrIndividual',
  /** column name */
  hometown = 'hometown',
  /** column name */
  id = 'id',
  /** column name */
  leadOrFollow = 'leadOrFollow',
  /** column name */
  mostComfortableLanguage = 'mostComfortableLanguage',
  /** column name */
  personality = 'personality',
  /** column name */
  priorWorkExperience = 'priorWorkExperience',
  /** column name */
  schoolsAttended = 'schoolsAttended',
  /** column name */
  skillsToGainFromTheCourse = 'skillsToGainFromTheCourse',
  /** column name */
  studentId = 'studentId',
  /** column name */
  timeAtCahmSoFar = 'timeAtCahmSoFar',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  whyChooseHospitality = 'whyChooseHospitality',
}

/** input type for updating data in table "student_familiarization_form" */
export type student_familiarization_form_set_input = {
  careerAmbition?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  currentResidentLocation?: Maybe<Scalars['String']>;
  englishReading?: Maybe<Scalars['Int']>;
  englishSpeaking?: Maybe<Scalars['Int']>;
  englishUnderstanding?: Maybe<Scalars['Int']>;
  englishWriting?: Maybe<Scalars['Int']>;
  groupOrIndividual?: Maybe<Scalars['String']>;
  hometown?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  leadOrFollow?: Maybe<Scalars['String']>;
  mostComfortableLanguage?: Maybe<Scalars['String']>;
  personality?: Maybe<Scalars['String']>;
  priorWorkExperience?: Maybe<Scalars['String']>;
  schoolsAttended?: Maybe<Scalars['String']>;
  skillsToGainFromTheCourse?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  timeAtCahmSoFar?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  whyChooseHospitality?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type student_familiarization_form_stddev_fields = {
  __typename?: 'student_familiarization_form_stddev_fields';
  englishReading?: Maybe<Scalars['Float']>;
  englishSpeaking?: Maybe<Scalars['Float']>;
  englishUnderstanding?: Maybe<Scalars['Float']>;
  englishWriting?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type student_familiarization_form_stddev_pop_fields = {
  __typename?: 'student_familiarization_form_stddev_pop_fields';
  englishReading?: Maybe<Scalars['Float']>;
  englishSpeaking?: Maybe<Scalars['Float']>;
  englishUnderstanding?: Maybe<Scalars['Float']>;
  englishWriting?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type student_familiarization_form_stddev_samp_fields = {
  __typename?: 'student_familiarization_form_stddev_samp_fields';
  englishReading?: Maybe<Scalars['Float']>;
  englishSpeaking?: Maybe<Scalars['Float']>;
  englishUnderstanding?: Maybe<Scalars['Float']>;
  englishWriting?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type student_familiarization_form_sum_fields = {
  __typename?: 'student_familiarization_form_sum_fields';
  englishReading?: Maybe<Scalars['Int']>;
  englishSpeaking?: Maybe<Scalars['Int']>;
  englishUnderstanding?: Maybe<Scalars['Int']>;
  englishWriting?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** update columns of table "student_familiarization_form" */
export enum student_familiarization_form_update_column {
  /** column name */
  careerAmbition = 'careerAmbition',
  /** column name */
  created_at = 'created_at',
  /** column name */
  currentResidentLocation = 'currentResidentLocation',
  /** column name */
  englishReading = 'englishReading',
  /** column name */
  englishSpeaking = 'englishSpeaking',
  /** column name */
  englishUnderstanding = 'englishUnderstanding',
  /** column name */
  englishWriting = 'englishWriting',
  /** column name */
  groupOrIndividual = 'groupOrIndividual',
  /** column name */
  hometown = 'hometown',
  /** column name */
  id = 'id',
  /** column name */
  leadOrFollow = 'leadOrFollow',
  /** column name */
  mostComfortableLanguage = 'mostComfortableLanguage',
  /** column name */
  personality = 'personality',
  /** column name */
  priorWorkExperience = 'priorWorkExperience',
  /** column name */
  schoolsAttended = 'schoolsAttended',
  /** column name */
  skillsToGainFromTheCourse = 'skillsToGainFromTheCourse',
  /** column name */
  studentId = 'studentId',
  /** column name */
  timeAtCahmSoFar = 'timeAtCahmSoFar',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  whyChooseHospitality = 'whyChooseHospitality',
}

/** aggregate var_pop on columns */
export type student_familiarization_form_var_pop_fields = {
  __typename?: 'student_familiarization_form_var_pop_fields';
  englishReading?: Maybe<Scalars['Float']>;
  englishSpeaking?: Maybe<Scalars['Float']>;
  englishUnderstanding?: Maybe<Scalars['Float']>;
  englishWriting?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type student_familiarization_form_var_samp_fields = {
  __typename?: 'student_familiarization_form_var_samp_fields';
  englishReading?: Maybe<Scalars['Float']>;
  englishSpeaking?: Maybe<Scalars['Float']>;
  englishUnderstanding?: Maybe<Scalars['Float']>;
  englishWriting?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type student_familiarization_form_variance_fields = {
  __typename?: 'student_familiarization_form_variance_fields';
  englishReading?: Maybe<Scalars['Float']>;
  englishSpeaking?: Maybe<Scalars['Float']>;
  englishUnderstanding?: Maybe<Scalars['Float']>;
  englishWriting?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "student_familiarization_interview" */
export type student_familiarization_interview = {
  __typename?: 'student_familiarization_interview';
  createUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  createdUser?: Maybe<user_public>;
  created_at: Scalars['timestamptz'];
  doubtsFears: Scalars['String'];
  familyBackground: Scalars['String'];
  id: Scalars['uuid'];
  learningPreferences: Scalars['String'];
  makingFriendsAtCahm: Scalars['String'];
  roleModel: Scalars['String'];
  /** An object relationship */
  student: student;
  studentId: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "student_familiarization_interview" */
export type student_familiarization_interview_aggregate = {
  __typename?: 'student_familiarization_interview_aggregate';
  aggregate?: Maybe<student_familiarization_interview_aggregate_fields>;
  nodes: Array<student_familiarization_interview>;
};

/** aggregate fields of "student_familiarization_interview" */
export type student_familiarization_interview_aggregate_fields = {
  __typename?: 'student_familiarization_interview_aggregate_fields';
  avg?: Maybe<student_familiarization_interview_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_familiarization_interview_max_fields>;
  min?: Maybe<student_familiarization_interview_min_fields>;
  stddev?: Maybe<student_familiarization_interview_stddev_fields>;
  stddev_pop?: Maybe<student_familiarization_interview_stddev_pop_fields>;
  stddev_samp?: Maybe<student_familiarization_interview_stddev_samp_fields>;
  sum?: Maybe<student_familiarization_interview_sum_fields>;
  var_pop?: Maybe<student_familiarization_interview_var_pop_fields>;
  var_samp?: Maybe<student_familiarization_interview_var_samp_fields>;
  variance?: Maybe<student_familiarization_interview_variance_fields>;
};

/** aggregate fields of "student_familiarization_interview" */
export type student_familiarization_interview_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_familiarization_interview_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_familiarization_interview" */
export type student_familiarization_interview_aggregate_order_by = {
  avg?: Maybe<student_familiarization_interview_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_familiarization_interview_max_order_by>;
  min?: Maybe<student_familiarization_interview_min_order_by>;
  stddev?: Maybe<student_familiarization_interview_stddev_order_by>;
  stddev_pop?: Maybe<student_familiarization_interview_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_familiarization_interview_stddev_samp_order_by>;
  sum?: Maybe<student_familiarization_interview_sum_order_by>;
  var_pop?: Maybe<student_familiarization_interview_var_pop_order_by>;
  var_samp?: Maybe<student_familiarization_interview_var_samp_order_by>;
  variance?: Maybe<student_familiarization_interview_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_familiarization_interview" */
export type student_familiarization_interview_arr_rel_insert_input = {
  data: Array<student_familiarization_interview_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_familiarization_interview_on_conflict>;
};

/** aggregate avg on columns */
export type student_familiarization_interview_avg_fields = {
  __typename?: 'student_familiarization_interview_avg_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_avg_order_by = {
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_familiarization_interview". All fields are combined with a logical 'AND'. */
export type student_familiarization_interview_bool_exp = {
  _and?: Maybe<Array<student_familiarization_interview_bool_exp>>;
  _not?: Maybe<student_familiarization_interview_bool_exp>;
  _or?: Maybe<Array<student_familiarization_interview_bool_exp>>;
  createUserId?: Maybe<uuid_comparison_exp>;
  createdUser?: Maybe<user_public_bool_exp>;
  created_at?: Maybe<timestamptz_comparison_exp>;
  doubtsFears?: Maybe<String_comparison_exp>;
  familyBackground?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  learningPreferences?: Maybe<String_comparison_exp>;
  makingFriendsAtCahm?: Maybe<String_comparison_exp>;
  roleModel?: Maybe<String_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "student_familiarization_interview" */
export enum student_familiarization_interview_constraint {
  /** unique or primary key constraint */
  student_familiarization_interview_pkey = 'student_familiarization_interview_pkey',
}

/** input type for incrementing numeric columns in table "student_familiarization_interview" */
export type student_familiarization_interview_inc_input = {
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_familiarization_interview" */
export type student_familiarization_interview_insert_input = {
  createUserId?: Maybe<Scalars['uuid']>;
  createdUser?: Maybe<user_public_obj_rel_insert_input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  doubtsFears?: Maybe<Scalars['String']>;
  familyBackground?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  learningPreferences?: Maybe<Scalars['String']>;
  makingFriendsAtCahm?: Maybe<Scalars['String']>;
  roleModel?: Maybe<Scalars['String']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type student_familiarization_interview_max_fields = {
  __typename?: 'student_familiarization_interview_max_fields';
  createUserId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  doubtsFears?: Maybe<Scalars['String']>;
  familyBackground?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  learningPreferences?: Maybe<Scalars['String']>;
  makingFriendsAtCahm?: Maybe<Scalars['String']>;
  roleModel?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_max_order_by = {
  createUserId?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  doubtsFears?: Maybe<order_by>;
  familyBackground?: Maybe<order_by>;
  id?: Maybe<order_by>;
  learningPreferences?: Maybe<order_by>;
  makingFriendsAtCahm?: Maybe<order_by>;
  roleModel?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_familiarization_interview_min_fields = {
  __typename?: 'student_familiarization_interview_min_fields';
  createUserId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  doubtsFears?: Maybe<Scalars['String']>;
  familyBackground?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  learningPreferences?: Maybe<Scalars['String']>;
  makingFriendsAtCahm?: Maybe<Scalars['String']>;
  roleModel?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_min_order_by = {
  createUserId?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  doubtsFears?: Maybe<order_by>;
  familyBackground?: Maybe<order_by>;
  id?: Maybe<order_by>;
  learningPreferences?: Maybe<order_by>;
  makingFriendsAtCahm?: Maybe<order_by>;
  roleModel?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** response of any mutation on the table "student_familiarization_interview" */
export type student_familiarization_interview_mutation_response = {
  __typename?: 'student_familiarization_interview_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_familiarization_interview>;
};

/** on conflict condition type for table "student_familiarization_interview" */
export type student_familiarization_interview_on_conflict = {
  constraint: student_familiarization_interview_constraint;
  update_columns?: Array<student_familiarization_interview_update_column>;
  where?: Maybe<student_familiarization_interview_bool_exp>;
};

/** Ordering options when selecting data from "student_familiarization_interview". */
export type student_familiarization_interview_order_by = {
  createUserId?: Maybe<order_by>;
  createdUser?: Maybe<user_public_order_by>;
  created_at?: Maybe<order_by>;
  doubtsFears?: Maybe<order_by>;
  familyBackground?: Maybe<order_by>;
  id?: Maybe<order_by>;
  learningPreferences?: Maybe<order_by>;
  makingFriendsAtCahm?: Maybe<order_by>;
  roleModel?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** primary key columns input for table: student_familiarization_interview */
export type student_familiarization_interview_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_familiarization_interview" */
export enum student_familiarization_interview_select_column {
  /** column name */
  createUserId = 'createUserId',
  /** column name */
  created_at = 'created_at',
  /** column name */
  doubtsFears = 'doubtsFears',
  /** column name */
  familyBackground = 'familyBackground',
  /** column name */
  id = 'id',
  /** column name */
  learningPreferences = 'learningPreferences',
  /** column name */
  makingFriendsAtCahm = 'makingFriendsAtCahm',
  /** column name */
  roleModel = 'roleModel',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "student_familiarization_interview" */
export type student_familiarization_interview_set_input = {
  createUserId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  doubtsFears?: Maybe<Scalars['String']>;
  familyBackground?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  learningPreferences?: Maybe<Scalars['String']>;
  makingFriendsAtCahm?: Maybe<Scalars['String']>;
  roleModel?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type student_familiarization_interview_stddev_fields = {
  __typename?: 'student_familiarization_interview_stddev_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_stddev_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_familiarization_interview_stddev_pop_fields = {
  __typename?: 'student_familiarization_interview_stddev_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_stddev_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_familiarization_interview_stddev_samp_fields = {
  __typename?: 'student_familiarization_interview_stddev_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_stddev_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_familiarization_interview_sum_fields = {
  __typename?: 'student_familiarization_interview_sum_fields';
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_sum_order_by = {
  studentId?: Maybe<order_by>;
};

/** update columns of table "student_familiarization_interview" */
export enum student_familiarization_interview_update_column {
  /** column name */
  createUserId = 'createUserId',
  /** column name */
  created_at = 'created_at',
  /** column name */
  doubtsFears = 'doubtsFears',
  /** column name */
  familyBackground = 'familyBackground',
  /** column name */
  id = 'id',
  /** column name */
  learningPreferences = 'learningPreferences',
  /** column name */
  makingFriendsAtCahm = 'makingFriendsAtCahm',
  /** column name */
  roleModel = 'roleModel',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate var_pop on columns */
export type student_familiarization_interview_var_pop_fields = {
  __typename?: 'student_familiarization_interview_var_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_var_pop_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_familiarization_interview_var_samp_fields = {
  __typename?: 'student_familiarization_interview_var_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_var_samp_order_by = {
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_familiarization_interview_variance_fields = {
  __typename?: 'student_familiarization_interview_variance_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_familiarization_interview" */
export type student_familiarization_interview_variance_order_by = {
  studentId?: Maybe<order_by>;
};

/** columns and relationships of "student_for_batch" */
export type student_for_batch = {
  __typename?: 'student_for_batch';
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['student_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  /** An array relationship */
  student_batch_classes_batch_classes: Array<student_batch_classes_batch_class>;
  /** An aggregate relationship */
  student_batch_classes_batch_classes_aggregate: student_batch_classes_batch_class_aggregate;
  /** An array relationship */
  student_batch_histories: Array<student_batch_history>;
  /** An aggregate relationship */
  student_batch_histories_aggregate: student_batch_history_aggregate;
  /** An array relationship */
  student_courses: Array<student_course>;
  /** An aggregate relationship */
  student_courses_aggregate: student_course_aggregate;
  waiID?: Maybe<Scalars['String']>;
};

/** columns and relationships of "student_for_batch" */
export type student_for_batchstudent_batch_classes_batch_classesArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

/** columns and relationships of "student_for_batch" */
export type student_for_batchstudent_batch_classes_batch_classes_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

/** columns and relationships of "student_for_batch" */
export type student_for_batchstudent_batch_historiesArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

/** columns and relationships of "student_for_batch" */
export type student_for_batchstudent_batch_histories_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

/** columns and relationships of "student_for_batch" */
export type student_for_batchstudent_coursesArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** columns and relationships of "student_for_batch" */
export type student_for_batchstudent_courses_aggregateArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** aggregated selection of "student_for_batch" */
export type student_for_batch_aggregate = {
  __typename?: 'student_for_batch_aggregate';
  aggregate?: Maybe<student_for_batch_aggregate_fields>;
  nodes: Array<student_for_batch>;
};

/** aggregate fields of "student_for_batch" */
export type student_for_batch_aggregate_fields = {
  __typename?: 'student_for_batch_aggregate_fields';
  avg?: Maybe<student_for_batch_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_for_batch_max_fields>;
  min?: Maybe<student_for_batch_min_fields>;
  stddev?: Maybe<student_for_batch_stddev_fields>;
  stddev_pop?: Maybe<student_for_batch_stddev_pop_fields>;
  stddev_samp?: Maybe<student_for_batch_stddev_samp_fields>;
  sum?: Maybe<student_for_batch_sum_fields>;
  var_pop?: Maybe<student_for_batch_var_pop_fields>;
  var_samp?: Maybe<student_for_batch_var_samp_fields>;
  variance?: Maybe<student_for_batch_variance_fields>;
};

/** aggregate fields of "student_for_batch" */
export type student_for_batch_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_for_batch_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type student_for_batch_avg_fields = {
  __typename?: 'student_for_batch_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "student_for_batch". All fields are combined with a logical 'AND'. */
export type student_for_batch_bool_exp = {
  _and?: Maybe<Array<student_for_batch_bool_exp>>;
  _not?: Maybe<student_for_batch_bool_exp>;
  _or?: Maybe<Array<student_for_batch_bool_exp>>;
  firstName?: Maybe<String_comparison_exp>;
  gender?: Maybe<student_gender_enum_comparison_exp>;
  id?: Maybe<Int_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  middleName?: Maybe<String_comparison_exp>;
  regNumber?: Maybe<String_comparison_exp>;
  sliitID?: Maybe<String_comparison_exp>;
  status?: Maybe<String_comparison_exp>;
  student_batch_classes_batch_classes?: Maybe<student_batch_classes_batch_class_bool_exp>;
  student_batch_histories?: Maybe<student_batch_history_bool_exp>;
  student_courses?: Maybe<student_course_bool_exp>;
  waiID?: Maybe<String_comparison_exp>;
};

/** input type for incrementing numeric columns in table "student_for_batch" */
export type student_for_batch_inc_input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_for_batch" */
export type student_for_batch_insert_input = {
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['student_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student_batch_classes_batch_classes?: Maybe<student_batch_classes_batch_class_arr_rel_insert_input>;
  student_batch_histories?: Maybe<student_batch_history_arr_rel_insert_input>;
  student_courses?: Maybe<student_course_arr_rel_insert_input>;
  waiID?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type student_for_batch_max_fields = {
  __typename?: 'student_for_batch_max_fields';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  waiID?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type student_for_batch_min_fields = {
  __typename?: 'student_for_batch_min_fields';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  waiID?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "student_for_batch" */
export type student_for_batch_mutation_response = {
  __typename?: 'student_for_batch_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_for_batch>;
};

/** Ordering options when selecting data from "student_for_batch". */
export type student_for_batch_order_by = {
  firstName?: Maybe<order_by>;
  gender?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
  sliitID?: Maybe<order_by>;
  status?: Maybe<order_by>;
  student_batch_classes_batch_classes_aggregate?: Maybe<student_batch_classes_batch_class_aggregate_order_by>;
  student_batch_histories_aggregate?: Maybe<student_batch_history_aggregate_order_by>;
  student_courses_aggregate?: Maybe<student_course_aggregate_order_by>;
  waiID?: Maybe<order_by>;
};

/** select columns of table "student_for_batch" */
export enum student_for_batch_select_column {
  /** column name */
  firstName = 'firstName',
  /** column name */
  gender = 'gender',
  /** column name */
  id = 'id',
  /** column name */
  lastName = 'lastName',
  /** column name */
  middleName = 'middleName',
  /** column name */
  regNumber = 'regNumber',
  /** column name */
  sliitID = 'sliitID',
  /** column name */
  status = 'status',
  /** column name */
  waiID = 'waiID',
}

/** input type for updating data in table "student_for_batch" */
export type student_for_batch_set_input = {
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['student_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  waiID?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type student_for_batch_stddev_fields = {
  __typename?: 'student_for_batch_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type student_for_batch_stddev_pop_fields = {
  __typename?: 'student_for_batch_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type student_for_batch_stddev_samp_fields = {
  __typename?: 'student_for_batch_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type student_for_batch_sum_fields = {
  __typename?: 'student_for_batch_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type student_for_batch_var_pop_fields = {
  __typename?: 'student_for_batch_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type student_for_batch_var_samp_fields = {
  __typename?: 'student_for_batch_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type student_for_batch_variance_fields = {
  __typename?: 'student_for_batch_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "student_gender_enum". All fields are combined with logical 'AND'. */
export type student_gender_enum_comparison_exp = {
  _eq?: Maybe<Scalars['student_gender_enum']>;
  _gt?: Maybe<Scalars['student_gender_enum']>;
  _gte?: Maybe<Scalars['student_gender_enum']>;
  _in?: Maybe<Array<Scalars['student_gender_enum']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['student_gender_enum']>;
  _lte?: Maybe<Scalars['student_gender_enum']>;
  _neq?: Maybe<Scalars['student_gender_enum']>;
  _nin?: Maybe<Array<Scalars['student_gender_enum']>>;
};

/** columns and relationships of "student_general_request" */
export type student_general_request = {
  __typename?: 'student_general_request';
  id: Scalars['uuid'];
  studentRequestId: Scalars['Int'];
  /** An object relationship */
  student_request?: Maybe<student_request>;
  title: Scalars['String'];
};

/** aggregated selection of "student_general_request" */
export type student_general_request_aggregate = {
  __typename?: 'student_general_request_aggregate';
  aggregate?: Maybe<student_general_request_aggregate_fields>;
  nodes: Array<student_general_request>;
};

/** aggregate fields of "student_general_request" */
export type student_general_request_aggregate_fields = {
  __typename?: 'student_general_request_aggregate_fields';
  avg?: Maybe<student_general_request_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_general_request_max_fields>;
  min?: Maybe<student_general_request_min_fields>;
  stddev?: Maybe<student_general_request_stddev_fields>;
  stddev_pop?: Maybe<student_general_request_stddev_pop_fields>;
  stddev_samp?: Maybe<student_general_request_stddev_samp_fields>;
  sum?: Maybe<student_general_request_sum_fields>;
  var_pop?: Maybe<student_general_request_var_pop_fields>;
  var_samp?: Maybe<student_general_request_var_samp_fields>;
  variance?: Maybe<student_general_request_variance_fields>;
};

/** aggregate fields of "student_general_request" */
export type student_general_request_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_general_request_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_general_request" */
export type student_general_request_aggregate_order_by = {
  avg?: Maybe<student_general_request_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_general_request_max_order_by>;
  min?: Maybe<student_general_request_min_order_by>;
  stddev?: Maybe<student_general_request_stddev_order_by>;
  stddev_pop?: Maybe<student_general_request_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_general_request_stddev_samp_order_by>;
  sum?: Maybe<student_general_request_sum_order_by>;
  var_pop?: Maybe<student_general_request_var_pop_order_by>;
  var_samp?: Maybe<student_general_request_var_samp_order_by>;
  variance?: Maybe<student_general_request_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_general_request" */
export type student_general_request_arr_rel_insert_input = {
  data: Array<student_general_request_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_general_request_on_conflict>;
};

/** aggregate avg on columns */
export type student_general_request_avg_fields = {
  __typename?: 'student_general_request_avg_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_general_request" */
export type student_general_request_avg_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_general_request". All fields are combined with a logical 'AND'. */
export type student_general_request_bool_exp = {
  _and?: Maybe<Array<student_general_request_bool_exp>>;
  _not?: Maybe<student_general_request_bool_exp>;
  _or?: Maybe<Array<student_general_request_bool_exp>>;
  id?: Maybe<uuid_comparison_exp>;
  studentRequestId?: Maybe<Int_comparison_exp>;
  student_request?: Maybe<student_request_bool_exp>;
  title?: Maybe<String_comparison_exp>;
};

/** unique or primary key constraints on table "student_general_request" */
export enum student_general_request_constraint {
  /** unique or primary key constraint */
  student_general_request_pkey = 'student_general_request_pkey',
}

/** input type for incrementing numeric columns in table "student_general_request" */
export type student_general_request_inc_input = {
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_general_request" */
export type student_general_request_insert_input = {
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  student_request?: Maybe<student_request_obj_rel_insert_input>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type student_general_request_max_fields = {
  __typename?: 'student_general_request_max_fields';
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "student_general_request" */
export type student_general_request_max_order_by = {
  id?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  title?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_general_request_min_fields = {
  __typename?: 'student_general_request_min_fields';
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "student_general_request" */
export type student_general_request_min_order_by = {
  id?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  title?: Maybe<order_by>;
};

/** response of any mutation on the table "student_general_request" */
export type student_general_request_mutation_response = {
  __typename?: 'student_general_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_general_request>;
};

/** on conflict condition type for table "student_general_request" */
export type student_general_request_on_conflict = {
  constraint: student_general_request_constraint;
  update_columns?: Array<student_general_request_update_column>;
  where?: Maybe<student_general_request_bool_exp>;
};

/** Ordering options when selecting data from "student_general_request". */
export type student_general_request_order_by = {
  id?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  student_request?: Maybe<student_request_order_by>;
  title?: Maybe<order_by>;
};

/** primary key columns input for table: student_general_request */
export type student_general_request_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_general_request" */
export enum student_general_request_select_column {
  /** column name */
  id = 'id',
  /** column name */
  studentRequestId = 'studentRequestId',
  /** column name */
  title = 'title',
}

/** input type for updating data in table "student_general_request" */
export type student_general_request_set_input = {
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type student_general_request_stddev_fields = {
  __typename?: 'student_general_request_stddev_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_general_request" */
export type student_general_request_stddev_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_general_request_stddev_pop_fields = {
  __typename?: 'student_general_request_stddev_pop_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_general_request" */
export type student_general_request_stddev_pop_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_general_request_stddev_samp_fields = {
  __typename?: 'student_general_request_stddev_samp_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_general_request" */
export type student_general_request_stddev_samp_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_general_request_sum_fields = {
  __typename?: 'student_general_request_sum_fields';
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_general_request" */
export type student_general_request_sum_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** update columns of table "student_general_request" */
export enum student_general_request_update_column {
  /** column name */
  id = 'id',
  /** column name */
  studentRequestId = 'studentRequestId',
  /** column name */
  title = 'title',
}

/** aggregate var_pop on columns */
export type student_general_request_var_pop_fields = {
  __typename?: 'student_general_request_var_pop_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_general_request" */
export type student_general_request_var_pop_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_general_request_var_samp_fields = {
  __typename?: 'student_general_request_var_samp_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_general_request" */
export type student_general_request_var_samp_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_general_request_variance_fields = {
  __typename?: 'student_general_request_variance_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_general_request" */
export type student_general_request_variance_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** input type for incrementing numeric columns in table "student" */
export type student_inc_input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student" */
export type student_insert_input = {
  agreementURLs?: Maybe<Scalars['String']>;
  attendance_students?: Maybe<attendance_student_arr_rel_insert_input>;
  bloodType?: Maybe<blood_type_enum>;
  blood_type?: Maybe<blood_type_obj_rel_insert_input>;
  createdAt?: Maybe<Scalars['timestamp']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  education_qualifications?: Maybe<education_qualification_arr_rel_insert_input>;
  educationalCertificatesURLs?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employment_experiences?: Maybe<employment_experience_arr_rel_insert_input>;
  exit_interview_answers?: Maybe<exit_interview_answer_arr_rel_insert_input>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['student_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  illnessesDisabilities?: Maybe<Scalars['String']>;
  initialRegistrationFeePaid?: Maybe<Scalars['Boolean']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  inquiry?: Maybe<inquiry_obj_rel_insert_input>;
  isContactParent?: Maybe<Scalars['Boolean']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['student_nationality_enum']>;
  nicCopyURLs?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  ordinaryLevelCertificateURLs?: Maybe<Scalars['String']>;
  parentOrGuardianCity?: Maybe<Scalars['String']>;
  parentOrGuardianCountry?: Maybe<Scalars['String']>;
  parentOrGuardianDistrict?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianName?: Maybe<Scalars['String']>;
  parentOrGuardianProvince?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress1?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress2?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  passportOrBirthCertificateURLs?: Maybe<Scalars['String']>;
  passportSizePhotoURLs?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  postal_id?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  referredVia?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  request_messages?: Maybe<student_request_message_arr_rel_insert_input>;
  sameAsPermanentAddress?: Maybe<Scalars['Boolean']>;
  scannedDocumentURL?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  spokenLanguages?: Maybe<Scalars['String']>;
  status?: Maybe<student_status_enum>;
  student_assessment_submissions?: Maybe<student_assessment_submission_arr_rel_insert_input>;
  student_batch_classes_batch_classes?: Maybe<student_batch_classes_batch_class_arr_rel_insert_input>;
  student_batch_histories?: Maybe<student_batch_history_arr_rel_insert_input>;
  student_courses?: Maybe<student_course_arr_rel_insert_input>;
  student_familiarization_interviews?: Maybe<student_familiarization_interview_arr_rel_insert_input>;
  student_performances?: Maybe<student_performance_arr_rel_insert_input>;
  student_requests?: Maybe<student_request_arr_rel_insert_input>;
  student_result_sheets?: Maybe<student_result_sheet_arr_rel_insert_input>;
  student_status?: Maybe<student_status_obj_rel_insert_input>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  waiID?: Maybe<Scalars['String']>;
  whatsapp_number?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type student_max_fields = {
  __typename?: 'student_max_fields';
  agreementURLs?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  educationalCertificatesURLs?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  illnessesDisabilities?: Maybe<Scalars['String']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicCopyURLs?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  ordinaryLevelCertificateURLs?: Maybe<Scalars['String']>;
  parentOrGuardianCity?: Maybe<Scalars['String']>;
  parentOrGuardianCountry?: Maybe<Scalars['String']>;
  parentOrGuardianDistrict?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianName?: Maybe<Scalars['String']>;
  parentOrGuardianProvince?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress1?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress2?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  passportOrBirthCertificateURLs?: Maybe<Scalars['String']>;
  passportSizePhotoURLs?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  postal_id?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  referredVia?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  scannedDocumentURL?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  spokenLanguages?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  waiID?: Maybe<Scalars['String']>;
  whatsapp_number?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "student" */
export type student_max_order_by = {
  agreementURLs?: Maybe<order_by>;
  createdAt?: Maybe<order_by>;
  dateOfBirth?: Maybe<order_by>;
  educationalCertificatesURLs?: Maybe<order_by>;
  email?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  illnessesDisabilities?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  nicCopyURLs?: Maybe<order_by>;
  nicNo?: Maybe<order_by>;
  ordinaryLevelCertificateURLs?: Maybe<order_by>;
  parentOrGuardianCity?: Maybe<order_by>;
  parentOrGuardianCountry?: Maybe<order_by>;
  parentOrGuardianDistrict?: Maybe<order_by>;
  parentOrGuardianLandLineNo?: Maybe<order_by>;
  parentOrGuardianMobileNo?: Maybe<order_by>;
  parentOrGuardianName?: Maybe<order_by>;
  parentOrGuardianProvince?: Maybe<order_by>;
  parentOrGuardianStreetAddress1?: Maybe<order_by>;
  parentOrGuardianStreetAddress2?: Maybe<order_by>;
  passportNo?: Maybe<order_by>;
  passportOrBirthCertificateURLs?: Maybe<order_by>;
  passportSizePhotoURLs?: Maybe<order_by>;
  permanentCity?: Maybe<order_by>;
  permanentCountry?: Maybe<order_by>;
  permanentDistrict?: Maybe<order_by>;
  permanentProvince?: Maybe<order_by>;
  permanentStreetAddress1?: Maybe<order_by>;
  permanentStreetAddress2?: Maybe<order_by>;
  postal_id?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  profileUploadedPhotoURLs?: Maybe<order_by>;
  publishedAt?: Maybe<order_by>;
  referredVia?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
  remarks?: Maybe<order_by>;
  scannedDocumentURL?: Maybe<order_by>;
  sliitID?: Maybe<order_by>;
  spokenLanguages?: Maybe<order_by>;
  updatedAt?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  waiID?: Maybe<order_by>;
  whatsapp_number?: Maybe<order_by>;
};

/** columns and relationships of "student_medical_request" */
export type student_medical_request = {
  __typename?: 'student_medical_request';
  id: Scalars['uuid'];
  leaveEndDate: Scalars['timestamptz'];
  leaveStartDate: Scalars['timestamptz'];
  medicalCertificateIssueDate?: Maybe<Scalars['timestamptz']>;
  medicalOfficerName: Scalars['String'];
  signAndSymptoms?: Maybe<Scalars['String']>;
  studentRequestId: Scalars['Int'];
  /** An object relationship */
  student_request?: Maybe<student_request>;
};

/** aggregated selection of "student_medical_request" */
export type student_medical_request_aggregate = {
  __typename?: 'student_medical_request_aggregate';
  aggregate?: Maybe<student_medical_request_aggregate_fields>;
  nodes: Array<student_medical_request>;
};

/** aggregate fields of "student_medical_request" */
export type student_medical_request_aggregate_fields = {
  __typename?: 'student_medical_request_aggregate_fields';
  avg?: Maybe<student_medical_request_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_medical_request_max_fields>;
  min?: Maybe<student_medical_request_min_fields>;
  stddev?: Maybe<student_medical_request_stddev_fields>;
  stddev_pop?: Maybe<student_medical_request_stddev_pop_fields>;
  stddev_samp?: Maybe<student_medical_request_stddev_samp_fields>;
  sum?: Maybe<student_medical_request_sum_fields>;
  var_pop?: Maybe<student_medical_request_var_pop_fields>;
  var_samp?: Maybe<student_medical_request_var_samp_fields>;
  variance?: Maybe<student_medical_request_variance_fields>;
};

/** aggregate fields of "student_medical_request" */
export type student_medical_request_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_medical_request_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_medical_request" */
export type student_medical_request_aggregate_order_by = {
  avg?: Maybe<student_medical_request_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_medical_request_max_order_by>;
  min?: Maybe<student_medical_request_min_order_by>;
  stddev?: Maybe<student_medical_request_stddev_order_by>;
  stddev_pop?: Maybe<student_medical_request_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_medical_request_stddev_samp_order_by>;
  sum?: Maybe<student_medical_request_sum_order_by>;
  var_pop?: Maybe<student_medical_request_var_pop_order_by>;
  var_samp?: Maybe<student_medical_request_var_samp_order_by>;
  variance?: Maybe<student_medical_request_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_medical_request" */
export type student_medical_request_arr_rel_insert_input = {
  data: Array<student_medical_request_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_medical_request_on_conflict>;
};

/** aggregate avg on columns */
export type student_medical_request_avg_fields = {
  __typename?: 'student_medical_request_avg_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_medical_request" */
export type student_medical_request_avg_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_medical_request". All fields are combined with a logical 'AND'. */
export type student_medical_request_bool_exp = {
  _and?: Maybe<Array<student_medical_request_bool_exp>>;
  _not?: Maybe<student_medical_request_bool_exp>;
  _or?: Maybe<Array<student_medical_request_bool_exp>>;
  id?: Maybe<uuid_comparison_exp>;
  leaveEndDate?: Maybe<timestamptz_comparison_exp>;
  leaveStartDate?: Maybe<timestamptz_comparison_exp>;
  medicalCertificateIssueDate?: Maybe<timestamptz_comparison_exp>;
  medicalOfficerName?: Maybe<String_comparison_exp>;
  signAndSymptoms?: Maybe<String_comparison_exp>;
  studentRequestId?: Maybe<Int_comparison_exp>;
  student_request?: Maybe<student_request_bool_exp>;
};

/** unique or primary key constraints on table "student_medical_request" */
export enum student_medical_request_constraint {
  /** unique or primary key constraint */
  student_medical_request_pkey = 'student_medical_request_pkey',
}

/** input type for incrementing numeric columns in table "student_medical_request" */
export type student_medical_request_inc_input = {
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_medical_request" */
export type student_medical_request_insert_input = {
  id?: Maybe<Scalars['uuid']>;
  leaveEndDate?: Maybe<Scalars['timestamptz']>;
  leaveStartDate?: Maybe<Scalars['timestamptz']>;
  medicalCertificateIssueDate?: Maybe<Scalars['timestamptz']>;
  medicalOfficerName?: Maybe<Scalars['String']>;
  signAndSymptoms?: Maybe<Scalars['String']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  student_request?: Maybe<student_request_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type student_medical_request_max_fields = {
  __typename?: 'student_medical_request_max_fields';
  id?: Maybe<Scalars['uuid']>;
  leaveEndDate?: Maybe<Scalars['timestamptz']>;
  leaveStartDate?: Maybe<Scalars['timestamptz']>;
  medicalCertificateIssueDate?: Maybe<Scalars['timestamptz']>;
  medicalOfficerName?: Maybe<Scalars['String']>;
  signAndSymptoms?: Maybe<Scalars['String']>;
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "student_medical_request" */
export type student_medical_request_max_order_by = {
  id?: Maybe<order_by>;
  leaveEndDate?: Maybe<order_by>;
  leaveStartDate?: Maybe<order_by>;
  medicalCertificateIssueDate?: Maybe<order_by>;
  medicalOfficerName?: Maybe<order_by>;
  signAndSymptoms?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_medical_request_min_fields = {
  __typename?: 'student_medical_request_min_fields';
  id?: Maybe<Scalars['uuid']>;
  leaveEndDate?: Maybe<Scalars['timestamptz']>;
  leaveStartDate?: Maybe<Scalars['timestamptz']>;
  medicalCertificateIssueDate?: Maybe<Scalars['timestamptz']>;
  medicalOfficerName?: Maybe<Scalars['String']>;
  signAndSymptoms?: Maybe<Scalars['String']>;
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "student_medical_request" */
export type student_medical_request_min_order_by = {
  id?: Maybe<order_by>;
  leaveEndDate?: Maybe<order_by>;
  leaveStartDate?: Maybe<order_by>;
  medicalCertificateIssueDate?: Maybe<order_by>;
  medicalOfficerName?: Maybe<order_by>;
  signAndSymptoms?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** response of any mutation on the table "student_medical_request" */
export type student_medical_request_mutation_response = {
  __typename?: 'student_medical_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_medical_request>;
};

/** on conflict condition type for table "student_medical_request" */
export type student_medical_request_on_conflict = {
  constraint: student_medical_request_constraint;
  update_columns?: Array<student_medical_request_update_column>;
  where?: Maybe<student_medical_request_bool_exp>;
};

/** Ordering options when selecting data from "student_medical_request". */
export type student_medical_request_order_by = {
  id?: Maybe<order_by>;
  leaveEndDate?: Maybe<order_by>;
  leaveStartDate?: Maybe<order_by>;
  medicalCertificateIssueDate?: Maybe<order_by>;
  medicalOfficerName?: Maybe<order_by>;
  signAndSymptoms?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  student_request?: Maybe<student_request_order_by>;
};

/** primary key columns input for table: student_medical_request */
export type student_medical_request_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_medical_request" */
export enum student_medical_request_select_column {
  /** column name */
  id = 'id',
  /** column name */
  leaveEndDate = 'leaveEndDate',
  /** column name */
  leaveStartDate = 'leaveStartDate',
  /** column name */
  medicalCertificateIssueDate = 'medicalCertificateIssueDate',
  /** column name */
  medicalOfficerName = 'medicalOfficerName',
  /** column name */
  signAndSymptoms = 'signAndSymptoms',
  /** column name */
  studentRequestId = 'studentRequestId',
}

/** input type for updating data in table "student_medical_request" */
export type student_medical_request_set_input = {
  id?: Maybe<Scalars['uuid']>;
  leaveEndDate?: Maybe<Scalars['timestamptz']>;
  leaveStartDate?: Maybe<Scalars['timestamptz']>;
  medicalCertificateIssueDate?: Maybe<Scalars['timestamptz']>;
  medicalOfficerName?: Maybe<Scalars['String']>;
  signAndSymptoms?: Maybe<Scalars['String']>;
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type student_medical_request_stddev_fields = {
  __typename?: 'student_medical_request_stddev_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_medical_request" */
export type student_medical_request_stddev_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_medical_request_stddev_pop_fields = {
  __typename?: 'student_medical_request_stddev_pop_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_medical_request" */
export type student_medical_request_stddev_pop_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_medical_request_stddev_samp_fields = {
  __typename?: 'student_medical_request_stddev_samp_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_medical_request" */
export type student_medical_request_stddev_samp_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_medical_request_sum_fields = {
  __typename?: 'student_medical_request_sum_fields';
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_medical_request" */
export type student_medical_request_sum_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** update columns of table "student_medical_request" */
export enum student_medical_request_update_column {
  /** column name */
  id = 'id',
  /** column name */
  leaveEndDate = 'leaveEndDate',
  /** column name */
  leaveStartDate = 'leaveStartDate',
  /** column name */
  medicalCertificateIssueDate = 'medicalCertificateIssueDate',
  /** column name */
  medicalOfficerName = 'medicalOfficerName',
  /** column name */
  signAndSymptoms = 'signAndSymptoms',
  /** column name */
  studentRequestId = 'studentRequestId',
}

/** aggregate var_pop on columns */
export type student_medical_request_var_pop_fields = {
  __typename?: 'student_medical_request_var_pop_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_medical_request" */
export type student_medical_request_var_pop_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_medical_request_var_samp_fields = {
  __typename?: 'student_medical_request_var_samp_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_medical_request" */
export type student_medical_request_var_samp_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_medical_request_variance_fields = {
  __typename?: 'student_medical_request_variance_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_medical_request" */
export type student_medical_request_variance_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_min_fields = {
  __typename?: 'student_min_fields';
  agreementURLs?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  educationalCertificatesURLs?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  illnessesDisabilities?: Maybe<Scalars['String']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicCopyURLs?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  ordinaryLevelCertificateURLs?: Maybe<Scalars['String']>;
  parentOrGuardianCity?: Maybe<Scalars['String']>;
  parentOrGuardianCountry?: Maybe<Scalars['String']>;
  parentOrGuardianDistrict?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianName?: Maybe<Scalars['String']>;
  parentOrGuardianProvince?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress1?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress2?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  passportOrBirthCertificateURLs?: Maybe<Scalars['String']>;
  passportSizePhotoURLs?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  postal_id?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  referredVia?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  scannedDocumentURL?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  spokenLanguages?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  waiID?: Maybe<Scalars['String']>;
  whatsapp_number?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "student" */
export type student_min_order_by = {
  agreementURLs?: Maybe<order_by>;
  createdAt?: Maybe<order_by>;
  dateOfBirth?: Maybe<order_by>;
  educationalCertificatesURLs?: Maybe<order_by>;
  email?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  illnessesDisabilities?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  nicCopyURLs?: Maybe<order_by>;
  nicNo?: Maybe<order_by>;
  ordinaryLevelCertificateURLs?: Maybe<order_by>;
  parentOrGuardianCity?: Maybe<order_by>;
  parentOrGuardianCountry?: Maybe<order_by>;
  parentOrGuardianDistrict?: Maybe<order_by>;
  parentOrGuardianLandLineNo?: Maybe<order_by>;
  parentOrGuardianMobileNo?: Maybe<order_by>;
  parentOrGuardianName?: Maybe<order_by>;
  parentOrGuardianProvince?: Maybe<order_by>;
  parentOrGuardianStreetAddress1?: Maybe<order_by>;
  parentOrGuardianStreetAddress2?: Maybe<order_by>;
  passportNo?: Maybe<order_by>;
  passportOrBirthCertificateURLs?: Maybe<order_by>;
  passportSizePhotoURLs?: Maybe<order_by>;
  permanentCity?: Maybe<order_by>;
  permanentCountry?: Maybe<order_by>;
  permanentDistrict?: Maybe<order_by>;
  permanentProvince?: Maybe<order_by>;
  permanentStreetAddress1?: Maybe<order_by>;
  permanentStreetAddress2?: Maybe<order_by>;
  postal_id?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  profileUploadedPhotoURLs?: Maybe<order_by>;
  publishedAt?: Maybe<order_by>;
  referredVia?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
  remarks?: Maybe<order_by>;
  scannedDocumentURL?: Maybe<order_by>;
  sliitID?: Maybe<order_by>;
  spokenLanguages?: Maybe<order_by>;
  updatedAt?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  waiID?: Maybe<order_by>;
  whatsapp_number?: Maybe<order_by>;
};

/** response of any mutation on the table "student" */
export type student_mutation_response = {
  __typename?: 'student_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student>;
};

/** Boolean expression to compare columns of type "student_nationality_enum". All fields are combined with logical 'AND'. */
export type student_nationality_enum_comparison_exp = {
  _eq?: Maybe<Scalars['student_nationality_enum']>;
  _gt?: Maybe<Scalars['student_nationality_enum']>;
  _gte?: Maybe<Scalars['student_nationality_enum']>;
  _in?: Maybe<Array<Scalars['student_nationality_enum']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['student_nationality_enum']>;
  _lte?: Maybe<Scalars['student_nationality_enum']>;
  _neq?: Maybe<Scalars['student_nationality_enum']>;
  _nin?: Maybe<Array<Scalars['student_nationality_enum']>>;
};

/** input type for inserting object relation for remote table "student" */
export type student_obj_rel_insert_input = {
  data: student_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<student_on_conflict>;
};

/** on conflict condition type for table "student" */
export type student_on_conflict = {
  constraint: student_constraint;
  update_columns?: Array<student_update_column>;
  where?: Maybe<student_bool_exp>;
};

/** Ordering options when selecting data from "student". */
export type student_order_by = {
  agreementURLs?: Maybe<order_by>;
  attendance_students_aggregate?: Maybe<attendance_student_aggregate_order_by>;
  bloodType?: Maybe<order_by>;
  blood_type?: Maybe<blood_type_order_by>;
  createdAt?: Maybe<order_by>;
  dateOfBirth?: Maybe<order_by>;
  education_qualifications_aggregate?: Maybe<education_qualification_aggregate_order_by>;
  educationalCertificatesURLs?: Maybe<order_by>;
  email?: Maybe<order_by>;
  employment_experiences_aggregate?: Maybe<employment_experience_aggregate_order_by>;
  exit_interview_answers_aggregate?: Maybe<exit_interview_answer_aggregate_order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  gender?: Maybe<order_by>;
  id?: Maybe<order_by>;
  illnessesDisabilities?: Maybe<order_by>;
  initialRegistrationFeePaid?: Maybe<order_by>;
  initialTourFollowed?: Maybe<order_by>;
  inquiry?: Maybe<inquiry_order_by>;
  isContactParent?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  nationality?: Maybe<order_by>;
  nicCopyURLs?: Maybe<order_by>;
  nicNo?: Maybe<order_by>;
  ordinaryLevelCertificateURLs?: Maybe<order_by>;
  parentOrGuardianCity?: Maybe<order_by>;
  parentOrGuardianCountry?: Maybe<order_by>;
  parentOrGuardianDistrict?: Maybe<order_by>;
  parentOrGuardianLandLineNo?: Maybe<order_by>;
  parentOrGuardianMobileNo?: Maybe<order_by>;
  parentOrGuardianName?: Maybe<order_by>;
  parentOrGuardianProvince?: Maybe<order_by>;
  parentOrGuardianStreetAddress1?: Maybe<order_by>;
  parentOrGuardianStreetAddress2?: Maybe<order_by>;
  passportNo?: Maybe<order_by>;
  passportOrBirthCertificateURLs?: Maybe<order_by>;
  passportSizePhotoURLs?: Maybe<order_by>;
  permanentCity?: Maybe<order_by>;
  permanentCountry?: Maybe<order_by>;
  permanentDistrict?: Maybe<order_by>;
  permanentProvince?: Maybe<order_by>;
  permanentStreetAddress1?: Maybe<order_by>;
  permanentStreetAddress2?: Maybe<order_by>;
  postal_id?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  profileUploadedPhotoURLs?: Maybe<order_by>;
  publishedAt?: Maybe<order_by>;
  referredVia?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
  remarks?: Maybe<order_by>;
  request_messages_aggregate?: Maybe<student_request_message_aggregate_order_by>;
  sameAsPermanentAddress?: Maybe<order_by>;
  scannedDocumentURL?: Maybe<order_by>;
  sliitID?: Maybe<order_by>;
  spokenLanguages?: Maybe<order_by>;
  status?: Maybe<order_by>;
  student_assessment_submissions_aggregate?: Maybe<student_assessment_submission_aggregate_order_by>;
  student_batch_classes_batch_classes_aggregate?: Maybe<student_batch_classes_batch_class_aggregate_order_by>;
  student_batch_histories_aggregate?: Maybe<student_batch_history_aggregate_order_by>;
  student_courses_aggregate?: Maybe<student_course_aggregate_order_by>;
  student_familiarization_interviews_aggregate?: Maybe<student_familiarization_interview_aggregate_order_by>;
  student_performances_aggregate?: Maybe<student_performance_aggregate_order_by>;
  student_requests_aggregate?: Maybe<student_request_aggregate_order_by>;
  student_result_sheets_aggregate?: Maybe<student_result_sheet_aggregate_order_by>;
  student_status?: Maybe<student_status_order_by>;
  updatedAt?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  waiID?: Maybe<order_by>;
  whatsapp_number?: Maybe<order_by>;
};

/** columns and relationships of "student_performance" */
export type student_performance = {
  __typename?: 'student_performance';
  category: Scalars['String'];
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['Int'];
  status?: Maybe<perfomance_status_enum>;
  /** An object relationship */
  student: student;
  studentId: Scalars['Int'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<user_performance_public>;
};

/** aggregated selection of "student_performance" */
export type student_performance_aggregate = {
  __typename?: 'student_performance_aggregate';
  aggregate?: Maybe<student_performance_aggregate_fields>;
  nodes: Array<student_performance>;
};

/** aggregate fields of "student_performance" */
export type student_performance_aggregate_fields = {
  __typename?: 'student_performance_aggregate_fields';
  avg?: Maybe<student_performance_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_performance_max_fields>;
  min?: Maybe<student_performance_min_fields>;
  stddev?: Maybe<student_performance_stddev_fields>;
  stddev_pop?: Maybe<student_performance_stddev_pop_fields>;
  stddev_samp?: Maybe<student_performance_stddev_samp_fields>;
  sum?: Maybe<student_performance_sum_fields>;
  var_pop?: Maybe<student_performance_var_pop_fields>;
  var_samp?: Maybe<student_performance_var_samp_fields>;
  variance?: Maybe<student_performance_variance_fields>;
};

/** aggregate fields of "student_performance" */
export type student_performance_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_performance_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_performance" */
export type student_performance_aggregate_order_by = {
  avg?: Maybe<student_performance_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_performance_max_order_by>;
  min?: Maybe<student_performance_min_order_by>;
  stddev?: Maybe<student_performance_stddev_order_by>;
  stddev_pop?: Maybe<student_performance_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_performance_stddev_samp_order_by>;
  sum?: Maybe<student_performance_sum_order_by>;
  var_pop?: Maybe<student_performance_var_pop_order_by>;
  var_samp?: Maybe<student_performance_var_samp_order_by>;
  variance?: Maybe<student_performance_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_performance" */
export type student_performance_arr_rel_insert_input = {
  data: Array<student_performance_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_performance_on_conflict>;
};

/** aggregate avg on columns */
export type student_performance_avg_fields = {
  __typename?: 'student_performance_avg_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_performance" */
export type student_performance_avg_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_performance". All fields are combined with a logical 'AND'. */
export type student_performance_bool_exp = {
  _and?: Maybe<Array<student_performance_bool_exp>>;
  _not?: Maybe<student_performance_bool_exp>;
  _or?: Maybe<Array<student_performance_bool_exp>>;
  category?: Maybe<String_comparison_exp>;
  createdByUserFirebaseUID?: Maybe<String_comparison_exp>;
  created_at?: Maybe<timestamptz_comparison_exp>;
  description?: Maybe<String_comparison_exp>;
  id?: Maybe<Int_comparison_exp>;
  status?: Maybe<perfomance_status_enum_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  title?: Maybe<String_comparison_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
  user?: Maybe<user_performance_public_bool_exp>;
};

/** unique or primary key constraints on table "student_performance" */
export enum student_performance_constraint {
  /** unique or primary key constraint */
  student_performance_pkey = 'student_performance_pkey',
}

/** input type for incrementing numeric columns in table "student_performance" */
export type student_performance_inc_input = {
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_performance" */
export type student_performance_insert_input = {
  category?: Maybe<Scalars['String']>;
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<perfomance_status_enum>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<user_performance_public_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type student_performance_max_fields = {
  __typename?: 'student_performance_max_fields';
  category?: Maybe<Scalars['String']>;
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "student_performance" */
export type student_performance_max_order_by = {
  category?: Maybe<order_by>;
  createdByUserFirebaseUID?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  description?: Maybe<order_by>;
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  title?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_performance_min_fields = {
  __typename?: 'student_performance_min_fields';
  category?: Maybe<Scalars['String']>;
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "student_performance" */
export type student_performance_min_order_by = {
  category?: Maybe<order_by>;
  createdByUserFirebaseUID?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  description?: Maybe<order_by>;
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  title?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** response of any mutation on the table "student_performance" */
export type student_performance_mutation_response = {
  __typename?: 'student_performance_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_performance>;
};

/** on conflict condition type for table "student_performance" */
export type student_performance_on_conflict = {
  constraint: student_performance_constraint;
  update_columns?: Array<student_performance_update_column>;
  where?: Maybe<student_performance_bool_exp>;
};

/** Ordering options when selecting data from "student_performance". */
export type student_performance_order_by = {
  category?: Maybe<order_by>;
  createdByUserFirebaseUID?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  description?: Maybe<order_by>;
  id?: Maybe<order_by>;
  status?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  title?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  user?: Maybe<user_performance_public_order_by>;
};

/** primary key columns input for table: student_performance */
export type student_performance_pk_columns_input = {
  id: Scalars['Int'];
};

/** select columns of table "student_performance" */
export enum student_performance_select_column {
  /** column name */
  category = 'category',
  /** column name */
  createdByUserFirebaseUID = 'createdByUserFirebaseUID',
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  status = 'status',
  /** column name */
  studentId = 'studentId',
  /** column name */
  title = 'title',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "student_performance" */
export type student_performance_set_input = {
  category?: Maybe<Scalars['String']>;
  createdByUserFirebaseUID?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<perfomance_status_enum>;
  studentId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type student_performance_stddev_fields = {
  __typename?: 'student_performance_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_performance" */
export type student_performance_stddev_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_performance_stddev_pop_fields = {
  __typename?: 'student_performance_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_performance" */
export type student_performance_stddev_pop_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_performance_stddev_samp_fields = {
  __typename?: 'student_performance_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_performance" */
export type student_performance_stddev_samp_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_performance_sum_fields = {
  __typename?: 'student_performance_sum_fields';
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_performance" */
export type student_performance_sum_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** update columns of table "student_performance" */
export enum student_performance_update_column {
  /** column name */
  category = 'category',
  /** column name */
  createdByUserFirebaseUID = 'createdByUserFirebaseUID',
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  id = 'id',
  /** column name */
  status = 'status',
  /** column name */
  studentId = 'studentId',
  /** column name */
  title = 'title',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate var_pop on columns */
export type student_performance_var_pop_fields = {
  __typename?: 'student_performance_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_performance" */
export type student_performance_var_pop_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_performance_var_samp_fields = {
  __typename?: 'student_performance_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_performance" */
export type student_performance_var_samp_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_performance_variance_fields = {
  __typename?: 'student_performance_variance_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_performance" */
export type student_performance_variance_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** primary key columns input for table: student */
export type student_pk_columns_input = {
  id: Scalars['Int'];
};

/** columns and relationships of "student_request" */
export type student_request = {
  __typename?: 'student_request';
  approvedOn?: Maybe<Scalars['timestamptz']>;
  approvedUserId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  approved_user?: Maybe<user>;
  /** An object relationship */
  approved_user_public?: Maybe<user_public>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  evidence?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  status: student_request_status_enum;
  /** An object relationship */
  student: student;
  studentId: Scalars['Int'];
  /** An array relationship */
  student_external_engagement_requests: Array<student_external_engagement_request>;
  /** An aggregate relationship */
  student_external_engagement_requests_aggregate: student_external_engagement_request_aggregate;
  /** An array relationship */
  student_general_requests: Array<student_general_request>;
  /** An aggregate relationship */
  student_general_requests_aggregate: student_general_request_aggregate;
  /** An array relationship */
  student_medical_requests: Array<student_medical_request>;
  /** An aggregate relationship */
  student_medical_requests_aggregate: student_medical_request_aggregate;
  /** An array relationship */
  student_request_messages: Array<student_request_message>;
  /** An aggregate relationship */
  student_request_messages_aggregate: student_request_message_aggregate;
  /** An array relationship */
  student_request_requestees: Array<student_request_requestee>;
  /** An aggregate relationship */
  student_request_requestees_aggregate: student_request_requestee_aggregate;
  /** An object relationship */
  student_request_status: student_request_status;
  updated_at: Scalars['timestamptz'];
};

/** columns and relationships of "student_request" */
export type student_requeststudent_external_engagement_requestsArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_request_order_by>>;
  where?: Maybe<student_external_engagement_request_bool_exp>;
};

/** columns and relationships of "student_request" */
export type student_requeststudent_external_engagement_requests_aggregateArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_request_order_by>>;
  where?: Maybe<student_external_engagement_request_bool_exp>;
};

/** columns and relationships of "student_request" */
export type student_requeststudent_general_requestsArgs = {
  distinct_on?: Maybe<Array<student_general_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_general_request_order_by>>;
  where?: Maybe<student_general_request_bool_exp>;
};

/** columns and relationships of "student_request" */
export type student_requeststudent_general_requests_aggregateArgs = {
  distinct_on?: Maybe<Array<student_general_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_general_request_order_by>>;
  where?: Maybe<student_general_request_bool_exp>;
};

/** columns and relationships of "student_request" */
export type student_requeststudent_medical_requestsArgs = {
  distinct_on?: Maybe<Array<student_medical_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_medical_request_order_by>>;
  where?: Maybe<student_medical_request_bool_exp>;
};

/** columns and relationships of "student_request" */
export type student_requeststudent_medical_requests_aggregateArgs = {
  distinct_on?: Maybe<Array<student_medical_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_medical_request_order_by>>;
  where?: Maybe<student_medical_request_bool_exp>;
};

/** columns and relationships of "student_request" */
export type student_requeststudent_request_messagesArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

/** columns and relationships of "student_request" */
export type student_requeststudent_request_messages_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

/** columns and relationships of "student_request" */
export type student_requeststudent_request_requesteesArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

/** columns and relationships of "student_request" */
export type student_requeststudent_request_requestees_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

/** aggregated selection of "student_request" */
export type student_request_aggregate = {
  __typename?: 'student_request_aggregate';
  aggregate?: Maybe<student_request_aggregate_fields>;
  nodes: Array<student_request>;
};

/** aggregate fields of "student_request" */
export type student_request_aggregate_fields = {
  __typename?: 'student_request_aggregate_fields';
  avg?: Maybe<student_request_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_request_max_fields>;
  min?: Maybe<student_request_min_fields>;
  stddev?: Maybe<student_request_stddev_fields>;
  stddev_pop?: Maybe<student_request_stddev_pop_fields>;
  stddev_samp?: Maybe<student_request_stddev_samp_fields>;
  sum?: Maybe<student_request_sum_fields>;
  var_pop?: Maybe<student_request_var_pop_fields>;
  var_samp?: Maybe<student_request_var_samp_fields>;
  variance?: Maybe<student_request_variance_fields>;
};

/** aggregate fields of "student_request" */
export type student_request_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_request_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_request" */
export type student_request_aggregate_order_by = {
  avg?: Maybe<student_request_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_request_max_order_by>;
  min?: Maybe<student_request_min_order_by>;
  stddev?: Maybe<student_request_stddev_order_by>;
  stddev_pop?: Maybe<student_request_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_request_stddev_samp_order_by>;
  sum?: Maybe<student_request_sum_order_by>;
  var_pop?: Maybe<student_request_var_pop_order_by>;
  var_samp?: Maybe<student_request_var_samp_order_by>;
  variance?: Maybe<student_request_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_request" */
export type student_request_arr_rel_insert_input = {
  data: Array<student_request_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_request_on_conflict>;
};

/** aggregate avg on columns */
export type student_request_avg_fields = {
  __typename?: 'student_request_avg_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_request" */
export type student_request_avg_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_request". All fields are combined with a logical 'AND'. */
export type student_request_bool_exp = {
  _and?: Maybe<Array<student_request_bool_exp>>;
  _not?: Maybe<student_request_bool_exp>;
  _or?: Maybe<Array<student_request_bool_exp>>;
  approvedOn?: Maybe<timestamptz_comparison_exp>;
  approvedUserId?: Maybe<uuid_comparison_exp>;
  approved_user?: Maybe<user_bool_exp>;
  approved_user_public?: Maybe<user_public_bool_exp>;
  created_at?: Maybe<timestamptz_comparison_exp>;
  description?: Maybe<String_comparison_exp>;
  evidence?: Maybe<String_comparison_exp>;
  id?: Maybe<Int_comparison_exp>;
  status?: Maybe<student_request_status_enum_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  student_external_engagement_requests?: Maybe<student_external_engagement_request_bool_exp>;
  student_general_requests?: Maybe<student_general_request_bool_exp>;
  student_medical_requests?: Maybe<student_medical_request_bool_exp>;
  student_request_messages?: Maybe<student_request_message_bool_exp>;
  student_request_requestees?: Maybe<student_request_requestee_bool_exp>;
  student_request_status?: Maybe<student_request_status_bool_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "student_request" */
export enum student_request_constraint {
  /** unique or primary key constraint */
  student_request_id_key = 'student_request_id_key',
  /** unique or primary key constraint */
  student_request_pkey = 'student_request_pkey',
}

/** input type for incrementing numeric columns in table "student_request" */
export type student_request_inc_input = {
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_request" */
export type student_request_insert_input = {
  approvedOn?: Maybe<Scalars['timestamptz']>;
  approvedUserId?: Maybe<Scalars['uuid']>;
  approved_user?: Maybe<user_obj_rel_insert_input>;
  approved_user_public?: Maybe<user_public_obj_rel_insert_input>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  evidence?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<student_request_status_enum>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  student_external_engagement_requests?: Maybe<student_external_engagement_request_arr_rel_insert_input>;
  student_general_requests?: Maybe<student_general_request_arr_rel_insert_input>;
  student_medical_requests?: Maybe<student_medical_request_arr_rel_insert_input>;
  student_request_messages?: Maybe<student_request_message_arr_rel_insert_input>;
  student_request_requestees?: Maybe<student_request_requestee_arr_rel_insert_input>;
  student_request_status?: Maybe<student_request_status_obj_rel_insert_input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type student_request_max_fields = {
  __typename?: 'student_request_max_fields';
  approvedOn?: Maybe<Scalars['timestamptz']>;
  approvedUserId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  evidence?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "student_request" */
export type student_request_max_order_by = {
  approvedOn?: Maybe<order_by>;
  approvedUserId?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  description?: Maybe<order_by>;
  evidence?: Maybe<order_by>;
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** columns and relationships of "student_request_message" */
export type student_request_message = {
  __typename?: 'student_request_message';
  content: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  student?: Maybe<student>;
  studentId?: Maybe<Scalars['Int']>;
  studentRequestId: Scalars['Int'];
  /** An object relationship */
  student_request?: Maybe<student_request>;
  /** An object relationship */
  user?: Maybe<user>;
  userId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  user_public?: Maybe<user_public>;
};

/** aggregated selection of "student_request_message" */
export type student_request_message_aggregate = {
  __typename?: 'student_request_message_aggregate';
  aggregate?: Maybe<student_request_message_aggregate_fields>;
  nodes: Array<student_request_message>;
};

/** aggregate fields of "student_request_message" */
export type student_request_message_aggregate_fields = {
  __typename?: 'student_request_message_aggregate_fields';
  avg?: Maybe<student_request_message_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_request_message_max_fields>;
  min?: Maybe<student_request_message_min_fields>;
  stddev?: Maybe<student_request_message_stddev_fields>;
  stddev_pop?: Maybe<student_request_message_stddev_pop_fields>;
  stddev_samp?: Maybe<student_request_message_stddev_samp_fields>;
  sum?: Maybe<student_request_message_sum_fields>;
  var_pop?: Maybe<student_request_message_var_pop_fields>;
  var_samp?: Maybe<student_request_message_var_samp_fields>;
  variance?: Maybe<student_request_message_variance_fields>;
};

/** aggregate fields of "student_request_message" */
export type student_request_message_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_request_message_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_request_message" */
export type student_request_message_aggregate_order_by = {
  avg?: Maybe<student_request_message_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_request_message_max_order_by>;
  min?: Maybe<student_request_message_min_order_by>;
  stddev?: Maybe<student_request_message_stddev_order_by>;
  stddev_pop?: Maybe<student_request_message_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_request_message_stddev_samp_order_by>;
  sum?: Maybe<student_request_message_sum_order_by>;
  var_pop?: Maybe<student_request_message_var_pop_order_by>;
  var_samp?: Maybe<student_request_message_var_samp_order_by>;
  variance?: Maybe<student_request_message_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_request_message" */
export type student_request_message_arr_rel_insert_input = {
  data: Array<student_request_message_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_request_message_on_conflict>;
};

/** aggregate avg on columns */
export type student_request_message_avg_fields = {
  __typename?: 'student_request_message_avg_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_request_message" */
export type student_request_message_avg_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_request_message". All fields are combined with a logical 'AND'. */
export type student_request_message_bool_exp = {
  _and?: Maybe<Array<student_request_message_bool_exp>>;
  _not?: Maybe<student_request_message_bool_exp>;
  _or?: Maybe<Array<student_request_message_bool_exp>>;
  content?: Maybe<String_comparison_exp>;
  id?: Maybe<Int_comparison_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  studentRequestId?: Maybe<Int_comparison_exp>;
  student_request?: Maybe<student_request_bool_exp>;
  user?: Maybe<user_bool_exp>;
  userId?: Maybe<uuid_comparison_exp>;
  user_public?: Maybe<user_public_bool_exp>;
};

/** unique or primary key constraints on table "student_request_message" */
export enum student_request_message_constraint {
  /** unique or primary key constraint */
  request_message_pkey = 'request_message_pkey',
}

/** input type for incrementing numeric columns in table "student_request_message" */
export type student_request_message_inc_input = {
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_request_message" */
export type student_request_message_insert_input = {
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  student_request?: Maybe<student_request_obj_rel_insert_input>;
  user?: Maybe<user_obj_rel_insert_input>;
  userId?: Maybe<Scalars['uuid']>;
  user_public?: Maybe<user_public_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type student_request_message_max_fields = {
  __typename?: 'student_request_message_max_fields';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "student_request_message" */
export type student_request_message_max_order_by = {
  content?: Maybe<order_by>;
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_request_message_min_fields = {
  __typename?: 'student_request_message_min_fields';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "student_request_message" */
export type student_request_message_min_order_by = {
  content?: Maybe<order_by>;
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** response of any mutation on the table "student_request_message" */
export type student_request_message_mutation_response = {
  __typename?: 'student_request_message_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_request_message>;
};

/** on conflict condition type for table "student_request_message" */
export type student_request_message_on_conflict = {
  constraint: student_request_message_constraint;
  update_columns?: Array<student_request_message_update_column>;
  where?: Maybe<student_request_message_bool_exp>;
};

/** Ordering options when selecting data from "student_request_message". */
export type student_request_message_order_by = {
  content?: Maybe<order_by>;
  id?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  student_request?: Maybe<student_request_order_by>;
  user?: Maybe<user_order_by>;
  userId?: Maybe<order_by>;
  user_public?: Maybe<user_public_order_by>;
};

/** primary key columns input for table: student_request_message */
export type student_request_message_pk_columns_input = {
  id: Scalars['Int'];
};

/** select columns of table "student_request_message" */
export enum student_request_message_select_column {
  /** column name */
  content = 'content',
  /** column name */
  id = 'id',
  /** column name */
  studentId = 'studentId',
  /** column name */
  studentRequestId = 'studentRequestId',
  /** column name */
  userId = 'userId',
}

/** input type for updating data in table "student_request_message" */
export type student_request_message_set_input = {
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type student_request_message_stddev_fields = {
  __typename?: 'student_request_message_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_request_message" */
export type student_request_message_stddev_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_request_message_stddev_pop_fields = {
  __typename?: 'student_request_message_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_request_message" */
export type student_request_message_stddev_pop_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_request_message_stddev_samp_fields = {
  __typename?: 'student_request_message_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_request_message" */
export type student_request_message_stddev_samp_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_request_message_sum_fields = {
  __typename?: 'student_request_message_sum_fields';
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_request_message" */
export type student_request_message_sum_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** update columns of table "student_request_message" */
export enum student_request_message_update_column {
  /** column name */
  content = 'content',
  /** column name */
  id = 'id',
  /** column name */
  studentId = 'studentId',
  /** column name */
  studentRequestId = 'studentRequestId',
  /** column name */
  userId = 'userId',
}

/** aggregate var_pop on columns */
export type student_request_message_var_pop_fields = {
  __typename?: 'student_request_message_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_request_message" */
export type student_request_message_var_pop_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_request_message_var_samp_fields = {
  __typename?: 'student_request_message_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_request_message" */
export type student_request_message_var_samp_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_request_message_variance_fields = {
  __typename?: 'student_request_message_variance_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_request_message" */
export type student_request_message_variance_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_request_min_fields = {
  __typename?: 'student_request_min_fields';
  approvedOn?: Maybe<Scalars['timestamptz']>;
  approvedUserId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  evidence?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "student_request" */
export type student_request_min_order_by = {
  approvedOn?: Maybe<order_by>;
  approvedUserId?: Maybe<order_by>;
  created_at?: Maybe<order_by>;
  description?: Maybe<order_by>;
  evidence?: Maybe<order_by>;
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
};

/** response of any mutation on the table "student_request" */
export type student_request_mutation_response = {
  __typename?: 'student_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_request>;
};

/** input type for inserting object relation for remote table "student_request" */
export type student_request_obj_rel_insert_input = {
  data: student_request_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<student_request_on_conflict>;
};

/** on conflict condition type for table "student_request" */
export type student_request_on_conflict = {
  constraint: student_request_constraint;
  update_columns?: Array<student_request_update_column>;
  where?: Maybe<student_request_bool_exp>;
};

/** Ordering options when selecting data from "student_request". */
export type student_request_order_by = {
  approvedOn?: Maybe<order_by>;
  approvedUserId?: Maybe<order_by>;
  approved_user?: Maybe<user_order_by>;
  approved_user_public?: Maybe<user_public_order_by>;
  created_at?: Maybe<order_by>;
  description?: Maybe<order_by>;
  evidence?: Maybe<order_by>;
  id?: Maybe<order_by>;
  status?: Maybe<order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  student_external_engagement_requests_aggregate?: Maybe<student_external_engagement_request_aggregate_order_by>;
  student_general_requests_aggregate?: Maybe<student_general_request_aggregate_order_by>;
  student_medical_requests_aggregate?: Maybe<student_medical_request_aggregate_order_by>;
  student_request_messages_aggregate?: Maybe<student_request_message_aggregate_order_by>;
  student_request_requestees_aggregate?: Maybe<student_request_requestee_aggregate_order_by>;
  student_request_status?: Maybe<student_request_status_order_by>;
  updated_at?: Maybe<order_by>;
};

/** primary key columns input for table: student_request */
export type student_request_pk_columns_input = {
  id: Scalars['Int'];
};

/** columns and relationships of "student_request_requestee" */
export type student_request_requestee = {
  __typename?: 'student_request_requestee';
  id: Scalars['uuid'];
  studentRequestId: Scalars['Int'];
  /** An object relationship */
  student_request?: Maybe<student_request>;
  /** An object relationship */
  user: user;
  userId: Scalars['uuid'];
  /** An object relationship */
  user_public?: Maybe<user_public>;
};

/** aggregated selection of "student_request_requestee" */
export type student_request_requestee_aggregate = {
  __typename?: 'student_request_requestee_aggregate';
  aggregate?: Maybe<student_request_requestee_aggregate_fields>;
  nodes: Array<student_request_requestee>;
};

/** aggregate fields of "student_request_requestee" */
export type student_request_requestee_aggregate_fields = {
  __typename?: 'student_request_requestee_aggregate_fields';
  avg?: Maybe<student_request_requestee_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_request_requestee_max_fields>;
  min?: Maybe<student_request_requestee_min_fields>;
  stddev?: Maybe<student_request_requestee_stddev_fields>;
  stddev_pop?: Maybe<student_request_requestee_stddev_pop_fields>;
  stddev_samp?: Maybe<student_request_requestee_stddev_samp_fields>;
  sum?: Maybe<student_request_requestee_sum_fields>;
  var_pop?: Maybe<student_request_requestee_var_pop_fields>;
  var_samp?: Maybe<student_request_requestee_var_samp_fields>;
  variance?: Maybe<student_request_requestee_variance_fields>;
};

/** aggregate fields of "student_request_requestee" */
export type student_request_requestee_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_request_requestee_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_request_requestee" */
export type student_request_requestee_aggregate_order_by = {
  avg?: Maybe<student_request_requestee_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_request_requestee_max_order_by>;
  min?: Maybe<student_request_requestee_min_order_by>;
  stddev?: Maybe<student_request_requestee_stddev_order_by>;
  stddev_pop?: Maybe<student_request_requestee_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_request_requestee_stddev_samp_order_by>;
  sum?: Maybe<student_request_requestee_sum_order_by>;
  var_pop?: Maybe<student_request_requestee_var_pop_order_by>;
  var_samp?: Maybe<student_request_requestee_var_samp_order_by>;
  variance?: Maybe<student_request_requestee_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_request_requestee" */
export type student_request_requestee_arr_rel_insert_input = {
  data: Array<student_request_requestee_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_request_requestee_on_conflict>;
};

/** aggregate avg on columns */
export type student_request_requestee_avg_fields = {
  __typename?: 'student_request_requestee_avg_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_request_requestee" */
export type student_request_requestee_avg_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_request_requestee". All fields are combined with a logical 'AND'. */
export type student_request_requestee_bool_exp = {
  _and?: Maybe<Array<student_request_requestee_bool_exp>>;
  _not?: Maybe<student_request_requestee_bool_exp>;
  _or?: Maybe<Array<student_request_requestee_bool_exp>>;
  id?: Maybe<uuid_comparison_exp>;
  studentRequestId?: Maybe<Int_comparison_exp>;
  student_request?: Maybe<student_request_bool_exp>;
  user?: Maybe<user_bool_exp>;
  userId?: Maybe<uuid_comparison_exp>;
  user_public?: Maybe<user_public_bool_exp>;
};

/** unique or primary key constraints on table "student_request_requestee" */
export enum student_request_requestee_constraint {
  /** unique or primary key constraint */
  student_request_requestee_pkey = 'student_request_requestee_pkey',
  /** unique or primary key constraint */
  student_request_requestee_userId_studentRequestId_key = 'student_request_requestee_userId_studentRequestId_key',
}

/** input type for incrementing numeric columns in table "student_request_requestee" */
export type student_request_requestee_inc_input = {
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_request_requestee" */
export type student_request_requestee_insert_input = {
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  student_request?: Maybe<student_request_obj_rel_insert_input>;
  user?: Maybe<user_obj_rel_insert_input>;
  userId?: Maybe<Scalars['uuid']>;
  user_public?: Maybe<user_public_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type student_request_requestee_max_fields = {
  __typename?: 'student_request_requestee_max_fields';
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "student_request_requestee" */
export type student_request_requestee_max_order_by = {
  id?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_request_requestee_min_fields = {
  __typename?: 'student_request_requestee_min_fields';
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "student_request_requestee" */
export type student_request_requestee_min_order_by = {
  id?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** response of any mutation on the table "student_request_requestee" */
export type student_request_requestee_mutation_response = {
  __typename?: 'student_request_requestee_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_request_requestee>;
};

/** on conflict condition type for table "student_request_requestee" */
export type student_request_requestee_on_conflict = {
  constraint: student_request_requestee_constraint;
  update_columns?: Array<student_request_requestee_update_column>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

/** Ordering options when selecting data from "student_request_requestee". */
export type student_request_requestee_order_by = {
  id?: Maybe<order_by>;
  studentRequestId?: Maybe<order_by>;
  student_request?: Maybe<student_request_order_by>;
  user?: Maybe<user_order_by>;
  userId?: Maybe<order_by>;
  user_public?: Maybe<user_public_order_by>;
};

/** primary key columns input for table: student_request_requestee */
export type student_request_requestee_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_request_requestee" */
export enum student_request_requestee_select_column {
  /** column name */
  id = 'id',
  /** column name */
  studentRequestId = 'studentRequestId',
  /** column name */
  userId = 'userId',
}

/** input type for updating data in table "student_request_requestee" */
export type student_request_requestee_set_input = {
  id?: Maybe<Scalars['uuid']>;
  studentRequestId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type student_request_requestee_stddev_fields = {
  __typename?: 'student_request_requestee_stddev_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_request_requestee" */
export type student_request_requestee_stddev_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_request_requestee_stddev_pop_fields = {
  __typename?: 'student_request_requestee_stddev_pop_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_request_requestee" */
export type student_request_requestee_stddev_pop_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_request_requestee_stddev_samp_fields = {
  __typename?: 'student_request_requestee_stddev_samp_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_request_requestee" */
export type student_request_requestee_stddev_samp_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_request_requestee_sum_fields = {
  __typename?: 'student_request_requestee_sum_fields';
  studentRequestId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_request_requestee" */
export type student_request_requestee_sum_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** update columns of table "student_request_requestee" */
export enum student_request_requestee_update_column {
  /** column name */
  id = 'id',
  /** column name */
  studentRequestId = 'studentRequestId',
  /** column name */
  userId = 'userId',
}

/** aggregate var_pop on columns */
export type student_request_requestee_var_pop_fields = {
  __typename?: 'student_request_requestee_var_pop_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_request_requestee" */
export type student_request_requestee_var_pop_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_request_requestee_var_samp_fields = {
  __typename?: 'student_request_requestee_var_samp_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_request_requestee" */
export type student_request_requestee_var_samp_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_request_requestee_variance_fields = {
  __typename?: 'student_request_requestee_variance_fields';
  studentRequestId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_request_requestee" */
export type student_request_requestee_variance_order_by = {
  studentRequestId?: Maybe<order_by>;
};

/** select columns of table "student_request" */
export enum student_request_select_column {
  /** column name */
  approvedOn = 'approvedOn',
  /** column name */
  approvedUserId = 'approvedUserId',
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  evidence = 'evidence',
  /** column name */
  id = 'id',
  /** column name */
  status = 'status',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updated_at = 'updated_at',
}

/** input type for updating data in table "student_request" */
export type student_request_set_input = {
  approvedOn?: Maybe<Scalars['timestamptz']>;
  approvedUserId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  evidence?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<student_request_status_enum>;
  studentId?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** columns and relationships of "student_request_status" */
export type student_request_status = {
  __typename?: 'student_request_status';
  name: Scalars['String'];
  /** An array relationship */
  student_requests: Array<student_request>;
  /** An aggregate relationship */
  student_requests_aggregate: student_request_aggregate;
};

/** columns and relationships of "student_request_status" */
export type student_request_statusstudent_requestsArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** columns and relationships of "student_request_status" */
export type student_request_statusstudent_requests_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** aggregated selection of "student_request_status" */
export type student_request_status_aggregate = {
  __typename?: 'student_request_status_aggregate';
  aggregate?: Maybe<student_request_status_aggregate_fields>;
  nodes: Array<student_request_status>;
};

/** aggregate fields of "student_request_status" */
export type student_request_status_aggregate_fields = {
  __typename?: 'student_request_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<student_request_status_max_fields>;
  min?: Maybe<student_request_status_min_fields>;
};

/** aggregate fields of "student_request_status" */
export type student_request_status_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_request_status_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "student_request_status". All fields are combined with a logical 'AND'. */
export type student_request_status_bool_exp = {
  _and?: Maybe<Array<student_request_status_bool_exp>>;
  _not?: Maybe<student_request_status_bool_exp>;
  _or?: Maybe<Array<student_request_status_bool_exp>>;
  name?: Maybe<String_comparison_exp>;
  student_requests?: Maybe<student_request_bool_exp>;
};

/** unique or primary key constraints on table "student_request_status" */
export enum student_request_status_constraint {
  /** unique or primary key constraint */
  student_request_status_pkey = 'student_request_status_pkey',
}

export enum student_request_status_enum {
  approved = 'approved',
  notApproved = 'notApproved',
  pending = 'pending',
}

/** Boolean expression to compare columns of type "student_request_status_enum". All fields are combined with logical 'AND'. */
export type student_request_status_enum_comparison_exp = {
  _eq?: Maybe<student_request_status_enum>;
  _in?: Maybe<Array<student_request_status_enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<student_request_status_enum>;
  _nin?: Maybe<Array<student_request_status_enum>>;
};

/** input type for inserting data into table "student_request_status" */
export type student_request_status_insert_input = {
  name?: Maybe<Scalars['String']>;
  student_requests?: Maybe<student_request_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type student_request_status_max_fields = {
  __typename?: 'student_request_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type student_request_status_min_fields = {
  __typename?: 'student_request_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "student_request_status" */
export type student_request_status_mutation_response = {
  __typename?: 'student_request_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_request_status>;
};

/** input type for inserting object relation for remote table "student_request_status" */
export type student_request_status_obj_rel_insert_input = {
  data: student_request_status_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<student_request_status_on_conflict>;
};

/** on conflict condition type for table "student_request_status" */
export type student_request_status_on_conflict = {
  constraint: student_request_status_constraint;
  update_columns?: Array<student_request_status_update_column>;
  where?: Maybe<student_request_status_bool_exp>;
};

/** Ordering options when selecting data from "student_request_status". */
export type student_request_status_order_by = {
  name?: Maybe<order_by>;
  student_requests_aggregate?: Maybe<student_request_aggregate_order_by>;
};

/** primary key columns input for table: student_request_status */
export type student_request_status_pk_columns_input = {
  name: Scalars['String'];
};

/** select columns of table "student_request_status" */
export enum student_request_status_select_column {
  /** column name */
  name = 'name',
}

/** input type for updating data in table "student_request_status" */
export type student_request_status_set_input = {
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "student_request_status" */
export enum student_request_status_update_column {
  /** column name */
  name = 'name',
}

/** aggregate stddev on columns */
export type student_request_stddev_fields = {
  __typename?: 'student_request_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_request" */
export type student_request_stddev_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_request_stddev_pop_fields = {
  __typename?: 'student_request_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_request" */
export type student_request_stddev_pop_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_request_stddev_samp_fields = {
  __typename?: 'student_request_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_request" */
export type student_request_stddev_samp_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_request_sum_fields = {
  __typename?: 'student_request_sum_fields';
  id?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_request" */
export type student_request_sum_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** update columns of table "student_request" */
export enum student_request_update_column {
  /** column name */
  approvedOn = 'approvedOn',
  /** column name */
  approvedUserId = 'approvedUserId',
  /** column name */
  created_at = 'created_at',
  /** column name */
  description = 'description',
  /** column name */
  evidence = 'evidence',
  /** column name */
  id = 'id',
  /** column name */
  status = 'status',
  /** column name */
  studentId = 'studentId',
  /** column name */
  updated_at = 'updated_at',
}

/** aggregate var_pop on columns */
export type student_request_var_pop_fields = {
  __typename?: 'student_request_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_request" */
export type student_request_var_pop_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_request_var_samp_fields = {
  __typename?: 'student_request_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_request" */
export type student_request_var_samp_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_request_variance_fields = {
  __typename?: 'student_request_variance_fields';
  id?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_request" */
export type student_request_variance_order_by = {
  id?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** columns and relationships of "student_result" */
export type student_result = {
  __typename?: 'student_result';
  /** An object relationship */
  assessment?: Maybe<assessment>;
  assessmentId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  batch_subject_extra_slot?: Maybe<batch_subject_extra_slot>;
  firstAttemptMarks?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  isFirstAttemptNYC: Scalars['Boolean'];
  isSecondAttemptNYC: Scalars['Boolean'];
  isThirdAttemptNYC: Scalars['Boolean'];
  secondAttemptMarks?: Maybe<Scalars['Int']>;
  studentResultSheedId: Scalars['uuid'];
  /** An object relationship */
  student_result_sheet: student_result_sheet;
  thirdAttemptMarks?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "student_result" */
export type student_result_aggregate = {
  __typename?: 'student_result_aggregate';
  aggregate?: Maybe<student_result_aggregate_fields>;
  nodes: Array<student_result>;
};

/** aggregate fields of "student_result" */
export type student_result_aggregate_fields = {
  __typename?: 'student_result_aggregate_fields';
  avg?: Maybe<student_result_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_result_max_fields>;
  min?: Maybe<student_result_min_fields>;
  stddev?: Maybe<student_result_stddev_fields>;
  stddev_pop?: Maybe<student_result_stddev_pop_fields>;
  stddev_samp?: Maybe<student_result_stddev_samp_fields>;
  sum?: Maybe<student_result_sum_fields>;
  var_pop?: Maybe<student_result_var_pop_fields>;
  var_samp?: Maybe<student_result_var_samp_fields>;
  variance?: Maybe<student_result_variance_fields>;
};

/** aggregate fields of "student_result" */
export type student_result_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_result_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_result" */
export type student_result_aggregate_order_by = {
  avg?: Maybe<student_result_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_result_max_order_by>;
  min?: Maybe<student_result_min_order_by>;
  stddev?: Maybe<student_result_stddev_order_by>;
  stddev_pop?: Maybe<student_result_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_result_stddev_samp_order_by>;
  sum?: Maybe<student_result_sum_order_by>;
  var_pop?: Maybe<student_result_var_pop_order_by>;
  var_samp?: Maybe<student_result_var_samp_order_by>;
  variance?: Maybe<student_result_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_result" */
export type student_result_arr_rel_insert_input = {
  data: Array<student_result_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_result_on_conflict>;
};

/** aggregate avg on columns */
export type student_result_avg_fields = {
  __typename?: 'student_result_avg_fields';
  firstAttemptMarks?: Maybe<Scalars['Float']>;
  secondAttemptMarks?: Maybe<Scalars['Float']>;
  thirdAttemptMarks?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_result" */
export type student_result_avg_order_by = {
  firstAttemptMarks?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_result". All fields are combined with a logical 'AND'. */
export type student_result_bool_exp = {
  _and?: Maybe<Array<student_result_bool_exp>>;
  _not?: Maybe<student_result_bool_exp>;
  _or?: Maybe<Array<student_result_bool_exp>>;
  assessment?: Maybe<assessment_bool_exp>;
  assessmentId?: Maybe<uuid_comparison_exp>;
  batchSubjectExtraSlotId?: Maybe<uuid_comparison_exp>;
  batch_subject_extra_slot?: Maybe<batch_subject_extra_slot_bool_exp>;
  firstAttemptMarks?: Maybe<Int_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  isFirstAttemptNYC?: Maybe<Boolean_comparison_exp>;
  isSecondAttemptNYC?: Maybe<Boolean_comparison_exp>;
  isThirdAttemptNYC?: Maybe<Boolean_comparison_exp>;
  secondAttemptMarks?: Maybe<Int_comparison_exp>;
  studentResultSheedId?: Maybe<uuid_comparison_exp>;
  student_result_sheet?: Maybe<student_result_sheet_bool_exp>;
  thirdAttemptMarks?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "student_result" */
export enum student_result_constraint {
  /** unique or primary key constraint */
  student_result_assessmentId_studentResultSheedId_key = 'student_result_assessmentId_studentResultSheedId_key',
  /** unique or primary key constraint */
  student_result_batchSubjectExtraSlotId_studentResultSheedId_key = 'student_result_batchSubjectExtraSlotId_studentResultSheedId_key',
  /** unique or primary key constraint */
  student_result_pkey = 'student_result_pkey',
}

/** input type for incrementing numeric columns in table "student_result" */
export type student_result_inc_input = {
  firstAttemptMarks?: Maybe<Scalars['Int']>;
  secondAttemptMarks?: Maybe<Scalars['Int']>;
  thirdAttemptMarks?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_result" */
export type student_result_insert_input = {
  assessment?: Maybe<assessment_obj_rel_insert_input>;
  assessmentId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  batch_subject_extra_slot?: Maybe<batch_subject_extra_slot_obj_rel_insert_input>;
  firstAttemptMarks?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  isFirstAttemptNYC?: Maybe<Scalars['Boolean']>;
  isSecondAttemptNYC?: Maybe<Scalars['Boolean']>;
  isThirdAttemptNYC?: Maybe<Scalars['Boolean']>;
  secondAttemptMarks?: Maybe<Scalars['Int']>;
  studentResultSheedId?: Maybe<Scalars['uuid']>;
  student_result_sheet?: Maybe<student_result_sheet_obj_rel_insert_input>;
  thirdAttemptMarks?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type student_result_max_fields = {
  __typename?: 'student_result_max_fields';
  assessmentId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  firstAttemptMarks?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  secondAttemptMarks?: Maybe<Scalars['Int']>;
  studentResultSheedId?: Maybe<Scalars['uuid']>;
  thirdAttemptMarks?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "student_result" */
export type student_result_max_order_by = {
  assessmentId?: Maybe<order_by>;
  batchSubjectExtraSlotId?: Maybe<order_by>;
  firstAttemptMarks?: Maybe<order_by>;
  id?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  studentResultSheedId?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_result_min_fields = {
  __typename?: 'student_result_min_fields';
  assessmentId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  firstAttemptMarks?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  secondAttemptMarks?: Maybe<Scalars['Int']>;
  studentResultSheedId?: Maybe<Scalars['uuid']>;
  thirdAttemptMarks?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "student_result" */
export type student_result_min_order_by = {
  assessmentId?: Maybe<order_by>;
  batchSubjectExtraSlotId?: Maybe<order_by>;
  firstAttemptMarks?: Maybe<order_by>;
  id?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  studentResultSheedId?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** response of any mutation on the table "student_result" */
export type student_result_mutation_response = {
  __typename?: 'student_result_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_result>;
};

/** on conflict condition type for table "student_result" */
export type student_result_on_conflict = {
  constraint: student_result_constraint;
  update_columns?: Array<student_result_update_column>;
  where?: Maybe<student_result_bool_exp>;
};

/** Ordering options when selecting data from "student_result". */
export type student_result_order_by = {
  assessment?: Maybe<assessment_order_by>;
  assessmentId?: Maybe<order_by>;
  batchSubjectExtraSlotId?: Maybe<order_by>;
  batch_subject_extra_slot?: Maybe<batch_subject_extra_slot_order_by>;
  firstAttemptMarks?: Maybe<order_by>;
  id?: Maybe<order_by>;
  isFirstAttemptNYC?: Maybe<order_by>;
  isSecondAttemptNYC?: Maybe<order_by>;
  isThirdAttemptNYC?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  studentResultSheedId?: Maybe<order_by>;
  student_result_sheet?: Maybe<student_result_sheet_order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** primary key columns input for table: student_result */
export type student_result_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_result" */
export enum student_result_select_column {
  /** column name */
  assessmentId = 'assessmentId',
  /** column name */
  batchSubjectExtraSlotId = 'batchSubjectExtraSlotId',
  /** column name */
  firstAttemptMarks = 'firstAttemptMarks',
  /** column name */
  id = 'id',
  /** column name */
  isFirstAttemptNYC = 'isFirstAttemptNYC',
  /** column name */
  isSecondAttemptNYC = 'isSecondAttemptNYC',
  /** column name */
  isThirdAttemptNYC = 'isThirdAttemptNYC',
  /** column name */
  secondAttemptMarks = 'secondAttemptMarks',
  /** column name */
  studentResultSheedId = 'studentResultSheedId',
  /** column name */
  thirdAttemptMarks = 'thirdAttemptMarks',
}

/** input type for updating data in table "student_result" */
export type student_result_set_input = {
  assessmentId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  firstAttemptMarks?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  isFirstAttemptNYC?: Maybe<Scalars['Boolean']>;
  isSecondAttemptNYC?: Maybe<Scalars['Boolean']>;
  isThirdAttemptNYC?: Maybe<Scalars['Boolean']>;
  secondAttemptMarks?: Maybe<Scalars['Int']>;
  studentResultSheedId?: Maybe<Scalars['uuid']>;
  thirdAttemptMarks?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "student_result_sheet" */
export type student_result_sheet = {
  __typename?: 'student_result_sheet';
  customMarks?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  remark?: Maybe<Scalars['String']>;
  resultSheetId: Scalars['uuid'];
  /** An object relationship */
  result_sheet: result_sheet;
  /** An object relationship */
  student: student;
  studentId: Scalars['Int'];
  /** An array relationship */
  student_results: Array<student_result>;
  /** An aggregate relationship */
  student_results_aggregate: student_result_aggregate;
};

/** columns and relationships of "student_result_sheet" */
export type student_result_sheetstudent_resultsArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

/** columns and relationships of "student_result_sheet" */
export type student_result_sheetstudent_results_aggregateArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

/** aggregated selection of "student_result_sheet" */
export type student_result_sheet_aggregate = {
  __typename?: 'student_result_sheet_aggregate';
  aggregate?: Maybe<student_result_sheet_aggregate_fields>;
  nodes: Array<student_result_sheet>;
};

/** aggregate fields of "student_result_sheet" */
export type student_result_sheet_aggregate_fields = {
  __typename?: 'student_result_sheet_aggregate_fields';
  avg?: Maybe<student_result_sheet_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_result_sheet_max_fields>;
  min?: Maybe<student_result_sheet_min_fields>;
  stddev?: Maybe<student_result_sheet_stddev_fields>;
  stddev_pop?: Maybe<student_result_sheet_stddev_pop_fields>;
  stddev_samp?: Maybe<student_result_sheet_stddev_samp_fields>;
  sum?: Maybe<student_result_sheet_sum_fields>;
  var_pop?: Maybe<student_result_sheet_var_pop_fields>;
  var_samp?: Maybe<student_result_sheet_var_samp_fields>;
  variance?: Maybe<student_result_sheet_variance_fields>;
};

/** aggregate fields of "student_result_sheet" */
export type student_result_sheet_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_result_sheet_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "student_result_sheet" */
export type student_result_sheet_aggregate_order_by = {
  avg?: Maybe<student_result_sheet_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<student_result_sheet_max_order_by>;
  min?: Maybe<student_result_sheet_min_order_by>;
  stddev?: Maybe<student_result_sheet_stddev_order_by>;
  stddev_pop?: Maybe<student_result_sheet_stddev_pop_order_by>;
  stddev_samp?: Maybe<student_result_sheet_stddev_samp_order_by>;
  sum?: Maybe<student_result_sheet_sum_order_by>;
  var_pop?: Maybe<student_result_sheet_var_pop_order_by>;
  var_samp?: Maybe<student_result_sheet_var_samp_order_by>;
  variance?: Maybe<student_result_sheet_variance_order_by>;
};

/** input type for inserting array relation for remote table "student_result_sheet" */
export type student_result_sheet_arr_rel_insert_input = {
  data: Array<student_result_sheet_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<student_result_sheet_on_conflict>;
};

/** aggregate avg on columns */
export type student_result_sheet_avg_fields = {
  __typename?: 'student_result_sheet_avg_fields';
  customMarks?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "student_result_sheet" */
export type student_result_sheet_avg_order_by = {
  customMarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "student_result_sheet". All fields are combined with a logical 'AND'. */
export type student_result_sheet_bool_exp = {
  _and?: Maybe<Array<student_result_sheet_bool_exp>>;
  _not?: Maybe<student_result_sheet_bool_exp>;
  _or?: Maybe<Array<student_result_sheet_bool_exp>>;
  customMarks?: Maybe<Int_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  remark?: Maybe<String_comparison_exp>;
  resultSheetId?: Maybe<uuid_comparison_exp>;
  result_sheet?: Maybe<result_sheet_bool_exp>;
  student?: Maybe<student_bool_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  student_results?: Maybe<student_result_bool_exp>;
};

/** unique or primary key constraints on table "student_result_sheet" */
export enum student_result_sheet_constraint {
  /** unique or primary key constraint */
  student_result_sheet_pkey = 'student_result_sheet_pkey',
  /** unique or primary key constraint */
  student_result_sheet_studentId_resultSheetId_key = 'student_result_sheet_studentId_resultSheetId_key',
}

/** input type for incrementing numeric columns in table "student_result_sheet" */
export type student_result_sheet_inc_input = {
  customMarks?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_result_sheet" */
export type student_result_sheet_insert_input = {
  customMarks?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  remark?: Maybe<Scalars['String']>;
  resultSheetId?: Maybe<Scalars['uuid']>;
  result_sheet?: Maybe<result_sheet_obj_rel_insert_input>;
  student?: Maybe<student_obj_rel_insert_input>;
  studentId?: Maybe<Scalars['Int']>;
  student_results?: Maybe<student_result_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type student_result_sheet_max_fields = {
  __typename?: 'student_result_sheet_max_fields';
  customMarks?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  remark?: Maybe<Scalars['String']>;
  resultSheetId?: Maybe<Scalars['uuid']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "student_result_sheet" */
export type student_result_sheet_max_order_by = {
  customMarks?: Maybe<order_by>;
  id?: Maybe<order_by>;
  remark?: Maybe<order_by>;
  resultSheetId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type student_result_sheet_min_fields = {
  __typename?: 'student_result_sheet_min_fields';
  customMarks?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  remark?: Maybe<Scalars['String']>;
  resultSheetId?: Maybe<Scalars['uuid']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "student_result_sheet" */
export type student_result_sheet_min_order_by = {
  customMarks?: Maybe<order_by>;
  id?: Maybe<order_by>;
  remark?: Maybe<order_by>;
  resultSheetId?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** response of any mutation on the table "student_result_sheet" */
export type student_result_sheet_mutation_response = {
  __typename?: 'student_result_sheet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_result_sheet>;
};

/** input type for inserting object relation for remote table "student_result_sheet" */
export type student_result_sheet_obj_rel_insert_input = {
  data: student_result_sheet_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<student_result_sheet_on_conflict>;
};

/** on conflict condition type for table "student_result_sheet" */
export type student_result_sheet_on_conflict = {
  constraint: student_result_sheet_constraint;
  update_columns?: Array<student_result_sheet_update_column>;
  where?: Maybe<student_result_sheet_bool_exp>;
};

/** Ordering options when selecting data from "student_result_sheet". */
export type student_result_sheet_order_by = {
  customMarks?: Maybe<order_by>;
  id?: Maybe<order_by>;
  remark?: Maybe<order_by>;
  resultSheetId?: Maybe<order_by>;
  result_sheet?: Maybe<result_sheet_order_by>;
  student?: Maybe<student_order_by>;
  studentId?: Maybe<order_by>;
  student_results_aggregate?: Maybe<student_result_aggregate_order_by>;
};

/** primary key columns input for table: student_result_sheet */
export type student_result_sheet_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "student_result_sheet" */
export enum student_result_sheet_select_column {
  /** column name */
  customMarks = 'customMarks',
  /** column name */
  id = 'id',
  /** column name */
  remark = 'remark',
  /** column name */
  resultSheetId = 'resultSheetId',
  /** column name */
  studentId = 'studentId',
}

/** input type for updating data in table "student_result_sheet" */
export type student_result_sheet_set_input = {
  customMarks?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  remark?: Maybe<Scalars['String']>;
  resultSheetId?: Maybe<Scalars['uuid']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type student_result_sheet_stddev_fields = {
  __typename?: 'student_result_sheet_stddev_fields';
  customMarks?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_result_sheet" */
export type student_result_sheet_stddev_order_by = {
  customMarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_result_sheet_stddev_pop_fields = {
  __typename?: 'student_result_sheet_stddev_pop_fields';
  customMarks?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_result_sheet" */
export type student_result_sheet_stddev_pop_order_by = {
  customMarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_result_sheet_stddev_samp_fields = {
  __typename?: 'student_result_sheet_stddev_samp_fields';
  customMarks?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_result_sheet" */
export type student_result_sheet_stddev_samp_order_by = {
  customMarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_result_sheet_sum_fields = {
  __typename?: 'student_result_sheet_sum_fields';
  customMarks?: Maybe<Scalars['Int']>;
  studentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_result_sheet" */
export type student_result_sheet_sum_order_by = {
  customMarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** update columns of table "student_result_sheet" */
export enum student_result_sheet_update_column {
  /** column name */
  customMarks = 'customMarks',
  /** column name */
  id = 'id',
  /** column name */
  remark = 'remark',
  /** column name */
  resultSheetId = 'resultSheetId',
  /** column name */
  studentId = 'studentId',
}

/** aggregate var_pop on columns */
export type student_result_sheet_var_pop_fields = {
  __typename?: 'student_result_sheet_var_pop_fields';
  customMarks?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_result_sheet" */
export type student_result_sheet_var_pop_order_by = {
  customMarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_result_sheet_var_samp_fields = {
  __typename?: 'student_result_sheet_var_samp_fields';
  customMarks?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_result_sheet" */
export type student_result_sheet_var_samp_order_by = {
  customMarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_result_sheet_variance_fields = {
  __typename?: 'student_result_sheet_variance_fields';
  customMarks?: Maybe<Scalars['Float']>;
  studentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_result_sheet" */
export type student_result_sheet_variance_order_by = {
  customMarks?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
};

/** aggregate stddev on columns */
export type student_result_stddev_fields = {
  __typename?: 'student_result_stddev_fields';
  firstAttemptMarks?: Maybe<Scalars['Float']>;
  secondAttemptMarks?: Maybe<Scalars['Float']>;
  thirdAttemptMarks?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student_result" */
export type student_result_stddev_order_by = {
  firstAttemptMarks?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_result_stddev_pop_fields = {
  __typename?: 'student_result_stddev_pop_fields';
  firstAttemptMarks?: Maybe<Scalars['Float']>;
  secondAttemptMarks?: Maybe<Scalars['Float']>;
  thirdAttemptMarks?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student_result" */
export type student_result_stddev_pop_order_by = {
  firstAttemptMarks?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_result_stddev_samp_fields = {
  __typename?: 'student_result_stddev_samp_fields';
  firstAttemptMarks?: Maybe<Scalars['Float']>;
  secondAttemptMarks?: Maybe<Scalars['Float']>;
  thirdAttemptMarks?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student_result" */
export type student_result_stddev_samp_order_by = {
  firstAttemptMarks?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_result_sum_fields = {
  __typename?: 'student_result_sum_fields';
  firstAttemptMarks?: Maybe<Scalars['Int']>;
  secondAttemptMarks?: Maybe<Scalars['Int']>;
  thirdAttemptMarks?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student_result" */
export type student_result_sum_order_by = {
  firstAttemptMarks?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** update columns of table "student_result" */
export enum student_result_update_column {
  /** column name */
  assessmentId = 'assessmentId',
  /** column name */
  batchSubjectExtraSlotId = 'batchSubjectExtraSlotId',
  /** column name */
  firstAttemptMarks = 'firstAttemptMarks',
  /** column name */
  id = 'id',
  /** column name */
  isFirstAttemptNYC = 'isFirstAttemptNYC',
  /** column name */
  isSecondAttemptNYC = 'isSecondAttemptNYC',
  /** column name */
  isThirdAttemptNYC = 'isThirdAttemptNYC',
  /** column name */
  secondAttemptMarks = 'secondAttemptMarks',
  /** column name */
  studentResultSheedId = 'studentResultSheedId',
  /** column name */
  thirdAttemptMarks = 'thirdAttemptMarks',
}

/** aggregate var_pop on columns */
export type student_result_var_pop_fields = {
  __typename?: 'student_result_var_pop_fields';
  firstAttemptMarks?: Maybe<Scalars['Float']>;
  secondAttemptMarks?: Maybe<Scalars['Float']>;
  thirdAttemptMarks?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student_result" */
export type student_result_var_pop_order_by = {
  firstAttemptMarks?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_result_var_samp_fields = {
  __typename?: 'student_result_var_samp_fields';
  firstAttemptMarks?: Maybe<Scalars['Float']>;
  secondAttemptMarks?: Maybe<Scalars['Float']>;
  thirdAttemptMarks?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student_result" */
export type student_result_var_samp_order_by = {
  firstAttemptMarks?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_result_variance_fields = {
  __typename?: 'student_result_variance_fields';
  firstAttemptMarks?: Maybe<Scalars['Float']>;
  secondAttemptMarks?: Maybe<Scalars['Float']>;
  thirdAttemptMarks?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student_result" */
export type student_result_variance_order_by = {
  firstAttemptMarks?: Maybe<order_by>;
  secondAttemptMarks?: Maybe<order_by>;
  thirdAttemptMarks?: Maybe<order_by>;
};

/** select columns of table "student" */
export enum student_select_column {
  /** column name */
  agreementURLs = 'agreementURLs',
  /** column name */
  bloodType = 'bloodType',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  dateOfBirth = 'dateOfBirth',
  /** column name */
  educationalCertificatesURLs = 'educationalCertificatesURLs',
  /** column name */
  email = 'email',
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  gender = 'gender',
  /** column name */
  id = 'id',
  /** column name */
  illnessesDisabilities = 'illnessesDisabilities',
  /** column name */
  initialRegistrationFeePaid = 'initialRegistrationFeePaid',
  /** column name */
  initialTourFollowed = 'initialTourFollowed',
  /** column name */
  isContactParent = 'isContactParent',
  /** column name */
  landLineNo = 'landLineNo',
  /** column name */
  lastName = 'lastName',
  /** column name */
  middleName = 'middleName',
  /** column name */
  mobileNo = 'mobileNo',
  /** column name */
  nationality = 'nationality',
  /** column name */
  nicCopyURLs = 'nicCopyURLs',
  /** column name */
  nicNo = 'nicNo',
  /** column name */
  ordinaryLevelCertificateURLs = 'ordinaryLevelCertificateURLs',
  /** column name */
  parentOrGuardianCity = 'parentOrGuardianCity',
  /** column name */
  parentOrGuardianCountry = 'parentOrGuardianCountry',
  /** column name */
  parentOrGuardianDistrict = 'parentOrGuardianDistrict',
  /** column name */
  parentOrGuardianLandLineNo = 'parentOrGuardianLandLineNo',
  /** column name */
  parentOrGuardianMobileNo = 'parentOrGuardianMobileNo',
  /** column name */
  parentOrGuardianName = 'parentOrGuardianName',
  /** column name */
  parentOrGuardianProvince = 'parentOrGuardianProvince',
  /** column name */
  parentOrGuardianStreetAddress1 = 'parentOrGuardianStreetAddress1',
  /** column name */
  parentOrGuardianStreetAddress2 = 'parentOrGuardianStreetAddress2',
  /** column name */
  passportNo = 'passportNo',
  /** column name */
  passportOrBirthCertificateURLs = 'passportOrBirthCertificateURLs',
  /** column name */
  passportSizePhotoURLs = 'passportSizePhotoURLs',
  /** column name */
  permanentCity = 'permanentCity',
  /** column name */
  permanentCountry = 'permanentCountry',
  /** column name */
  permanentDistrict = 'permanentDistrict',
  /** column name */
  permanentProvince = 'permanentProvince',
  /** column name */
  permanentStreetAddress1 = 'permanentStreetAddress1',
  /** column name */
  permanentStreetAddress2 = 'permanentStreetAddress2',
  /** column name */
  postal_id = 'postal_id',
  /** column name */
  preferredName = 'preferredName',
  /** column name */
  profileUploadedPhotoURLs = 'profileUploadedPhotoURLs',
  /** column name */
  publishedAt = 'publishedAt',
  /** column name */
  referredVia = 'referredVia',
  /** column name */
  regNumber = 'regNumber',
  /** column name */
  remarks = 'remarks',
  /** column name */
  sameAsPermanentAddress = 'sameAsPermanentAddress',
  /** column name */
  scannedDocumentURL = 'scannedDocumentURL',
  /** column name */
  sliitID = 'sliitID',
  /** column name */
  spokenLanguages = 'spokenLanguages',
  /** column name */
  status = 'status',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  waiID = 'waiID',
  /** column name */
  whatsapp_number = 'whatsapp_number',
}

/** columns and relationships of "student_self_editable_information" */
export type student_self_editable_information = {
  __typename?: 'student_self_editable_information';
  bloodType?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  illnessesDisabilities?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
};

/** aggregated selection of "student_self_editable_information" */
export type student_self_editable_information_aggregate = {
  __typename?: 'student_self_editable_information_aggregate';
  aggregate?: Maybe<student_self_editable_information_aggregate_fields>;
  nodes: Array<student_self_editable_information>;
};

/** aggregate fields of "student_self_editable_information" */
export type student_self_editable_information_aggregate_fields = {
  __typename?: 'student_self_editable_information_aggregate_fields';
  avg?: Maybe<student_self_editable_information_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_self_editable_information_max_fields>;
  min?: Maybe<student_self_editable_information_min_fields>;
  stddev?: Maybe<student_self_editable_information_stddev_fields>;
  stddev_pop?: Maybe<student_self_editable_information_stddev_pop_fields>;
  stddev_samp?: Maybe<student_self_editable_information_stddev_samp_fields>;
  sum?: Maybe<student_self_editable_information_sum_fields>;
  var_pop?: Maybe<student_self_editable_information_var_pop_fields>;
  var_samp?: Maybe<student_self_editable_information_var_samp_fields>;
  variance?: Maybe<student_self_editable_information_variance_fields>;
};

/** aggregate fields of "student_self_editable_information" */
export type student_self_editable_information_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_self_editable_information_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type student_self_editable_information_avg_fields = {
  __typename?: 'student_self_editable_information_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "student_self_editable_information". All fields are combined with a logical 'AND'. */
export type student_self_editable_information_bool_exp = {
  _and?: Maybe<Array<student_self_editable_information_bool_exp>>;
  _not?: Maybe<student_self_editable_information_bool_exp>;
  _or?: Maybe<Array<student_self_editable_information_bool_exp>>;
  bloodType?: Maybe<String_comparison_exp>;
  firebaseUID?: Maybe<String_comparison_exp>;
  id?: Maybe<Int_comparison_exp>;
  illnessesDisabilities?: Maybe<String_comparison_exp>;
  profileUploadedPhotoURLs?: Maybe<String_comparison_exp>;
  regNumber?: Maybe<String_comparison_exp>;
};

/** input type for incrementing numeric columns in table "student_self_editable_information" */
export type student_self_editable_information_inc_input = {
  id?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "student_self_editable_information" */
export type student_self_editable_information_insert_input = {
  bloodType?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  illnessesDisabilities?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type student_self_editable_information_max_fields = {
  __typename?: 'student_self_editable_information_max_fields';
  bloodType?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  illnessesDisabilities?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type student_self_editable_information_min_fields = {
  __typename?: 'student_self_editable_information_min_fields';
  bloodType?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  illnessesDisabilities?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "student_self_editable_information" */
export type student_self_editable_information_mutation_response = {
  __typename?: 'student_self_editable_information_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_self_editable_information>;
};

/** Ordering options when selecting data from "student_self_editable_information". */
export type student_self_editable_information_order_by = {
  bloodType?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  id?: Maybe<order_by>;
  illnessesDisabilities?: Maybe<order_by>;
  profileUploadedPhotoURLs?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
};

/** select columns of table "student_self_editable_information" */
export enum student_self_editable_information_select_column {
  /** column name */
  bloodType = 'bloodType',
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  id = 'id',
  /** column name */
  illnessesDisabilities = 'illnessesDisabilities',
  /** column name */
  profileUploadedPhotoURLs = 'profileUploadedPhotoURLs',
  /** column name */
  regNumber = 'regNumber',
}

/** input type for updating data in table "student_self_editable_information" */
export type student_self_editable_information_set_input = {
  bloodType?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  illnessesDisabilities?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type student_self_editable_information_stddev_fields = {
  __typename?: 'student_self_editable_information_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type student_self_editable_information_stddev_pop_fields = {
  __typename?: 'student_self_editable_information_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type student_self_editable_information_stddev_samp_fields = {
  __typename?: 'student_self_editable_information_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type student_self_editable_information_sum_fields = {
  __typename?: 'student_self_editable_information_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type student_self_editable_information_var_pop_fields = {
  __typename?: 'student_self_editable_information_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type student_self_editable_information_var_samp_fields = {
  __typename?: 'student_self_editable_information_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type student_self_editable_information_variance_fields = {
  __typename?: 'student_self_editable_information_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** input type for updating data in table "student" */
export type student_set_input = {
  agreementURLs?: Maybe<Scalars['String']>;
  bloodType?: Maybe<blood_type_enum>;
  createdAt?: Maybe<Scalars['timestamp']>;
  dateOfBirth?: Maybe<Scalars['date']>;
  educationalCertificatesURLs?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['student_gender_enum']>;
  id?: Maybe<Scalars['Int']>;
  illnessesDisabilities?: Maybe<Scalars['String']>;
  initialRegistrationFeePaid?: Maybe<Scalars['Boolean']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  isContactParent?: Maybe<Scalars['Boolean']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['student_nationality_enum']>;
  nicCopyURLs?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  ordinaryLevelCertificateURLs?: Maybe<Scalars['String']>;
  parentOrGuardianCity?: Maybe<Scalars['String']>;
  parentOrGuardianCountry?: Maybe<Scalars['String']>;
  parentOrGuardianDistrict?: Maybe<Scalars['String']>;
  parentOrGuardianLandLineNo?: Maybe<Scalars['String']>;
  parentOrGuardianMobileNo?: Maybe<Scalars['String']>;
  parentOrGuardianName?: Maybe<Scalars['String']>;
  parentOrGuardianProvince?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress1?: Maybe<Scalars['String']>;
  parentOrGuardianStreetAddress2?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  passportOrBirthCertificateURLs?: Maybe<Scalars['String']>;
  passportSizePhotoURLs?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  postal_id?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profileUploadedPhotoURLs?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  referredVia?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  sameAsPermanentAddress?: Maybe<Scalars['Boolean']>;
  scannedDocumentURL?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  spokenLanguages?: Maybe<Scalars['String']>;
  status?: Maybe<student_status_enum>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  waiID?: Maybe<Scalars['String']>;
  whatsapp_number?: Maybe<Scalars['String']>;
};

/** columns and relationships of "student_status" */
export type student_status = {
  __typename?: 'student_status';
  name: Scalars['String'];
  /** An array relationship */
  routes: Array<route>;
  /** An aggregate relationship */
  routes_aggregate: route_aggregate;
  /** An array relationship */
  students: Array<student>;
  /** An aggregate relationship */
  students_aggregate: student_aggregate;
};

/** columns and relationships of "student_status" */
export type student_statusroutesArgs = {
  distinct_on?: Maybe<Array<route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_order_by>>;
  where?: Maybe<route_bool_exp>;
};

/** columns and relationships of "student_status" */
export type student_statusroutes_aggregateArgs = {
  distinct_on?: Maybe<Array<route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_order_by>>;
  where?: Maybe<route_bool_exp>;
};

/** columns and relationships of "student_status" */
export type student_statusstudentsArgs = {
  distinct_on?: Maybe<Array<student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_order_by>>;
  where?: Maybe<student_bool_exp>;
};

/** columns and relationships of "student_status" */
export type student_statusstudents_aggregateArgs = {
  distinct_on?: Maybe<Array<student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_order_by>>;
  where?: Maybe<student_bool_exp>;
};

/** aggregated selection of "student_status" */
export type student_status_aggregate = {
  __typename?: 'student_status_aggregate';
  aggregate?: Maybe<student_status_aggregate_fields>;
  nodes: Array<student_status>;
};

/** aggregate fields of "student_status" */
export type student_status_aggregate_fields = {
  __typename?: 'student_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<student_status_max_fields>;
  min?: Maybe<student_status_min_fields>;
};

/** aggregate fields of "student_status" */
export type student_status_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_status_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "student_status". All fields are combined with a logical 'AND'. */
export type student_status_bool_exp = {
  _and?: Maybe<Array<student_status_bool_exp>>;
  _not?: Maybe<student_status_bool_exp>;
  _or?: Maybe<Array<student_status_bool_exp>>;
  name?: Maybe<String_comparison_exp>;
  routes?: Maybe<route_bool_exp>;
  students?: Maybe<student_bool_exp>;
};

/** unique or primary key constraints on table "student_status" */
export enum student_status_constraint {
  /** unique or primary key constraint */
  student_status_pkey = 'student_status_pkey',
}

export enum student_status_enum {
  active = 'active',
  completed = 'completed',
  expelled = 'expelled',
  pending = 'pending',
  suspended = 'suspended',
  withdrawn = 'withdrawn',
}

/** Boolean expression to compare columns of type "student_status_enum". All fields are combined with logical 'AND'. */
export type student_status_enum_comparison_exp = {
  _eq?: Maybe<student_status_enum>;
  _in?: Maybe<Array<student_status_enum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<student_status_enum>;
  _nin?: Maybe<Array<student_status_enum>>;
};

/** input type for inserting data into table "student_status" */
export type student_status_insert_input = {
  name?: Maybe<Scalars['String']>;
  routes?: Maybe<route_arr_rel_insert_input>;
  students?: Maybe<student_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type student_status_max_fields = {
  __typename?: 'student_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type student_status_min_fields = {
  __typename?: 'student_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "student_status" */
export type student_status_mutation_response = {
  __typename?: 'student_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<student_status>;
};

/** input type for inserting object relation for remote table "student_status" */
export type student_status_obj_rel_insert_input = {
  data: student_status_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<student_status_on_conflict>;
};

/** on conflict condition type for table "student_status" */
export type student_status_on_conflict = {
  constraint: student_status_constraint;
  update_columns?: Array<student_status_update_column>;
  where?: Maybe<student_status_bool_exp>;
};

/** Ordering options when selecting data from "student_status". */
export type student_status_order_by = {
  name?: Maybe<order_by>;
  routes_aggregate?: Maybe<route_aggregate_order_by>;
  students_aggregate?: Maybe<student_aggregate_order_by>;
};

/** primary key columns input for table: student_status */
export type student_status_pk_columns_input = {
  name: Scalars['String'];
};

/** select columns of table "student_status" */
export enum student_status_select_column {
  /** column name */
  name = 'name',
}

/** input type for updating data in table "student_status" */
export type student_status_set_input = {
  name?: Maybe<Scalars['String']>;
};

/** update columns of table "student_status" */
export enum student_status_update_column {
  /** column name */
  name = 'name',
}

/** aggregate stddev on columns */
export type student_stddev_fields = {
  __typename?: 'student_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "student" */
export type student_stddev_order_by = {
  id?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type student_stddev_pop_fields = {
  __typename?: 'student_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "student" */
export type student_stddev_pop_order_by = {
  id?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type student_stddev_samp_fields = {
  __typename?: 'student_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "student" */
export type student_stddev_samp_order_by = {
  id?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type student_sum_fields = {
  __typename?: 'student_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "student" */
export type student_sum_order_by = {
  id?: Maybe<order_by>;
};

/** columns and relationships of "student_timetable_item" */
export type student_timetable_item = {
  __typename?: 'student_timetable_item';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchName?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lecturerFirstName?: Maybe<Scalars['String']>;
  lecturerId?: Maybe<Scalars['uuid']>;
  lecturerLastName?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  studentFirebaseUID?: Maybe<Scalars['String']>;
  studentFirstName?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  studentLastName?: Maybe<Scalars['String']>;
  /** An array relationship */
  student_requests: Array<student_request>;
  /** An aggregate relationship */
  student_requests_aggregate: student_request_aggregate;
  subjectCode?: Maybe<Scalars['String']>;
  subjectColor?: Maybe<Scalars['String']>;
  subjectExtraSlotName?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<user>;
};

/** columns and relationships of "student_timetable_item" */
export type student_timetable_itemstudent_requestsArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** columns and relationships of "student_timetable_item" */
export type student_timetable_itemstudent_requests_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** aggregated selection of "student_timetable_item" */
export type student_timetable_item_aggregate = {
  __typename?: 'student_timetable_item_aggregate';
  aggregate?: Maybe<student_timetable_item_aggregate_fields>;
  nodes: Array<student_timetable_item>;
};

/** aggregate fields of "student_timetable_item" */
export type student_timetable_item_aggregate_fields = {
  __typename?: 'student_timetable_item_aggregate_fields';
  avg?: Maybe<student_timetable_item_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<student_timetable_item_max_fields>;
  min?: Maybe<student_timetable_item_min_fields>;
  stddev?: Maybe<student_timetable_item_stddev_fields>;
  stddev_pop?: Maybe<student_timetable_item_stddev_pop_fields>;
  stddev_samp?: Maybe<student_timetable_item_stddev_samp_fields>;
  sum?: Maybe<student_timetable_item_sum_fields>;
  var_pop?: Maybe<student_timetable_item_var_pop_fields>;
  var_samp?: Maybe<student_timetable_item_var_samp_fields>;
  variance?: Maybe<student_timetable_item_variance_fields>;
};

/** aggregate fields of "student_timetable_item" */
export type student_timetable_item_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<student_timetable_item_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type student_timetable_item_avg_fields = {
  __typename?: 'student_timetable_item_avg_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "student_timetable_item". All fields are combined with a logical 'AND'. */
export type student_timetable_item_bool_exp = {
  _and?: Maybe<Array<student_timetable_item_bool_exp>>;
  _not?: Maybe<student_timetable_item_bool_exp>;
  _or?: Maybe<Array<student_timetable_item_bool_exp>>;
  batchClassId?: Maybe<uuid_comparison_exp>;
  batchName?: Maybe<String_comparison_exp>;
  endTime?: Maybe<timestamptz_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  lecturerFirstName?: Maybe<String_comparison_exp>;
  lecturerId?: Maybe<uuid_comparison_exp>;
  lecturerLastName?: Maybe<String_comparison_exp>;
  locationName?: Maybe<String_comparison_exp>;
  preferredName?: Maybe<String_comparison_exp>;
  regNumber?: Maybe<String_comparison_exp>;
  sliitID?: Maybe<String_comparison_exp>;
  startTime?: Maybe<timestamptz_comparison_exp>;
  status?: Maybe<String_comparison_exp>;
  studentFirebaseUID?: Maybe<String_comparison_exp>;
  studentFirstName?: Maybe<String_comparison_exp>;
  studentId?: Maybe<Int_comparison_exp>;
  studentLastName?: Maybe<String_comparison_exp>;
  student_requests?: Maybe<student_request_bool_exp>;
  subjectCode?: Maybe<String_comparison_exp>;
  subjectColor?: Maybe<String_comparison_exp>;
  subjectExtraSlotName?: Maybe<String_comparison_exp>;
  subjectName?: Maybe<String_comparison_exp>;
  user?: Maybe<user_bool_exp>;
};

/** aggregate max on columns */
export type student_timetable_item_max_fields = {
  __typename?: 'student_timetable_item_max_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchName?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lecturerFirstName?: Maybe<Scalars['String']>;
  lecturerId?: Maybe<Scalars['uuid']>;
  lecturerLastName?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  studentFirebaseUID?: Maybe<Scalars['String']>;
  studentFirstName?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  studentLastName?: Maybe<Scalars['String']>;
  subjectCode?: Maybe<Scalars['String']>;
  subjectColor?: Maybe<Scalars['String']>;
  subjectExtraSlotName?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type student_timetable_item_min_fields = {
  __typename?: 'student_timetable_item_min_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchName?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  lecturerFirstName?: Maybe<Scalars['String']>;
  lecturerId?: Maybe<Scalars['uuid']>;
  lecturerLastName?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  sliitID?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  studentFirebaseUID?: Maybe<Scalars['String']>;
  studentFirstName?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['Int']>;
  studentLastName?: Maybe<Scalars['String']>;
  subjectCode?: Maybe<Scalars['String']>;
  subjectColor?: Maybe<Scalars['String']>;
  subjectExtraSlotName?: Maybe<Scalars['String']>;
  subjectName?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "student_timetable_item". */
export type student_timetable_item_order_by = {
  batchClassId?: Maybe<order_by>;
  batchName?: Maybe<order_by>;
  endTime?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lecturerFirstName?: Maybe<order_by>;
  lecturerId?: Maybe<order_by>;
  lecturerLastName?: Maybe<order_by>;
  locationName?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
  sliitID?: Maybe<order_by>;
  startTime?: Maybe<order_by>;
  status?: Maybe<order_by>;
  studentFirebaseUID?: Maybe<order_by>;
  studentFirstName?: Maybe<order_by>;
  studentId?: Maybe<order_by>;
  studentLastName?: Maybe<order_by>;
  student_requests_aggregate?: Maybe<student_request_aggregate_order_by>;
  subjectCode?: Maybe<order_by>;
  subjectColor?: Maybe<order_by>;
  subjectExtraSlotName?: Maybe<order_by>;
  subjectName?: Maybe<order_by>;
  user?: Maybe<user_order_by>;
};

/** select columns of table "student_timetable_item" */
export enum student_timetable_item_select_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  batchName = 'batchName',
  /** column name */
  endTime = 'endTime',
  /** column name */
  id = 'id',
  /** column name */
  lecturerFirstName = 'lecturerFirstName',
  /** column name */
  lecturerId = 'lecturerId',
  /** column name */
  lecturerLastName = 'lecturerLastName',
  /** column name */
  locationName = 'locationName',
  /** column name */
  preferredName = 'preferredName',
  /** column name */
  regNumber = 'regNumber',
  /** column name */
  sliitID = 'sliitID',
  /** column name */
  startTime = 'startTime',
  /** column name */
  status = 'status',
  /** column name */
  studentFirebaseUID = 'studentFirebaseUID',
  /** column name */
  studentFirstName = 'studentFirstName',
  /** column name */
  studentId = 'studentId',
  /** column name */
  studentLastName = 'studentLastName',
  /** column name */
  subjectCode = 'subjectCode',
  /** column name */
  subjectColor = 'subjectColor',
  /** column name */
  subjectExtraSlotName = 'subjectExtraSlotName',
  /** column name */
  subjectName = 'subjectName',
}

/** aggregate stddev on columns */
export type student_timetable_item_stddev_fields = {
  __typename?: 'student_timetable_item_stddev_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type student_timetable_item_stddev_pop_fields = {
  __typename?: 'student_timetable_item_stddev_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type student_timetable_item_stddev_samp_fields = {
  __typename?: 'student_timetable_item_stddev_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type student_timetable_item_sum_fields = {
  __typename?: 'student_timetable_item_sum_fields';
  studentId?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type student_timetable_item_var_pop_fields = {
  __typename?: 'student_timetable_item_var_pop_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type student_timetable_item_var_samp_fields = {
  __typename?: 'student_timetable_item_var_samp_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type student_timetable_item_variance_fields = {
  __typename?: 'student_timetable_item_variance_fields';
  studentId?: Maybe<Scalars['Float']>;
};

/** update columns of table "student" */
export enum student_update_column {
  /** column name */
  agreementURLs = 'agreementURLs',
  /** column name */
  bloodType = 'bloodType',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  dateOfBirth = 'dateOfBirth',
  /** column name */
  educationalCertificatesURLs = 'educationalCertificatesURLs',
  /** column name */
  email = 'email',
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  gender = 'gender',
  /** column name */
  id = 'id',
  /** column name */
  illnessesDisabilities = 'illnessesDisabilities',
  /** column name */
  initialRegistrationFeePaid = 'initialRegistrationFeePaid',
  /** column name */
  initialTourFollowed = 'initialTourFollowed',
  /** column name */
  isContactParent = 'isContactParent',
  /** column name */
  landLineNo = 'landLineNo',
  /** column name */
  lastName = 'lastName',
  /** column name */
  middleName = 'middleName',
  /** column name */
  mobileNo = 'mobileNo',
  /** column name */
  nationality = 'nationality',
  /** column name */
  nicCopyURLs = 'nicCopyURLs',
  /** column name */
  nicNo = 'nicNo',
  /** column name */
  ordinaryLevelCertificateURLs = 'ordinaryLevelCertificateURLs',
  /** column name */
  parentOrGuardianCity = 'parentOrGuardianCity',
  /** column name */
  parentOrGuardianCountry = 'parentOrGuardianCountry',
  /** column name */
  parentOrGuardianDistrict = 'parentOrGuardianDistrict',
  /** column name */
  parentOrGuardianLandLineNo = 'parentOrGuardianLandLineNo',
  /** column name */
  parentOrGuardianMobileNo = 'parentOrGuardianMobileNo',
  /** column name */
  parentOrGuardianName = 'parentOrGuardianName',
  /** column name */
  parentOrGuardianProvince = 'parentOrGuardianProvince',
  /** column name */
  parentOrGuardianStreetAddress1 = 'parentOrGuardianStreetAddress1',
  /** column name */
  parentOrGuardianStreetAddress2 = 'parentOrGuardianStreetAddress2',
  /** column name */
  passportNo = 'passportNo',
  /** column name */
  passportOrBirthCertificateURLs = 'passportOrBirthCertificateURLs',
  /** column name */
  passportSizePhotoURLs = 'passportSizePhotoURLs',
  /** column name */
  permanentCity = 'permanentCity',
  /** column name */
  permanentCountry = 'permanentCountry',
  /** column name */
  permanentDistrict = 'permanentDistrict',
  /** column name */
  permanentProvince = 'permanentProvince',
  /** column name */
  permanentStreetAddress1 = 'permanentStreetAddress1',
  /** column name */
  permanentStreetAddress2 = 'permanentStreetAddress2',
  /** column name */
  postal_id = 'postal_id',
  /** column name */
  preferredName = 'preferredName',
  /** column name */
  profileUploadedPhotoURLs = 'profileUploadedPhotoURLs',
  /** column name */
  publishedAt = 'publishedAt',
  /** column name */
  referredVia = 'referredVia',
  /** column name */
  regNumber = 'regNumber',
  /** column name */
  remarks = 'remarks',
  /** column name */
  sameAsPermanentAddress = 'sameAsPermanentAddress',
  /** column name */
  scannedDocumentURL = 'scannedDocumentURL',
  /** column name */
  sliitID = 'sliitID',
  /** column name */
  spokenLanguages = 'spokenLanguages',
  /** column name */
  status = 'status',
  /** column name */
  updatedAt = 'updatedAt',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  waiID = 'waiID',
  /** column name */
  whatsapp_number = 'whatsapp_number',
}

/** aggregate var_pop on columns */
export type student_var_pop_fields = {
  __typename?: 'student_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "student" */
export type student_var_pop_order_by = {
  id?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type student_var_samp_fields = {
  __typename?: 'student_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "student" */
export type student_var_samp_order_by = {
  id?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type student_variance_fields = {
  __typename?: 'student_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "student" */
export type student_variance_order_by = {
  id?: Maybe<order_by>;
};

/** columns and relationships of "subject" */
export type subject = {
  __typename?: 'subject';
  /** An array relationship */
  batch_subject_configurations: Array<batch_subject_configuration>;
  /** An aggregate relationship */
  batch_subject_configurations_aggregate: batch_subject_configuration_aggregate;
  code: Scalars['String'];
  color: Scalars['String'];
  /** An array relationship */
  course_semester_subjects_subjects: Array<course_semester_subjects_subject>;
  /** An aggregate relationship */
  course_semester_subjects_subjects_aggregate: course_semester_subjects_subject_aggregate;
  hoursPerSlot: Scalars['Int'];
  id: Scalars['uuid'];
  minutesPerSlot: Scalars['Int'];
  name: Scalars['String'];
  /** An array relationship */
  student_batch_history_subjects: Array<student_batch_history_subject>;
  /** An aggregate relationship */
  student_batch_history_subjects_aggregate: student_batch_history_subject_aggregate;
  /** An array relationship */
  subject_extra_slots: Array<subject_extra_slot>;
  /** An aggregate relationship */
  subject_extra_slots_aggregate: subject_extra_slot_aggregate;
  /** An array relationship */
  subject_to_users: Array<subject_to_user>;
  /** An aggregate relationship */
  subject_to_users_aggregate: subject_to_user_aggregate;
  totalSlots: Scalars['Int'];
};

/** columns and relationships of "subject" */
export type subjectbatch_subject_configurationsArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

/** columns and relationships of "subject" */
export type subjectbatch_subject_configurations_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

/** columns and relationships of "subject" */
export type subjectcourse_semester_subjects_subjectsArgs = {
  distinct_on?: Maybe<Array<course_semester_subjects_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_subjects_subject_order_by>>;
  where?: Maybe<course_semester_subjects_subject_bool_exp>;
};

/** columns and relationships of "subject" */
export type subjectcourse_semester_subjects_subjects_aggregateArgs = {
  distinct_on?: Maybe<Array<course_semester_subjects_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_subjects_subject_order_by>>;
  where?: Maybe<course_semester_subjects_subject_bool_exp>;
};

/** columns and relationships of "subject" */
export type subjectstudent_batch_history_subjectsArgs = {
  distinct_on?: Maybe<Array<student_batch_history_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_subject_order_by>>;
  where?: Maybe<student_batch_history_subject_bool_exp>;
};

/** columns and relationships of "subject" */
export type subjectstudent_batch_history_subjects_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_subject_order_by>>;
  where?: Maybe<student_batch_history_subject_bool_exp>;
};

/** columns and relationships of "subject" */
export type subjectsubject_extra_slotsArgs = {
  distinct_on?: Maybe<Array<subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_extra_slot_order_by>>;
  where?: Maybe<subject_extra_slot_bool_exp>;
};

/** columns and relationships of "subject" */
export type subjectsubject_extra_slots_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_extra_slot_order_by>>;
  where?: Maybe<subject_extra_slot_bool_exp>;
};

/** columns and relationships of "subject" */
export type subjectsubject_to_usersArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

/** columns and relationships of "subject" */
export type subjectsubject_to_users_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

/** aggregated selection of "subject" */
export type subject_aggregate = {
  __typename?: 'subject_aggregate';
  aggregate?: Maybe<subject_aggregate_fields>;
  nodes: Array<subject>;
};

/** aggregate fields of "subject" */
export type subject_aggregate_fields = {
  __typename?: 'subject_aggregate_fields';
  avg?: Maybe<subject_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<subject_max_fields>;
  min?: Maybe<subject_min_fields>;
  stddev?: Maybe<subject_stddev_fields>;
  stddev_pop?: Maybe<subject_stddev_pop_fields>;
  stddev_samp?: Maybe<subject_stddev_samp_fields>;
  sum?: Maybe<subject_sum_fields>;
  var_pop?: Maybe<subject_var_pop_fields>;
  var_samp?: Maybe<subject_var_samp_fields>;
  variance?: Maybe<subject_variance_fields>;
};

/** aggregate fields of "subject" */
export type subject_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<subject_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type subject_avg_fields = {
  __typename?: 'subject_avg_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "subject". All fields are combined with a logical 'AND'. */
export type subject_bool_exp = {
  _and?: Maybe<Array<subject_bool_exp>>;
  _not?: Maybe<subject_bool_exp>;
  _or?: Maybe<Array<subject_bool_exp>>;
  batch_subject_configurations?: Maybe<batch_subject_configuration_bool_exp>;
  code?: Maybe<String_comparison_exp>;
  color?: Maybe<String_comparison_exp>;
  course_semester_subjects_subjects?: Maybe<course_semester_subjects_subject_bool_exp>;
  hoursPerSlot?: Maybe<Int_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  minutesPerSlot?: Maybe<Int_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  student_batch_history_subjects?: Maybe<student_batch_history_subject_bool_exp>;
  subject_extra_slots?: Maybe<subject_extra_slot_bool_exp>;
  subject_to_users?: Maybe<subject_to_user_bool_exp>;
  totalSlots?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "subject" */
export enum subject_constraint {
  /** unique or primary key constraint */
  IDX_92374adc6b583e8cf659977e48 = 'IDX_92374adc6b583e8cf659977e48',
  /** unique or primary key constraint */
  PK_12eee115462e38d62e5455fc054 = 'PK_12eee115462e38d62e5455fc054',
  /** unique or primary key constraint */
  UQ_d011c391e37d9a5e63e8b04c977 = 'UQ_d011c391e37d9a5e63e8b04c977',
}

/** columns and relationships of "subject_extra_slot" */
export type subject_extra_slot = {
  __typename?: 'subject_extra_slot';
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** An object relationship */
  subject?: Maybe<subject>;
  subjectId?: Maybe<Scalars['uuid']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "subject_extra_slot" */
export type subject_extra_slot_aggregate = {
  __typename?: 'subject_extra_slot_aggregate';
  aggregate?: Maybe<subject_extra_slot_aggregate_fields>;
  nodes: Array<subject_extra_slot>;
};

/** aggregate fields of "subject_extra_slot" */
export type subject_extra_slot_aggregate_fields = {
  __typename?: 'subject_extra_slot_aggregate_fields';
  avg?: Maybe<subject_extra_slot_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<subject_extra_slot_max_fields>;
  min?: Maybe<subject_extra_slot_min_fields>;
  stddev?: Maybe<subject_extra_slot_stddev_fields>;
  stddev_pop?: Maybe<subject_extra_slot_stddev_pop_fields>;
  stddev_samp?: Maybe<subject_extra_slot_stddev_samp_fields>;
  sum?: Maybe<subject_extra_slot_sum_fields>;
  var_pop?: Maybe<subject_extra_slot_var_pop_fields>;
  var_samp?: Maybe<subject_extra_slot_var_samp_fields>;
  variance?: Maybe<subject_extra_slot_variance_fields>;
};

/** aggregate fields of "subject_extra_slot" */
export type subject_extra_slot_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<subject_extra_slot_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subject_extra_slot" */
export type subject_extra_slot_aggregate_order_by = {
  avg?: Maybe<subject_extra_slot_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<subject_extra_slot_max_order_by>;
  min?: Maybe<subject_extra_slot_min_order_by>;
  stddev?: Maybe<subject_extra_slot_stddev_order_by>;
  stddev_pop?: Maybe<subject_extra_slot_stddev_pop_order_by>;
  stddev_samp?: Maybe<subject_extra_slot_stddev_samp_order_by>;
  sum?: Maybe<subject_extra_slot_sum_order_by>;
  var_pop?: Maybe<subject_extra_slot_var_pop_order_by>;
  var_samp?: Maybe<subject_extra_slot_var_samp_order_by>;
  variance?: Maybe<subject_extra_slot_variance_order_by>;
};

/** input type for inserting array relation for remote table "subject_extra_slot" */
export type subject_extra_slot_arr_rel_insert_input = {
  data: Array<subject_extra_slot_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<subject_extra_slot_on_conflict>;
};

/** aggregate avg on columns */
export type subject_extra_slot_avg_fields = {
  __typename?: 'subject_extra_slot_avg_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "subject_extra_slot" */
export type subject_extra_slot_avg_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "subject_extra_slot". All fields are combined with a logical 'AND'. */
export type subject_extra_slot_bool_exp = {
  _and?: Maybe<Array<subject_extra_slot_bool_exp>>;
  _not?: Maybe<subject_extra_slot_bool_exp>;
  _or?: Maybe<Array<subject_extra_slot_bool_exp>>;
  hoursPerSlot?: Maybe<Int_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  minutesPerSlot?: Maybe<Int_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  subject?: Maybe<subject_bool_exp>;
  subjectId?: Maybe<uuid_comparison_exp>;
  totalMarks?: Maybe<Int_comparison_exp>;
  totalSlots?: Maybe<Int_comparison_exp>;
};

/** unique or primary key constraints on table "subject_extra_slot" */
export enum subject_extra_slot_constraint {
  /** unique or primary key constraint */
  PK_2e4fff5d9937882feb81e9776ba = 'PK_2e4fff5d9937882feb81e9776ba',
}

/** input type for incrementing numeric columns in table "subject_extra_slot" */
export type subject_extra_slot_inc_input = {
  hoursPerSlot?: Maybe<Scalars['Int']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "subject_extra_slot" */
export type subject_extra_slot_insert_input = {
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  subject?: Maybe<subject_obj_rel_insert_input>;
  subjectId?: Maybe<Scalars['uuid']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type subject_extra_slot_max_fields = {
  __typename?: 'subject_extra_slot_max_fields';
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['uuid']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "subject_extra_slot" */
export type subject_extra_slot_max_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  name?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate min on columns */
export type subject_extra_slot_min_fields = {
  __typename?: 'subject_extra_slot_min_fields';
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['uuid']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "subject_extra_slot" */
export type subject_extra_slot_min_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  name?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** response of any mutation on the table "subject_extra_slot" */
export type subject_extra_slot_mutation_response = {
  __typename?: 'subject_extra_slot_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<subject_extra_slot>;
};

/** on conflict condition type for table "subject_extra_slot" */
export type subject_extra_slot_on_conflict = {
  constraint: subject_extra_slot_constraint;
  update_columns?: Array<subject_extra_slot_update_column>;
  where?: Maybe<subject_extra_slot_bool_exp>;
};

/** Ordering options when selecting data from "subject_extra_slot". */
export type subject_extra_slot_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  name?: Maybe<order_by>;
  subject?: Maybe<subject_order_by>;
  subjectId?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** primary key columns input for table: subject_extra_slot */
export type subject_extra_slot_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "subject_extra_slot" */
export enum subject_extra_slot_select_column {
  /** column name */
  hoursPerSlot = 'hoursPerSlot',
  /** column name */
  id = 'id',
  /** column name */
  minutesPerSlot = 'minutesPerSlot',
  /** column name */
  name = 'name',
  /** column name */
  subjectId = 'subjectId',
  /** column name */
  totalMarks = 'totalMarks',
  /** column name */
  totalSlots = 'totalSlots',
}

/** input type for updating data in table "subject_extra_slot" */
export type subject_extra_slot_set_input = {
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  subjectId?: Maybe<Scalars['uuid']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type subject_extra_slot_stddev_fields = {
  __typename?: 'subject_extra_slot_stddev_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "subject_extra_slot" */
export type subject_extra_slot_stddev_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type subject_extra_slot_stddev_pop_fields = {
  __typename?: 'subject_extra_slot_stddev_pop_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "subject_extra_slot" */
export type subject_extra_slot_stddev_pop_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type subject_extra_slot_stddev_samp_fields = {
  __typename?: 'subject_extra_slot_stddev_samp_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "subject_extra_slot" */
export type subject_extra_slot_stddev_samp_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type subject_extra_slot_sum_fields = {
  __typename?: 'subject_extra_slot_sum_fields';
  hoursPerSlot?: Maybe<Scalars['Int']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  totalMarks?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subject_extra_slot" */
export type subject_extra_slot_sum_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** update columns of table "subject_extra_slot" */
export enum subject_extra_slot_update_column {
  /** column name */
  hoursPerSlot = 'hoursPerSlot',
  /** column name */
  id = 'id',
  /** column name */
  minutesPerSlot = 'minutesPerSlot',
  /** column name */
  name = 'name',
  /** column name */
  subjectId = 'subjectId',
  /** column name */
  totalMarks = 'totalMarks',
  /** column name */
  totalSlots = 'totalSlots',
}

/** aggregate var_pop on columns */
export type subject_extra_slot_var_pop_fields = {
  __typename?: 'subject_extra_slot_var_pop_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "subject_extra_slot" */
export type subject_extra_slot_var_pop_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type subject_extra_slot_var_samp_fields = {
  __typename?: 'subject_extra_slot_var_samp_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "subject_extra_slot" */
export type subject_extra_slot_var_samp_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type subject_extra_slot_variance_fields = {
  __typename?: 'subject_extra_slot_variance_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalMarks?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "subject_extra_slot" */
export type subject_extra_slot_variance_order_by = {
  hoursPerSlot?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  totalMarks?: Maybe<order_by>;
  totalSlots?: Maybe<order_by>;
};

/** input type for incrementing numeric columns in table "subject" */
export type subject_inc_input = {
  hoursPerSlot?: Maybe<Scalars['Int']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "subject" */
export type subject_insert_input = {
  batch_subject_configurations?: Maybe<batch_subject_configuration_arr_rel_insert_input>;
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  course_semester_subjects_subjects?: Maybe<course_semester_subjects_subject_arr_rel_insert_input>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  student_batch_history_subjects?: Maybe<student_batch_history_subject_arr_rel_insert_input>;
  subject_extra_slots?: Maybe<subject_extra_slot_arr_rel_insert_input>;
  subject_to_users?: Maybe<subject_to_user_arr_rel_insert_input>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type subject_max_fields = {
  __typename?: 'subject_max_fields';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type subject_min_fields = {
  __typename?: 'subject_min_fields';
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "subject" */
export type subject_mutation_response = {
  __typename?: 'subject_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<subject>;
};

/** input type for inserting object relation for remote table "subject" */
export type subject_obj_rel_insert_input = {
  data: subject_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<subject_on_conflict>;
};

/** on conflict condition type for table "subject" */
export type subject_on_conflict = {
  constraint: subject_constraint;
  update_columns?: Array<subject_update_column>;
  where?: Maybe<subject_bool_exp>;
};

/** Ordering options when selecting data from "subject". */
export type subject_order_by = {
  batch_subject_configurations_aggregate?: Maybe<batch_subject_configuration_aggregate_order_by>;
  code?: Maybe<order_by>;
  color?: Maybe<order_by>;
  course_semester_subjects_subjects_aggregate?: Maybe<course_semester_subjects_subject_aggregate_order_by>;
  hoursPerSlot?: Maybe<order_by>;
  id?: Maybe<order_by>;
  minutesPerSlot?: Maybe<order_by>;
  name?: Maybe<order_by>;
  student_batch_history_subjects_aggregate?: Maybe<student_batch_history_subject_aggregate_order_by>;
  subject_extra_slots_aggregate?: Maybe<subject_extra_slot_aggregate_order_by>;
  subject_to_users_aggregate?: Maybe<subject_to_user_aggregate_order_by>;
  totalSlots?: Maybe<order_by>;
};

/** primary key columns input for table: subject */
export type subject_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "subject" */
export enum subject_select_column {
  /** column name */
  code = 'code',
  /** column name */
  color = 'color',
  /** column name */
  hoursPerSlot = 'hoursPerSlot',
  /** column name */
  id = 'id',
  /** column name */
  minutesPerSlot = 'minutesPerSlot',
  /** column name */
  name = 'name',
  /** column name */
  totalSlots = 'totalSlots',
}

/** input type for updating data in table "subject" */
export type subject_set_input = {
  code?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  hoursPerSlot?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type subject_stddev_fields = {
  __typename?: 'subject_stddev_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type subject_stddev_pop_fields = {
  __typename?: 'subject_stddev_pop_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type subject_stddev_samp_fields = {
  __typename?: 'subject_stddev_samp_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type subject_sum_fields = {
  __typename?: 'subject_sum_fields';
  hoursPerSlot?: Maybe<Scalars['Int']>;
  minutesPerSlot?: Maybe<Scalars['Int']>;
  totalSlots?: Maybe<Scalars['Int']>;
};

/** columns and relationships of "subject_to_user" */
export type subject_to_user = {
  __typename?: 'subject_to_user';
  id: Scalars['uuid'];
  priority: Scalars['Int'];
  /** An object relationship */
  subject: subject;
  subjectId: Scalars['uuid'];
  /** An object relationship */
  user: user;
  userId: Scalars['uuid'];
  /** An object relationship */
  user_public?: Maybe<user_public>;
};

/** aggregated selection of "subject_to_user" */
export type subject_to_user_aggregate = {
  __typename?: 'subject_to_user_aggregate';
  aggregate?: Maybe<subject_to_user_aggregate_fields>;
  nodes: Array<subject_to_user>;
};

/** aggregate fields of "subject_to_user" */
export type subject_to_user_aggregate_fields = {
  __typename?: 'subject_to_user_aggregate_fields';
  avg?: Maybe<subject_to_user_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<subject_to_user_max_fields>;
  min?: Maybe<subject_to_user_min_fields>;
  stddev?: Maybe<subject_to_user_stddev_fields>;
  stddev_pop?: Maybe<subject_to_user_stddev_pop_fields>;
  stddev_samp?: Maybe<subject_to_user_stddev_samp_fields>;
  sum?: Maybe<subject_to_user_sum_fields>;
  var_pop?: Maybe<subject_to_user_var_pop_fields>;
  var_samp?: Maybe<subject_to_user_var_samp_fields>;
  variance?: Maybe<subject_to_user_variance_fields>;
};

/** aggregate fields of "subject_to_user" */
export type subject_to_user_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<subject_to_user_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "subject_to_user" */
export type subject_to_user_aggregate_order_by = {
  avg?: Maybe<subject_to_user_avg_order_by>;
  count?: Maybe<order_by>;
  max?: Maybe<subject_to_user_max_order_by>;
  min?: Maybe<subject_to_user_min_order_by>;
  stddev?: Maybe<subject_to_user_stddev_order_by>;
  stddev_pop?: Maybe<subject_to_user_stddev_pop_order_by>;
  stddev_samp?: Maybe<subject_to_user_stddev_samp_order_by>;
  sum?: Maybe<subject_to_user_sum_order_by>;
  var_pop?: Maybe<subject_to_user_var_pop_order_by>;
  var_samp?: Maybe<subject_to_user_var_samp_order_by>;
  variance?: Maybe<subject_to_user_variance_order_by>;
};

/** input type for inserting array relation for remote table "subject_to_user" */
export type subject_to_user_arr_rel_insert_input = {
  data: Array<subject_to_user_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<subject_to_user_on_conflict>;
};

/** aggregate avg on columns */
export type subject_to_user_avg_fields = {
  __typename?: 'subject_to_user_avg_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "subject_to_user" */
export type subject_to_user_avg_order_by = {
  priority?: Maybe<order_by>;
};

/** Boolean expression to filter rows from the table "subject_to_user". All fields are combined with a logical 'AND'. */
export type subject_to_user_bool_exp = {
  _and?: Maybe<Array<subject_to_user_bool_exp>>;
  _not?: Maybe<subject_to_user_bool_exp>;
  _or?: Maybe<Array<subject_to_user_bool_exp>>;
  id?: Maybe<uuid_comparison_exp>;
  priority?: Maybe<Int_comparison_exp>;
  subject?: Maybe<subject_bool_exp>;
  subjectId?: Maybe<uuid_comparison_exp>;
  user?: Maybe<user_bool_exp>;
  userId?: Maybe<uuid_comparison_exp>;
  user_public?: Maybe<user_public_bool_exp>;
};

/** unique or primary key constraints on table "subject_to_user" */
export enum subject_to_user_constraint {
  /** unique or primary key constraint */
  PK_a7d2336152081270bc5e2606114 = 'PK_a7d2336152081270bc5e2606114',
  /** unique or primary key constraint */
  UNIQUE_LECTURER_SUBJECT = 'UNIQUE_LECTURER_SUBJECT',
}

/** input type for incrementing numeric columns in table "subject_to_user" */
export type subject_to_user_inc_input = {
  priority?: Maybe<Scalars['Int']>;
};

/** input type for inserting data into table "subject_to_user" */
export type subject_to_user_insert_input = {
  id?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  subject?: Maybe<subject_obj_rel_insert_input>;
  subjectId?: Maybe<Scalars['uuid']>;
  user?: Maybe<user_obj_rel_insert_input>;
  userId?: Maybe<Scalars['uuid']>;
  user_public?: Maybe<user_public_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type subject_to_user_max_fields = {
  __typename?: 'subject_to_user_max_fields';
  id?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  subjectId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "subject_to_user" */
export type subject_to_user_max_order_by = {
  id?: Maybe<order_by>;
  priority?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type subject_to_user_min_fields = {
  __typename?: 'subject_to_user_min_fields';
  id?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  subjectId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "subject_to_user" */
export type subject_to_user_min_order_by = {
  id?: Maybe<order_by>;
  priority?: Maybe<order_by>;
  subjectId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** response of any mutation on the table "subject_to_user" */
export type subject_to_user_mutation_response = {
  __typename?: 'subject_to_user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<subject_to_user>;
};

/** on conflict condition type for table "subject_to_user" */
export type subject_to_user_on_conflict = {
  constraint: subject_to_user_constraint;
  update_columns?: Array<subject_to_user_update_column>;
  where?: Maybe<subject_to_user_bool_exp>;
};

/** Ordering options when selecting data from "subject_to_user". */
export type subject_to_user_order_by = {
  id?: Maybe<order_by>;
  priority?: Maybe<order_by>;
  subject?: Maybe<subject_order_by>;
  subjectId?: Maybe<order_by>;
  user?: Maybe<user_order_by>;
  userId?: Maybe<order_by>;
  user_public?: Maybe<user_public_order_by>;
};

/** primary key columns input for table: subject_to_user */
export type subject_to_user_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "subject_to_user" */
export enum subject_to_user_select_column {
  /** column name */
  id = 'id',
  /** column name */
  priority = 'priority',
  /** column name */
  subjectId = 'subjectId',
  /** column name */
  userId = 'userId',
}

/** input type for updating data in table "subject_to_user" */
export type subject_to_user_set_input = {
  id?: Maybe<Scalars['uuid']>;
  priority?: Maybe<Scalars['Int']>;
  subjectId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type subject_to_user_stddev_fields = {
  __typename?: 'subject_to_user_stddev_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "subject_to_user" */
export type subject_to_user_stddev_order_by = {
  priority?: Maybe<order_by>;
};

/** aggregate stddev_pop on columns */
export type subject_to_user_stddev_pop_fields = {
  __typename?: 'subject_to_user_stddev_pop_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "subject_to_user" */
export type subject_to_user_stddev_pop_order_by = {
  priority?: Maybe<order_by>;
};

/** aggregate stddev_samp on columns */
export type subject_to_user_stddev_samp_fields = {
  __typename?: 'subject_to_user_stddev_samp_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "subject_to_user" */
export type subject_to_user_stddev_samp_order_by = {
  priority?: Maybe<order_by>;
};

/** aggregate sum on columns */
export type subject_to_user_sum_fields = {
  __typename?: 'subject_to_user_sum_fields';
  priority?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "subject_to_user" */
export type subject_to_user_sum_order_by = {
  priority?: Maybe<order_by>;
};

/** update columns of table "subject_to_user" */
export enum subject_to_user_update_column {
  /** column name */
  id = 'id',
  /** column name */
  priority = 'priority',
  /** column name */
  subjectId = 'subjectId',
  /** column name */
  userId = 'userId',
}

/** aggregate var_pop on columns */
export type subject_to_user_var_pop_fields = {
  __typename?: 'subject_to_user_var_pop_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "subject_to_user" */
export type subject_to_user_var_pop_order_by = {
  priority?: Maybe<order_by>;
};

/** aggregate var_samp on columns */
export type subject_to_user_var_samp_fields = {
  __typename?: 'subject_to_user_var_samp_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "subject_to_user" */
export type subject_to_user_var_samp_order_by = {
  priority?: Maybe<order_by>;
};

/** aggregate variance on columns */
export type subject_to_user_variance_fields = {
  __typename?: 'subject_to_user_variance_fields';
  priority?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "subject_to_user" */
export type subject_to_user_variance_order_by = {
  priority?: Maybe<order_by>;
};

/** update columns of table "subject" */
export enum subject_update_column {
  /** column name */
  code = 'code',
  /** column name */
  color = 'color',
  /** column name */
  hoursPerSlot = 'hoursPerSlot',
  /** column name */
  id = 'id',
  /** column name */
  minutesPerSlot = 'minutesPerSlot',
  /** column name */
  name = 'name',
  /** column name */
  totalSlots = 'totalSlots',
}

/** aggregate var_pop on columns */
export type subject_var_pop_fields = {
  __typename?: 'subject_var_pop_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type subject_var_samp_fields = {
  __typename?: 'subject_var_samp_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type subject_variance_fields = {
  __typename?: 'subject_variance_fields';
  hoursPerSlot?: Maybe<Scalars['Float']>;
  minutesPerSlot?: Maybe<Scalars['Float']>;
  totalSlots?: Maybe<Scalars['Float']>;
};

export type subscription_root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "academic_calendar_item" */
  academic_calendar_item: Array<academic_calendar_item>;
  /** fetch aggregated fields from the table: "academic_calendar_item" */
  academic_calendar_item_aggregate: academic_calendar_item_aggregate;
  /** fetch data from the table: "academic_calendar_item" using primary key columns */
  academic_calendar_item_by_pk?: Maybe<academic_calendar_item>;
  /** fetch data from the table: "active_batch" */
  active_batch: Array<active_batch>;
  /** fetch aggregated fields from the table: "active_batch" */
  active_batch_aggregate: active_batch_aggregate;
  /** fetch data from the table: "assessment" */
  assessment: Array<assessment>;
  /** fetch aggregated fields from the table: "assessment" */
  assessment_aggregate: assessment_aggregate;
  /** fetch data from the table: "assessment" using primary key columns */
  assessment_by_pk?: Maybe<assessment>;
  /** fetch data from the table: "attendance" */
  attendance: Array<attendance>;
  /** fetch aggregated fields from the table: "attendance" */
  attendance_aggregate: attendance_aggregate;
  /** fetch data from the table: "attendance" using primary key columns */
  attendance_by_pk?: Maybe<attendance>;
  /** fetch data from the table: "attendance_student" */
  attendance_student: Array<attendance_student>;
  /** fetch aggregated fields from the table: "attendance_student" */
  attendance_student_aggregate: attendance_student_aggregate;
  /** fetch data from the table: "attendance_student" using primary key columns */
  attendance_student_by_pk?: Maybe<attendance_student>;
  /** fetch data from the table: "batch" */
  batch: Array<batch>;
  /** fetch aggregated fields from the table: "batch" */
  batch_aggregate: batch_aggregate;
  /** fetch data from the table: "batch" using primary key columns */
  batch_by_pk?: Maybe<batch>;
  /** fetch data from the table: "batch_class" */
  batch_class: Array<batch_class>;
  /** fetch aggregated fields from the table: "batch_class" */
  batch_class_aggregate: batch_class_aggregate;
  /** An array relationship */
  batch_class_batch_subject_configurations: Array<batch_class_batch_subject_configurations>;
  /** An aggregate relationship */
  batch_class_batch_subject_configurations_aggregate: batch_class_batch_subject_configurations_aggregate;
  /** An array relationship */
  batch_class_batch_subject_extra_slot: Array<batch_class_batch_subject_extra_slot>;
  /** An aggregate relationship */
  batch_class_batch_subject_extra_slot_aggregate: batch_class_batch_subject_extra_slot_aggregate;
  /** fetch data from the table: "batch_class" using primary key columns */
  batch_class_by_pk?: Maybe<batch_class>;
  /** fetch data from the table: "batch_subject_configuration" */
  batch_subject_configuration: Array<batch_subject_configuration>;
  /** fetch aggregated fields from the table: "batch_subject_configuration" */
  batch_subject_configuration_aggregate: batch_subject_configuration_aggregate;
  /** fetch data from the table: "batch_subject_configuration" using primary key columns */
  batch_subject_configuration_by_pk?: Maybe<batch_subject_configuration>;
  /** fetch data from the table: "batch_subject_extra_slot" */
  batch_subject_extra_slot: Array<batch_subject_extra_slot>;
  /** fetch aggregated fields from the table: "batch_subject_extra_slot" */
  batch_subject_extra_slot_aggregate: batch_subject_extra_slot_aggregate;
  /** fetch data from the table: "batch_subject_extra_slot" using primary key columns */
  batch_subject_extra_slot_by_pk?: Maybe<batch_subject_extra_slot>;
  /** fetch data from the table: "blood_type" */
  blood_type: Array<blood_type>;
  /** fetch aggregated fields from the table: "blood_type" */
  blood_type_aggregate: blood_type_aggregate;
  /** fetch data from the table: "blood_type" using primary key columns */
  blood_type_by_pk?: Maybe<blood_type>;
  /** fetch data from the table: "course" */
  course: Array<course>;
  /** fetch aggregated fields from the table: "course" */
  course_aggregate: course_aggregate;
  /** fetch data from the table: "course" using primary key columns */
  course_by_pk?: Maybe<course>;
  /** fetch data from the table: "course_coordinator" */
  course_coordinator: Array<course_coordinator>;
  /** fetch aggregated fields from the table: "course_coordinator" */
  course_coordinator_aggregate: course_coordinator_aggregate;
  /** fetch data from the table: "course_coordinator" using primary key columns */
  course_coordinator_by_pk?: Maybe<course_coordinator>;
  /** fetch data from the table: "course_level" */
  course_level: Array<course_level>;
  /** fetch aggregated fields from the table: "course_level" */
  course_level_aggregate: course_level_aggregate;
  /** fetch data from the table: "course_level" using primary key columns */
  course_level_by_pk?: Maybe<course_level>;
  /** fetch data from the table: "course_semester" */
  course_semester: Array<course_semester>;
  /** fetch aggregated fields from the table: "course_semester" */
  course_semester_aggregate: course_semester_aggregate;
  /** fetch data from the table: "course_semester" using primary key columns */
  course_semester_by_pk?: Maybe<course_semester>;
  /** fetch data from the table: "course_semester_subjects_subject" */
  course_semester_subjects_subject: Array<course_semester_subjects_subject>;
  /** fetch aggregated fields from the table: "course_semester_subjects_subject" */
  course_semester_subjects_subject_aggregate: course_semester_subjects_subject_aggregate;
  /** fetch data from the table: "course_semester_subjects_subject" using primary key columns */
  course_semester_subjects_subject_by_pk?: Maybe<course_semester_subjects_subject>;
  /** fetch data from the table: "current_student" */
  current_student: Array<current_student>;
  /** fetch aggregated fields from the table: "current_student" */
  current_student_aggregate: current_student_aggregate;
  /** fetch data from the table: "current_student_course" */
  current_student_course: Array<current_student_course>;
  /** fetch aggregated fields from the table: "current_student_course" */
  current_student_course_aggregate: current_student_course_aggregate;
  /** fetch data from the table: "current_student_routes_route" */
  current_student_routes_route: Array<current_student_routes_route>;
  /** fetch aggregated fields from the table: "current_student_routes_route" */
  current_student_routes_route_aggregate: current_student_routes_route_aggregate;
  /** fetch data from the table: "current_user" */
  current_user: Array<current_user>;
  /** fetch aggregated fields from the table: "current_user" */
  current_user_aggregate: current_user_aggregate;
  /** fetch data from the table: "current_user_route" */
  current_user_route: Array<current_user_route>;
  /** fetch aggregated fields from the table: "current_user_route" */
  current_user_route_aggregate: current_user_route_aggregate;
  /** fetch data from the table: "current_user_routes_route" */
  current_user_routes_route: Array<current_user_routes_route>;
  /** An aggregate relationship */
  current_user_routes_route_aggregate: current_user_routes_route_aggregate;
  /** fetch data from the table: "department" */
  department: Array<department>;
  /** fetch aggregated fields from the table: "department" */
  department_aggregate: department_aggregate;
  /** fetch data from the table: "department" using primary key columns */
  department_by_pk?: Maybe<department>;
  /** fetch data from the table: "education_qualification" */
  education_qualification: Array<education_qualification>;
  /** fetch aggregated fields from the table: "education_qualification" */
  education_qualification_aggregate: education_qualification_aggregate;
  /** fetch data from the table: "education_qualification" using primary key columns */
  education_qualification_by_pk?: Maybe<education_qualification>;
  /** fetch data from the table: "employment_experience" */
  employment_experience: Array<employment_experience>;
  /** fetch aggregated fields from the table: "employment_experience" */
  employment_experience_aggregate: employment_experience_aggregate;
  /** fetch data from the table: "employment_experience" using primary key columns */
  employment_experience_by_pk?: Maybe<employment_experience>;
  /** fetch data from the table: "endpoint" */
  endpoint: Array<endpoint>;
  /** fetch aggregated fields from the table: "endpoint" */
  endpoint_aggregate: endpoint_aggregate;
  /** fetch data from the table: "endpoint" using primary key columns */
  endpoint_by_pk?: Maybe<endpoint>;
  /** An array relationship */
  exit_interview_answer: Array<exit_interview_answer>;
  /** An aggregate relationship */
  exit_interview_answer_aggregate: exit_interview_answer_aggregate;
  /** fetch data from the table: "exit_interview_answer" using primary key columns */
  exit_interview_answer_by_pk?: Maybe<exit_interview_answer>;
  /** An array relationship */
  exit_interview_answer_multi_choice_questions: Array<exit_interview_answer_multi_choice_questions>;
  /** An aggregate relationship */
  exit_interview_answer_multi_choice_questions_aggregate: exit_interview_answer_multi_choice_questions_aggregate;
  /** fetch data from the table: "exit_interview_answer_multi_choice_questions" using primary key columns */
  exit_interview_answer_multi_choice_questions_by_pk?: Maybe<exit_interview_answer_multi_choice_questions>;
  /** fetch data from the table: "exit_interview_question" */
  exit_interview_question: Array<exit_interview_question>;
  /** fetch aggregated fields from the table: "exit_interview_question" */
  exit_interview_question_aggregate: exit_interview_question_aggregate;
  /** An array relationship */
  exit_interview_question_answers: Array<exit_interview_question_answers>;
  /** An aggregate relationship */
  exit_interview_question_answers_aggregate: exit_interview_question_answers_aggregate;
  /** fetch data from the table: "exit_interview_question_answers" using primary key columns */
  exit_interview_question_answers_by_pk?: Maybe<exit_interview_question_answers>;
  /** fetch data from the table: "exit_interview_question" using primary key columns */
  exit_interview_question_by_pk?: Maybe<exit_interview_question>;
  /** fetch data from the table: "exit_interview_question_group" */
  exit_interview_question_group: Array<exit_interview_question_group>;
  /** fetch aggregated fields from the table: "exit_interview_question_group" */
  exit_interview_question_group_aggregate: exit_interview_question_group_aggregate;
  /** fetch data from the table: "exit_interview_question_group" using primary key columns */
  exit_interview_question_group_by_pk?: Maybe<exit_interview_question_group>;
  /** An array relationship */
  inquiry: Array<inquiry>;
  /** An aggregate relationship */
  inquiry_aggregate: inquiry_aggregate;
  /** fetch data from the table: "inquiry" using primary key columns */
  inquiry_by_pk?: Maybe<inquiry>;
  /** fetch data from the table: "inquiry_status_enum" */
  inquiry_status_enum: Array<inquiry_status_enum>;
  /** fetch aggregated fields from the table: "inquiry_status_enum" */
  inquiry_status_enum_aggregate: inquiry_status_enum_aggregate;
  /** fetch data from the table: "inquiry_status_enum" using primary key columns */
  inquiry_status_enum_by_pk?: Maybe<inquiry_status_enum>;
  /** fetch data from the table: "intake" */
  intake: Array<intake>;
  /** fetch aggregated fields from the table: "intake" */
  intake_aggregate: intake_aggregate;
  /** fetch data from the table: "intake" using primary key columns */
  intake_by_pk?: Maybe<intake>;
  /** fetch data from the table: "lecture_material" */
  lecture_material: Array<lecture_material>;
  /** fetch aggregated fields from the table: "lecture_material" */
  lecture_material_aggregate: lecture_material_aggregate;
  /** fetch data from the table: "lecture_material" using primary key columns */
  lecture_material_by_pk?: Maybe<lecture_material>;
  /** fetch data from the table: "lecture_material_category" */
  lecture_material_category: Array<lecture_material_category>;
  /** fetch aggregated fields from the table: "lecture_material_category" */
  lecture_material_category_aggregate: lecture_material_category_aggregate;
  /** fetch data from the table: "lecture_material_category" using primary key columns */
  lecture_material_category_by_pk?: Maybe<lecture_material_category>;
  /** fetch data from the table: "lecturer" */
  lecturer: Array<lecturer>;
  /** fetch aggregated fields from the table: "lecturer" */
  lecturer_aggregate: lecturer_aggregate;
  /** fetch data from the table: "location" */
  location: Array<location>;
  /** fetch aggregated fields from the table: "location" */
  location_aggregate: location_aggregate;
  /** fetch data from the table: "location" using primary key columns */
  location_by_pk?: Maybe<location>;
  /** fetch data from the table: "multi_choice_question" */
  multi_choice_question: Array<multi_choice_question>;
  /** fetch aggregated fields from the table: "multi_choice_question" */
  multi_choice_question_aggregate: multi_choice_question_aggregate;
  /** fetch data from the table: "multi_choice_question" using primary key columns */
  multi_choice_question_by_pk?: Maybe<multi_choice_question>;
  /** fetch data from the table: "perfomance_status" */
  perfomance_status: Array<perfomance_status>;
  /** fetch aggregated fields from the table: "perfomance_status" */
  perfomance_status_aggregate: perfomance_status_aggregate;
  /** fetch data from the table: "perfomance_status" using primary key columns */
  perfomance_status_by_pk?: Maybe<perfomance_status>;
  /** fetch data from the table: "question_type" */
  question_type: Array<question_type>;
  /** fetch aggregated fields from the table: "question_type" */
  question_type_aggregate: question_type_aggregate;
  /** fetch data from the table: "question_type" using primary key columns */
  question_type_by_pk?: Maybe<question_type>;
  /** fetch data from the table: "result_sheet" */
  result_sheet: Array<result_sheet>;
  /** fetch aggregated fields from the table: "result_sheet" */
  result_sheet_aggregate: result_sheet_aggregate;
  /** fetch data from the table: "result_sheet" using primary key columns */
  result_sheet_by_pk?: Maybe<result_sheet>;
  /** fetch data from the table: "result_sheet_status" */
  result_sheet_status: Array<result_sheet_status>;
  /** fetch aggregated fields from the table: "result_sheet_status" */
  result_sheet_status_aggregate: result_sheet_status_aggregate;
  /** fetch data from the table: "result_sheet_status" using primary key columns */
  result_sheet_status_by_pk?: Maybe<result_sheet_status>;
  /** fetch data from the table: "route" */
  route: Array<route>;
  /** fetch aggregated fields from the table: "route" */
  route_aggregate: route_aggregate;
  /** fetch data from the table: "route" using primary key columns */
  route_by_pk?: Maybe<route>;
  /** fetch data from the table: "route_endpoints_endpoint" */
  route_endpoints_endpoint: Array<route_endpoints_endpoint>;
  /** fetch aggregated fields from the table: "route_endpoints_endpoint" */
  route_endpoints_endpoint_aggregate: route_endpoints_endpoint_aggregate;
  /** fetch data from the table: "route_endpoints_endpoint" using primary key columns */
  route_endpoints_endpoint_by_pk?: Maybe<route_endpoints_endpoint>;
  /** fetch data from the table: "student" */
  student: Array<student>;
  /** fetch data from the table: "student_admin_editable_information" */
  student_admin_editable_information: Array<student_admin_editable_information>;
  /** fetch aggregated fields from the table: "student_admin_editable_information" */
  student_admin_editable_information_aggregate: student_admin_editable_information_aggregate;
  /** fetch aggregated fields from the table: "student" */
  student_aggregate: student_aggregate;
  /** fetch data from the table: "student_assessment_submission" */
  student_assessment_submission: Array<student_assessment_submission>;
  /** fetch aggregated fields from the table: "student_assessment_submission" */
  student_assessment_submission_aggregate: student_assessment_submission_aggregate;
  /** fetch data from the table: "student_assessment_submission" using primary key columns */
  student_assessment_submission_by_pk?: Maybe<student_assessment_submission>;
  /** fetch data from the table: "student_attendance_status" */
  student_attendance_status: Array<student_attendance_status>;
  /** fetch aggregated fields from the table: "student_attendance_status" */
  student_attendance_status_aggregate: student_attendance_status_aggregate;
  /** fetch data from the table: "student_attendance_status" using primary key columns */
  student_attendance_status_by_pk?: Maybe<student_attendance_status>;
  /** fetch data from the table: "student_batch_classes_batch_class" */
  student_batch_classes_batch_class: Array<student_batch_classes_batch_class>;
  /** fetch aggregated fields from the table: "student_batch_classes_batch_class" */
  student_batch_classes_batch_class_aggregate: student_batch_classes_batch_class_aggregate;
  /** fetch data from the table: "student_batch_classes_batch_class" using primary key columns */
  student_batch_classes_batch_class_by_pk?: Maybe<student_batch_classes_batch_class>;
  /** fetch data from the table: "student_batch_history" */
  student_batch_history: Array<student_batch_history>;
  /** fetch aggregated fields from the table: "student_batch_history" */
  student_batch_history_aggregate: student_batch_history_aggregate;
  /** fetch data from the table: "student_batch_history" using primary key columns */
  student_batch_history_by_pk?: Maybe<student_batch_history>;
  /** fetch data from the table: "student_batch_history_subject" */
  student_batch_history_subject: Array<student_batch_history_subject>;
  /** fetch aggregated fields from the table: "student_batch_history_subject" */
  student_batch_history_subject_aggregate: student_batch_history_subject_aggregate;
  /** fetch data from the table: "student_batch_history_subject" using primary key columns */
  student_batch_history_subject_by_pk?: Maybe<student_batch_history_subject>;
  /** fetch data from the table: "student" using primary key columns */
  student_by_pk?: Maybe<student>;
  /** fetch data from the table: "student_course" */
  student_course: Array<student_course>;
  /** fetch aggregated fields from the table: "student_course" */
  student_course_aggregate: student_course_aggregate;
  /** fetch data from the table: "student_course" using primary key columns */
  student_course_by_pk?: Maybe<student_course>;
  /** fetch data from the table: "student_external_engagement_info" */
  student_external_engagement_info: Array<student_external_engagement_info>;
  /** fetch aggregated fields from the table: "student_external_engagement_info" */
  student_external_engagement_info_aggregate: student_external_engagement_info_aggregate;
  /** fetch data from the table: "student_external_engagement_request" */
  student_external_engagement_request: Array<student_external_engagement_request>;
  /** fetch aggregated fields from the table: "student_external_engagement_request" */
  student_external_engagement_request_aggregate: student_external_engagement_request_aggregate;
  /** fetch data from the table: "student_external_engagement_request" using primary key columns */
  student_external_engagement_request_by_pk?: Maybe<student_external_engagement_request>;
  /** fetch data from the table: "student_familiarization_form" */
  student_familiarization_form: Array<student_familiarization_form>;
  /** fetch aggregated fields from the table: "student_familiarization_form" */
  student_familiarization_form_aggregate: student_familiarization_form_aggregate;
  /** fetch data from the table: "student_familiarization_form" using primary key columns */
  student_familiarization_form_by_pk?: Maybe<student_familiarization_form>;
  /** fetch data from the table: "student_familiarization_interview" */
  student_familiarization_interview: Array<student_familiarization_interview>;
  /** fetch aggregated fields from the table: "student_familiarization_interview" */
  student_familiarization_interview_aggregate: student_familiarization_interview_aggregate;
  /** fetch data from the table: "student_familiarization_interview" using primary key columns */
  student_familiarization_interview_by_pk?: Maybe<student_familiarization_interview>;
  /** fetch data from the table: "student_for_batch" */
  student_for_batch: Array<student_for_batch>;
  /** fetch aggregated fields from the table: "student_for_batch" */
  student_for_batch_aggregate: student_for_batch_aggregate;
  /** fetch data from the table: "student_general_request" */
  student_general_request: Array<student_general_request>;
  /** fetch aggregated fields from the table: "student_general_request" */
  student_general_request_aggregate: student_general_request_aggregate;
  /** fetch data from the table: "student_general_request" using primary key columns */
  student_general_request_by_pk?: Maybe<student_general_request>;
  /** fetch data from the table: "student_medical_request" */
  student_medical_request: Array<student_medical_request>;
  /** fetch aggregated fields from the table: "student_medical_request" */
  student_medical_request_aggregate: student_medical_request_aggregate;
  /** fetch data from the table: "student_medical_request" using primary key columns */
  student_medical_request_by_pk?: Maybe<student_medical_request>;
  /** fetch data from the table: "student_performance" */
  student_performance: Array<student_performance>;
  /** fetch aggregated fields from the table: "student_performance" */
  student_performance_aggregate: student_performance_aggregate;
  /** fetch data from the table: "student_performance" using primary key columns */
  student_performance_by_pk?: Maybe<student_performance>;
  /** fetch data from the table: "student_request" */
  student_request: Array<student_request>;
  /** fetch aggregated fields from the table: "student_request" */
  student_request_aggregate: student_request_aggregate;
  /** fetch data from the table: "student_request" using primary key columns */
  student_request_by_pk?: Maybe<student_request>;
  /** fetch data from the table: "student_request_message" */
  student_request_message: Array<student_request_message>;
  /** fetch aggregated fields from the table: "student_request_message" */
  student_request_message_aggregate: student_request_message_aggregate;
  /** fetch data from the table: "student_request_message" using primary key columns */
  student_request_message_by_pk?: Maybe<student_request_message>;
  /** fetch data from the table: "student_request_requestee" */
  student_request_requestee: Array<student_request_requestee>;
  /** fetch aggregated fields from the table: "student_request_requestee" */
  student_request_requestee_aggregate: student_request_requestee_aggregate;
  /** fetch data from the table: "student_request_requestee" using primary key columns */
  student_request_requestee_by_pk?: Maybe<student_request_requestee>;
  /** fetch data from the table: "student_request_status" */
  student_request_status: Array<student_request_status>;
  /** fetch aggregated fields from the table: "student_request_status" */
  student_request_status_aggregate: student_request_status_aggregate;
  /** fetch data from the table: "student_request_status" using primary key columns */
  student_request_status_by_pk?: Maybe<student_request_status>;
  /** fetch data from the table: "student_result" */
  student_result: Array<student_result>;
  /** fetch aggregated fields from the table: "student_result" */
  student_result_aggregate: student_result_aggregate;
  /** fetch data from the table: "student_result" using primary key columns */
  student_result_by_pk?: Maybe<student_result>;
  /** fetch data from the table: "student_result_sheet" */
  student_result_sheet: Array<student_result_sheet>;
  /** fetch aggregated fields from the table: "student_result_sheet" */
  student_result_sheet_aggregate: student_result_sheet_aggregate;
  /** fetch data from the table: "student_result_sheet" using primary key columns */
  student_result_sheet_by_pk?: Maybe<student_result_sheet>;
  /** fetch data from the table: "student_self_editable_information" */
  student_self_editable_information: Array<student_self_editable_information>;
  /** fetch aggregated fields from the table: "student_self_editable_information" */
  student_self_editable_information_aggregate: student_self_editable_information_aggregate;
  /** fetch data from the table: "student_status" */
  student_status: Array<student_status>;
  /** fetch aggregated fields from the table: "student_status" */
  student_status_aggregate: student_status_aggregate;
  /** fetch data from the table: "student_status" using primary key columns */
  student_status_by_pk?: Maybe<student_status>;
  /** fetch data from the table: "student_timetable_item" */
  student_timetable_item: Array<student_timetable_item>;
  /** fetch aggregated fields from the table: "student_timetable_item" */
  student_timetable_item_aggregate: student_timetable_item_aggregate;
  /** fetch data from the table: "subject" */
  subject: Array<subject>;
  /** fetch aggregated fields from the table: "subject" */
  subject_aggregate: subject_aggregate;
  /** fetch data from the table: "subject" using primary key columns */
  subject_by_pk?: Maybe<subject>;
  /** fetch data from the table: "subject_extra_slot" */
  subject_extra_slot: Array<subject_extra_slot>;
  /** fetch aggregated fields from the table: "subject_extra_slot" */
  subject_extra_slot_aggregate: subject_extra_slot_aggregate;
  /** fetch data from the table: "subject_extra_slot" using primary key columns */
  subject_extra_slot_by_pk?: Maybe<subject_extra_slot>;
  /** fetch data from the table: "subject_to_user" */
  subject_to_user: Array<subject_to_user>;
  /** fetch aggregated fields from the table: "subject_to_user" */
  subject_to_user_aggregate: subject_to_user_aggregate;
  /** fetch data from the table: "subject_to_user" using primary key columns */
  subject_to_user_by_pk?: Maybe<subject_to_user>;
  /** fetch data from the table: "timetable_item" */
  timetable_item: Array<timetable_item>;
  /** fetch aggregated fields from the table: "timetable_item" */
  timetable_item_aggregate: timetable_item_aggregate;
  /** fetch data from the table: "timetable_item" using primary key columns */
  timetable_item_by_pk?: Maybe<timetable_item>;
  /** fetch data from the table: "timetable_timeslot_configuration" */
  timetable_timeslot_configuration: Array<timetable_timeslot_configuration>;
  /** fetch aggregated fields from the table: "timetable_timeslot_configuration" */
  timetable_timeslot_configuration_aggregate: timetable_timeslot_configuration_aggregate;
  /** fetch data from the table: "timetable_timeslot_configuration" using primary key columns */
  timetable_timeslot_configuration_by_pk?: Maybe<timetable_timeslot_configuration>;
  /** fetch data from the table: "user" */
  user: Array<user>;
  /** fetch aggregated fields from the table: "user" */
  user_aggregate: user_aggregate;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<user>;
  /** fetch data from the table: "user_performance_public" */
  user_performance_public: Array<user_performance_public>;
  /** fetch aggregated fields from the table: "user_performance_public" */
  user_performance_public_aggregate: user_performance_public_aggregate;
  /** fetch data from the table: "user_public" */
  user_public: Array<user_public>;
  /** fetch aggregated fields from the table: "user_public" */
  user_public_aggregate: user_public_aggregate;
  /** fetch data from the table: "user_role" */
  user_role: Array<user_role>;
  /** fetch aggregated fields from the table: "user_role" */
  user_role_aggregate: user_role_aggregate;
  /** fetch data from the table: "user_role" using primary key columns */
  user_role_by_pk?: Maybe<user_role>;
  /** fetch data from the table: "user_role_routes_route" */
  user_role_routes_route: Array<user_role_routes_route>;
  /** fetch aggregated fields from the table: "user_role_routes_route" */
  user_role_routes_route_aggregate: user_role_routes_route_aggregate;
  /** fetch data from the table: "user_role_routes_route" using primary key columns */
  user_role_routes_route_by_pk?: Maybe<user_role_routes_route>;
  /** fetch data from the table: "user_routes_route" */
  user_routes_route: Array<user_routes_route>;
  /** fetch aggregated fields from the table: "user_routes_route" */
  user_routes_route_aggregate: user_routes_route_aggregate;
  /** fetch data from the table: "user_routes_route" using primary key columns */
  user_routes_route_by_pk?: Maybe<user_routes_route>;
  /** fetch data from the table: "user_user_roles_user_role" */
  user_user_roles_user_role: Array<user_user_roles_user_role>;
  /** fetch aggregated fields from the table: "user_user_roles_user_role" */
  user_user_roles_user_role_aggregate: user_user_roles_user_role_aggregate;
  /** fetch data from the table: "user_user_roles_user_role" using primary key columns */
  user_user_roles_user_role_by_pk?: Maybe<user_user_roles_user_role>;
  /** fetch data from the table: "withdrawn_request" */
  withdrawn_request: Array<withdrawn_request>;
  /** fetch aggregated fields from the table: "withdrawn_request" */
  withdrawn_request_aggregate: withdrawn_request_aggregate;
};

export type subscription_rootacademic_calendar_itemArgs = {
  distinct_on?: Maybe<Array<academic_calendar_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<academic_calendar_item_order_by>>;
  where?: Maybe<academic_calendar_item_bool_exp>;
};

export type subscription_rootacademic_calendar_item_aggregateArgs = {
  distinct_on?: Maybe<Array<academic_calendar_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<academic_calendar_item_order_by>>;
  where?: Maybe<academic_calendar_item_bool_exp>;
};

export type subscription_rootacademic_calendar_item_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootactive_batchArgs = {
  distinct_on?: Maybe<Array<active_batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<active_batch_order_by>>;
  where?: Maybe<active_batch_bool_exp>;
};

export type subscription_rootactive_batch_aggregateArgs = {
  distinct_on?: Maybe<Array<active_batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<active_batch_order_by>>;
  where?: Maybe<active_batch_bool_exp>;
};

export type subscription_rootassessmentArgs = {
  distinct_on?: Maybe<Array<assessment_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<assessment_order_by>>;
  where?: Maybe<assessment_bool_exp>;
};

export type subscription_rootassessment_aggregateArgs = {
  distinct_on?: Maybe<Array<assessment_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<assessment_order_by>>;
  where?: Maybe<assessment_bool_exp>;
};

export type subscription_rootassessment_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootattendanceArgs = {
  distinct_on?: Maybe<Array<attendance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_order_by>>;
  where?: Maybe<attendance_bool_exp>;
};

export type subscription_rootattendance_aggregateArgs = {
  distinct_on?: Maybe<Array<attendance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_order_by>>;
  where?: Maybe<attendance_bool_exp>;
};

export type subscription_rootattendance_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootattendance_studentArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

export type subscription_rootattendance_student_aggregateArgs = {
  distinct_on?: Maybe<Array<attendance_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_student_order_by>>;
  where?: Maybe<attendance_student_bool_exp>;
};

export type subscription_rootattendance_student_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootbatchArgs = {
  distinct_on?: Maybe<Array<batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_order_by>>;
  where?: Maybe<batch_bool_exp>;
};

export type subscription_rootbatch_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_order_by>>;
  where?: Maybe<batch_bool_exp>;
};

export type subscription_rootbatch_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootbatch_classArgs = {
  distinct_on?: Maybe<Array<batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_order_by>>;
  where?: Maybe<batch_class_bool_exp>;
};

export type subscription_rootbatch_class_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_order_by>>;
  where?: Maybe<batch_class_bool_exp>;
};

export type subscription_rootbatch_class_batch_subject_configurationsArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_configurations_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_configurations_order_by>>;
  where?: Maybe<batch_class_batch_subject_configurations_bool_exp>;
};

export type subscription_rootbatch_class_batch_subject_configurations_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_configurations_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_configurations_order_by>>;
  where?: Maybe<batch_class_batch_subject_configurations_bool_exp>;
};

export type subscription_rootbatch_class_batch_subject_extra_slotArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_class_batch_subject_extra_slot_bool_exp>;
};

export type subscription_rootbatch_class_batch_subject_extra_slot_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_class_batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_class_batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_class_batch_subject_extra_slot_bool_exp>;
};

export type subscription_rootbatch_class_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootbatch_subject_configurationArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

export type subscription_rootbatch_subject_configuration_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_subject_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_configuration_order_by>>;
  where?: Maybe<batch_subject_configuration_bool_exp>;
};

export type subscription_rootbatch_subject_configuration_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootbatch_subject_extra_slotArgs = {
  distinct_on?: Maybe<Array<batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_subject_extra_slot_bool_exp>;
};

export type subscription_rootbatch_subject_extra_slot_aggregateArgs = {
  distinct_on?: Maybe<Array<batch_subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<batch_subject_extra_slot_order_by>>;
  where?: Maybe<batch_subject_extra_slot_bool_exp>;
};

export type subscription_rootbatch_subject_extra_slot_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootblood_typeArgs = {
  distinct_on?: Maybe<Array<blood_type_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<blood_type_order_by>>;
  where?: Maybe<blood_type_bool_exp>;
};

export type subscription_rootblood_type_aggregateArgs = {
  distinct_on?: Maybe<Array<blood_type_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<blood_type_order_by>>;
  where?: Maybe<blood_type_bool_exp>;
};

export type subscription_rootblood_type_by_pkArgs = {
  name: Scalars['String'];
};

export type subscription_rootcourseArgs = {
  distinct_on?: Maybe<Array<course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_order_by>>;
  where?: Maybe<course_bool_exp>;
};

export type subscription_rootcourse_aggregateArgs = {
  distinct_on?: Maybe<Array<course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_order_by>>;
  where?: Maybe<course_bool_exp>;
};

export type subscription_rootcourse_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootcourse_coordinatorArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

export type subscription_rootcourse_coordinator_aggregateArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

export type subscription_rootcourse_coordinator_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootcourse_levelArgs = {
  distinct_on?: Maybe<Array<course_level_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_level_order_by>>;
  where?: Maybe<course_level_bool_exp>;
};

export type subscription_rootcourse_level_aggregateArgs = {
  distinct_on?: Maybe<Array<course_level_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_level_order_by>>;
  where?: Maybe<course_level_bool_exp>;
};

export type subscription_rootcourse_level_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootcourse_semesterArgs = {
  distinct_on?: Maybe<Array<course_semester_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_order_by>>;
  where?: Maybe<course_semester_bool_exp>;
};

export type subscription_rootcourse_semester_aggregateArgs = {
  distinct_on?: Maybe<Array<course_semester_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_order_by>>;
  where?: Maybe<course_semester_bool_exp>;
};

export type subscription_rootcourse_semester_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootcourse_semester_subjects_subjectArgs = {
  distinct_on?: Maybe<Array<course_semester_subjects_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_subjects_subject_order_by>>;
  where?: Maybe<course_semester_subjects_subject_bool_exp>;
};

export type subscription_rootcourse_semester_subjects_subject_aggregateArgs = {
  distinct_on?: Maybe<Array<course_semester_subjects_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_semester_subjects_subject_order_by>>;
  where?: Maybe<course_semester_subjects_subject_bool_exp>;
};

export type subscription_rootcourse_semester_subjects_subject_by_pkArgs = {
  courseSemesterId: Scalars['uuid'];
  subjectId: Scalars['uuid'];
};

export type subscription_rootcurrent_studentArgs = {
  distinct_on?: Maybe<Array<current_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_order_by>>;
  where?: Maybe<current_student_bool_exp>;
};

export type subscription_rootcurrent_student_aggregateArgs = {
  distinct_on?: Maybe<Array<current_student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_order_by>>;
  where?: Maybe<current_student_bool_exp>;
};

export type subscription_rootcurrent_student_courseArgs = {
  distinct_on?: Maybe<Array<current_student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_course_order_by>>;
  where?: Maybe<current_student_course_bool_exp>;
};

export type subscription_rootcurrent_student_course_aggregateArgs = {
  distinct_on?: Maybe<Array<current_student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_course_order_by>>;
  where?: Maybe<current_student_course_bool_exp>;
};

export type subscription_rootcurrent_student_routes_routeArgs = {
  distinct_on?: Maybe<Array<current_student_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_routes_route_order_by>>;
  where?: Maybe<current_student_routes_route_bool_exp>;
};

export type subscription_rootcurrent_student_routes_route_aggregateArgs = {
  distinct_on?: Maybe<Array<current_student_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_student_routes_route_order_by>>;
  where?: Maybe<current_student_routes_route_bool_exp>;
};

export type subscription_rootcurrent_userArgs = {
  distinct_on?: Maybe<Array<current_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_order_by>>;
  where?: Maybe<current_user_bool_exp>;
};

export type subscription_rootcurrent_user_aggregateArgs = {
  distinct_on?: Maybe<Array<current_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_order_by>>;
  where?: Maybe<current_user_bool_exp>;
};

export type subscription_rootcurrent_user_routeArgs = {
  distinct_on?: Maybe<Array<current_user_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_route_order_by>>;
  where?: Maybe<current_user_route_bool_exp>;
};

export type subscription_rootcurrent_user_route_aggregateArgs = {
  distinct_on?: Maybe<Array<current_user_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_route_order_by>>;
  where?: Maybe<current_user_route_bool_exp>;
};

export type subscription_rootcurrent_user_routes_routeArgs = {
  distinct_on?: Maybe<Array<current_user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_routes_route_order_by>>;
  where?: Maybe<current_user_routes_route_bool_exp>;
};

export type subscription_rootcurrent_user_routes_route_aggregateArgs = {
  distinct_on?: Maybe<Array<current_user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<current_user_routes_route_order_by>>;
  where?: Maybe<current_user_routes_route_bool_exp>;
};

export type subscription_rootdepartmentArgs = {
  distinct_on?: Maybe<Array<department_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<department_order_by>>;
  where?: Maybe<department_bool_exp>;
};

export type subscription_rootdepartment_aggregateArgs = {
  distinct_on?: Maybe<Array<department_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<department_order_by>>;
  where?: Maybe<department_bool_exp>;
};

export type subscription_rootdepartment_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rooteducation_qualificationArgs = {
  distinct_on?: Maybe<Array<education_qualification_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<education_qualification_order_by>>;
  where?: Maybe<education_qualification_bool_exp>;
};

export type subscription_rooteducation_qualification_aggregateArgs = {
  distinct_on?: Maybe<Array<education_qualification_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<education_qualification_order_by>>;
  where?: Maybe<education_qualification_bool_exp>;
};

export type subscription_rooteducation_qualification_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootemployment_experienceArgs = {
  distinct_on?: Maybe<Array<employment_experience_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<employment_experience_order_by>>;
  where?: Maybe<employment_experience_bool_exp>;
};

export type subscription_rootemployment_experience_aggregateArgs = {
  distinct_on?: Maybe<Array<employment_experience_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<employment_experience_order_by>>;
  where?: Maybe<employment_experience_bool_exp>;
};

export type subscription_rootemployment_experience_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootendpointArgs = {
  distinct_on?: Maybe<Array<endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<endpoint_order_by>>;
  where?: Maybe<endpoint_bool_exp>;
};

export type subscription_rootendpoint_aggregateArgs = {
  distinct_on?: Maybe<Array<endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<endpoint_order_by>>;
  where?: Maybe<endpoint_bool_exp>;
};

export type subscription_rootendpoint_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootexit_interview_answerArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

export type subscription_rootexit_interview_answer_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_order_by>>;
  where?: Maybe<exit_interview_answer_bool_exp>;
};

export type subscription_rootexit_interview_answer_by_pkArgs = {
  questionId: Scalars['uuid'];
  studentId: Scalars['Int'];
};

export type subscription_rootexit_interview_answer_multi_choice_questionsArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_multi_choice_questions_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_multi_choice_questions_order_by>>;
  where?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
};

export type subscription_rootexit_interview_answer_multi_choice_questions_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_answer_multi_choice_questions_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_answer_multi_choice_questions_order_by>>;
  where?: Maybe<exit_interview_answer_multi_choice_questions_bool_exp>;
};

export type subscription_rootexit_interview_answer_multi_choice_questions_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootexit_interview_questionArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_order_by>>;
  where?: Maybe<exit_interview_question_bool_exp>;
};

export type subscription_rootexit_interview_question_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_order_by>>;
  where?: Maybe<exit_interview_question_bool_exp>;
};

export type subscription_rootexit_interview_question_answersArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_answers_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_answers_order_by>>;
  where?: Maybe<exit_interview_question_answers_bool_exp>;
};

export type subscription_rootexit_interview_question_answers_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_answers_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_answers_order_by>>;
  where?: Maybe<exit_interview_question_answers_bool_exp>;
};

export type subscription_rootexit_interview_question_answers_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootexit_interview_question_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootexit_interview_question_groupArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_group_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_group_order_by>>;
  where?: Maybe<exit_interview_question_group_bool_exp>;
};

export type subscription_rootexit_interview_question_group_aggregateArgs = {
  distinct_on?: Maybe<Array<exit_interview_question_group_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<exit_interview_question_group_order_by>>;
  where?: Maybe<exit_interview_question_group_bool_exp>;
};

export type subscription_rootexit_interview_question_group_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootinquiryArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

export type subscription_rootinquiry_aggregateArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

export type subscription_rootinquiry_by_pkArgs = {
  id: Scalars['Int'];
};

export type subscription_rootinquiry_status_enumArgs = {
  distinct_on?: Maybe<Array<inquiry_status_enum_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_status_enum_order_by>>;
  where?: Maybe<inquiry_status_enum_bool_exp>;
};

export type subscription_rootinquiry_status_enum_aggregateArgs = {
  distinct_on?: Maybe<Array<inquiry_status_enum_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_status_enum_order_by>>;
  where?: Maybe<inquiry_status_enum_bool_exp>;
};

export type subscription_rootinquiry_status_enum_by_pkArgs = {
  name: Scalars['String'];
};

export type subscription_rootintakeArgs = {
  distinct_on?: Maybe<Array<intake_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<intake_order_by>>;
  where?: Maybe<intake_bool_exp>;
};

export type subscription_rootintake_aggregateArgs = {
  distinct_on?: Maybe<Array<intake_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<intake_order_by>>;
  where?: Maybe<intake_bool_exp>;
};

export type subscription_rootintake_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootlecture_materialArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

export type subscription_rootlecture_material_aggregateArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

export type subscription_rootlecture_material_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootlecture_material_categoryArgs = {
  distinct_on?: Maybe<Array<lecture_material_category_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_category_order_by>>;
  where?: Maybe<lecture_material_category_bool_exp>;
};

export type subscription_rootlecture_material_category_aggregateArgs = {
  distinct_on?: Maybe<Array<lecture_material_category_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_category_order_by>>;
  where?: Maybe<lecture_material_category_bool_exp>;
};

export type subscription_rootlecture_material_category_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootlecturerArgs = {
  distinct_on?: Maybe<Array<lecturer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecturer_order_by>>;
  where?: Maybe<lecturer_bool_exp>;
};

export type subscription_rootlecturer_aggregateArgs = {
  distinct_on?: Maybe<Array<lecturer_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecturer_order_by>>;
  where?: Maybe<lecturer_bool_exp>;
};

export type subscription_rootlocationArgs = {
  distinct_on?: Maybe<Array<location_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<location_order_by>>;
  where?: Maybe<location_bool_exp>;
};

export type subscription_rootlocation_aggregateArgs = {
  distinct_on?: Maybe<Array<location_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<location_order_by>>;
  where?: Maybe<location_bool_exp>;
};

export type subscription_rootlocation_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootmulti_choice_questionArgs = {
  distinct_on?: Maybe<Array<multi_choice_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<multi_choice_question_order_by>>;
  where?: Maybe<multi_choice_question_bool_exp>;
};

export type subscription_rootmulti_choice_question_aggregateArgs = {
  distinct_on?: Maybe<Array<multi_choice_question_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<multi_choice_question_order_by>>;
  where?: Maybe<multi_choice_question_bool_exp>;
};

export type subscription_rootmulti_choice_question_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootperfomance_statusArgs = {
  distinct_on?: Maybe<Array<perfomance_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<perfomance_status_order_by>>;
  where?: Maybe<perfomance_status_bool_exp>;
};

export type subscription_rootperfomance_status_aggregateArgs = {
  distinct_on?: Maybe<Array<perfomance_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<perfomance_status_order_by>>;
  where?: Maybe<perfomance_status_bool_exp>;
};

export type subscription_rootperfomance_status_by_pkArgs = {
  name: Scalars['String'];
};

export type subscription_rootquestion_typeArgs = {
  distinct_on?: Maybe<Array<question_type_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<question_type_order_by>>;
  where?: Maybe<question_type_bool_exp>;
};

export type subscription_rootquestion_type_aggregateArgs = {
  distinct_on?: Maybe<Array<question_type_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<question_type_order_by>>;
  where?: Maybe<question_type_bool_exp>;
};

export type subscription_rootquestion_type_by_pkArgs = {
  name: Scalars['String'];
};

export type subscription_rootresult_sheetArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

export type subscription_rootresult_sheet_aggregateArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

export type subscription_rootresult_sheet_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootresult_sheet_statusArgs = {
  distinct_on?: Maybe<Array<result_sheet_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_status_order_by>>;
  where?: Maybe<result_sheet_status_bool_exp>;
};

export type subscription_rootresult_sheet_status_aggregateArgs = {
  distinct_on?: Maybe<Array<result_sheet_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_status_order_by>>;
  where?: Maybe<result_sheet_status_bool_exp>;
};

export type subscription_rootresult_sheet_status_by_pkArgs = {
  name: Scalars['String'];
};

export type subscription_rootrouteArgs = {
  distinct_on?: Maybe<Array<route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_order_by>>;
  where?: Maybe<route_bool_exp>;
};

export type subscription_rootroute_aggregateArgs = {
  distinct_on?: Maybe<Array<route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_order_by>>;
  where?: Maybe<route_bool_exp>;
};

export type subscription_rootroute_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootroute_endpoints_endpointArgs = {
  distinct_on?: Maybe<Array<route_endpoints_endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_endpoints_endpoint_order_by>>;
  where?: Maybe<route_endpoints_endpoint_bool_exp>;
};

export type subscription_rootroute_endpoints_endpoint_aggregateArgs = {
  distinct_on?: Maybe<Array<route_endpoints_endpoint_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<route_endpoints_endpoint_order_by>>;
  where?: Maybe<route_endpoints_endpoint_bool_exp>;
};

export type subscription_rootroute_endpoints_endpoint_by_pkArgs = {
  endpointId: Scalars['uuid'];
  routeId: Scalars['uuid'];
};

export type subscription_rootstudentArgs = {
  distinct_on?: Maybe<Array<student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_order_by>>;
  where?: Maybe<student_bool_exp>;
};

export type subscription_rootstudent_admin_editable_informationArgs = {
  distinct_on?: Maybe<Array<student_admin_editable_information_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_admin_editable_information_order_by>>;
  where?: Maybe<student_admin_editable_information_bool_exp>;
};

export type subscription_rootstudent_admin_editable_information_aggregateArgs = {
  distinct_on?: Maybe<Array<student_admin_editable_information_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_admin_editable_information_order_by>>;
  where?: Maybe<student_admin_editable_information_bool_exp>;
};

export type subscription_rootstudent_aggregateArgs = {
  distinct_on?: Maybe<Array<student_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_order_by>>;
  where?: Maybe<student_bool_exp>;
};

export type subscription_rootstudent_assessment_submissionArgs = {
  distinct_on?: Maybe<Array<student_assessment_submission_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_assessment_submission_order_by>>;
  where?: Maybe<student_assessment_submission_bool_exp>;
};

export type subscription_rootstudent_assessment_submission_aggregateArgs = {
  distinct_on?: Maybe<Array<student_assessment_submission_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_assessment_submission_order_by>>;
  where?: Maybe<student_assessment_submission_bool_exp>;
};

export type subscription_rootstudent_assessment_submission_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_attendance_statusArgs = {
  distinct_on?: Maybe<Array<student_attendance_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_attendance_status_order_by>>;
  where?: Maybe<student_attendance_status_bool_exp>;
};

export type subscription_rootstudent_attendance_status_aggregateArgs = {
  distinct_on?: Maybe<Array<student_attendance_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_attendance_status_order_by>>;
  where?: Maybe<student_attendance_status_bool_exp>;
};

export type subscription_rootstudent_attendance_status_by_pkArgs = {
  name: Scalars['String'];
};

export type subscription_rootstudent_batch_classes_batch_classArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

export type subscription_rootstudent_batch_classes_batch_class_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_classes_batch_class_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_classes_batch_class_order_by>>;
  where?: Maybe<student_batch_classes_batch_class_bool_exp>;
};

export type subscription_rootstudent_batch_classes_batch_class_by_pkArgs = {
  batchClassId: Scalars['uuid'];
  studentId: Scalars['Int'];
};

export type subscription_rootstudent_batch_historyArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

export type subscription_rootstudent_batch_history_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

export type subscription_rootstudent_batch_history_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_batch_history_subjectArgs = {
  distinct_on?: Maybe<Array<student_batch_history_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_subject_order_by>>;
  where?: Maybe<student_batch_history_subject_bool_exp>;
};

export type subscription_rootstudent_batch_history_subject_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_subject_order_by>>;
  where?: Maybe<student_batch_history_subject_bool_exp>;
};

export type subscription_rootstudent_batch_history_subject_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_by_pkArgs = {
  id: Scalars['Int'];
};

export type subscription_rootstudent_courseArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

export type subscription_rootstudent_course_aggregateArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

export type subscription_rootstudent_course_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_external_engagement_infoArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_info_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_info_order_by>>;
  where?: Maybe<student_external_engagement_info_bool_exp>;
};

export type subscription_rootstudent_external_engagement_info_aggregateArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_info_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_info_order_by>>;
  where?: Maybe<student_external_engagement_info_bool_exp>;
};

export type subscription_rootstudent_external_engagement_requestArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_request_order_by>>;
  where?: Maybe<student_external_engagement_request_bool_exp>;
};

export type subscription_rootstudent_external_engagement_request_aggregateArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_request_order_by>>;
  where?: Maybe<student_external_engagement_request_bool_exp>;
};

export type subscription_rootstudent_external_engagement_request_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_familiarization_formArgs = {
  distinct_on?: Maybe<Array<student_familiarization_form_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_form_order_by>>;
  where?: Maybe<student_familiarization_form_bool_exp>;
};

export type subscription_rootstudent_familiarization_form_aggregateArgs = {
  distinct_on?: Maybe<Array<student_familiarization_form_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_form_order_by>>;
  where?: Maybe<student_familiarization_form_bool_exp>;
};

export type subscription_rootstudent_familiarization_form_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_familiarization_interviewArgs = {
  distinct_on?: Maybe<Array<student_familiarization_interview_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_interview_order_by>>;
  where?: Maybe<student_familiarization_interview_bool_exp>;
};

export type subscription_rootstudent_familiarization_interview_aggregateArgs = {
  distinct_on?: Maybe<Array<student_familiarization_interview_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_familiarization_interview_order_by>>;
  where?: Maybe<student_familiarization_interview_bool_exp>;
};

export type subscription_rootstudent_familiarization_interview_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_for_batchArgs = {
  distinct_on?: Maybe<Array<student_for_batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_for_batch_order_by>>;
  where?: Maybe<student_for_batch_bool_exp>;
};

export type subscription_rootstudent_for_batch_aggregateArgs = {
  distinct_on?: Maybe<Array<student_for_batch_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_for_batch_order_by>>;
  where?: Maybe<student_for_batch_bool_exp>;
};

export type subscription_rootstudent_general_requestArgs = {
  distinct_on?: Maybe<Array<student_general_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_general_request_order_by>>;
  where?: Maybe<student_general_request_bool_exp>;
};

export type subscription_rootstudent_general_request_aggregateArgs = {
  distinct_on?: Maybe<Array<student_general_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_general_request_order_by>>;
  where?: Maybe<student_general_request_bool_exp>;
};

export type subscription_rootstudent_general_request_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_medical_requestArgs = {
  distinct_on?: Maybe<Array<student_medical_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_medical_request_order_by>>;
  where?: Maybe<student_medical_request_bool_exp>;
};

export type subscription_rootstudent_medical_request_aggregateArgs = {
  distinct_on?: Maybe<Array<student_medical_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_medical_request_order_by>>;
  where?: Maybe<student_medical_request_bool_exp>;
};

export type subscription_rootstudent_medical_request_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_performanceArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

export type subscription_rootstudent_performance_aggregateArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

export type subscription_rootstudent_performance_by_pkArgs = {
  id: Scalars['Int'];
};

export type subscription_rootstudent_requestArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

export type subscription_rootstudent_request_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

export type subscription_rootstudent_request_by_pkArgs = {
  id: Scalars['Int'];
};

export type subscription_rootstudent_request_messageArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

export type subscription_rootstudent_request_message_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

export type subscription_rootstudent_request_message_by_pkArgs = {
  id: Scalars['Int'];
};

export type subscription_rootstudent_request_requesteeArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

export type subscription_rootstudent_request_requestee_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

export type subscription_rootstudent_request_requestee_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_request_statusArgs = {
  distinct_on?: Maybe<Array<student_request_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_status_order_by>>;
  where?: Maybe<student_request_status_bool_exp>;
};

export type subscription_rootstudent_request_status_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_status_order_by>>;
  where?: Maybe<student_request_status_bool_exp>;
};

export type subscription_rootstudent_request_status_by_pkArgs = {
  name: Scalars['String'];
};

export type subscription_rootstudent_resultArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

export type subscription_rootstudent_result_aggregateArgs = {
  distinct_on?: Maybe<Array<student_result_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_order_by>>;
  where?: Maybe<student_result_bool_exp>;
};

export type subscription_rootstudent_result_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_result_sheetArgs = {
  distinct_on?: Maybe<Array<student_result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_sheet_order_by>>;
  where?: Maybe<student_result_sheet_bool_exp>;
};

export type subscription_rootstudent_result_sheet_aggregateArgs = {
  distinct_on?: Maybe<Array<student_result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_result_sheet_order_by>>;
  where?: Maybe<student_result_sheet_bool_exp>;
};

export type subscription_rootstudent_result_sheet_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootstudent_self_editable_informationArgs = {
  distinct_on?: Maybe<Array<student_self_editable_information_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_self_editable_information_order_by>>;
  where?: Maybe<student_self_editable_information_bool_exp>;
};

export type subscription_rootstudent_self_editable_information_aggregateArgs = {
  distinct_on?: Maybe<Array<student_self_editable_information_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_self_editable_information_order_by>>;
  where?: Maybe<student_self_editable_information_bool_exp>;
};

export type subscription_rootstudent_statusArgs = {
  distinct_on?: Maybe<Array<student_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_status_order_by>>;
  where?: Maybe<student_status_bool_exp>;
};

export type subscription_rootstudent_status_aggregateArgs = {
  distinct_on?: Maybe<Array<student_status_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_status_order_by>>;
  where?: Maybe<student_status_bool_exp>;
};

export type subscription_rootstudent_status_by_pkArgs = {
  name: Scalars['String'];
};

export type subscription_rootstudent_timetable_itemArgs = {
  distinct_on?: Maybe<Array<student_timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_timetable_item_order_by>>;
  where?: Maybe<student_timetable_item_bool_exp>;
};

export type subscription_rootstudent_timetable_item_aggregateArgs = {
  distinct_on?: Maybe<Array<student_timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_timetable_item_order_by>>;
  where?: Maybe<student_timetable_item_bool_exp>;
};

export type subscription_rootsubjectArgs = {
  distinct_on?: Maybe<Array<subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_order_by>>;
  where?: Maybe<subject_bool_exp>;
};

export type subscription_rootsubject_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_order_by>>;
  where?: Maybe<subject_bool_exp>;
};

export type subscription_rootsubject_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootsubject_extra_slotArgs = {
  distinct_on?: Maybe<Array<subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_extra_slot_order_by>>;
  where?: Maybe<subject_extra_slot_bool_exp>;
};

export type subscription_rootsubject_extra_slot_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_extra_slot_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_extra_slot_order_by>>;
  where?: Maybe<subject_extra_slot_bool_exp>;
};

export type subscription_rootsubject_extra_slot_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootsubject_to_userArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

export type subscription_rootsubject_to_user_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

export type subscription_rootsubject_to_user_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_roottimetable_itemArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

export type subscription_roottimetable_item_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

export type subscription_roottimetable_item_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_roottimetable_timeslot_configurationArgs = {
  distinct_on?: Maybe<Array<timetable_timeslot_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_timeslot_configuration_order_by>>;
  where?: Maybe<timetable_timeslot_configuration_bool_exp>;
};

export type subscription_roottimetable_timeslot_configuration_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_timeslot_configuration_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_timeslot_configuration_order_by>>;
  where?: Maybe<timetable_timeslot_configuration_bool_exp>;
};

export type subscription_roottimetable_timeslot_configuration_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootuserArgs = {
  distinct_on?: Maybe<Array<user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_order_by>>;
  where?: Maybe<user_bool_exp>;
};

export type subscription_rootuser_aggregateArgs = {
  distinct_on?: Maybe<Array<user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_order_by>>;
  where?: Maybe<user_bool_exp>;
};

export type subscription_rootuser_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootuser_performance_publicArgs = {
  distinct_on?: Maybe<Array<user_performance_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_performance_public_order_by>>;
  where?: Maybe<user_performance_public_bool_exp>;
};

export type subscription_rootuser_performance_public_aggregateArgs = {
  distinct_on?: Maybe<Array<user_performance_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_performance_public_order_by>>;
  where?: Maybe<user_performance_public_bool_exp>;
};

export type subscription_rootuser_publicArgs = {
  distinct_on?: Maybe<Array<user_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_public_order_by>>;
  where?: Maybe<user_public_bool_exp>;
};

export type subscription_rootuser_public_aggregateArgs = {
  distinct_on?: Maybe<Array<user_public_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_public_order_by>>;
  where?: Maybe<user_public_bool_exp>;
};

export type subscription_rootuser_roleArgs = {
  distinct_on?: Maybe<Array<user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_order_by>>;
  where?: Maybe<user_role_bool_exp>;
};

export type subscription_rootuser_role_aggregateArgs = {
  distinct_on?: Maybe<Array<user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_order_by>>;
  where?: Maybe<user_role_bool_exp>;
};

export type subscription_rootuser_role_by_pkArgs = {
  id: Scalars['uuid'];
};

export type subscription_rootuser_role_routes_routeArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

export type subscription_rootuser_role_routes_route_aggregateArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

export type subscription_rootuser_role_routes_route_by_pkArgs = {
  routeId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
};

export type subscription_rootuser_routes_routeArgs = {
  distinct_on?: Maybe<Array<user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_routes_route_order_by>>;
  where?: Maybe<user_routes_route_bool_exp>;
};

export type subscription_rootuser_routes_route_aggregateArgs = {
  distinct_on?: Maybe<Array<user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_routes_route_order_by>>;
  where?: Maybe<user_routes_route_bool_exp>;
};

export type subscription_rootuser_routes_route_by_pkArgs = {
  routeId: Scalars['uuid'];
  userId: Scalars['uuid'];
};

export type subscription_rootuser_user_roles_user_roleArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

export type subscription_rootuser_user_roles_user_role_aggregateArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

export type subscription_rootuser_user_roles_user_role_by_pkArgs = {
  userId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
};

export type subscription_rootwithdrawn_requestArgs = {
  distinct_on?: Maybe<Array<withdrawn_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<withdrawn_request_order_by>>;
  where?: Maybe<withdrawn_request_bool_exp>;
};

export type subscription_rootwithdrawn_request_aggregateArgs = {
  distinct_on?: Maybe<Array<withdrawn_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<withdrawn_request_order_by>>;
  where?: Maybe<withdrawn_request_bool_exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type timestamp_comparison_exp = {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type timestamptz_comparison_exp = {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "timetable_item" */
export type timetable_item = {
  __typename?: 'timetable_item';
  /** An array relationship */
  attendances: Array<attendance>;
  /** An aggregate relationship */
  attendances_aggregate: attendance_aggregate;
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  batch_class?: Maybe<batch_class>;
  /** An object relationship */
  batch_subject_configuration?: Maybe<batch_subject_configuration>;
  /** An object relationship */
  batch_subject_extra_slot?: Maybe<batch_subject_extra_slot>;
  createUserId?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  /** An object relationship */
  location?: Maybe<location>;
  locationId?: Maybe<Scalars['uuid']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  student_external_engagement_requests: Array<student_external_engagement_request>;
  /** An aggregate relationship */
  student_external_engagement_requests_aggregate: student_external_engagement_request_aggregate;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user?: Maybe<user>;
  /** An object relationship */
  userByCreateuserid?: Maybe<user>;
  userId?: Maybe<Scalars['uuid']>;
};

/** columns and relationships of "timetable_item" */
export type timetable_itemattendancesArgs = {
  distinct_on?: Maybe<Array<attendance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_order_by>>;
  where?: Maybe<attendance_bool_exp>;
};

/** columns and relationships of "timetable_item" */
export type timetable_itemattendances_aggregateArgs = {
  distinct_on?: Maybe<Array<attendance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<attendance_order_by>>;
  where?: Maybe<attendance_bool_exp>;
};

/** columns and relationships of "timetable_item" */
export type timetable_itemstudent_external_engagement_requestsArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_request_order_by>>;
  where?: Maybe<student_external_engagement_request_bool_exp>;
};

/** columns and relationships of "timetable_item" */
export type timetable_itemstudent_external_engagement_requests_aggregateArgs = {
  distinct_on?: Maybe<Array<student_external_engagement_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_external_engagement_request_order_by>>;
  where?: Maybe<student_external_engagement_request_bool_exp>;
};

/** aggregated selection of "timetable_item" */
export type timetable_item_aggregate = {
  __typename?: 'timetable_item_aggregate';
  aggregate?: Maybe<timetable_item_aggregate_fields>;
  nodes: Array<timetable_item>;
};

/** aggregate fields of "timetable_item" */
export type timetable_item_aggregate_fields = {
  __typename?: 'timetable_item_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<timetable_item_max_fields>;
  min?: Maybe<timetable_item_min_fields>;
};

/** aggregate fields of "timetable_item" */
export type timetable_item_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<timetable_item_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "timetable_item" */
export type timetable_item_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<timetable_item_max_order_by>;
  min?: Maybe<timetable_item_min_order_by>;
};

/** input type for inserting array relation for remote table "timetable_item" */
export type timetable_item_arr_rel_insert_input = {
  data: Array<timetable_item_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<timetable_item_on_conflict>;
};

/** Boolean expression to filter rows from the table "timetable_item". All fields are combined with a logical 'AND'. */
export type timetable_item_bool_exp = {
  _and?: Maybe<Array<timetable_item_bool_exp>>;
  _not?: Maybe<timetable_item_bool_exp>;
  _or?: Maybe<Array<timetable_item_bool_exp>>;
  attendances?: Maybe<attendance_bool_exp>;
  batchClassId?: Maybe<uuid_comparison_exp>;
  batchSubjectConfigurationId?: Maybe<uuid_comparison_exp>;
  batchSubjectExtraSlotId?: Maybe<uuid_comparison_exp>;
  batch_class?: Maybe<batch_class_bool_exp>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_bool_exp>;
  batch_subject_extra_slot?: Maybe<batch_subject_extra_slot_bool_exp>;
  createUserId?: Maybe<uuid_comparison_exp>;
  endTime?: Maybe<timestamptz_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  location?: Maybe<location_bool_exp>;
  locationId?: Maybe<uuid_comparison_exp>;
  published?: Maybe<Boolean_comparison_exp>;
  publishedAt?: Maybe<timestamp_comparison_exp>;
  startTime?: Maybe<timestamptz_comparison_exp>;
  student_external_engagement_requests?: Maybe<student_external_engagement_request_bool_exp>;
  updated_at?: Maybe<timestamptz_comparison_exp>;
  user?: Maybe<user_bool_exp>;
  userByCreateuserid?: Maybe<user_bool_exp>;
  userId?: Maybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "timetable_item" */
export enum timetable_item_constraint {
  /** unique or primary key constraint */
  PK_ff34dca3be28b7c867bda178c66 = 'PK_ff34dca3be28b7c867bda178c66',
}

/** input type for inserting data into table "timetable_item" */
export type timetable_item_insert_input = {
  attendances?: Maybe<attendance_arr_rel_insert_input>;
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  batch_class?: Maybe<batch_class_obj_rel_insert_input>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_obj_rel_insert_input>;
  batch_subject_extra_slot?: Maybe<batch_subject_extra_slot_obj_rel_insert_input>;
  createUserId?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  location?: Maybe<location_obj_rel_insert_input>;
  locationId?: Maybe<Scalars['uuid']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  student_external_engagement_requests?: Maybe<student_external_engagement_request_arr_rel_insert_input>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<user_obj_rel_insert_input>;
  userByCreateuserid?: Maybe<user_obj_rel_insert_input>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type timetable_item_max_fields = {
  __typename?: 'timetable_item_max_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  createUserId?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  locationId?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "timetable_item" */
export type timetable_item_max_order_by = {
  batchClassId?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  batchSubjectExtraSlotId?: Maybe<order_by>;
  createUserId?: Maybe<order_by>;
  endTime?: Maybe<order_by>;
  id?: Maybe<order_by>;
  locationId?: Maybe<order_by>;
  publishedAt?: Maybe<order_by>;
  startTime?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type timetable_item_min_fields = {
  __typename?: 'timetable_item_min_fields';
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  createUserId?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  locationId?: Maybe<Scalars['uuid']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "timetable_item" */
export type timetable_item_min_order_by = {
  batchClassId?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  batchSubjectExtraSlotId?: Maybe<order_by>;
  createUserId?: Maybe<order_by>;
  endTime?: Maybe<order_by>;
  id?: Maybe<order_by>;
  locationId?: Maybe<order_by>;
  publishedAt?: Maybe<order_by>;
  startTime?: Maybe<order_by>;
  updated_at?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** response of any mutation on the table "timetable_item" */
export type timetable_item_mutation_response = {
  __typename?: 'timetable_item_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<timetable_item>;
};

/** input type for inserting object relation for remote table "timetable_item" */
export type timetable_item_obj_rel_insert_input = {
  data: timetable_item_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<timetable_item_on_conflict>;
};

/** on conflict condition type for table "timetable_item" */
export type timetable_item_on_conflict = {
  constraint: timetable_item_constraint;
  update_columns?: Array<timetable_item_update_column>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** Ordering options when selecting data from "timetable_item". */
export type timetable_item_order_by = {
  attendances_aggregate?: Maybe<attendance_aggregate_order_by>;
  batchClassId?: Maybe<order_by>;
  batchSubjectConfigurationId?: Maybe<order_by>;
  batchSubjectExtraSlotId?: Maybe<order_by>;
  batch_class?: Maybe<batch_class_order_by>;
  batch_subject_configuration?: Maybe<batch_subject_configuration_order_by>;
  batch_subject_extra_slot?: Maybe<batch_subject_extra_slot_order_by>;
  createUserId?: Maybe<order_by>;
  endTime?: Maybe<order_by>;
  id?: Maybe<order_by>;
  location?: Maybe<location_order_by>;
  locationId?: Maybe<order_by>;
  published?: Maybe<order_by>;
  publishedAt?: Maybe<order_by>;
  startTime?: Maybe<order_by>;
  student_external_engagement_requests_aggregate?: Maybe<student_external_engagement_request_aggregate_order_by>;
  updated_at?: Maybe<order_by>;
  user?: Maybe<user_order_by>;
  userByCreateuserid?: Maybe<user_order_by>;
  userId?: Maybe<order_by>;
};

/** primary key columns input for table: timetable_item */
export type timetable_item_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "timetable_item" */
export enum timetable_item_select_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  batchSubjectExtraSlotId = 'batchSubjectExtraSlotId',
  /** column name */
  createUserId = 'createUserId',
  /** column name */
  endTime = 'endTime',
  /** column name */
  id = 'id',
  /** column name */
  locationId = 'locationId',
  /** column name */
  published = 'published',
  /** column name */
  publishedAt = 'publishedAt',
  /** column name */
  startTime = 'startTime',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  userId = 'userId',
}

/** input type for updating data in table "timetable_item" */
export type timetable_item_set_input = {
  batchClassId?: Maybe<Scalars['uuid']>;
  batchSubjectConfigurationId?: Maybe<Scalars['uuid']>;
  batchSubjectExtraSlotId?: Maybe<Scalars['uuid']>;
  createUserId?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  locationId?: Maybe<Scalars['uuid']>;
  published?: Maybe<Scalars['Boolean']>;
  publishedAt?: Maybe<Scalars['timestamp']>;
  startTime?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "timetable_item" */
export enum timetable_item_update_column {
  /** column name */
  batchClassId = 'batchClassId',
  /** column name */
  batchSubjectConfigurationId = 'batchSubjectConfigurationId',
  /** column name */
  batchSubjectExtraSlotId = 'batchSubjectExtraSlotId',
  /** column name */
  createUserId = 'createUserId',
  /** column name */
  endTime = 'endTime',
  /** column name */
  id = 'id',
  /** column name */
  locationId = 'locationId',
  /** column name */
  published = 'published',
  /** column name */
  publishedAt = 'publishedAt',
  /** column name */
  startTime = 'startTime',
  /** column name */
  updated_at = 'updated_at',
  /** column name */
  userId = 'userId',
}

/** columns and relationships of "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration = {
  __typename?: 'timetable_timeslot_configuration';
  /** An object relationship */
  batch?: Maybe<batch>;
  batchId?: Maybe<Scalars['uuid']>;
  day: Scalars['weekdays'];
  default: Scalars['Boolean'];
  endTime: Scalars['timestamptz'];
  id: Scalars['uuid'];
  interval: Scalars['Boolean'];
  startTime: Scalars['timestamptz'];
};

/** aggregated selection of "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_aggregate = {
  __typename?: 'timetable_timeslot_configuration_aggregate';
  aggregate?: Maybe<timetable_timeslot_configuration_aggregate_fields>;
  nodes: Array<timetable_timeslot_configuration>;
};

/** aggregate fields of "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_aggregate_fields = {
  __typename?: 'timetable_timeslot_configuration_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<timetable_timeslot_configuration_max_fields>;
  min?: Maybe<timetable_timeslot_configuration_min_fields>;
};

/** aggregate fields of "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<timetable_timeslot_configuration_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<timetable_timeslot_configuration_max_order_by>;
  min?: Maybe<timetable_timeslot_configuration_min_order_by>;
};

/** input type for inserting array relation for remote table "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_arr_rel_insert_input = {
  data: Array<timetable_timeslot_configuration_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<timetable_timeslot_configuration_on_conflict>;
};

/** Boolean expression to filter rows from the table "timetable_timeslot_configuration". All fields are combined with a logical 'AND'. */
export type timetable_timeslot_configuration_bool_exp = {
  _and?: Maybe<Array<timetable_timeslot_configuration_bool_exp>>;
  _not?: Maybe<timetable_timeslot_configuration_bool_exp>;
  _or?: Maybe<Array<timetable_timeslot_configuration_bool_exp>>;
  batch?: Maybe<batch_bool_exp>;
  batchId?: Maybe<uuid_comparison_exp>;
  day?: Maybe<weekdays_comparison_exp>;
  default?: Maybe<Boolean_comparison_exp>;
  endTime?: Maybe<timestamptz_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  interval?: Maybe<Boolean_comparison_exp>;
  startTime?: Maybe<timestamptz_comparison_exp>;
};

/** unique or primary key constraints on table "timetable_timeslot_configuration" */
export enum timetable_timeslot_configuration_constraint {
  /** unique or primary key constraint */
  timetable_timeslot_configuration_pkey = 'timetable_timeslot_configuration_pkey',
}

/** input type for inserting data into table "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_insert_input = {
  batch?: Maybe<batch_obj_rel_insert_input>;
  batchId?: Maybe<Scalars['uuid']>;
  day?: Maybe<Scalars['weekdays']>;
  default?: Maybe<Scalars['Boolean']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  interval?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type timetable_timeslot_configuration_max_fields = {
  __typename?: 'timetable_timeslot_configuration_max_fields';
  batchId?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  startTime?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_max_order_by = {
  batchId?: Maybe<order_by>;
  endTime?: Maybe<order_by>;
  id?: Maybe<order_by>;
  startTime?: Maybe<order_by>;
};

/** aggregate min on columns */
export type timetable_timeslot_configuration_min_fields = {
  __typename?: 'timetable_timeslot_configuration_min_fields';
  batchId?: Maybe<Scalars['uuid']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  startTime?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_min_order_by = {
  batchId?: Maybe<order_by>;
  endTime?: Maybe<order_by>;
  id?: Maybe<order_by>;
  startTime?: Maybe<order_by>;
};

/** response of any mutation on the table "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_mutation_response = {
  __typename?: 'timetable_timeslot_configuration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<timetable_timeslot_configuration>;
};

/** on conflict condition type for table "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_on_conflict = {
  constraint: timetable_timeslot_configuration_constraint;
  update_columns?: Array<timetable_timeslot_configuration_update_column>;
  where?: Maybe<timetable_timeslot_configuration_bool_exp>;
};

/** Ordering options when selecting data from "timetable_timeslot_configuration". */
export type timetable_timeslot_configuration_order_by = {
  batch?: Maybe<batch_order_by>;
  batchId?: Maybe<order_by>;
  day?: Maybe<order_by>;
  default?: Maybe<order_by>;
  endTime?: Maybe<order_by>;
  id?: Maybe<order_by>;
  interval?: Maybe<order_by>;
  startTime?: Maybe<order_by>;
};

/** primary key columns input for table: timetable_timeslot_configuration */
export type timetable_timeslot_configuration_pk_columns_input = {
  id: Scalars['uuid'];
};

/** select columns of table "timetable_timeslot_configuration" */
export enum timetable_timeslot_configuration_select_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  day = 'day',
  /** column name */
  default = 'default',
  /** column name */
  endTime = 'endTime',
  /** column name */
  id = 'id',
  /** column name */
  interval = 'interval',
  /** column name */
  startTime = 'startTime',
}

/** input type for updating data in table "timetable_timeslot_configuration" */
export type timetable_timeslot_configuration_set_input = {
  batchId?: Maybe<Scalars['uuid']>;
  day?: Maybe<Scalars['weekdays']>;
  default?: Maybe<Scalars['Boolean']>;
  endTime?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  interval?: Maybe<Scalars['Boolean']>;
  startTime?: Maybe<Scalars['timestamptz']>;
};

/** update columns of table "timetable_timeslot_configuration" */
export enum timetable_timeslot_configuration_update_column {
  /** column name */
  batchId = 'batchId',
  /** column name */
  day = 'day',
  /** column name */
  default = 'default',
  /** column name */
  endTime = 'endTime',
  /** column name */
  id = 'id',
  /** column name */
  interval = 'interval',
  /** column name */
  startTime = 'startTime',
}

/** columns and relationships of "user" */
export type user = {
  __typename?: 'user';
  active: Scalars['Boolean'];
  allergies?: Maybe<Scalars['String']>;
  /** An array relationship */
  course_coordinators: Array<course_coordinator>;
  /** An aggregate relationship */
  course_coordinators_aggregate: course_coordinator_aggregate;
  createdAt: Scalars['timestamp'];
  currentMedications?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  department?: Maybe<department>;
  departmentId?: Maybe<Scalars['uuid']>;
  email: Scalars['String'];
  emergencyContact1City?: Maybe<Scalars['String']>;
  emergencyContact1Country?: Maybe<Scalars['String']>;
  emergencyContact1District?: Maybe<Scalars['String']>;
  emergencyContact1LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact1MobileNo?: Maybe<Scalars['String']>;
  emergencyContact1Name?: Maybe<Scalars['String']>;
  emergencyContact1Province?: Maybe<Scalars['String']>;
  emergencyContact1Relationship?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact1WorkPhoneNo?: Maybe<Scalars['String']>;
  emergencyContact2City?: Maybe<Scalars['String']>;
  emergencyContact2Country?: Maybe<Scalars['String']>;
  emergencyContact2District?: Maybe<Scalars['String']>;
  emergencyContact2LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact2MobileNo?: Maybe<Scalars['String']>;
  emergencyContact2Name?: Maybe<Scalars['String']>;
  emergencyContact2Province?: Maybe<Scalars['String']>;
  emergencyContact2Relationship?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact2WorkPhoneNo?: Maybe<Scalars['String']>;
  employeeID: Scalars['String'];
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Scalars['user_gender_enum']>;
  healthConditions?: Maybe<Scalars['String']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  initialTourFollowed: Scalars['Boolean'];
  /** An array relationship */
  inquiries: Array<inquiry>;
  /** An aggregate relationship */
  inquiries_aggregate: inquiry_aggregate;
  insuranceName?: Maybe<Scalars['String']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  /** An array relationship */
  lecture_materials: Array<lecture_material>;
  /** An aggregate relationship */
  lecture_materials_aggregate: lecture_material_aggregate;
  married?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  policyNo?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  /** An array relationship */
  result_sheets: Array<result_sheet>;
  /** An aggregate relationship */
  result_sheets_aggregate: result_sheet_aggregate;
  /** An array relationship */
  student_performances: Array<student_performance>;
  /** An aggregate relationship */
  student_performances_aggregate: student_performance_aggregate;
  /** An array relationship */
  student_request_messages: Array<student_request_message>;
  /** An aggregate relationship */
  student_request_messages_aggregate: student_request_message_aggregate;
  /** An array relationship */
  student_request_requestees: Array<student_request_requestee>;
  /** An aggregate relationship */
  student_request_requestees_aggregate: student_request_requestee_aggregate;
  /** An array relationship */
  student_requests: Array<student_request>;
  /** An aggregate relationship */
  student_requests_aggregate: student_request_aggregate;
  /** An array relationship */
  subject_to_users: Array<subject_to_user>;
  /** An aggregate relationship */
  subject_to_users_aggregate: subject_to_user_aggregate;
  /** An array relationship */
  timetable_items: Array<timetable_item>;
  /** An aggregate relationship */
  timetable_items_aggregate: timetable_item_aggregate;
  updatedAt: Scalars['timestamp'];
  /** An array relationship */
  user_routes_routes: Array<user_routes_route>;
  /** An aggregate relationship */
  user_routes_routes_aggregate: user_routes_route_aggregate;
  /** An array relationship */
  user_user_roles_user_roles: Array<user_user_roles_user_role>;
  /** An aggregate relationship */
  user_user_roles_user_roles_aggregate: user_user_roles_user_role_aggregate;
};

/** columns and relationships of "user" */
export type usercourse_coordinatorsArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

/** columns and relationships of "user" */
export type usercourse_coordinators_aggregateArgs = {
  distinct_on?: Maybe<Array<course_coordinator_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<course_coordinator_order_by>>;
  where?: Maybe<course_coordinator_bool_exp>;
};

/** columns and relationships of "user" */
export type userinquiriesArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

/** columns and relationships of "user" */
export type userinquiries_aggregateArgs = {
  distinct_on?: Maybe<Array<inquiry_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<inquiry_order_by>>;
  where?: Maybe<inquiry_bool_exp>;
};

/** columns and relationships of "user" */
export type userlecture_materialsArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

/** columns and relationships of "user" */
export type userlecture_materials_aggregateArgs = {
  distinct_on?: Maybe<Array<lecture_material_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<lecture_material_order_by>>;
  where?: Maybe<lecture_material_bool_exp>;
};

/** columns and relationships of "user" */
export type userresult_sheetsArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** columns and relationships of "user" */
export type userresult_sheets_aggregateArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** columns and relationships of "user" */
export type userstudent_performancesArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

/** columns and relationships of "user" */
export type userstudent_performances_aggregateArgs = {
  distinct_on?: Maybe<Array<student_performance_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_performance_order_by>>;
  where?: Maybe<student_performance_bool_exp>;
};

/** columns and relationships of "user" */
export type userstudent_request_messagesArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

/** columns and relationships of "user" */
export type userstudent_request_messages_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

/** columns and relationships of "user" */
export type userstudent_request_requesteesArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

/** columns and relationships of "user" */
export type userstudent_request_requestees_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

/** columns and relationships of "user" */
export type userstudent_requestsArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** columns and relationships of "user" */
export type userstudent_requests_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** columns and relationships of "user" */
export type usersubject_to_usersArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

/** columns and relationships of "user" */
export type usersubject_to_users_aggregateArgs = {
  distinct_on?: Maybe<Array<subject_to_user_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<subject_to_user_order_by>>;
  where?: Maybe<subject_to_user_bool_exp>;
};

/** columns and relationships of "user" */
export type usertimetable_itemsArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** columns and relationships of "user" */
export type usertimetable_items_aggregateArgs = {
  distinct_on?: Maybe<Array<timetable_item_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<timetable_item_order_by>>;
  where?: Maybe<timetable_item_bool_exp>;
};

/** columns and relationships of "user" */
export type useruser_routes_routesArgs = {
  distinct_on?: Maybe<Array<user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_routes_route_order_by>>;
  where?: Maybe<user_routes_route_bool_exp>;
};

/** columns and relationships of "user" */
export type useruser_routes_routes_aggregateArgs = {
  distinct_on?: Maybe<Array<user_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_routes_route_order_by>>;
  where?: Maybe<user_routes_route_bool_exp>;
};

/** columns and relationships of "user" */
export type useruser_user_roles_user_rolesArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** columns and relationships of "user" */
export type useruser_user_roles_user_roles_aggregateArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** aggregated selection of "user" */
export type user_aggregate = {
  __typename?: 'user_aggregate';
  aggregate?: Maybe<user_aggregate_fields>;
  nodes: Array<user>;
};

/** aggregate fields of "user" */
export type user_aggregate_fields = {
  __typename?: 'user_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<user_max_fields>;
  min?: Maybe<user_min_fields>;
};

/** aggregate fields of "user" */
export type user_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<user_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user" */
export type user_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<user_max_order_by>;
  min?: Maybe<user_min_order_by>;
};

/** input type for inserting array relation for remote table "user" */
export type user_arr_rel_insert_input = {
  data: Array<user_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<user_on_conflict>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type user_bool_exp = {
  _and?: Maybe<Array<user_bool_exp>>;
  _not?: Maybe<user_bool_exp>;
  _or?: Maybe<Array<user_bool_exp>>;
  active?: Maybe<Boolean_comparison_exp>;
  allergies?: Maybe<String_comparison_exp>;
  course_coordinators?: Maybe<course_coordinator_bool_exp>;
  createdAt?: Maybe<timestamp_comparison_exp>;
  currentMedications?: Maybe<String_comparison_exp>;
  dateOfBirth?: Maybe<timestamp_comparison_exp>;
  dateOfJoining?: Maybe<timestamp_comparison_exp>;
  department?: Maybe<department_bool_exp>;
  departmentId?: Maybe<uuid_comparison_exp>;
  email?: Maybe<String_comparison_exp>;
  emergencyContact1City?: Maybe<String_comparison_exp>;
  emergencyContact1Country?: Maybe<String_comparison_exp>;
  emergencyContact1District?: Maybe<String_comparison_exp>;
  emergencyContact1LandLineNo?: Maybe<String_comparison_exp>;
  emergencyContact1MobileNo?: Maybe<String_comparison_exp>;
  emergencyContact1Name?: Maybe<String_comparison_exp>;
  emergencyContact1Province?: Maybe<String_comparison_exp>;
  emergencyContact1Relationship?: Maybe<String_comparison_exp>;
  emergencyContact1StreetAddress1?: Maybe<String_comparison_exp>;
  emergencyContact1StreetAddress2?: Maybe<String_comparison_exp>;
  emergencyContact1WorkPhoneNo?: Maybe<String_comparison_exp>;
  emergencyContact2City?: Maybe<String_comparison_exp>;
  emergencyContact2Country?: Maybe<String_comparison_exp>;
  emergencyContact2District?: Maybe<String_comparison_exp>;
  emergencyContact2LandLineNo?: Maybe<String_comparison_exp>;
  emergencyContact2MobileNo?: Maybe<String_comparison_exp>;
  emergencyContact2Name?: Maybe<String_comparison_exp>;
  emergencyContact2Province?: Maybe<String_comparison_exp>;
  emergencyContact2Relationship?: Maybe<String_comparison_exp>;
  emergencyContact2StreetAddress1?: Maybe<String_comparison_exp>;
  emergencyContact2StreetAddress2?: Maybe<String_comparison_exp>;
  emergencyContact2WorkPhoneNo?: Maybe<String_comparison_exp>;
  employeeID?: Maybe<String_comparison_exp>;
  expirationDate?: Maybe<timestamp_comparison_exp>;
  extensionNo?: Maybe<String_comparison_exp>;
  firebaseUID?: Maybe<String_comparison_exp>;
  firstName?: Maybe<String_comparison_exp>;
  gender?: Maybe<user_gender_enum_comparison_exp>;
  healthConditions?: Maybe<String_comparison_exp>;
  homeCity?: Maybe<String_comparison_exp>;
  homeCountry?: Maybe<String_comparison_exp>;
  homeDistrict?: Maybe<String_comparison_exp>;
  homeProvince?: Maybe<String_comparison_exp>;
  homeStreetAddress1?: Maybe<String_comparison_exp>;
  homeStreetAddress2?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  initialTourFollowed?: Maybe<Boolean_comparison_exp>;
  inquiries?: Maybe<inquiry_bool_exp>;
  insuranceName?: Maybe<String_comparison_exp>;
  landLineNo?: Maybe<String_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  lecture_materials?: Maybe<lecture_material_bool_exp>;
  married?: Maybe<Boolean_comparison_exp>;
  middleName?: Maybe<String_comparison_exp>;
  mobileNo?: Maybe<String_comparison_exp>;
  nicNo?: Maybe<String_comparison_exp>;
  passportNo?: Maybe<String_comparison_exp>;
  permanentCity?: Maybe<String_comparison_exp>;
  permanentCountry?: Maybe<String_comparison_exp>;
  permanentDistrict?: Maybe<String_comparison_exp>;
  permanentProvince?: Maybe<String_comparison_exp>;
  permanentStreetAddress1?: Maybe<String_comparison_exp>;
  permanentStreetAddress2?: Maybe<String_comparison_exp>;
  policyNo?: Maybe<String_comparison_exp>;
  preferredName?: Maybe<String_comparison_exp>;
  profilePicture?: Maybe<String_comparison_exp>;
  result_sheets?: Maybe<result_sheet_bool_exp>;
  student_performances?: Maybe<student_performance_bool_exp>;
  student_request_messages?: Maybe<student_request_message_bool_exp>;
  student_request_requestees?: Maybe<student_request_requestee_bool_exp>;
  student_requests?: Maybe<student_request_bool_exp>;
  subject_to_users?: Maybe<subject_to_user_bool_exp>;
  timetable_items?: Maybe<timetable_item_bool_exp>;
  updatedAt?: Maybe<timestamp_comparison_exp>;
  user_routes_routes?: Maybe<user_routes_route_bool_exp>;
  user_user_roles_user_roles?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** unique or primary key constraints on table "user" */
export enum user_constraint {
  /** unique or primary key constraint */
  IDX_1644511d3de198ef38fb2ad1a0 = 'IDX_1644511d3de198ef38fb2ad1a0',
  /** unique or primary key constraint */
  IDX_19b80ce7ff447dba7f64c818bc = 'IDX_19b80ce7ff447dba7f64c818bc',
  /** unique or primary key constraint */
  PK_cace4a159ff9f2512dd42373760 = 'PK_cace4a159ff9f2512dd42373760',
  /** unique or primary key constraint */
  user_email_key = 'user_email_key',
  /** unique or primary key constraint */
  user_firebaseUID_key = 'user_firebaseUID_key',
  /** unique or primary key constraint */
  user_nicNo_key = 'user_nicNo_key',
  /** unique or primary key constraint */
  user_passportNo_key = 'user_passportNo_key',
}

/** Boolean expression to compare columns of type "user_gender_enum". All fields are combined with logical 'AND'. */
export type user_gender_enum_comparison_exp = {
  _eq?: Maybe<Scalars['user_gender_enum']>;
  _gt?: Maybe<Scalars['user_gender_enum']>;
  _gte?: Maybe<Scalars['user_gender_enum']>;
  _in?: Maybe<Array<Scalars['user_gender_enum']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['user_gender_enum']>;
  _lte?: Maybe<Scalars['user_gender_enum']>;
  _neq?: Maybe<Scalars['user_gender_enum']>;
  _nin?: Maybe<Array<Scalars['user_gender_enum']>>;
};

/** input type for inserting data into table "user" */
export type user_insert_input = {
  active?: Maybe<Scalars['Boolean']>;
  allergies?: Maybe<Scalars['String']>;
  course_coordinators?: Maybe<course_coordinator_arr_rel_insert_input>;
  createdAt?: Maybe<Scalars['timestamp']>;
  currentMedications?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  department?: Maybe<department_obj_rel_insert_input>;
  departmentId?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  emergencyContact1City?: Maybe<Scalars['String']>;
  emergencyContact1Country?: Maybe<Scalars['String']>;
  emergencyContact1District?: Maybe<Scalars['String']>;
  emergencyContact1LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact1MobileNo?: Maybe<Scalars['String']>;
  emergencyContact1Name?: Maybe<Scalars['String']>;
  emergencyContact1Province?: Maybe<Scalars['String']>;
  emergencyContact1Relationship?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact1WorkPhoneNo?: Maybe<Scalars['String']>;
  emergencyContact2City?: Maybe<Scalars['String']>;
  emergencyContact2Country?: Maybe<Scalars['String']>;
  emergencyContact2District?: Maybe<Scalars['String']>;
  emergencyContact2LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact2MobileNo?: Maybe<Scalars['String']>;
  emergencyContact2Name?: Maybe<Scalars['String']>;
  emergencyContact2Province?: Maybe<Scalars['String']>;
  emergencyContact2Relationship?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact2WorkPhoneNo?: Maybe<Scalars['String']>;
  employeeID?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['user_gender_enum']>;
  healthConditions?: Maybe<Scalars['String']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  inquiries?: Maybe<inquiry_arr_rel_insert_input>;
  insuranceName?: Maybe<Scalars['String']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lecture_materials?: Maybe<lecture_material_arr_rel_insert_input>;
  married?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  policyNo?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  result_sheets?: Maybe<result_sheet_arr_rel_insert_input>;
  student_performances?: Maybe<student_performance_arr_rel_insert_input>;
  student_request_messages?: Maybe<student_request_message_arr_rel_insert_input>;
  student_request_requestees?: Maybe<student_request_requestee_arr_rel_insert_input>;
  student_requests?: Maybe<student_request_arr_rel_insert_input>;
  subject_to_users?: Maybe<subject_to_user_arr_rel_insert_input>;
  timetable_items?: Maybe<timetable_item_arr_rel_insert_input>;
  updatedAt?: Maybe<Scalars['timestamp']>;
  user_routes_routes?: Maybe<user_routes_route_arr_rel_insert_input>;
  user_user_roles_user_roles?: Maybe<user_user_roles_user_role_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type user_max_fields = {
  __typename?: 'user_max_fields';
  allergies?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  currentMedications?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  departmentId?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  emergencyContact1City?: Maybe<Scalars['String']>;
  emergencyContact1Country?: Maybe<Scalars['String']>;
  emergencyContact1District?: Maybe<Scalars['String']>;
  emergencyContact1LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact1MobileNo?: Maybe<Scalars['String']>;
  emergencyContact1Name?: Maybe<Scalars['String']>;
  emergencyContact1Province?: Maybe<Scalars['String']>;
  emergencyContact1Relationship?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact1WorkPhoneNo?: Maybe<Scalars['String']>;
  emergencyContact2City?: Maybe<Scalars['String']>;
  emergencyContact2Country?: Maybe<Scalars['String']>;
  emergencyContact2District?: Maybe<Scalars['String']>;
  emergencyContact2LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact2MobileNo?: Maybe<Scalars['String']>;
  emergencyContact2Name?: Maybe<Scalars['String']>;
  emergencyContact2Province?: Maybe<Scalars['String']>;
  emergencyContact2Relationship?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact2WorkPhoneNo?: Maybe<Scalars['String']>;
  employeeID?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  healthConditions?: Maybe<Scalars['String']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insuranceName?: Maybe<Scalars['String']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  policyNo?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "user" */
export type user_max_order_by = {
  allergies?: Maybe<order_by>;
  createdAt?: Maybe<order_by>;
  currentMedications?: Maybe<order_by>;
  dateOfBirth?: Maybe<order_by>;
  dateOfJoining?: Maybe<order_by>;
  departmentId?: Maybe<order_by>;
  email?: Maybe<order_by>;
  emergencyContact1City?: Maybe<order_by>;
  emergencyContact1Country?: Maybe<order_by>;
  emergencyContact1District?: Maybe<order_by>;
  emergencyContact1LandLineNo?: Maybe<order_by>;
  emergencyContact1MobileNo?: Maybe<order_by>;
  emergencyContact1Name?: Maybe<order_by>;
  emergencyContact1Province?: Maybe<order_by>;
  emergencyContact1Relationship?: Maybe<order_by>;
  emergencyContact1StreetAddress1?: Maybe<order_by>;
  emergencyContact1StreetAddress2?: Maybe<order_by>;
  emergencyContact1WorkPhoneNo?: Maybe<order_by>;
  emergencyContact2City?: Maybe<order_by>;
  emergencyContact2Country?: Maybe<order_by>;
  emergencyContact2District?: Maybe<order_by>;
  emergencyContact2LandLineNo?: Maybe<order_by>;
  emergencyContact2MobileNo?: Maybe<order_by>;
  emergencyContact2Name?: Maybe<order_by>;
  emergencyContact2Province?: Maybe<order_by>;
  emergencyContact2Relationship?: Maybe<order_by>;
  emergencyContact2StreetAddress1?: Maybe<order_by>;
  emergencyContact2StreetAddress2?: Maybe<order_by>;
  emergencyContact2WorkPhoneNo?: Maybe<order_by>;
  employeeID?: Maybe<order_by>;
  expirationDate?: Maybe<order_by>;
  extensionNo?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  healthConditions?: Maybe<order_by>;
  homeCity?: Maybe<order_by>;
  homeCountry?: Maybe<order_by>;
  homeDistrict?: Maybe<order_by>;
  homeProvince?: Maybe<order_by>;
  homeStreetAddress1?: Maybe<order_by>;
  homeStreetAddress2?: Maybe<order_by>;
  id?: Maybe<order_by>;
  insuranceName?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  nicNo?: Maybe<order_by>;
  passportNo?: Maybe<order_by>;
  permanentCity?: Maybe<order_by>;
  permanentCountry?: Maybe<order_by>;
  permanentDistrict?: Maybe<order_by>;
  permanentProvince?: Maybe<order_by>;
  permanentStreetAddress1?: Maybe<order_by>;
  permanentStreetAddress2?: Maybe<order_by>;
  policyNo?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  profilePicture?: Maybe<order_by>;
  updatedAt?: Maybe<order_by>;
};

/** aggregate min on columns */
export type user_min_fields = {
  __typename?: 'user_min_fields';
  allergies?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  currentMedications?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  departmentId?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  emergencyContact1City?: Maybe<Scalars['String']>;
  emergencyContact1Country?: Maybe<Scalars['String']>;
  emergencyContact1District?: Maybe<Scalars['String']>;
  emergencyContact1LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact1MobileNo?: Maybe<Scalars['String']>;
  emergencyContact1Name?: Maybe<Scalars['String']>;
  emergencyContact1Province?: Maybe<Scalars['String']>;
  emergencyContact1Relationship?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact1WorkPhoneNo?: Maybe<Scalars['String']>;
  emergencyContact2City?: Maybe<Scalars['String']>;
  emergencyContact2Country?: Maybe<Scalars['String']>;
  emergencyContact2District?: Maybe<Scalars['String']>;
  emergencyContact2LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact2MobileNo?: Maybe<Scalars['String']>;
  emergencyContact2Name?: Maybe<Scalars['String']>;
  emergencyContact2Province?: Maybe<Scalars['String']>;
  emergencyContact2Relationship?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact2WorkPhoneNo?: Maybe<Scalars['String']>;
  employeeID?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  healthConditions?: Maybe<Scalars['String']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insuranceName?: Maybe<Scalars['String']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  policyNo?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "user" */
export type user_min_order_by = {
  allergies?: Maybe<order_by>;
  createdAt?: Maybe<order_by>;
  currentMedications?: Maybe<order_by>;
  dateOfBirth?: Maybe<order_by>;
  dateOfJoining?: Maybe<order_by>;
  departmentId?: Maybe<order_by>;
  email?: Maybe<order_by>;
  emergencyContact1City?: Maybe<order_by>;
  emergencyContact1Country?: Maybe<order_by>;
  emergencyContact1District?: Maybe<order_by>;
  emergencyContact1LandLineNo?: Maybe<order_by>;
  emergencyContact1MobileNo?: Maybe<order_by>;
  emergencyContact1Name?: Maybe<order_by>;
  emergencyContact1Province?: Maybe<order_by>;
  emergencyContact1Relationship?: Maybe<order_by>;
  emergencyContact1StreetAddress1?: Maybe<order_by>;
  emergencyContact1StreetAddress2?: Maybe<order_by>;
  emergencyContact1WorkPhoneNo?: Maybe<order_by>;
  emergencyContact2City?: Maybe<order_by>;
  emergencyContact2Country?: Maybe<order_by>;
  emergencyContact2District?: Maybe<order_by>;
  emergencyContact2LandLineNo?: Maybe<order_by>;
  emergencyContact2MobileNo?: Maybe<order_by>;
  emergencyContact2Name?: Maybe<order_by>;
  emergencyContact2Province?: Maybe<order_by>;
  emergencyContact2Relationship?: Maybe<order_by>;
  emergencyContact2StreetAddress1?: Maybe<order_by>;
  emergencyContact2StreetAddress2?: Maybe<order_by>;
  emergencyContact2WorkPhoneNo?: Maybe<order_by>;
  employeeID?: Maybe<order_by>;
  expirationDate?: Maybe<order_by>;
  extensionNo?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  healthConditions?: Maybe<order_by>;
  homeCity?: Maybe<order_by>;
  homeCountry?: Maybe<order_by>;
  homeDistrict?: Maybe<order_by>;
  homeProvince?: Maybe<order_by>;
  homeStreetAddress1?: Maybe<order_by>;
  homeStreetAddress2?: Maybe<order_by>;
  id?: Maybe<order_by>;
  insuranceName?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  nicNo?: Maybe<order_by>;
  passportNo?: Maybe<order_by>;
  permanentCity?: Maybe<order_by>;
  permanentCountry?: Maybe<order_by>;
  permanentDistrict?: Maybe<order_by>;
  permanentProvince?: Maybe<order_by>;
  permanentStreetAddress1?: Maybe<order_by>;
  permanentStreetAddress2?: Maybe<order_by>;
  policyNo?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  profilePicture?: Maybe<order_by>;
  updatedAt?: Maybe<order_by>;
};

/** response of any mutation on the table "user" */
export type user_mutation_response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<user>;
};

/** input type for inserting object relation for remote table "user" */
export type user_obj_rel_insert_input = {
  data: user_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<user_on_conflict>;
};

/** on conflict condition type for table "user" */
export type user_on_conflict = {
  constraint: user_constraint;
  update_columns?: Array<user_update_column>;
  where?: Maybe<user_bool_exp>;
};

/** Ordering options when selecting data from "user". */
export type user_order_by = {
  active?: Maybe<order_by>;
  allergies?: Maybe<order_by>;
  course_coordinators_aggregate?: Maybe<course_coordinator_aggregate_order_by>;
  createdAt?: Maybe<order_by>;
  currentMedications?: Maybe<order_by>;
  dateOfBirth?: Maybe<order_by>;
  dateOfJoining?: Maybe<order_by>;
  department?: Maybe<department_order_by>;
  departmentId?: Maybe<order_by>;
  email?: Maybe<order_by>;
  emergencyContact1City?: Maybe<order_by>;
  emergencyContact1Country?: Maybe<order_by>;
  emergencyContact1District?: Maybe<order_by>;
  emergencyContact1LandLineNo?: Maybe<order_by>;
  emergencyContact1MobileNo?: Maybe<order_by>;
  emergencyContact1Name?: Maybe<order_by>;
  emergencyContact1Province?: Maybe<order_by>;
  emergencyContact1Relationship?: Maybe<order_by>;
  emergencyContact1StreetAddress1?: Maybe<order_by>;
  emergencyContact1StreetAddress2?: Maybe<order_by>;
  emergencyContact1WorkPhoneNo?: Maybe<order_by>;
  emergencyContact2City?: Maybe<order_by>;
  emergencyContact2Country?: Maybe<order_by>;
  emergencyContact2District?: Maybe<order_by>;
  emergencyContact2LandLineNo?: Maybe<order_by>;
  emergencyContact2MobileNo?: Maybe<order_by>;
  emergencyContact2Name?: Maybe<order_by>;
  emergencyContact2Province?: Maybe<order_by>;
  emergencyContact2Relationship?: Maybe<order_by>;
  emergencyContact2StreetAddress1?: Maybe<order_by>;
  emergencyContact2StreetAddress2?: Maybe<order_by>;
  emergencyContact2WorkPhoneNo?: Maybe<order_by>;
  employeeID?: Maybe<order_by>;
  expirationDate?: Maybe<order_by>;
  extensionNo?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  gender?: Maybe<order_by>;
  healthConditions?: Maybe<order_by>;
  homeCity?: Maybe<order_by>;
  homeCountry?: Maybe<order_by>;
  homeDistrict?: Maybe<order_by>;
  homeProvince?: Maybe<order_by>;
  homeStreetAddress1?: Maybe<order_by>;
  homeStreetAddress2?: Maybe<order_by>;
  id?: Maybe<order_by>;
  initialTourFollowed?: Maybe<order_by>;
  inquiries_aggregate?: Maybe<inquiry_aggregate_order_by>;
  insuranceName?: Maybe<order_by>;
  landLineNo?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  lecture_materials_aggregate?: Maybe<lecture_material_aggregate_order_by>;
  married?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  nicNo?: Maybe<order_by>;
  passportNo?: Maybe<order_by>;
  permanentCity?: Maybe<order_by>;
  permanentCountry?: Maybe<order_by>;
  permanentDistrict?: Maybe<order_by>;
  permanentProvince?: Maybe<order_by>;
  permanentStreetAddress1?: Maybe<order_by>;
  permanentStreetAddress2?: Maybe<order_by>;
  policyNo?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  profilePicture?: Maybe<order_by>;
  result_sheets_aggregate?: Maybe<result_sheet_aggregate_order_by>;
  student_performances_aggregate?: Maybe<student_performance_aggregate_order_by>;
  student_request_messages_aggregate?: Maybe<student_request_message_aggregate_order_by>;
  student_request_requestees_aggregate?: Maybe<student_request_requestee_aggregate_order_by>;
  student_requests_aggregate?: Maybe<student_request_aggregate_order_by>;
  subject_to_users_aggregate?: Maybe<subject_to_user_aggregate_order_by>;
  timetable_items_aggregate?: Maybe<timetable_item_aggregate_order_by>;
  updatedAt?: Maybe<order_by>;
  user_routes_routes_aggregate?: Maybe<user_routes_route_aggregate_order_by>;
  user_user_roles_user_roles_aggregate?: Maybe<user_user_roles_user_role_aggregate_order_by>;
};

/** columns and relationships of "user_performance_public" */
export type user_performance_public = {
  __typename?: 'user_performance_public';
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
};

/** aggregated selection of "user_performance_public" */
export type user_performance_public_aggregate = {
  __typename?: 'user_performance_public_aggregate';
  aggregate?: Maybe<user_performance_public_aggregate_fields>;
  nodes: Array<user_performance_public>;
};

/** aggregate fields of "user_performance_public" */
export type user_performance_public_aggregate_fields = {
  __typename?: 'user_performance_public_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<user_performance_public_max_fields>;
  min?: Maybe<user_performance_public_min_fields>;
};

/** aggregate fields of "user_performance_public" */
export type user_performance_public_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<user_performance_public_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_performance_public". All fields are combined with a logical 'AND'. */
export type user_performance_public_bool_exp = {
  _and?: Maybe<Array<user_performance_public_bool_exp>>;
  _not?: Maybe<user_performance_public_bool_exp>;
  _or?: Maybe<Array<user_performance_public_bool_exp>>;
  firebaseUID?: Maybe<String_comparison_exp>;
  firstName?: Maybe<String_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  middleName?: Maybe<String_comparison_exp>;
};

/** input type for inserting data into table "user_performance_public" */
export type user_performance_public_insert_input = {
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
};

/** aggregate max on columns */
export type user_performance_public_max_fields = {
  __typename?: 'user_performance_public_max_fields';
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type user_performance_public_min_fields = {
  __typename?: 'user_performance_public_min_fields';
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_performance_public" */
export type user_performance_public_mutation_response = {
  __typename?: 'user_performance_public_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<user_performance_public>;
};

/** input type for inserting object relation for remote table "user_performance_public" */
export type user_performance_public_obj_rel_insert_input = {
  data: user_performance_public_insert_input;
};

/** Ordering options when selecting data from "user_performance_public". */
export type user_performance_public_order_by = {
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
};

/** select columns of table "user_performance_public" */
export enum user_performance_public_select_column {
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  lastName = 'lastName',
  /** column name */
  middleName = 'middleName',
}

/** input type for updating data in table "user_performance_public" */
export type user_performance_public_set_input = {
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
};

/** primary key columns input for table: user */
export type user_pk_columns_input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "user_public" */
export type user_public = {
  __typename?: 'user_public';
  active?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  department?: Maybe<department>;
  departmentId?: Maybe<Scalars['uuid']>;
  employeeID?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  /** An array relationship */
  result_sheets: Array<result_sheet>;
  /** An aggregate relationship */
  result_sheets_aggregate: result_sheet_aggregate;
  /** An array relationship */
  student_request_messages: Array<student_request_message>;
  /** An aggregate relationship */
  student_request_messages_aggregate: student_request_message_aggregate;
  /** An array relationship */
  student_request_requestees: Array<student_request_requestee>;
  /** An aggregate relationship */
  student_request_requestees_aggregate: student_request_requestee_aggregate;
  /** An array relationship */
  student_requests: Array<student_request>;
  /** An aggregate relationship */
  student_requests_aggregate: student_request_aggregate;
};

/** columns and relationships of "user_public" */
export type user_publicresult_sheetsArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** columns and relationships of "user_public" */
export type user_publicresult_sheets_aggregateArgs = {
  distinct_on?: Maybe<Array<result_sheet_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<result_sheet_order_by>>;
  where?: Maybe<result_sheet_bool_exp>;
};

/** columns and relationships of "user_public" */
export type user_publicstudent_request_messagesArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

/** columns and relationships of "user_public" */
export type user_publicstudent_request_messages_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_message_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_message_order_by>>;
  where?: Maybe<student_request_message_bool_exp>;
};

/** columns and relationships of "user_public" */
export type user_publicstudent_request_requesteesArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

/** columns and relationships of "user_public" */
export type user_publicstudent_request_requestees_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_requestee_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_requestee_order_by>>;
  where?: Maybe<student_request_requestee_bool_exp>;
};

/** columns and relationships of "user_public" */
export type user_publicstudent_requestsArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** columns and relationships of "user_public" */
export type user_publicstudent_requests_aggregateArgs = {
  distinct_on?: Maybe<Array<student_request_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_request_order_by>>;
  where?: Maybe<student_request_bool_exp>;
};

/** aggregated selection of "user_public" */
export type user_public_aggregate = {
  __typename?: 'user_public_aggregate';
  aggregate?: Maybe<user_public_aggregate_fields>;
  nodes: Array<user_public>;
};

/** aggregate fields of "user_public" */
export type user_public_aggregate_fields = {
  __typename?: 'user_public_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<user_public_max_fields>;
  min?: Maybe<user_public_min_fields>;
};

/** aggregate fields of "user_public" */
export type user_public_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<user_public_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_public" */
export type user_public_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<user_public_max_order_by>;
  min?: Maybe<user_public_min_order_by>;
};

/** input type for inserting array relation for remote table "user_public" */
export type user_public_arr_rel_insert_input = {
  data: Array<user_public_insert_input>;
};

/** Boolean expression to filter rows from the table "user_public". All fields are combined with a logical 'AND'. */
export type user_public_bool_exp = {
  _and?: Maybe<Array<user_public_bool_exp>>;
  _not?: Maybe<user_public_bool_exp>;
  _or?: Maybe<Array<user_public_bool_exp>>;
  active?: Maybe<Boolean_comparison_exp>;
  department?: Maybe<department_bool_exp>;
  departmentId?: Maybe<uuid_comparison_exp>;
  employeeID?: Maybe<String_comparison_exp>;
  firebaseUID?: Maybe<String_comparison_exp>;
  firstName?: Maybe<String_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  middleName?: Maybe<String_comparison_exp>;
  preferredName?: Maybe<String_comparison_exp>;
  result_sheets?: Maybe<result_sheet_bool_exp>;
  student_request_messages?: Maybe<student_request_message_bool_exp>;
  student_request_requestees?: Maybe<student_request_requestee_bool_exp>;
  student_requests?: Maybe<student_request_bool_exp>;
};

/** input type for inserting data into table "user_public" */
export type user_public_insert_input = {
  active?: Maybe<Scalars['Boolean']>;
  department?: Maybe<department_obj_rel_insert_input>;
  departmentId?: Maybe<Scalars['uuid']>;
  employeeID?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  result_sheets?: Maybe<result_sheet_arr_rel_insert_input>;
  student_request_messages?: Maybe<student_request_message_arr_rel_insert_input>;
  student_request_requestees?: Maybe<student_request_requestee_arr_rel_insert_input>;
  student_requests?: Maybe<student_request_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type user_public_max_fields = {
  __typename?: 'user_public_max_fields';
  departmentId?: Maybe<Scalars['uuid']>;
  employeeID?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_public" */
export type user_public_max_order_by = {
  departmentId?: Maybe<order_by>;
  employeeID?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
};

/** aggregate min on columns */
export type user_public_min_fields = {
  __typename?: 'user_public_min_fields';
  departmentId?: Maybe<Scalars['uuid']>;
  employeeID?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_public" */
export type user_public_min_order_by = {
  departmentId?: Maybe<order_by>;
  employeeID?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
};

/** response of any mutation on the table "user_public" */
export type user_public_mutation_response = {
  __typename?: 'user_public_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<user_public>;
};

/** input type for inserting object relation for remote table "user_public" */
export type user_public_obj_rel_insert_input = {
  data: user_public_insert_input;
};

/** Ordering options when selecting data from "user_public". */
export type user_public_order_by = {
  active?: Maybe<order_by>;
  department?: Maybe<department_order_by>;
  departmentId?: Maybe<order_by>;
  employeeID?: Maybe<order_by>;
  firebaseUID?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  middleName?: Maybe<order_by>;
  preferredName?: Maybe<order_by>;
  result_sheets_aggregate?: Maybe<result_sheet_aggregate_order_by>;
  student_request_messages_aggregate?: Maybe<student_request_message_aggregate_order_by>;
  student_request_requestees_aggregate?: Maybe<student_request_requestee_aggregate_order_by>;
  student_requests_aggregate?: Maybe<student_request_aggregate_order_by>;
};

/** select columns of table "user_public" */
export enum user_public_select_column {
  /** column name */
  active = 'active',
  /** column name */
  departmentId = 'departmentId',
  /** column name */
  employeeID = 'employeeID',
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastName = 'lastName',
  /** column name */
  middleName = 'middleName',
  /** column name */
  preferredName = 'preferredName',
}

/** input type for updating data in table "user_public" */
export type user_public_set_input = {
  active?: Maybe<Scalars['Boolean']>;
  departmentId?: Maybe<Scalars['uuid']>;
  employeeID?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
};

/** columns and relationships of "user_role" */
export type user_role = {
  __typename?: 'user_role';
  /** An object relationship */
  department?: Maybe<department>;
  departmentId?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  systemRole: Scalars['Boolean'];
  /** An array relationship */
  user_role_routes_routes: Array<user_role_routes_route>;
  /** An aggregate relationship */
  user_role_routes_routes_aggregate: user_role_routes_route_aggregate;
  /** An array relationship */
  user_user_roles_user_roles: Array<user_user_roles_user_role>;
  /** An aggregate relationship */
  user_user_roles_user_roles_aggregate: user_user_roles_user_role_aggregate;
};

/** columns and relationships of "user_role" */
export type user_roleuser_role_routes_routesArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

/** columns and relationships of "user_role" */
export type user_roleuser_role_routes_routes_aggregateArgs = {
  distinct_on?: Maybe<Array<user_role_routes_route_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_role_routes_route_order_by>>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

/** columns and relationships of "user_role" */
export type user_roleuser_user_roles_user_rolesArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** columns and relationships of "user_role" */
export type user_roleuser_user_roles_user_roles_aggregateArgs = {
  distinct_on?: Maybe<Array<user_user_roles_user_role_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<user_user_roles_user_role_order_by>>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** aggregated selection of "user_role" */
export type user_role_aggregate = {
  __typename?: 'user_role_aggregate';
  aggregate?: Maybe<user_role_aggregate_fields>;
  nodes: Array<user_role>;
};

/** aggregate fields of "user_role" */
export type user_role_aggregate_fields = {
  __typename?: 'user_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<user_role_max_fields>;
  min?: Maybe<user_role_min_fields>;
};

/** aggregate fields of "user_role" */
export type user_role_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<user_role_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_role" */
export type user_role_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<user_role_max_order_by>;
  min?: Maybe<user_role_min_order_by>;
};

/** input type for inserting array relation for remote table "user_role" */
export type user_role_arr_rel_insert_input = {
  data: Array<user_role_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<user_role_on_conflict>;
};

/** Boolean expression to filter rows from the table "user_role". All fields are combined with a logical 'AND'. */
export type user_role_bool_exp = {
  _and?: Maybe<Array<user_role_bool_exp>>;
  _not?: Maybe<user_role_bool_exp>;
  _or?: Maybe<Array<user_role_bool_exp>>;
  department?: Maybe<department_bool_exp>;
  departmentId?: Maybe<uuid_comparison_exp>;
  id?: Maybe<uuid_comparison_exp>;
  name?: Maybe<String_comparison_exp>;
  systemRole?: Maybe<Boolean_comparison_exp>;
  user_role_routes_routes?: Maybe<user_role_routes_route_bool_exp>;
  user_user_roles_user_roles?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** unique or primary key constraints on table "user_role" */
export enum user_role_constraint {
  /** unique or primary key constraint */
  PK_fb2e442d14add3cefbdf33c4561 = 'PK_fb2e442d14add3cefbdf33c4561',
  /** unique or primary key constraint */
  user_role_name_key = 'user_role_name_key',
}

/** input type for inserting data into table "user_role" */
export type user_role_insert_input = {
  department?: Maybe<department_obj_rel_insert_input>;
  departmentId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  systemRole?: Maybe<Scalars['Boolean']>;
  user_role_routes_routes?: Maybe<user_role_routes_route_arr_rel_insert_input>;
  user_user_roles_user_roles?: Maybe<user_user_roles_user_role_arr_rel_insert_input>;
};

/** aggregate max on columns */
export type user_role_max_fields = {
  __typename?: 'user_role_max_fields';
  departmentId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_role" */
export type user_role_max_order_by = {
  departmentId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
};

/** aggregate min on columns */
export type user_role_min_fields = {
  __typename?: 'user_role_min_fields';
  departmentId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_role" */
export type user_role_min_order_by = {
  departmentId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
};

/** response of any mutation on the table "user_role" */
export type user_role_mutation_response = {
  __typename?: 'user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<user_role>;
};

/** input type for inserting object relation for remote table "user_role" */
export type user_role_obj_rel_insert_input = {
  data: user_role_insert_input;
  /** on conflict condition */
  on_conflict?: Maybe<user_role_on_conflict>;
};

/** on conflict condition type for table "user_role" */
export type user_role_on_conflict = {
  constraint: user_role_constraint;
  update_columns?: Array<user_role_update_column>;
  where?: Maybe<user_role_bool_exp>;
};

/** Ordering options when selecting data from "user_role". */
export type user_role_order_by = {
  department?: Maybe<department_order_by>;
  departmentId?: Maybe<order_by>;
  id?: Maybe<order_by>;
  name?: Maybe<order_by>;
  systemRole?: Maybe<order_by>;
  user_role_routes_routes_aggregate?: Maybe<user_role_routes_route_aggregate_order_by>;
  user_user_roles_user_roles_aggregate?: Maybe<user_user_roles_user_role_aggregate_order_by>;
};

/** primary key columns input for table: user_role */
export type user_role_pk_columns_input = {
  id: Scalars['uuid'];
};

/** columns and relationships of "user_role_routes_route" */
export type user_role_routes_route = {
  __typename?: 'user_role_routes_route';
  /** An object relationship */
  route: route;
  routeId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
  /** An object relationship */
  user_role: user_role;
};

/** aggregated selection of "user_role_routes_route" */
export type user_role_routes_route_aggregate = {
  __typename?: 'user_role_routes_route_aggregate';
  aggregate?: Maybe<user_role_routes_route_aggregate_fields>;
  nodes: Array<user_role_routes_route>;
};

/** aggregate fields of "user_role_routes_route" */
export type user_role_routes_route_aggregate_fields = {
  __typename?: 'user_role_routes_route_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<user_role_routes_route_max_fields>;
  min?: Maybe<user_role_routes_route_min_fields>;
};

/** aggregate fields of "user_role_routes_route" */
export type user_role_routes_route_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<user_role_routes_route_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_role_routes_route" */
export type user_role_routes_route_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<user_role_routes_route_max_order_by>;
  min?: Maybe<user_role_routes_route_min_order_by>;
};

/** input type for inserting array relation for remote table "user_role_routes_route" */
export type user_role_routes_route_arr_rel_insert_input = {
  data: Array<user_role_routes_route_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<user_role_routes_route_on_conflict>;
};

/** Boolean expression to filter rows from the table "user_role_routes_route". All fields are combined with a logical 'AND'. */
export type user_role_routes_route_bool_exp = {
  _and?: Maybe<Array<user_role_routes_route_bool_exp>>;
  _not?: Maybe<user_role_routes_route_bool_exp>;
  _or?: Maybe<Array<user_role_routes_route_bool_exp>>;
  route?: Maybe<route_bool_exp>;
  routeId?: Maybe<uuid_comparison_exp>;
  userRoleId?: Maybe<uuid_comparison_exp>;
  user_role?: Maybe<user_role_bool_exp>;
};

/** unique or primary key constraints on table "user_role_routes_route" */
export enum user_role_routes_route_constraint {
  /** unique or primary key constraint */
  user_role_routes_route_pkey = 'user_role_routes_route_pkey',
}

/** input type for inserting data into table "user_role_routes_route" */
export type user_role_routes_route_insert_input = {
  route?: Maybe<route_obj_rel_insert_input>;
  routeId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
  user_role?: Maybe<user_role_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type user_role_routes_route_max_fields = {
  __typename?: 'user_role_routes_route_max_fields';
  routeId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_role_routes_route" */
export type user_role_routes_route_max_order_by = {
  routeId?: Maybe<order_by>;
  userRoleId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type user_role_routes_route_min_fields = {
  __typename?: 'user_role_routes_route_min_fields';
  routeId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_role_routes_route" */
export type user_role_routes_route_min_order_by = {
  routeId?: Maybe<order_by>;
  userRoleId?: Maybe<order_by>;
};

/** response of any mutation on the table "user_role_routes_route" */
export type user_role_routes_route_mutation_response = {
  __typename?: 'user_role_routes_route_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<user_role_routes_route>;
};

/** on conflict condition type for table "user_role_routes_route" */
export type user_role_routes_route_on_conflict = {
  constraint: user_role_routes_route_constraint;
  update_columns?: Array<user_role_routes_route_update_column>;
  where?: Maybe<user_role_routes_route_bool_exp>;
};

/** Ordering options when selecting data from "user_role_routes_route". */
export type user_role_routes_route_order_by = {
  route?: Maybe<route_order_by>;
  routeId?: Maybe<order_by>;
  userRoleId?: Maybe<order_by>;
  user_role?: Maybe<user_role_order_by>;
};

/** primary key columns input for table: user_role_routes_route */
export type user_role_routes_route_pk_columns_input = {
  routeId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
};

/** select columns of table "user_role_routes_route" */
export enum user_role_routes_route_select_column {
  /** column name */
  routeId = 'routeId',
  /** column name */
  userRoleId = 'userRoleId',
}

/** input type for updating data in table "user_role_routes_route" */
export type user_role_routes_route_set_input = {
  routeId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_role_routes_route" */
export enum user_role_routes_route_update_column {
  /** column name */
  routeId = 'routeId',
  /** column name */
  userRoleId = 'userRoleId',
}

/** select columns of table "user_role" */
export enum user_role_select_column {
  /** column name */
  departmentId = 'departmentId',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  systemRole = 'systemRole',
}

/** input type for updating data in table "user_role" */
export type user_role_set_input = {
  departmentId?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  systemRole?: Maybe<Scalars['Boolean']>;
};

/** update columns of table "user_role" */
export enum user_role_update_column {
  /** column name */
  departmentId = 'departmentId',
  /** column name */
  id = 'id',
  /** column name */
  name = 'name',
  /** column name */
  systemRole = 'systemRole',
}

/** columns and relationships of "user_routes_route" */
export type user_routes_route = {
  __typename?: 'user_routes_route';
  /** An object relationship */
  route: route;
  routeId: Scalars['uuid'];
  /** An object relationship */
  user: user;
  userId: Scalars['uuid'];
};

/** aggregated selection of "user_routes_route" */
export type user_routes_route_aggregate = {
  __typename?: 'user_routes_route_aggregate';
  aggregate?: Maybe<user_routes_route_aggregate_fields>;
  nodes: Array<user_routes_route>;
};

/** aggregate fields of "user_routes_route" */
export type user_routes_route_aggregate_fields = {
  __typename?: 'user_routes_route_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<user_routes_route_max_fields>;
  min?: Maybe<user_routes_route_min_fields>;
};

/** aggregate fields of "user_routes_route" */
export type user_routes_route_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<user_routes_route_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_routes_route" */
export type user_routes_route_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<user_routes_route_max_order_by>;
  min?: Maybe<user_routes_route_min_order_by>;
};

/** input type for inserting array relation for remote table "user_routes_route" */
export type user_routes_route_arr_rel_insert_input = {
  data: Array<user_routes_route_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<user_routes_route_on_conflict>;
};

/** Boolean expression to filter rows from the table "user_routes_route". All fields are combined with a logical 'AND'. */
export type user_routes_route_bool_exp = {
  _and?: Maybe<Array<user_routes_route_bool_exp>>;
  _not?: Maybe<user_routes_route_bool_exp>;
  _or?: Maybe<Array<user_routes_route_bool_exp>>;
  route?: Maybe<route_bool_exp>;
  routeId?: Maybe<uuid_comparison_exp>;
  user?: Maybe<user_bool_exp>;
  userId?: Maybe<uuid_comparison_exp>;
};

/** unique or primary key constraints on table "user_routes_route" */
export enum user_routes_route_constraint {
  /** unique or primary key constraint */
  PK_52e5503fd1e136b33303d5402f3 = 'PK_52e5503fd1e136b33303d5402f3',
}

/** input type for inserting data into table "user_routes_route" */
export type user_routes_route_insert_input = {
  route?: Maybe<route_obj_rel_insert_input>;
  routeId?: Maybe<Scalars['uuid']>;
  user?: Maybe<user_obj_rel_insert_input>;
  userId?: Maybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type user_routes_route_max_fields = {
  __typename?: 'user_routes_route_max_fields';
  routeId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_routes_route" */
export type user_routes_route_max_order_by = {
  routeId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type user_routes_route_min_fields = {
  __typename?: 'user_routes_route_min_fields';
  routeId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_routes_route" */
export type user_routes_route_min_order_by = {
  routeId?: Maybe<order_by>;
  userId?: Maybe<order_by>;
};

/** response of any mutation on the table "user_routes_route" */
export type user_routes_route_mutation_response = {
  __typename?: 'user_routes_route_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<user_routes_route>;
};

/** on conflict condition type for table "user_routes_route" */
export type user_routes_route_on_conflict = {
  constraint: user_routes_route_constraint;
  update_columns?: Array<user_routes_route_update_column>;
  where?: Maybe<user_routes_route_bool_exp>;
};

/** Ordering options when selecting data from "user_routes_route". */
export type user_routes_route_order_by = {
  route?: Maybe<route_order_by>;
  routeId?: Maybe<order_by>;
  user?: Maybe<user_order_by>;
  userId?: Maybe<order_by>;
};

/** primary key columns input for table: user_routes_route */
export type user_routes_route_pk_columns_input = {
  routeId: Scalars['uuid'];
  userId: Scalars['uuid'];
};

/** select columns of table "user_routes_route" */
export enum user_routes_route_select_column {
  /** column name */
  routeId = 'routeId',
  /** column name */
  userId = 'userId',
}

/** input type for updating data in table "user_routes_route" */
export type user_routes_route_set_input = {
  routeId?: Maybe<Scalars['uuid']>;
  userId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_routes_route" */
export enum user_routes_route_update_column {
  /** column name */
  routeId = 'routeId',
  /** column name */
  userId = 'userId',
}

/** select columns of table "user" */
export enum user_select_column {
  /** column name */
  active = 'active',
  /** column name */
  allergies = 'allergies',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  currentMedications = 'currentMedications',
  /** column name */
  dateOfBirth = 'dateOfBirth',
  /** column name */
  dateOfJoining = 'dateOfJoining',
  /** column name */
  departmentId = 'departmentId',
  /** column name */
  email = 'email',
  /** column name */
  emergencyContact1City = 'emergencyContact1City',
  /** column name */
  emergencyContact1Country = 'emergencyContact1Country',
  /** column name */
  emergencyContact1District = 'emergencyContact1District',
  /** column name */
  emergencyContact1LandLineNo = 'emergencyContact1LandLineNo',
  /** column name */
  emergencyContact1MobileNo = 'emergencyContact1MobileNo',
  /** column name */
  emergencyContact1Name = 'emergencyContact1Name',
  /** column name */
  emergencyContact1Province = 'emergencyContact1Province',
  /** column name */
  emergencyContact1Relationship = 'emergencyContact1Relationship',
  /** column name */
  emergencyContact1StreetAddress1 = 'emergencyContact1StreetAddress1',
  /** column name */
  emergencyContact1StreetAddress2 = 'emergencyContact1StreetAddress2',
  /** column name */
  emergencyContact1WorkPhoneNo = 'emergencyContact1WorkPhoneNo',
  /** column name */
  emergencyContact2City = 'emergencyContact2City',
  /** column name */
  emergencyContact2Country = 'emergencyContact2Country',
  /** column name */
  emergencyContact2District = 'emergencyContact2District',
  /** column name */
  emergencyContact2LandLineNo = 'emergencyContact2LandLineNo',
  /** column name */
  emergencyContact2MobileNo = 'emergencyContact2MobileNo',
  /** column name */
  emergencyContact2Name = 'emergencyContact2Name',
  /** column name */
  emergencyContact2Province = 'emergencyContact2Province',
  /** column name */
  emergencyContact2Relationship = 'emergencyContact2Relationship',
  /** column name */
  emergencyContact2StreetAddress1 = 'emergencyContact2StreetAddress1',
  /** column name */
  emergencyContact2StreetAddress2 = 'emergencyContact2StreetAddress2',
  /** column name */
  emergencyContact2WorkPhoneNo = 'emergencyContact2WorkPhoneNo',
  /** column name */
  employeeID = 'employeeID',
  /** column name */
  expirationDate = 'expirationDate',
  /** column name */
  extensionNo = 'extensionNo',
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  gender = 'gender',
  /** column name */
  healthConditions = 'healthConditions',
  /** column name */
  homeCity = 'homeCity',
  /** column name */
  homeCountry = 'homeCountry',
  /** column name */
  homeDistrict = 'homeDistrict',
  /** column name */
  homeProvince = 'homeProvince',
  /** column name */
  homeStreetAddress1 = 'homeStreetAddress1',
  /** column name */
  homeStreetAddress2 = 'homeStreetAddress2',
  /** column name */
  id = 'id',
  /** column name */
  initialTourFollowed = 'initialTourFollowed',
  /** column name */
  insuranceName = 'insuranceName',
  /** column name */
  landLineNo = 'landLineNo',
  /** column name */
  lastName = 'lastName',
  /** column name */
  married = 'married',
  /** column name */
  middleName = 'middleName',
  /** column name */
  mobileNo = 'mobileNo',
  /** column name */
  nicNo = 'nicNo',
  /** column name */
  passportNo = 'passportNo',
  /** column name */
  permanentCity = 'permanentCity',
  /** column name */
  permanentCountry = 'permanentCountry',
  /** column name */
  permanentDistrict = 'permanentDistrict',
  /** column name */
  permanentProvince = 'permanentProvince',
  /** column name */
  permanentStreetAddress1 = 'permanentStreetAddress1',
  /** column name */
  permanentStreetAddress2 = 'permanentStreetAddress2',
  /** column name */
  policyNo = 'policyNo',
  /** column name */
  preferredName = 'preferredName',
  /** column name */
  profilePicture = 'profilePicture',
  /** column name */
  updatedAt = 'updatedAt',
}

/** input type for updating data in table "user" */
export type user_set_input = {
  active?: Maybe<Scalars['Boolean']>;
  allergies?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  currentMedications?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['timestamp']>;
  dateOfJoining?: Maybe<Scalars['timestamp']>;
  departmentId?: Maybe<Scalars['uuid']>;
  email?: Maybe<Scalars['String']>;
  emergencyContact1City?: Maybe<Scalars['String']>;
  emergencyContact1Country?: Maybe<Scalars['String']>;
  emergencyContact1District?: Maybe<Scalars['String']>;
  emergencyContact1LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact1MobileNo?: Maybe<Scalars['String']>;
  emergencyContact1Name?: Maybe<Scalars['String']>;
  emergencyContact1Province?: Maybe<Scalars['String']>;
  emergencyContact1Relationship?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact1StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact1WorkPhoneNo?: Maybe<Scalars['String']>;
  emergencyContact2City?: Maybe<Scalars['String']>;
  emergencyContact2Country?: Maybe<Scalars['String']>;
  emergencyContact2District?: Maybe<Scalars['String']>;
  emergencyContact2LandLineNo?: Maybe<Scalars['String']>;
  emergencyContact2MobileNo?: Maybe<Scalars['String']>;
  emergencyContact2Name?: Maybe<Scalars['String']>;
  emergencyContact2Province?: Maybe<Scalars['String']>;
  emergencyContact2Relationship?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress1?: Maybe<Scalars['String']>;
  emergencyContact2StreetAddress2?: Maybe<Scalars['String']>;
  emergencyContact2WorkPhoneNo?: Maybe<Scalars['String']>;
  employeeID?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['timestamp']>;
  extensionNo?: Maybe<Scalars['String']>;
  firebaseUID?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['user_gender_enum']>;
  healthConditions?: Maybe<Scalars['String']>;
  homeCity?: Maybe<Scalars['String']>;
  homeCountry?: Maybe<Scalars['String']>;
  homeDistrict?: Maybe<Scalars['String']>;
  homeProvince?: Maybe<Scalars['String']>;
  homeStreetAddress1?: Maybe<Scalars['String']>;
  homeStreetAddress2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  initialTourFollowed?: Maybe<Scalars['Boolean']>;
  insuranceName?: Maybe<Scalars['String']>;
  landLineNo?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  married?: Maybe<Scalars['Boolean']>;
  middleName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  nicNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  permanentCity?: Maybe<Scalars['String']>;
  permanentCountry?: Maybe<Scalars['String']>;
  permanentDistrict?: Maybe<Scalars['String']>;
  permanentProvince?: Maybe<Scalars['String']>;
  permanentStreetAddress1?: Maybe<Scalars['String']>;
  permanentStreetAddress2?: Maybe<Scalars['String']>;
  policyNo?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** update columns of table "user" */
export enum user_update_column {
  /** column name */
  active = 'active',
  /** column name */
  allergies = 'allergies',
  /** column name */
  createdAt = 'createdAt',
  /** column name */
  currentMedications = 'currentMedications',
  /** column name */
  dateOfBirth = 'dateOfBirth',
  /** column name */
  dateOfJoining = 'dateOfJoining',
  /** column name */
  departmentId = 'departmentId',
  /** column name */
  email = 'email',
  /** column name */
  emergencyContact1City = 'emergencyContact1City',
  /** column name */
  emergencyContact1Country = 'emergencyContact1Country',
  /** column name */
  emergencyContact1District = 'emergencyContact1District',
  /** column name */
  emergencyContact1LandLineNo = 'emergencyContact1LandLineNo',
  /** column name */
  emergencyContact1MobileNo = 'emergencyContact1MobileNo',
  /** column name */
  emergencyContact1Name = 'emergencyContact1Name',
  /** column name */
  emergencyContact1Province = 'emergencyContact1Province',
  /** column name */
  emergencyContact1Relationship = 'emergencyContact1Relationship',
  /** column name */
  emergencyContact1StreetAddress1 = 'emergencyContact1StreetAddress1',
  /** column name */
  emergencyContact1StreetAddress2 = 'emergencyContact1StreetAddress2',
  /** column name */
  emergencyContact1WorkPhoneNo = 'emergencyContact1WorkPhoneNo',
  /** column name */
  emergencyContact2City = 'emergencyContact2City',
  /** column name */
  emergencyContact2Country = 'emergencyContact2Country',
  /** column name */
  emergencyContact2District = 'emergencyContact2District',
  /** column name */
  emergencyContact2LandLineNo = 'emergencyContact2LandLineNo',
  /** column name */
  emergencyContact2MobileNo = 'emergencyContact2MobileNo',
  /** column name */
  emergencyContact2Name = 'emergencyContact2Name',
  /** column name */
  emergencyContact2Province = 'emergencyContact2Province',
  /** column name */
  emergencyContact2Relationship = 'emergencyContact2Relationship',
  /** column name */
  emergencyContact2StreetAddress1 = 'emergencyContact2StreetAddress1',
  /** column name */
  emergencyContact2StreetAddress2 = 'emergencyContact2StreetAddress2',
  /** column name */
  emergencyContact2WorkPhoneNo = 'emergencyContact2WorkPhoneNo',
  /** column name */
  employeeID = 'employeeID',
  /** column name */
  expirationDate = 'expirationDate',
  /** column name */
  extensionNo = 'extensionNo',
  /** column name */
  firebaseUID = 'firebaseUID',
  /** column name */
  firstName = 'firstName',
  /** column name */
  gender = 'gender',
  /** column name */
  healthConditions = 'healthConditions',
  /** column name */
  homeCity = 'homeCity',
  /** column name */
  homeCountry = 'homeCountry',
  /** column name */
  homeDistrict = 'homeDistrict',
  /** column name */
  homeProvince = 'homeProvince',
  /** column name */
  homeStreetAddress1 = 'homeStreetAddress1',
  /** column name */
  homeStreetAddress2 = 'homeStreetAddress2',
  /** column name */
  id = 'id',
  /** column name */
  initialTourFollowed = 'initialTourFollowed',
  /** column name */
  insuranceName = 'insuranceName',
  /** column name */
  landLineNo = 'landLineNo',
  /** column name */
  lastName = 'lastName',
  /** column name */
  married = 'married',
  /** column name */
  middleName = 'middleName',
  /** column name */
  mobileNo = 'mobileNo',
  /** column name */
  nicNo = 'nicNo',
  /** column name */
  passportNo = 'passportNo',
  /** column name */
  permanentCity = 'permanentCity',
  /** column name */
  permanentCountry = 'permanentCountry',
  /** column name */
  permanentDistrict = 'permanentDistrict',
  /** column name */
  permanentProvince = 'permanentProvince',
  /** column name */
  permanentStreetAddress1 = 'permanentStreetAddress1',
  /** column name */
  permanentStreetAddress2 = 'permanentStreetAddress2',
  /** column name */
  policyNo = 'policyNo',
  /** column name */
  preferredName = 'preferredName',
  /** column name */
  profilePicture = 'profilePicture',
  /** column name */
  updatedAt = 'updatedAt',
}

/** columns and relationships of "user_user_roles_user_role" */
export type user_user_roles_user_role = {
  __typename?: 'user_user_roles_user_role';
  /** An object relationship */
  user: user;
  userId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
  /** An object relationship */
  user_role: user_role;
};

/** aggregated selection of "user_user_roles_user_role" */
export type user_user_roles_user_role_aggregate = {
  __typename?: 'user_user_roles_user_role_aggregate';
  aggregate?: Maybe<user_user_roles_user_role_aggregate_fields>;
  nodes: Array<user_user_roles_user_role>;
};

/** aggregate fields of "user_user_roles_user_role" */
export type user_user_roles_user_role_aggregate_fields = {
  __typename?: 'user_user_roles_user_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<user_user_roles_user_role_max_fields>;
  min?: Maybe<user_user_roles_user_role_min_fields>;
};

/** aggregate fields of "user_user_roles_user_role" */
export type user_user_roles_user_role_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<user_user_roles_user_role_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_user_roles_user_role" */
export type user_user_roles_user_role_aggregate_order_by = {
  count?: Maybe<order_by>;
  max?: Maybe<user_user_roles_user_role_max_order_by>;
  min?: Maybe<user_user_roles_user_role_min_order_by>;
};

/** input type for inserting array relation for remote table "user_user_roles_user_role" */
export type user_user_roles_user_role_arr_rel_insert_input = {
  data: Array<user_user_roles_user_role_insert_input>;
  /** on conflict condition */
  on_conflict?: Maybe<user_user_roles_user_role_on_conflict>;
};

/** Boolean expression to filter rows from the table "user_user_roles_user_role". All fields are combined with a logical 'AND'. */
export type user_user_roles_user_role_bool_exp = {
  _and?: Maybe<Array<user_user_roles_user_role_bool_exp>>;
  _not?: Maybe<user_user_roles_user_role_bool_exp>;
  _or?: Maybe<Array<user_user_roles_user_role_bool_exp>>;
  user?: Maybe<user_bool_exp>;
  userId?: Maybe<uuid_comparison_exp>;
  userRoleId?: Maybe<uuid_comparison_exp>;
  user_role?: Maybe<user_role_bool_exp>;
};

/** unique or primary key constraints on table "user_user_roles_user_role" */
export enum user_user_roles_user_role_constraint {
  /** unique or primary key constraint */
  user_user_roles_user_role_pkey = 'user_user_roles_user_role_pkey',
}

/** input type for inserting data into table "user_user_roles_user_role" */
export type user_user_roles_user_role_insert_input = {
  user?: Maybe<user_obj_rel_insert_input>;
  userId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
  user_role?: Maybe<user_role_obj_rel_insert_input>;
};

/** aggregate max on columns */
export type user_user_roles_user_role_max_fields = {
  __typename?: 'user_user_roles_user_role_max_fields';
  userId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_user_roles_user_role" */
export type user_user_roles_user_role_max_order_by = {
  userId?: Maybe<order_by>;
  userRoleId?: Maybe<order_by>;
};

/** aggregate min on columns */
export type user_user_roles_user_role_min_fields = {
  __typename?: 'user_user_roles_user_role_min_fields';
  userId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_user_roles_user_role" */
export type user_user_roles_user_role_min_order_by = {
  userId?: Maybe<order_by>;
  userRoleId?: Maybe<order_by>;
};

/** response of any mutation on the table "user_user_roles_user_role" */
export type user_user_roles_user_role_mutation_response = {
  __typename?: 'user_user_roles_user_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<user_user_roles_user_role>;
};

/** on conflict condition type for table "user_user_roles_user_role" */
export type user_user_roles_user_role_on_conflict = {
  constraint: user_user_roles_user_role_constraint;
  update_columns?: Array<user_user_roles_user_role_update_column>;
  where?: Maybe<user_user_roles_user_role_bool_exp>;
};

/** Ordering options when selecting data from "user_user_roles_user_role". */
export type user_user_roles_user_role_order_by = {
  user?: Maybe<user_order_by>;
  userId?: Maybe<order_by>;
  userRoleId?: Maybe<order_by>;
  user_role?: Maybe<user_role_order_by>;
};

/** primary key columns input for table: user_user_roles_user_role */
export type user_user_roles_user_role_pk_columns_input = {
  userId: Scalars['uuid'];
  userRoleId: Scalars['uuid'];
};

/** select columns of table "user_user_roles_user_role" */
export enum user_user_roles_user_role_select_column {
  /** column name */
  userId = 'userId',
  /** column name */
  userRoleId = 'userRoleId',
}

/** input type for updating data in table "user_user_roles_user_role" */
export type user_user_roles_user_role_set_input = {
  userId?: Maybe<Scalars['uuid']>;
  userRoleId?: Maybe<Scalars['uuid']>;
};

/** update columns of table "user_user_roles_user_role" */
export enum user_user_roles_user_role_update_column {
  /** column name */
  userId = 'userId',
  /** column name */
  userRoleId = 'userRoleId',
}

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type uuid_comparison_exp = {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
};

/** Boolean expression to compare columns of type "weekdays". All fields are combined with logical 'AND'. */
export type weekdays_comparison_exp = {
  _eq?: Maybe<Scalars['weekdays']>;
  _gt?: Maybe<Scalars['weekdays']>;
  _gte?: Maybe<Scalars['weekdays']>;
  _in?: Maybe<Array<Scalars['weekdays']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['weekdays']>;
  _lte?: Maybe<Scalars['weekdays']>;
  _neq?: Maybe<Scalars['weekdays']>;
  _nin?: Maybe<Array<Scalars['weekdays']>>;
};

/** columns and relationships of "withdrawn_request" */
export type withdrawn_request = {
  __typename?: 'withdrawn_request';
  attendanceStudentId?: Maybe<Scalars['uuid']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  /** An array relationship */
  student_batch_histories: Array<student_batch_history>;
  /** An aggregate relationship */
  student_batch_histories_aggregate: student_batch_history_aggregate;
  /** An array relationship */
  student_courses: Array<student_course>;
  /** An aggregate relationship */
  student_courses_aggregate: student_course_aggregate;
};

/** columns and relationships of "withdrawn_request" */
export type withdrawn_requeststudent_batch_historiesArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

/** columns and relationships of "withdrawn_request" */
export type withdrawn_requeststudent_batch_histories_aggregateArgs = {
  distinct_on?: Maybe<Array<student_batch_history_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_batch_history_order_by>>;
  where?: Maybe<student_batch_history_bool_exp>;
};

/** columns and relationships of "withdrawn_request" */
export type withdrawn_requeststudent_coursesArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** columns and relationships of "withdrawn_request" */
export type withdrawn_requeststudent_courses_aggregateArgs = {
  distinct_on?: Maybe<Array<student_course_select_column>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<student_course_order_by>>;
  where?: Maybe<student_course_bool_exp>;
};

/** aggregated selection of "withdrawn_request" */
export type withdrawn_request_aggregate = {
  __typename?: 'withdrawn_request_aggregate';
  aggregate?: Maybe<withdrawn_request_aggregate_fields>;
  nodes: Array<withdrawn_request>;
};

/** aggregate fields of "withdrawn_request" */
export type withdrawn_request_aggregate_fields = {
  __typename?: 'withdrawn_request_aggregate_fields';
  avg?: Maybe<withdrawn_request_avg_fields>;
  count: Scalars['Int'];
  max?: Maybe<withdrawn_request_max_fields>;
  min?: Maybe<withdrawn_request_min_fields>;
  stddev?: Maybe<withdrawn_request_stddev_fields>;
  stddev_pop?: Maybe<withdrawn_request_stddev_pop_fields>;
  stddev_samp?: Maybe<withdrawn_request_stddev_samp_fields>;
  sum?: Maybe<withdrawn_request_sum_fields>;
  var_pop?: Maybe<withdrawn_request_var_pop_fields>;
  var_samp?: Maybe<withdrawn_request_var_samp_fields>;
  variance?: Maybe<withdrawn_request_variance_fields>;
};

/** aggregate fields of "withdrawn_request" */
export type withdrawn_request_aggregate_fieldscountArgs = {
  columns?: Maybe<Array<withdrawn_request_select_column>>;
  distinct?: Maybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type withdrawn_request_avg_fields = {
  __typename?: 'withdrawn_request_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "withdrawn_request". All fields are combined with a logical 'AND'. */
export type withdrawn_request_bool_exp = {
  _and?: Maybe<Array<withdrawn_request_bool_exp>>;
  _not?: Maybe<withdrawn_request_bool_exp>;
  _or?: Maybe<Array<withdrawn_request_bool_exp>>;
  attendanceStudentId?: Maybe<uuid_comparison_exp>;
  firstName?: Maybe<String_comparison_exp>;
  id?: Maybe<Int_comparison_exp>;
  lastName?: Maybe<String_comparison_exp>;
  mobileNo?: Maybe<String_comparison_exp>;
  regNumber?: Maybe<String_comparison_exp>;
  remarks?: Maybe<String_comparison_exp>;
  student_batch_histories?: Maybe<student_batch_history_bool_exp>;
  student_courses?: Maybe<student_course_bool_exp>;
};

/** aggregate max on columns */
export type withdrawn_request_max_fields = {
  __typename?: 'withdrawn_request_max_fields';
  attendanceStudentId?: Maybe<Scalars['uuid']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type withdrawn_request_min_fields = {
  __typename?: 'withdrawn_request_min_fields';
  attendanceStudentId?: Maybe<Scalars['uuid']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['String']>;
  mobileNo?: Maybe<Scalars['String']>;
  regNumber?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "withdrawn_request". */
export type withdrawn_request_order_by = {
  attendanceStudentId?: Maybe<order_by>;
  firstName?: Maybe<order_by>;
  id?: Maybe<order_by>;
  lastName?: Maybe<order_by>;
  mobileNo?: Maybe<order_by>;
  regNumber?: Maybe<order_by>;
  remarks?: Maybe<order_by>;
  student_batch_histories_aggregate?: Maybe<student_batch_history_aggregate_order_by>;
  student_courses_aggregate?: Maybe<student_course_aggregate_order_by>;
};

/** select columns of table "withdrawn_request" */
export enum withdrawn_request_select_column {
  /** column name */
  attendanceStudentId = 'attendanceStudentId',
  /** column name */
  firstName = 'firstName',
  /** column name */
  id = 'id',
  /** column name */
  lastName = 'lastName',
  /** column name */
  mobileNo = 'mobileNo',
  /** column name */
  regNumber = 'regNumber',
  /** column name */
  remarks = 'remarks',
}

/** aggregate stddev on columns */
export type withdrawn_request_stddev_fields = {
  __typename?: 'withdrawn_request_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type withdrawn_request_stddev_pop_fields = {
  __typename?: 'withdrawn_request_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type withdrawn_request_stddev_samp_fields = {
  __typename?: 'withdrawn_request_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type withdrawn_request_sum_fields = {
  __typename?: 'withdrawn_request_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type withdrawn_request_var_pop_fields = {
  __typename?: 'withdrawn_request_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type withdrawn_request_var_samp_fields = {
  __typename?: 'withdrawn_request_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type withdrawn_request_variance_fields = {
  __typename?: 'withdrawn_request_variance_fields';
  id?: Maybe<Scalars['Float']>;
};
